import React__default, { useContext, useState, createElement } from 'react';
import { makeObservable, computed, action, observable, runInAction, makeAutoObservable } from 'mobx';
import moment from 'moment';
import clsx from 'clsx';
import { v4 } from 'uuid';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import PouchDB from 'pouchdb';
import PouchDBFind from 'pouchdb-find';
import { observer } from 'mobx-react-lite';

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var environment = function environment() {
  if (typeof document != 'undefined') {
    return 'web';
  } else if (typeof navigator != 'undefined' && navigator.product == 'ReactNative') {
    return 'native';
  } else {
    return 'node';
  }
};
var formats = {
  'date': 'DD-MM-YYYY',
  'datetime': 'DD-MM-YYYY HH:mm:ss',
  'time': 'h:mm:ss'
};
var server_formats = {
  'date': 'YYYY-MM-DD',
  'datetime': 'YYYY-MM-DD HH:mm:ss',
  'time': 'hh:mm:ss'
};
var formatDate = function formatDate(value, type) {
  if (value) {
    var format = formats[type];

    if (type === 'date') {
      value = moment.utc(value).format(format);
    } else {
      value = moment.utc(value).local().format(format);
    }
  } else {
    value = "";
  }

  return value;
};
var validateNumber = function validateNumber(value) {
  value = value.replace(',', '.');
  return parseFloat(value);
};
var validateDate = function validateDate(value, type) {
  if (value) {
    var format = server_formats[type];
    value = moment.utc(value).format(format);
  } else {
    value = null;
  }

  return value;
};
var validateInput = {
  'integer': validateNumber,
  'float': validateNumber,
  'numeric': validateNumber,
  'char': function char(value) {
    return value;
  }
};
var createUrl = function createUrl(params) {
  var query = "?";
  Object.keys(params).map(function (field) {
    if (field === "current_search") {
      var current_search = params[field];
      current_search.forEach(function (domain) {
        var field = domain[0];
        var operator = domain[1];
        var value = domain[2];

        if (value !== "" && value !== undefined) {
          if (operator) {
            if (Array.isArray(value)) {
              value = value.toString();
              value = '['.concat(value).concat(']');
            }
          }

          value = operator.concat(";").concat(value);
        }

        query = query.concat(field).concat('=').concat(value).concat('&');
      });
    } else if (field === 'action_params') {
      var action_params = params[field];

      if (action_params.length) {
        query = query.concat('_ap=');
        action_params.forEach(function (domain) {
          var field = domain[0];
          var operator = domain[1];
          var value = domain[2];

          if (value !== "" && value !== undefined) {
            if (operator) {
              if (Array.isArray(value)) {
                value = value.toString();
                value = '['.concat(value).concat(']');
              }
            }

            value = operator.concat(";").concat(value);
          }

          query = query.concat(field).concat(';').concat(value).concat('&');
        });
      }
    } else if (field === "order") {
      if (params[field].length) {
        query = query.concat('_order').concat("=").concat(params[field].toString());
      }
    } else if (field === "action_id") {
      if (params[field]) {
        query = query.concat('_action_id').concat("=").concat(params[field]);
      }
    }
  });
  return query;
};
var domain_to_object = function domain_to_object(domain) {
  var res = {};
  domain.forEach(function (pair) {
    res[pair[0]] = pair[2];
  });
  return res;
};
var parse_domain = function parse_domain(data, expr, _parent_record, _parent_selected_records) {
  if (_parent_selected_records === void 0) {
    _parent_selected_records = [];
  }

  var domain = [];

  if (!expr) {
    return domain;
  }

  var str_terms = expr.substring(1, expr.length - 1).split(',');
  var terms_array = [];
  var size = 3;

  for (var i = 0; i < str_terms.length; i += size) {
    terms_array.push(str_terms.slice(i, i + size));
  }

  terms_array.forEach(function (term) {
    if ([term[0], term[1], term[2]].includes(undefined)) {
      return;
    }

    var fname = term[0].replaceAll("'", "").replaceAll(" ", "").replaceAll('[', "");
    var operator = term[1].replaceAll("'", "").replaceAll(" ", "");
    var value = term[2].substring(0, term[2].length - 1);

    if (value.includes('{')) {
      var _expr = value.match(/{([^}]+)}/g);

      if (_expr && _expr.length) {
        _expr = _expr[0];
        value = browseObject(data, _expr, false, {}, _parent_record, _parent_selected_records);
      }
    }

    domain.push([fname, operator, value]);
  });
  return domain;
};
var evalExpr = function evalExpr(data, expr, _parent_record, _parent_selected_records) {
  if (_parent_selected_records === void 0) {
    _parent_selected_records = [];
  }

  if (!expr) {
    return "";
  }

  var variables_obj = {};
  var variables = expr.match(/{([^}]+)}/g);
  var str = expr;

  if (!data) {
    if (variables) {
      variables.forEach(function (v) {
        str = str.replace(v, "");
      });
    }

    return str;
  }

  if (variables) {
    variables.forEach(function (v) {
      var value = browseObject(data, v, {}, [], _parent_record, _parent_selected_records) || "";
      str = str.replace(v, value);
      variables_obj[v.substring(1, v.length - 1)] = value;
    });
  }

  return {
    str: str,
    variables: variables_obj
  };
};
var browseObject = function browseObject(data, expr, user_context, fields, _parent_record, _parent_selected_records) {
  if (_parent_selected_records === void 0) {
    _parent_selected_records = [];
  }

  var value;

  if (expr.includes('{')) {
    expr = expr.replace('{', "").replace('}', "");
  }

  if (expr.startsWith('_parent_record')) {
    if (!_parent_record) {
      return "";
    }

    data = _parent_record;
    expr = expr.replace('_parent_record.', '');
  } else if (expr.startsWith('_parent_selected_records')) {
    data = {
      '_parent_selected_records': _parent_selected_records
    };
  }

  if (user_context) {
    data['user_context'] = user_context;
  }

  if (!data || !expr) {
    return "";
  }

  var res = [];
  var spl = expr.split('.');

  if (spl.length > 1) {
    if (data.hasOwnProperty(expr)) {
      return data[expr];
    }

    value = data[spl[0]];

    if (data[spl[0].concat('.')]) {
      value = data[spl[0].concat('.')];
    }

    var expr_array = spl.slice(1, spl.length);

    if (Array.isArray(value)) {
      value.forEach(function (val, index) {
        var expression = expr_array.join('.');
        var new_val = browseObject(val, expression, false);

        if (new_val) {
          if (!res.includes(new_val)) {
            res.push(new_val);
          }
        }
      });
      return res;
    }

    expr_array.forEach(function (dot, index) {
      if (!value) {
        return false;
      }

      if (value[dot.concat('.')]) {
        dot = dot.concat('.');
      }

      if (!value[dot]) {
        value = "";
        return "";
      }

      value = value[dot];
    });
  } else if (data.hasOwnProperty(expr)) {
    value = data[expr];
  } else {
    value = expr;
  }

  return value;
};
var flatten = function flatten(arr) {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
  }, []);
};
var evalCondition = function evalCondition(p1, operator, p2) {
  var math_ops = ['<', '>', '>=', '<='];

  if (math_ops.includes(operator)) {
    p1 = parseFloat(p1);
    p2 = parseFloat(p2);

    if (typeof p1 !== 'number' || isNaN(p1)) {
      p1 = 0.00;
    }

    if (typeof p2 !== 'number' || isNaN(p2)) {
      alert("The value " + p2 + "is not valid for the use with the operator " + operator);
      throw new Error("The value " + p2 + "is not valid for the use with the operator " + operator);
    }
  }

  switch (operator) {
    case '=':
      return p1 == p2;

    case '!=':
      return p1 != p2;

    case 'in':
      return p2.includes(p1);

    case 'not in':
      return !p2.includes(p1);

    case '>':
      return p1 > p2;

    case '>=':
      return p1 >= p2;

    case '<':
      return p1 < p2;

    case '<=':
      return p1 <= p2;

    case 'is_empty':
      return p1 === undefined || p1 == "" || p1 == null;

    case 'is_not_empty':
      return p1 !== undefined && p1 != "" && p1 != null;

    default:
      alert("El operador " + operator + " no se encuentra soportado");
      throw new Error("Operator " + operator + " not Supported");
  }
};
var downloadFile = function downloadFile(url, name) {
  var downloadLink = document.createElement("a");
  downloadLink.href = url;
  downloadLink.download = name ? name : "download.csv";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};
var readFile = function readFile(value) {
  try {
    var res = "";

    if (environment() === 'web') {
      res = URL.createObjectURL(value);
      return Promise.resolve(res);
    } else {
      return Promise.resolve(new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.readAsDataURL(value.data);

        reader.onload = function () {
          resolve(reader.result);
        };
      }));
    }
  } catch (e) {
    return Promise.reject(e);
  }
};
var castValue = function castValue(ftype, value, operator) {
  var castInteger = function castInteger(val) {
    return parseInt(val);
  };

  var types = {
    'integer': function integer(value) {
      return Array.isArray(value) ? value : castInteger(value);
    },
    'many2one': function many2one(value) {
      return castInteger(value);
    }
  };
  var operators = {
    'in': function _in(value) {
      return Array.isArray(value) ? value : [value];
    },
    '=': function _(value) {
      return value;
    }
  };

  if (!types[ftype]) {
    return value;
  }

  return operators[operator](types[ftype](value));
};
var mergeDomain = function mergeDomain(current_domain, new_domain) {
  var domain = [].concat(new_domain);
  var seen_fields = domain.map(function (pair) {
    return pair[0];
  });
  current_domain.forEach(function (pair) {
    if (!seen_fields.includes(pair[0])) {
      domain.push(pair);
    }
  });
  return domain;
};
var common = {
  validateNumber: validateNumber,
  validateInput: validateInput,
  validateDate: validateDate,
  createUrl: createUrl,
  evalExpr: evalExpr,
  browseObject: browseObject,
  formatDate: formatDate,
  flatten: flatten,
  environment: environment,
  readFile: readFile,
  formats: formats,
  parse_domain: parse_domain,
  domain_to_object: domain_to_object,
  castValue: castValue,
  mergeDomain: mergeDomain
};

var createField = function createField(attributes, screen) {
  switch (attributes.type) {
    case 'char':
      return new CharField(attributes, screen);

    case 'integer':
      return new IntegerField(attributes, screen);

    case 'float':
      return new FloatField(attributes, screen);

    case 'many2one':
      return new Many2OneField(attributes, screen);

    case 'multi_link':
      return new MultiLinkField(attributes, screen);

    case 'reference':
      return new ReferenceField(attributes, screen);

    case 'date':
      return new DateField(attributes, screen);

    case 'datetime':
      return new DateTimeField(attributes, screen);

    case 'selection':
      return new SelectionField(attributes, screen);

    case 'multi_selection':
      return new MultiSelectionField(attributes, screen);

    case 'boolean':
      return new BooleanField(attributes, screen);

    case 'one2many':
      return new One2ManyField(attributes, screen);

    case 'button':
      return new Button(attributes, screen);

    case 'divider':
      return new Divider(attributes, screen);

    case 'text':
      return new TextField(attributes, screen);

    case 'dict':
      return new DictField(attributes, screen);

    case 'lookup':
      return new LookUpField(attributes, screen);

    case 'binary':
      return new BinaryField(attributes, screen);

    case 'html':
      return new HTMLField(attributes, screen);

    case 'formula':
      return createFormulaField(attributes, screen);

    default:
      throw new Error("Unsupported Field Type: " + attributes.type);
  }
};
var Field = /*#__PURE__*/function () {
  function Field(attributes, screen) {
    if (screen) {
      this.screen = screen;
    }

    this.attributes = attributes;
    this.char_search = attributes.char_search;
    this.colspan = attributes.colspan ? attributes.colspan : this.screen && this.screen.default_columns ? this.screen.default_columns : 4;
    this.column_start = attributes.column_start;
    this.default_value = attributes.default_value;
    this.description = attributes.description;
    this.id = attributes.id;
    this.lazy = attributes.lazy;
    this.mobile_available = attributes.mobile_available;
    this.name = attributes.name;
    this.original_name = attributes.original_name;
    this.readonly = attributes.readonly;
    this.required = attributes.required;
    this.searchable = attributes.searchable;
    this.sortable = attributes.sortable;
    this.states = attributes.states;
    this.type = attributes.type;
    this.visible = attributes.visible;
    this.width = attributes.width;
    this.hide_value = attributes.hide_value;
    this.hide_label = attributes.hide_label;
    this.background_color = attributes.background_color;
    this.text_color = attributes.text_color;
    this.prefix = attributes.prefix;
    this.in_edition = false;
    this.height = attributes.height;
    this.filter = attributes.filter || false;
    this.style = attributes.style ? JSON.parse(attributes.style) : '', this.conditional_style = attributes.conditional_style;
    this.conditional_style_dependencies = attributes.conditional_style_dependencies ? attributes.conditional_style_dependencies.split(';') : [];
    this.tooltip = attributes.tooltip || false;
    this.freeze = attributes.freeze ? attributes.freeze : false;
    this.no_wrap = attributes.no_wrap;
    this.on_change = attributes.on_change ? new Function('{value,record}', attributes.on_change) : false;
    makeObservable(this, {
      in_edition: observable,
      set_edition: action
    });
  }

  var _proto = Field.prototype;

  _proto.get_style = function get_style(record) {
    var style = {};

    if (this.style) {
      style = this.style;
    }

    if (this.conditional_style) {
      style = _extends({}, style, record.get_style(this.name));
    }

    return style;
  };

  _proto.get_conditional_style = function get_conditional_style(calc) {
    try {
      var _this2 = this;

      var args = {};
      var value = {};
      args['field'] = _this2.id;
      args['data'] = calc.get_dependencies_values();
      var abortController = new AbortController();
      return Promise.resolve(_this2.screen.connection.dispatch('GET', '/field/conditional_style', args, false, true, false, abortController)).then(function (_this$screen$connecti) {
        value = _this$screen$connecti;
        return value;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.set_edition = function set_edition(record) {
    this.in_edition = record.id;
  };

  _proto.get_value = function get_value(record) {
    return record.get_value(this.name);
  };

  _proto.get_prefix_value = function get_prefix_value(record) {
    return this.prefix;
  };

  _proto.get_string_value = function get_string_value(record, val) {
    var value = val ? val : this.get_value(record);

    if (value) {
      value = value.toString();
    } else {
      value = "";
    }

    var prefix = this.get_prefix_value(record);

    if (prefix) {
      value = prefix.concat(value);
    }

    return value;
  };

  _proto.set_value = function set_value(value, record) {
    record.set_value(this.name, value);
  };

  _proto.get_state_attrs = function get_state_attrs(record) {
    var state_attrs = record.state_attrs ? record.state_attrs[this.name] ? record.state_attrs[this.name].get_value() : false : false;

    if (!state_attrs) {
      state_attrs = {
        'invisible': this.invisible,
        'readonly': this.readonly,
        'required': this.required
      };
    }

    return state_attrs;
  };

  _proto.has_value = function has_value(record) {
    return Boolean(record._values[this.name]);
  };

  _proto.nameInFilters = function nameInFilters(fname) {
    var filter_name = false;

    if (!this.filter) {
      return filter_name;
    }

    return this.filter.filter_group.get_filter_fname(fname);
  };

  _proto.custom_on_change = function custom_on_change(_ref) {
    var value = _ref.value,
        record = _ref.record;

    if (!record || !this.on_change) {
      return;
    }

    try {
      this.on_change({
        value: value,
        record: record
      });
    } catch (e) {
      var message = "A problem ocurred with the custom on_change method of the field: " + this.name + '  =>  ';
      message += e.toString();
      this.screen.notifications.addSnack({
        message: message,
        level: 'error',
        timeout: 5000
      });
    }
  };

  _createClass(Field, [{
    key: "default_state_attrs",
    get: function get() {
      return {
        'required': this.required,
        'readonly': this.readonly,
        'invisible': !this.visible
      };
    }
  }, {
    key: "grid_cls",
    get: function get() {
      var cls = clsx("col-span-" + this.screen.default_columns, "md:col-span-" + this.colspan);

      if (this.column_start) {
        cls = clsx(cls, 'md:col-start-' + this.column_start);
      }

      return cls;
    }
  }]);

  return Field;
}();

var CharField = /*#__PURE__*/function (_Field) {
  _inheritsLoose(CharField, _Field);

  function CharField(attributes, screen) {
    return _Field.call(this, attributes, screen) || this;
  }

  var _proto2 = CharField.prototype;

  _proto2.get_value = function get_value(record) {
    return record._values[this.name];
  };

  _proto2.set_value = function set_value(value, record) {
    record.set_value(this.name, value);
  };

  return CharField;
}(Field);

var TextField = /*#__PURE__*/function (_CharField) {
  _inheritsLoose(TextField, _CharField);

  function TextField(attributes, screen) {
    return _CharField.call(this, attributes, screen) || this;
  }

  return TextField;
}(CharField);

var IntegerField = /*#__PURE__*/function (_Field2) {
  _inheritsLoose(IntegerField, _Field2);

  function IntegerField(attributes, screen) {
    return _Field2.call(this, attributes, screen) || this;
  }

  var _proto3 = IntegerField.prototype;

  _proto3.get_value = function get_value(record) {
    return record._values[this.name];
  };

  _proto3.get_string_value = function get_string_value(record, val) {
    var value = !isNaN(val) ? val : this.get_value(record);

    if (value || value === 0) {
      value = value.toString();
    } else {
      value = "";
    }

    var prefix = this.get_prefix_value(record);

    if (prefix) {
      value = prefix.concat(value);
    }

    return value;
  };

  _proto3.set_value = function set_value(value, record) {
    value = value || value == 0 ? parseInt(value) : null;
    record.set_value(this.name, value);
  };

  return IntegerField;
}(Field);

var FloatField = /*#__PURE__*/function (_Field3) {
  _inheritsLoose(FloatField, _Field3);

  function FloatField(attributes, screen) {
    return _Field3.call(this, attributes, screen) || this;
  }

  var _proto4 = FloatField.prototype;

  _proto4.get_value = function get_value(record) {
    return record.get_value(this.name);
  };

  _proto4.get_string_value = function get_string_value(record, val) {
    var value = !isNaN(val) ? this.get_formatted_value(false, val) : this.get_formatted_value(record);

    if (value || value === 0) {
      value = value.toString();
    } else {
      value = "";
    }

    var prefix = this.get_prefix_value(record);

    if (prefix) {
      value = prefix.concat(value);
    }

    return value;
  };

  _proto4.set_value = function set_value(value, record) {
    value = value || value === 0 ? Number(value.replace(',', '.')) : null;
    record.set_value(this.name, value);
  };

  _proto4.get_formatted_value = function get_formatted_value(record, value) {
    var val = !isNaN(value) ? value : this.get_value(record);

    if (!val && val !== 0) {
      return null;
    }

    var options = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 20
    };
    return Number(val).toLocaleString('es', options);
  };

  return FloatField;
}(Field);

var Many2OneField = /*#__PURE__*/function (_Field4) {
  _inheritsLoose(Many2OneField, _Field4);

  function Many2OneField(attributes, screen) {
    var _this3;

    _this3 = _Field4.call(this, attributes, screen) || this;
    _this3.rec_name_field = "";
    _this3.key_fields = "";
    _this3.data_name = "";
    _this3.read_fields = "";
    _this3.rec_name_field = attributes.rec_name_field || "";
    _this3.key_fields = attributes.key_fields ? attributes.key_fields.split(';') : null;
    _this3.group_options = attributes.group_options;
    _this3.value_field = attributes.value_field;
    _this3.data_name = _this3.name.concat('.') || "";
    _this3.read_fields = attributes.read_fields ? attributes.read_fields.split(';') : [];
    return _this3;
  }

  var _proto5 = Many2OneField.prototype;

  _proto5.get_key_fields_values = function get_key_fields_values(record) {
    if (!this.key_fields) {
      return "";
    }

    var values = {};
    var parent_record = this.screen.parent ? this.screen.parent.active_record : false;
    this.key_fields.forEach(function (field) {
      var value = -1;
      var fname = field;

      if (field.includes('.')) {
        fname = field.split('.')[0];
      }

      if (fname === '_parent_record') {
        value = browseObject(record.get_all_values(), field, {}, [], parent_record.get_all_values());
      } else if (record._values[fname]) {
        value = browseObject(record.get_all_values(), field);
      }

      if (Array.isArray(value)) {
        value = flatten(value);
      }

      if (!value) {
        value = -1;
      }

      values[field] = value;
    });
    return values;
  };

  _proto5.getOptions = function getOptions(record, inputValue) {
    try {
      var _this5 = this;

      var args = {
        'id': _this5.id
      };
      var options = [];
      var abortController = new AbortController();
      args['search'] = [];

      var filter_options = function filter_options(v) {
        var res = v.id;

        if (_this5.group_options) {
          res = browseObject(v.data, _this5.group_options);
        }

        return res;
      };

      if (_this5.key_fields) {
        var key_field_values = _this5.get_key_fields_values(record);

        for (var field in key_field_values) {
          args['search'].push([field, '=', key_field_values[field]]);
        }
      }

      return Promise.resolve(_this5.screen.connection.dispatch('GET', '/field/field_options', args, false, true, false, abortController)).then(function (_this4$screen$connect) {
        options = _this4$screen$connect;
        options = options.map(function (option) {
          return {
            id: this.value_field ? browseObject(option, this.value_field) : option.id,
            rec_name: this.rec_name_field ? browseObject(option, this.rec_name_field) : option.rec_name,
            data: option
          };
        }.bind(_this5)).filter(function (v, i, a) {
          return a.findIndex(function (t) {
            return filter_options(t) === filter_options(v);
          }) === i;
        });
        return options;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto5.get_value = function get_value(record, raw) {
    if (raw === void 0) {
      raw = false;
    }

    var value = record.get_value(this.data_name);

    if (raw && value) {
      return value.id;
    }

    if (this.rec_name_field && value) {
      var val = {};
      var data = value.data ? value.data : value;
      val.rec_name = browseObject(data, this.rec_name_field) || value.rec_name;
      val.id = value.id;
      value = val;
    }

    return value;
  };

  _proto5.get_string_value = function get_string_value(record) {
    var val = this.get_value(record);
    var value = typeof val === 'object' && val !== null ? val.rec_name : val;
    return value;
  };

  _proto5.set_value = function set_value(value, record) {
    var values = {};
    values[this.name] = value ? value.id : null;
    values[this.data_name] = value ? value : null;
    record.set_values(values);
  };

  _proto5.has_value = function has_value(record) {
    return record._values[this.name] > 0;
  };

  return Many2OneField;
}(Field);

var MultiLinkField = /*#__PURE__*/function (_Many2OneField) {
  _inheritsLoose(MultiLinkField, _Many2OneField);

  function MultiLinkField(attributes, screen) {
    return _Many2OneField.call(this, attributes, screen) || this;
  }

  var _proto6 = MultiLinkField.prototype;

  _proto6.get_rec_name = function get_rec_name(value) {
    if (this.rec_name_field) {
      return browseObject(value, this.rec_name_field) || value.rec_name;
    } else {
      value = value.rec_name ? value.rec_name : "";
    }

    return value;
  };

  _proto6.get_string_value = function get_string_value(record) {
    var value = this.get_value(record);

    if (!value) {
      return "";
    } else {
      return this.get_value(record).map(function (item) {
        return this.get_rec_name(item);
      }.bind(this)).toString();
    }
  };

  _proto6.get_value = function get_value(record) {
    var value = record.get_value(this.data_name);
    return value;
  };

  _proto6.has_value = function has_value(record) {
    var value = record._values[this.name];
    return (value && value.length) > 0;
  };

  _proto6.set_value = function set_value(value, record) {
    var values = {};
    var data_values = value ? value : null;
    values[this.name] = value ? value.map(function (v) {
      return v.id ? v.id : v;
    }) : null;
    var no_data = value ? value.filter(function (v) {
      return !v.rec_name;
    }) : [];

    if (no_data.length) {
      this.getOptions(record).then(function (options) {
        data_values = [];
        value = values[this.name].map(function (v) {
          v = parseInt(v);
          var option = options.find(function (o) {
            return o.id === v;
          });
          data_values.push({
            id: v,
            rec_name: option.rec_name
          });
        });
        values[this.data_name] = data_values;
        record.set_values(values);
      }.bind(this));
    } else {
      values[this.data_name] = data_values;
      record.set_values(values);
    }
  };

  return MultiLinkField;
}(Many2OneField);

var ReferenceField = /*#__PURE__*/function (_Many2OneField2) {
  _inheritsLoose(ReferenceField, _Many2OneField2);

  function ReferenceField(attributes, screen) {
    return _Many2OneField2.call(this, attributes, screen) || this;
  }

  return ReferenceField;
}(Many2OneField);

var SelectionField = /*#__PURE__*/function (_Field5) {
  _inheritsLoose(SelectionField, _Field5);

  function SelectionField(attributes, screen) {
    var _this6;

    _this6 = _Field5.call(this, attributes, screen) || this;
    _this6.selection_options = [];
    _this6.selection_options = attributes.selection_options || [];
    return _this6;
  }

  var _proto7 = SelectionField.prototype;

  _proto7.get_value = function get_value(record, raw) {
    if (raw === void 0) {
      raw = false;
    }

    var values = this.selection_options.filter(function (option) {
      return option.value === record.get_value(this.name);
    }.bind(this));
    var value = values.length ? values[0] : [];

    if (raw && !Array.isArray(value)) {
      value = value.value;
    }

    return value;
  };

  _proto7.get_style = function get_style(record) {
    var _this7 = this;

    var style = {};
    var selected_option = this.selection_options.find(function (opt) {
      return opt.value === record.get_value(_this7.name);
    });

    if (selected_option && selected_option.color) {
      style['color'] = selected_option.color;
    }

    return style;
  };

  _proto7.get_string_value = function get_string_value(record) {
    var value = this.get_value(record);
    return value ? value.label : "";
  };

  _proto7.set_value = function set_value(value, record) {
    record.set_value(this.name, value.value);
  };

  return SelectionField;
}(Field);

var MultiSelectionField = /*#__PURE__*/function (_Field6) {
  _inheritsLoose(MultiSelectionField, _Field6);

  function MultiSelectionField(attributes, screen) {
    var _this8;

    _this8 = _Field6.call(this, attributes, screen) || this;
    _this8.selection_options = [];
    _this8.selection_options = attributes.selection_options || [];
    return _this8;
  }

  var _proto8 = MultiSelectionField.prototype;

  _proto8.get_value = function get_value(record) {
    var vals = record.get_value(this.name);

    if (!vals) {
      return vals;
    } else {
      var res = vals.map(function (val) {
        return this.selection_options.filter(function (option) {
          return option.value === val;
        }.bind(this))[0];
      }.bind(this));
      return res;
    }
  };

  _proto8.get_string_value = function get_string_value(record) {
    var values = this.get_value(record);

    if (!values) {
      return "";
    }

    return values.map(function (val) {
      return val.label;
    }).toString();
  };

  _proto8.set_value = function set_value(value, record) {
    if (!value) {
      value = [];
    }

    var values = value.map(function (val) {
      return val.value ? val.value : val;
    });
    record.set_value(this.name, values);
  };

  return MultiSelectionField;
}(Field);

var DateField = /*#__PURE__*/function (_Field7) {
  _inheritsLoose(DateField, _Field7);

  function DateField(attributes, screen) {
    var _this9;

    _this9 = _Field7.call(this, attributes, screen) || this;
    _this9.min_date = "";
    _this9.max_date = "";
    _this9.min_date = attributes.min_date;
    _this9.max_date = attributes.max_date;
    return _this9;
  }

  var _proto9 = DateField.prototype;

  _proto9.get_value = function get_value(record) {
    return moment(record.get_value(this.name));
  };

  _proto9.get_string_value = function get_string_value(record, val) {
    var value = val ? val : record.get_value(this.name);
    return formatDate(value, 'date');
  };

  _proto9.date_from_string = function date_from_string(val) {
    var vals = val.split('-');
    return new Date(parseInt(vals[0]), parseInt(vals[1]) - 1, parseInt(vals[2]));
  };

  _proto9.parse_limit_value = function parse_limit_value(value, record) {
    var res = false;

    if (value === '{_today}') {
      res = new Date();
    } else if (value.includes('{')) {
      var expr = value;
      var fname = expr.replace('{', "").replace('}', "");

      if (this.filter) {
        var expr_filter = this.nameInFilters(fname);
        expr = expr.replace(fname, expr_filter.id);
        fname = expr_filter.id;
      }

      var expr_value = browseObject(record._values, expr);

      if (expr_value != fname) {
        res = this.date_from_string(expr_value);
      }
    }

    return res;
  };

  _proto9.get_min_value = function get_min_value(record) {
    if (!this.min_date) {
      return false;
    }

    var min = this.parse_limit_value(this.min_date, record);

    if (this.get_value(record).toDate() < min) {
      this.set_value("", record);
    }

    return min;
  };

  _proto9.get_max_value = function get_max_value(record) {
    if (!this.max_date) {
      return false;
    }

    var max = this.parse_limit_value(this.max_date, record);

    if (this.get_value(record).toDate() > max) {
      this.set_value("", record);
    }

    return max;
  };

  return DateField;
}(Field);

var DateTimeField = /*#__PURE__*/function (_DateField) {
  _inheritsLoose(DateTimeField, _DateField);

  function DateTimeField(attributes, screen) {
    return _DateField.call(this, attributes, screen) || this;
  }

  var _proto10 = DateTimeField.prototype;

  _proto10.get_value = function get_value(record) {
    return moment.utc(record.get_value(this.name)).local();
  };

  _proto10.get_string_value = function get_string_value(record, val) {
    var value = val ? val : record.get_value(this.name);
    return formatDate(value, 'datetime');
  };

  return DateTimeField;
}(DateField);

var Button = /*#__PURE__*/function (_Field8) {
  _inheritsLoose(Button, _Field8);

  function Button(attributes, screen) {
    var _this10;

    _this10 = _Field8.call(this, attributes, screen) || this;
    _this10.button_type = "primary";
    makeObservable(_assertThisInitialized(_this10), {
      action: computed
    });
    _this10.action_id = attributes.action;
    _this10.button_variant = attributes.button_variant || 'primary';
    return _this10;
  }

  _createClass(Button, [{
    key: "action",
    get: function get() {
      var _this11 = this;

      return this.screen.actions.find(function (act) {
        return act.id === _this11.action_id;
      });
    }
  }]);

  return Button;
}(Field);

var Divider = /*#__PURE__*/function (_Field9) {
  _inheritsLoose(Divider, _Field9);

  function Divider(attributes, screen) {
    return _Field9.call(this, attributes, screen) || this;
  }

  return Divider;
}(Field);

var BooleanField = /*#__PURE__*/function (_Field10) {
  _inheritsLoose(BooleanField, _Field10);

  function BooleanField(attributes, screen) {
    return _Field10.call(this, attributes, screen) || this;
  }

  var _proto11 = BooleanField.prototype;

  _proto11.get_value = function get_value(record) {
    var val = record.get_value(this.name);

    if (val) {
      val = 1;
    } else {
      val = 0;
    }

    return val;
  };

  return BooleanField;
}(Field);

var One2ManyField = /*#__PURE__*/function (_Field11) {
  _inheritsLoose(One2ManyField, _Field11);

  function One2ManyField(attributes, screen) {
    var _this12;

    _this12 = _Field11.call(this, attributes) || this;
    _this12.screen = false;
    _this12.current_record = false;
    _this12.initialized = false;
    _this12.list_active_record = false;
    _this12.key_fields = "";
    _this12.view = attributes.display_view;
    _this12.view_form = attributes.display_form_view;
    _this12.record_form_action = attributes.record_form_action;
    _this12.confirm_form_action = attributes.confirm_form_action;
    _this12.domain = attributes.domain;
    _this12.parent = screen;
    _this12.active_record = false;
    _this12.new_record_button = attributes.new_record_button ? attributes.new_record_button : false;
    _this12.key_fields = attributes.key_fields ? attributes.key_fields.split(';') : null;
    makeObservable(_assertThisInitialized(_this12), {
      initialize: action,
      initialized: observable,
      screen: observable,
      list_active_record: observable,
      set_list_active_record: action
    });
    return _this12;
  }

  var _proto12 = One2ManyField.prototype;

  _proto12.get_key_fields_values = function get_key_fields_values(record) {
    if (!this.key_fields) {
      return "";
    }

    var values = {};
    var parent_record = this.screen.parent ? this.screen.parent.active_record : false;

    var record_values = _extends({}, record.get_all_values());

    this.key_fields.forEach(function (field) {
      var value = -1;
      var fname = field;

      if (field.includes('.')) {
        fname = field.split('.')[0];
      }

      if (fname === '_parent_record') {
        value = browseObject(record_values, field, false, [], parent_record._values);
      } else if (record_values[fname]) {
        value = browseObject(record_values, field, false);
      }

      if (Array.isArray(value)) {
        value = flatten(value);
      }

      if (!value) {
        value = -1;
      }

      values[field] = value;
    });
    return JSON.stringify(values);
  };

  _proto12.get_domain = function get_domain(record) {
    if (!record) {
      record = this.current_record;
    }

    var domain = parse_domain(record.get_all_values(), this.domain, false, this.parent.parent_selected_records);
    var initial_search = {
      current_search: []
    };

    if (domain) {
      initial_search.current_search = domain;
    }

    return initial_search;
  };

  _proto12.initialize = function initialize(record, force_reload, callback) {
    var _this13 = this;

    if (callback === void 0) {
      callback = false;
    }

    if (record.id === this.current_record.id && !force_reload) {
      return false;
    }

    this.current_record = record;
    var local_values = this.current_record.get_value(this.name);
    var initialize_data = local_values ? false : true;
    var intialize_callback = local_values ? function (screen) {
      return screen_callback(record);
    } : false;
    var initial_search = {
      'current_search': []
    };

    var screen_callback = function screen_callback(record, screen) {
      if (record) {
        if (callback) {
          return callback(record);
        }
      }
    };

    screen = this.parent.field_childs.addScreen(this.view, false, initial_search, {}, false, true, this.parent, true, true, initialize_data, intialize_callback);
    screen.parent = this.parent;
    screen.auto_save = false;
    screen.set_title(this.description);
    screen.set_readonly(this.get_state_attrs(record).readonly);

    if (this.record_form_action) {
      var actions_map = {};
      var add_record_button = this.new_record_button ? this.new_record_button : false;

      if (add_record_button) {
        add_record_button['execute'] = function () {
          _this13.openFormView();
        };

        screen.set_add_record_button(add_record_button);
      }

      actions_map[this.record_form_action.name] = function (records) {
        _this13.openFormView(records[0]);
      };

      screen.set_actions_map(actions_map);
    }

    this.screen = screen;
    this.initialized = true;
    this.screen.set_field_instance(this);
    return screen;
  };

  _proto12.get_local_values = function get_local_values() {
    return this.current_record.get_value(this.name);
  };

  _proto12.apply_local_values = function apply_local_values() {
    var values = this.get_local_values();
    this.addRecords(values);
  };

  _proto12.reload = function reload() {
    if (!this.initialized) {
      return;
    }

    var local_values = this.current_record.get_value(this.name);

    if (local_values) {
      this.apply_local_values();
    } else {
      var domain = this.get_domain();
      this.screen.do_search(domain);
    }
  };

  _proto12.confirmForm = function confirmForm(records, screen, callback) {
    var record = records[0];

    if (record._values.id < 0) {
      delete record._values['id'];
    }

    var fnames = this.screen.field_names;

    var values = _extends({}, record.get_all_values());

    for (var fname in values) {
      if (!fnames.includes(fname) && !fname.endsWith('.')) {
        delete values[fname];
      }
    }

    if (this.list_active_record) {
      this.list_active_record.set_values(values);
      this.set_list_active_record(false);
    } else {
      this.screen.data.addRecord({
        values: values,
        index: this.screen.data.length
      });
      this.screen.data.setChanged(true);
    }

    this.screen.modal_childs.removeScreen(screen);

    if (callback) {
      callback();
    }

    this.custom_on_change({
      value: this.screen.data.records,
      record: this.screen.data.records
    });
  };

  _proto12.openFormView = function openFormView(record, callback) {
    var _this14 = this;

    if (!this.view_form) {
      return false;
    }

    var initialize_data = record ? false : true;
    this.set_list_active_record(false);

    var screen_callback = function screen_callback(record, screen) {
      if (record) {
        var form_record = screen.data.addRecord({
          values: {},
          index: 0
        });
        screen.set_active_record(form_record);
        var new_values = record.get_all_values();
        form_record.set_values(new_values);

        _this14.set_list_active_record(record);
      }
    };

    var form_screen = this.screen.modal_childs.addScreen(this.view_form, false, {}, {}, true, true, this.parent, true, true, initialize_data, function (screen) {
      return screen_callback(record, screen);
    });
    var confirm_action_name = this.confirm_form_action.name;
    var actions_map = {};

    actions_map[confirm_action_name] = function (records) {
      _this14.confirmForm(records, form_screen.id, callback);
    };

    form_screen.set_actions_map(actions_map);
  };

  _proto12.set_list_active_record = function set_list_active_record(record) {
    this.list_active_record = record;
  };

  _proto12.has_value = function has_value(record) {
    var res = true;

    if (!this.initialized) {
      return false;
    }

    if (this.screen.data.records.length < 1) {
      res = false;
    } else {
      this.screen.data.records.forEach(function (rec) {
        if (!rec.validate()) {
          res = false;
        }
      });
    }

    return res;
  };

  _proto12.get_value = function get_value(record) {
    if (!this.initialized || !this.screen.data.records) {
      return [];
    }

    return this.screen.data.records.map(function (rec) {
      return rec.get_all_values();
    });
  };

  _proto12.addRecord = function addRecord(_ref2) {
    var values = _ref2.values,
        index = _ref2.index;
    this.screen.data.addRecord({
      values: values,
      index: index
    });
    this.screen.data.setChanged(true);
  };

  _proto12.addRecords = function addRecords(values) {
    values.forEach(function (val) {
      this.addRecord({
        values: val
      });
    }.bind(this));
  };

  _proto12.getRecords = function getRecords() {
    return this.screen.data.records;
  };

  _proto12.clearRecords = function clearRecords() {
    return this.screen.data.clearRecords();
  };

  return One2ManyField;
}(Field);

var DictField = /*#__PURE__*/function (_Field12) {
  _inheritsLoose(DictField, _Field12);

  function DictField(attributes, screen) {
    return _Field12.call(this, attributes, screen) || this;
  }

  var _proto13 = DictField.prototype;

  _proto13.get_value = function get_value(record) {
    return record.get_value(this.name);
  };

  _proto13.get_string_value = function get_string_value(record) {
    var value = record.get_value(this.name) || false;
    var string = "";

    if (value) {
      var addValue = function addValue(k) {
        return k.concat(':').concat(value[k].toString()).concat(';');
      };

      for (var k in value) {
        string = string.concat(addValue(k));
      }
    }

    return string;
  };

  return DictField;
}(Field);

var LookUpField = /*#__PURE__*/function (_Field13) {
  _inheritsLoose(LookUpField, _Field13);

  function LookUpField(attributes, screen) {
    var _this15;

    _this15 = _Field13.call(this, attributes, screen) || this;
    _this15.expression = "";
    _this15.depends = [];
    _this15.expression = attributes.lookup_expression;
    _this15.depends = [_this15.expression.split('.')[0]];
    return _this15;
  }

  var _proto14 = LookUpField.prototype;

  _proto14.get_value = function get_value(record) {
    var value = "";

    if (this.expression === this.name) {
      return record._values[this.name];
    } else if (this.pre_readed_value) {
      var local_value = browseObject(record._values, this.expression);

      if (local_value && local_value != this.expression) {
        return local_value;
      }

      return "";
    }

    if (record._values[this.name]) {
      value = record._values[this.name].get_value();
    } else {
      value = record.set_calculated_value(this);
    }

    return value;
  };

  _proto14.get_string_value = function get_string_value(record) {
    var value = this.get_value(record);

    if (this.prefix) {
      value = this.get_prefix_value(record).concat(value);
    }

    return value;
  };

  _proto14.get_dependencies = function get_dependencies(record) {
    var values = {};
    this.depends.forEach(function (d) {
      values[d] = record.get_value(d);
    });
    return values;
  };

  _proto14.is_loading = function is_loading(record) {
    var loading = true;

    if (record._values[this.name]) {
      loading = record._values[this.name].loading;
    }

    return loading;
  };

  _proto14.get_lookup_value = function get_lookup_value(record) {
    try {
      var _this17 = this;

      var args = {};
      var value = "";
      args['field'] = _this17.id;
      args['data'] = _this17.get_dependencies(record);

      if (Object.values(args['data']).includes(null) || Object.values(args['data']).includes(undefined)) {
        return Promise.resolve("");
      }

      var abortController = new AbortController();
      return Promise.resolve(_this17.screen.connection.dispatch('GET', '/field/lookup_value', args, false, true, false, abortController)).then(function (_this16$screen$connec) {
        value = _this16$screen$connec;
        return value;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _createClass(LookUpField, [{
    key: "pre_readed_value",
    get: function get() {
      var fname = this.depends[0];
      var field = this.screen.get_field_by_name(fname);

      if (field && field.read_fields) {
        return field.read_fields.includes(this.expression.replace(fname + '.', ''));
      }

      return false;
    }
  }]);

  return LookUpField;
}(Field);

var BinaryField = /*#__PURE__*/function (_Field14) {
  _inheritsLoose(BinaryField, _Field14);

  function BinaryField(attributes, screen) {
    var _this18;

    _this18 = _Field14.call(this, attributes, screen) || this;
    _this18.filename_field = "";
    _this18.filename_field = attributes.filename_field;
    return _this18;
  }

  var _proto15 = BinaryField.prototype;

  _proto15.get_binary_value = function get_binary_value(record) {
    try {
      var _this20 = this;

      var abortController = new AbortController();
      var args = {
        'field': _this20.id,
        'record': record.id
      };
      return Promise.resolve(_this20.screen.connection.dispatch('GET', '/get_binary_value', args, false, false, true, abortController)).then(function (value) {
        var _temp2 = function () {
          if (value) {
            var _temp3 = function () {
              if (value.type === 'application/json') {
                value = false;
              } else {
                return Promise.resolve(readFile(value.data)).then(function (_readFile) {
                  value = _readFile;
                });
              }
            }();

            if (_temp3 && _temp3.then) return _temp3.then(function () {});
          } else {
            value = false;
          }
        }();

        return _temp2 && _temp2.then ? _temp2.then(function () {
          return value;
        }) : value;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto15.get_value = function get_value(record) {
    var value = "";

    if (record._values[this.name]) {
      value = record._values[this.name].get_value();
    } else {
      value = record.set_binary_value(this);
    }

    return value;
  };

  _proto15.download_content = function download_content(record) {
    var filename = this.get_filename(record);

    if (filename instanceof Promise) {
      filename.then(function (val) {
        return downloadFile(this.get_value(record).data, val);
      }.bind(this));
    } else {
      return downloadFile(this.get_value(record).data, filename);
    }
  };

  _proto15.get_filename = function get_filename(record) {
    return this.screen.get_field_by_name(this.filename_field).get_string_value(record);
  };

  _proto15.is_loading = function is_loading(record) {
    var loading = true;

    if (record._values[this.name]) {
      loading = record._values[this.name].loading;
    }

    return loading;
  };

  _proto15.set_value = function set_value(value, record) {
    record._values[this.name].set_value(value);

    record.set_changed([this.name]);
  };

  _proto15.has_value = function has_value(record) {
    var val = this.get_value(record);

    if (!val) {
      return false;
    }

    return true;
  };

  return BinaryField;
}(Field);

var HTMLField = /*#__PURE__*/function (_Field15) {
  _inheritsLoose(HTMLField, _Field15);

  function HTMLField(attributes, screen) {
    return _Field15.call(this, attributes, screen) || this;
  }

  var _proto16 = HTMLField.prototype;

  _proto16.get_value = function get_value(record) {
    return record.get_value(this.name);
  };

  return HTMLField;
}(Field);

var FormulaField = /*#__PURE__*/function (_Field16) {
  _inheritsLoose(FormulaField, _Field16);

  function FormulaField(attributes, screen) {
    var _this21;

    _this21 = _Field16.call(this, attributes, screen) || this;
    _this21.formula_field_widget = "";
    _this21.formula_type = "";
    _this21.formula_dependencies = [];
    _this21.field_widget = "";
    _this21.formula_field_widget = attributes.formula_field_widget;
    _this21.formula_type = attributes.formula_type;
    _this21.formula_dependencies = attributes.formula_dependencies ? attributes.formula_dependencies.split(';') : [];
    _this21.readonly = true;

    var widget_attributes = _extends({}, attributes);

    widget_attributes['type'] = attributes.formula_field_widget;
    _this21.field_widget = createField(widget_attributes, screen);
    _this21.selection_options = attributes.selection_options;
    return _this21;
  }

  var _proto17 = FormulaField.prototype;

  _proto17.is_loading = function is_loading(record) {
    if (record._values[this.name]) {
      return record._values[this.name].loading;
    }
  };

  _proto17.get_formatted_value = function get_formatted_value(record) {
    return this.field_widget.get_formatted_value(false, this.get_value(record));
  };

  _proto17.get_value = function get_value(record) {
    var value = "";

    if (record._values[this.name]) {
      value = record._values[this.name].get_value();
    } else {
      value = record.set_new_calculated_value(this);
    }

    return value;
  };

  _proto17.get_string_value = function get_string_value(record, value) {
    if (value === void 0) {
      value = false;
    }

    value = value ? value : this.get_value(record);

    if (value instanceof Promise) {
      value.then(function (val) {
        return val.toString();
      });
    }

    return value;
  };

  _proto17.get_calculated_value = function get_calculated_value(calc) {
    try {
      var _this23 = this;

      var args = {};
      var value = "";
      args['field'] = _this23.id;
      args['data'] = calc.get_dependencies_values();

      for (var k in args['data']) {
        if (args['data'][k] === null) {
          args['data'][k] = "";
        }
      }

      var abortController = new AbortController();
      return Promise.resolve(_this23.screen.connection.dispatch('GET', '/field/formula_value', args, false, true, false, abortController)).then(function (_this22$screen$connec) {
        value = _this22$screen$connec;
        return value;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return FormulaField;
}(Field);

var InlineFormulaField = /*#__PURE__*/function (_FormulaField) {
  _inheritsLoose(InlineFormulaField, _FormulaField);

  function InlineFormulaField(attributes, screen) {
    var _this24;

    _this24 = _FormulaField.call(this, attributes, screen) || this;
    _this24.formula_value = "";
    _this24.formula_value = attributes.formula_value;
    return _this24;
  }

  return InlineFormulaField;
}(FormulaField);

var BackendCustomFormula = /*#__PURE__*/function (_FormulaField2) {
  _inheritsLoose(BackendCustomFormula, _FormulaField2);

  function BackendCustomFormula(attributes, screen) {
    var _this25;

    _this25 = _FormulaField2.call(this, attributes, screen) || this;
    _this25.backend_method_name = "";
    _this25.backend_method_name = "";
    return _this25;
  }

  return BackendCustomFormula;
}(FormulaField);

var FrontendCustomFormula = /*#__PURE__*/function (_FormulaField3) {
  _inheritsLoose(FrontendCustomFormula, _FormulaField3);

  function FrontendCustomFormula(attributes, screen) {
    var _this26;

    _this26 = _FormulaField3.call(this, attributes, screen) || this;
    _this26.formula_js_value = "";
    _this26.formula_js_value = attributes.formula_js_value;
    _this26.formula = attributes.formula_js_value ? new Function('{values}', attributes.formula_js_value) : false;
    return _this26;
  }

  var _proto18 = FrontendCustomFormula.prototype;

  _proto18.get_calculated_value = function get_calculated_value(calc) {
    try {
      var _this28 = this;

      var args = {};
      args['field'] = _this28.id;

      var _values = calc.get_dependencies_values();

      try {
        return Promise.resolve(_this28.formula({
          values: _values
        }));
      } catch (e) {
        var message = "A problem ocurred with the formula field: " + _this28.name + '  =>  ';
        message += e.toString();

        _this28.screen.notifications.addSnack({
          message: message,
          level: 'error',
          timeout: 5000
        });
      }

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return FrontendCustomFormula;
}(FormulaField);

var FORMULA_FIELDS = {
  'formula': InlineFormulaField,
  'custom_method': BackendCustomFormula,
  'frontend_custom_method': FrontendCustomFormula
};

var createFormulaField = function createFormulaField(attributes, screen) {
  return new FORMULA_FIELDS[attributes.formula_type](attributes, screen);
};

// A type of promise-like that resolves synchronously and supports only one observer
const _Pact = /*#__PURE__*/(function() {
	function _Pact() {}
	_Pact.prototype.then = function(onFulfilled, onRejected) {
		const result = new _Pact();
		const state = this.s;
		if (state) {
			const callback = state & 1 ? onFulfilled : onRejected;
			if (callback) {
				try {
					_settle(result, 1, callback(this.v));
				} catch (e) {
					_settle(result, 2, e);
				}
				return result;
			} else {
				return this;
			}
		}
		this.o = function(_this) {
			try {
				const value = _this.v;
				if (_this.s & 1) {
					_settle(result, 1, onFulfilled ? onFulfilled(value) : value);
				} else if (onRejected) {
					_settle(result, 1, onRejected(value));
				} else {
					_settle(result, 2, value);
				}
			} catch (e) {
				_settle(result, 2, e);
			}
		};
		return result;
	};
	return _Pact;
})();

// Settles a pact synchronously
function _settle(pact, state, value) {
	if (!pact.s) {
		if (value instanceof _Pact) {
			if (value.s) {
				if (state & 1) {
					state = value.s;
				}
				value = value.v;
			} else {
				value.o = _settle.bind(null, pact, state);
				return;
			}
		}
		if (value && value.then) {
			value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
			return;
		}
		pact.s = state;
		pact.v = value;
		const observer = pact.o;
		if (observer) {
			observer(pact);
		}
	}
}

function _isSettledPact(thenable) {
	return thenable instanceof _Pact && thenable.s & 1;
}

// Asynchronously iterate through an object that has a length property, passing the index as the first argument to the callback (even as the length property changes)
function _forTo(array, body, check) {
	var i = -1, pact, reject;
	function _cycle(result) {
		try {
			while (++i < array.length && (!check || !check())) {
				result = body(i);
				if (result && result.then) {
					if (_isSettledPact(result)) {
						result = result.v;
					} else {
						result.then(_cycle, reject || (reject = _settle.bind(null, pact = new _Pact(), 2)));
						return;
					}
				}
			}
			if (pact) {
				_settle(pact, 1, result);
			} else {
				pact = result;
			}
		} catch (e) {
			_settle(pact || (pact = new _Pact()), 2, e);
		}
	}
	_cycle();
	return pact;
}

// Asynchronously iterate through an object's properties (including properties inherited from the prototype)
// Uses a snapshot of the object's properties
function _forIn(target, body, check) {
	var keys = [];
	for (var key in target) {
		keys.push(key);
	}
	return _forTo(keys, function(i) { return body(keys[i]); }, check);
}

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously implement a switch statement
function _switch(discriminant, cases) {
	var dispatchIndex = -1;
	var awaitBody;
	outer: {
		for (var i = 0; i < cases.length; i++) {
			var test = cases[i][0];
			if (test) {
				var testValue = test();
				if (testValue && testValue.then) {
					break outer;
				}
				if (testValue === discriminant) {
					dispatchIndex = i;
					break;
				}
			} else {
				// Found the default case, set it as the pending dispatch case
				dispatchIndex = i;
			}
		}
		if (dispatchIndex !== -1) {
			do {
				var body = cases[dispatchIndex][1];
				while (!body) {
					dispatchIndex++;
					body = cases[dispatchIndex][1];
				}
				var result = body();
				if (result && result.then) {
					awaitBody = true;
					break outer;
				}
				var fallthroughCheck = cases[dispatchIndex][2];
				dispatchIndex++;
			} while (fallthroughCheck && !fallthroughCheck());
			return result;
		}
	}
	const pact = new _Pact();
	const reject = _settle.bind(null, pact, 2);
	(awaitBody ? result.then(_resumeAfterBody) : testValue.then(_resumeAfterTest)).then(void 0, reject);
	return pact;
	function _resumeAfterTest(value) {
		for (;;) {
			if (value === discriminant) {
				dispatchIndex = i;
				break;
			}
			if (++i === cases.length) {
				if (dispatchIndex !== -1) {
					break;
				} else {
					_settle(pact, 1, result);
					return;
				}
			}
			test = cases[i][0];
			if (test) {
				value = test();
				if (value && value.then) {
					value.then(_resumeAfterTest).then(void 0, reject);
					return;
				}
			} else {
				dispatchIndex = i;
			}
		}
		do {
			var body = cases[dispatchIndex][1];
			while (!body) {
				dispatchIndex++;
				body = cases[dispatchIndex][1];
			}
			var result = body();
			if (result && result.then) {
				result.then(_resumeAfterBody).then(void 0, reject);
				return;
			}
			var fallthroughCheck = cases[dispatchIndex][2];
			dispatchIndex++;
		} while (fallthroughCheck && !fallthroughCheck());
		_settle(pact, 1, result);
	}
	function _resumeAfterBody(result) {
		for (;;) {
			var fallthroughCheck = cases[dispatchIndex][2];
			if (!fallthroughCheck || fallthroughCheck()) {
				break;
			}
			dispatchIndex++;
			var body = cases[dispatchIndex][1];
			while (!body) {
				dispatchIndex++;
				body = cases[dispatchIndex][1];
			}
			result = body();
			if (result && result.then) {
				result.then(_resumeAfterBody).then(void 0, reject);
				return;
			}
		}
		_settle(pact, 1, result);
	}
}

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var StateAttrs = /*#__PURE__*/function () {
  function StateAttrs(field, record) {
    this.field = false;
    this.record = false;
    this.readonly = null;
    this.required = null;
    this.invisible = null;
    this.dependencies = [];
    this.inputs = "";
    this.loading = true;
    this.initialized = false;
    this.states = {};
    makeObservable(this, {
      required: observable,
      invisible: observable,
      readonly: observable,
      initialized: observable,
      loading: observable,
      dependencies: observable,
      inputs: observable,
      reload: action,
      update_inputs: action
    });
    this.field = field;
    this.states = this.field.states;
    this.record = record;
    var default_attrs = field.default_state_attrs;
    this.invisible = default_attrs.invisible;
    this.readonly = this.field.screen.readonly == true ? true : default_attrs.readonly;
    this.required = default_attrs.required;
    this.loading = false;
    this.dependencies = this.get_dependencies();
  }

  var _proto = StateAttrs.prototype;

  _proto.get_dependencies = function get_dependencies() {
    var dependencies = [];

    if (this.states) {
      var expr = this.field.states.substring(1, this.field.states.length - 1);
      expr.match(/{([^}]+)}/g).forEach(function (field_name) {
        field_name = field_name.substring(1, field_name.length - 1);

        if (field_name.includes('.')) {
          field_name = field_name.split('.')[0];
        }

        var field = this.field_by_name(field_name);
        field_name = field.name;

        if (!dependencies.includes(field_name)) {
          dependencies.push(field_name);
        }
      }.bind(this));
    }

    return dependencies;
  };

  _proto.create_json_value = function create_json_value() {
    var vals = {};
    this.dependencies.forEach(function (dep) {
      var field = this.field_by_name(dep);

      if (!field) {
        console.log("NO FIELD");
        throw new Error("Check the state_attrs configuration of the field: " + this.field.name);
      }

      var value = field.get_value(this.record);
      vals[dep] = value;
    }.bind(this));
    return JSON.stringify(vals);
  };

  _proto.update_inputs = function update_inputs() {
    this.inputs = this.create_json_value();
  };

  _proto.field_by_name = function field_by_name(fname) {
    return this.record.screen.get_field_by_any_name(fname);
  };

  _proto.get_value = function get_value() {
    if (!this.dependencies.length) {
      return this;
    } else {
      if (this.inputsChanged()) {
        return this.reload();
      } else {
        return this;
      }
    }
  };

  _proto.inputsChanged = function inputsChanged() {
    var res = false;
    var new_values = this.create_json_value();

    if (new_values !== this.inputs) {
      res = true;
    }

    return res;
  };

  _proto.get_part_value = function get_part_value(part) {
    var value;

    if (typeof part === 'string' && part.startsWith('{')) {
      var expr = part.substring(1, part.length - 1);
      var fname = "";
      var raw = true;

      if (expr.includes('.')) {
        fname = expr.split('.')[0];
        raw = false;
      } else {
        fname = expr;
      }

      value = this.field_by_name(fname).get_value(this.record, raw);

      if (expr != fname) {
        expr = expr.replace(fname + '.', '');
        value = browseObject(value, expr);
      }
    } else {
      value = part;
    }

    return value;
  };

  _proto.reload = function reload() {
    var json = JSON.parse(this.states);

    for (var attr in json) {
      var conditions = json[attr].map(function (condition) {
        var p1 = this.get_part_value(condition[0]);
        var operator = condition[1];
        var p2 = this.get_part_value(condition[2]);
        return evalCondition(p1, operator, p2);
      }.bind(this));
      this[attr] = conditions.every(function (a) {
        return a === true;
      });
    }

    this.update_inputs();
    return this;
  };

  _createClass(StateAttrs, [{
    key: "definition",
    get: function get() {
      return {
        'required': this.required,
        'invisible': this.invisible,
        'readonly': this.readonly
      };
    }
  }]);

  return StateAttrs;
}();

var NewCalculatedValue = /*#__PURE__*/function () {
  function NewCalculatedValue(field, record, dependencies, value_getter) {
    if (dependencies === void 0) {
      dependencies = false;
    }

    if (value_getter === void 0) {
      value_getter = false;
    }

    this.field = false;
    this.record = false;
    this.value = "";
    this.dependencies = [];
    this.inputs = "";
    this.loading = true;
    this.value_getter = false;
    makeObservable(this, {
      loading: observable,
      dependencies: observable,
      inputs: observable,
      reload: action,
      update_inputs: action,
      setLoading: action
    });
    this.field = field;
    this.record = record;
    this.loading = false;
    this.dependencies = dependencies ? dependencies : field.formula_dependencies;
    this.value_getter = value_getter ? value_getter : false;
  }

  var _proto = NewCalculatedValue.prototype;

  _proto.get_dependencies_values = function get_dependencies_values() {
    var vals = {};
    this.dependencies.forEach(function (dep) {
      var field = this.field_by_name(dep);
      var value;

      if (field.type === 'formula' && field.is_loading(this.record)) {
        return;
      }

      value = field.get_value(this.record);
      vals[dep] = value;
    }.bind(this));
    return vals;
  };

  _proto.create_json_value = function create_json_value() {
    var vals = this.get_dependencies_values();

    if (Object.keys(vals).length === 0) {
      return false;
    }

    return JSON.stringify(vals);
  };

  _proto.update_inputs = function update_inputs() {
    this.inputs = this.create_json_value();
  };

  _proto.field_by_name = function field_by_name(fname) {
    return this.record.screen.fields.find(function (f) {
      return f.name === fname;
    });
  };

  _proto.get_value = function get_value() {
    if (this.inputsChanged()) {
      return this.reload();
    } else {
      return this.value;
    }
  };

  _proto.inputsChanged = function inputsChanged() {
    var res = false;
    var in_edition = this.dependencies.map(function (fname) {
      return this.record.field_in_edition == fname;
    }.bind(this)).some(function (a) {
      return a === true;
    }.bind(this));

    if (in_edition) {
      return false;
    }

    var new_values = this.create_json_value();

    if (!new_values) {
      return false;
    }

    if (new_values !== this.inputs) {
      res = true;
    }

    return res;
  };

  _proto.setLoading = function setLoading(value) {
    this.loading = value;
  };

  _proto.calc_value = function calc_value() {
    try {
      var _this2 = this;

      if (_this2.value_getter) {
        return Promise.resolve(_this2.value_getter(_this2));
      } else {
        return Promise.resolve(_this2.field.get_calculated_value(_this2));
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.reload = function reload() {
    try {
      var _this4 = this;

      return Promise.resolve(function () {
        if (!_this4.loading) {
          _this4.setLoading(true);

          return Promise.resolve(_this4.calc_value()).then(function (_this3$calc_value) {
            _this4.value = _this3$calc_value;

            _this4.update_inputs();

            _this4.setLoading(false);

            return _this4.value;
          });
        }
      }());
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return NewCalculatedValue;
}();

var DEFAULT_ACTIVE_RECORD = ['form', 'html'];

var CalculatedValue = /*#__PURE__*/function () {
  function CalculatedValue(field, record) {
    this.field = false;
    this.value = null;
    this.inputs = {};
    this.loading = true;
    this.initialized = false;
    makeObservable(this, {
      value: observable,
      reload: action,
      toogleLoading: action,
      initialized: observable
    });
    this.field = field;
    this.inputs = field.get_dependencies(record);
    this.loading = false;
    this.reload(record);
  }

  var _proto = CalculatedValue.prototype;

  _proto.get_value = function get_value() {
    return this.value;
  };

  _proto.shouldReload = function shouldReload(record) {
    var res = false;

    for (var i in this.inputs) {
      if (this.inputs[i] !== record._values[i]) {
        res = true;
      }
    }

    return res;
  };

  _proto.toogleLoading = function toogleLoading() {
    this.loading = !this.loading;
  };

  _proto.reload = function reload(record) {
    try {
      var _temp3 = function _temp3() {
        runInAction(function () {
          _this2.value = value;
          _this2.inputs = _this2.field.get_dependencies(record);

          _this2.toogleLoading();

          _this2.initialized = true;
        });
      };

      var _this2 = this;

      if (_this2.loading) {
        return Promise.resolve();
      }

      _this2.toogleLoading();

      var value = browseObject(record._values, _this2.field.expression);

      var _temp4 = function () {
        if (!value) {
          return Promise.resolve(_this2.field.get_lookup_value(record)).then(function (_this$field$get_looku) {
            value = _this$field$get_looku;
          });
        }
      }();

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return CalculatedValue;
}();

var BinaryValue = /*#__PURE__*/function () {
  function BinaryValue(field, record) {
    this.field = false;
    this.value = null;
    this.loading = false;
    makeObservable(this, {
      value: observable,
      set_value: action,
      reload: action,
      toogleLoading: action
    });
    this.field = field;
    this.value = null;
    this.loading = false;
    this.reload(record);
  }

  var _proto2 = BinaryValue.prototype;

  _proto2.get_value = function get_value() {
    return this.value;
  };

  _proto2.set_value = function set_value(value) {
    this.value = value;
  };

  _proto2.toogleLoading = function toogleLoading() {
    this.loading = !this.loading;
  };

  _proto2.reload = function reload(record) {
    try {
      var _temp7 = function _temp7() {
        runInAction(function () {
          _this4.value = value ? {
            data: value
          } : false;

          _this4.toogleLoading();
        });
      };

      var _this4 = this;

      _this4.toogleLoading();

      var value = record._values[_this4.field.name];

      var _temp8 = function () {
        if (!value) {
          return Promise.resolve(_this4.field.get_binary_value(record)).then(function (_this3$field$get_bina) {
            value = _this3$field$get_bina;
          });
        }
      }();

      return Promise.resolve(_temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return BinaryValue;
}();

var RecordGroup = /*#__PURE__*/function () {
  function RecordGroup(connection, attrs, screen) {
    this.records = [];
    this.count = 0;
    this.loading = true;
    this.loadingInitialData = false;
    this.current_page = 1;
    this.next_new_id = 0;
    this._changed = false;
    this.pagination_enabled = false;
    this.default_page_size = 0;
    this.page_size_options = [];
    this.limit = null;
    this.show_records_count = false;
    this.single_record = false;
    makeObservable(this, {
      records: observable,
      count: observable,
      loadData: action,
      setInitialLoading: action,
      setLoading: action,
      loadingInitialData: observable,
      loading: observable,
      addRecord: action,
      clearRecords: action,
      setChanged: action,
      removeRecords: action,
      replaceRecord: action,
      o2m_fields: computed,
      nextPage: action,
      prevPage: action,
      limit: observable,
      current_page: observable,
      setCurrentPage: action,
      pagination_enabled: observable,
      show_records_count: observable,
      single_record: observable
    });
    this.connection = connection;
    this.screen = screen;
    this.model = screen.model;
    this.pagination_enabled = attrs.pagination_enabled;

    if (this.pagination_enabled) {
      this.default_page_size = attrs.default_page_size;
      this.limit = attrs.default_page_size;
      this.page_size_options = attrs.page_size_options;
    }

    this.show_records_count = this.pagination_enabled ? true : attrs.show_records_count;
    this.data_callback = this.screen.data_callback;
    this.on_load_data = this.screen.on_load_data;
    this.single_record = this.screen.type == 'form';
  }

  var _proto3 = RecordGroup.prototype;

  _proto3.get_record_by_index = function get_record_by_index(index) {
    return this.records[index];
  };

  _proto3.get_record_by_id = function get_record_by_id(id) {
    return this.records.find(function (rec) {
      return rec.id === id;
    });
  };

  _proto3.setChanged = function setChanged(value) {
    this._changed = value;
  };

  _proto3.get_next_new_id = function get_next_new_id() {
    this.next_new_id -= 1;
    return this.next_new_id;
  };

  _proto3.addRecord = function addRecord(_ref) {
    var values = _ref.values,
        index = _ref.index;
    var i = index ? index : this.records.length;

    if (!values) {
      values = {};
    }

    var record = new Record(values, this.screen, this);

    if (!Object.keys(values).length) {
      record.setDefaultValues();
    }

    this.records.splice(i, 0, record);
    return record;
  };

  _proto3.clearRecords = function clearRecords() {
    this.records = [];
    this.next_new_id = 0;
    this.count = 0;
  };

  _proto3.removeRecords = function removeRecords(records) {
    records.forEach(function (record) {
      this.records.splice(this.records.indexOf(record), 1);
    }.bind(this));

    if (this.screen.selected_records) {
      this.screen.set_selected_record([]);
    }
  };

  _proto3.replaceRecord = function replaceRecord(old_record, new_record) {
    new_record.group = this;
    this.records[this.records.indexOf(old_record)] = new_record;

    if (this.screen.active_record && this.screen.active_record.id == old_record.id) {
      this.screen.set_active_record(new_record);
    }
  };

  _proto3.setInitialLoading = function setInitialLoading(value) {
    this.loadingInitialData = value;
  };

  _proto3.setLoading = function setLoading(value) {
    this.loading = value;
  };

  _proto3.setLimit = function setLimit(value) {
    this.limit = value;
    this.loadData(false, true);
  };

  _proto3.nextPage = function nextPage() {
    var next_page = this.current_page + 1;

    if (next_page > this.page_qty) {
      return;
    }

    this.current_page = this.current_page + 1;
    this.loadData();
  };

  _proto3.prevPage = function prevPage() {
    var prev_page = this.current_page - 1;

    if (prev_page < 1) {
      return;
    }

    this.current_page = this.current_page - 1;
    this.loadData();
  };

  _proto3.getRecordsCount = function getRecordsCount() {
    try {
      var _this6 = this;

      var _temp10 = function () {
        if (_this6.connection.status) {
          var abortController = new AbortController();
          var count = 0;
          var args = {
            view_id: _this6.screen.id,
            search: _this6.screen.current_search,
            order: _this6.screen.order,
            model: _this6.screen.model,
            count: true
          };

          if (!_this6.screen.headless) {
            args['action_id'] = _this6.screen.action_id ? _this6.screen.action_id : "";
            args['action_params'] = _this6.screen.action_params;
          }

          return Promise.resolve(_this6.connection.dispatch('GET', '/data/get', args, false, false, false, abortController)).then(function (_this5$connection$dis) {
            count = _this5$connection$dis;
            runInAction(function () {
              _this6.count = count;
            });
          });
        }
      }();

      return Promise.resolve(_temp10 && _temp10.then ? _temp10.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto3.setCurrentPage = function setCurrentPage(value) {
    this.current_page = value;
  };

  _proto3.loadData = function loadData(force_count, reset_page, extra_args) {

    if (reset_page === void 0) {
      reset_page = false;
    }

    if (extra_args === void 0) {
      extra_args = {};
    }

    try {
      var _this8 = this;

      var _temp14 = function () {
        if (!_this8.loadingInitialData && _this8.connection.status) {
          var _temp15 = function _temp15() {
            runInAction(function () {
              if (_this8.loadingInitialData) {
                _this8.loadingInitialData = false;

                if (_this8.show_records_count) {
                  _this8.getRecordsCount();
                }
              }

              _this8.loading = false;
            });

            if (_this8.show_records_count) {
              _this8.getRecordsCount();
            }

            _this8.onLoadData(_this8.records);
          };

          var abortController = new AbortController();
          var new_data = [];
          _this8.loading = true;
          var args = {
            view_id: _this8.screen.id,
            search: _this8.screen.current_search,
            order: _this8.screen.order,
            model: _this8.screen.model
          };

          if (_this8.pagination_enabled) {
            var current_page = _this8.current_page - 1;
            args['limit'] = _this8.limit;

            if (reset_page) {
              current_page = 0;

              _this8.setCurrentPage(1);
            }

            args['offset'] = current_page * _this8.limit;
          }

          if (!_this8.screen.headless) {
            args['action_id'] = _this8.screen.action_id ? _this8.screen.action_id : "";
            args['action_params'] = _this8.screen.action_params;
          }

          args = _extends({}, args, extra_args);

          var _temp16 = function () {
            if (_this8.single_record && !args.search.length && !args.action_params.length || _this8.screen.data_origin === 'none') {
              runInAction(function () {
                if (DEFAULT_ACTIVE_RECORD.includes(_this8.screen.type)) {
                  _this8.clearRecords();

                  var record = _this8.addRecord({});

                  _this8.screen.set_active_record(record);
                }
              });
            } else {
              return Promise.resolve(_this8.connection.dispatch('GET', '/data/get', args, false, false, false, abortController)).then(function (_this7$connection$dis) {
                new_data = _this7$connection$dis;

                if (new_data) {
                  runInAction(function () {
                    _this8.records = new_data.map(function (row) {
                      return new Record(row, this.screen, this);
                    }.bind(_this8));

                    if (DEFAULT_ACTIVE_RECORD.includes(_this8.screen.type)) {
                      _this8.screen.set_active_record(_this8.records[0]);
                    }
                  });
                }
              });
            }
          }();

          return _temp16 && _temp16.then ? _temp16.then(_temp15) : _temp15(_temp16);
        }
      }();

      return Promise.resolve(_temp14 && _temp14.then ? _temp14.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto3.runCallback = function runCallback(record) {
    if (this.data_callback) {
      this.data_callback(record);
    }
  };

  _proto3.onLoadData = function onLoadData(records) {
    if (this.on_load_data) {
      this.on_load_data(this.screen, records);
    }
  };

  _createClass(RecordGroup, [{
    key: "o2m_fields",
    get: function get() {
      return this.screen.fields.filter(function (field) {
        return field.type == 'one2many' && field.initialized === true;
      });
    }
  }, {
    key: "page_qty",
    get: function get() {
      return Math.ceil(this.count && this.limit ? this.count / this.limit : 0);
    }
  }]);

  return RecordGroup;
}();
var Record = /*#__PURE__*/function () {
  function Record(attributes, screen, group) {
    this.id = -1;
    this._values = {};
    this._changed = {};
    this._errors = {};
    this.state_attrs = {};
    this.conditional_styles = {};
    this.group = false;
    this.field_in_edition = false;
    makeObservable(this, {
      set_state_attrs: action,
      set_value: action,
      set_values: action,
      set_changed: action,
      set_conditional_styles: action,
      _values: observable,
      _changed: observable,
      _errors: observable,
      state_attrs: observable,
      conditional_styles: observable,
      field_in_edition: observable,
      setFieldInEdition: action,
      setDefaultValues: action,
      backend_values: computed,
      required_fields: computed,
      set_calculated_value: action
    });
    var id = attributes.id ? attributes.id : group ? group.get_next_new_id() : -1;
    this.id = id;
    this._values = attributes;
    this._changed = {};
    this._values['id'] = id;
    this.screen = screen;
    this.group = group;
    this.state_attrs = {};
    this.field_in_edition = false;
    this.set_state_attrs();
    this.set_conditional_styles();
    this.intialize_formula_fields();
  }

  var _proto4 = Record.prototype;

  _proto4.intialize_formula_fields = function intialize_formula_fields() {
    this.formula_fields.forEach(function (f) {
      f.get_value(this);
    }.bind(this));
  };

  _proto4.setFieldInEdition = function setFieldInEdition(fname) {
    this.field_in_edition = fname;
  };

  _proto4.get_value = function get_value(fname) {
    if (this.formula_fnames.includes(fname)) {
      var value = this._values[fname].get_value();

      return value;
    }

    return this._values[fname];
  };

  _proto4.isField = function isField(fname) {
    return this.screen.field_names.includes(fname);
  };

  _proto4.on_change = function on_change() {
    var values = {};
    var prms = [];
    this.listener_fields.forEach(function (field) {
      if (this._values[field.name]) {
        if (!this._values[field.name].shouldReload(this)) {
          return false;
        } else {
          prms.push(this._values[field.name].reload(this));
          this._changed[field.name] = true;
        }
      } else {
        values[field.name] = new CalculatedValue(field, this);
      }
    }.bind(this));

    if (Object.keys(values).length) {
      this.set_values(values);
    }

    return prms;
  };

  _proto4.set_calculated_value = function set_calculated_value(field) {
    if (this._values[field.name]) {
      return this._values[field.name].get_value();
    } else {
      this._values[field.name] = new CalculatedValue(field, this);
    }

    return this._values[field.name].get_value();
  };

  _proto4.set_new_calculated_value = function set_new_calculated_value(field) {
    if (this._values[field.name]) {
      return this._values[field.name].get_value();
    } else {
      this._values[field.name] = new NewCalculatedValue(field, this);
    }

    return this._values[field.name].get_value();
  };

  _proto4.set_binary_value = function set_binary_value(field) {
    if (this._values[field.name]) {
      return this._values[field.name].get_value();
    } else {
      this._values[field.name] = new BinaryValue(field, this);
    }

    return this._values[field.name].get_value();
  };

  _proto4.set_changed = function set_changed(fnames) {
    var changed = false;
    fnames.forEach(function (fname) {
      if (this.isField(fname)) {
        this._changed[fname] = true;
        changed = true;
      }
    }.bind(this));

    if (changed && this.group && !this.group._changed) {
      this.group.setChanged(changed);
    }

    var prms = this.on_change();

    if (this.group) {
      if (prms && prms.length) {
        Promise.all(prms).then(function (p) {
          this.group.runCallback(this);
        }.bind(this));
      } else {
        this.group.runCallback(this);
      }
    }
  };

  _proto4.set_value = function set_value(fname, value) {
    this._values[fname] = value;
    this.set_changed([fname]);
  };

  _proto4.set_values = function set_values(values) {
    var fnames = [];

    for (var fname in values) {
      this._values[fname] = values[fname];
      fnames.push(fname);
    }

    this.set_changed(fnames);
  };

  _proto4.get_parent_defaults = function get_parent_defaults(parent_record) {
    var values = {};

    if (!parent_record) {
      parent_record = this.screen.parent.active_record;
    }

    if (parent_record) {
      this.parent_default_fields.forEach(function (f) {
        values[f.name] = browseObject(parent_record._values, f.default_value, false, this.screen.fields, parent_record._values);
      }.bind(this));
    }

    this.parent_selected_records_fields.forEach(function (f) {
      values[f.name] = this.screen.parent_selected_records;
      values[f.name] = browseObject({}, f.default_value, false, this.screen.fields, {}, this.screen.parent_selected_records);
    }.bind(this));
    return values;
  };

  _proto4.setDefaultValues = function setDefaultValues(pivot_values) {
    if (pivot_values === void 0) {
      pivot_values = [];
    }

    try {
      var _this10 = this;

      return Promise.resolve(_this10.getDefaultValues(pivot_values)).then(function (values) {
        if (values[0].hasOwnProperty('id')) {
          _this10.id = values[0].id;
        }

        values = _extends({}, values[0], _this10.get_parent_defaults());

        _this10.set_values(values);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto4.getDefaultValues = function getDefaultValues(pivot_values) {
    if (pivot_values === void 0) {
      pivot_values = [];
    }

    try {
      var _this12 = this;

      var args = {
        view_id: _this12.screen.id,
        search: {},
        order: [],
        pivot_values: pivot_values
      };
      var abortController = new AbortController();
      return Promise.resolve(_this12.group.connection.dispatch('GET', '/view/default_values', args, false, false, false, abortController));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto4.get_changed_values = function get_changed_values() {
    var cv = {};

    for (var field in this._changed) {
      cv[field] = this._values[field];
    }

    var fnames = Object.keys(cv);
    this.listener_fields.forEach(function (lf) {
      if (fnames.includes(lf.name)) {
        cv[lf.name] = this._values[lf.name].get_value();
      }
    }.bind(this));
    this.binary_fields.forEach(function (bf) {
      if (fnames.includes(bf.name)) {
        cv[bf.name] = this._values[bf.name].get_value();
      }
    }.bind(this));
    return cv;
  };

  _proto4.get_changed_childs_records = function get_changed_childs_records() {
    var values = {};

    if (!this.group) {
      return {};
    }

    this.group.o2m_fields.filter(function (f) {
      return f.screen && f.screen.data._changed === true;
    }).forEach(function (f) {
      values[f.name] = f.screen.data.records;
    });
    return values;
  };

  _proto4.get_childs_records = function get_childs_records() {
    var values = {};
    this.group.o2m_fields.forEach(function (f) {
      values[f.name] = f.screen.data.records;
    });
    return values;
  };

  _proto4.validate = function validate(required_fields) {
    var valid = true;
    var _errors = {};

    if (!required_fields) {
      required_fields = this.required_fields;
    }

    required_fields.forEach(function (field) {
      if (!field.has_value(this)) {
        valid = false;
        _errors[field.name] = "required";
      }
    }.bind(this));
    this._errors = _errors;

    if (valid) {
      valid = this.validate_childs();
    }

    if (!valid) {
      this.screen.notifications.addSnack({
        message: "Por favor, complete los campos requeridos.",
        level: 'error',
        timeout: 2000
      });
    }

    return valid;
  };

  _proto4.validate_childs = function validate_childs() {
    var valid = true;
    var child_values = this.get_changed_childs_records();

    for (var child in child_values) {
      child_values[child].forEach(function (rec) {
        if (!rec.validate()) {
          valid = false;
        }
      });
    }

    return valid;
  };

  _proto4.get_raw_values = function get_raw_values() {
    var raw_values = {};
    var calculated_fnames = [].concat(this.listener_fields.map(function (f) {
      return f.name;
    }), this.formula_fields.map(function (f) {
      return f.name;
    }));

    for (var k in this._values) {
      if (!calculated_fnames.includes(k)) {
        raw_values[k] = this._values[k];
      }
    }

    return raw_values;
  };

  _proto4.get_all_values = function get_all_values() {
    var values = _extends({}, this._values);

    var fnames = Object.keys(values);
    this.listener_fields.forEach(function (lf) {
      if (fnames.includes(lf.name)) {
        values[lf.name] = this._values[lf.name].get_value();
      }
    }.bind(this));
    this.binary_fields.forEach(function (bf) {
      if (fnames.includes(bf.name)) {
        values[bf.name] = this._values[bf.name].get_value();
      }
    }.bind(this));
    this.formula_fields.forEach(function (ff) {
      if (fnames.includes(ff.name)) {
        values[ff.name] = this._values[ff.name].get_value();
      }
    }.bind(this));
    var child_values = this.get_childs_records();

    for (var child in child_values) {
      values[child] = child_values[child].map(function (c) {
        return c.get_all_values();
      });
    }

    return values;
  };

  _proto4.save = function save(action) {
    try {
      var _this14 = this;

      if (!_this14.validate()) {
        return Promise.resolve(false);
      }

      var abortController = new AbortController();
      var path = action.custom_path ? action.custom_path : '/data/save';
      var args = {};
      args['action_id'] = action.id;
      var values = {};

      var vals = _this14.get_changed_values();

      var child_values = _this14.get_changed_childs_records();

      for (var child in child_values) {
        vals[child] = child_values[child].map(function (c) {
          return c.backend_values;
        });
      }

      vals.id = _this14.id;
      values[_this14.id] = vals;
      args['values'] = values;
      args['model'] = _this14.screen.model;
      return Promise.resolve(_this14.screen.connection.dispatch('POST', path, args, false, false, false, abortController));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto4.set_state_attrs = function set_state_attrs() {
    try {
      var _this16 = this;

      if (!_this16._values) {
        return Promise.resolve(false);
      }

      var state_attrs = {};

      _this16.screen.fields.forEach(function (field) {
        state_attrs[field.name] = new StateAttrs(field, this);
      }.bind(_this16));

      runInAction(function () {
        _this16.state_attrs = state_attrs;
      });
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto4.get_style = function get_style(fname) {
    var style = {};

    if (this.conditional_styles && this.conditional_styles[fname]) {
      style = this.conditional_styles[fname].get_value();
    }

    return style;
  };

  _proto4.set_conditional_styles = function set_conditional_styles() {
    try {
      var _this18 = this;

      if (!_this18._values) {
        return Promise.resolve(false);
      }

      var conditional_styles = {};

      _this18.screen.conditional_style_fields.forEach(function (field) {
        conditional_styles[field.name] = new NewCalculatedValue(field, this, field.conditional_style_dependencies, function (calc) {
          try {
            return Promise.resolve(field.get_conditional_style(calc));
          } catch (e) {
            return Promise.reject(e);
          }
        });
      }.bind(_this18));

      runInAction(function () {
        _this18.conditional_styles = conditional_styles;
      });
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _createClass(Record, [{
    key: "backend_values",
    get: function get() {
      var values = {};

      for (var v in this._values) {
        if (this.isField(v)) {
          values[v] = this._values[v];
        }
      }

      var fnames = Object.keys(values);
      this.listener_fields.forEach(function (lf) {
        if (fnames.includes(lf.name)) {
          delete values[lf.name];
        }
      }.bind(this));
      return values;
    }
  }, {
    key: "required_fields",
    get: function get() {
      return Object.keys(this.state_attrs).filter(function (fname) {
        return this.state_attrs[fname].required;
      }.bind(this)).map(function (fname) {
        return this.screen.fields.find(function (f) {
          return f.name === fname;
        });
      }.bind(this));
    }
  }, {
    key: "listener_fields",
    get: function get() {
      return this.screen.fields.filter(function (f) {
        return f.type === 'lookup';
      });
    }
  }, {
    key: "binary_fields",
    get: function get() {
      return this.screen.fields.filter(function (f) {
        return f.type === 'binary';
      });
    }
  }, {
    key: "formula_fields",
    get: function get() {
      return this.screen.fields.filter(function (f) {
        return f.type === 'formula';
      });
    }
  }, {
    key: "formula_fnames",
    get: function get() {
      return this.formula_fields.map(function (f) {
        return f.name;
      });
    }
  }, {
    key: "parent_default_fields",
    get: function get() {
      return this.screen.fields.filter(function (f) {
        if (f.default_value) {
          return f.default_value.includes("_parent_record");
        }
      });
    }
  }, {
    key: "parent_selected_records_fields",
    get: function get() {
      return this.screen.fields.filter(function (f) {
        if (f.default_value) {
          return f.default_value.includes("_parent_selected_records");
        }
      });
    }
  }, {
    key: "mobile_record_title",
    get: function get() {
      return evalExpr(this._values, this.screen.mobile_record_title).str || "";
    }
  }]);

  return Record;
}();

var AsyncFunction = Object.getPrototypeOf(function () {
  return Promise.resolve();
}).constructor;
var Action = /*#__PURE__*/function () {
  function Action(attributes, screen) {
    this["default"] = false;
    this.default_save = false;
    this.description = "";
    this.id = "";
    this.key_fields = "";
    this.modal = null;
    this.multiple_records = false;
    this.name = "";
    this.show_button = false;
    this.target_title = "";
    this.target_view = "";
    this.type = "";
    this.visible_on_select = false;
    this.return_action = null;
    this.report_ids = "";
    this.report_data = "";
    this.target_view_definition = {};
    this.pre_action = "";
    this.post_action = "";
    this.custom_method_op = "";
    this.custom_validation = false;
    this.requires_confirmation = false;
    this.confirmation_message = false;
    this.show_success_message = false;
    this.success_message_type = "";
    this.success_message = "";
    this.invisible = false;
    this.custom_path = '';
    this.report_filename = '';
    this.modal_style = '';
    this.custom_frontend_function = '';
    this.is_async = false;
    makeAutoObservable(this);
    this.screen = screen;
    this["default"] = attributes["default"] || false;
    this.default_save = attributes.default_save || false;
    this.description = attributes.description || "";
    this.id = attributes.id || "";
    this.key_fields = attributes.key_fields || "";
    this.modal = attributes.modal || null;
    this.multiple_records = attributes.multiple_records || false;
    this.name = attributes.name || "";
    this.show_button = attributes.show_button || false;
    this.target_title = attributes.target_title || "";
    this.type = attributes.type || "";
    this.visible_on_select = attributes.visible_on_select || false;
    this.target_view = attributes.target_view;
    this.target_view_definition = attributes.target_view_definition;
    this.return_action = attributes.return_action;
    this.report_ids = attributes.report_ids;
    this.report_data = attributes.report_data || "";
    this.report_filename = attributes.report_filename || "";
    this.pre_action = attributes.pre_action;
    this.post_action = attributes.post_action;
    this.custom_method_op = attributes.custom_method_op;
    this.custom_method_args = attributes.custom_method_args || [];
    this.custom_validation = attributes.validation_function ? new Function('records', attributes.validation_function) : false;
    this.requires_confirmation = attributes.requires_confirmation;
    this.confirmation_message = attributes.confirmation_message;
    this.show_success_message = attributes.show_success_message;
    this.success_message_type = attributes.success_message_type;
    this.success_message = attributes.success_message;
    this.include_current_search = attributes.include_current_search;
    this.invisible = attributes.invisible ? attributes.invisible : false;
    this.custom_path = attributes.custom_path;
    this.batch_records_field = attributes.batch_records_field;
    this.modal_style = attributes.modal_style ? JSON.parse(attributes.modal_style) : false;
    this.custom_frontend_function = attributes.custom_frontend_function ? new AsyncFunction('action,records', attributes.custom_frontend_function) : false;
    this.is_async = attributes.is_async;
  }

  var _proto = Action.prototype;

  _proto.getKeyFields = function getKeyFields() {
    return this.key_fields.split(";");
  };

  _proto.mapNewRecords = function mapNewRecords(old_records, new_records) {
    if (new_records === void 0) {
      new_records = [];
    }

    var recs = old_records.map(function (r) {
      var attrs = new_records.find(function (n) {
        return Object.keys(n)[0] == r.id;
      });
      var new_record = new Record(attrs[r.id], this.screen, this.group);
      this.screen.data.replaceRecord(r, new_record);
      return new_record;
    }.bind(this));
    return recs;
  };

  _proto.executeCreateUpdate = function executeCreateUpdate(records, async_reload) {
    try {
      var _this2 = this;

      var prm = [];
      records.forEach(function (rec) {
        prm.push(rec.save(this));
      }.bind(_this2));
      return Promise.resolve(Promise.all(prm)).then(function (_Promise$all) {
        prm = _Promise$all;

        if (Array.isArray(prm) && prm.some(function (r) {
          return r === false;
        })) {
          prm = false;
        } else {
          prm = _this2.mapNewRecords(records, prm);
        }

        return prm;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.executeDeleteRecord = function executeDeleteRecord(records) {
    try {
      var _temp3 = function _temp3() {
        if (args['ids'].length && res['result'] !== null) {
          return false;
        }

        _this4.screen.data.removeRecords(selected_records);

        return res;
      };

      var _this4 = this;

      var selected_records = records ? records : _this4.screen.selected_records;
      var args = {};
      var res = {};
      args['ids'] = selected_records.filter(function (r) {
        return r.id > 0;
      }).map(function (rec) {
        return rec.id;
      });
      args['view'] = _this4.screen.id;

      var _temp4 = function () {
        if (args['ids'].length) {
          var abortController = new AbortController();
          return Promise.resolve(_this4.screen.connection.dispatch('POST', '/data/delete', args, false, false, true, abortController)).then(function (_this3$screen$connect) {
            res = _this3$screen$connect;
          });
        }
      }();

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.executeLinkAction = function executeLinkAction(records, initialize_callback, caller_reference) {
    if (caller_reference === void 0) {
      caller_reference = false;
    }

    try {
      var _this6 = this;

      var selected_records = records ? records : _this6.screen.selected_records;

      if (_this6.visible_on_select && selected_records.length < 1) {
        _this6.screen.notifications.addSnack({
          message: "Seleccione un registro para ejecutar esta acción",
          level: 'error'
        });

        return Promise.resolve(false);
      }

      if (!_this6.multiple_records && selected_records.length > 1) {
        _this6.screen.notifications.addSnack({
          message: "Seleccione sólo un registro para ejecutar esta acción",
          level: 'error'
        });

        return Promise.resolve(false);
      }

      var field_value = function field_value(records, fname) {
        var val;

        if (!records.length) {
          return;
        }

        if (records.length > 1) {
          val = records.map(function (record) {
            return record.get_value(fname);
          });
        } else {
          val = records[0].get_value(fname);

          if (_this6.multiple_records) {
            val = [val];
          }
        }

        return val;
      };

      var target_title = function target_title(records, expression) {
        var title = "";

        if (records.length > 1) {
          var variables = records.map(function (record) {
            return evalExpr(record._values, expression).variables || "";
          });
          var to_replace = expression.match(/{([^}]+)}/g);
          title = expression;
          to_replace.forEach(function (field) {
            title = title.replace(field, "");
          });
          title += variables.map(function (variable) {
            var text = "";

            for (var k in variable) {
              text += variable[k].toString();
            }

            return text;
          }).toString();
        } else {
          title = evalExpr(records[0]._values, expression).str || "";
        }

        return title;
      };

      var key_fields = _this6.getKeyFields();

      var search = {
        current_search: [],
        action_params: [],
        action_id: _this6.id
      };

      if (_this6.include_current_search) {
        search.current_search = _this6.screen.current_search;
      }

      if (key_fields) {
        key_fields.forEach(function (field) {
          if (field.split('.').length > 1) {
            var spl_field = field.split('.');
            throw new Error("Invalid Key field " + field);
          } else {
            if (field) {
              if (records.length) {
                search.action_params.push([field, '=', field_value(selected_records, field)]);
              }
            }
          }
        });
      }

      search['_action_id'] = {
        value: _this6.id
      };

      var route = _this6.screen.connection.getRouteById(_this6.target_view);

      if (!route) {
        _this6.screen.notifications.addSnack({
          message: "No tiene acceso a esta vista.",
          level: 'error'
        });

        return Promise.resolve(false);
      }

      var route_state = {};

      if (_this6.target_title && selected_records.length) {
        route_state[_this6.id] = {};
        var title = target_title(selected_records, _this6.target_title);
        route_state[_this6.id]['title'] = title;
      }

      if (_this6.modal) {
        var view_definition = _extends({}, _this6.target_view_definition, {
          parent_ref: caller_reference
        });

        var target_screen = _this6.screen.modal_childs.addScreen(view_definition, false, search, route_state, true, true, _this6.screen, true, true, true, initialize_callback);

        if (_this6.modal_style) {
          target_screen.add_style({
            'modal': _this6.modal_style
          });
        }
      } else {
        var path = route.path ? route.path.concat(_this6.screen.connection.createUrl(search)) : route.name;
        var params = route.path ? route_state : search;

        _this6.screen.navigate(path, params);
      }

      return Promise.resolve(true);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.executeExportData = function executeExportData() {
    try {
      var _this8 = this;

      var abortController = new AbortController();
      var params = {};

      var notification = _this8.screen.notifications.addSnack({
        message: "Exportación en curso...",
        persistant: true
      });

      params['search'] = _this8.screen.current_search;
      params['action_params'] = _this8.screen.action_params;
      params['action_id'] = _this8.id;
      params['origin_action_id'] = _this8.screen.action_id ? _this8.screen.action_id : '';
      return Promise.resolve(_this8.screen.connection.dispatch('GET', '/data/export', params, false, false, true, abortController)).then(function (res) {
        downloadFile(URL.createObjectURL(res.data), _this8.screen.title);
        notification.remove();

        _this8.screen.notifications.addSnack({
          message: "Descarga Completa"
        });

        return res;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.executeReportAction = function executeReportAction(records) {
    try {
      var _this10 = this;

      var notification = _this10.screen.notifications.addSnack({
        message: "Reporte en progreso...",
        persistant: true
      });

      var selected_records = records ? records : _this10.screen.selected_records;
      var args = {};
      args.action_id = _this10.id;
      args.ids = [];
      selected_records.forEach(function (record) {
        var ids_value = record.get_value(this.report_ids);

        if (Array.isArray(ids_value)) {
          ids_value.forEach(function (id) {
            args.ids.push(id);
          });
        } else {
          args.ids.push(ids_value);
        }
      }.bind(_this10));
      args['data'] = {};
      selected_records.forEach(function (r) {
        var expr = evalExpr(_extends({
          ids: args.ids
        }, r._values), this.report_data.substring(1, this.report_data.length - 1));

        if (expr.str) {
          args['data'] = JSON.parse('{' + expr.str + '}');
        }
      }.bind(_this10));
      var abortController = new AbortController();
      return Promise.resolve(_this10.screen.connection.dispatch('GET', '/actions/report', args, false, false, true, abortController)).then(function (_ref) {
        var data = _ref.data,
            filename = _ref.filename;

        if (_this10.report_filename) {
          filename = _this10.report_filename;
        } else if (!filename) {
          filename = "Report";
        }

        if (!data) {
          notification.remove();
          return;
        }

        if (_this10.screen.fileHandler) {
          notification.remove();
          return _this10.screen.fileHandler(data);
        } else {
          notification.remove();
          return downloadFile(URL.createObjectURL(data), filename);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.executeClassMethod = function executeClassMethod(records) {
    try {
      var _temp7 = function _temp7(_result) {
        if (_exit2) return _result;

        if (!new_recs) {
          return false;
        }

        var key_fields = _this12.getKeyFields();

        key_fields.forEach(function (fname) {
          if (["ids", "records"].includes(fname)) {
            args.values[fname] = new_recs.map(function (r) {
              return r.id;
            });
          }
        });
        return Promise.resolve(_this12.screen.connection.dispatch('POST', '/actions/classmethod', args, false, false, false, abortController)).then(function (res) {
          return res ? _this12.mapNewRecords(new_recs, res) : false;
        });
      };

      var _exit2 = false;

      var _this12 = this;

      var selected_records = records ? records : _this12.screen.selected_records;
      var new_recs = selected_records;
      var save_action = _this12.screen.default_save_action;
      var args = {};
      args.values = {};
      args['action_id'] = _this12.id;
      var abortController = new AbortController();

      var _temp8 = function () {
        if (save_action) {
          return Promise.resolve(_this12.executeCreateUpdate(selected_records)).then(function (_this11$executeCreate) {
            new_recs = _this11$executeCreate;

            if (Array.isArray(new_recs) && new_recs.some(function (r) {
              return r === false;
            })) {
              _exit2 = true;
              return false;
            }
          });
        }
      }();

      return Promise.resolve(_temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.executeBatchUpdate = function executeBatchUpdate(records) {
    try {
      var _this14 = this;

      var args = {};
      var selected_records = records ? records : _this14.screen.selected_records;

      if (selected_records.length > 1) {
        var message = "This action can't be executed from multiple records";

        _this14.screen.notifications.addSnack({
          message: message,
          level: 'error',
          timeout: 5000
        });

        return Promise.resolve(false);
      }

      var record = selected_records[0];
      var valid = record.validate();

      var records_field = _this14.screen.get_field_by_id(_this14.batch_records_field);

      if (!valid || !records_field) {
        return Promise.resolve(false);
      }

      args['action_id'] = _this14.id;
      var values = record.get_all_values();
      args['data'] = values;
      args['records'] = values[records_field.name];
      var abortController = new AbortController();
      return Promise.resolve(_this14.screen.connection.dispatch('POST', '/actions/batch_update', args, false, false, false, abortController));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.executeCustomMethod = function executeCustomMethod(records) {
    try {
      var _this16 = this;

      var args = {};
      var path = _this16.custom_path ? _this16.custom_path : '/actions/custom_action';
      var selected_records = records ? records : _this16.screen.selected_records;
      args['action_id'] = _this16.id;
      var fnames = _this16.custom_method_args;

      if (_this16.screen.modal && _this16.screen.parent) {
        args['_parent'] = {
          'view_id': _this16.screen.parent.id,
          'active_record': _this16.screen.parent.active_record ? _this16.screen.parent.active_record.id : false
        };
      }

      args['data'] = selected_records.map(function (record) {
        if (record.validate()) {
          if (fnames.length) {
            var vals = {};
            fnames.forEach(function (fname) {
              vals[fname] = record.get_value(fname);
            });
            return vals;
          } else {
            return record.get_all_values();
          }
        } else {
          return false;
        }
      });

      if (Array.isArray(args['data']) && args['data'].some(function (r) {
        return r === false;
      })) {
        return Promise.resolve(false);
      }

      var abortController = new AbortController();
      return Promise.resolve(_this16.screen.connection.dispatch(_this16.custom_method_op, path, args, false, false, false, abortController));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.executeCustomFrontendMethod = function executeCustomFrontendMethod(action, records) {
    try {
      var _this18 = this;

      return Promise.resolve(_catch(function () {
        return Promise.resolve(_this18.custom_frontend_function(action, records));
      }, function (e) {
        var message = "A problem ocurred with the custom  action : " + action.name + '  =>  ';
        message += e.toString();

        _this18.screen.notifications.addSnack({
          message: message,
          level: 'error',
          timeout: 5000
        });
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.executeSendMail = function executeSendMail(records) {
    try {
      var _this20 = this;

      var args = {};
      args['action_id'] = _this20.id;
      args['data'] = records.map(function (record) {
        if (record.validate()) {
          return record.get_all_values();
        } else {
          return false;
        }
      });

      if (Array.isArray(args['data']) && args['data'].some(function (r) {
        return r === false;
      })) {
        return Promise.resolve(false);
      }

      var abortController = new AbortController();
      return Promise.resolve(_this20.screen.connection.dispatch('POST', '/actions/send_mail', args, false, false, false, abortController));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.save_active_record = function save_active_record(records) {
    try {
      var _this22 = this;

      var selected_records = records ? records : _this22.screen.selected_records;
      var save_action = _this22.screen.default_save_action;

      if (!save_action) {
        return Promise.resolve();
      }

      return Promise.resolve(save_action.execute(selected_records));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.validate_records = function validate_records(records) {
    var valid = true;
    var recs = records.map(function (record) {
      return record.validate();
    });

    if (Array.isArray(recs) && recs.some(function (r) {
      return r === false;
    })) {
      valid = false;
    }

    return valid;
  };

  _proto.save_parent_record = function save_parent_record(records) {
    try {
      var _this24 = this;

      var save_action = _this24.screen.parent.default_save_action;

      if (!save_action) {
        return Promise.resolve(false);
      }

      var selected_records = records ? records : _this24.screen.selected_records;
      var new_recs = selected_records;
      return Promise.resolve(save_action.execute([_this24.screen.parent.active_record])).then(function (_save_action$execute) {
        new_recs = _save_action$execute;
        records.forEach(function (record) {
          var parent_defaults = record.get_parent_defaults(new_recs[0]);
          record.set_values(parent_defaults);
        });
        return new_recs;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.executePreAction = function executePreAction(records) {
    try {
      var _this26 = this;

      if (!_this26.validate_records(records)) {
        return Promise.resolve(false);
      }

      return Promise.resolve(function () {
        if (_this26.pre_action === 'save') {
          return Promise.resolve(_this26.save_active_record(records));
        } else return function () {
          if (_this26.pre_action === 'save_parent') {
            return Promise.resolve(_this26.save_parent_record(records));
          }
        }();
      }());
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.execute_custom_validation = function execute_custom_validation(records) {
    try {
      var _this28 = this;

      var valid = false;

      try {
        valid = _this28.custom_validation(records);
      } catch (e) {
        var message = "A problem ocurred with the custom validation method on action: " + _this28.name + '  =>  ';
        message += e.toString();

        _this28.screen.notifications.addSnack({
          message: message,
          level: 'error',
          timeout: 5000
        });
      }

      return Promise.resolve(valid);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.showSuccessMessage = function showSuccessMessage() {
    if (this.success_message_type === 'snack') {
      this.screen.notifications.addSnack({
        message: this.success_message,
        level: 'sucessfull',
        timeout: 5000
      });
    } else if (this.success_message_type == 'dialog') {
      this.screen.notifications.addDialog({
        'message': this.success_message,
        'html': true,
        'actions': []
      }, true);
    }
  };

  _proto.execute = function execute(records, async_reload, confirmed, executed, initialize_callback, caller_reference) {
    if (confirmed === void 0) {
      confirmed = false;
    }

    if (executed === void 0) {
      executed = false;
    }

    if (initialize_callback === void 0) {
      initialize_callback = false;
    }

    if (caller_reference === void 0) {
      caller_reference = false;
    }

    try {
      var _temp17 = function _temp17(_result6) {
        if (_exit4) return _result6;

        function _temp13() {
          function _temp11() {
            if (res && _this30.post_action) {
              if (_this30.post_action === 'close_reload') {
                _this30.screen.reload_parent();

                _this30.screen.group.removeScreen(_this30.screen.id);
              } else if (_this30.post_action === 'reload_parent') {
                _this30.screen.reload_parent();
              } else if (_this30.post_action === 'update_record') {
                if (res) {
                  res = _this30.mapNewRecords(records, [res]);
                }
              }
            }

            if (res && _this30.show_success_message) {
              _this30.showSuccessMessage();
            }

            if (_this30.is_async) {
              return res;
            }

            if (res && _this30.return_action) {
              var return_action = new Action(_this30.return_action, _this30.screen);
              return_action.execute(res).then(function (a) {
                if (this.type === 'classmethod' || this.type == 'custom_method') {
                  this.screen.reload_field_childs();
                }
              }.bind(_this30));
            }

            return res;
          }

          var _temp10 = function () {
            if (_this30.type == 'custom_frontend_method') {
              return Promise.resolve(_this30.executeCustomFrontendMethod(_this30, records)).then(function (_this29$executeCustom) {
                res = _this29$executeCustom;
              });
            } else {
              var _interrupt2 = false;

              var _temp16 = _switch(_this30.type, [[function () {
                return 'create_update';
              }, function () {
                return Promise.resolve(_this30.executeCreateUpdate(records, async_reload)).then(function (_this29$executeCreate) {
                  res = _this29$executeCreate;
                  _interrupt2 = true;
                });
              }], [function () {
                return 'batch_update';
              }, function () {
                return Promise.resolve(_this30.executeBatchUpdate(records)).then(function (_this29$executeBatchU) {
                  res = _this29$executeBatchU;
                  _interrupt2 = true;
                });
              }], [function () {
                return 'link';
              }, function () {
                return Promise.resolve(_this30.executeLinkAction(records, initialize_callback, caller_reference)).then(function (_this29$executeLinkAc) {
                  res = _this29$executeLinkAc;
                  _interrupt2 = true;
                });
              }], [function () {
                return 'export_data';
              }, function () {
                return Promise.resolve(_this30.executeExportData()).then(function (_this29$executeExport) {
                  res = _this29$executeExport;
                  _interrupt2 = true;
                });
              }], [function () {
                return 'report';
              }, function () {
                return Promise.resolve(_this30.executeReportAction(records)).then(function (_this29$executeReport) {
                  res = _this29$executeReport;
                  _interrupt2 = true;
                });
              }], [function () {
                return 'classmethod';
              }, function () {
                return Promise.resolve(_this30.executeClassMethod(records)).then(function (_this29$executeClassM) {
                  res = _this29$executeClassM;
                  _interrupt2 = true;
                });
              }], [function () {
                return 'custom_method';
              }, function () {
                _this30.screen.set_processing(true);

                return Promise.resolve(_this30.executeCustomMethod(records)).then(function (_this29$executeCustom2) {
                  res = _this29$executeCustom2;

                  _this30.screen.set_processing(false);

                  _interrupt2 = true;
                });
              }], [function () {
                return 'delete_record';
              }, function () {
                return Promise.resolve(_this30.executeDeleteRecord(records)).then(function (_this29$executeDelete) {
                  res = _this29$executeDelete;
                  _interrupt2 = true;
                });
              }], [function () {
                return 'send_email';
              }, function () {
                return Promise.resolve(_this30.executeSendMail(records)).then(function (_this29$executeSendMa) {
                  res = _this29$executeSendMa;
                  _interrupt2 = true;
                });
              }]]);

              if (_temp16 && _temp16.then) return _temp16.then(function () {});
            }
          }();

          return _temp10 && _temp10.then ? _temp10.then(_temp11) : _temp11(_temp10);
        }

        if (_this30.requires_confirmation && !confirmed) {
          _this30.screen.notifications.addDialog({
            'message': _this30.confirmation_message,
            'html': true,
            'actions': [{
              'name': 'OK',
              'color': 'primary',
              'callback': function callback() {
                _this30.execute(records, false, true);

                return true;
              }
            }]
          }, true);

          return false;
        }

        var _temp12 = function () {
          if (_this30.pre_action) {
            return Promise.resolve(_this30.executePreAction(records)).then(function () {});
          }
        }();

        return _temp12 && _temp12.then ? _temp12.then(_temp13) : _temp13(_temp12);
      };

      var _exit4 = false;

      var _this30 = this;

      var res = "";
      records = records ? records : _this30.screen.selected_records;

      if (!_this30.multiple_records && records.length > 1) {
        _this30.screen.notifications.addSnack({
          message: "Seleccione sólo un registro para ejecutar esta acción",
          level: 'error'
        });

        return Promise.resolve(false);
      }

      if (_this30.screen.actions_map.hasOwnProperty(_this30.name) && !executed) {
        if (_this30.validate_records(records)) {
          return Promise.resolve(_this30.screen.actions_map[_this30.name](records));
        }
      }

      var _temp18 = function () {
        if (_this30.custom_validation) {
          return function () {
            if (_this30.validate_records(records)) {
              return Promise.resolve(_this30.execute_custom_validation(records)).then(function (is_valid) {
                if (!is_valid) {
                  _exit4 = true;
                  return false;
                }
              });
            } else {
              _exit4 = true;
              return false;
            }
          }();
        }
      }();

      return Promise.resolve(_temp18 && _temp18.then ? _temp18.then(_temp17) : _temp17(_temp18));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return Action;
}();

var operators = [{
  label: '=',
  value: '='
}, {
  label: 'not',
  value: '!='
}, {
  label: 'Incluye',
  value: 'in'
}, {
  label: 'No incluye',
  value: 'not in'
}, {
  label: '>',
  value: '>'
}, {
  label: '>=',
  value: '>='
}, {
  label: '<',
  value: '<'
}, {
  label: '<=',
  value: '<='
}, {
  label: 'Contiene',
  value: 'ilike'
}];
var getOperator = function getOperator(value) {
  var ops = operators.filter(function (op) {
    return op.value === value;
  });

  if (ops[0]) {
    return ops[0];
  } else {
    throw new Error("Invalid Operator: " + value);
  }
};
var typeOperators = {
  'number': ['=', '>', '<'],
  'char': ['=', 'ilike'],
  'selection': ['in', 'not in'],
  'date': ['=', '>', '<'],
  'boolean': ['=', '!=']
};
var typeMapping = {
  'char': 'char',
  'selection': 'selection',
  'many2one': 'selection',
  'multi_selection': 'selection',
  'multi_link': 'selection',
  'float': 'number',
  'integer': 'number',
  'date': 'date',
  'datetime': 'date',
  'boolean': 'boolean'
};
var getDefaultOperator = function getDefaultOperator(type) {
  switch (type) {
    case 'selection':
      return 'in';

    case 'multi_selection':
      return 'in';

    case 'multi_link':
      return 'in';

    case 'date':
      return '=';

    case 'datetime':
      return '=';

    case 'integer':
      return '=';

    case 'many2one':
      return 'in';

    case 'boolean':
      return '=';

    default:
      return 'ilike';
  }
};

var Filters = /*#__PURE__*/function () {
  function Filters(attributes, screen) {
    this.type = false;
    this.active_filters = [];
    this.record = "";
    this.type = false;
    this.screen = screen;
    this.active_filters = [];
    this.record = new Record({
      id: -1
    }, screen);
    makeAutoObservable(this, {
      fields: computed,
      addFilter: action,
      removeFilter: action,
      setInitialFilters: action,
      clean: action,
      record: observable,
      screen: observable
    });
  }

  var _proto = Filters.prototype;

  _proto.getDefaultFilters = function getDefaultFilters() {
    var filters = [];
    this.screen.default_filters.forEach(function (filter) {
      var attributes = {};
      attributes['field'] = this.fields.find(function (f) {
        return f.id === filter.field;
      });
      attributes['operator'] = getOperator(filter.operator);
      attributes['required'] = filter.required;
      attributes['readonly_field'] = filter.readonly_field;
      attributes['readonly_operator'] = filter.readonly_operator;
      attributes['hide_modifiers'] = filter.hide_modifiers;
      attributes['quick_filter'] = filter.quick_filter;
      attributes['is_default'] = true;
      var new_filter = new Filter(attributes, this);
      filters.push(new_filter);
    }.bind(this));
    return filters;
  };

  _proto.setInitialFilters = function setInitialFilters() {
    var filters = this.getDefaultFilters();
    this.clean();
    var default_applied = [];
    this.screen.current_search.forEach(function (f) {
      var attributes = {};
      var default_filter = filters.find(function (filter) {
        return filter.field_name === f[0];
      });

      if (default_filter && !default_applied.includes(f[0])) {
        default_filter.field.set_value(f[2], this.record);
        default_applied.push(f[0]);
      } else {
        attributes.field = this.fields.find(function (field) {
          return field.name === f[0];
        });

        if (attributes.field) {
          attributes.operator = getOperator(f[1]);
          var filter = new Filter(attributes, this);
          filter.field.set_value(f[2], this.record);
          filters.push(filter);
        }
      }
    }.bind(this));
    this.active_filters = filters;
  };

  _proto.search = function search(navigate) {
    if (navigate === void 0) {
      navigate = true;
    }

    if (this.required_filter_fields.length) {
      if (!this.record.validate(this.required_filter_fields)) {
        return false;
      }
    }

    var current_search = [];
    var search = this.screen.search_state;
    this.active_filters.forEach(function (filter) {
      var val = this.record._values[filter.field.name];

      if (val) {
        current_search.push([filter.field_name, filter.operator.value, this.record._values[filter.field.name]]);
      }
    }.bind(this));
    search['search'] = current_search;

    if (navigate && this.screen.navigate) {
      var url = this.screen.connection.createUrl(search);
      this.screen.navigate(url);
    } else {
      search['current_search'] = current_search;
      this.screen.do_search(search);
    }

    return true;
  };

  _proto.addFilter = function addFilter() {
    var filter = {};
    filter['field_options'] = this.fields.map(function (f) {
      return f;
    });
    filter['field'] = '';
    filter['operator'] = '';
    filter['value'] = '';
    this.active_filters.push(new Filter(filter, this));
  };

  _proto.removeFilter = function removeFilter(filter) {
    var removed = this.active_filters.splice(this.active_filters.findIndex(function (rec) {
      return rec.id === filter.id;
    }), 1);
    removed.forEach(function (f) {
      delete this.record._values[f.field.name];
      delete this.record._changed[f.field.name];
    }.bind(this));
  };

  _proto.clean = function clean() {
    this.active_filters = [];
    this.record = new Record({}, this.screen);
  };

  _proto.get_filter_fname = function get_filter_fname(fname) {
    return this.active_filters.find(function (f) {
      return f.field_name === fname;
    });
  };

  _createClass(Filters, [{
    key: "fields",
    get: function get() {
      return this.screen.filterable_fields;
    }
  }, {
    key: "required_filter_fields",
    get: function get() {
      return this.active_filters.filter(function (f) {
        return f.required === true;
      }).map(function (filter) {
        return filter.field;
      });
    }
  }, {
    key: "some_applied",
    get: function get() {
      var _this = this;

      return this.active_filters.some(function (f) {
        return f.field && f.field.has_value(_this.record) === true;
      });
    }
  }, {
    key: "quick_filters",
    get: function get() {
      return this.active_filters.filter(function (f) {
        return f.quick_filter;
      });
    }
  }]);

  return Filters;
}();
var Filter = /*#__PURE__*/function () {
  function Filter(attributes, filter_group) {
    this.field_options = "";
    this.field = "";
    this.field_name = "";
    this.operator = "";
    this.value = "";
    this.id = "";
    this.filter_group = "";
    this.required = false;
    this.is_default = false;
    makeAutoObservable(this, {
      setField: action,
      setOperator: action
    });
    this.field_options = attributes.field_options;
    this.operator = attributes.operator;
    this.required = attributes.required || false;
    this.value = attributes.value;
    this.readonly_field = attributes.readonly_field || false;
    this.readonly_operator = attributes.readonly_operator || false;
    this.hide_modifiers = attributes.hide_modifiers || false;
    this.is_default = attributes.is_default || false;
    this.quick_filter = attributes.quick_filter || false;
    this.id = v4();
    this.filter_group = filter_group;

    if (attributes.field) {
      this.createFilterField(attributes.field);
    }
  }

  var _proto2 = Filter.prototype;

  _proto2.setOperator = function setOperator(value) {
    this.operator = value;
  };

  _proto2.getFieldType = function getFieldType(field) {
    var type = field.type;

    if (field.char_search) {
      type = 'char';
    } else {
      switch (type) {
        case 'selection':
          return 'multi_selection';

        case 'many2one':
          return 'multi_link';

        case 'boolean':
          return 'selection';

        default:
          return type;
      }
    }

    return type;
  };

  _proto2.createFilterField = function createFilterField(field) {
    var type = this.getFieldType(field);

    var new_attributes = _extends({}, field.attributes);

    new_attributes.type = type;
    new_attributes.name = this.id;
    new_attributes.readonly = false;
    new_attributes.required = this.required;
    new_attributes.filter = this;
    this.field_name = field.name;
    this.field = createField(new_attributes, this.filter_group.screen);
  };

  _proto2.setField = function setField(field) {
    if (this.field) {
      this.field.set_value("", this.filter_group.record);
    }

    this.createFilterField(field);
    this.setOperator(getOperator(getDefaultOperator(field.type)));
  };

  _createClass(Filter, [{
    key: "operator_options",
    get: function get() {
      if (!this.field) {
        return [];
      }

      return operators.filter(function (op) {
        return typeOperators[typeMapping[this.field.type]].includes(op.value);
      }.bind(this));
    }
  }, {
    key: "is_field_readonly",
    get: function get() {
      return [this.required, this.readonly_field].includes(true);
    }
  }, {
    key: "is_operator_readonly",
    get: function get() {
      return [this.required, this.readonly_operator].includes(true);
    }
  }]);

  return Filter;
}();

var ScreenEditor = /*#__PURE__*/function () {
  function ScreenEditor(config, screen, permissions) {
    if (permissions === void 0) {
      permissions = {};
    }

    this.permissions = {};
    this.screen = {};
    this.permissions = {};
    this.config = config;
    this.screen = screen;
    this.permissions = permissions || {};
    makeObservable(this, {
      permissions: observable,
      config: observable
    });
  }

  var _proto = ScreenEditor.prototype;

  _proto.executeAndReload = function executeAndReload(record, screen) {
    try {
      var _this2 = this;

      return Promise.resolve(screen.default_save_action.execute([record], false, false, true)).then(function () {
        return Promise.resolve(_this2.screen.loadFields()).then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.new_screen_callback = function new_screen_callback(screen) {
    var new_values = {
      'view': this.screen.id,
      'view.': {
        'id': this.screen.id,
        'rec_name': this.screen.view.name
      },
      'ds_type': this.screen.view.data_source_type,
      'view_model_': this.screen.model
    };
    screen.active_record.set_values(new_values);
  };

  _proto.openFieldScreen = function openFieldScreen() {
    var _this3 = this;

    var view_definition = this.config.get_definition('fields');
    var field_screen = this.screen.modal_childs.addScreen(view_definition, false, {}, {}, true, true, this.screen, true, true, true, function (screen) {
      return _this3.new_screen_callback(screen);
    });
    var actions_map = {};

    actions_map['save'] = function (records) {
      _this3.executeAndReload(records[0], field_screen);
    };

    field_screen.set_actions_map(actions_map);
  };

  _createClass(ScreenEditor, [{
    key: "fields_permission",
    get: function get() {
      return this.permissions.fields;
    }
  }, {
    key: "edition_options",
    get: function get() {
      var _this4 = this;

      var options = [];

      if (this.fields_permission) {
        options.push({
          'id': 'add_field',
          'label': '+ Add Field',
          'onClick': function onClick() {
            _this4.openFieldScreen();
          }
        });
      }

      return options;
    }
  }]);

  return ScreenEditor;
}();

var GENERAL_TYPE_ACTIONS = ['export_data'];
var Screen = /*#__PURE__*/function () {
  function Screen(group, view, connection, navigate, initial_search, route_state, is_modal, parent, initialize_fields, initialize_actions, initialize_data, initialize_callback, fileHandler, data_callback, on_load_data) {
    if (initialize_fields === void 0) {
      initialize_fields = true;
    }

    if (initialize_actions === void 0) {
      initialize_actions = true;
    }

    if (initialize_data === void 0) {
      initialize_data = true;
    }

    if (initialize_callback === void 0) {
      initialize_callback = false;
    }

    if (fileHandler === void 0) {
      fileHandler = false;
    }

    if (data_callback === void 0) {
      data_callback = false;
    }

    if (on_load_data === void 0) {
      on_load_data = false;
    }

    this.fields = [];
    this.actions = [];
    this.records = [];
    this.current_search = [];
    this.order = [];
    this.limit = null;
    this.processing = false;
    this.loadingFields = true;
    this.loadingInitialData = true;
    this.loadingData = false;
    this.headless = false;
    this.action_id = "";
    this.action_params = [];
    this.active_record = false;
    this.filters = [];
    this.parent = false;
    this.field_childs = {};
    this.modal_childs = {};
    this.modal = false;
    this.parent = false;
    this.data = {};
    this.actions_map = {};
    this.mobile_record_title = "";
    this.mobile_record_header_image = "";
    this.auto_save = true;
    this.start_empty = false;
    this.style_modifiers = {
      'styles': {},
      'classnames': {}
    };
    this.view_template = "";
    this.default_filters = [];
    this.default_filters_open = false;
    this.screen_editor_access = {};
    this.fileHandler = false;
    this.no_data_message = "";
    this.add_record_button = false;
    this.readonly = false;
    this.model = "";
    this.offline_available = false;
    this.parent_ref = false;
    this.default_columns = 4;
    this.view = view;
    this.initialize_data = initialize_data;
    this.initialize_fields = initialize_fields;
    this.initialize_actions = initialize_actions;
    this.title = route_state && route_state.title ? route_state.title : view.title;
    this.id = view.id;
    this.model = view.model;
    this.type = view.type;
    this.connection = connection;
    this.ordered_column = {
      name: false,
      order: false
    };
    this.id_field = view.id_field ? view.id_field : "id";
    this.filterable = view.filterable;
    this.navigate = navigate;
    this.data_origin = view.data_origin;
    this.no_data_message = view.no_data_message;
    this.group = group;
    this.data_callback = data_callback;
    this.on_load_data = on_load_data;
    this.parent_ref = view.parent_ref || false;

    if (group && this.group.createGroup) {
      this.field_childs = group.createGroup(connection, true);
      this.modal_childs = group.createGroup(connection, true);
    } else {
      this.field_childs = [];
      this.modal_childs = [];
    }

    this.data = new RecordGroup(connection, {
      'pagination_enabled': view.pagination_enabled,
      'default_page_size': view.default_page_size,
      'page_size_options': view.page_size_options,
      'show_records_count': view.show_records_count
    }, this);
    this.modal = is_modal;
    this.parent = parent;
    this.mobile_record_title = view.mobile_record_title;
    this.mobile_record_header_image = view.mobile_record_header_image;
    this.start_empty = view.start_empty;
    this.view_template = view.view_template;
    this.default_filters = view.default_filters || [];
    this.default_filters_open = view.default_filters_open;
    this.initialize_callback = initialize_callback;
    this.editor = new ScreenEditor(this.connection.editor_config, this, view.view_edition_access);
    this.fileHandler = fileHandler;
    this.readonly = false;
    this.offline_available = view.offline_available;
    this.default_columns = view.default_columns ? view.default_columns : 4;
    this.processing = false;
    makeObservable(this, {
      visible_fields: computed,
      initialized: computed,
      link_actions: computed,
      filterable_fields: computed,
      search_state: computed,
      fields: observable,
      actions: observable,
      current_search: observable,
      action_id: observable,
      action_params: observable,
      active_record: observable,
      ordered_column: observable,
      filters: observable,
      order: observable,
      data: observable,
      modal: observable,
      loadingFields: observable,
      style_modifiers: observable,
      title: observable,
      editor: observable,
      fileHandler: observable,
      add_record_button: observable,
      readonly: observable,
      new_record: action,
      set_title: action,
      set_actions_map: action,
      set_limit: action,
      add_classname: action,
      add_style: action,
      set_ordered_column: action,
      set_active_record: action,
      reset_fields: action,
      set_file_handler: action,
      set_add_record_button: action,
      set_readonly: action,
      processing: observable,
      set_processing: action
    });
    this.filters = view.filterable ? new Filters({}, this) : false;
    this.initialize(initial_search);
    this.loadActions();
  }

  var _proto = Screen.prototype;

  _proto.initialize = function initialize(search) {
    try {
      var _this2 = this;

      return Promise.resolve(_this2.loadFields(search)).then(function () {
        function _temp2() {
          if (_this2.initialize_callback) {
            _this2.initialize_callback(_this2);
          }
        }

        var _temp = function () {
          if (!_this2.start_empty && _this2.initialize_data) {
            return Promise.resolve(_this2.do_search(search)).then(function () {});
          } else {
            _this2.data.setInitialLoading(false);

            _this2.data.setLoading(false);

            if (_this2.filterable) {
              _this2.filters.setInitialFilters();
            }
          }
        }();

        return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.set_file_handler = function set_file_handler(value) {
    this.fileHandler = value;
  };

  _proto.reload_field_childs = function reload_field_childs() {
    try {
      var _this4 = this;

      if (_this4.active_record.id > 0) {
        _this4.data.o2m_fields.forEach(function (field) {
          if (field.initialized) {
            field.reload();
          } else {
            field.initialize(this.active_record, true);
          }
        }.bind(_this4));
      }

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.reload_parent = function reload_parent() {
    try {
      var _this6 = this;

      return Promise.resolve(_this6.parent.do_search()).then(function () {
        return Promise.resolve(_this6.parent.reload_field_childs()).then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.set_add_record_button = function set_add_record_button(value) {
    this.add_record_button = value;
  };

  _proto.set_readonly = function set_readonly(value) {
    this.readonly = value;
    this.data.records.forEach(function (record) {
      record.set_state_attrs();
    });
  };

  _proto.set_processing = function set_processing(value) {
    this.processing = value;
  };

  _proto.do_search = function do_search(search, force) {
    try {
      var _this8 = this;

      var count = false;
      var reset_page = false;

      if (search) {
        _this8.current_search = search.current_search || _this8.current_search;
        _this8.action_params = search.action_params || _this8.action_params;
        _this8.action_id = search.action_id || false;
        _this8.order = search.order || _this8.order;
        count = true;
        reset_page = true;
      }

      if (_this8.filterable) {
        _this8.filters.setInitialFilters();
      }

      _this8.data.loadData(count, reset_page);

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.set_limit = function set_limit(value) {
    this.data.setLimit(value);
  };

  _proto.set_ordered_column = function set_ordered_column(fname, direction) {
    this.ordered_column = {
      name: fname,
      order: direction
    };
    this.order = [[fname, direction]];
  };

  _proto.set_order = function set_order(field_name, direction, dispatch, navigate) {
    if (dispatch === void 0) {
      dispatch = true;
    }

    if (navigate === void 0) {
      navigate = true;
    }

    try {
      var _this10 = this;

      var search = _extends({}, _this10.search_state);

      direction = direction ? direction : _this10.ordered_column.order === 'ASC' ? 'DESC' : 'ASC';
      search['order'] = [[field_name, direction]];
      search['search'] = search.current_search;

      _this10.set_ordered_column(field_name, direction);

      if (dispatch) {
        if (navigate && _this10.navigate) {
          var url = _this10.connection.createUrl(search);

          _this10.navigate(url);
        } else {
          _this10.do_search(search);
        }
      }

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.set_title = function set_title(title) {
    this.title = title ? title : this.title;
  };

  _proto.set_active_record = function set_active_record(record) {
    this.active_record = record;
  };

  _proto.get_record_by_index = function get_record_by_index(index) {
    return this.data.get_record_by_index(index);
  };

  _proto.get_record_by_id = function get_record_by_id(id) {
    return this.data.get_record_by_id(id);
  };

  _proto.get_field_by_name = function get_field_by_name(fname) {
    return this.fields.find(function (f) {
      return f.name == fname;
    });
  };

  _proto.get_field_by_id = function get_field_by_id(field_id) {
    return this.fields.find(function (f) {
      return f.id == field_id;
    });
  };

  _proto.get_field_by_original_name = function get_field_by_original_name(original_name) {
    return this.fields.find(function (f) {
      return f.original_name == original_name;
    });
  };

  _proto.get_field_by_any_name = function get_field_by_any_name(name) {
    var field = this.get_field_by_name(name);

    if (!field) {
      field = this.get_field_by_original_name(name);
    }

    return field;
  };

  _proto.new_record = function new_record(values) {
    var new_record = new Record(values, this);
    this.records.push(new_record);
    this.set_active_record(this.records[this.records.indexOf(new_record)]);
  };

  _proto.createFields = function createFields(fields) {
    this.fields = fields.map(function (f) {
      return createField(f, this);
    }.bind(this));
  };

  _proto.reset_fields = function reset_fields() {
    alert("reset fields");
    this.fields = [];
  };

  _proto.loadFields = function loadFields(search, pivot_values) {
    if (search === void 0) {
      search = {};
    }

    if (pivot_values === void 0) {
      pivot_values = {};
    }

    try {
      var _this12 = this;

      if (!_this12.initialize_fields) {
        return Promise.resolve(false);
      }

      var args = {
        view_id: _this12.view.id,
        search: search,
        pivot_values: pivot_values,
        model: _this12.model
      };
      var abortController = new AbortController();
      return Promise.resolve(_this12.connection.dispatch('GET', '/view/fields', args, false, false, false, abortController)).then(function (all_fields) {
        runInAction(function () {
          _this12.createFields(all_fields);

          _this12.loadingFields = false;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.createActions = function createActions(actions) {
    this.actions = actions.map(function (a) {
      return new Action(a, this);
    }.bind(this));
  };

  _proto.set_actions_map = function set_actions_map(actions_map) {
    this.actions_map = actions_map;
  };

  _proto.loadActions = function loadActions() {
    try {
      var _this14 = this;

      if (!_this14.initialize_actions) {
        return Promise.resolve(false);
      }

      var args = {
        view_id: _this14.view.id
      };
      var abortController = new AbortController();
      return Promise.resolve(_this14.connection.dispatch('GET', '/view/actions', args, false, true, false, abortController)).then(function (new_actions) {
        runInAction(function () {
          _this14.createActions(new_actions);
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.add_style = function add_style(style) {
    this.style_modifiers.styles = _extends({}, this.style_modifiers.styles, style);
  };

  _proto.add_classname = function add_classname(classname) {
    this.style_modifiers.classnames = _extends({}, this.style_modifiers.classnames, classname);
  };

  _createClass(Screen, [{
    key: "visible_fields",
    get: function get() {
      var vf = this.fields.filter(function (field) {
        return field.visible;
      });

      if (vf[0] !== "selector" && this.type === 'list' || this.type === 'spreadsheet') {
        vf.unshift("selector");
      }

      return vf;
    }
  }, {
    key: "filterable_fields",
    get: function get() {
      var vf = this.fields.filter(function (field) {
        return field.searchable;
      });
      return vf;
    }
  }, {
    key: "conditional_style_fields",
    get: function get() {
      var fields = this.fields.filter(function (field) {
        return field.conditional_style;
      });
      return fields;
    }
  }, {
    key: "field_names",
    get: function get() {
      return this.fields.map(function (f) {
        return f.name;
      });
    }
  }, {
    key: "initialized",
    get: function get() {
      return !this.loadingFields && !this.data.loadingInitialData;
    }
  }, {
    key: "visible_actions",
    get: function get() {
      return this.actions.filter(function (act) {
        return act.invisible == false;
      });
    }
  }, {
    key: "link_actions",
    get: function get() {
      return this.visible_actions.filter(function (act) {
        return act.type === 'link';
      });
    }
  }, {
    key: "report_actions",
    get: function get() {
      return this.visible_actions.filter(function (act) {
        return act.type === 'report';
      });
    }
  }, {
    key: "action_actions",
    get: function get() {
      return this.visible_actions.filter(function (act) {
        return act.type === 'action';
      });
    }
  }, {
    key: "view_group_actions",
    get: function get() {
      return this.visible_actions.filter(function (act) {
        return act.type === 'view_group';
      });
    }
  }, {
    key: "button_actions",
    get: function get() {
      return this.actions.filter(function (act) {
        return act.show_button === true;
      });
    }
  }, {
    key: "all_menu_actions",
    get: function get() {
      return this.visible_actions.filter(function (act) {
        return act.show_button === false;
      });
    }
  }, {
    key: "default_action",
    get: function get() {
      return this.actions.find(function (a) {
        return a["default"] === true;
      });
    }
  }, {
    key: "default_save_action",
    get: function get() {
      return this.actions.find(function (a) {
        return a.default_save === true;
      });
    }
  }, {
    key: "delete_action",
    get: function get() {
      var delete_actions = this.actions.filter(function (act) {
        return act.type === 'delete_record';
      });

      if (delete_actions.length === 1) {
        return delete_actions[0];
      } else if (delete_actions.length > 1) {
        throw new Error("Only one delete action its allowed");
      } else {
        return false;
      }
    }
  }, {
    key: "general_actions",
    get: function get() {
      return this.actions.filter(function (act) {
        return GENERAL_TYPE_ACTIONS.includes(act.type);
      });
    }
  }, {
    key: "search_state",
    get: function get() {
      return {
        current_search: this.current_search,
        action_params: this.action_params,
        action_id: this.action_id,
        order: this.order
      };
    }
  }, {
    key: "notifications",
    get: function get() {
      return this.connection.notifications;
    }
  }, {
    key: "mobile_primary_fields",
    get: function get() {
      return this.visible_fields.filter(function (f) {
        return f.mobile_available === 'primary';
      });
    }
  }, {
    key: "mobile_secondary_fields",
    get: function get() {
      return this.visible_fields.filter(function (f) {
        return f.mobile_available === 'secondary';
      });
    }
  }, {
    key: "mobile_record_image_header_field",
    get: function get() {
      var _this15 = this;

      return this.fields.find(function (f) {
        return f.name === _this15.mobile_record_header_image;
      });
    }
  }, {
    key: "parent_selected_records",
    get: function get() {
      if (!this.parent || !this.parent.selected_records) {
        return [];
      }

      return this.parent.selected_records;
    }
  }]);

  return Screen;
}();

var BoardWidget = function BoardWidget(attributes, parent) {
  this.type = "";
  this.id = "";
  this.name = "";
  this.colspan = false;
  this.height = "";
  this.type = attributes.type;
  this.name = attributes.name;
  this.parent = parent;
  this.id = attributes.id;
  this.colspan = attributes.colspan ? parseInt(attributes.colspan) : false;
  this.height = attributes.height ? parseFloat(attributes.height) : 0.4;
};

var ViewWidget = /*#__PURE__*/function (_BoardWidget) {
  _inheritsLoose(ViewWidget, _BoardWidget);

  function ViewWidget(attributes, parent) {
    var _this;

    _this = _BoardWidget.call(this, attributes, parent) || this;
    _this.view_definition = "";
    _this.screen = "";
    _this.view_definition = attributes.widget_view;
    _this.view_definition.start_empty = true;
    _this.parent = parent;
    _this.screen = _this.parent.child_screens.addScreen(_this.view_definition, false, {
      current_search: []
    }, {}, false);
    _this.screen.parent = _this.parent;
    _this.colspan = _this.colspan ? _this.colspan : 4;
    _this.screen.navigate = false;
    return _this;
  }

  return ViewWidget;
}(BoardWidget);

var IndicatorWidget = function IndicatorWidget(attributes, screen) {};

var ActionWidget = /*#__PURE__*/function (_BoardWidget2) {
  _inheritsLoose(ActionWidget, _BoardWidget2);

  function ActionWidget(attributes, parent) {
    var _this2;

    _this2 = _BoardWidget2.call(this, attributes, parent) || this;
    _this2.action = "";
    _this2.image = "";
    _this2.icon_name = "";
    _this2.text_color = "";
    _this2.icon_color = "";
    _this2.background_color = "";

    if (attributes['action']) {
      _this2.action = new Action(attributes['action'], parent);
    }

    _this2.icon_name = attributes['icon_name'];
    _this2.text_color = attributes['text_color'];
    _this2.icon_color = attributes['icon_color'];
    _this2.background_color = attributes['background_color'];
    _this2.colspan = _this2.colspan ? _this2.colspan : 2;
    makeObservable(_assertThisInitialized(_this2), {
      image: observable,
      icon_name: observable,
      getImage: action
    });

    _this2.getImage();

    return _this2;
  }

  var _proto = ActionWidget.prototype;

  _proto.getImage = function getImage() {
    try {
      var _this4 = this;

      var args = {
        'widget_id': _this4.id
      };
      var abortController = new AbortController();
      return Promise.resolve(_this4.parent.connection.dispatch('GET', '/widget_image', args, false, true, true, abortController)).then(function (image) {
        if (environment() === 'web') {
          image = URL.createObjectURL(image);
        } else {
          var reader = new FileReader();
          reader.readAsDataURL(image.data);

          reader.onloadend = function () {
            var base64data = reader.result;
            image = base64data;
          };
        }

        runInAction(function () {
          _this4.image = image;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return ActionWidget;
}(BoardWidget);

var SupersetDashboardWidget = /*#__PURE__*/function (_BoardWidget3) {
  _inheritsLoose(SupersetDashboardWidget, _BoardWidget3);

  function SupersetDashboardWidget(attributes, parent) {
    var _this5;

    _this5 = _BoardWidget3.call(this, attributes, parent) || this;
    _this5.uuid = false;
    _this5.uuid = attributes.superset_dashboard_uuid;
    return _this5;
  }

  var _proto2 = SupersetDashboardWidget.prototype;

  _proto2.isEnabled = function isEnabled() {
    return this.parent.connection.superset.enabled;
  };

  _proto2.getGuestToken = function getGuestToken() {
    try {
      var _this7 = this;

      var args = {};
      var abortController = new AbortController();
      return Promise.resolve(_this7.parent.connection.dispatch('GET', '/superset/guest_token', args, false, false, false, abortController)).then(function (guest_token) {
        console.log("SUPERSET: guest_token");
        console.log(guest_token);
        return guest_token;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto2.embedSupersetDashboard = function embedSupersetDashboard(element, style) {
    try {
      var _this9 = this;

      return Promise.resolve(embedDashboard({
        id: _this9.uuid,
        supersetDomain: _this9.parent.connection.superset.url,
        mountPoint: element,
        fetchGuestToken: function fetchGuestToken() {
          return _this9.getGuestToken();
        }
      })).then(function (res) {
        console.log("THE RES FROM THE EMBED ?");
        console.log(res);
        console.log(res.getScrollSize());
        console.log();
        element.children[0].style = style;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return SupersetDashboardWidget;
}(BoardWidget);

var BoardWidgets = {
  'view': ViewWidget,
  'indicator': IndicatorWidget,
  'action': ActionWidget,
  'superset_dashboard': SupersetDashboardWidget
};

var BoardScreen = /*#__PURE__*/function (_Screen) {
  _inheritsLoose(BoardScreen, _Screen);

  function BoardScreen(group, view, connection, navigate, initial_search, route_state, is_modal, parent, initialize_fields, initialize_actions, initialize_data, initialize_callback, fileHandler) {
    var _this;

    if (initialize_fields === void 0) {
      initialize_fields = true;
    }

    if (initialize_actions === void 0) {
      initialize_actions = true;
    }

    if (initialize_data === void 0) {
      initialize_data = true;
    }

    if (initialize_callback === void 0) {
      initialize_callback = false;
    }

    if (fileHandler === void 0) {
      fileHandler = false;
    }

    _this = _Screen.call(this, group, view, connection, navigate, initial_search, route_state, is_modal, parent, initialize_fields = true, initialize_actions = true, initialize_data = true, initialize_callback = false, fileHandler = false) || this;
    _this.widgets = [];
    _this.child_screens = [];
    _this.default_columns = 2;
    _this.default_columns = view.default_columns;
    _this.child_screens = group.createGroup(_this.connection);
    makeObservable(_assertThisInitialized(_this), {
      widgets: observable
    });
    return _this;
  }

  var _proto = BoardScreen.prototype;

  _proto.initialize = function initialize(search) {
    try {
      var _this3 = this;

      return Promise.resolve(_this3.loadFields()).then(function () {
        return Promise.resolve(_this3.loadWidgets()).then(function () {
          return Promise.resolve(_this3.do_search(search)).then(function () {});
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.createWidgets = function createWidgets(data) {
    this.widgets = data.map(function (w) {
      return new BoardWidgets[w.type](w, this);
    }.bind(this));
  };

  _proto.loadWidgets = function loadWidgets() {
    try {
      var _this5 = this;

      var args = {
        view_id: _this5.view.id
      };
      var abortController = new AbortController();
      return Promise.resolve(_this5.connection.dispatch('GET', '/view/widgets', args, false, true, false, abortController)).then(function (widgets) {
        runInAction(function () {
          _this5.createWidgets(widgets);
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.do_search = function do_search(search, force) {
    try {
      var _this7 = this;

      if (search) {
        _this7.current_search = search.current_search || _this7.current_search;
        _this7.action_params = search.action_params || _this7.action_params;
        _this7.action_id = search.action_id || false;
        _this7.order = search.order || _this7.order;
      }

      _this7.view_widgets.forEach(function (child_view) {
        child_view.screen.do_search(search);
      });

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _createClass(BoardScreen, [{
    key: "view_widgets",
    get: function get() {
      return this.widgets.filter(function (widget) {
        return widget.type === 'view';
      });
    }
  }, {
    key: "action_widgets",
    get: function get() {
      return this.widgets.filter(function (widget) {
        return widget.type === 'action';
      });
    }
  }]);

  return BoardScreen;
}(Screen);

var HTMLScreen = /*#__PURE__*/function (_Screen) {
  _inheritsLoose(HTMLScreen, _Screen);

  function HTMLScreen(group, view, connection, navigate, initial_search, route_state, is_modal, parent, initialize_fields, initialize_actions, initialize_data, initialize_callback, fileHandler, data_callback, on_load_data) {
    var _this;

    if (initialize_fields === void 0) {
      initialize_fields = true;
    }

    if (initialize_actions === void 0) {
      initialize_actions = true;
    }

    if (initialize_data === void 0) {
      initialize_data = true;
    }

    if (initialize_callback === void 0) {
      initialize_callback = false;
    }

    if (fileHandler === void 0) {
      fileHandler = false;
    }

    if (data_callback === void 0) {
      data_callback = false;
    }

    if (on_load_data === void 0) {
      on_load_data = false;
    }

    on_load_data = function on_load_data(screen, records) {
      screen.render_template(records);
    };

    _this = _Screen.call(this, group, view, connection, navigate, initial_search, route_state, is_modal, parent, initialize_fields, initialize_actions, initialize_data, initialize_callback, fileHandler, data_callback, on_load_data) || this;
    _this.template_source = "";
    _this.template_field = "";
    _this.view_template = "";
    _this.template_source = view.html.template_source;
    _this.template_field = view.html.template_field;
    _this.view_template = "";
    _this.processing = true;
    makeObservable(_assertThisInitialized(_this), {
      view_template: observable,
      template_field: observable,
      setViewTemplate: action
    });
    return _this;
  }

  var _proto = HTMLScreen.prototype;

  _proto.setViewTemplate = function setViewTemplate(content) {
    this.view_template = content;
  };

  _proto.render_template = function render_template(records) {
    if (records === void 0) {
      records = [];
    }

    try {
      var _this3 = this;

      if (!records.length) {
        records = _this3.data.records;
      }

      console.log(records);
      var abortController = new AbortController();
      var args = {};
      args.ids = records.map(function (rec) {
        return rec.id;
      });
      args.view_id = _this3.view.id;
      return Promise.resolve(_this3.connection.dispatch('GET', '/view/render_html_content', args, false, false, false, abortController)).then(function (content) {
        _this3.setViewTemplate(content.content);

        _this3.set_processing(false);

        return content.content;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _createClass(HTMLScreen, [{
    key: "template_field_object",
    get: function get() {
      var _this4 = this;

      var field = false;

      if (this.template_field && this.fields.length) {
        field = this.fields.find(function (f) {
          return f.name === _this4.template_field;
        });
      }

      return field;
    }
  }, {
    key: "content",
    get: function get() {
      var content = "";

      if (this.template_source === 'view_field' && this.active_record.id) {
        content = this.template_field_object.get_value(this.active_record);
      } else {
        content = this.view_template;
      }

      return content;
    }
  }]);

  return HTMLScreen;
}(Screen);

var SpreadsheetScreen = /*#__PURE__*/function (_Screen) {
  _inheritsLoose(SpreadsheetScreen, _Screen);

  function SpreadsheetScreen(group, view, connection, navigate, initial_search, route_state, is_modal, parent, initialize_fields, initialize_actions, initialize_data, initialize_callback, fileHandler) {
    var _this;

    if (initialize_fields === void 0) {
      initialize_fields = true;
    }

    if (initialize_actions === void 0) {
      initialize_actions = true;
    }

    if (initialize_data === void 0) {
      initialize_data = true;
    }

    if (initialize_callback === void 0) {
      initialize_callback = false;
    }

    if (fileHandler === void 0) {
      fileHandler = false;
    }

    _this = _Screen.call(this, group, view, connection, navigate, initial_search, route_state, is_modal, parent, initialize_fields, initialize_actions, initialize_data, initialize_callback, fileHandler) || this;
    _this.selected_records = [];
    _this.list_type = "";
    _this.smart_sort_options = [];
    _this.field_instance = false;
    _this.list_type = view.list_type;
    _this.smart_sort_options = view.smart_sort_options ? view.smart_sort_options : [];
    makeObservable(_assertThisInitialized(_this), {
      set_selected_record: action,
      add_selected_records: action,
      set_field_instance: action,
      remove_selected_records: action,
      selected_records: observable,
      field_instance: observable,
      list_type: observable
    });
    return _this;
  }

  var _proto = SpreadsheetScreen.prototype;

  _proto.set_field_instance = function set_field_instance(field) {
    this.field_instance = field;
  };

  _proto.record_index = function record_index(record) {
    return this.data.records.indexOf(record);
  };

  _proto.is_selected = function is_selected(id) {
    return this.selected_records.findIndex(function (rec) {
      return rec.id === id;
    }) >= 0;
  };

  _proto.set_selected_record = function set_selected_record(records) {
    this.selected_records = records;
  };

  _proto.add_selected_records = function add_selected_records(records) {
    var _this2 = this;

    runInAction(function () {
      records.forEach(function (i) {
        this.selected_records.push(i);
      }.bind(_this2));
    });
  };

  _proto.remove_selected_records = function remove_selected_records(records) {
    records.forEach(function (i) {
      var rec = this.selected_records.indexOf(i);
      this.selected_records.splice(rec, 1);
    }.bind(this));
  };

  _proto.changeSelection = function changeSelection(_ref) {
    var _this3 = this;

    var _ref$id = _ref.id,
        id = _ref$id === void 0 ? 0 : _ref$id,
        _ref$index = _ref.index,
        index = _ref$index === void 0 ? 0 : _ref$index,
        _ref$toogle = _ref.toogle,
        toogle = _ref$toogle === void 0 ? false : _ref$toogle,
        _ref$range = _ref.range,
        range = _ref$range === void 0 ? false : _ref$range;
    var record = id ? this.get_record_by_id(id) : this.get_record_by_index(index);
    var selected = this.is_selected(record.id);

    var get_range = function get_range(to) {
      var res = [].concat(_this3.selected_records);
      var from = _this3.selected_records.length ? _this3.record_index(_this3.selected_records[_this3.selected_records.length - 1]) : to;
      var start = to < from ? to : from;
      var end = to < from ? from : to;

      while (start <= end) {
        var _record = _this3.get_record_by_index(start);

        if (!_this3.is_selected(_record.id)) {
          res.push(_record);
        }

        start += 1;
      }

      return res;
    };

    if (toogle) {
      if (!selected) {
        this.set_selected_record([record]);
      } else {
        if (this.selected_records.length > 1) {
          this.set_selected_record([record]);
        } else {
          this.set_selected_record([]);
        }
      }
    } else {
      if (range) {
        this.set_selected_record(get_range(index));
      } else if (!selected) {
        this.add_selected_records([record]);
      } else {
        this.remove_selected_records([record]);
      }
    }
  };

  _proto.toogleSelectAll = function toogleSelectAll(all_selected) {
    var selected = [];

    if (all_selected) {
      selected = [].concat(selected, this.data.records);
    }

    this.set_selected_record(selected);
  };

  _proto.pasteValues = function pasteValues(start_row, start_column, values) {
    values.forEach(function (row, rec_index) {
      var next_rec = start_row + rec_index;
      var record;

      if (next_rec >= this.data.records.length) {
        record = this.data.addRecord({
          'values': {}
        });
      } else {
        record = this.data.records[start_row + rec_index];
      }

      row.forEach(function (col, col_index) {
        var next_col = start_column + col_index;

        if (next_col >= this.visible_fields.length) {
          return;
        }

        var field = this.visible_fields[start_column + col_index];

        if (!field.get_state_attrs(record).readonly) {
          field.set_value(col, record);
        }
      }.bind(this));
    }.bind(this));
  };

  _proto.pasteValuesFromClipboard = function pasteValuesFromClipboard(_ref2) {
    var columnIndex = _ref2.columnIndex,
        rowIndex = _ref2.rowIndex,
        event = _ref2.event;
    event.preventDefault();
    var clipboardData = event.clipboardData || event.originalEvent && event.originalEvent.clipboardData;
    var value = clipboardData.getData("Text") || clipboardData.getData("text/plain");
    var rows = value.replace(/"((?:[^"]*(?:\r\n|\n\r|\n|\r))+[^"]+)"/mg, function (match, p1) {
      p1 = p1.replace(/""/g, '"').replace(/\r\n|\n\r|\n|\r/g, ' ');
      return p1;
    }).split(/\r\n|\n\r|\n|\r/g);
    rows = rows.map(function (row) {
      row = row.split(/\t/).filter(function (value) {
        value = value.trim();
        return Boolean(value);
      });
      return row;
    });
    return this.pasteValues(rowIndex, columnIndex, rows);
  };

  _proto.do_search = function do_search(search, force) {
    if (this.field_instance) {
      var field_domain = this.field_instance.get_domain();

      if (field_domain && field_domain.current_search) {
        search.current_search = mergeDomain(search.current_search, field_domain.current_search);
      }
    }

    _Screen.prototype.do_search.call(this, search, force);

    this.set_selected_record([]);
    this.set_active_record(false);
  };

  _createClass(SpreadsheetScreen, [{
    key: "all_records_selected",
    get: function get() {
      return this.data.records.length && this.data.records.length === this.selected_records.length;
    }
  }]);

  return SpreadsheetScreen;
}(Screen);

var BarPieGraph = /*#__PURE__*/function () {
  function BarPieGraph(definition, screen) {
    this.id = "";
    this.type = "";
    this.groupby = "";
    this.action = "";
    this.markers = [];
    this.screen = "";
    this.id = definition.id;
    this.type = definition.type;
    this.groupby = definition.groupby;
    this.action = definition.action;
    this.markers = definition.graph_markers;
    this.screen = screen;
    makeObservable(this, {
      type: observable,
      groupby: observable,
      action: observable,
      markers: observable
    });
  }

  _createClass(BarPieGraph, [{
    key: "definition",
    get: function get() {
      return {
        id: this.id,
        type: this.type,
        groupby: this.groupby,
        action: this.action,
        markers: this.markers
      };
    }
  }, {
    key: "x_field",
    get: function get() {
      var _this = this;

      return this.screen.fields.find(function (f) {
        return f.name == _this.groupby;
      });
    }
  }, {
    key: "x_legend",
    get: function get() {
      return this.x_field ? this.x_field.description : "";
    }
  }, {
    key: "value_field",
    get: function get() {
      return this.screen.fields.find(function (f) {
        return f.name == 'value';
      });
    }
  }, {
    key: "y_legend",
    get: function get() {
      return this.value_field ? this.value_field.description : "";
    }
  }, {
    key: "x_labels",
    get: function get() {
      var labels = false;

      if (this.x_field.type === 'selection') {
        labels = {};
        this.x_field.selection_options.forEach(function (option) {
          labels[option.value] = option.label;
        });
      } else if (this.x_field.type === 'many2one') {
        labels = {};
        this.screen.data.records.forEach(function (record) {
          var value = this.x_field.get_value(record);
          labels[record.id] = value ? value.rec_name : "";
        }.bind(this));
      }

      return labels;
    }
  }]);

  return BarPieGraph;
}();

var date_formats = {
  'datetime': 'time:%Y-%m-%d %H:%M:%SZ',
  'date': 'time:%Y-%m-%dZ'
};
var LineGraph = /*#__PURE__*/function () {
  function LineGraph(definition, screen) {
    this.id = "";
    this.type = "";
    this.groupby = "";
    this.action = "";
    this.markers = [];
    this.screen = "";
    this.x_axis = "";
    this.y_axis = "";
    this.id = definition.id;
    this.type = definition.type;
    this.groupby = definition.groupby;
    this.action = definition.action;
    this.markers = definition.graph_markers;
    this.x_axis = definition.x_axis;
    this.y_axis = definition.y_axis;
    this.screen = screen;
    makeObservable(this, {
      type: observable,
      groupby: observable,
      action: observable,
      markers: observable
    });
  }

  _createClass(LineGraph, [{
    key: "definition",
    get: function get() {
      return {
        id: this.id,
        type: this.type,
        groupby: this.groupby,
        action: this.action,
        markers: this.markers,
        x_axis: this.x_axis,
        y_axis: this.y_axis
      };
    }
  }, {
    key: "x_field",
    get: function get() {
      var _this = this;

      return this.screen.fields.find(function (f) {
        return f.name == _this.x_axis;
      });
    }
  }, {
    key: "y_field",
    get: function get() {
      var _this2 = this;

      return this.screen.fields.find(function (f) {
        return f.name == _this2.y_axis;
      });
    }
  }, {
    key: "x_legend",
    get: function get() {
      return this.x_field ? this.x_field.description : "";
    }
  }, {
    key: "y_legend",
    get: function get() {
      return this.y_field ? this.y_field.description : "";
    }
  }, {
    key: "x_format",
    get: function get() {
      var res = false;

      if (['date', 'datetime'].includes(this.x_field.type)) {
        res = date_formats[this.x_field.type];
      }

      return res;
    }
  }]);

  return LineGraph;
}();

var GRAPH_TYPES = {
  'bar': BarPieGraph,
  'pie': BarPieGraph,
  'line': LineGraph
};
var GraphScreen = /*#__PURE__*/function (_Screen) {
  _inheritsLoose(GraphScreen, _Screen);

  function GraphScreen(group, view, connection, navigate, initial_search, route_state, is_modal, parent, initialize_fields, initialize_actions, initialize_data, initialize_callback, fileHandler) {
    var _this;

    if (initialize_fields === void 0) {
      initialize_fields = true;
    }

    if (initialize_actions === void 0) {
      initialize_actions = true;
    }

    if (initialize_data === void 0) {
      initialize_data = true;
    }

    if (initialize_callback === void 0) {
      initialize_callback = false;
    }

    if (fileHandler === void 0) {
      fileHandler = false;
    }

    _this = _Screen.call(this, group, view, connection, navigate, initial_search, route_state, is_modal, parent, initialize_fields = true, initialize_actions = true, initialize_data = true, initialize_callback = false, fileHandler = false) || this;
    _this.graphs = [];
    _this.active_graph = false;
    _this.show_data = false;
    _this.data_screen = false;
    makeObservable(_assertThisInitialized(_this), {
      graphs: observable,
      show_data: observable,
      data_screen: observable,
      set_active_graph: action,
      switch_view: action
    });

    _this.set_graphs(view.graphs);

    _this.set_active_graph(_this.graphs[0]);

    var data_view = _extends({}, view);

    data_view['type'] = 'list';
    data_view['id'] = data_view['id'] + 'data_view';
    data_view['start_empty'] = true;
    _this.data_screen = group.addScreen(data_view, false, [], {}, true, false, false, false, false);
    _this.data_screen.title = "";
    return _this;
  }

  var _proto = GraphScreen.prototype;

  _proto.set_active_graph = function set_active_graph(graph) {
    this.active_graph = graph;
  };

  _proto.set_graphs = function set_graphs(definitions) {
    var _this2 = this;

    runInAction(function () {
      _this2.graphs = definitions.map(function (definition) {
        if (!GRAPH_TYPES[definition.type]) {
          throw new Error("Graph type not supported: " + definition.type);
        }

        return new GRAPH_TYPES[definition.type](definition, this);
      }.bind(_this2));
    });
  };

  _proto.do_search = function do_search(search, force) {
    try {
      var _this4 = this;

      if (!_this4.active_graph) {
        return Promise.resolve();
      }

      var count = false;
      var reset_page = false;

      if (search) {
        _this4.current_search = search.current_search || _this4.current_search;
        _this4.action_params = search.action_params || _this4.action_params;
        _this4.action_id = search.action_id || false;
        _this4.order = search.order || _this4.order;
        count = true;
        reset_page = true;
      }

      if (_this4.filterable) {
        _this4.filters.setInitialFilters();
      }

      var extra_args = {
        'graph': _this4.active_graph.definition
      };

      _this4.data.loadData(count, reset_page, extra_args);

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.switch_view = function switch_view() {
    this.show_data = !this.show_data;
    var fields = this.fields.map(function (field) {
      return field.attributes;
    });
    this.data_screen.createFields(fields);
    this.data_screen.loadingFields = false;

    if (this.show_data && !this.data_screen.data.records.length) {
      var values = this.data.records.map(function (record) {
        return _extends({}, record._values);
      });
      var records = values.map(function (val) {
        return new Record(val, this.data_screen, this.data_screen.data);
      }.bind(this));
      this.data_screen.data.records = records;
    }
  };

  _createClass(GraphScreen, [{
    key: "data_values",
    get: function get() {
      return this.data.records.map(function (record) {
        return record._values;
      });
    }
  }]);

  return GraphScreen;
}(Screen);

var CalendarScreen = /*#__PURE__*/function (_Screen) {
  _inheritsLoose(CalendarScreen, _Screen);

  function CalendarScreen(group, view, connection, navigate, initial_search, route_state, is_modal, parent, initialize_fields, initialize_actions, initialize_data, initialize_callback, fileHandler) {
    var _this;

    if (initialize_fields === void 0) {
      initialize_fields = true;
    }

    if (initialize_actions === void 0) {
      initialize_actions = true;
    }

    if (initialize_data === void 0) {
      initialize_data = true;
    }

    if (initialize_callback === void 0) {
      initialize_callback = false;
    }

    if (fileHandler === void 0) {
      fileHandler = false;
    }

    _this = _Screen.call(this, group, view, connection, navigate, initial_search, route_state, is_modal, parent, initialize_fields, initialize_actions, initialize_data, initialize_callback, fileHandler) || this;
    _this.start_date_field_id = "";
    _this.end_date_field_id = "";
    _this.event_title_field_id = "";
    _this.event_detail_action_id = "";
    _this.event_new_action_id = "";
    _this.view_types = [];
    _this.initial_view = "";
    _this.start_date_field_id = view.calendar_start_date_field;
    _this.end_date_field_id = view.calendar_end_date_field;
    _this.event_title_field_id = view.calendar_event_title_field;
    _this.event_detail_action_id = view.calendar_event_detail_action;
    _this.event_new_action_id = view.calendar_event_new_action;
    _this.view_types = ['month', 'week', 'day', 'agenda', 'work_week'];
    _this.initial_view = 'month';
    makeObservable(_assertThisInitialized(_this), {
      start_date_field_id: observable,
      end_date_field_id: observable,
      view_types: observable,
      initial_view: observable
    });
    return _this;
  }

  var _proto = CalendarScreen.prototype;

  _proto.get_start_date_value = function get_start_date_value(record) {
    var value = moment.utc(this.start_date_field.get_value(record)).toDate();
    return value;
  };

  _proto.get_end_date_value = function get_end_date_value(record) {
    var start_date = this.get_start_date_value(record);
    var end_date = this.end_date_field.get_value(record);
    var is_range = start_date != end_date;

    if (is_range) {
      if (this.all_day_events) {
        end_date = end_date.add(1, 'days');
      } else if (moment.utc(end_date).local().format("HH:mm:ss") == "00:00:00") {
        end_date = end_date.add(1, 'days');
      }
    }

    var value = moment.utc(end_date).toDate();
    return value;
  };

  _proto.get_title_value = function get_title_value(record) {
    return this.event_title_field.get_string_value(record);
  };

  _proto.view_event_detail = function view_event_detail(records) {
    if (this.event_detail_action) {
      this.event_detail_action.execute(records);
    }
  };

  _proto.new_event = function new_event(event_info) {
    var _this2 = this;

    if (!this.event_new_action) {
      return;
    }

    function setInitialValues(start_field, end_field, form_screen) {
      console.log("Callbacking");
      console.log("modal childs");

      if (form_screen.active_record) {
        console.log("Event info");
        console.log(event_info);
        var start_date = validateDate(event_info.start, start_field.type);
        form_screen.active_record.set_value(start_field.name, start_date);
        form_screen.active_record.set_value(end_field.name, start_date);
      }
    }

    this.event_new_action.execute([], false, false, false, function (screen) {
      setInitialValues(_this2.start_date_field, _this2.end_date_field, screen);
    });
  };

  _createClass(CalendarScreen, [{
    key: "start_date_field",
    get: function get() {
      var _this3 = this;

      return this.fields.find(function (f) {
        return f.id === _this3.start_date_field_id;
      });
    }
  }, {
    key: "end_date_field",
    get: function get() {
      var _this4 = this;

      return this.fields.find(function (f) {
        return f.id === _this4.end_date_field_id;
      });
    }
  }, {
    key: "event_title_field",
    get: function get() {
      var _this5 = this;

      return this.fields.find(function (f) {
        return f.id === _this5.event_title_field_id;
      });
    }
  }, {
    key: "all_day_events",
    get: function get() {
      return this.start_date_field.type == 'date' && this.end_date_field.type == 'date';
    }
  }, {
    key: "event_detail_action",
    get: function get() {
      var _this6 = this;

      return this.actions.find(function (a) {
        return a.id === _this6.event_detail_action_id;
      });
    }
  }, {
    key: "event_new_action",
    get: function get() {
      var _this7 = this;

      return this.actions.find(function (a) {
        return a.id === _this7.event_new_action_id;
      });
    }
  }]);

  return CalendarScreen;
}(Screen);

var ScreenGroup = /*#__PURE__*/function () {
  function ScreenGroup(connection, sub_group) {
    if (sub_group === void 0) {
      sub_group = false;
    }

    this.screens = {};
    this.connection = false;
    this.active_screen = false;
    makeAutoObservable(this, {
      addScreen: action,
      removeScreen: action,
      clear: action
    });
    this.connection = connection;
    this.screens = {};
    this.active_screen = false;
    this.sub_group = sub_group;

    if (this.sub_group == false) {
      this.connection.setMainScreenGroup(this);
    }
  }

  var _proto = ScreenGroup.prototype;

  _proto.set_active_screen = function set_active_screen(screen) {
    var _this = this;

    runInAction(function () {
      if (_this.active_screen) {
        for (var id in _this.active_screen.field_childs.screens) {
          _this.active_screen.field_childs.removeScreen(id);
        }
      }

      _this.active_screen = screen;
    });
  };

  _proto.addScreen = function addScreen(view, history, initial_search, route_state, set_active, is_modal, parent, initialize_fields, initialize_actions, initialize_data, initialize_callback, fileHandler, data_callback) {
    if (route_state === void 0) {
      route_state = {};
    }

    if (set_active === void 0) {
      set_active = true;
    }

    if (is_modal === void 0) {
      is_modal = false;
    }

    if (parent === void 0) {
      parent = false;
    }

    if (initialize_fields === void 0) {
      initialize_fields = true;
    }

    if (initialize_actions === void 0) {
      initialize_actions = true;
    }

    if (initialize_data === void 0) {
      initialize_data = true;
    }

    if (initialize_callback === void 0) {
      initialize_callback = false;
    }

    if (fileHandler === void 0) {
      fileHandler = false;
    }

    if (data_callback === void 0) {
      data_callback = false;
    }

    var res = "";
    var offline_mode = this.connection.offline_mode;

    if (offline_mode) {
      if (!this.connection.offlineAvailable(view.id)) {
        return false;
      }
    }

    var setScreenTitle = function setScreenTitle(screen) {
      var title = route_state[initial_search.action_id] ? route_state[initial_search.action_id].title : screen.view.title;
      screen.set_title(title);
    };

    if (!this.screens[view.id] || view.multi_model_view) {
      var screen;

      if (SCREEN_TYPES[view.type]) {
        screen = new SCREEN_TYPES[view.type](this, view, this.connection, history, initial_search, route_state, is_modal, parent, initialize_fields, initialize_actions, initialize_data, initialize_callback, fileHandler, data_callback = data_callback);
      } else {
        screen = new Screen(this, view, this.connection, history, initial_search, route_state, is_modal, parent, initialize_fields, initialize_actions, initialize_data, initialize_callback, fileHandler, data_callback = data_callback);
      }

      this.screens[view.id] = screen;
      res = screen;
      setScreenTitle(res);
    } else {
      res = this.screens[view.id];
      setScreenTitle(res);

      if (res.start_empty) {
        if (initial_search.current_search.length) {
          res.do_search(initial_search);
        }
      } else {
        res.do_search(initial_search);
      }
    }

    if (set_active) {
      this.set_active_screen(res);
    }

    return res;
  };

  _proto.removeScreen = function removeScreen(view_id) {
    delete this.screens[view_id];
  };

  _proto.clear = function clear() {
    this.screens = {};
  };

  _proto.getScreen = function getScreen(id) {
    return this.screens.filter(function (view) {
      return view.id === id;
    })[0];
  };

  _proto.createGroup = function createGroup(connection, sub_group) {
    if (sub_group === void 0) {
      sub_group = false;
    }

    return new ScreenGroup(connection, sub_group);
  };

  return ScreenGroup;
}();
var SCREEN_TYPES = {
  'board': BoardScreen,
  'html': HTMLScreen,
  'list': SpreadsheetScreen,
  'spreadsheet': SpreadsheetScreen,
  'graph': GraphScreen,
  'calendar': CalendarScreen
};

var Cache = /*#__PURE__*/function () {
  function Cache() {
    this.store = {};
    makeObservable(this, {
      store: observable,
      get: action,
      set: action
    });
  }

  var _proto = Cache.prototype;

  _proto.get = function get(key) {
    return this.store[key];
  };

  _proto.set = function set(key, value) {
    this.store[key] = value;
  };

  return Cache;
}();

var asyncStorage = false;

try {
  asyncStorage = require('@react-native-async-storage/async-storage')["default"];
} catch (e) {
  console.log("Web Environment");
}

var Storage = environment() === 'web' ? localStorage : asyncStorage;
var createStorage = function createStorage() {
  var env = environment();

  if (env === 'web') {
    return new WebStorage();
  } else if (env === 'native') {
    return new NativeStorage();
  } else {
    throw new Error('Not implemented Environment:' + env);
  }
};
var WebStorage = /*#__PURE__*/function () {
  function WebStorage() {
    this.environment = 'web';
  }

  var _proto = WebStorage.prototype;

  _proto.getItem = function getItem(key) {
    return Storage.getItem(key);
  };

  _proto.setItem = function setItem(key, value) {
    return Storage.setItem(key, value);
  };

  _proto.removeItem = function removeItem(key) {
    return Storage.removeItem(key);
  };

  return WebStorage;
}();
var NativeStorage = /*#__PURE__*/function () {
  function NativeStorage() {
    this.environment = 'native';
  }

  var _proto2 = NativeStorage.prototype;

  _proto2.getItem = function getItem(key) {
    try {
      var val = "";

      var _temp2 = _catch(function () {
        return Promise.resolve(Storage.getItem(key)).then(function (value) {
          if (value !== null) {
            val = value;
          }
        });
      }, function (e) {
        console.log("Error");
        console.log(e);
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {
        return val;
      }) : val);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto2.setItem = function setItem(key, value) {
    try {
      var res = false;

      var _temp4 = _catch(function () {
        return Promise.resolve(Storage.setItem(key, value)).then(function () {
          res = true;
        });
      }, function (e) {
        console.log("Error");
        console.log(e);
      });

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(function () {
        return res;
      }) : res);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto2.removeItem = function removeItem(key) {
    try {
      var res = false;

      var _temp6 = _catch(function () {
        return Promise.resolve(Storage.removeItem(key)).then(function () {
          res = true;
        });
      }, function (e) {
        console.log("Error");
        console.log(e);
      });

      return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {
        return res;
      }) : res);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return NativeStorage;
}();

var WEB_CONFIG = {
  api_path: "/app/v1"
};
var NATIVE_CONFIG = {
  auth_proxy: "https://kalenislims.com"
};
var configs = {
  'native': NATIVE_CONFIG,
  'web': WEB_CONFIG
};
var Config = function Config(external_handler) {
  if (external_handler) {
    return external_handler;
  }

  return configs[environment()];
};

var rnfa = false;

try {
  rnfa = require('react-native-fetch-api');
} catch (e) {
  console.log("Web environment, no polyfills");
}

var _ref = environment() === 'web' ? {
  fetch_: fetch
} : {
  fetch_: fetch
},
    fetch_ = _ref.fetch_;

var EditorConfig = /*#__PURE__*/function () {
  function EditorConfig(connection) {
    this.initialized = false;
    this.view_definitions = {};
    this.view_wizards = [];
    this.connection = connection;
    makeObservable(this, {
      view_definitions: observable,
      initialized: observable,
      view_wizards: observable,
      set_initialized: action,
      set_view_definitions: action
    });
    this.initialize();
  }

  var _proto = EditorConfig.prototype;

  _proto.initialize = function initialize() {
    try {
      var _this2 = this;

      return Promise.resolve(_this2.loadViewDefinitions()).then(function () {
        return Promise.resolve(_this2.loadViewWizards()).then(function () {
          _this2.set_initialized(true);
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.set_initialized = function set_initialized(val) {
    this.initialized = val;
  };

  _proto.set_view_definitions = function set_view_definitions(definitions) {
    this.view_definitions = definitions;
  };

  _proto.set_view_wizards = function set_view_wizards(wizards) {
    this.view_wizards = wizards;
  };

  _proto.loadViewDefinitions = function loadViewDefinitions() {
    try {
      var _this4 = this;

      var abortController = new AbortController();
      return Promise.resolve(_this4.connection.dispatch('GET', '/view_handler/editor_definitions', {}, false, true, false, abortController)).then(function (definitions) {
        _this4.set_view_definitions(definitions);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.loadViewWizards = function loadViewWizards() {
    try {
      var _this6 = this;

      var abortController = new AbortController();
      return Promise.resolve(_this6.connection.dispatch('GET', '/view_handler/view_wizards', {}, false, true, false, abortController)).then(function (wizards) {
        _this6.set_view_wizards(wizards);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.get_definition = function get_definition(type) {
    var definition = false;

    if (this.view_definitions[type]) {
      definition = this.view_definitions[type];
    }

    return definition;
  };

  return EditorConfig;
}();

var Pool = /*#__PURE__*/function () {
  function Pool(db, connection) {
    this.models = {};
    this.db = db;
    this.connection = connection;
  }

  var _proto = Pool.prototype;

  _proto.initialize = function initialize(models) {
    models.forEach(function (model) {
      this.models[model.model] = new Model(this, model.model, model.view);
    }.bind(this));
    this.db.local_db.createIndex({
      index: {
        fields: ['model_', 'id']
      }
    });
  };

  _proto.get = function get(model_name) {
    if (this.models[model_name]) {
      return this.models[model_name];
    } else {
      throw new Error("The Model " + model_name + " is not defined or not available for offline use");
    }
  };

  _proto.dispatch = function dispatch(model, method, args) {
    try {
      var _this2 = this;

      return Promise.resolve(_this2.get(model)[method](args));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.populateModels = function populateModels() {
    try {
      var _this4 = this;

      var prms = [];

      for (var name in _this4.models) {
        prms.push(_this4.models[name].loadRecords());
      }

      return Promise.resolve(Promise.all(prms));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getUpdatedRecords = function getUpdatedRecords(ids_by_view) {
    try {
      var _this6 = this;

      var prms = [];

      var _loop = function _loop(view_id) {
        var ids = ids_by_view[view_id];

        var route = _this6.connection.offline_routes.find(function (r) {
          return r.id == view_id;
        });

        if (!route) {
          return "continue";
        }

        if (!_this6.models[route.model]) {
          return "continue";
        }

        prms.push(_this6.models[route.model].getUpdatedRecords(ids));
      };

      for (var view_id in ids_by_view) {
        var _ret = _loop(view_id);

        if (_ret === "continue") continue;
      }

      return Promise.resolve(Promise.all(prms));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return Pool;
}();
var Model = /*#__PURE__*/function () {
  function Model(pool, name, master_view_id) {
    this.db = false;
    this.pool = pool;
    this.name = name;
    this.master_view = master_view_id;
    this.local_db = this.pool.db.local_db;
  }

  var _proto2 = Model.prototype;

  _proto2.create_selector = function create_selector(pair, view) {
    if (view === void 0) {
      view = false;
    }

    try {
      var _this8 = this;

      var selector = {};
      var expr = {};
      var operators = {
        '=': '$eq',
        'in': '$in'
      };

      if (!view) {
        view = _this8.master_view;
      }

      return Promise.resolve(_this8.pool.db.fields_handler.getFieldType(pair[0], view)).then(function (field_type) {
        var value = castValue(field_type, pair[2], pair[1]);
        expr[operators[pair[1]]] = value;
        selector[pair[0]] = expr;
        return selector;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto2.domain_to_selector = function domain_to_selector(domain, view) {
    if (view === void 0) {
      view = false;
    }

    try {
      var _this10 = this;

      var selector = {};
      var prms = domain.map(function (pair) {
        return this.create_selector(pair, view);
      }.bind(_this10));
      return Promise.resolve(Promise.all(prms)).then(function (selectors) {
        selectors.forEach(function (sel) {
          selector = _extends({}, sel, selector);
        });
        return selector;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto2.eval_domain = function eval_domain(values, domain) {
    values = domain_to_object(values);
    return parse_domain(values, domain);
  };

  _proto2.eval_data_domain = function eval_data_domain(args) {
    try {
      var _temp3 = function _temp3() {
        if (args.search && args.search.length) {
          search_domain = args.search;
        }

        return [].concat(action_domain, search_domain);
      };

      var _this12 = this;

      var action_domain = [];
      var search_domain = [];

      var _temp4 = function () {
        if (args.action_id) {
          var action_doc_id = ('actions:' + args.action_id).toString();
          return Promise.resolve(_this12.pool.db.getDocument(action_doc_id)).then(function (action) {
            if (action.target_view_domain) {
              var target_view_domain = action.target_view_domain.replace(/"/g, "").replace(/'/g, "");
              action_domain = _this12.eval_domain(args.action_params, target_view_domain);
            }
          });
        }
      }();

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto2.search = function search(_ref) {
    var search_selector = _ref.search_selector,
        domain = _ref.domain,
        fnames = _ref.fnames;

    try {
      var _temp7 = function _temp7() {
        return Promise.resolve(_this14.pool.db.executeQuery({
          selector: selector,
          fields: fnames
        }));
      };

      var _this14 = this;

      var selector = {
        model_: {
          $eq: _this14.name
        }
      };

      if (search_selector) {
        selector = _extends({}, search_selector, selector);
      }

      var _temp8 = function () {
        if (domain) {
          return Promise.resolve(_this14.domain_to_selector(_this14.eval_domain(domain.values, domain.expr))).then(function (domain_selector) {
            selector = _extends({}, domain_selector, selector);
          });
        }
      }();

      return Promise.resolve(_temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto2.read = function read() {
    return Promise.resolve();
  };

  _proto2.write = function write() {
    return Promise.resolve();
  };

  _proto2.get_record_id = function get_record_id(id) {
    return this.name + ':' + id;
  };

  _proto2.save = function save(args) {
    try {
      var _this16 = this;

      var res = {};
      var values = args.values;
      var pending_transaction = args.pending_transaction;
      var prms = [];

      for (var rec in values) {
        var doc_id = _this16.get_record_id(values[rec].id);

        values[rec]['no_sync_'] = true;
        values[rec]['model_'] = args.model;
        prms.push(_this16.pool.db.composeDocument(doc_id, values[rec]));
      }

      return Promise.resolve(Promise.all(prms)).then(function (new_docs) {
        if (pending_transaction) {
          new_docs.forEach(function (doc) {
            if (!doc._rev) {
              doc["origin_transaction"] = pending_transaction.id;
            }

            if (doc.related_transactions) {
              doc.related_transactions.push(pending_transaction.id);
            } else {
              doc.related_transactions = [pending_transaction.id];
            }
          });
        }

        return Promise.resolve(_this16.local_db.bulkDocs(new_docs)).then(function (new_records) {
          return Promise.resolve(Promise.all(new_records.map(function (rec) {
            return this.pool.db.getDocument(rec.id);
          }.bind(_this16)))).then(function (new_values) {
            new_values.forEach(function (doc) {
              res[doc.id] = doc;
            });
            return res;
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto2.get_data = function get_data(args) {
    try {
      var _this18 = this;

      var view = args.view_id;
      return Promise.resolve(_this18.eval_data_domain(args)).then(function (domain) {
        return Promise.resolve(_this18.domain_to_selector(domain, view)).then(function (search_selector) {
          return Promise.resolve(_this18.search({
            search_selector: search_selector
          })).then(function (data) {
            return args.count ? data['docs'].length : data.docs;
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto2.bulk_write = function bulk_write(data) {
    try {
      var _this20 = this;

      var prms = data.map(function (rec) {
        var id = this.name + ':' + rec.id.toString();
        rec['no_sync_'] = true;
        rec['model_'] = this.name;
        return this.pool.db.composeDocument(id, rec);
      }.bind(_this20));
      return Promise.resolve(Promise.all(prms)).then(function (docs) {
        return Promise.resolve(_this20.local_db.bulkDocs(docs)).then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto2.loadRecords = function loadRecords() {
    try {
      var _this22 = this;

      var args = {
        view_id: _this22.master_view,
        search: [],
        order: [],
        model: _this22.name,
        offset: 0
      };
      var abortController = new AbortController();
      return Promise.resolve(_this22.pool.connection.dispatch('GET', '/data/get', args, false, false, false, abortController)).then(function (data) {
        return Promise.resolve(_this22.bulk_write(data)).then(function () {
          return _this22.name;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto2.getUpdatedRecords = function getUpdatedRecords(ids) {
    try {
      var _this24 = this;

      var search = [['id', 'in', ids]];
      var args = {
        'view_id': _this24.master_view,
        'model': _this24.name,
        'search': search
      };
      var abortController = new AbortController();
      return Promise.resolve(_this24.pool.connection.dispatch('GET', '/data/get', args, false, false, false, abortController)).then(function (data) {
        _this24.bulk_write(data);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return Model;
}();

var FieldsHandler = /*#__PURE__*/function () {
  function FieldsHandler(db, connection) {
    this.db = db;
    this.connection = connection;
  }

  var _proto = FieldsHandler.prototype;

  _proto.getFieldById = function getFieldById(id) {
    try {
      var _this2 = this;

      return Promise.resolve(_this2.db.getDocument('fields:' + id));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getExtraViews = function getExtraViews(view_definition, args) {
    try {
      var _temp3 = function _temp3(_result) {
        return _exit2 ? _result : [];
      };

      var _exit2 = false;

      var _this4 = this;

      var pivot_values = args['pivot_values'];

      var _temp4 = function () {
        if (!Object.keys(pivot_values).length) {
          return Promise.resolve(_this4.db.pool.dispatch(args.model, 'get_data', args.search)).then(function (active_record) {
            if (active_record && active_record.length) {
              var template_view_ids = active_record[0][view_definition.extended_models_fname];
              _exit2 = true;
              return template_view_ids;
            }
          });
        }
      }();

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getFields = function getFields(args) {
    try {
      var _this6 = this;

      var view_id = args['view_id'];
      var pivot_values = args['pivot_values'];
      var extra_views = false;
      return Promise.resolve(_this6.db.local_db.get('views:' + view_id)).then(function (view_definition) {
        function _temp8() {
          var _exit3 = false;

          function _temp6(_result2) {
            return _exit3 ? _result2 : Promise.resolve(_this6.db.local_db.query('fields/by_view', {
              startkey: [view_id],
              endkey: [view_id, {}]
            })).then(function (view_fields) {
              return Promise.resolve(Promise.all(view_fields.rows.map(function (field) {
                return this.db.getDocument(field.id);
              }.bind(_this6))));
            });
          }

          var _temp5 = function () {
            if (extra_views && extra_views.length) {
              var fields_id = 'multi_model_fields:' + view_id.toString() + '_' + extra_views.join('_');
              return Promise.resolve(_this6.db.getDocument(fields_id)).then(function (fields) {
                if (fields) {
                  var _fields$fields2 = fields.fields;
                  _exit3 = true;
                  return _fields$fields2;
                }
              });
            }
          }();

          return _temp5 && _temp5.then ? _temp5.then(_temp6) : _temp6(_temp5);
        }

        var _temp7 = function () {
          if (view_definition.multi_model_view) {
            return Promise.resolve(_this6.getExtraViews(view_definition, args)).then(function (_this5$getExtraViews) {
              extra_views = _this5$getExtraViews;
            });
          }
        }();

        return _temp7 && _temp7.then ? _temp7.then(_temp8) : _temp8(_temp7);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getFieldType = function getFieldType(fname, view) {
    if (view === void 0) {
      view = false;
    }

    try {
      var _this8 = this;

      if (!view) {
        view = _this8.master_view;
      }

      return Promise.resolve(_this8.db.local_db.query('fields/field_by_name', {
        key: [view, fname]
      })).then(function (view_field) {
        var type = view_field.rows.length ? view_field.rows[0].value : false;
        return type;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getFieldOptions = function getFieldOptions(args) {
    try {
      var _this10 = this;

      var options = [];
      return Promise.resolve(_this10.getFieldById(args.id)).then(function (field) {
        var target_model = field.target_model;

        var _temp9 = function () {
          if (target_model) {
            var domain_str = field.domain;
            var search = args.search;
            var domain = false;

            if (domain_str) {
              domain = {
                values: search ? search : [],
                expr: domain_str ? domain_str : ""
              };
            }

            var fnames = ['id', 'rec_name'];

            if (field.read_fields) {
              fnames = [].concat(fnames, field.read_fields.split(','));
            }

            return Promise.resolve(_this10.db.pool.dispatch(target_model, 'search', {
              domain: domain,
              fnames: fnames
            })).then(function (data) {
              options = data.docs;
            });
          }
        }();

        return _temp9 && _temp9.then ? _temp9.then(function () {
          return options;
        }) : options;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return FieldsHandler;
}();

var Database = /*#__PURE__*/function () {
  function Database(connection, config, load_db_handler) {
    if (load_db_handler === void 0) {
      load_db_handler = false;
    }

    this.remote_db_name = "";
    this.local_db_name = "";
    this.remote_url = "";
    this.local_db = false;
    this.remote_db = false;
    this.connection = false;
    this.token = "";
    this.connection = connection;
    this.token = config.token;
    this.remote_db_name = config.database_name;
    this.local_db_name = 'local_'.concat(this.remote_db_name);
    this.remote_url = this.connection.getBasePath() + '/' + this.remote_db_name;
    this.pool = new Pool(this, connection);
    this.fields_handler = new FieldsHandler(this, connection);
    this.allowed_log_values = ['struct_last_sync', 'transaction_last_sync', 'records_last_sync', 'full_synced'];
    this.status = {
      'structure': false,
      'transactions': false,
      'records': false
    };
    makeAutoObservable(this, {
      status: observable,
      setStatus: action
    });

    if (load_db_handler) {
      this.db_handler = load_db_handler();
      this.db_adapter = 'react-native-sqlite';
    } else {
      this.db_handler = PouchDB;
    }

    this.db_handler.plugin(PouchDBFind);
    this.path_getters = {
      '/app/v1/view/fields': function (args, pending_transaction) {
        try {
          var _this2 = this;

          return Promise.resolve(_this2.fields_handler.getFields(args));
        } catch (e) {
          return Promise.reject(e);
        }
      }.bind(this),
      '/app/v1/field/field_options': function (args, pending_transaction) {
        try {
          var _this4 = this;

          return Promise.resolve(_this4.fields_handler.getFieldOptions(args));
        } catch (e) {
          return Promise.reject(e);
        }
      }.bind(this),
      '/app/v1/view/actions': function (args, pending_transaction) {
        try {
          var _this6 = this;

          return Promise.resolve(_this6.getActions(args));
        } catch (e) {
          return Promise.reject(e);
        }
      }.bind(this),
      '/app/v1/data/get': function (args, pending_transaction) {
        try {
          var _this8 = this;

          return Promise.resolve(_this8.pool.dispatch(args.model, "get_data", args));
        } catch (e) {
          return Promise.reject(e);
        }
      }.bind(this),
      '/app/v1/user/context': function (args, pending_transaction) {
        try {
          var _this10 = this;

          return Promise.resolve(_this10.getUserContext());
        } catch (e) {
          return Promise.reject(e);
        }
      }.bind(this),
      '/app/v1/user/menu': function (args, pending_transaction) {
        try {
          var _this12 = this;

          return Promise.resolve(_this12.getRoutes());
        } catch (e) {
          return Promise.reject(e);
        }
      }.bind(this),
      '/app/v1/theme/host_theme': function (args, pending_transaction) {
        try {
          var _this14 = this;

          return Promise.resolve(_this14.getTheme());
        } catch (e) {
          return Promise.reject(e);
        }
      }.bind(this),
      '/app/v1/data/save': function (args, pending_transaction) {
        try {
          var _this16 = this;

          return Promise.resolve(_this16.pool.dispatch(args.model, "save", _extends({}, args, {
            pending_transaction: pending_transaction
          })));
        } catch (e) {
          return Promise.reject(e);
        }
      }.bind(this),
      '/app/v1/view/default_values': function (args, pending_transaction) {
        return Promise.resolve([{}]);
      }.bind(this),
      '/app/v1/view_handler/editor_definitions': function (args, pending_transaction) {
        return Promise.resolve({});
      }.bind(this),
      '/app/v1/view_handler/view_wizards': function (args, pending_transaction) {
        return Promise.resolve([]);
      }.bind(this),
      '/app/v1/theme_logo': function (args, pending_transaction) {
        return Promise.resolve(false);
      }.bind(this)
    };
  }

  var _proto = Database.prototype;

  _proto.initialize = function initialize() {
    try {
      var _this18 = this;

      return Promise.resolve(_this18.create_local_db()).then(function () {
        return Promise.resolve(_this18.create_remote_db()).then(function () {
          return Promise.resolve(_this18.start_live_sync()).then(function () {});
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.initialize_pool = function initialize_pool() {
    try {
      var _this20 = this;

      _this20.pool.initialize(_this20.connection.offline_models);

      return Promise.resolve(_this20.populateModels()).then(function () {
        return new Date();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.populateModels = function populateModels() {
    try {
      var _this22 = this;

      return Promise.resolve(_this22.connection.checkConnection()).then(function (conn_status) {
        var _temp2 = function () {
          if (conn_status) {
            _this22.setStatus({
              'records': 'syncing'
            });

            return Promise.resolve(_this22.pool.populateModels()).then(function () {
              _this22.setStatus({
                'records': 'synced'
              });

              return Promise.resolve(_this22.registerSyncDate('records_last_sync')).then(function () {
                var _temp = function () {
                  if (!_this22.is_sync_active) {
                    return Promise.resolve(_this22.registerSyncDate('full_synced')).then(function () {});
                  }
                }();

                if (_temp && _temp.then) return _temp.then(function () {});
              });
            });
          }
        }();

        if (_temp2 && _temp2.then) return _temp2.then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.resync = function resync() {
    try {
      var _this24 = this;

      return Promise.resolve(_this24.start_structure_sync(false, false)).then(function () {
        return Promise.resolve(_this24.start_transactions_sync(false, false)).then(function () {
          return Promise.resolve(_this24.initialize_pool()).then(function () {
            return Promise.resolve(_this24.getLastSync());
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getLastSync = function getLastSync() {
    try {
      var _this26 = this;

      return Promise.resolve(_this26.getDocument('log:full_synced')).then(function (last_sync) {
        return last_sync.full_synced;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.registerLog = function registerLog(key, values) {
    try {
      var _this28 = this;

      var doc_id = 'log:' + key;
      var invalid_values = Object.keys(values).some(function (item) {
        return _this28.allowed_log_values.includes(item) === false;
      });

      if (invalid_values) {
        throw new Error('You are trying to register a wrong value on the DB LOG');
      }

      return Promise.resolve(_this28.composeDocument(doc_id, values, true)).then(function (log_doc) {
        return Promise.resolve(_this28.local_db.put(log_doc));
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.registerSyncDate = function registerSyncDate(key) {
    try {
      var _this30 = this;

      var new_values = {};
      new_values[key] = new Date().toString();
      return Promise.resolve(_this30.registerLog(key, new_values));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setStatus = function setStatus(new_status) {
    this.status = _extends({}, this.status, new_status);
  };

  _proto.create_local_db = function create_local_db() {
    try {
      var _this32 = this;

      if (_this32.db_adapter) {
        _this32.local_db = new _this32.db_handler(_this32.local_db_name, {
          adapter: _this32.db_adapter
        });
      } else {
        _this32.local_db = new _this32.db_handler(_this32.local_db_name);
      }

      return Promise.resolve(_this32.local_db.info()).then(function (db_info) {
        return _this32.local_db;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.create_remote_db = function create_remote_db() {
    try {
      var _temp5 = function _temp5(_result) {
        return _exit2 ? _result : _this34.remote_db;
      };

      var _exit2 = false;

      var _this34 = this;

      var headers = _this34.connection.getHeaders();

      _this34.remote_db = new _this34.db_handler(_this34.remote_url, {
        fetch: function (url, opts) {
          for (var key in headers) {
            opts.headers.set(key, headers[key]);
          }

          opts.headers.set('X-Auth-CouchDB-Token', this.token);
          return PouchDB.fetch(url, opts);
        }.bind(_this34)
      });

      var _temp6 = _catch(function () {
        return Promise.resolve(_this34.remote_db.info()).then(function () {});
      }, function () {
        var _this33$remote_db = _this34.remote_db;
        _exit2 = true;
        return _this33$remote_db;
      });

      return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(_temp5) : _temp5(_temp6));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.start_structure_sync = function start_structure_sync(live, retry) {
    if (live === void 0) {
      live = true;
    }

    if (retry === void 0) {
      retry = true;
    }

    try {
      var _this36 = this;

      var struct_opts = {
        live: live,
        retry: retry,
        filter: 'structure/get',
        query_params: {
          'role_id': _this36.connection.user_context.role
        }
      };
      return Promise.resolve(_this36.local_db.replicate.from(_this36.remote_db, struct_opts).on('change', function (info) {
        this.setStatus({
          'structure': 'syncing'
        });
      }.bind(_this36)).on('active', function (info) {}).on('paused', function (err) {
        try {
          var _this38 = this;

          if (live) {
            _this38.setStatus({
              'structure': 'synced'
            });
          }

          return Promise.resolve();
        } catch (e) {
          return Promise.reject(e);
        }
      }.bind(_this36)).on('complete', function (err) {
        try {
          var _this40 = this;

          _this40.setStatus({
            'structure': 'synced'
          });

          return Promise.resolve();
        } catch (e) {
          return Promise.reject(e);
        }
      }.bind(_this36)).on('error', function (err) {}));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.start_transactions_sync = function start_transactions_sync(live, retry) {
    if (live === void 0) {
      live = true;
    }

    if (retry === void 0) {
      retry = true;
    }

    try {
      var _this42 = this;

      var transaction_opts = {
        live: live,
        retry: retry,
        filter: 'pending_transactions_filter/by_user',
        query_params: {
          'user': _this42.connection.user_context.id
        }
      };
      return Promise.resolve(_this42.local_db.sync(_this42.remote_db, transaction_opts).on('change', function (info) {
        if (info.direction == 'pull') {
          this.setStatus({
            'transactions': 'syncing'
          });
          this.getDoneTransactions();
        }
      }.bind(_this42)).on('paused', function (err) {
        try {
          var _this44 = this;

          if (live) {
            _this44.setStatus({
              'transactions': 'synced'
            });
          }

          return Promise.resolve();
        } catch (e) {
          return Promise.reject(e);
        }
      }.bind(_this42)).on('complete', function () {
        try {
          var _this46 = this;

          _this46.setStatus({
            'transactions': 'synced'
          });

          return Promise.resolve();
        } catch (e) {
          return Promise.reject(e);
        }
      }.bind(_this42)).on('error', function (err) {}));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.start_live_sync = function start_live_sync() {
    try {
      var _this48 = this;

      var struct_opts = {
        live: false,
        retry: false,
        filter: 'structure/get',
        query_params: {
          'role_id': _this48.connection.user_context.role
        }
      };

      _this48.local_db.replicate.from(_this48.remote_db, struct_opts).on('complete', function (info) {
        this.start_structure_sync();
        this.start_transactions_sync();
      }.bind(_this48)).on('error', function (err) {
        this.start_structure_sync();
        this.start_transactions_sync();
      }.bind(_this48));

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getPath = function getPath(path) {
    if (path.startsWith('http')) {
      path = path.replace(this.connection.base_path, "");
    }

    return path;
  };

  _proto.getDocument = function getDocument(id) {
    try {
      var _exit4 = false;

      var _this50 = this;

      var doc = {};

      var _temp8 = _catch(function () {
        return Promise.resolve(_this50.local_db.get(id)).then(function (_this49$local_db$get) {
          doc = _this49$local_db$get;
        });
      }, function (err) {
        if (err.name === 'not_found') {
          doc = {};
        } else {
          throw err;
        }
      });

      return Promise.resolve(_temp8 && _temp8.then ? _temp8.then(function (_result2) {
        return _exit4 ? _result2 : doc;
      }) : _exit4 ? _temp8 : doc);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.composeDocument = function composeDocument(id, values, no_sync) {
    if (no_sync === void 0) {
      no_sync = false;
    }

    try {
      var _this52 = this;

      return Promise.resolve(_this52.getDocument(id)).then(function (doc) {
        if (!doc['_id']) {
          doc['_id'] = id;
        }

        if (no_sync) {
          doc['no_sync_'] = true;
        }

        doc = _extends({}, doc, values);
        return doc;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getActions = function getActions(args) {
    try {
      var _this54 = this;

      var view_id = args['view_id'];
      return Promise.resolve(_this54.local_db.query('actions/by_view', {
        key: view_id
      })).then(function (view_actions) {
        return Promise.resolve(Promise.all(view_actions.rows.map(function (action) {
          return this.getDocument(action.id);
        }.bind(_this54))));
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.executeQuery = function executeQuery(options) {
    try {
      var _this56 = this;

      return Promise.resolve(_this56.local_db.find(options));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.get_record_id = function get_record_id(model, id) {
    return model + ':' + id;
  };

  _proto.registerPendingTransaction = function registerPendingTransaction(_ref) {
    var type = _ref.type,
        path = _ref.path,
        args = _ref.args,
        headers = _ref.headers;

    try {
      var _temp12 = function _temp12() {
        var values = {
          '_id': 'pending_transactions:' + v4(),
          'status': 'new',
          'user': _this58.connection.user_context.id,
          'created_at': new Date().toUTCString(),
          'doc_type': 'pending_transaction',
          headers: headers,
          type: type,
          path: path,
          args: args,
          dependencies: dependencies
        };
        return Promise.resolve(_this58.local_db.put(values));
      };

      var _this58 = this;

      var transaction_values = args.values;
      var dependencies = {};

      var _temp13 = _forIn(transaction_values, function (rec) {
        var rec_id = transaction_values[rec].id;

        var _temp9 = function () {
          if (rec_id < 0) {
            var doc_id = _this58.get_record_id(args.model, rec_id);

            return Promise.resolve(_this58.getDocument(doc_id)).then(function (current_document) {
              if (current_document.origin_transaction) {
                dependencies[rec_id] = current_document.origin_transaction;
              }
            });
          }
        }();

        if (_temp9 && _temp9.then) return _temp9.then(function () {});
      });

      return Promise.resolve(_temp13 && _temp13.then ? _temp13.then(_temp12) : _temp12(_temp13));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getUserContextId = function getUserContextId() {
    return 'user:context';
  };

  _proto.setUserContext = function setUserContext(user_context) {
    try {
      var _this60 = this;

      var id = _this60.getUserContextId();

      return Promise.resolve(_this60.composeDocument(id, user_context, true)).then(function (doc) {
        return Promise.resolve(_this60.local_db.put(doc));
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getUserContext = function getUserContext() {
    try {
      var _this62 = this;

      return Promise.resolve(_this62.getDocument(_this62.getUserContextId()));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getRoutes = function getRoutes() {
    try {
      var _this64 = this;

      var id = 'roles:' + _this64.connection.user_context.role;
      return Promise.resolve(_this64.getDocument(id));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getTheme = function getTheme() {
    try {
      var _this66 = this;

      var selector = {
        selector: {
          type: {
            $eq: "theme"
          },
          is_default: {
            $eq: true
          }
        }
      };
      var theme = {};
      return Promise.resolve(_this66.executeQuery(selector)).then(function (theme_query) {
        if (theme_query.docs.length) {
          theme = theme_query.docs[0];
        }

        return theme;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.countNewTransactions = function countNewTransactions() {
    try {
      var _this68 = this;

      return Promise.resolve(_this68.local_db.query('pending_transactions/new')).then(function (new_transactions) {
        return new_transactions.total_rows;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getRelatedRecords = function getRelatedRecords(transaction_ids) {
    try {
      var _this70 = this;

      var map = function map(doc, emit) {
        var included = function included(currentValue) {
          return transaction_ids.includes(currentValue);
        };

        if (!doc.related_transactions || !doc.related_transactions.length) {
          return;
        }

        if (doc.related_transactions.every(included)) {
          emit(doc.id, {
            '_id': doc._id,
            '_rev': doc._rev
          });
        }
      };

      return Promise.resolve(_this70.local_db.query({
        'map': map
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getDoneTransactions = function getDoneTransactions() {
    try {
      var _this72 = this;

      return Promise.resolve(_this72.local_db.query('pending_transactions/done_ids')).then(function (done_transactions) {
        var records_to_reload = {};
        var records_to_delete = [];

        if (done_transactions.total_rows === 0) {
          return;
        }

        var transaction_ids = done_transactions.rows.map(function (transaction) {
          var update_records = transaction.value.update_records;

          if (update_records) {
            var view_id = update_records.view;

            if (records_to_reload[view_id]) {
              records_to_reload[view_id] = [].concat(records_to_reload[view_id], update_records.ids);
            } else {
              records_to_reload[view_id] = update_records.ids;
            }
          }

          return transaction.id;
        });
        return Promise.resolve(_this72.getRelatedRecords(transaction_ids)).then(function (related_records) {
          records_to_delete = related_records.rows.map(function (rec) {
            return rec.value;
          });
          var delete_prms = records_to_delete.map(function (doc) {
            return this.local_db.remove(doc);
          }.bind(_this72));
          return Promise.resolve(Promise.all(delete_prms)).then(function (deleted) {
            _this72.pool.getUpdatedRecords(records_to_reload);

            return Promise.resolve(_this72.getRelatedRecords(transaction_ids)).then(function (pending_records) {
              if (pending_records.total_rows === 0) {
                var deleted_transactions = done_transactions.rows.map(function (transaction) {
                  transaction.value['_deleted'] = true;
                  return transaction.value;
                });

                _this72.local_db.bulkDocs(deleted_transactions);
              }
            });
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.dispatch = function dispatch(_ref2) {
    var type = _ref2.type,
        path = _ref2.path,
        args = _ref2.args,
        headers = _ref2.headers,
        _ref2$pending_transac = _ref2.pending_transaction,
        pending_transaction = _ref2$pending_transac === void 0 ? true : _ref2$pending_transac;

    try {
      var _this74 = this;

      path = _this74.getPath(path);

      var original_args = _extends({}, args);

      if (_this74.path_getters[path]) {
        var res = [];

        var _temp15 = function () {
          if (type === 'POST' && pending_transaction) {
            return Promise.resolve(_this74.registerPendingTransaction({
              type: type,
              path: path,
              args: args,
              headers: headers
            })).then(function (new_transaction) {
              return Promise.resolve(_this74.path_getters[path](original_args, new_transaction)).then(function (_this73$path_getters$) {
                res = _this73$path_getters$;
              });
            });
          } else {
            return Promise.resolve(_this74.path_getters[path](original_args, pending_transaction)).then(function (_this73$path_getters$2) {
              res = _this73$path_getters$2;
            });
          }
        }();

        return Promise.resolve(_temp15 && _temp15.then ? _temp15.then(function () {
          return res;
        }) : res);
      } else {
        return Promise.resolve();
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.mirrorAction = function mirrorAction(_ref3) {
    var type = _ref3.type,
        path = _ref3.path,
        original_args = _ref3.original_args,
        res = _ref3.res;

    try {
      var _this76 = this;

      original_args.values = res;
      return Promise.resolve(_this76.dispatch({
        type: type,
        path: path,
        args: original_args,
        pending_transaction: false
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _createClass(Database, [{
    key: "is_sync_active",
    get: function get() {
      return [this.status.structure, this.status.transactions, this.status.records].some(function (item) {
        return item === 'syncing';
      });
    }
  }]);

  return Database;
}();

var UserContext = /*#__PURE__*/function () {
  function UserContext(connection, values) {
    this.screen = "";
    this.connection = "";
    this.base_values = {};
    this.initialized = false;
    this.appbar_expression = "";
    this.view_editor = false;
    makeObservable(this, {
      setScreen: action,
      screen: observable,
      initialized: observable
    });
    this.connection = connection;
    this.base_values = values;
    this.getUserContextView();
    this.appbar_expression = "";
    this.view_editor = values.view_editor;
  }

  var _proto = UserContext.prototype;

  _proto.setValues = function setValues(values) {
    console.log("NOT SETTING THE VALUES YET...");
    console.log(values);
  };

  _proto.get_all_values = function get_all_values() {
    var record = this.screen.active_record;
    var values = {};
    this.screen.fields.forEach(function (field) {
      if (field.has_value(record)) {
        values[field.name] = record.get_value(field.name);
      }
    });
    return values;
  };

  _proto.get_field = function get_field(fname) {
    return this.screen.get_field_by_name(fname);
  };

  _proto.get_value = function get_value(fname) {
    var field = this.get_field(fname);
    return field.get_value(this.screen.active_record);
  };

  _proto.get_string_value = function get_string_value(fname) {
    var field = this.get_field(fname);

    if (!field) {
      return "";
    }

    return field.get_string_value(this.screen.active_record);
  };

  _proto.onRecordUpdate = function onRecordUpdate(record) {
    console.log("RUNNING CALLBACK");

    if (this.connection.main_screen_group && this.connection.main_screen_group.active_screen) {
      this.connection.main_screen_group.active_screen.do_search();
    }
  };

  _proto.createScreen = function createScreen(definition) {
    var _this = this;

    var group = new ScreenGroup(this.connection, true);
    var screen = group.addScreen(definition.view, false, [], {}, true, false, false, false, false, false, false, false, function (record) {
      return _this.onRecordUpdate(record);
    });
    screen.createFields(definition.fields);
    screen.createActions(definition.actions);
    screen.loadingFields = false;
    return screen;
  };

  _proto.setScreen = function setScreen(definition) {
    var _this2 = this;

    var screen = this.createScreen(definition);
    var record = screen.data.addRecord({
      values: this.base_values
    });
    screen.set_active_record(record);
    screen.data.loadingInitialData = false;
    screen.data.loading = false;
    screen.set_actions_map({
      'logout': function logout() {
        _this2.connection.logout();
      }
    });
    this.screen = screen;
    this.initialized = true;
  };

  _proto.getUserContextView = function getUserContextView() {
    try {
      var _this4 = this;

      var abortController = new AbortController();
      return Promise.resolve(_this4.connection.dispatch('GET', '/user/context_view', {}, false, true, false, abortController)).then(function (view_info) {
        if (!view_info) {
          return;
        }

        if (view_info) {
          _this4.setScreen(view_info.view);

          _this4.appbar_expression = view_info.appbar_info;
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _createClass(UserContext, [{
    key: "appbar_data",
    get: function get() {
      if (this.screen && this.screen.active_record) {
        return evalExpr(this.screen.active_record.get_all_values(), this.appbar_expression).str;
      }

      return "";
    }
  }]);

  return UserContext;
}();

var Connection = /*#__PURE__*/function () {
  function Connection(notifications, external_handler, load_db_adapter) {
    if (load_db_adapter === void 0) {
      load_db_adapter = false;
    }

    this.status = false;
    this.token = "";
    this.base_path = "";
    this.api_path = "";
    this.cache = {};
    this.routes = [];
    this.menu_tree = [];
    this.user_context = false;
    this.editor_config = {};
    this.router = {
      'routes': [],
      'navigate': false
    };
    this.superset = {};
    this.offline_mode = false;
    this.main_screen_group = false;
    makeAutoObservable(this, {
      loadRoutes: action,
      setRouter: action,
      setEditorConfig: action,
      visible_routes: computed,
      routes: observable,
      menu_tree: observable,
      editor_config: observable,
      api_path: observable,
      base_path: observable,
      setApiPath: action,
      setSessionStatus: action,
      status: observable,
      initialize: action,
      user_context: observable,
      offline_mode: observable,
      setOfflineMode: action,
      setUserContext: action,
      setSession: action,
      main_screen_group: observable,
      setMainScreenGroup: action,
      status_getter: observable,
      set_status_getter: action
    });
    this.initialize(notifications, external_handler, load_db_adapter).then(function (session) {});
  }

  var _proto = Connection.prototype;

  _proto.initialize = function initialize(notifications, external_handler, load_db_adapter) {
    if (external_handler === void 0) {
      external_handler = false;
    }

    if (load_db_adapter === void 0) {
      load_db_adapter = false;
    }

    try {
      var _this2 = this;

      _this2.external_handler = external_handler;
      _this2.config = Config(external_handler);
      _this2.status = undefined;
      _this2.token = "";
      _this2.api_path = _this2.config.api_path ? _this2.config.api_path : false;
      _this2.auth_proxy = _this2.config.auth_proxy ? _this2.config.auth_proxy : false;
      _this2.routes = [];
      _this2.router = {
        'routes': [],
        'navigate': false
      };
      _this2.cache = new Cache();
      _this2.storage = createStorage();
      _this2.notifications = notifications;
      _this2.db_adapter = load_db_adapter;
      _this2.user_context = false;

      _this2.setStatusGetter(function () {
        try {
          return Promise.resolve(navigator.onLine);
        } catch (e) {
          return Promise.reject(e);
        }
      });

      _this2.checkConnection();

      return Promise.resolve(_this2.getSessionFromStorage());
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setOfflineMode = function setOfflineMode(status) {
    this.offline_mode = status;
  };

  _proto.setStatusGetter = function setStatusGetter(getter) {
    this.status_getter = getter;
  };

  _proto.offlineAvailable = function offlineAvailable(view_id) {
    return this.routes.find(function (route) {
      return route.id === view_id;
    }).offline_available;
  };

  _proto.reSync = function reSync() {
    this.db_handler.resync();
  };

  _proto.setMainScreenGroup = function setMainScreenGroup(group) {
    this.main_screen_group = group;
  };

  _proto.checkConnection = function checkConnection() {
    try {
      var _this4 = this;

      return Promise.resolve(_this4.status_getter()).then(function (status) {
        if (status === false) {
          _this4.setOfflineMode(true);
        } else {
          _this4.setOfflineMode(false);
        }

        return status;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getSessionFromStorage = function getSessionFromStorage() {
    try {
      var _this6 = this;

      return Promise.resolve(_this6.storage.getItem('kalenis_session')).then(function (session_info) {
        if (session_info) {
          _this6.setSession(JSON.parse(session_info));
        } else {
          _this6.setSessionStatus(false);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.saveSessionToStorage = function saveSessionToStorage(session) {
    try {
      var _this8 = this;

      return Promise.resolve(_this8.storage.getItem('kalenis_session')).then(function (stored_session) {
        var _temp = function () {
          if (!stored_session) {
            return Promise.resolve(_this8.storage.setItem('kalenis_session', JSON.stringify(session))).then(function () {});
          }
        }();

        if (_temp && _temp.then) return _temp.then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setSessionStatus = function setSessionStatus(value) {
    this.status = value;
  };

  _proto.getBasePath = function getBasePath() {
    if (environment() === 'web') {
      return window.location.origin;
    } else {
      return this.base_path;
    }
  };

  _proto.getFullPath = function getFullPath(path) {
    if (environment() === 'web') {
      return window.location.origin + this.getPath(path);
    } else {
      return this.getPath(path);
    }
  };

  _proto.getPath = function getPath(path) {
    if (!this.api_path) {
      return false;
    }

    return this.api_path.concat(path);
  };

  _proto.getRouteById = function getRouteById(id) {
    return this.router.routes.find(function (route) {
      return route.id === id;
    });
  };

  _proto.setRouter = function setRouter(router) {
    this.router = router;
  };

  _proto.createUrl = function createUrl(params) {
    var query = "?";
    Object.keys(params).map(function (field) {
      if (field === "search") {
        var current_search = params[field];
        current_search.forEach(function (domain) {
          var field = domain[0];
          var operator = domain[1];
          var value = domain[2];

          if (value !== "" && value !== undefined) {
            if (operator) {
              if (Array.isArray(value)) {
                value = value.toString();
                value = '['.concat(value).concat(']');
              }
            }

            value = operator.concat(";").concat(value);
          }

          query = query.concat(field).concat('=').concat(value).concat('&');
        });
      } else if (field === 'action_params') {
        var action_params = params[field];

        if (action_params.length) {
          query = query.concat('_ap=');
          action_params.forEach(function (domain) {
            var field = domain[0];
            var operator = domain[1];
            var value = domain[2];

            if (value !== "" && value !== undefined) {
              if (operator) {
                if (Array.isArray(value)) {
                  value = value.toString();
                  value = '['.concat(value).concat(']');
                }
              }

              value = operator.concat(";").concat(value);
            }

            query = query.concat(field).concat(';').concat(value).concat('&');
          });
        }
      } else if (field === "order") {
        if (params[field].length) {
          query = query.concat('_order').concat("=").concat(params[field].toString()).concat('&');
        }
      } else if (field === "action_id") {
        if (params[field]) {
          query = query.concat('_action_id').concat("=").concat(params[field]).concat('&');
        }
      }
    });
    return query;
  };

  _proto.getHeaders = function getHeaders() {
    var headers;

    if (this.status && this.token) {
      headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.token,
        'pragma': 'no-cache',
        'cache-control': 'no-cache'
      };
    } else {
      headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };
    }

    return headers;
  };

  _proto.createQuery = function createQuery(params) {
    var search = "?";
    Object.keys(params).map(function (field) {
      if (params[field] !== "" && params[field] !== undefined) {
        var field_value = params[field];

        if (field_value instanceof Array) {
          field_value = JSON.stringify(field_value);
          field_value = field_value.replaceAll('null', 'None');
        } else if (field_value instanceof Object) {
          field_value = JSON.stringify(field_value);
          field_value = field_value.replaceAll('null', 'None');
        } else if (field_value == 'null' || field_value == null) {
          field_value = 'None';
        }

        search = search.concat(field).concat('=').concat(field_value).concat('&');
      }
    });
    return search;
  };

  _proto.handleNativeBlobResponse = function handleNativeBlobResponse(response) {
    try {
      res = {};
      res['mimetype'] = response.headers.get('content-type');
      return Promise.resolve(response.blob()).then(function (_response$blob) {
        res['data'] = _response$blob;
        return res;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.Post = function Post(body, path, headers, raw_response) {
    try {
      var _temp9 = function _temp9(_result) {
        var _exit2 = false;
        if (_exit4) return _result;

        function _temp6(_result2) {
          var _exit3 = false;
          if (_exit2) return _result2;

          function _temp4(_result3) {
            if (_exit3) return _result3;

            var _temp2 = function () {
              if (raw_response) {
                res = response;
              } else {
                return Promise.resolve(response.json()).then(function (_response$json2) {
                  res = _response$json2;
                });
              }
            }();

            return _temp2 && _temp2.then ? _temp2.then(function () {
              return res;
            }) : res;
          }

          var _temp3 = function () {
            if (!raw_response && response.status !== 200) {
              return Promise.resolve(response.text()).then(function (_response$text) {
                res = _response$text;

                _this10.notifications.addSnack({
                  message: "Algo ha salido mal, por favor intentelo nuevamente mas tarde.",
                  level: 'error',
                  persistant: false
                });

                _exit3 = true;
                return false;
              });
            }
          }();

          return _temp3 && _temp3.then ? _temp3.then(_temp4) : _temp4(_temp3);
        }

        var res;

        if (!raw_response && response.status === 401) {
          _this10.removeLocalSession();

          return false;
        }

        var _temp5 = function () {
          if (!raw_response && response.status === 400) {
            return Promise.resolve(response.json()).then(function (_response$json) {
              res = _response$json;

              _this10.notifications.addSnack({
                message: res.error,
                level: 'error',
                persistant: false
              });

              _exit2 = true;
              return false;
            });
          }
        }();

        return _temp5 && _temp5.then ? _temp5.then(_temp6) : _temp6(_temp5);
      };

      var _exit4 = false;

      var _this10 = this;

      var body_req = JSON.stringify(body);
      var response = "";

      var _temp10 = _catch(function () {
        return Promise.resolve(fetch_(path, {
          method: 'POST',
          headers: headers,
          mode: 'cors',
          body: body_req
        })).then(function (_fetch) {
          response = _fetch;
        });
      }, function () {
        var _error = {
          'error': 'retry'
        };
        _exit4 = true;
        return _error;
      });

      return Promise.resolve(_temp10 && _temp10.then ? _temp10.then(_temp9) : _temp9(_temp10));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.Get = function Get(args, path, headers, raw_response, blob, cache_write, abortController) {
    try {
      var _this12 = this;

      var fullPath = args ? path.concat(_this12.createQuery(args)) : path;

      var cached = _this12.cache.get(fullPath);

      if (cached) {
        return Promise.resolve(cached);
      }

      return Promise.resolve(fetch_(fullPath, {
        signal: abortController ? abortController.signal : false,
        method: 'GET',
        headers: headers,
        mode: 'cors'
      })).then(function (response) {
        var _exit5 = false;

        function _temp15(_result5) {
          if (_exit5) return _result5;

          function _temp13() {
            if (cache_write) {
              runInAction(function () {
                _this12.cache.set(fullPath, res);
              });
            }

            return res;
          }

          var _temp12 = function () {
            if (blob) {
              var _temp16 = function () {
                if (environment() === 'native') {
                  return Promise.resolve(_this12.handleNativeBlobResponse(response)).then(function (_this11$handleNativeB) {
                    res = _this11$handleNativeB;
                  });
                } else {
                  var filename = response.headers.get('x-filename');
                  return Promise.resolve(response.blob()).then(function (data) {
                    res = {
                      filename: filename,
                      data: data
                    };
                  });
                }
              }();

              if (_temp16 && _temp16.then) return _temp16.then(function () {});
            } else {
              return Promise.resolve(response.json()).then(function (_response$json4) {
                res = _response$json4;
              });
            }
          }();

          return _temp12 && _temp12.then ? _temp12.then(_temp13) : _temp13(_temp12);
        }

        if (response.status === 401) {
          _this12.removeLocalSession();

          return false;
        }

        var res;

        var _temp14 = function () {
          if (!raw_response && response.status === 404) {
            _exit5 = true;
            return false;
          } else return function () {
            if (response.status === 400) {
              return Promise.resolve(response.json()).then(function (_response$json3) {
                res = _response$json3;

                _this12.notifications.addSnack({
                  message: res.error,
                  level: 'error',
                  persistant: false
                });

                _exit5 = true;
                return false;
              });
            }
          }();
        }();

        return _temp14 && _temp14.then ? _temp14.then(_temp15) : _temp15(_temp14);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.removeLocalSession = function removeLocalSession() {
    try {
      var _this14 = this;

      return Promise.resolve(_this14.storage.removeItem('kalenis_session'));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setLocalDB = function setLocalDB(config) {
    try {
      var _this16 = this;

      _this16.db_handler = new Database(_this16, config, _this16.db_adapter);
      return Promise.resolve(_this16.db_handler.initialize()).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setSession = function setSession(session) {
    try {
      var _this18 = this;

      if (!session) {
        return Promise.resolve();
      }

      _this18.token = session.token;

      if (session.superset) {
        _this18.superset = session.superset;
      }

      if (session.url && _this18.auth_proxy) {
        _this18.setApiPath(session.url);
      }

      return Promise.resolve(_this18.saveSessionToStorage(session)).then(function () {
        function _temp18() {
          _this18.setEditorConfig();

          return Promise.resolve(_this18.loadRoutes()).then(function () {
            if (_this18.db_handler) {
              _this18.db_handler.initialize_pool();
            }
          });
        }

        _this18.setSessionStatus(true);

        _this18.user_context = new UserContext(_this18, session.context);
        console.log("USER CONTEXT CREATED ?");

        var _temp17 = function () {
          if (session.token && session.couch_db.enabled) {
            return Promise.resolve(_this18.setLocalDB(session.couch_db)).then(function () {});
          }
        }();

        return _temp17 && _temp17.then ? _temp17.then(_temp18) : _temp18(_temp17);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.loadUserContext = function loadUserContext() {
    try {
      var _this20 = this;

      var abortController = new AbortController();
      return Promise.resolve(_this20.dispatch('GET', '/user/context', '', false, true, false, abortController));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setUserContext = function setUserContext(context) {
    this.user_context.setValues(context);
  };

  _proto.setEditorConfig = function setEditorConfig() {
    this.editor_config = new EditorConfig(this);
  };

  _proto.loadRoutes = function loadRoutes() {
    try {
      var _this22 = this;

      var abortController = new AbortController();
      return Promise.resolve(_this22.dispatch('GET', '/user/menu', '', false, false, false, abortController)).then(function (routes) {
        runInAction(function () {
          _this22.routes = routes.routes;
          _this22.menu_tree = routes.tree;
        });
        return routes;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.logout = function logout() {
    this.status = false;
    this.token = "";
    this.removeLocalSession();
    this.initialize(this.notifications);
  };

  _proto.setApiPath = function setApiPath(path) {
    this.base_path = path;
    this.api_path = path.concat('/app/v1');
  };

  _proto.getAvailableHosts = function getAvailableHosts(values) {
    try {
      var _this24 = this;

      var headers = _this24.getHeaders();

      var session_path = _this24.config.auth_proxy.concat('/mid/v1/user/hosts');

      return Promise.resolve(_this24.Get(values, session_path, headers, false));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.login = function login(values) {
    try {
      var _this26 = this;

      var headers = _this26.getHeaders();

      var session_path = _this26.getPath("/auth/token");

      return Promise.resolve(_this26.Post(values, session_path, headers, false)).then(function (session) {
        var _temp19 = function () {
          if (session) {
            session['url'] = _this26.base_path;
            return Promise.resolve(_this26.setSession(session)).then(function () {});
          }
        }();

        return _temp19 && _temp19.then ? _temp19.then(function () {
          return session;
        }) : session;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.dispatch = function dispatch(type, path, args, raw_response, cache_write, blob, abortController) {
    try {
      var _this28 = this;

      var headers = _this28.getHeaders();

      var _res = "";
      path = path ? _this28.getPath(path) : "";

      if (args && _this28.user_context && _this28.user_context.initialized) {
        args['_user_context'] = JSON.stringify(_this28.user_context.get_all_values());
      }

      if (!path) {
        return Promise.resolve(false);
      }

      return Promise.resolve(_this28.checkConnection()).then(function (conn_status) {
        var _exit6 = false;

        function _temp21(_result6) {
          if (_exit6) return _result6;

          switch (type) {
            case 'POST':
              {
                return Promise.resolve(_this28.Post(args, path, headers, raw_response)).then(function (_this27$Post) {
                  _res = _this27$Post;

                  if (args.view && _this28.offlineAvailable(args.view)) {
                    _this28.db_handler.mirrorAction({
                      type: type,
                      path: path,
                      original_args: args,
                      res: _res
                    });
                  }

                  return _res;
                });
              }

            case 'GET':
              {
                return Promise.resolve(_this28.Get(args, path, headers, raw_response, blob, cache_write, abortController)).then(function (_this27$Get) {
                  _res = _this27$Get;
                  return _res;
                });
              }

            default:
              throw new Error();
          }
        }

        var _temp20 = function () {
          if (!conn_status && _this28.db_handler) {
            return Promise.resolve(_this28.db_handler.dispatch({
              type: type,
              path: path,
              args: args,
              raw_response: raw_response,
              cache_write: cache_write,
              blob: blob,
              headers: headers
            })).then(function (offline_value) {
              _exit6 = true;
              return offline_value;
            });
          }
        }();

        return _temp20 && _temp20.then ? _temp20.then(_temp21) : _temp21(_temp20);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _createClass(Connection, [{
    key: "visible_routes",
    get: function get() {
      if (!this.routes) {
        return [];
      }

      return this.routes.filter(function (route) {
        return route.visible_menu === true;
      });
    }
  }, {
    key: "offline_models",
    get: function get() {
      return this.offline_master_routes.map(function (route) {
        return {
          'model': route.model,
          'view': route.id
        };
      });
    }
  }, {
    key: "offline_master_routes",
    get: function get() {
      if (!this.routes) {
        return [];
      }

      return this.routes.filter(function (route) {
        return route.offline_master === true;
      });
    }
  }, {
    key: "offline_routes",
    get: function get() {
      if (!this.routes) {
        return [];
      }

      return this.routes.filter(function (route) {
        return route.offline_available === true;
      });
    }
  }, {
    key: "is_sync_active",
    get: function get() {
      return this.db_handler ? this.db_handler.is_sync_active : false;
    }
  }]);

  return Connection;
}();

var SessionContext = React__default.createContext();

var NotificationContext = React__default.createContext();

function ConnectionProvider(_ref) {
  var children = _ref.children,
      connection_info = _ref.connection_info,
      load_db_adapter = _ref.load_db_adapter;
  var notifications = useContext(NotificationContext);
  return /*#__PURE__*/React__default.createElement(SessionContext.Provider, {
    value: new Connection(notifications, connection_info, load_db_adapter)
  }, children);
}

var AppContext = React__default.createContext();

var AppContextProvider = observer(function AppContextProvider(_ref) {
  var children = _ref.children;
  var connection = useContext(SessionContext);

  var _useState = useState(connection.status);

  var value = new ScreenGroup(connection);
  return /*#__PURE__*/React__default.createElement(AppContext.Provider, {
    value: value
  }, children);
});

var ThemeContext = React__default.createContext();

var default_logo = "isologo-kalenis~TIrruTIy.png";

var hexAToRGBA = function hexAToRGBA(h, a) {
  var r = 0,
      g = 0,
      b = 0;

  if (h.length === 4) {
    r = "0x" + h[1] + h[1];
    g = "0x" + h[2] + h[2];
    b = "0x" + h[3] + h[3];
  } else if (h.length === 7) {
    r = "0x" + h[1] + h[2];
    g = "0x" + h[3] + h[4];
    b = "0x" + h[5] + h[6];
  }

  return "rgba(" + +r + "," + +g + "," + +b + "," + a + ")";
};
var lighten = function lighten(color, percent) {
  var num = parseInt(color.replace("#", ""), 16),
      amt = Math.round(2.55 * percent),
      R = (num >> 16) + amt,
      B = (num >> 8 & 0x00FF) + amt,
      G = (num & 0x0000FF) + amt;
  var l_color = (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (B < 255 ? B < 1 ? 0 : B : 255) * 0x100 + (G < 255 ? G < 1 ? 0 : G : 255)).toString(16).slice(1);
  l_color = "#".concat(l_color);
  return l_color;
};

var default_theme_values = {
  logo: default_logo,
  palette: {
    primary: "#195fc7",
    secondary: "rgb(220,0,78)"
  }
};
var Theme = /*#__PURE__*/function () {
  function Theme(connection, use_default_theme) {

    this.connection = false;
    this.values = default_theme_values;
    this.use_default_theme = false;
    this.logo = "";
    this.ready = false;
    this["default"] = true;
    this.tooltip_templates = [];
    makeObservable(this, {
      setTheme: action,
      ready: observable,
      values: observable,
      logo: observable,
      "default": observable,
      setLogo: action,
      setDefault: action,
      setTooltipTemplates: action
    });
    this.connection = connection;

    if (this.connection.api_path) {
      this.getTheme();
    } else {
      this.setTheme(default_theme_values);
      this.setDefault(true);
    }
  }

  var _proto = Theme.prototype;

  _proto.getTheme = function getTheme() {
    try {
      var _this2 = this;

      var args = {};

      if (environment() === 'web') {
        args['host'] = window.location.host;
      } else {
        args['host'] = '';
      }

      var values = default_theme_values;
      var abortController = new AbortController();
      return Promise.resolve(_this2.connection.dispatch('GET', '/theme/host_theme', args, false, true, false, abortController)).then(function (theme) {
        console.log("THE THEME GETTED");
        console.log(theme);
        return Promise.resolve(_this2.connection.dispatch('GET', '/theme_logo', {
          theme_id: theme.id
        }, false, false, true, abortController)).then(function (res) {
          var logo = res.data;
          return Promise.resolve(_this2.connection.dispatch('GET', '/theme/tooltip_templates', {
            theme_id: theme.id
          }, false, true, false, abortController)).then(function (tooltip_templates) {
            if (theme) {
              values = theme;

              if (logo) {
                if (environment() === 'web') {
                  _this2.setLogo(URL.createObjectURL(logo));
                } else {
                  console.log("TRY TO DECODE THE LOGO");
                  var reader = new FileReader();
                  reader.readAsDataURL(logo.data);

                  reader.onloadend = function () {
                    var base64data = reader.result;
                    this.setLogo(base64data);
                  }.bind(_this2);
                }
              }

              _this2.setTooltipTemplates(tooltip_templates);
            }

            _this2.setDefault(false);

            return _this2.setTheme(values);
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setLogo = function setLogo(value) {
    this.logo = value;
  };

  _proto.setTooltipTemplates = function setTooltipTemplates(templates) {
    this.tooltip_templates = templates;
  };

  _proto.getTooltipTemplate = function getTooltipTemplate(id) {
    return this.tooltip_templates.find(function (t) {
      return t.id == id;
    });
  };

  _proto.setDefault = function setDefault(value) {
    this["default"] = value;
  };

  _proto.setTheme = function setTheme(values) {
    var env = environment();

    if (values.primary) {
      values['light_selected'] = hexAToRGBA(lighten(values.primary, 40), '.3');
    }

    this.values = values;

    if (env === 'web') {
      this.setWebTheme(values);
    }

    this.ready = true;
    return this;
  };

  _proto.setWebTheme = function setWebTheme(theme) {
    document.documentElement.style.setProperty('--color-primary', theme.primary);
    document.documentElement.style.setProperty('--color-contrast-primary', 'rgb(255,255,255)');
    document.documentElement.style.setProperty('--color-lighten-primary', lighten(theme.primary, 12));
    document.documentElement.style.setProperty('--color-secondary', theme.secondary);
    document.documentElement.style.setProperty('--color-disabled', 'lightgrey');
    document.documentElement.style.setProperty('--color-light-selected', hexAToRGBA(lighten(theme.primary, 40), '.3'));
    document.documentElement.style.setProperty('font-size', '1rem');
  };

  return Theme;
}();

function ThemeContextProvider(_ref) {
  var children = _ref.children,
      use_default_theme = _ref.use_default_theme;
  var connection = useContext(SessionContext);
  var theme = new Theme(connection, use_default_theme);
  return /*#__PURE__*/React__default.createElement(ThemeContext.Provider, {
    value: theme
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children));
}

var SnackNotification = /*#__PURE__*/function () {
  function SnackNotification(attributes, manager) {
    var _this = this;

    this.id = v4();
    this.message = "";
    this.level = "";
    this.timeout = "";
    this.persistant = false;
    this.manager = false;
    this.component = false;
    this.message = attributes.message;
    this.level = attributes.level || 'sucessfull';
    this.persistant = attributes.persistant || false;
    this.timeout = attributes.persistant ? false : attributes.timeout ? attributes.timeout : 3000;
    this.manager = manager;
    this.component = manager.snack_component ? manager.snack_component : false;

    if (this.timeout) {
      setTimeout(function () {
        _this.remove(_this.id);
      }, this.timeout);
    }
  }

  var _proto = SnackNotification.prototype;

  _proto.remove = function remove() {
    this.manager.removeSnack(this.id);
  };

  return SnackNotification;
}();

var DialogNotification = /*#__PURE__*/function () {
  function DialogNotification(attributes, manager, component) {
    this.id = v4();
    this.message = "";
    this.body_component = false;
    this.actions = [];
    makeObservable(this, {
      actions: observable,
      message: observable
    });
    this.message = attributes.message;
    this.html = attributes.html;
    this.actions = attributes.actions ? attributes.actions : [];
    this.manager = manager;
    this.body_component = component;
  }

  var _proto2 = DialogNotification.prototype;

  _proto2.callbackWrapper = function callbackWrapper(callback) {
    try {
      var _this3 = this;

      return Promise.resolve(function () {
        if (!callback) {
          return _this3.remove();
        } else {
          return Promise.resolve(callback()).then(function (res) {
            if (res) {
              return _this3.remove();
            }
          });
        }
      }());
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto2.remove = function remove() {
    this.manager.removeDialog(this.id);
  };

  return DialogNotification;
}();

var NotificationManager = /*#__PURE__*/function () {
  function NotificationManager() {
    this.snack_queue = [];
    this.dialog_queue = [];
    this.snack_timeout = 3000;
    this.snack_component = "";
    this.dialog_component = "";
    makeObservable(this, {
      snack_queue: observable,
      dialog_queue: observable,
      snack_component: observable,
      dialog_component: observable,
      addSnack: action,
      removeSnack: action,
      addDialog: action,
      removeDialog: action,
      setSnackComponent: action,
      setDialogComponent: action
    });
  }

  var _proto3 = NotificationManager.prototype;

  _proto3.setSnackComponent = function setSnackComponent(component) {
    this.snack_component = component;
  };

  _proto3.setDialogComponent = function setDialogComponent(component, extra_props) {
    this.dialog_component = {
      component: component,
      extra_props: extra_props
    };
  };

  _proto3.addSnack = function addSnack(value) {
    var newSnack = new SnackNotification(value, this);
    this.snack_queue.push(newSnack);
    return newSnack;
  };

  _proto3.removeSnack = function removeSnack(id) {
    var snack_index = this.snack_queue.findIndex(function (element) {
      return element.id === id;
    });
    this.snack_queue.splice(snack_index, 1);
    return false;
  };

  _proto3.addDialog = function addDialog(value, add_close, component) {
    var dialog = _extends({}, value);

    if (add_close) {
      var close_action = {
        name: 'Cerrar',
        color: 'disabled'
      };

      if (dialog.actions && Array.isArray(dialog.actions)) {
        dialog.actions.unshift(close_action);
      }
    }

    this.dialog_queue.push(new DialogNotification(dialog, this, component));
  };

  _proto3.removeDialog = function removeDialog(id) {
    var dialog_index = this.dialog_queue.findIndex(function (element) {
      return element.id === id;
    });
    this.dialog_queue.splice(dialog_index, 1);
    return false;
  };

  return NotificationManager;
}();

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var scheduler_production_min = createCommonjsModule(function (module, exports) {

  function f(a, b) {
    var c = a.length;
    a.push(b);

    a: for (; 0 < c;) {
      var d = c - 1 >>> 1,
          e = a[d];
      if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;else break a;
    }
  }

  function h(a) {
    return 0 === a.length ? null : a[0];
  }

  function k(a) {
    if (0 === a.length) return null;
    var b = a[0],
        c = a.pop();

    if (c !== b) {
      a[0] = c;

      a: for (var d = 0, e = a.length, w = e >>> 1; d < w;) {
        var m = 2 * (d + 1) - 1,
            C = a[m],
            n = m + 1,
            x = a[n];
        if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;else break a;
      }
    }

    return b;
  }

  function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
  }

  if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;

    exports.unstable_now = function () {
      return l.now();
    };
  } else {
    var p = Date,
        q = p.now();

    exports.unstable_now = function () {
      return p.now() - q;
    };
  }

  var r = [],
      t = [],
      u = 1,
      v = null,
      y = 3,
      z = !1,
      A = !1,
      B = !1,
      D = "function" === typeof setTimeout ? setTimeout : null,
      E = "function" === typeof clearTimeout ? clearTimeout : null,
      F = "undefined" !== typeof setImmediate ? setImmediate : null;
  "undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);

  function G(a) {
    for (var b = h(t); null !== b;) {
      if (null === b.callback) k(t);else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);else break;
      b = h(t);
    }
  }

  function H(a) {
    B = !1;
    G(a);
    if (!A) if (null !== h(r)) A = !0, I(J);else {
      var b = h(t);
      null !== b && K(H, b.startTime - a);
    }
  }

  function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;

    try {
      G(b);

      for (v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());) {
        var d = v.callback;

        if ("function" === typeof d) {
          v.callback = null;
          y = v.priorityLevel;
          var e = d(v.expirationTime <= b);
          b = exports.unstable_now();
          "function" === typeof e ? v.callback = e : v === h(r) && k(r);
          G(b);
        } else k(r);

        v = h(r);
      }

      if (null !== v) var w = !0;else {
        var m = h(t);
        null !== m && K(H, m.startTime - b);
        w = !1;
      }
      return w;
    } finally {
      v = null, y = c, z = !1;
    }
  }

  var N = !1,
      O = null,
      L = -1,
      P = 5,
      Q = -1;

  function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
  }

  function R() {
    if (null !== O) {
      var a = exports.unstable_now();
      Q = a;
      var b = !0;

      try {
        b = O(!0, a);
      } finally {
        b ? S() : (N = !1, O = null);
      }
    } else N = !1;
  }

  var S;
  if ("function" === typeof F) S = function S() {
    F(R);
  };else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel(),
        U = T.port2;
    T.port1.onmessage = R;

    S = function S() {
      U.postMessage(null);
    };
  } else S = function S() {
    D(R, 0);
  };

  function I(a) {
    O = a;
    N || (N = !0, S());
  }

  function K(a, b) {
    L = D(function () {
      a(exports.unstable_now());
    }, b);
  }

  exports.unstable_IdlePriority = 5;
  exports.unstable_ImmediatePriority = 1;
  exports.unstable_LowPriority = 4;
  exports.unstable_NormalPriority = 3;
  exports.unstable_Profiling = null;
  exports.unstable_UserBlockingPriority = 2;

  exports.unstable_cancelCallback = function (a) {
    a.callback = null;
  };

  exports.unstable_continueExecution = function () {
    A || z || (A = !0, I(J));
  };

  exports.unstable_forceFrameRate = function (a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
  };

  exports.unstable_getCurrentPriorityLevel = function () {
    return y;
  };

  exports.unstable_getFirstCallbackNode = function () {
    return h(r);
  };

  exports.unstable_next = function (a) {
    switch (y) {
      case 1:
      case 2:
      case 3:
        var b = 3;
        break;

      default:
        b = y;
    }

    var c = y;
    y = b;

    try {
      return a();
    } finally {
      y = c;
    }
  };

  exports.unstable_pauseExecution = function () {};

  exports.unstable_requestPaint = function () {};

  exports.unstable_runWithPriority = function (a, b) {
    switch (a) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;

      default:
        a = 3;
    }

    var c = y;
    y = a;

    try {
      return b();
    } finally {
      y = c;
    }
  };

  exports.unstable_scheduleCallback = function (a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;

    switch (a) {
      case 1:
        var e = -1;
        break;

      case 2:
        e = 250;
        break;

      case 5:
        e = 1073741823;
        break;

      case 4:
        e = 1E4;
        break;

      default:
        e = 5E3;
    }

    e = c + e;
    a = {
      id: u++,
      callback: b,
      priorityLevel: a,
      startTime: c,
      expirationTime: e,
      sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
  };

  exports.unstable_shouldYield = M;

  exports.unstable_wrapCallback = function (a) {
    var b = y;
    return function () {
      var c = y;
      y = b;

      try {
        return a.apply(this, arguments);
      } finally {
        y = c;
      }
    };
  };
});

var scheduler_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {

      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }

      var enableSchedulerDebugging = false;
      var enableProfiling = false;
      var frameYieldMs = 5;

      function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
      }

      function peek(heap) {
        return heap.length === 0 ? null : heap[0];
      }

      function pop(heap) {
        if (heap.length === 0) {
          return null;
        }

        var first = heap[0];
        var last = heap.pop();

        if (last !== first) {
          heap[0] = last;
          siftDown(heap, last, 0);
        }

        return first;
      }

      function siftUp(heap, node, i) {
        var index = i;

        while (index > 0) {
          var parentIndex = index - 1 >>> 1;
          var parent = heap[parentIndex];

          if (compare(parent, node) > 0) {
            heap[parentIndex] = node;
            heap[index] = parent;
            index = parentIndex;
          } else {
            return;
          }
        }
      }

      function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;

        while (index < halfLength) {
          var leftIndex = (index + 1) * 2 - 1;
          var left = heap[leftIndex];
          var rightIndex = leftIndex + 1;
          var right = heap[rightIndex];

          if (compare(left, node) < 0) {
            if (rightIndex < length && compare(right, left) < 0) {
              heap[index] = right;
              heap[rightIndex] = node;
              index = rightIndex;
            } else {
              heap[index] = left;
              heap[leftIndex] = node;
              index = leftIndex;
            }
          } else if (rightIndex < length && compare(right, node) < 0) {
            heap[index] = right;
            heap[rightIndex] = node;
            index = rightIndex;
          } else {
            return;
          }
        }
      }

      function compare(a, b) {
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
      }

      var ImmediatePriority = 1;
      var UserBlockingPriority = 2;
      var NormalPriority = 3;
      var LowPriority = 4;
      var IdlePriority = 5;

      function markTaskErrored(task, ms) {}

      var hasPerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';

      if (hasPerformanceNow) {
        var localPerformance = performance;

        exports.unstable_now = function () {
          return localPerformance.now();
        };
      } else {
        var localDate = Date;
        var initialTime = localDate.now();

        exports.unstable_now = function () {
          return localDate.now() - initialTime;
        };
      }

      var maxSigned31BitInt = 1073741823;
      var IMMEDIATE_PRIORITY_TIMEOUT = -1;
      var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
      var NORMAL_PRIORITY_TIMEOUT = 5000;
      var LOW_PRIORITY_TIMEOUT = 10000;
      var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt;
      var taskQueue = [];
      var timerQueue = [];
      var taskIdCounter = 1;
      var currentTask = null;
      var currentPriorityLevel = NormalPriority;
      var isPerformingWork = false;
      var isHostCallbackScheduled = false;
      var isHostTimeoutScheduled = false;
      var localSetTimeout = typeof setTimeout === 'function' ? setTimeout : null;
      var localClearTimeout = typeof clearTimeout === 'function' ? clearTimeout : null;
      var localSetImmediate = typeof setImmediate !== 'undefined' ? setImmediate : null;
      var isInputPending = typeof navigator !== 'undefined' && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;

      function advanceTimers(currentTime) {
        var timer = peek(timerQueue);

        while (timer !== null) {
          if (timer.callback === null) {
            pop(timerQueue);
          } else if (timer.startTime <= currentTime) {
            pop(timerQueue);
            timer.sortIndex = timer.expirationTime;
            push(taskQueue, timer);
          } else {
            return;
          }

          timer = peek(timerQueue);
        }
      }

      function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);

        if (!isHostCallbackScheduled) {
          if (peek(taskQueue) !== null) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
          } else {
            var firstTimer = peek(timerQueue);

            if (firstTimer !== null) {
              requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
          }
        }
      }

      function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;

        if (isHostTimeoutScheduled) {
          isHostTimeoutScheduled = false;
          cancelHostTimeout();
        }

        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;

        try {
          if (enableProfiling) {
            try {
              return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
              if (currentTask !== null) {
                var currentTime = exports.unstable_now();
                markTaskErrored(currentTask, currentTime);
                currentTask.isQueued = false;
              }

              throw error;
            }
          } else {
            return workLoop(hasTimeRemaining, initialTime);
          }
        } finally {
          currentTask = null;
          currentPriorityLevel = previousPriorityLevel;
          isPerformingWork = false;
        }
      }

      function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);

        while (currentTask !== null && !enableSchedulerDebugging) {
          if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) {
            break;
          }

          var callback = currentTask.callback;

          if (typeof callback === 'function') {
            currentTask.callback = null;
            currentPriorityLevel = currentTask.priorityLevel;
            var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
            var continuationCallback = callback(didUserCallbackTimeout);
            currentTime = exports.unstable_now();

            if (typeof continuationCallback === 'function') {
              currentTask.callback = continuationCallback;
            } else {
              if (currentTask === peek(taskQueue)) {
                pop(taskQueue);
              }
            }

            advanceTimers(currentTime);
          } else {
            pop(taskQueue);
          }

          currentTask = peek(taskQueue);
        }

        if (currentTask !== null) {
          return true;
        } else {
          var firstTimer = peek(timerQueue);

          if (firstTimer !== null) {
            requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
          }

          return false;
        }
      }

      function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch (priorityLevel) {
          case ImmediatePriority:
          case UserBlockingPriority:
          case NormalPriority:
          case LowPriority:
          case IdlePriority:
            break;

          default:
            priorityLevel = NormalPriority;
        }

        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;

        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      }

      function unstable_next(eventHandler) {
        var priorityLevel;

        switch (currentPriorityLevel) {
          case ImmediatePriority:
          case UserBlockingPriority:
          case NormalPriority:
            priorityLevel = NormalPriority;
            break;

          default:
            priorityLevel = currentPriorityLevel;
            break;
        }

        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;

        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      }

      function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function () {
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = parentPriorityLevel;

          try {
            return callback.apply(this, arguments);
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        };
      }

      function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = exports.unstable_now();
        var startTime;

        if (typeof options === 'object' && options !== null) {
          var delay = options.delay;

          if (typeof delay === 'number' && delay > 0) {
            startTime = currentTime + delay;
          } else {
            startTime = currentTime;
          }
        } else {
          startTime = currentTime;
        }

        var timeout;

        switch (priorityLevel) {
          case ImmediatePriority:
            timeout = IMMEDIATE_PRIORITY_TIMEOUT;
            break;

          case UserBlockingPriority:
            timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
            break;

          case IdlePriority:
            timeout = IDLE_PRIORITY_TIMEOUT;
            break;

          case LowPriority:
            timeout = LOW_PRIORITY_TIMEOUT;
            break;

          case NormalPriority:
          default:
            timeout = NORMAL_PRIORITY_TIMEOUT;
            break;
        }

        var expirationTime = startTime + timeout;
        var newTask = {
          id: taskIdCounter++,
          callback: callback,
          priorityLevel: priorityLevel,
          startTime: startTime,
          expirationTime: expirationTime,
          sortIndex: -1
        };

        if (startTime > currentTime) {
          newTask.sortIndex = startTime;
          push(timerQueue, newTask);

          if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
            if (isHostTimeoutScheduled) {
              cancelHostTimeout();
            } else {
              isHostTimeoutScheduled = true;
            }

            requestHostTimeout(handleTimeout, startTime - currentTime);
          }
        } else {
          newTask.sortIndex = expirationTime;
          push(taskQueue, newTask);

          if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
          }
        }

        return newTask;
      }

      function unstable_pauseExecution() {}

      function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
          isHostCallbackScheduled = true;
          requestHostCallback(flushWork);
        }
      }

      function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
      }

      function unstable_cancelCallback(task) {
        task.callback = null;
      }

      function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
      }

      var isMessageLoopRunning = false;
      var scheduledHostCallback = null;
      var taskTimeoutID = -1;
      var frameInterval = frameYieldMs;
      var startTime = -1;

      function shouldYieldToHost() {
        var timeElapsed = exports.unstable_now() - startTime;

        if (timeElapsed < frameInterval) {
          return false;
        }

        return true;
      }

      function requestPaint() {}

      function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
          console['error']('forceFrameRate takes a positive int between 0 and 125, ' + 'forcing frame rates higher than 125 fps is not supported');
          return;
        }

        if (fps > 0) {
          frameInterval = Math.floor(1000 / fps);
        } else {
          frameInterval = frameYieldMs;
        }
      }

      var performWorkUntilDeadline = function performWorkUntilDeadline() {
        if (scheduledHostCallback !== null) {
          var currentTime = exports.unstable_now();
          startTime = currentTime;
          var hasTimeRemaining = true;
          var hasMoreWork = true;

          try {
            hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
          } finally {
            if (hasMoreWork) {
              schedulePerformWorkUntilDeadline();
            } else {
              isMessageLoopRunning = false;
              scheduledHostCallback = null;
            }
          }
        } else {
          isMessageLoopRunning = false;
        }
      };

      var schedulePerformWorkUntilDeadline;

      if (typeof localSetImmediate === 'function') {
        schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
          localSetImmediate(performWorkUntilDeadline);
        };
      } else if (typeof MessageChannel !== 'undefined') {
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;

        schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
          port.postMessage(null);
        };
      } else {
        schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
          localSetTimeout(performWorkUntilDeadline, 0);
        };
      }

      function requestHostCallback(callback) {
        scheduledHostCallback = callback;

        if (!isMessageLoopRunning) {
          isMessageLoopRunning = true;
          schedulePerformWorkUntilDeadline();
        }
      }

      function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function () {
          callback(exports.unstable_now());
        }, ms);
      }

      function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
      }

      var unstable_requestPaint = requestPaint;
      var unstable_Profiling = null;
      exports.unstable_IdlePriority = IdlePriority;
      exports.unstable_ImmediatePriority = ImmediatePriority;
      exports.unstable_LowPriority = LowPriority;
      exports.unstable_NormalPriority = NormalPriority;
      exports.unstable_Profiling = unstable_Profiling;
      exports.unstable_UserBlockingPriority = UserBlockingPriority;
      exports.unstable_cancelCallback = unstable_cancelCallback;
      exports.unstable_continueExecution = unstable_continueExecution;
      exports.unstable_forceFrameRate = forceFrameRate;
      exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
      exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
      exports.unstable_next = unstable_next;
      exports.unstable_pauseExecution = unstable_pauseExecution;
      exports.unstable_requestPaint = unstable_requestPaint;
      exports.unstable_runWithPriority = unstable_runWithPriority;
      exports.unstable_scheduleCallback = unstable_scheduleCallback;
      exports.unstable_shouldYield = shouldYieldToHost;
      exports.unstable_wrapCallback = unstable_wrapCallback;

      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
});

var scheduler = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = scheduler_production_min;
  } else {
    module.exports = scheduler_development;
  }
});

function p(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
    b += "&args[]=" + encodeURIComponent(arguments[c]);
  }

  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}

var da = new Set(),
    ea = {};

function fa(a, b) {
  ha(a, b);
  ha(a + "Capture", b);
}

function ha(a, b) {
  ea[a] = b;

  for (a = 0; a < b.length; a++) {
    da.add(b[a]);
  }
}

var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement),
    ja = Object.prototype.hasOwnProperty,
    ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    la = {},
    ma = {};

function na(a) {
  if (ja.call(ma, a)) return !0;
  if (ja.call(la, a)) return !1;
  if (ka.test(a)) return ma[a] = !0;
  la[a] = !0;
  return !1;
}

function oa(a, b, c, d) {
  if (null !== c && 0 === c.type) return !1;

  switch (typeof b) {
    case "function":
    case "symbol":
      return !0;

    case "boolean":
      if (d) return !1;
      if (null !== c) return !c.acceptsBooleans;
      a = a.toLowerCase().slice(0, 5);
      return "data-" !== a && "aria-" !== a;

    default:
      return !1;
  }
}

function pa(a, b, c, d) {
  if (null === b || "undefined" === typeof b || oa(a, b, c, d)) return !0;
  if (d) return !1;
  if (null !== c) switch (c.type) {
    case 3:
      return !b;

    case 4:
      return !1 === b;

    case 5:
      return isNaN(b);

    case 6:
      return isNaN(b) || 1 > b;
  }
  return !1;
}

function t(a, b, c, d, e, f, g) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
  this.attributeName = d;
  this.attributeNamespace = e;
  this.mustUseProperty = c;
  this.propertyName = a;
  this.type = b;
  this.sanitizeURL = f;
  this.removeEmptyString = g;
}

var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  z[a] = new t(a, 0, !1, a, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];
  z[b] = new t(b, 1, !1, a[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  z[a] = new t(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
  z[a] = new t(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  z[a] = new t(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function (a) {
  z[a] = new t(a, 3, !0, a, null, !1, !1);
});
["capture", "download"].forEach(function (a) {
  z[a] = new t(a, 4, !1, a, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function (a) {
  z[a] = new t(a, 6, !1, a, null, !1, !1);
});
["rowSpan", "start"].forEach(function (a) {
  z[a] = new t(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var qa = /[\-:]([a-z])/g;

function ra(a) {
  return a[1].toUpperCase();
}

"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(qa, ra);
  z[b] = new t(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(qa, ra);
  z[b] = new t(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(qa, ra);
  z[b] = new t(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function (a) {
  z[a] = new t(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new t("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function (a) {
  z[a] = new t(a, 1, !1, a.toLowerCase(), null, !0, !0);
});

function sa(a, b, c, d) {
  var e = z.hasOwnProperty(b) ? z[b] : null;
  if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) pa(b, c, e, d) && (c = null), d || null === e ? na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}

var ta = React__default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    ua = Symbol["for"]("react.element"),
    va = Symbol["for"]("react.portal"),
    wa = Symbol["for"]("react.fragment"),
    xa = Symbol["for"]("react.strict_mode"),
    za = Symbol["for"]("react.profiler"),
    Aa = Symbol["for"]("react.provider"),
    Ba = Symbol["for"]("react.context"),
    Ca = Symbol["for"]("react.forward_ref"),
    Da = Symbol["for"]("react.suspense"),
    Ea = Symbol["for"]("react.suspense_list"),
    Fa = Symbol["for"]("react.memo"),
    Ga = Symbol["for"]("react.lazy");
var Ha = Symbol["for"]("react.offscreen");
var Ia = Symbol.iterator;

function Ja(a) {
  if (null === a || "object" !== typeof a) return null;
  a = Ia && a[Ia] || a["@@iterator"];
  return "function" === typeof a ? a : null;
}

var A = Object.assign,
    Ka;

function La(a) {
  if (void 0 === Ka) try {
    throw Error();
  } catch (c) {
    var b = c.stack.trim().match(/\n( *(at )?)/);
    Ka = b && b[1] || "";
  }
  return "\n" + Ka + a;
}

var Ma = !1;

function Na(a, b) {
  if (!a || Ma) return "";
  Ma = !0;
  var c = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;

  try {
    if (b) {
      if (b = function b() {
        throw Error();
      }, Object.defineProperty(b.prototype, "props", {
        set: function set() {
          throw Error();
        }
      }), "object" === typeof Reflect && Reflect.construct) {
        try {
          Reflect.construct(b, []);
        } catch (l) {
          var d = l;
        }

        Reflect.construct(a, [], b);
      } else {
        try {
          b.call();
        } catch (l) {
          d = l;
        }

        a.call(b.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (l) {
        d = l;
      }

      a();
    }
  } catch (l) {
    if (l && d && "string" === typeof l.stack) {
      for (var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];) {
        h--;
      }

      for (; 1 <= g && 0 <= h; g--, h--) {
        if (e[g] !== f[h]) {
          if (1 !== g || 1 !== h) {
            do {
              if (g--, h--, 0 > h || e[g] !== f[h]) {
                var k = "\n" + e[g].replace(" at new ", " at ");
                a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                return k;
              }
            } while (1 <= g && 0 <= h);
          }

          break;
        }
      }
    }
  } finally {
    Ma = !1, Error.prepareStackTrace = c;
  }

  return (a = a ? a.displayName || a.name : "") ? La(a) : "";
}

function Oa(a) {
  switch (a.tag) {
    case 5:
      return La(a.type);

    case 16:
      return La("Lazy");

    case 13:
      return La("Suspense");

    case 19:
      return La("SuspenseList");

    case 0:
    case 2:
    case 15:
      return a = Na(a.type, !1), a;

    case 11:
      return a = Na(a.type.render, !1), a;

    case 1:
      return a = Na(a.type, !0), a;

    default:
      return "";
  }
}

function Pa(a) {
  if (null == a) return null;
  if ("function" === typeof a) return a.displayName || a.name || null;
  if ("string" === typeof a) return a;

  switch (a) {
    case wa:
      return "Fragment";

    case va:
      return "Portal";

    case za:
      return "Profiler";

    case xa:
      return "StrictMode";

    case Da:
      return "Suspense";

    case Ea:
      return "SuspenseList";
  }

  if ("object" === typeof a) switch (a.$$typeof) {
    case Ba:
      return (a.displayName || "Context") + ".Consumer";

    case Aa:
      return (a._context.displayName || "Context") + ".Provider";

    case Ca:
      var b = a.render;
      a = a.displayName;
      a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
      return a;

    case Fa:
      return b = a.displayName || null, null !== b ? b : Pa(a.type) || "Memo";

    case Ga:
      b = a._payload;
      a = a._init;

      try {
        return Pa(a(b));
      } catch (c) {}

  }
  return null;
}

function Qa(a) {
  var b = a.type;

  switch (a.tag) {
    case 24:
      return "Cache";

    case 9:
      return (b.displayName || "Context") + ".Consumer";

    case 10:
      return (b._context.displayName || "Context") + ".Provider";

    case 18:
      return "DehydratedFragment";

    case 11:
      return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");

    case 7:
      return "Fragment";

    case 5:
      return b;

    case 4:
      return "Portal";

    case 3:
      return "Root";

    case 6:
      return "Text";

    case 16:
      return Pa(b);

    case 8:
      return b === xa ? "StrictMode" : "Mode";

    case 22:
      return "Offscreen";

    case 12:
      return "Profiler";

    case 21:
      return "Scope";

    case 13:
      return "Suspense";

    case 19:
      return "SuspenseList";

    case 25:
      return "TracingMarker";

    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if ("function" === typeof b) return b.displayName || b.name || null;
      if ("string" === typeof b) return b;
  }

  return null;
}

function Ra(a) {
  switch (typeof a) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return a;

    case "object":
      return a;

    default:
      return "";
  }
}

function Sa(a) {
  var b = a.type;
  return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}

function Ta(a) {
  var b = Sa(a) ? "checked" : "value",
      c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
      d = "" + a[b];

  if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
    var e = c.get,
        f = c.set;
    Object.defineProperty(a, b, {
      configurable: !0,
      get: function get() {
        return e.call(this);
      },
      set: function set(a) {
        d = "" + a;
        f.call(this, a);
      }
    });
    Object.defineProperty(a, b, {
      enumerable: c.enumerable
    });
    return {
      getValue: function getValue() {
        return d;
      },
      setValue: function setValue(a) {
        d = "" + a;
      },
      stopTracking: function stopTracking() {
        a._valueTracker = null;
        delete a[b];
      }
    };
  }
}

function Ua(a) {
  a._valueTracker || (a._valueTracker = Ta(a));
}

function Va(a) {
  if (!a) return !1;
  var b = a._valueTracker;
  if (!b) return !0;
  var c = b.getValue();
  var d = "";
  a && (d = Sa(a) ? a.checked ? "true" : "false" : a.value);
  a = d;
  return a !== c ? (b.setValue(a), !0) : !1;
}

function Wa(a) {
  a = a || ("undefined" !== typeof document ? document : void 0);
  if ("undefined" === typeof a) return null;

  try {
    return a.activeElement || a.body;
  } catch (b) {
    return a.body;
  }
}

function Xa(a, b) {
  var c = b.checked;
  return A({}, b, {
    defaultChecked: void 0,
    defaultValue: void 0,
    value: void 0,
    checked: null != c ? c : a._wrapperState.initialChecked
  });
}

function Ya(a, b) {
  var c = null == b.defaultValue ? "" : b.defaultValue,
      d = null != b.checked ? b.checked : b.defaultChecked;
  c = Ra(null != b.value ? b.value : c);
  a._wrapperState = {
    initialChecked: d,
    initialValue: c,
    controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
  };
}

function Za(a, b) {
  b = b.checked;
  null != b && sa(a, "checked", b, !1);
}

function $a(a, b) {
  Za(a, b);
  var c = Ra(b.value),
      d = b.type;
  if (null != c) {
    if ("number" === d) {
      if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
    } else a.value !== "" + c && (a.value = "" + c);
  } else if ("submit" === d || "reset" === d) {
    a.removeAttribute("value");
    return;
  }
  b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Ra(b.defaultValue));
  null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}

function cb(a, b, c) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
    var d = b.type;
    if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
    b = "" + a._wrapperState.initialValue;
    c || b === a.value || (a.value = b);
    a.defaultValue = b;
  }

  c = a.name;
  "" !== c && (a.name = "");
  a.defaultChecked = !!a._wrapperState.initialChecked;
  "" !== c && (a.name = c);
}

function bb(a, b, c) {
  if ("number" !== b || Wa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}

var db = Array.isArray;

function eb(a, b, c, d) {
  a = a.options;

  if (b) {
    b = {};

    for (var e = 0; e < c.length; e++) {
      b["$" + c[e]] = !0;
    }

    for (c = 0; c < a.length; c++) {
      e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    }
  } else {
    c = "" + Ra(c);
    b = null;

    for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = !0;
        d && (a[e].defaultSelected = !0);
        return;
      }

      null !== b || a[e].disabled || (b = a[e]);
    }

    null !== b && (b.selected = !0);
  }
}

function fb(a, b) {
  if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
  return A({}, b, {
    value: void 0,
    defaultValue: void 0,
    children: "" + a._wrapperState.initialValue
  });
}

function gb(a, b) {
  var c = b.value;

  if (null == c) {
    c = b.children;
    b = b.defaultValue;

    if (null != c) {
      if (null != b) throw Error(p(92));

      if (db(c)) {
        if (1 < c.length) throw Error(p(93));
        c = c[0];
      }

      b = c;
    }

    null == b && (b = "");
    c = b;
  }

  a._wrapperState = {
    initialValue: Ra(c)
  };
}

function hb(a, b) {
  var c = Ra(b.value),
      d = Ra(b.defaultValue);
  null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
  null != d && (a.defaultValue = "" + d);
}

function ib(a) {
  var b = a.textContent;
  b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}

function jb(a) {
  switch (a) {
    case "svg":
      return "http://www.w3.org/2000/svg";

    case "math":
      return "http://www.w3.org/1998/Math/MathML";

    default:
      return "http://www.w3.org/1999/xhtml";
  }
}

function kb(a, b) {
  return null == a || "http://www.w3.org/1999/xhtml" === a ? jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}

var lb,
    mb = function (a) {
  return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
    MSApp.execUnsafeLocalFunction(function () {
      return a(b, c, d, e);
    });
  } : a;
}(function (a, b) {
  if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;else {
    lb = lb || document.createElement("div");
    lb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";

    for (b = lb.firstChild; a.firstChild;) {
      a.removeChild(a.firstChild);
    }

    for (; b.firstChild;) {
      a.appendChild(b.firstChild);
    }
  }
});

function nb(a, b) {
  if (b) {
    var c = a.firstChild;

    if (c && c === a.lastChild && 3 === c.nodeType) {
      c.nodeValue = b;
      return;
    }
  }

  a.textContent = b;
}

var ob = {
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
},
    pb = ["Webkit", "ms", "Moz", "O"];
Object.keys(ob).forEach(function (a) {
  pb.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    ob[b] = ob[a];
  });
});

function qb(a, b, c) {
  return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || ob.hasOwnProperty(a) && ob[a] ? ("" + b).trim() : b + "px";
}

function rb(a, b) {
  a = a.style;

  for (var c in b) {
    if (b.hasOwnProperty(c)) {
      var d = 0 === c.indexOf("--"),
          e = qb(c, b[c], d);
      "float" === c && (c = "cssFloat");
      d ? a.setProperty(c, e) : a[c] = e;
    }
  }
}

var sb = A({
  menuitem: !0
}, {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
});

function tb(a, b) {
  if (b) {
    if (sb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));

    if (null != b.dangerouslySetInnerHTML) {
      if (null != b.children) throw Error(p(60));
      if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
    }

    if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
  }
}

function ub(a, b) {
  if (-1 === a.indexOf("-")) return "string" === typeof b.is;

  switch (a) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;

    default:
      return !0;
  }
}

var vb = null;

function wb(a) {
  a = a.target || a.srcElement || window;
  a.correspondingUseElement && (a = a.correspondingUseElement);
  return 3 === a.nodeType ? a.parentNode : a;
}

var xb = null,
    yb = null,
    zb = null;

function Ab(a) {
  if (a = Bb(a)) {
    if ("function" !== typeof xb) throw Error(p(280));
    var b = a.stateNode;
    b && (b = Cb(b), xb(a.stateNode, a.type, b));
  }
}

function Db(a) {
  yb ? zb ? zb.push(a) : zb = [a] : yb = a;
}

function Eb() {
  if (yb) {
    var a = yb,
        b = zb;
    zb = yb = null;
    Ab(a);
    if (b) for (a = 0; a < b.length; a++) {
      Ab(b[a]);
    }
  }
}

function Fb(a, b) {
  return a(b);
}

function Gb() {}

var Hb = !1;

function Ib(a, b, c) {
  if (Hb) return a(b, c);
  Hb = !0;

  try {
    return Fb(a, b, c);
  } finally {
    if (Hb = !1, null !== yb || null !== zb) Gb(), Eb();
  }
}

function Jb(a, b) {
  var c = a.stateNode;
  if (null === c) return null;
  var d = Cb(c);
  if (null === d) return null;
  c = d[b];

  a: switch (b) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
      a = !d;
      break a;

    default:
      a = !1;
  }

  if (a) return null;
  if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
  return c;
}

var Kb = !1;
if (ia) try {
  var Lb = {};
  Object.defineProperty(Lb, "passive", {
    get: function get() {
      Kb = !0;
    }
  });
  window.addEventListener("test", Lb, Lb);
  window.removeEventListener("test", Lb, Lb);
} catch (a) {
  Kb = !1;
}

function Mb(a, b, c, d, e, f, g, h, k) {
  var l = Array.prototype.slice.call(arguments, 3);

  try {
    b.apply(c, l);
  } catch (n) {
    this.onError(n);
  }
}

var Nb = !1,
    Ob = null,
    Pb = !1,
    Qb = null,
    Rb = {
  onError: function onError(a) {
    Nb = !0;
    Ob = a;
  }
};

function Sb(a, b, c, d, e, f, g, h, k) {
  Nb = !1;
  Ob = null;
  Mb.apply(Rb, arguments);
}

function Tb(a, b, c, d, e, f, g, h, k) {
  Sb.apply(this, arguments);

  if (Nb) {
    if (Nb) {
      var l = Ob;
      Nb = !1;
      Ob = null;
    } else throw Error(p(198));

    Pb || (Pb = !0, Qb = l);
  }
}

function Ub(a) {
  var b = a,
      c = a;
  if (a.alternate) for (; b["return"];) {
    b = b["return"];
  } else {
    a = b;

    do {
      b = a, 0 !== (b.flags & 4098) && (c = b["return"]), a = b["return"];
    } while (a);
  }
  return 3 === b.tag ? c : null;
}

function Vb(a) {
  if (13 === a.tag) {
    var b = a.memoizedState;
    null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
    if (null !== b) return b.dehydrated;
  }

  return null;
}

function Wb(a) {
  if (Ub(a) !== a) throw Error(p(188));
}

function Xb(a) {
  var b = a.alternate;

  if (!b) {
    b = Ub(a);
    if (null === b) throw Error(p(188));
    return b !== a ? null : a;
  }

  for (var c = a, d = b;;) {
    var e = c["return"];
    if (null === e) break;
    var f = e.alternate;

    if (null === f) {
      d = e["return"];

      if (null !== d) {
        c = d;
        continue;
      }

      break;
    }

    if (e.child === f.child) {
      for (f = e.child; f;) {
        if (f === c) return Wb(e), a;
        if (f === d) return Wb(e), b;
        f = f.sibling;
      }

      throw Error(p(188));
    }

    if (c["return"] !== d["return"]) c = e, d = f;else {
      for (var g = !1, h = e.child; h;) {
        if (h === c) {
          g = !0;
          c = e;
          d = f;
          break;
        }

        if (h === d) {
          g = !0;
          d = e;
          c = f;
          break;
        }

        h = h.sibling;
      }

      if (!g) {
        for (h = f.child; h;) {
          if (h === c) {
            g = !0;
            c = f;
            d = e;
            break;
          }

          if (h === d) {
            g = !0;
            d = f;
            c = e;
            break;
          }

          h = h.sibling;
        }

        if (!g) throw Error(p(189));
      }
    }
    if (c.alternate !== d) throw Error(p(190));
  }

  if (3 !== c.tag) throw Error(p(188));
  return c.stateNode.current === c ? a : b;
}

function Yb(a) {
  a = Xb(a);
  return null !== a ? Zb(a) : null;
}

function Zb(a) {
  if (5 === a.tag || 6 === a.tag) return a;

  for (a = a.child; null !== a;) {
    var b = Zb(a);
    if (null !== b) return b;
    a = a.sibling;
  }

  return null;
}

var $b = scheduler.unstable_scheduleCallback,
    ac = scheduler.unstable_cancelCallback,
    bc = scheduler.unstable_shouldYield,
    cc = scheduler.unstable_requestPaint,
    B = scheduler.unstable_now,
    dc = scheduler.unstable_getCurrentPriorityLevel,
    ec = scheduler.unstable_ImmediatePriority,
    fc = scheduler.unstable_UserBlockingPriority,
    gc = scheduler.unstable_NormalPriority,
    hc = scheduler.unstable_LowPriority,
    ic = scheduler.unstable_IdlePriority,
    jc = null,
    kc = null;

function lc(a) {
  if (kc && "function" === typeof kc.onCommitFiberRoot) try {
    kc.onCommitFiberRoot(jc, a, void 0, 128 === (a.current.flags & 128));
  } catch (b) {}
}

var nc = Math.clz32 ? Math.clz32 : mc,
    oc = Math.log,
    pc = Math.LN2;

function mc(a) {
  a >>>= 0;
  return 0 === a ? 32 : 31 - (oc(a) / pc | 0) | 0;
}

var qc = 64,
    rc = 4194304;

function sc(a) {
  switch (a & -a) {
    case 1:
      return 1;

    case 2:
      return 2;

    case 4:
      return 4;

    case 8:
      return 8;

    case 16:
      return 16;

    case 32:
      return 32;

    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return a & 4194240;

    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return a & 130023424;

    case 134217728:
      return 134217728;

    case 268435456:
      return 268435456;

    case 536870912:
      return 536870912;

    case 1073741824:
      return 1073741824;

    default:
      return a;
  }
}

function tc(a, b) {
  var c = a.pendingLanes;
  if (0 === c) return 0;
  var d = 0,
      e = a.suspendedLanes,
      f = a.pingedLanes,
      g = c & 268435455;

  if (0 !== g) {
    var h = g & ~e;
    0 !== h ? d = sc(h) : (f &= g, 0 !== f && (d = sc(f)));
  } else g = c & ~e, 0 !== g ? d = sc(g) : 0 !== f && (d = sc(f));

  if (0 === d) return 0;
  if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
  0 !== (d & 4) && (d |= c & 16);
  b = a.entangledLanes;
  if (0 !== b) for (a = a.entanglements, b &= d; 0 < b;) {
    c = 31 - nc(b), e = 1 << c, d |= a[c], b &= ~e;
  }
  return d;
}

function uc(a, b) {
  switch (a) {
    case 1:
    case 2:
    case 4:
      return b + 250;

    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return b + 5E3;

    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;

    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;

    default:
      return -1;
  }
}

function vc(a, b) {
  for (var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;) {
    var g = 31 - nc(f),
        h = 1 << g,
        k = e[g];

    if (-1 === k) {
      if (0 === (h & c) || 0 !== (h & d)) e[g] = uc(h, b);
    } else k <= b && (a.expiredLanes |= h);

    f &= ~h;
  }
}

function wc(a) {
  a = a.pendingLanes & -1073741825;
  return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}

function xc() {
  var a = qc;
  qc <<= 1;
  0 === (qc & 4194240) && (qc = 64);
  return a;
}

function yc(a) {
  for (var b = [], c = 0; 31 > c; c++) {
    b.push(a);
  }

  return b;
}

function zc(a, b, c) {
  a.pendingLanes |= b;
  536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
  a = a.eventTimes;
  b = 31 - nc(b);
  a[b] = c;
}

function Ac(a, b) {
  var c = a.pendingLanes & ~b;
  a.pendingLanes = b;
  a.suspendedLanes = 0;
  a.pingedLanes = 0;
  a.expiredLanes &= b;
  a.mutableReadLanes &= b;
  a.entangledLanes &= b;
  b = a.entanglements;
  var d = a.eventTimes;

  for (a = a.expirationTimes; 0 < c;) {
    var e = 31 - nc(c),
        f = 1 << e;
    b[e] = 0;
    d[e] = -1;
    a[e] = -1;
    c &= ~f;
  }
}

function Bc(a, b) {
  var c = a.entangledLanes |= b;

  for (a = a.entanglements; c;) {
    var d = 31 - nc(c),
        e = 1 << d;
    e & b | a[d] & b && (a[d] |= b);
    c &= ~e;
  }
}

var C = 0;

function Cc(a) {
  a &= -a;
  return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}

var Dc,
    Ec,
    Fc,
    Gc,
    Hc,
    Ic = !1,
    Jc = [],
    Kc = null,
    Lc = null,
    Mc = null,
    Nc = new Map(),
    Oc = new Map(),
    Pc = [],
    Qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");

function Rc(a, b) {
  switch (a) {
    case "focusin":
    case "focusout":
      Kc = null;
      break;

    case "dragenter":
    case "dragleave":
      Lc = null;
      break;

    case "mouseover":
    case "mouseout":
      Mc = null;
      break;

    case "pointerover":
    case "pointerout":
      Nc["delete"](b.pointerId);
      break;

    case "gotpointercapture":
    case "lostpointercapture":
      Oc["delete"](b.pointerId);
  }
}

function Sc(a, b, c, d, e, f) {
  if (null === a || a.nativeEvent !== f) return a = {
    blockedOn: b,
    domEventName: c,
    eventSystemFlags: d,
    nativeEvent: f,
    targetContainers: [e]
  }, null !== b && (b = Bb(b), null !== b && Ec(b)), a;
  a.eventSystemFlags |= d;
  b = a.targetContainers;
  null !== e && -1 === b.indexOf(e) && b.push(e);
  return a;
}

function Tc(a, b, c, d, e) {
  switch (b) {
    case "focusin":
      return Kc = Sc(Kc, a, b, c, d, e), !0;

    case "dragenter":
      return Lc = Sc(Lc, a, b, c, d, e), !0;

    case "mouseover":
      return Mc = Sc(Mc, a, b, c, d, e), !0;

    case "pointerover":
      var f = e.pointerId;
      Nc.set(f, Sc(Nc.get(f) || null, a, b, c, d, e));
      return !0;

    case "gotpointercapture":
      return f = e.pointerId, Oc.set(f, Sc(Oc.get(f) || null, a, b, c, d, e)), !0;
  }

  return !1;
}

function Uc(a) {
  var b = Vc(a.target);

  if (null !== b) {
    var c = Ub(b);
    if (null !== c) if (b = c.tag, 13 === b) {
      if (b = Vb(c), null !== b) {
        a.blockedOn = b;
        Hc(a.priority, function () {
          Fc(c);
        });
        return;
      }
    } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
      a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
      return;
    }
  }

  a.blockedOn = null;
}

function Wc(a) {
  if (null !== a.blockedOn) return !1;

  for (var b = a.targetContainers; 0 < b.length;) {
    var c = Xc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);

    if (null === c) {
      c = a.nativeEvent;
      var d = new c.constructor(c.type, c);
      vb = d;
      c.target.dispatchEvent(d);
      vb = null;
    } else return b = Bb(c), null !== b && Ec(b), a.blockedOn = c, !1;

    b.shift();
  }

  return !0;
}

function Yc(a, b, c) {
  Wc(a) && c["delete"](b);
}

function Zc() {
  Ic = !1;
  null !== Kc && Wc(Kc) && (Kc = null);
  null !== Lc && Wc(Lc) && (Lc = null);
  null !== Mc && Wc(Mc) && (Mc = null);
  Nc.forEach(Yc);
  Oc.forEach(Yc);
}

function $c(a, b) {
  a.blockedOn === b && (a.blockedOn = null, Ic || (Ic = !0, scheduler.unstable_scheduleCallback(scheduler.unstable_NormalPriority, Zc)));
}

function ad(a) {
  function b(b) {
    return $c(b, a);
  }

  if (0 < Jc.length) {
    $c(Jc[0], a);

    for (var c = 1; c < Jc.length; c++) {
      var d = Jc[c];
      d.blockedOn === a && (d.blockedOn = null);
    }
  }

  null !== Kc && $c(Kc, a);
  null !== Lc && $c(Lc, a);
  null !== Mc && $c(Mc, a);
  Nc.forEach(b);
  Oc.forEach(b);

  for (c = 0; c < Pc.length; c++) {
    d = Pc[c], d.blockedOn === a && (d.blockedOn = null);
  }

  for (; 0 < Pc.length && (c = Pc[0], null === c.blockedOn);) {
    Uc(c), null === c.blockedOn && Pc.shift();
  }
}

var bd = ta.ReactCurrentBatchConfig,
    cd = !0;

function dd(a, b, c, d) {
  var e = C,
      f = bd.transition;
  bd.transition = null;

  try {
    C = 1, ed(a, b, c, d);
  } finally {
    C = e, bd.transition = f;
  }
}

function fd(a, b, c, d) {
  var e = C,
      f = bd.transition;
  bd.transition = null;

  try {
    C = 4, ed(a, b, c, d);
  } finally {
    C = e, bd.transition = f;
  }
}

function ed(a, b, c, d) {
  if (cd) {
    var e = Xc(a, b, c, d);
    if (null === e) gd(a, b, d, hd, c), Rc(a, d);else if (Tc(e, a, b, c, d)) d.stopPropagation();else if (Rc(a, d), b & 4 && -1 < Qc.indexOf(a)) {
      for (; null !== e;) {
        var f = Bb(e);
        null !== f && Dc(f);
        f = Xc(a, b, c, d);
        null === f && gd(a, b, d, hd, c);
        if (f === e) break;
        e = f;
      }

      null !== e && d.stopPropagation();
    } else gd(a, b, d, null, c);
  }
}

var hd = null;

function Xc(a, b, c, d) {
  hd = null;
  a = wb(d);
  a = Vc(a);
  if (null !== a) if (b = Ub(a), null === b) a = null;else if (c = b.tag, 13 === c) {
    a = Vb(b);
    if (null !== a) return a;
    a = null;
  } else if (3 === c) {
    if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
    a = null;
  } else b !== a && (a = null);
  hd = a;
  return null;
}

function id(a) {
  switch (a) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;

    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;

    case "message":
      switch (dc()) {
        case ec:
          return 1;

        case fc:
          return 4;

        case gc:
        case hc:
          return 16;

        case ic:
          return 536870912;

        default:
          return 16;
      }

    default:
      return 16;
  }
}

var jd = null,
    kd = null,
    ld = null;

function md() {
  if (ld) return ld;
  var a,
      b = kd,
      c = b.length,
      d,
      e = "value" in jd ? jd.value : jd.textContent,
      f = e.length;

  for (a = 0; a < c && b[a] === e[a]; a++) {
  }

  var g = c - a;

  for (d = 1; d <= g && b[c - d] === e[f - d]; d++) {
  }

  return ld = e.slice(a, 1 < d ? 1 - d : void 0);
}

function nd(a) {
  var b = a.keyCode;
  "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
  10 === a && (a = 13);
  return 32 <= a || 13 === a ? a : 0;
}

function od() {
  return !0;
}

function pd() {
  return !1;
}

function qd(a) {
  function b(b, d, e, f, g) {
    this._reactName = b;
    this._targetInst = e;
    this.type = d;
    this.nativeEvent = f;
    this.target = g;
    this.currentTarget = null;

    for (var c in a) {
      a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
    }

    this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? od : pd;
    this.isPropagationStopped = pd;
    return this;
  }

  A(b.prototype, {
    preventDefault: function preventDefault() {
      this.defaultPrevented = !0;
      var a = this.nativeEvent;
      a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = od);
    },
    stopPropagation: function stopPropagation() {
      var a = this.nativeEvent;
      a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = od);
    },
    persist: function persist() {},
    isPersistent: od
  });
  return b;
}

var rd = {
  eventPhase: 0,
  bubbles: 0,
  cancelable: 0,
  timeStamp: function timeStamp(a) {
    return a.timeStamp || Date.now();
  },
  defaultPrevented: 0,
  isTrusted: 0
},
    sd = qd(rd),
    td = A({}, rd, {
  view: 0,
  detail: 0
}),
    ud = qd(td),
    vd,
    wd,
    xd,
    zd = A({}, td, {
  screenX: 0,
  screenY: 0,
  clientX: 0,
  clientY: 0,
  pageX: 0,
  pageY: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  getModifierState: yd,
  button: 0,
  buttons: 0,
  relatedTarget: function relatedTarget(a) {
    return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
  },
  movementX: function movementX(a) {
    if ("movementX" in a) return a.movementX;
    a !== xd && (xd && "mousemove" === a.type ? (vd = a.screenX - xd.screenX, wd = a.screenY - xd.screenY) : wd = vd = 0, xd = a);
    return vd;
  },
  movementY: function movementY(a) {
    return "movementY" in a ? a.movementY : wd;
  }
}),
    Ad = qd(zd),
    Bd = A({}, zd, {
  dataTransfer: 0
}),
    Cd = qd(Bd),
    Dd = A({}, td, {
  relatedTarget: 0
}),
    Ed = qd(Dd),
    Fd = A({}, rd, {
  animationName: 0,
  elapsedTime: 0,
  pseudoElement: 0
}),
    Gd = qd(Fd),
    Hd = A({}, rd, {
  clipboardData: function clipboardData(a) {
    return "clipboardData" in a ? a.clipboardData : window.clipboardData;
  }
}),
    Id = qd(Hd),
    Jd = A({}, rd, {
  data: 0
}),
    Kd = qd(Jd),
    Ld = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
},
    Md = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
},
    Nd = {
  Alt: "altKey",
  Control: "ctrlKey",
  Meta: "metaKey",
  Shift: "shiftKey"
};

function Od(a) {
  var b = this.nativeEvent;
  return b.getModifierState ? b.getModifierState(a) : (a = Nd[a]) ? !!b[a] : !1;
}

function yd() {
  return Od;
}

var Pd = A({}, td, {
  key: function key(a) {
    if (a.key) {
      var b = Ld[a.key] || a.key;
      if ("Unidentified" !== b) return b;
    }

    return "keypress" === a.type ? (a = nd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Md[a.keyCode] || "Unidentified" : "";
  },
  code: 0,
  location: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  repeat: 0,
  locale: 0,
  getModifierState: yd,
  charCode: function charCode(a) {
    return "keypress" === a.type ? nd(a) : 0;
  },
  keyCode: function keyCode(a) {
    return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  },
  which: function which(a) {
    return "keypress" === a.type ? nd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  }
}),
    Qd = qd(Pd),
    Rd = A({}, zd, {
  pointerId: 0,
  width: 0,
  height: 0,
  pressure: 0,
  tangentialPressure: 0,
  tiltX: 0,
  tiltY: 0,
  twist: 0,
  pointerType: 0,
  isPrimary: 0
}),
    Sd = qd(Rd),
    Td = A({}, td, {
  touches: 0,
  targetTouches: 0,
  changedTouches: 0,
  altKey: 0,
  metaKey: 0,
  ctrlKey: 0,
  shiftKey: 0,
  getModifierState: yd
}),
    Ud = qd(Td),
    Vd = A({}, rd, {
  propertyName: 0,
  elapsedTime: 0,
  pseudoElement: 0
}),
    Wd = qd(Vd),
    Xd = A({}, zd, {
  deltaX: function deltaX(a) {
    return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
  },
  deltaY: function deltaY(a) {
    return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}),
    Yd = qd(Xd),
    Zd = [9, 13, 27, 32],
    $d = ia && "CompositionEvent" in window,
    ae = null;
ia && "documentMode" in document && (ae = document.documentMode);
var be = ia && "TextEvent" in window && !ae,
    ce = ia && (!$d || ae && 8 < ae && 11 >= ae),
    de = String.fromCharCode(32),
    ee = !1;

function fe(a, b) {
  switch (a) {
    case "keyup":
      return -1 !== Zd.indexOf(b.keyCode);

    case "keydown":
      return 229 !== b.keyCode;

    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;

    default:
      return !1;
  }
}

function ge(a) {
  a = a.detail;
  return "object" === typeof a && "data" in a ? a.data : null;
}

var he = !1;

function ie(a, b) {
  switch (a) {
    case "compositionend":
      return ge(b);

    case "keypress":
      if (32 !== b.which) return null;
      ee = !0;
      return de;

    case "textInput":
      return a = b.data, a === de && ee ? null : a;

    default:
      return null;
  }
}

function je(a, b) {
  if (he) return "compositionend" === a || !$d && fe(a, b) ? (a = md(), ld = kd = jd = null, he = !1, a) : null;

  switch (a) {
    case "paste":
      return null;

    case "keypress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b["char"] && 1 < b["char"].length) return b["char"];
        if (b.which) return String.fromCharCode(b.which);
      }

      return null;

    case "compositionend":
      return ce && "ko" !== b.locale ? null : b.data;

    default:
      return null;
  }
}

var ke = {
  color: !0,
  date: !0,
  datetime: !0,
  "datetime-local": !0,
  email: !0,
  month: !0,
  number: !0,
  password: !0,
  range: !0,
  search: !0,
  tel: !0,
  text: !0,
  time: !0,
  url: !0,
  week: !0
};

function le(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return "input" === b ? !!ke[a.type] : "textarea" === b ? !0 : !1;
}

function me(a, b, c, d) {
  Db(d);
  b = ne(b, "onChange");
  0 < b.length && (c = new sd("onChange", "change", null, c, d), a.push({
    event: c,
    listeners: b
  }));
}

var oe = null,
    pe = null;

function qe(a) {
  re(a, 0);
}

function se(a) {
  var b = te(a);
  if (Va(b)) return a;
}

function ue(a, b) {
  if ("change" === a) return b;
}

var ve = !1;

if (ia) {
  var we;

  if (ia) {
    var xe = ("oninput" in document);

    if (!xe) {
      var ye = document.createElement("div");
      ye.setAttribute("oninput", "return;");
      xe = "function" === typeof ye.oninput;
    }

    we = xe;
  } else we = !1;

  ve = we && (!document.documentMode || 9 < document.documentMode);
}

function ze() {
  oe && (oe.detachEvent("onpropertychange", Ae), pe = oe = null);
}

function Ae(a) {
  if ("value" === a.propertyName && se(pe)) {
    var b = [];
    me(b, pe, a, wb(a));
    Ib(qe, b);
  }
}

function Be(a, b, c) {
  "focusin" === a ? (ze(), oe = b, pe = c, oe.attachEvent("onpropertychange", Ae)) : "focusout" === a && ze();
}

function Ce(a) {
  if ("selectionchange" === a || "keyup" === a || "keydown" === a) return se(pe);
}

function De(a, b) {
  if ("click" === a) return se(b);
}

function Ee(a, b) {
  if ("input" === a || "change" === a) return se(b);
}

function Fe(a, b) {
  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}

var Ge = "function" === typeof Object.is ? Object.is : Fe;

function He(a, b) {
  if (Ge(a, b)) return !0;
  if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
  var c = Object.keys(a),
      d = Object.keys(b);
  if (c.length !== d.length) return !1;

  for (d = 0; d < c.length; d++) {
    var e = c[d];
    if (!ja.call(b, e) || !Ge(a[e], b[e])) return !1;
  }

  return !0;
}

function Ie(a) {
  for (; a && a.firstChild;) {
    a = a.firstChild;
  }

  return a;
}

function Je(a, b) {
  var c = Ie(a);
  a = 0;

  for (var d; c;) {
    if (3 === c.nodeType) {
      d = a + c.textContent.length;
      if (a <= b && d >= b) return {
        node: c,
        offset: b - a
      };
      a = d;
    }

    a: {
      for (; c;) {
        if (c.nextSibling) {
          c = c.nextSibling;
          break a;
        }

        c = c.parentNode;
      }

      c = void 0;
    }

    c = Ie(c);
  }
}

function Ke(a, b) {
  return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Ke(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}

function Le() {
  for (var a = window, b = Wa(); b instanceof a.HTMLIFrameElement;) {
    try {
      var c = "string" === typeof b.contentWindow.location.href;
    } catch (d) {
      c = !1;
    }

    if (c) a = b.contentWindow;else break;
    b = Wa(a.document);
  }

  return b;
}

function Me(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}

function Ne(a) {
  var b = Le(),
      c = a.focusedElem,
      d = a.selectionRange;

  if (b !== c && c && c.ownerDocument && Ke(c.ownerDocument.documentElement, c)) {
    if (null !== d && Me(c)) if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
      a = a.getSelection();
      var e = c.textContent.length,
          f = Math.min(d.start, e);
      d = void 0 === d.end ? f : Math.min(d.end, e);
      !a.extend && f > d && (e = d, d = f, f = e);
      e = Je(c, f);
      var g = Je(c, d);
      e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
    }
    b = [];

    for (a = c; a = a.parentNode;) {
      1 === a.nodeType && b.push({
        element: a,
        left: a.scrollLeft,
        top: a.scrollTop
      });
    }

    "function" === typeof c.focus && c.focus();

    for (c = 0; c < b.length; c++) {
      a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
  }
}

var Oe = ia && "documentMode" in document && 11 >= document.documentMode,
    Pe = null,
    Qe = null,
    Re = null,
    Se = !1;

function Te(a, b, c) {
  var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
  Se || null == Pe || Pe !== Wa(d) || (d = Pe, "selectionStart" in d && Me(d) ? d = {
    start: d.selectionStart,
    end: d.selectionEnd
  } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
    anchorNode: d.anchorNode,
    anchorOffset: d.anchorOffset,
    focusNode: d.focusNode,
    focusOffset: d.focusOffset
  }), Re && He(Re, d) || (Re = d, d = ne(Qe, "onSelect"), 0 < d.length && (b = new sd("onSelect", "select", null, b, c), a.push({
    event: b,
    listeners: d
  }), b.target = Pe)));
}

function Ue(a, b) {
  var c = {};
  c[a.toLowerCase()] = b.toLowerCase();
  c["Webkit" + a] = "webkit" + b;
  c["Moz" + a] = "moz" + b;
  return c;
}

var Ve = {
  animationend: Ue("Animation", "AnimationEnd"),
  animationiteration: Ue("Animation", "AnimationIteration"),
  animationstart: Ue("Animation", "AnimationStart"),
  transitionend: Ue("Transition", "TransitionEnd")
},
    We = {},
    Xe = {};
ia && (Xe = document.createElement("div").style, "AnimationEvent" in window || (delete Ve.animationend.animation, delete Ve.animationiteration.animation, delete Ve.animationstart.animation), "TransitionEvent" in window || delete Ve.transitionend.transition);

function Ye(a) {
  if (We[a]) return We[a];
  if (!Ve[a]) return a;
  var b = Ve[a],
      c;

  for (c in b) {
    if (b.hasOwnProperty(c) && c in Xe) return We[a] = b[c];
  }

  return a;
}

var Ze = Ye("animationend"),
    $e = Ye("animationiteration"),
    af = Ye("animationstart"),
    bf = Ye("transitionend"),
    cf = new Map(),
    df = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");

function ef(a, b) {
  cf.set(a, b);
  fa(b, [a]);
}

for (var ff = 0; ff < df.length; ff++) {
  var gf = df[ff],
      hf = gf.toLowerCase(),
      jf = gf[0].toUpperCase() + gf.slice(1);
  ef(hf, "on" + jf);
}

ef(Ze, "onAnimationEnd");
ef($e, "onAnimationIteration");
ef(af, "onAnimationStart");
ef("dblclick", "onDoubleClick");
ef("focusin", "onFocus");
ef("focusout", "onBlur");
ef(bf, "onTransitionEnd");
ha("onMouseEnter", ["mouseout", "mouseover"]);
ha("onMouseLeave", ["mouseout", "mouseover"]);
ha("onPointerEnter", ["pointerout", "pointerover"]);
ha("onPointerLeave", ["pointerout", "pointerover"]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var kf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
    lf = new Set("cancel close invalid load scroll toggle".split(" ").concat(kf));

function mf(a, b, c) {
  var d = a.type || "unknown-event";
  a.currentTarget = c;
  Tb(d, b, void 0, a);
  a.currentTarget = null;
}

function re(a, b) {
  b = 0 !== (b & 4);

  for (var c = 0; c < a.length; c++) {
    var d = a[c],
        e = d.event;
    d = d.listeners;

    a: {
      var f = void 0;
      if (b) for (var g = d.length - 1; 0 <= g; g--) {
        var h = d[g],
            k = h.instance,
            l = h.currentTarget;
        h = h.listener;
        if (k !== f && e.isPropagationStopped()) break a;
        mf(e, h, l);
        f = k;
      } else for (g = 0; g < d.length; g++) {
        h = d[g];
        k = h.instance;
        l = h.currentTarget;
        h = h.listener;
        if (k !== f && e.isPropagationStopped()) break a;
        mf(e, h, l);
        f = k;
      }
    }
  }

  if (Pb) throw a = Qb, Pb = !1, Qb = null, a;
}

function D(a, b) {
  var c = b[nf];
  void 0 === c && (c = b[nf] = new Set());
  var d = a + "__bubble";
  c.has(d) || (of(b, a, 2, !1), c.add(d));
}

function pf(a, b, c) {
  var d = 0;
  b && (d |= 4);
  of(c, a, d, b);
}

var qf = "_reactListening" + Math.random().toString(36).slice(2);

function rf(a) {
  if (!a[qf]) {
    a[qf] = !0;
    da.forEach(function (b) {
      "selectionchange" !== b && (lf.has(b) || pf(b, !1, a), pf(b, !0, a));
    });
    var b = 9 === a.nodeType ? a : a.ownerDocument;
    null === b || b[qf] || (b[qf] = !0, pf("selectionchange", !1, b));
  }
}

function of(a, b, c, d) {
  switch (id(b)) {
    case 1:
      var e = dd;
      break;

    case 4:
      e = fd;
      break;

    default:
      e = ed;
  }

  c = e.bind(null, b, c, a);
  e = void 0;
  !Kb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
  d ? void 0 !== e ? a.addEventListener(b, c, {
    capture: !0,
    passive: e
  }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
    passive: e
  }) : a.addEventListener(b, c, !1);
}

function gd(a, b, c, d, e) {
  var f = d;
  if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for (;;) {
    if (null === d) return;
    var g = d.tag;

    if (3 === g || 4 === g) {
      var h = d.stateNode.containerInfo;
      if (h === e || 8 === h.nodeType && h.parentNode === e) break;
      if (4 === g) for (g = d["return"]; null !== g;) {
        var k = g.tag;
        if (3 === k || 4 === k) if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
        g = g["return"];
      }

      for (; null !== h;) {
        g = Vc(h);
        if (null === g) return;
        k = g.tag;

        if (5 === k || 6 === k) {
          d = f = g;
          continue a;
        }

        h = h.parentNode;
      }
    }

    d = d["return"];
  }
  Ib(function () {
    var d = f,
        e = wb(c),
        g = [];

    a: {
      var h = cf.get(a);

      if (void 0 !== h) {
        var k = sd,
            m = a;

        switch (a) {
          case "keypress":
            if (0 === nd(c)) break a;

          case "keydown":
          case "keyup":
            k = Qd;
            break;

          case "focusin":
            m = "focus";
            k = Ed;
            break;

          case "focusout":
            m = "blur";
            k = Ed;
            break;

          case "beforeblur":
          case "afterblur":
            k = Ed;
            break;

          case "click":
            if (2 === c.button) break a;

          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            k = Ad;
            break;

          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            k = Cd;
            break;

          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            k = Ud;
            break;

          case Ze:
          case $e:
          case af:
            k = Gd;
            break;

          case bf:
            k = Wd;
            break;

          case "scroll":
            k = ud;
            break;

          case "wheel":
            k = Yd;
            break;

          case "copy":
          case "cut":
          case "paste":
            k = Id;
            break;

          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            k = Sd;
        }

        var w = 0 !== (b & 4),
            J = !w && "scroll" === a,
            v = w ? null !== h ? h + "Capture" : null : h;
        w = [];

        for (var x = d, r; null !== x;) {
          r = x;
          var F = r.stateNode;
          5 === r.tag && null !== F && (r = F, null !== v && (F = Jb(x, v), null != F && w.push(sf(x, F, r))));
          if (J) break;
          x = x["return"];
        }

        0 < w.length && (h = new k(h, m, null, c, e), g.push({
          event: h,
          listeners: w
        }));
      }
    }

    if (0 === (b & 7)) {
      a: {
        h = "mouseover" === a || "pointerover" === a;
        k = "mouseout" === a || "pointerout" === a;
        if (h && c !== vb && (m = c.relatedTarget || c.fromElement) && (Vc(m) || m[tf])) break a;

        if (k || h) {
          h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;

          if (k) {
            if (m = c.relatedTarget || c.toElement, k = d, m = m ? Vc(m) : null, null !== m && (J = Ub(m), m !== J || 5 !== m.tag && 6 !== m.tag)) m = null;
          } else k = null, m = d;

          if (k !== m) {
            w = Ad;
            F = "onMouseLeave";
            v = "onMouseEnter";
            x = "mouse";
            if ("pointerout" === a || "pointerover" === a) w = Sd, F = "onPointerLeave", v = "onPointerEnter", x = "pointer";
            J = null == k ? h : te(k);
            r = null == m ? h : te(m);
            h = new w(F, x + "leave", k, c, e);
            h.target = J;
            h.relatedTarget = r;
            F = null;
            Vc(e) === d && (w = new w(v, x + "enter", m, c, e), w.target = r, w.relatedTarget = J, F = w);
            J = F;
            if (k && m) b: {
              w = k;
              v = m;
              x = 0;

              for (r = w; r; r = uf(r)) {
                x++;
              }

              r = 0;

              for (F = v; F; F = uf(F)) {
                r++;
              }

              for (; 0 < x - r;) {
                w = uf(w), x--;
              }

              for (; 0 < r - x;) {
                v = uf(v), r--;
              }

              for (; x--;) {
                if (w === v || null !== v && w === v.alternate) break b;
                w = uf(w);
                v = uf(v);
              }

              w = null;
            } else w = null;
            null !== k && vf(g, h, k, w, !1);
            null !== m && null !== J && vf(g, J, m, w, !0);
          }
        }
      }

      a: {
        h = d ? te(d) : window;
        k = h.nodeName && h.nodeName.toLowerCase();
        if ("select" === k || "input" === k && "file" === h.type) var Z = ue;else if (le(h)) {
          if (ve) Z = Ee;else {
            Z = Ce;
            var ya = Be;
          }
        } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (Z = De);

        if (Z && (Z = Z(a, d))) {
          me(g, Z, c, e);
          break a;
        }

        ya && ya(a, h, d);
        "focusout" === a && (ya = h._wrapperState) && ya.controlled && "number" === h.type && bb(h, "number", h.value);
      }

      ya = d ? te(d) : window;

      switch (a) {
        case "focusin":
          if (le(ya) || "true" === ya.contentEditable) Pe = ya, Qe = d, Re = null;
          break;

        case "focusout":
          Re = Qe = Pe = null;
          break;

        case "mousedown":
          Se = !0;
          break;

        case "contextmenu":
        case "mouseup":
        case "dragend":
          Se = !1;
          Te(g, c, e);
          break;

        case "selectionchange":
          if (Oe) break;

        case "keydown":
        case "keyup":
          Te(g, c, e);
      }

      var ab;
      if ($d) b: {
        switch (a) {
          case "compositionstart":
            var ca = "onCompositionStart";
            break b;

          case "compositionend":
            ca = "onCompositionEnd";
            break b;

          case "compositionupdate":
            ca = "onCompositionUpdate";
            break b;
        }

        ca = void 0;
      } else he ? fe(a, c) && (ca = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ca = "onCompositionStart");
      ca && (ce && "ko" !== c.locale && (he || "onCompositionStart" !== ca ? "onCompositionEnd" === ca && he && (ab = md()) : (jd = e, kd = "value" in jd ? jd.value : jd.textContent, he = !0)), ya = ne(d, ca), 0 < ya.length && (ca = new Kd(ca, a, null, c, e), g.push({
        event: ca,
        listeners: ya
      }), ab ? ca.data = ab : (ab = ge(c), null !== ab && (ca.data = ab))));
      if (ab = be ? ie(a, c) : je(a, c)) d = ne(d, "onBeforeInput"), 0 < d.length && (e = new Kd("onBeforeInput", "beforeinput", null, c, e), g.push({
        event: e,
        listeners: d
      }), e.data = ab);
    }

    re(g, b);
  });
}

function sf(a, b, c) {
  return {
    instance: a,
    listener: b,
    currentTarget: c
  };
}

function ne(a, b) {
  for (var c = b + "Capture", d = []; null !== a;) {
    var e = a,
        f = e.stateNode;
    5 === e.tag && null !== f && (e = f, f = Jb(a, c), null != f && d.unshift(sf(a, f, e)), f = Jb(a, b), null != f && d.push(sf(a, f, e)));
    a = a["return"];
  }

  return d;
}

function uf(a) {
  if (null === a) return null;

  do {
    a = a["return"];
  } while (a && 5 !== a.tag);

  return a ? a : null;
}

function vf(a, b, c, d, e) {
  for (var f = b._reactName, g = []; null !== c && c !== d;) {
    var h = c,
        k = h.alternate,
        l = h.stateNode;
    if (null !== k && k === d) break;
    5 === h.tag && null !== l && (h = l, e ? (k = Jb(c, f), null != k && g.unshift(sf(c, k, h))) : e || (k = Jb(c, f), null != k && g.push(sf(c, k, h))));
    c = c["return"];
  }

  0 !== g.length && a.push({
    event: b,
    listeners: g
  });
}

var wf = /\r\n?/g,
    xf = /\u0000|\uFFFD/g;

function yf(a) {
  return ("string" === typeof a ? a : "" + a).replace(wf, "\n").replace(xf, "");
}

function zf(a, b, c) {
  b = yf(b);
  if (yf(a) !== b && c) throw Error(p(425));
}

function Af() {}

var Bf = null,
    Cf = null;

function Df(a, b) {
  return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}

var Ef = "function" === typeof setTimeout ? setTimeout : void 0,
    Ff = "function" === typeof clearTimeout ? clearTimeout : void 0,
    Gf = "function" === typeof Promise ? Promise : void 0,
    If = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Gf ? function (a) {
  return Gf.resolve(null).then(a)["catch"](Hf);
} : Ef;

function Hf(a) {
  setTimeout(function () {
    throw a;
  });
}

function Jf(a, b) {
  var c = b,
      d = 0;

  do {
    var e = c.nextSibling;
    a.removeChild(c);
    if (e && 8 === e.nodeType) if (c = e.data, "/$" === c) {
      if (0 === d) {
        a.removeChild(e);
        ad(b);
        return;
      }

      d--;
    } else "$" !== c && "$?" !== c && "$!" !== c || d++;
    c = e;
  } while (c);

  ad(b);
}

function Kf(a) {
  for (; null != a; a = a.nextSibling) {
    var b = a.nodeType;
    if (1 === b || 3 === b) break;

    if (8 === b) {
      b = a.data;
      if ("$" === b || "$!" === b || "$?" === b) break;
      if ("/$" === b) return null;
    }
  }

  return a;
}

function Lf(a) {
  a = a.previousSibling;

  for (var b = 0; a;) {
    if (8 === a.nodeType) {
      var c = a.data;

      if ("$" === c || "$!" === c || "$?" === c) {
        if (0 === b) return a;
        b--;
      } else "/$" === c && b++;
    }

    a = a.previousSibling;
  }

  return null;
}

var Mf = Math.random().toString(36).slice(2),
    Nf = "__reactFiber$" + Mf,
    Of = "__reactProps$" + Mf,
    tf = "__reactContainer$" + Mf,
    nf = "__reactEvents$" + Mf,
    Pf = "__reactListeners$" + Mf,
    Qf = "__reactHandles$" + Mf;

function Vc(a) {
  var b = a[Nf];
  if (b) return b;

  for (var c = a.parentNode; c;) {
    if (b = c[tf] || c[Nf]) {
      c = b.alternate;
      if (null !== b.child || null !== c && null !== c.child) for (a = Lf(a); null !== a;) {
        if (c = a[Nf]) return c;
        a = Lf(a);
      }
      return b;
    }

    a = c;
    c = a.parentNode;
  }

  return null;
}

function Bb(a) {
  a = a[Nf] || a[tf];
  return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}

function te(a) {
  if (5 === a.tag || 6 === a.tag) return a.stateNode;
  throw Error(p(33));
}

function Cb(a) {
  return a[Of] || null;
}

var Rf = [],
    Sf = -1;

function Tf(a) {
  return {
    current: a
  };
}

function E(a) {
  0 > Sf || (a.current = Rf[Sf], Rf[Sf] = null, Sf--);
}

function G(a, b) {
  Sf++;
  Rf[Sf] = a.current;
  a.current = b;
}

var Uf = {},
    H = Tf(Uf),
    Vf = Tf(!1),
    Wf = Uf;

function Xf(a, b) {
  var c = a.type.contextTypes;
  if (!c) return Uf;
  var d = a.stateNode;
  if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
  var e = {},
      f;

  for (f in c) {
    e[f] = b[f];
  }

  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
  return e;
}

function Yf(a) {
  a = a.childContextTypes;
  return null !== a && void 0 !== a;
}

function Zf() {
  E(Vf);
  E(H);
}

function $f(a, b, c) {
  if (H.current !== Uf) throw Error(p(168));
  G(H, b);
  G(Vf, c);
}

function ag(a, b, c) {
  var d = a.stateNode;
  b = b.childContextTypes;
  if ("function" !== typeof d.getChildContext) return c;
  d = d.getChildContext();

  for (var e in d) {
    if (!(e in b)) throw Error(p(108, Qa(a) || "Unknown", e));
  }

  return A({}, c, d);
}

function bg(a) {
  a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Uf;
  Wf = H.current;
  G(H, a);
  G(Vf, Vf.current);
  return !0;
}

function cg(a, b, c) {
  var d = a.stateNode;
  if (!d) throw Error(p(169));
  c ? (a = ag(a, b, Wf), d.__reactInternalMemoizedMergedChildContext = a, E(Vf), E(H), G(H, a)) : E(Vf);
  G(Vf, c);
}

var dg = null,
    eg = !1,
    fg = !1;

function gg(a) {
  null === dg ? dg = [a] : dg.push(a);
}

function hg(a) {
  eg = !0;
  gg(a);
}

function ig() {
  if (!fg && null !== dg) {
    fg = !0;
    var a = 0,
        b = C;

    try {
      var c = dg;

      for (C = 1; a < c.length; a++) {
        var d = c[a];

        do {
          d = d(!0);
        } while (null !== d);
      }

      dg = null;
      eg = !1;
    } catch (e) {
      throw null !== dg && (dg = dg.slice(a + 1)), $b(ec, ig), e;
    } finally {
      C = b, fg = !1;
    }
  }

  return null;
}

var jg = ta.ReactCurrentBatchConfig;

function kg(a, b) {
  if (a && a.defaultProps) {
    b = A({}, b);
    a = a.defaultProps;

    for (var c in a) {
      void 0 === b[c] && (b[c] = a[c]);
    }

    return b;
  }

  return b;
}

var lg = Tf(null),
    mg = null,
    ng = null,
    og = null;

function pg() {
  og = ng = mg = null;
}

function qg(a) {
  var b = lg.current;
  E(lg);
  a._currentValue = b;
}

function rg(a, b, c) {
  for (; null !== a;) {
    var d = a.alternate;
    (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
    if (a === c) break;
    a = a["return"];
  }
}

function sg(a, b) {
  mg = a;
  og = ng = null;
  a = a.dependencies;
  null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (tg = !0), a.firstContext = null);
}

function ug(a) {
  var b = a._currentValue;
  if (og !== a) if (a = {
    context: a,
    memoizedValue: b,
    next: null
  }, null === ng) {
    if (null === mg) throw Error(p(308));
    ng = a;
    mg.dependencies = {
      lanes: 0,
      firstContext: a
    };
  } else ng = ng.next = a;
  return b;
}

var vg = null,
    wg = !1;

function xg(a) {
  a.updateQueue = {
    baseState: a.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: {
      pending: null,
      interleaved: null,
      lanes: 0
    },
    effects: null
  };
}

function yg(a, b) {
  a = a.updateQueue;
  b.updateQueue === a && (b.updateQueue = {
    baseState: a.baseState,
    firstBaseUpdate: a.firstBaseUpdate,
    lastBaseUpdate: a.lastBaseUpdate,
    shared: a.shared,
    effects: a.effects
  });
}

function zg(a, b) {
  return {
    eventTime: a,
    lane: b,
    tag: 0,
    payload: null,
    callback: null,
    next: null
  };
}

function Ag(a, b) {
  var c = a.updateQueue;
  null !== c && (c = c.shared, Bg(a) ? (a = c.interleaved, null === a ? (b.next = b, null === vg ? vg = [c] : vg.push(c)) : (b.next = a.next, a.next = b), c.interleaved = b) : (a = c.pending, null === a ? b.next = b : (b.next = a.next, a.next = b), c.pending = b));
}

function Cg(a, b, c) {
  b = b.updateQueue;

  if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
    var d = b.lanes;
    d &= a.pendingLanes;
    c |= d;
    b.lanes = c;
    Bc(a, c);
  }
}

function Dg(a, b) {
  var c = a.updateQueue,
      d = a.alternate;

  if (null !== d && (d = d.updateQueue, c === d)) {
    var e = null,
        f = null;
    c = c.firstBaseUpdate;

    if (null !== c) {
      do {
        var g = {
          eventTime: c.eventTime,
          lane: c.lane,
          tag: c.tag,
          payload: c.payload,
          callback: c.callback,
          next: null
        };
        null === f ? e = f = g : f = f.next = g;
        c = c.next;
      } while (null !== c);

      null === f ? e = f = b : f = f.next = b;
    } else e = f = b;

    c = {
      baseState: d.baseState,
      firstBaseUpdate: e,
      lastBaseUpdate: f,
      shared: d.shared,
      effects: d.effects
    };
    a.updateQueue = c;
    return;
  }

  a = c.lastBaseUpdate;
  null === a ? c.firstBaseUpdate = b : a.next = b;
  c.lastBaseUpdate = b;
}

function Eg(a, b, c, d) {
  var e = a.updateQueue;
  wg = !1;
  var f = e.firstBaseUpdate,
      g = e.lastBaseUpdate,
      h = e.shared.pending;

  if (null !== h) {
    e.shared.pending = null;
    var k = h,
        l = k.next;
    k.next = null;
    null === g ? f = l : g.next = l;
    g = k;
    var n = a.alternate;
    null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
  }

  if (null !== f) {
    var u = e.baseState;
    g = 0;
    n = l = k = null;
    h = f;

    do {
      var q = h.lane,
          y = h.eventTime;

      if ((d & q) === q) {
        null !== n && (n = n.next = {
          eventTime: y,
          lane: 0,
          tag: h.tag,
          payload: h.payload,
          callback: h.callback,
          next: null
        });

        a: {
          var m = a,
              w = h;
          q = b;
          y = c;

          switch (w.tag) {
            case 1:
              m = w.payload;

              if ("function" === typeof m) {
                u = m.call(y, u, q);
                break a;
              }

              u = m;
              break a;

            case 3:
              m.flags = m.flags & -65537 | 128;

            case 0:
              m = w.payload;
              q = "function" === typeof m ? m.call(y, u, q) : m;
              if (null === q || void 0 === q) break a;
              u = A({}, u, q);
              break a;

            case 2:
              wg = !0;
          }
        }

        null !== h.callback && 0 !== h.lane && (a.flags |= 64, q = e.effects, null === q ? e.effects = [h] : q.push(h));
      } else y = {
        eventTime: y,
        lane: q,
        tag: h.tag,
        payload: h.payload,
        callback: h.callback,
        next: null
      }, null === n ? (l = n = y, k = u) : n = n.next = y, g |= q;

      h = h.next;
      if (null === h) if (h = e.shared.pending, null === h) break;else q = h, h = q.next, q.next = null, e.lastBaseUpdate = q, e.shared.pending = null;
    } while (1);

    null === n && (k = u);
    e.baseState = k;
    e.firstBaseUpdate = l;
    e.lastBaseUpdate = n;
    b = e.shared.interleaved;

    if (null !== b) {
      e = b;

      do {
        g |= e.lane, e = e.next;
      } while (e !== b);
    } else null === f && (e.shared.lanes = 0);

    Fg |= g;
    a.lanes = g;
    a.memoizedState = u;
  }
}

function Gg(a, b, c) {
  a = b.effects;
  b.effects = null;
  if (null !== a) for (b = 0; b < a.length; b++) {
    var d = a[b],
        e = d.callback;

    if (null !== e) {
      d.callback = null;
      d = c;
      if ("function" !== typeof e) throw Error(p(191, e));
      e.call(d);
    }
  }
}

var Hg = new React__default.Component().refs;

function Ig(a, b, c, d) {
  b = a.memoizedState;
  c = c(d, b);
  c = null === c || void 0 === c ? b : A({}, b, c);
  a.memoizedState = c;
  0 === a.lanes && (a.updateQueue.baseState = c);
}

var Mg = {
  isMounted: function isMounted(a) {
    return (a = a._reactInternals) ? Ub(a) === a : !1;
  },
  enqueueSetState: function enqueueSetState(a, b, c) {
    a = a._reactInternals;
    var d = Jg(),
        e = Kg(a),
        f = zg(d, e);
    f.payload = b;
    void 0 !== c && null !== c && (f.callback = c);
    Ag(a, f);
    b = Lg(a, e, d);
    null !== b && Cg(b, a, e);
  },
  enqueueReplaceState: function enqueueReplaceState(a, b, c) {
    a = a._reactInternals;
    var d = Jg(),
        e = Kg(a),
        f = zg(d, e);
    f.tag = 1;
    f.payload = b;
    void 0 !== c && null !== c && (f.callback = c);
    Ag(a, f);
    b = Lg(a, e, d);
    null !== b && Cg(b, a, e);
  },
  enqueueForceUpdate: function enqueueForceUpdate(a, b) {
    a = a._reactInternals;
    var c = Jg(),
        d = Kg(a),
        e = zg(c, d);
    e.tag = 2;
    void 0 !== b && null !== b && (e.callback = b);
    Ag(a, e);
    b = Lg(a, d, c);
    null !== b && Cg(b, a, d);
  }
};

function Ng(a, b, c, d, e, f, g) {
  a = a.stateNode;
  return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !He(c, d) || !He(e, f) : !0;
}

function Og(a, b, c) {
  var d = !1,
      e = Uf;
  var f = b.contextType;
  "object" === typeof f && null !== f ? f = ug(f) : (e = Yf(b) ? Wf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Xf(a, e) : Uf);
  b = new b(c, f);
  a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
  b.updater = Mg;
  a.stateNode = b;
  b._reactInternals = a;
  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
  return b;
}

function Pg(a, b, c, d) {
  a = b.state;
  "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
  "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
  b.state !== a && Mg.enqueueReplaceState(b, b.state, null);
}

function Qg(a, b, c, d) {
  var e = a.stateNode;
  e.props = c;
  e.state = a.memoizedState;
  e.refs = Hg;
  xg(a);
  var f = b.contextType;
  "object" === typeof f && null !== f ? e.context = ug(f) : (f = Yf(b) ? Wf : H.current, e.context = Xf(a, f));
  e.state = a.memoizedState;
  f = b.getDerivedStateFromProps;
  "function" === typeof f && (Ig(a, b, f, c), e.state = a.memoizedState);
  "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Mg.enqueueReplaceState(e, e.state, null), Eg(a, c, e, d), e.state = a.memoizedState);
  "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}

var Rg = [],
    Sg = 0,
    Tg = null,
    Ug = 0,
    Vg = [],
    Wg = 0,
    Xg = null,
    Yg = 1,
    Zg = "";

function $g(a, b) {
  Rg[Sg++] = Ug;
  Rg[Sg++] = Tg;
  Tg = a;
  Ug = b;
}

function ah(a, b, c) {
  Vg[Wg++] = Yg;
  Vg[Wg++] = Zg;
  Vg[Wg++] = Xg;
  Xg = a;
  var d = Yg;
  a = Zg;
  var e = 32 - nc(d) - 1;
  d &= ~(1 << e);
  c += 1;
  var f = 32 - nc(b) + e;

  if (30 < f) {
    var g = e - e % 5;
    f = (d & (1 << g) - 1).toString(32);
    d >>= g;
    e -= g;
    Yg = 1 << 32 - nc(b) + e | c << e | d;
    Zg = f + a;
  } else Yg = 1 << f | c << e | d, Zg = a;
}

function bh(a) {
  null !== a["return"] && ($g(a, 1), ah(a, 1, 0));
}

function ch(a) {
  for (; a === Tg;) {
    Tg = Rg[--Sg], Rg[Sg] = null, Ug = Rg[--Sg], Rg[Sg] = null;
  }

  for (; a === Xg;) {
    Xg = Vg[--Wg], Vg[Wg] = null, Zg = Vg[--Wg], Vg[Wg] = null, Yg = Vg[--Wg], Vg[Wg] = null;
  }
}

var dh = null,
    eh = null,
    I = !1,
    fh = null;

function gh(a, b) {
  var c = hh(5, null, null, 0);
  c.elementType = "DELETED";
  c.stateNode = b;
  c["return"] = a;
  b = a.deletions;
  null === b ? (a.deletions = [c], a.flags |= 16) : b.push(c);
}

function ih(a, b) {
  switch (a.tag) {
    case 5:
      var c = a.type;
      b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
      return null !== b ? (a.stateNode = b, dh = a, eh = Kf(b.firstChild), !0) : !1;

    case 6:
      return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, dh = a, eh = null, !0) : !1;

    case 13:
      return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== Xg ? {
        id: Yg,
        overflow: Zg
      } : null, a.memoizedState = {
        dehydrated: b,
        treeContext: c,
        retryLane: 1073741824
      }, c = hh(18, null, null, 0), c.stateNode = b, c["return"] = a, a.child = c, dh = a, eh = null, !0) : !1;

    default:
      return !1;
  }
}

function jh(a) {
  return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}

function kh(a) {
  if (I) {
    var b = eh;

    if (b) {
      var c = b;

      if (!ih(a, b)) {
        if (jh(a)) throw Error(p(418));
        b = Kf(c.nextSibling);
        var d = dh;
        b && ih(a, b) ? gh(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, dh = a);
      }
    } else {
      if (jh(a)) throw Error(p(418));
      a.flags = a.flags & -4097 | 2;
      I = !1;
      dh = a;
    }
  }
}

function lh(a) {
  for (a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;) {
    a = a["return"];
  }

  dh = a;
}

function mh(a) {
  if (a !== dh) return !1;
  if (!I) return lh(a), I = !0, !1;
  var b;
  (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Df(a.type, a.memoizedProps));

  if (b && (b = eh)) {
    if (jh(a)) {
      for (a = eh; a;) {
        a = Kf(a.nextSibling);
      }

      throw Error(p(418));
    }

    for (; b;) {
      gh(a, b), b = Kf(b.nextSibling);
    }
  }

  lh(a);

  if (13 === a.tag) {
    a = a.memoizedState;
    a = null !== a ? a.dehydrated : null;
    if (!a) throw Error(p(317));

    a: {
      a = a.nextSibling;

      for (b = 0; a;) {
        if (8 === a.nodeType) {
          var c = a.data;

          if ("/$" === c) {
            if (0 === b) {
              eh = Kf(a.nextSibling);
              break a;
            }

            b--;
          } else "$" !== c && "$!" !== c && "$?" !== c || b++;
        }

        a = a.nextSibling;
      }

      eh = null;
    }
  } else eh = dh ? Kf(a.stateNode.nextSibling) : null;

  return !0;
}

function nh() {
  eh = dh = null;
  I = !1;
}

function oh(a) {
  null === fh ? fh = [a] : fh.push(a);
}

function ph(a, b, c) {
  a = c.ref;

  if (null !== a && "function" !== typeof a && "object" !== typeof a) {
    if (c._owner) {
      c = c._owner;

      if (c) {
        if (1 !== c.tag) throw Error(p(309));
        var d = c.stateNode;
      }

      if (!d) throw Error(p(147, a));
      var e = d,
          f = "" + a;
      if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;

      b = function b(a) {
        var b = e.refs;
        b === Hg && (b = e.refs = {});
        null === a ? delete b[f] : b[f] = a;
      };

      b._stringRef = f;
      return b;
    }

    if ("string" !== typeof a) throw Error(p(284));
    if (!c._owner) throw Error(p(290, a));
  }

  return a;
}

function qh(a, b) {
  a = Object.prototype.toString.call(b);
  throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}

function rh(a) {
  var b = a._init;
  return b(a._payload);
}

function sh(a) {
  function b(b, c) {
    if (a) {
      var d = b.deletions;
      null === d ? (b.deletions = [c], b.flags |= 16) : d.push(c);
    }
  }

  function c(c, d) {
    if (!a) return null;

    for (; null !== d;) {
      b(c, d), d = d.sibling;
    }

    return null;
  }

  function d(a, b) {
    for (a = new Map(); null !== b;) {
      null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
    }

    return a;
  }

  function e(a, b) {
    a = th(a, b);
    a.index = 0;
    a.sibling = null;
    return a;
  }

  function f(b, c, d) {
    b.index = d;
    if (!a) return b.flags |= 1048576, c;
    d = b.alternate;
    if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
    b.flags |= 2;
    return c;
  }

  function g(b) {
    a && null === b.alternate && (b.flags |= 2);
    return b;
  }

  function h(a, b, c, d) {
    if (null === b || 6 !== b.tag) return b = uh(c, a.mode, d), b["return"] = a, b;
    b = e(b, c);
    b["return"] = a;
    return b;
  }

  function k(a, b, c, d) {
    var f = c.type;
    if (f === wa) return n(a, b, c.props.children, d, c.key);
    if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ga && rh(f) === b.type)) return d = e(b, c.props), d.ref = ph(a, b, c), d["return"] = a, d;
    d = vh(c.type, c.key, c.props, null, a.mode, d);
    d.ref = ph(a, b, c);
    d["return"] = a;
    return d;
  }

  function l(a, b, c, d) {
    if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = wh(c, a.mode, d), b["return"] = a, b;
    b = e(b, c.children || []);
    b["return"] = a;
    return b;
  }

  function n(a, b, c, d, f) {
    if (null === b || 7 !== b.tag) return b = xh(c, a.mode, d, f), b["return"] = a, b;
    b = e(b, c);
    b["return"] = a;
    return b;
  }

  function u(a, b, c) {
    if ("string" === typeof b && "" !== b || "number" === typeof b) return b = uh("" + b, a.mode, c), b["return"] = a, b;

    if ("object" === typeof b && null !== b) {
      switch (b.$$typeof) {
        case ua:
          return c = vh(b.type, b.key, b.props, null, a.mode, c), c.ref = ph(a, null, b), c["return"] = a, c;

        case va:
          return b = wh(b, a.mode, c), b["return"] = a, b;

        case Ga:
          var d = b._init;
          return u(a, d(b._payload), c);
      }

      if (db(b) || Ja(b)) return b = xh(b, a.mode, c, null), b["return"] = a, b;
      qh(a, b);
    }

    return null;
  }

  function q(a, b, c, d) {
    var e = null !== b ? b.key : null;
    if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);

    if ("object" === typeof c && null !== c) {
      switch (c.$$typeof) {
        case ua:
          return c.key === e ? k(a, b, c, d) : null;

        case va:
          return c.key === e ? l(a, b, c, d) : null;

        case Ga:
          return e = c._init, q(a, b, e(c._payload), d);
      }

      if (db(c) || Ja(c)) return null !== e ? null : n(a, b, c, d, null);
      qh(a, c);
    }

    return null;
  }

  function y(a, b, c, d, e) {
    if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);

    if ("object" === typeof d && null !== d) {
      switch (d.$$typeof) {
        case ua:
          return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);

        case va:
          return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);

        case Ga:
          var f = d._init;
          return y(a, b, c, f(d._payload), e);
      }

      if (db(d) || Ja(d)) return a = a.get(c) || null, n(b, a, d, e, null);
      qh(b, d);
    }

    return null;
  }

  function m(e, g, h, k) {
    for (var l = null, n = null, r = g, m = g = 0, x = null; null !== r && m < h.length; m++) {
      r.index > m ? (x = r, r = null) : x = r.sibling;
      var v = q(e, r, h[m], k);

      if (null === v) {
        null === r && (r = x);
        break;
      }

      a && r && null === v.alternate && b(e, r);
      g = f(v, g, m);
      null === n ? l = v : n.sibling = v;
      n = v;
      r = x;
    }

    if (m === h.length) return c(e, r), I && $g(e, m), l;

    if (null === r) {
      for (; m < h.length; m++) {
        r = u(e, h[m], k), null !== r && (g = f(r, g, m), null === n ? l = r : n.sibling = r, n = r);
      }

      I && $g(e, m);
      return l;
    }

    for (r = d(e, r); m < h.length; m++) {
      x = y(r, e, m, h[m], k), null !== x && (a && null !== x.alternate && r["delete"](null === x.key ? m : x.key), g = f(x, g, m), null === n ? l = x : n.sibling = x, n = x);
    }

    a && r.forEach(function (a) {
      return b(e, a);
    });
    I && $g(e, m);
    return l;
  }

  function w(e, g, h, k) {
    var l = Ja(h);
    if ("function" !== typeof l) throw Error(p(150));
    h = l.call(h);
    if (null == h) throw Error(p(151));

    for (var n = l = null, m = g, r = g = 0, x = null, v = h.next(); null !== m && !v.done; r++, v = h.next()) {
      m.index > r ? (x = m, m = null) : x = m.sibling;
      var w = q(e, m, v.value, k);

      if (null === w) {
        null === m && (m = x);
        break;
      }

      a && m && null === w.alternate && b(e, m);
      g = f(w, g, r);
      null === n ? l = w : n.sibling = w;
      n = w;
      m = x;
    }

    if (v.done) return c(e, m), I && $g(e, r), l;

    if (null === m) {
      for (; !v.done; r++, v = h.next()) {
        v = u(e, v.value, k), null !== v && (g = f(v, g, r), null === n ? l = v : n.sibling = v, n = v);
      }

      I && $g(e, r);
      return l;
    }

    for (m = d(e, m); !v.done; r++, v = h.next()) {
      v = y(m, e, r, v.value, k), null !== v && (a && null !== v.alternate && m["delete"](null === v.key ? r : v.key), g = f(v, g, r), null === n ? l = v : n.sibling = v, n = v);
    }

    a && m.forEach(function (a) {
      return b(e, a);
    });
    I && $g(e, r);
    return l;
  }

  function J(a, d, f, h) {
    "object" === typeof f && null !== f && f.type === wa && null === f.key && (f = f.props.children);

    if ("object" === typeof f && null !== f) {
      switch (f.$$typeof) {
        case ua:
          a: {
            for (var k = f.key, l = d; null !== l;) {
              if (l.key === k) {
                k = f.type;

                if (k === wa) {
                  if (7 === l.tag) {
                    c(a, l.sibling);
                    d = e(l, f.props.children);
                    d["return"] = a;
                    a = d;
                    break a;
                  }
                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ga && rh(k) === l.type) {
                  c(a, l.sibling);
                  d = e(l, f.props);
                  d.ref = ph(a, l, f);
                  d["return"] = a;
                  a = d;
                  break a;
                }

                c(a, l);
                break;
              } else b(a, l);

              l = l.sibling;
            }

            f.type === wa ? (d = xh(f.props.children, a.mode, h, f.key), d["return"] = a, a = d) : (h = vh(f.type, f.key, f.props, null, a.mode, h), h.ref = ph(a, d, f), h["return"] = a, a = h);
          }

          return g(a);

        case va:
          a: {
            for (l = f.key; null !== d;) {
              if (d.key === l) {
                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                  c(a, d.sibling);
                  d = e(d, f.children || []);
                  d["return"] = a;
                  a = d;
                  break a;
                } else {
                  c(a, d);
                  break;
                }
              } else b(a, d);
              d = d.sibling;
            }

            d = wh(f, a.mode, h);
            d["return"] = a;
            a = d;
          }

          return g(a);

        case Ga:
          return l = f._init, J(a, d, l(f._payload), h);
      }

      if (db(f)) return m(a, d, f, h);
      if (Ja(f)) return w(a, d, f, h);
      qh(a, f);
    }

    return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d["return"] = a, a = d) : (c(a, d), d = uh(f, a.mode, h), d["return"] = a, a = d), g(a)) : c(a, d);
  }

  return J;
}

var yh = sh(!0),
    zh = sh(!1),
    Ah = {},
    Bh = Tf(Ah),
    Ch = Tf(Ah),
    Dh = Tf(Ah);

function Eh(a) {
  if (a === Ah) throw Error(p(174));
  return a;
}

function Fh(a, b) {
  G(Dh, b);
  G(Ch, a);
  G(Bh, Ah);
  a = b.nodeType;

  switch (a) {
    case 9:
    case 11:
      b = (b = b.documentElement) ? b.namespaceURI : kb(null, "");
      break;

    default:
      a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = kb(b, a);
  }

  E(Bh);
  G(Bh, b);
}

function Gh() {
  E(Bh);
  E(Ch);
  E(Dh);
}

function Hh(a) {
  Eh(Dh.current);
  var b = Eh(Bh.current);
  var c = kb(b, a.type);
  b !== c && (G(Ch, a), G(Bh, c));
}

function Ih(a) {
  Ch.current === a && (E(Bh), E(Ch));
}

var K = Tf(0);

function Jh(a) {
  for (var b = a; null !== b;) {
    if (13 === b.tag) {
      var c = b.memoizedState;
      if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
    } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
      if (0 !== (b.flags & 128)) return b;
    } else if (null !== b.child) {
      b.child["return"] = b;
      b = b.child;
      continue;
    }

    if (b === a) break;

    for (; null === b.sibling;) {
      if (null === b["return"] || b["return"] === a) return null;
      b = b["return"];
    }

    b.sibling["return"] = b["return"];
    b = b.sibling;
  }

  return null;
}

var Kh = [];

function Lh() {
  for (var a = 0; a < Kh.length; a++) {
    Kh[a]._workInProgressVersionPrimary = null;
  }

  Kh.length = 0;
}

var Mh = ta.ReactCurrentDispatcher,
    Nh = ta.ReactCurrentBatchConfig,
    Oh = 0,
    L = null,
    M = null,
    N = null,
    Ph = !1,
    Qh = !1,
    Rh = 0,
    Sh = 0;

function O() {
  throw Error(p(321));
}

function Th(a, b) {
  if (null === b) return !1;

  for (var c = 0; c < b.length && c < a.length; c++) {
    if (!Ge(a[c], b[c])) return !1;
  }

  return !0;
}

function Uh(a, b, c, d, e, f) {
  Oh = f;
  L = b;
  b.memoizedState = null;
  b.updateQueue = null;
  b.lanes = 0;
  Mh.current = null === a || null === a.memoizedState ? Vh : Wh;
  a = c(d, e);

  if (Qh) {
    f = 0;

    do {
      Qh = !1;
      Rh = 0;
      if (25 <= f) throw Error(p(301));
      f += 1;
      N = M = null;
      b.updateQueue = null;
      Mh.current = Xh;
      a = c(d, e);
    } while (Qh);
  }

  Mh.current = Yh;
  b = null !== M && null !== M.next;
  Oh = 0;
  N = M = L = null;
  Ph = !1;
  if (b) throw Error(p(300));
  return a;
}

function Zh() {
  var a = 0 !== Rh;
  Rh = 0;
  return a;
}

function $h() {
  var a = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null
  };
  null === N ? L.memoizedState = N = a : N = N.next = a;
  return N;
}

function ai() {
  if (null === M) {
    var a = L.alternate;
    a = null !== a ? a.memoizedState : null;
  } else a = M.next;

  var b = null === N ? L.memoizedState : N.next;
  if (null !== b) N = b, M = a;else {
    if (null === a) throw Error(p(310));
    M = a;
    a = {
      memoizedState: M.memoizedState,
      baseState: M.baseState,
      baseQueue: M.baseQueue,
      queue: M.queue,
      next: null
    };
    null === N ? L.memoizedState = N = a : N = N.next = a;
  }
  return N;
}

function bi(a, b) {
  return "function" === typeof b ? b(a) : b;
}

function ci(a) {
  var b = ai(),
      c = b.queue;
  if (null === c) throw Error(p(311));
  c.lastRenderedReducer = a;
  var d = M,
      e = d.baseQueue,
      f = c.pending;

  if (null !== f) {
    if (null !== e) {
      var g = e.next;
      e.next = f.next;
      f.next = g;
    }

    d.baseQueue = e = f;
    c.pending = null;
  }

  if (null !== e) {
    f = e.next;
    d = d.baseState;
    var h = g = null,
        k = null,
        l = f;

    do {
      var n = l.lane;
      if ((Oh & n) === n) null !== k && (k = k.next = {
        lane: 0,
        action: l.action,
        hasEagerState: l.hasEagerState,
        eagerState: l.eagerState,
        next: null
      }), d = l.hasEagerState ? l.eagerState : a(d, l.action);else {
        var u = {
          lane: n,
          action: l.action,
          hasEagerState: l.hasEagerState,
          eagerState: l.eagerState,
          next: null
        };
        null === k ? (h = k = u, g = d) : k = k.next = u;
        L.lanes |= n;
        Fg |= n;
      }
      l = l.next;
    } while (null !== l && l !== f);

    null === k ? g = d : k.next = h;
    Ge(d, b.memoizedState) || (tg = !0);
    b.memoizedState = d;
    b.baseState = g;
    b.baseQueue = k;
    c.lastRenderedState = d;
  }

  a = c.interleaved;

  if (null !== a) {
    e = a;

    do {
      f = e.lane, L.lanes |= f, Fg |= f, e = e.next;
    } while (e !== a);
  } else null === e && (c.lanes = 0);

  return [b.memoizedState, c.dispatch];
}

function di(a) {
  var b = ai(),
      c = b.queue;
  if (null === c) throw Error(p(311));
  c.lastRenderedReducer = a;
  var d = c.dispatch,
      e = c.pending,
      f = b.memoizedState;

  if (null !== e) {
    c.pending = null;
    var g = e = e.next;

    do {
      f = a(f, g.action), g = g.next;
    } while (g !== e);

    Ge(f, b.memoizedState) || (tg = !0);
    b.memoizedState = f;
    null === b.baseQueue && (b.baseState = f);
    c.lastRenderedState = f;
  }

  return [f, d];
}

function ei() {}

function fi(a, b) {
  var c = L,
      d = ai(),
      e = b(),
      f = !Ge(d.memoizedState, e);
  f && (d.memoizedState = e, tg = !0);
  d = d.queue;
  gi(hi.bind(null, c, d, a), [a]);

  if (d.getSnapshot !== b || f || null !== N && N.memoizedState.tag & 1) {
    c.flags |= 2048;
    ii(9, ji.bind(null, c, d, e, b), void 0, null);
    if (null === P) throw Error(p(349));
    0 !== (Oh & 30) || ki(c, b, e);
  }

  return e;
}

function ki(a, b, c) {
  a.flags |= 16384;
  a = {
    getSnapshot: b,
    value: c
  };
  b = L.updateQueue;
  null === b ? (b = {
    lastEffect: null,
    stores: null
  }, L.updateQueue = b, b.stores = [a]) : (c = b.stores, null === c ? b.stores = [a] : c.push(a));
}

function ji(a, b, c, d) {
  b.value = c;
  b.getSnapshot = d;
  li(b) && Lg(a, 1, -1);
}

function hi(a, b, c) {
  return c(function () {
    li(b) && Lg(a, 1, -1);
  });
}

function li(a) {
  var b = a.getSnapshot;
  a = a.value;

  try {
    var c = b();
    return !Ge(a, c);
  } catch (d) {
    return !0;
  }
}

function mi(a) {
  var b = $h();
  "function" === typeof a && (a = a());
  b.memoizedState = b.baseState = a;
  a = {
    pending: null,
    interleaved: null,
    lanes: 0,
    dispatch: null,
    lastRenderedReducer: bi,
    lastRenderedState: a
  };
  b.queue = a;
  a = a.dispatch = ni.bind(null, L, a);
  return [b.memoizedState, a];
}

function ii(a, b, c, d) {
  a = {
    tag: a,
    create: b,
    destroy: c,
    deps: d,
    next: null
  };
  b = L.updateQueue;
  null === b ? (b = {
    lastEffect: null,
    stores: null
  }, L.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
  return a;
}

function oi() {
  return ai().memoizedState;
}

function pi(a, b, c, d) {
  var e = $h();
  L.flags |= a;
  e.memoizedState = ii(1 | b, c, void 0, void 0 === d ? null : d);
}

function qi(a, b, c, d) {
  var e = ai();
  d = void 0 === d ? null : d;
  var f = void 0;

  if (null !== M) {
    var g = M.memoizedState;
    f = g.destroy;

    if (null !== d && Th(d, g.deps)) {
      e.memoizedState = ii(b, c, f, d);
      return;
    }
  }

  L.flags |= a;
  e.memoizedState = ii(1 | b, c, f, d);
}

function ri(a, b) {
  return pi(8390656, 8, a, b);
}

function gi(a, b) {
  return qi(2048, 8, a, b);
}

function si(a, b) {
  return qi(4, 2, a, b);
}

function ti(a, b) {
  return qi(4, 4, a, b);
}

function ui(a, b) {
  if ("function" === typeof b) return a = a(), b(a), function () {
    b(null);
  };
  if (null !== b && void 0 !== b) return a = a(), b.current = a, function () {
    b.current = null;
  };
}

function vi(a, b, c) {
  c = null !== c && void 0 !== c ? c.concat([a]) : null;
  return qi(4, 4, ui.bind(null, b, a), c);
}

function wi() {}

function xi(a, b) {
  var c = ai();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Th(b, d[1])) return d[0];
  c.memoizedState = [a, b];
  return a;
}

function yi(a, b) {
  var c = ai();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Th(b, d[1])) return d[0];
  a = a();
  c.memoizedState = [a, b];
  return a;
}

function zi(a, b, c) {
  if (0 === (Oh & 21)) return a.baseState && (a.baseState = !1, tg = !0), a.memoizedState = c;
  Ge(c, b) || (c = xc(), L.lanes |= c, Fg |= c, a.baseState = !0);
  return b;
}

function Ai(a, b) {
  var c = C;
  C = 0 !== c && 4 > c ? c : 4;
  a(!0);
  var d = Nh.transition;
  Nh.transition = {};

  try {
    a(!1), b();
  } finally {
    C = c, Nh.transition = d;
  }
}

function Bi() {
  return ai().memoizedState;
}

function Ci(a, b, c) {
  var d = Kg(a);
  c = {
    lane: d,
    action: c,
    hasEagerState: !1,
    eagerState: null,
    next: null
  };
  Di(a) ? Ei(b, c) : (Fi(a, b, c), c = Jg(), a = Lg(a, d, c), null !== a && Gi(a, b, d));
}

function ni(a, b, c) {
  var d = Kg(a),
      e = {
    lane: d,
    action: c,
    hasEagerState: !1,
    eagerState: null,
    next: null
  };
  if (Di(a)) Ei(b, e);else {
    Fi(a, b, e);
    var f = a.alternate;
    if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
      var g = b.lastRenderedState,
          h = f(g, c);
      e.hasEagerState = !0;
      e.eagerState = h;
      if (Ge(h, g)) return;
    } catch (k) {} finally {}
    c = Jg();
    a = Lg(a, d, c);
    null !== a && Gi(a, b, d);
  }
}

function Di(a) {
  var b = a.alternate;
  return a === L || null !== b && b === L;
}

function Ei(a, b) {
  Qh = Ph = !0;
  var c = a.pending;
  null === c ? b.next = b : (b.next = c.next, c.next = b);
  a.pending = b;
}

function Fi(a, b, c) {
  Bg(a) ? (a = b.interleaved, null === a ? (c.next = c, null === vg ? vg = [b] : vg.push(b)) : (c.next = a.next, a.next = c), b.interleaved = c) : (a = b.pending, null === a ? c.next = c : (c.next = a.next, a.next = c), b.pending = c);
}

function Gi(a, b, c) {
  if (0 !== (c & 4194240)) {
    var d = b.lanes;
    d &= a.pendingLanes;
    c |= d;
    b.lanes = c;
    Bc(a, c);
  }
}

var Yh = {
  readContext: ug,
  useCallback: O,
  useContext: O,
  useEffect: O,
  useImperativeHandle: O,
  useInsertionEffect: O,
  useLayoutEffect: O,
  useMemo: O,
  useReducer: O,
  useRef: O,
  useState: O,
  useDebugValue: O,
  useDeferredValue: O,
  useTransition: O,
  useMutableSource: O,
  useSyncExternalStore: O,
  useId: O,
  unstable_isNewReconciler: !1
},
    Vh = {
  readContext: ug,
  useCallback: function useCallback(a, b) {
    $h().memoizedState = [a, void 0 === b ? null : b];
    return a;
  },
  useContext: ug,
  useEffect: ri,
  useImperativeHandle: function useImperativeHandle(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([a]) : null;
    return pi(4194308, 4, ui.bind(null, b, a), c);
  },
  useLayoutEffect: function useLayoutEffect(a, b) {
    return pi(4194308, 4, a, b);
  },
  useInsertionEffect: function useInsertionEffect(a, b) {
    return pi(4, 2, a, b);
  },
  useMemo: function useMemo(a, b) {
    var c = $h();
    b = void 0 === b ? null : b;
    a = a();
    c.memoizedState = [a, b];
    return a;
  },
  useReducer: function useReducer(a, b, c) {
    var d = $h();
    b = void 0 !== c ? c(b) : b;
    d.memoizedState = d.baseState = b;
    a = {
      pending: null,
      interleaved: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: a,
      lastRenderedState: b
    };
    d.queue = a;
    a = a.dispatch = Ci.bind(null, L, a);
    return [d.memoizedState, a];
  },
  useRef: function useRef(a) {
    var b = $h();
    a = {
      current: a
    };
    return b.memoizedState = a;
  },
  useState: mi,
  useDebugValue: wi,
  useDeferredValue: function useDeferredValue(a) {
    return $h().memoizedState = a;
  },
  useTransition: function useTransition() {
    var a = mi(!1),
        b = a[0];
    a = Ai.bind(null, a[1]);
    $h().memoizedState = a;
    return [b, a];
  },
  useMutableSource: function useMutableSource() {},
  useSyncExternalStore: function useSyncExternalStore(a, b, c) {
    var d = L,
        e = $h();

    if (I) {
      if (void 0 === c) throw Error(p(407));
      c = c();
    } else {
      c = b();
      if (null === P) throw Error(p(349));
      0 !== (Oh & 30) || ki(d, b, c);
    }

    e.memoizedState = c;
    var f = {
      value: c,
      getSnapshot: b
    };
    e.queue = f;
    ri(hi.bind(null, d, f, a), [a]);
    d.flags |= 2048;
    ii(9, ji.bind(null, d, f, c, b), void 0, null);
    return c;
  },
  useId: function useId() {
    var a = $h(),
        b = P.identifierPrefix;

    if (I) {
      var c = Zg;
      var d = Yg;
      c = (d & ~(1 << 32 - nc(d) - 1)).toString(32) + c;
      b = ":" + b + "R" + c;
      c = Rh++;
      0 < c && (b += "H" + c.toString(32));
      b += ":";
    } else c = Sh++, b = ":" + b + "r" + c.toString(32) + ":";

    return a.memoizedState = b;
  },
  unstable_isNewReconciler: !1
},
    Wh = {
  readContext: ug,
  useCallback: xi,
  useContext: ug,
  useEffect: gi,
  useImperativeHandle: vi,
  useInsertionEffect: si,
  useLayoutEffect: ti,
  useMemo: yi,
  useReducer: ci,
  useRef: oi,
  useState: function useState() {
    return ci(bi);
  },
  useDebugValue: wi,
  useDeferredValue: function useDeferredValue(a) {
    var b = ai();
    return zi(b, M.memoizedState, a);
  },
  useTransition: function useTransition() {
    var a = ci(bi)[0],
        b = ai().memoizedState;
    return [a, b];
  },
  useMutableSource: ei,
  useSyncExternalStore: fi,
  useId: Bi,
  unstable_isNewReconciler: !1
},
    Xh = {
  readContext: ug,
  useCallback: xi,
  useContext: ug,
  useEffect: gi,
  useImperativeHandle: vi,
  useInsertionEffect: si,
  useLayoutEffect: ti,
  useMemo: yi,
  useReducer: di,
  useRef: oi,
  useState: function useState() {
    return di(bi);
  },
  useDebugValue: wi,
  useDeferredValue: function useDeferredValue(a) {
    var b = ai();
    return null === M ? b.memoizedState = a : zi(b, M.memoizedState, a);
  },
  useTransition: function useTransition() {
    var a = di(bi)[0],
        b = ai().memoizedState;
    return [a, b];
  },
  useMutableSource: ei,
  useSyncExternalStore: fi,
  useId: Bi,
  unstable_isNewReconciler: !1
};

function Hi(a, b) {
  try {
    var c = "",
        d = b;

    do {
      c += Oa(d), d = d["return"];
    } while (d);

    var e = c;
  } catch (f) {
    e = "\nError generating stack: " + f.message + "\n" + f.stack;
  }

  return {
    value: a,
    source: b,
    stack: e
  };
}

function Ii(a, b) {
  try {
    console.error(b.value);
  } catch (c) {
    setTimeout(function () {
      throw c;
    });
  }
}

var Ji = "function" === typeof WeakMap ? WeakMap : Map;

function Ki(a, b, c) {
  c = zg(-1, c);
  c.tag = 3;
  c.payload = {
    element: null
  };
  var d = b.value;

  c.callback = function () {
    Li || (Li = !0, Mi = d);
    Ii(a, b);
  };

  return c;
}

function Ni(a, b, c) {
  c = zg(-1, c);
  c.tag = 3;
  var d = a.type.getDerivedStateFromError;

  if ("function" === typeof d) {
    var e = b.value;

    c.payload = function () {
      return d(e);
    };

    c.callback = function () {
      Ii(a, b);
    };
  }

  var f = a.stateNode;
  null !== f && "function" === typeof f.componentDidCatch && (c.callback = function () {
    Ii(a, b);
    "function" !== typeof d && (null === Oi ? Oi = new Set([this]) : Oi.add(this));
    var c = b.stack;
    this.componentDidCatch(b.value, {
      componentStack: null !== c ? c : ""
    });
  });
  return c;
}

function Pi(a, b, c) {
  var d = a.pingCache;

  if (null === d) {
    d = a.pingCache = new Ji();
    var e = new Set();
    d.set(b, e);
  } else e = d.get(b), void 0 === e && (e = new Set(), d.set(b, e));

  e.has(c) || (e.add(c), a = Qi.bind(null, a, b, c), b.then(a, a));
}

function Ri(a) {
  do {
    var b;
    if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
    if (b) return a;
    a = a["return"];
  } while (null !== a);

  return null;
}

function Si(a, b, c, d, e) {
  if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = zg(-1, 1), b.tag = 2, Ag(c, b))), c.lanes |= 1), a;
  a.flags |= 65536;
  a.lanes = e;
  return a;
}

var Ti, Ui, Vi, Wi;

Ti = function Ti(a, b) {
  for (var c = b.child; null !== c;) {
    if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);else if (4 !== c.tag && null !== c.child) {
      c.child["return"] = c;
      c = c.child;
      continue;
    }
    if (c === b) break;

    for (; null === c.sibling;) {
      if (null === c["return"] || c["return"] === b) return;
      c = c["return"];
    }

    c.sibling["return"] = c["return"];
    c = c.sibling;
  }
};

Ui = function Ui() {};

Vi = function Vi(a, b, c, d) {
  var e = a.memoizedProps;

  if (e !== d) {
    a = b.stateNode;
    Eh(Bh.current);
    var f = null;

    switch (c) {
      case "input":
        e = Xa(a, e);
        d = Xa(a, d);
        f = [];
        break;

      case "select":
        e = A({}, e, {
          value: void 0
        });
        d = A({}, d, {
          value: void 0
        });
        f = [];
        break;

      case "textarea":
        e = fb(a, e);
        d = fb(a, d);
        f = [];
        break;

      default:
        "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Af);
    }

    tb(c, d);
    var g;
    c = null;

    for (l in e) {
      if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) if ("style" === l) {
        var h = e[l];

        for (g in h) {
          h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
        }
      } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
    }

    for (l in d) {
      var k = d[l];
      h = null != e ? e[l] : void 0;
      if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) if ("style" === l) {
        if (h) {
          for (g in h) {
            !h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
          }

          for (g in k) {
            k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
          }
        } else c || (f || (f = []), f.push(l, c)), c = k;
      } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
    }

    c && (f = f || []).push("style", c);
    var l = f;
    if (b.updateQueue = l) b.flags |= 4;
  }
};

Wi = function Wi(a, b, c, d) {
  c !== d && (b.flags |= 4);
};

function Xi(a, b) {
  if (!I) switch (a.tailMode) {
    case "hidden":
      b = a.tail;

      for (var c = null; null !== b;) {
        null !== b.alternate && (c = b), b = b.sibling;
      }

      null === c ? a.tail = null : c.sibling = null;
      break;

    case "collapsed":
      c = a.tail;

      for (var d = null; null !== c;) {
        null !== c.alternate && (d = c), c = c.sibling;
      }

      null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
  }
}

function Q(a) {
  var b = null !== a.alternate && a.alternate.child === a.child,
      c = 0,
      d = 0;
  if (b) for (var e = a.child; null !== e;) {
    c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e["return"] = a, e = e.sibling;
  } else for (e = a.child; null !== e;) {
    c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e["return"] = a, e = e.sibling;
  }
  a.subtreeFlags |= d;
  a.childLanes = c;
  return b;
}

function Yi(a, b, c) {
  var d = b.pendingProps;
  ch(b);

  switch (b.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return Q(b), null;

    case 1:
      return Yf(b.type) && Zf(), Q(b), null;

    case 3:
      d = b.stateNode;
      Gh();
      E(Vf);
      E(H);
      Lh();
      d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
      if (null === a || null === a.child) mh(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== fh && (Zi(fh), fh = null));
      Ui(a, b);
      Q(b);
      return null;

    case 5:
      Ih(b);
      var e = Eh(Dh.current);
      c = b.type;
      if (null !== a && null != b.stateNode) Vi(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);else {
        if (!d) {
          if (null === b.stateNode) throw Error(p(166));
          Q(b);
          return null;
        }

        a = Eh(Bh.current);

        if (mh(b)) {
          d = b.stateNode;
          c = b.type;
          var f = b.memoizedProps;
          d[Nf] = b;
          d[Of] = f;
          a = 0 !== (b.mode & 1);

          switch (c) {
            case "dialog":
              D("cancel", d);
              D("close", d);
              break;

            case "iframe":
            case "object":
            case "embed":
              D("load", d);
              break;

            case "video":
            case "audio":
              for (e = 0; e < kf.length; e++) {
                D(kf[e], d);
              }

              break;

            case "source":
              D("error", d);
              break;

            case "img":
            case "image":
            case "link":
              D("error", d);
              D("load", d);
              break;

            case "details":
              D("toggle", d);
              break;

            case "input":
              Ya(d, f);
              D("invalid", d);
              break;

            case "select":
              d._wrapperState = {
                wasMultiple: !!f.multiple
              };
              D("invalid", d);
              break;

            case "textarea":
              gb(d, f), D("invalid", d);
          }

          tb(c, f);
          e = null;

          for (var g in f) {
            if (f.hasOwnProperty(g)) {
              var h = f[g];
              "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && zf(d.textContent, h, a), e = ["children", h]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && zf(d.textContent, h, a), e = ["children", "" + h]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
            }
          }

          switch (c) {
            case "input":
              Ua(d);
              cb(d, f, !0);
              break;

            case "textarea":
              Ua(d);
              ib(d);
              break;

            case "select":
            case "option":
              break;

            default:
              "function" === typeof f.onClick && (d.onclick = Af);
          }

          d = e;
          b.updateQueue = d;
          null !== d && (b.flags |= 4);
        } else {
          g = 9 === e.nodeType ? e : e.ownerDocument;
          "http://www.w3.org/1999/xhtml" === a && (a = jb(c));
          "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
            is: d.is
          }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
          a[Nf] = b;
          a[Of] = d;
          Ti(a, b, !1, !1);
          b.stateNode = a;

          a: {
            g = ub(c, d);

            switch (c) {
              case "dialog":
                D("cancel", a);
                D("close", a);
                e = d;
                break;

              case "iframe":
              case "object":
              case "embed":
                D("load", a);
                e = d;
                break;

              case "video":
              case "audio":
                for (e = 0; e < kf.length; e++) {
                  D(kf[e], a);
                }

                e = d;
                break;

              case "source":
                D("error", a);
                e = d;
                break;

              case "img":
              case "image":
              case "link":
                D("error", a);
                D("load", a);
                e = d;
                break;

              case "details":
                D("toggle", a);
                e = d;
                break;

              case "input":
                Ya(a, d);
                e = Xa(a, d);
                D("invalid", a);
                break;

              case "option":
                e = d;
                break;

              case "select":
                a._wrapperState = {
                  wasMultiple: !!d.multiple
                };
                e = A({}, d, {
                  value: void 0
                });
                D("invalid", a);
                break;

              case "textarea":
                gb(a, d);
                e = fb(a, d);
                D("invalid", a);
                break;

              default:
                e = d;
            }

            tb(c, e);
            h = e;

            for (f in h) {
              if (h.hasOwnProperty(f)) {
                var k = h[f];
                "style" === f ? rb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && mb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && nb(a, k) : "number" === typeof k && nb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && sa(a, f, k, g));
              }
            }

            switch (c) {
              case "input":
                Ua(a);
                cb(a, d, !1);
                break;

              case "textarea":
                Ua(a);
                ib(a);
                break;

              case "option":
                null != d.value && a.setAttribute("value", "" + Ra(d.value));
                break;

              case "select":
                a.multiple = !!d.multiple;
                f = d.value;
                null != f ? eb(a, !!d.multiple, f, !1) : null != d.defaultValue && eb(a, !!d.multiple, d.defaultValue, !0);
                break;

              default:
                "function" === typeof e.onClick && (a.onclick = Af);
            }

            switch (c) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                d = !!d.autoFocus;
                break a;

              case "img":
                d = !0;
                break a;

              default:
                d = !1;
            }
          }

          d && (b.flags |= 4);
        }

        null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
      }
      Q(b);
      return null;

    case 6:
      if (a && null != b.stateNode) Wi(a, b, a.memoizedProps, d);else {
        if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
        c = Eh(Dh.current);
        Eh(Bh.current);

        if (mh(b)) {
          d = b.stateNode;
          c = b.memoizedProps;
          d[Nf] = b;
          if (f = d.nodeValue !== c) if (a = dh, null !== a) switch (a.tag) {
            case 3:
              zf(d.nodeValue, c, 0 !== (a.mode & 1));
              break;

            case 5:
              !0 !== a.memoizedProps.suppressHydrationWarning && zf(d.nodeValue, c, 0 !== (a.mode & 1));
          }
          f && (b.flags |= 4);
        } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Nf] = b, b.stateNode = d;
      }
      Q(b);
      return null;

    case 13:
      E(K);
      d = b.memoizedState;

      if (I && null !== eh && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) {
        for (d = eh; d;) {
          d = Kf(d.nextSibling);
        }

        nh();
        b.flags |= 98560;
        return b;
      }

      if (null !== d && null !== d.dehydrated) {
        d = mh(b);

        if (null === a) {
          if (!d) throw Error(p(318));
          d = b.memoizedState;
          d = null !== d ? d.dehydrated : null;
          if (!d) throw Error(p(317));
          d[Nf] = b;
        } else nh(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;

        Q(b);
        return null;
      }

      null !== fh && (Zi(fh), fh = null);
      if (0 !== (b.flags & 128)) return b.lanes = c, b;
      d = null !== d;
      c = !1;
      null === a ? mh(b) : c = null !== a.memoizedState;
      d !== c && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (K.current & 1) ? 0 === R && (R = 3) : $i()));
      null !== b.updateQueue && (b.flags |= 4);
      Q(b);
      return null;

    case 4:
      return Gh(), Ui(a, b), null === a && rf(b.stateNode.containerInfo), Q(b), null;

    case 10:
      return qg(b.type._context), Q(b), null;

    case 17:
      return Yf(b.type) && Zf(), Q(b), null;

    case 19:
      E(K);
      f = b.memoizedState;
      if (null === f) return Q(b), null;
      d = 0 !== (b.flags & 128);
      g = f.rendering;
      if (null === g) {
        if (d) Xi(f, !1);else {
          if (0 !== R || null !== a && 0 !== (a.flags & 128)) for (a = b.child; null !== a;) {
            g = Jh(a);

            if (null !== g) {
              b.flags |= 128;
              Xi(f, !1);
              d = g.updateQueue;
              null !== d && (b.updateQueue = d, b.flags |= 4);
              b.subtreeFlags = 0;
              d = c;

              for (c = b.child; null !== c;) {
                f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                  lanes: a.lanes,
                  firstContext: a.firstContext
                }), c = c.sibling;
              }

              G(K, K.current & 1 | 2);
              return b.child;
            }

            a = a.sibling;
          }
          null !== f.tail && B() > aj && (b.flags |= 128, d = !0, Xi(f, !1), b.lanes = 4194304);
        }
      } else {
        if (!d) if (a = Jh(g), null !== a) {
          if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Xi(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return Q(b), null;
        } else 2 * B() - f.renderingStartTime > aj && 1073741824 !== c && (b.flags |= 128, d = !0, Xi(f, !1), b.lanes = 4194304);
        f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
      }
      if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = K.current, G(K, d ? c & 1 | 2 : c & 1), b;
      Q(b);
      return null;

    case 22:
    case 23:
      return bj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (cj & 1073741824) && (Q(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : Q(b), null;

    case 24:
      return null;

    case 25:
      return null;
  }

  throw Error(p(156, b.tag));
}

var dj = ta.ReactCurrentOwner,
    tg = !1;

function ej(a, b, c, d) {
  b.child = null === a ? zh(b, null, c, d) : yh(b, a.child, c, d);
}

function fj(a, b, c, d, e) {
  c = c.render;
  var f = b.ref;
  sg(b, e);
  d = Uh(a, b, c, d, f, e);
  c = Zh();
  if (null !== a && !tg) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, gj(a, b, e);
  I && c && bh(b);
  b.flags |= 1;
  ej(a, b, d, e);
  return b.child;
}

function hj(a, b, c, d, e) {
  if (null === a) {
    var f = c.type;
    if ("function" === typeof f && !ij(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, jj(a, b, f, d, e);
    a = vh(c.type, null, d, b, b.mode, e);
    a.ref = b.ref;
    a["return"] = b;
    return b.child = a;
  }

  f = a.child;

  if (0 === (a.lanes & e)) {
    var g = f.memoizedProps;
    c = c.compare;
    c = null !== c ? c : He;
    if (c(g, d) && a.ref === b.ref) return gj(a, b, e);
  }

  b.flags |= 1;
  a = th(f, d);
  a.ref = b.ref;
  a["return"] = b;
  return b.child = a;
}

function jj(a, b, c, d, e) {
  if (null !== a) {
    var f = a.memoizedProps;
    if (He(f, d) && a.ref === b.ref) if (tg = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (tg = !0);else return b.lanes = a.lanes, gj(a, b, e);
  }

  return kj(a, b, c, d, e);
}

function lj(a, b, c) {
  var d = b.pendingProps,
      e = d.children,
      f = null !== a ? a.memoizedState : null;
  if ("hidden" === d.mode) {
    if (0 === (b.mode & 1)) b.memoizedState = {
      baseLanes: 0,
      cachePool: null,
      transitions: null
    }, G(mj, cj), cj |= c;else if (0 !== (c & 1073741824)) b.memoizedState = {
      baseLanes: 0,
      cachePool: null,
      transitions: null
    }, d = null !== f ? f.baseLanes : c, G(mj, cj), cj |= d;else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
      baseLanes: a,
      cachePool: null,
      transitions: null
    }, b.updateQueue = null, G(mj, cj), cj |= a, null;
  } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(mj, cj), cj |= d;
  ej(a, b, e, c);
  return b.child;
}

function nj(a, b) {
  var c = b.ref;
  if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}

function kj(a, b, c, d, e) {
  var f = Yf(c) ? Wf : H.current;
  f = Xf(b, f);
  sg(b, e);
  c = Uh(a, b, c, d, f, e);
  d = Zh();
  if (null !== a && !tg) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, gj(a, b, e);
  I && d && bh(b);
  b.flags |= 1;
  ej(a, b, c, e);
  return b.child;
}

function oj(a, b, c, d, e) {
  if (Yf(c)) {
    var f = !0;
    bg(b);
  } else f = !1;

  sg(b, e);
  if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Og(b, c, d), Qg(b, c, d, e), d = !0;else if (null === a) {
    var g = b.stateNode,
        h = b.memoizedProps;
    g.props = h;
    var k = g.context,
        l = c.contextType;
    "object" === typeof l && null !== l ? l = ug(l) : (l = Yf(c) ? Wf : H.current, l = Xf(b, l));
    var n = c.getDerivedStateFromProps,
        u = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
    u || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Pg(b, g, d, l);
    wg = !1;
    var q = b.memoizedState;
    g.state = q;
    Eg(b, d, g, e);
    k = b.memoizedState;
    h !== d || q !== k || Vf.current || wg ? ("function" === typeof n && (Ig(b, c, n, d), k = b.memoizedState), (h = wg || Ng(b, c, h, d, q, k, l)) ? (u || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
  } else {
    g = b.stateNode;
    yg(a, b);
    h = b.memoizedProps;
    l = b.type === b.elementType ? h : kg(b.type, h);
    g.props = l;
    u = b.pendingProps;
    q = g.context;
    k = c.contextType;
    "object" === typeof k && null !== k ? k = ug(k) : (k = Yf(c) ? Wf : H.current, k = Xf(b, k));
    var y = c.getDerivedStateFromProps;
    (n = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== u || q !== k) && Pg(b, g, d, k);
    wg = !1;
    q = b.memoizedState;
    g.state = q;
    Eg(b, d, g, e);
    var m = b.memoizedState;
    h !== u || q !== m || Vf.current || wg ? ("function" === typeof y && (Ig(b, c, y, d), m = b.memoizedState), (l = wg || Ng(b, c, l, d, q, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 1024), d = !1);
  }
  return pj(a, b, c, d, f, e);
}

function pj(a, b, c, d, e, f) {
  nj(a, b);
  var g = 0 !== (b.flags & 128);
  if (!d && !g) return e && cg(b, c, !1), gj(a, b, f);
  d = b.stateNode;
  dj.current = b;
  var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
  b.flags |= 1;
  null !== a && g ? (b.child = yh(b, a.child, null, f), b.child = yh(b, null, h, f)) : ej(a, b, h, f);
  b.memoizedState = d.state;
  e && cg(b, c, !0);
  return b.child;
}

function qj(a) {
  var b = a.stateNode;
  b.pendingContext ? $f(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f(a, b.context, !1);
  Fh(a, b.containerInfo);
}

function rj(a, b, c, d, e) {
  nh();
  oh(e);
  b.flags |= 256;
  ej(a, b, c, d);
  return b.child;
}

var sj = {
  dehydrated: null,
  treeContext: null,
  retryLane: 0
};

function tj(a) {
  return {
    baseLanes: a,
    cachePool: null,
    transitions: null
  };
}

function uj(a, b) {
  return {
    baseLanes: a.baseLanes | b,
    cachePool: null,
    transitions: a.transitions
  };
}

function vj(a, b, c) {
  var d = b.pendingProps,
      e = K.current,
      f = !1,
      g = 0 !== (b.flags & 128),
      h;
  (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
  if (h) f = !0, b.flags &= -129;else if (null === a || null !== a.memoizedState) e |= 1;
  G(K, e & 1);

  if (null === a) {
    kh(b);
    a = b.memoizedState;
    if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
    e = d.children;
    a = d.fallback;
    return f ? (d = b.mode, f = b.child, e = {
      mode: "hidden",
      children: e
    }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = e) : f = wj(e, d, 0, null), a = xh(a, d, c, null), f["return"] = b, a["return"] = b, f.sibling = a, b.child = f, b.child.memoizedState = tj(c), b.memoizedState = sj, a) : xj(b, e);
  }

  e = a.memoizedState;

  if (null !== e) {
    h = e.dehydrated;

    if (null !== h) {
      if (g) {
        if (b.flags & 256) return b.flags &= -257, yj(a, b, c, Error(p(422)));
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = wj({
          mode: "visible",
          children: d.children
        }, e, 0, null);
        f = xh(f, e, c, null);
        f.flags |= 2;
        d["return"] = b;
        f["return"] = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && yh(b, a.child, null, c);
        b.child.memoizedState = tj(c);
        b.memoizedState = sj;
        return f;
      }

      if (0 === (b.mode & 1)) b = yj(a, b, c, null);else if ("$!" === h.data) b = yj(a, b, c, Error(p(419)));else if (d = 0 !== (c & a.childLanes), tg || d) {
        d = P;

        if (null !== d) {
          switch (c & -c) {
            case 4:
              f = 2;
              break;

            case 16:
              f = 8;
              break;

            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              f = 32;
              break;

            case 536870912:
              f = 268435456;
              break;

            default:
              f = 0;
          }

          d = 0 !== (f & (d.suspendedLanes | c)) ? 0 : f;
          0 !== d && d !== e.retryLane && (e.retryLane = d, Lg(a, d, -1));
        }

        $i();
        b = yj(a, b, c, Error(p(421)));
      } else "$?" === h.data ? (b.flags |= 128, b.child = a.child, b = zj.bind(null, a), h._reactRetry = b, b = null) : (c = e.treeContext, eh = Kf(h.nextSibling), dh = b, I = !0, fh = null, null !== c && (Vg[Wg++] = Yg, Vg[Wg++] = Zg, Vg[Wg++] = Xg, Yg = c.id, Zg = c.overflow, Xg = b), b = xj(b, b.pendingProps.children), b.flags |= 4096);
      return b;
    }

    if (f) return d = Aj(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? tj(c) : uj(e, c), f.childLanes = a.childLanes & ~c, b.memoizedState = sj, d;
    c = Bj(a, b, d.children, c);
    b.memoizedState = null;
    return c;
  }

  if (f) return d = Aj(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? tj(c) : uj(e, c), f.childLanes = a.childLanes & ~c, b.memoizedState = sj, d;
  c = Bj(a, b, d.children, c);
  b.memoizedState = null;
  return c;
}

function xj(a, b) {
  b = wj({
    mode: "visible",
    children: b
  }, a.mode, 0, null);
  b["return"] = a;
  return a.child = b;
}

function Bj(a, b, c, d) {
  var e = a.child;
  a = e.sibling;
  c = th(e, {
    mode: "visible",
    children: c
  });
  0 === (b.mode & 1) && (c.lanes = d);
  c["return"] = b;
  c.sibling = null;
  null !== a && (d = b.deletions, null === d ? (b.deletions = [a], b.flags |= 16) : d.push(a));
  return b.child = c;
}

function Aj(a, b, c, d, e) {
  var f = b.mode;
  a = a.child;
  var g = a.sibling,
      h = {
    mode: "hidden",
    children: c
  };
  0 === (f & 1) && b.child !== a ? (c = b.child, c.childLanes = 0, c.pendingProps = h, b.deletions = null) : (c = th(a, h), c.subtreeFlags = a.subtreeFlags & 14680064);
  null !== g ? d = th(g, d) : (d = xh(d, f, e, null), d.flags |= 2);
  d["return"] = b;
  c["return"] = b;
  c.sibling = d;
  b.child = c;
  return d;
}

function yj(a, b, c, d) {
  null !== d && oh(d);
  yh(b, a.child, null, c);
  a = xj(b, b.pendingProps.children);
  a.flags |= 2;
  b.memoizedState = null;
  return a;
}

function Cj(a, b, c) {
  a.lanes |= b;
  var d = a.alternate;
  null !== d && (d.lanes |= b);
  rg(a["return"], b, c);
}

function Dj(a, b, c, d, e) {
  var f = a.memoizedState;
  null === f ? a.memoizedState = {
    isBackwards: b,
    rendering: null,
    renderingStartTime: 0,
    last: d,
    tail: c,
    tailMode: e
  } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}

function Ej(a, b, c) {
  var d = b.pendingProps,
      e = d.revealOrder,
      f = d.tail;
  ej(a, b, d.children, c);
  d = K.current;
  if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;else {
    if (null !== a && 0 !== (a.flags & 128)) a: for (a = b.child; null !== a;) {
      if (13 === a.tag) null !== a.memoizedState && Cj(a, c, b);else if (19 === a.tag) Cj(a, c, b);else if (null !== a.child) {
        a.child["return"] = a;
        a = a.child;
        continue;
      }
      if (a === b) break a;

      for (; null === a.sibling;) {
        if (null === a["return"] || a["return"] === b) break a;
        a = a["return"];
      }

      a.sibling["return"] = a["return"];
      a = a.sibling;
    }
    d &= 1;
  }
  G(K, d);
  if (0 === (b.mode & 1)) b.memoizedState = null;else switch (e) {
    case "forwards":
      c = b.child;

      for (e = null; null !== c;) {
        a = c.alternate, null !== a && null === Jh(a) && (e = c), c = c.sibling;
      }

      c = e;
      null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
      Dj(b, !1, e, c, f);
      break;

    case "backwards":
      c = null;
      e = b.child;

      for (b.child = null; null !== e;) {
        a = e.alternate;

        if (null !== a && null === Jh(a)) {
          b.child = e;
          break;
        }

        a = e.sibling;
        e.sibling = c;
        c = e;
        e = a;
      }

      Dj(b, !0, c, null, f);
      break;

    case "together":
      Dj(b, !1, null, null, void 0);
      break;

    default:
      b.memoizedState = null;
  }
  return b.child;
}

function gj(a, b, c) {
  null !== a && (b.dependencies = a.dependencies);
  Fg |= b.lanes;
  if (0 === (c & b.childLanes)) return null;
  if (null !== a && b.child !== a.child) throw Error(p(153));

  if (null !== b.child) {
    a = b.child;
    c = th(a, a.pendingProps);
    b.child = c;

    for (c["return"] = b; null !== a.sibling;) {
      a = a.sibling, c = c.sibling = th(a, a.pendingProps), c["return"] = b;
    }

    c.sibling = null;
  }

  return b.child;
}

function Fj(a, b, c) {
  switch (b.tag) {
    case 3:
      qj(b);
      nh();
      break;

    case 5:
      Hh(b);
      break;

    case 1:
      Yf(b.type) && bg(b);
      break;

    case 4:
      Fh(b, b.stateNode.containerInfo);
      break;

    case 10:
      var d = b.type._context,
          e = b.memoizedProps.value;
      G(lg, d._currentValue);
      d._currentValue = e;
      break;

    case 13:
      d = b.memoizedState;

      if (null !== d) {
        if (null !== d.dehydrated) return G(K, K.current & 1), b.flags |= 128, null;
        if (0 !== (c & b.child.childLanes)) return vj(a, b, c);
        G(K, K.current & 1);
        a = gj(a, b, c);
        return null !== a ? a.sibling : null;
      }

      G(K, K.current & 1);
      break;

    case 19:
      d = 0 !== (c & b.childLanes);

      if (0 !== (a.flags & 128)) {
        if (d) return Ej(a, b, c);
        b.flags |= 128;
      }

      e = b.memoizedState;
      null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
      G(K, K.current);
      if (d) break;else return null;

    case 22:
    case 23:
      return b.lanes = 0, lj(a, b, c);
  }

  return gj(a, b, c);
}

function Gj(a, b) {
  ch(b);

  switch (b.tag) {
    case 1:
      return Yf(b.type) && Zf(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;

    case 3:
      return Gh(), E(Vf), E(H), Lh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;

    case 5:
      return Ih(b), null;

    case 13:
      E(K);
      a = b.memoizedState;

      if (null !== a && null !== a.dehydrated) {
        if (null === b.alternate) throw Error(p(340));
        nh();
      }

      a = b.flags;
      return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;

    case 19:
      return E(K), null;

    case 4:
      return Gh(), null;

    case 10:
      return qg(b.type._context), null;

    case 22:
    case 23:
      return bj(), null;

    case 24:
      return null;

    default:
      return null;
  }
}

var Hj = !1,
    S = !1,
    Ij = "function" === typeof WeakSet ? WeakSet : Set,
    T = null;

function Jj(a, b) {
  var c = a.ref;
  if (null !== c) if ("function" === typeof c) try {
    c(null);
  } catch (d) {
    U(a, b, d);
  } else c.current = null;
}

function Kj(a, b, c) {
  try {
    c();
  } catch (d) {
    U(a, b, d);
  }
}

var Lj = !1;

function Mj(a, b) {
  Bf = cd;
  a = Le();

  if (Me(a)) {
    if ("selectionStart" in a) var c = {
      start: a.selectionStart,
      end: a.selectionEnd
    };else a: {
      c = (c = a.ownerDocument) && c.defaultView || window;
      var d = c.getSelection && c.getSelection();

      if (d && 0 !== d.rangeCount) {
        c = d.anchorNode;
        var e = d.anchorOffset,
            f = d.focusNode;
        d = d.focusOffset;

        try {
          c.nodeType, f.nodeType;
        } catch (Z) {
          c = null;
          break a;
        }

        var g = 0,
            h = -1,
            k = -1,
            l = 0,
            n = 0,
            u = a,
            q = null;

        b: for (;;) {
          for (var y;;) {
            u !== c || 0 !== e && 3 !== u.nodeType || (h = g + e);
            u !== f || 0 !== d && 3 !== u.nodeType || (k = g + d);
            3 === u.nodeType && (g += u.nodeValue.length);
            if (null === (y = u.firstChild)) break;
            q = u;
            u = y;
          }

          for (;;) {
            if (u === a) break b;
            q === c && ++l === e && (h = g);
            q === f && ++n === d && (k = g);
            if (null !== (y = u.nextSibling)) break;
            u = q;
            q = u.parentNode;
          }

          u = y;
        }

        c = -1 === h || -1 === k ? null : {
          start: h,
          end: k
        };
      } else c = null;
    }
    c = c || {
      start: 0,
      end: 0
    };
  } else c = null;

  Cf = {
    focusedElem: a,
    selectionRange: c
  };
  cd = !1;

  for (T = b; null !== T;) {
    if (b = T, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a["return"] = b, T = a;else for (; null !== T;) {
      b = T;

      try {
        var m = b.alternate;
        if (0 !== (b.flags & 1024)) switch (b.tag) {
          case 0:
          case 11:
          case 15:
            break;

          case 1:
            if (null !== m) {
              var w = m.memoizedProps,
                  J = m.memoizedState,
                  v = b.stateNode,
                  x = v.getSnapshotBeforeUpdate(b.elementType === b.type ? w : kg(b.type, w), J);
              v.__reactInternalSnapshotBeforeUpdate = x;
            }

            break;

          case 3:
            var r = b.stateNode.containerInfo;
            if (1 === r.nodeType) r.textContent = "";else if (9 === r.nodeType) {
              var F = r.body;
              null != F && (F.textContent = "");
            }
            break;

          case 5:
          case 6:
          case 4:
          case 17:
            break;

          default:
            throw Error(p(163));
        }
      } catch (Z) {
        U(b, b["return"], Z);
      }

      a = b.sibling;

      if (null !== a) {
        a["return"] = b["return"];
        T = a;
        break;
      }

      T = b["return"];
    }
  }

  m = Lj;
  Lj = !1;
  return m;
}

function Nj(a, b, c) {
  var d = b.updateQueue;
  d = null !== d ? d.lastEffect : null;

  if (null !== d) {
    var e = d = d.next;

    do {
      if ((e.tag & a) === a) {
        var f = e.destroy;
        e.destroy = void 0;
        void 0 !== f && Kj(b, c, f);
      }

      e = e.next;
    } while (e !== d);
  }
}

function Oj(a, b) {
  b = b.updateQueue;
  b = null !== b ? b.lastEffect : null;

  if (null !== b) {
    var c = b = b.next;

    do {
      if ((c.tag & a) === a) {
        var d = c.create;
        c.destroy = d();
      }

      c = c.next;
    } while (c !== b);
  }
}

function Pj(a) {
  var b = a.ref;

  if (null !== b) {
    var c = a.stateNode;

    switch (a.tag) {
      case 5:
        a = c;
        break;

      default:
        a = c;
    }

    "function" === typeof b ? b(a) : b.current = a;
  }
}

function Qj(a) {
  var b = a.alternate;
  null !== b && (a.alternate = null, Qj(b));
  a.child = null;
  a.deletions = null;
  a.sibling = null;
  5 === a.tag && (b = a.stateNode, null !== b && (delete b[Nf], delete b[Of], delete b[nf], delete b[Pf], delete b[Qf]));
  a.stateNode = null;
  a["return"] = null;
  a.dependencies = null;
  a.memoizedProps = null;
  a.memoizedState = null;
  a.pendingProps = null;
  a.stateNode = null;
  a.updateQueue = null;
}

function Rj(a) {
  return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}

function Sj(a) {
  a: for (;;) {
    for (; null === a.sibling;) {
      if (null === a["return"] || Rj(a["return"])) return null;
      a = a["return"];
    }

    a.sibling["return"] = a["return"];

    for (a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;) {
      if (a.flags & 2) continue a;
      if (null === a.child || 4 === a.tag) continue a;else a.child["return"] = a, a = a.child;
    }

    if (!(a.flags & 2)) return a.stateNode;
  }
}

function Tj(a, b, c) {
  var d = a.tag;
  if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Af));else if (4 !== d && (a = a.child, null !== a)) for (Tj(a, b, c), a = a.sibling; null !== a;) {
    Tj(a, b, c), a = a.sibling;
  }
}

function Uj(a, b, c) {
  var d = a.tag;
  if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);else if (4 !== d && (a = a.child, null !== a)) for (Uj(a, b, c), a = a.sibling; null !== a;) {
    Uj(a, b, c), a = a.sibling;
  }
}

var V = null,
    Vj = !1;

function Wj(a, b, c) {
  for (c = c.child; null !== c;) {
    Xj(a, b, c), c = c.sibling;
  }
}

function Xj(a, b, c) {
  if (kc && "function" === typeof kc.onCommitFiberUnmount) try {
    kc.onCommitFiberUnmount(jc, c);
  } catch (h) {}

  switch (c.tag) {
    case 5:
      S || Jj(c, b);

    case 6:
      var d = V,
          e = Vj;
      V = null;
      Wj(a, b, c);
      V = d;
      Vj = e;
      null !== V && (Vj ? (a = V, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : V.removeChild(c.stateNode));
      break;

    case 18:
      null !== V && (Vj ? (a = V, c = c.stateNode, 8 === a.nodeType ? Jf(a.parentNode, c) : 1 === a.nodeType && Jf(a, c), ad(a)) : Jf(V, c.stateNode));
      break;

    case 4:
      d = V;
      e = Vj;
      V = c.stateNode.containerInfo;
      Vj = !0;
      Wj(a, b, c);
      V = d;
      Vj = e;
      break;

    case 0:
    case 11:
    case 14:
    case 15:
      if (!S && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
        e = d = d.next;

        do {
          var f = e,
              g = f.destroy;
          f = f.tag;
          void 0 !== g && (0 !== (f & 2) ? Kj(c, b, g) : 0 !== (f & 4) && Kj(c, b, g));
          e = e.next;
        } while (e !== d);
      }

      Wj(a, b, c);
      break;

    case 1:
      if (!S && (Jj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
        d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
      } catch (h) {
        U(c, b, h);
      }
      Wj(a, b, c);
      break;

    case 21:
      Wj(a, b, c);
      break;

    case 22:
      c.mode & 1 ? (S = (d = S) || null !== c.memoizedState, Wj(a, b, c), S = d) : Wj(a, b, c);
      break;

    default:
      Wj(a, b, c);
  }
}

function Yj(a) {
  var b = a.updateQueue;

  if (null !== b) {
    a.updateQueue = null;
    var c = a.stateNode;
    null === c && (c = a.stateNode = new Ij());
    b.forEach(function (b) {
      var d = Zj.bind(null, a, b);
      c.has(b) || (c.add(b), b.then(d, d));
    });
  }
}

function ak(a, b) {
  var c = b.deletions;
  if (null !== c) for (var d = 0; d < c.length; d++) {
    var e = c[d];

    try {
      var f = a,
          g = b,
          h = g;

      a: for (; null !== h;) {
        switch (h.tag) {
          case 5:
            V = h.stateNode;
            Vj = !1;
            break a;

          case 3:
            V = h.stateNode.containerInfo;
            Vj = !0;
            break a;

          case 4:
            V = h.stateNode.containerInfo;
            Vj = !0;
            break a;
        }

        h = h["return"];
      }

      if (null === V) throw Error(p(160));
      Xj(f, g, e);
      V = null;
      Vj = !1;
      var k = e.alternate;
      null !== k && (k["return"] = null);
      e["return"] = null;
    } catch (l) {
      U(e, b, l);
    }
  }
  if (b.subtreeFlags & 12854) for (b = b.child; null !== b;) {
    bk(b, a), b = b.sibling;
  }
}

function bk(a, b) {
  var c = a.alternate,
      d = a.flags;

  switch (a.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      ak(b, a);
      ck(a);

      if (d & 4) {
        try {
          Nj(3, a, a["return"]), Oj(3, a);
        } catch (m) {
          U(a, a["return"], m);
        }

        try {
          Nj(5, a, a["return"]);
        } catch (m) {
          U(a, a["return"], m);
        }
      }

      break;

    case 1:
      ak(b, a);
      ck(a);
      d & 512 && null !== c && Jj(c, c["return"]);
      break;

    case 5:
      ak(b, a);
      ck(a);
      d & 512 && null !== c && Jj(c, c["return"]);

      if (a.flags & 32) {
        var e = a.stateNode;

        try {
          nb(e, "");
        } catch (m) {
          U(a, a["return"], m);
        }
      }

      if (d & 4 && (e = a.stateNode, null != e)) {
        var f = a.memoizedProps,
            g = null !== c ? c.memoizedProps : f,
            h = a.type,
            k = a.updateQueue;
        a.updateQueue = null;
        if (null !== k) try {
          "input" === h && "radio" === f.type && null != f.name && Za(e, f);
          ub(h, g);
          var l = ub(h, f);

          for (g = 0; g < k.length; g += 2) {
            var n = k[g],
                u = k[g + 1];
            "style" === n ? rb(e, u) : "dangerouslySetInnerHTML" === n ? mb(e, u) : "children" === n ? nb(e, u) : sa(e, n, u, l);
          }

          switch (h) {
            case "input":
              $a(e, f);
              break;

            case "textarea":
              hb(e, f);
              break;

            case "select":
              var q = e._wrapperState.wasMultiple;
              e._wrapperState.wasMultiple = !!f.multiple;
              var y = f.value;
              null != y ? eb(e, !!f.multiple, y, !1) : q !== !!f.multiple && (null != f.defaultValue ? eb(e, !!f.multiple, f.defaultValue, !0) : eb(e, !!f.multiple, f.multiple ? [] : "", !1));
          }

          e[Of] = f;
        } catch (m) {
          U(a, a["return"], m);
        }
      }

      break;

    case 6:
      ak(b, a);
      ck(a);

      if (d & 4) {
        if (null === a.stateNode) throw Error(p(162));
        l = a.stateNode;
        n = a.memoizedProps;

        try {
          l.nodeValue = n;
        } catch (m) {
          U(a, a["return"], m);
        }
      }

      break;

    case 3:
      ak(b, a);
      ck(a);
      if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
        ad(b.containerInfo);
      } catch (m) {
        U(a, a["return"], m);
      }
      break;

    case 4:
      ak(b, a);
      ck(a);
      break;

    case 13:
      ak(b, a);
      ck(a);
      l = a.child;
      l.flags & 8192 && null !== l.memoizedState && (null === l.alternate || null === l.alternate.memoizedState) && (dk = B());
      d & 4 && Yj(a);
      break;

    case 22:
      l = null !== c && null !== c.memoizedState;
      a.mode & 1 ? (S = (n = S) || l, ak(b, a), S = n) : ak(b, a);
      ck(a);

      if (d & 8192) {
        n = null !== a.memoizedState;

        a: for (u = null, q = a;;) {
          if (5 === q.tag) {
            if (null === u) {
              u = q;

              try {
                e = q.stateNode, n ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = qb("display", g));
              } catch (m) {
                U(a, a["return"], m);
              }
            }
          } else if (6 === q.tag) {
            if (null === u) try {
              q.stateNode.nodeValue = n ? "" : q.memoizedProps;
            } catch (m) {
              U(a, a["return"], m);
            }
          } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
            q.child["return"] = q;
            q = q.child;
            continue;
          }

          if (q === a) break a;

          for (; null === q.sibling;) {
            if (null === q["return"] || q["return"] === a) break a;
            u === q && (u = null);
            q = q["return"];
          }

          u === q && (u = null);
          q.sibling["return"] = q["return"];
          q = q.sibling;
        }

        if (n && !l && 0 !== (a.mode & 1)) for (T = a, a = a.child; null !== a;) {
          for (l = T = a; null !== T;) {
            n = T;
            u = n.child;

            switch (n.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                Nj(4, n, n["return"]);
                break;

              case 1:
                Jj(n, n["return"]);
                f = n.stateNode;

                if ("function" === typeof f.componentWillUnmount) {
                  q = n;
                  y = n["return"];

                  try {
                    e = q, f.props = e.memoizedProps, f.state = e.memoizedState, f.componentWillUnmount();
                  } catch (m) {
                    U(q, y, m);
                  }
                }

                break;

              case 5:
                Jj(n, n["return"]);
                break;

              case 22:
                if (null !== n.memoizedState) {
                  ek(l);
                  continue;
                }

            }

            null !== u ? (u["return"] = n, T = u) : ek(l);
          }

          a = a.sibling;
        }
      }

      break;

    case 19:
      ak(b, a);
      ck(a);
      d & 4 && Yj(a);
      break;

    case 21:
      break;

    default:
      ak(b, a), ck(a);
  }
}

function ck(a) {
  var b = a.flags;

  if (b & 2) {
    try {
      a: {
        for (var c = a["return"]; null !== c;) {
          if (Rj(c)) {
            var d = c;
            break a;
          }

          c = c["return"];
        }

        throw Error(p(160));
      }

      switch (d.tag) {
        case 5:
          var e = d.stateNode;
          d.flags & 32 && (nb(e, ""), d.flags &= -33);
          var f = Sj(a);
          Uj(a, f, e);
          break;

        case 3:
        case 4:
          var g = d.stateNode.containerInfo,
              h = Sj(a);
          Tj(a, h, g);
          break;

        default:
          throw Error(p(161));
      }
    } catch (k) {
      U(a, a["return"], k);
    }

    a.flags &= -3;
  }

  b & 4096 && (a.flags &= -4097);
}

function fk(a, b, c) {
  T = a;
  gk(a);
}

function gk(a, b, c) {
  for (var d = 0 !== (a.mode & 1); null !== T;) {
    var e = T,
        f = e.child;

    if (22 === e.tag && d) {
      var g = null !== e.memoizedState || Hj;

      if (!g) {
        var h = e.alternate,
            k = null !== h && null !== h.memoizedState || S;
        h = Hj;
        var l = S;
        Hj = g;
        if ((S = k) && !l) for (T = e; null !== T;) {
          g = T, k = g.child, 22 === g.tag && null !== g.memoizedState ? hk(e) : null !== k ? (k["return"] = g, T = k) : hk(e);
        }

        for (; null !== f;) {
          T = f, gk(f), f = f.sibling;
        }

        T = e;
        Hj = h;
        S = l;
      }

      ik(a);
    } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f["return"] = e, T = f) : ik(a);
  }
}

function ik(a) {
  for (; null !== T;) {
    var b = T;

    if (0 !== (b.flags & 8772)) {
      var c = b.alternate;

      try {
        if (0 !== (b.flags & 8772)) switch (b.tag) {
          case 0:
          case 11:
          case 15:
            S || Oj(5, b);
            break;

          case 1:
            var d = b.stateNode;
            if (b.flags & 4 && !S) if (null === c) d.componentDidMount();else {
              var e = b.elementType === b.type ? c.memoizedProps : kg(b.type, c.memoizedProps);
              d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
            }
            var f = b.updateQueue;
            null !== f && Gg(b, f, d);
            break;

          case 3:
            var g = b.updateQueue;

            if (null !== g) {
              c = null;
              if (null !== b.child) switch (b.child.tag) {
                case 5:
                  c = b.child.stateNode;
                  break;

                case 1:
                  c = b.child.stateNode;
              }
              Gg(b, g, c);
            }

            break;

          case 5:
            var h = b.stateNode;

            if (null === c && b.flags & 4) {
              c = h;
              var k = b.memoizedProps;

              switch (b.type) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  k.autoFocus && c.focus();
                  break;

                case "img":
                  k.src && (c.src = k.src);
              }
            }

            break;

          case 6:
            break;

          case 4:
            break;

          case 12:
            break;

          case 13:
            if (null === b.memoizedState) {
              var l = b.alternate;

              if (null !== l) {
                var n = l.memoizedState;

                if (null !== n) {
                  var u = n.dehydrated;
                  null !== u && ad(u);
                }
              }
            }

            break;

          case 19:
          case 17:
          case 21:
          case 22:
          case 23:
            break;

          default:
            throw Error(p(163));
        }
        S || b.flags & 512 && Pj(b);
      } catch (q) {
        U(b, b["return"], q);
      }
    }

    if (b === a) {
      T = null;
      break;
    }

    c = b.sibling;

    if (null !== c) {
      c["return"] = b["return"];
      T = c;
      break;
    }

    T = b["return"];
  }
}

function ek(a) {
  for (; null !== T;) {
    var b = T;

    if (b === a) {
      T = null;
      break;
    }

    var c = b.sibling;

    if (null !== c) {
      c["return"] = b["return"];
      T = c;
      break;
    }

    T = b["return"];
  }
}

function hk(a) {
  for (; null !== T;) {
    var b = T;

    try {
      switch (b.tag) {
        case 0:
        case 11:
        case 15:
          var c = b["return"];

          try {
            Oj(4, b);
          } catch (k) {
            U(b, c, k);
          }

          break;

        case 1:
          var d = b.stateNode;

          if ("function" === typeof d.componentDidMount) {
            var e = b["return"];

            try {
              d.componentDidMount();
            } catch (k) {
              U(b, e, k);
            }
          }

          var f = b["return"];

          try {
            Pj(b);
          } catch (k) {
            U(b, f, k);
          }

          break;

        case 5:
          var g = b["return"];

          try {
            Pj(b);
          } catch (k) {
            U(b, g, k);
          }

      }
    } catch (k) {
      U(b, b["return"], k);
    }

    if (b === a) {
      T = null;
      break;
    }

    var h = b.sibling;

    if (null !== h) {
      h["return"] = b["return"];
      T = h;
      break;
    }

    T = b["return"];
  }
}

var jk = Math.ceil,
    kk = ta.ReactCurrentDispatcher,
    lk = ta.ReactCurrentOwner,
    mk = ta.ReactCurrentBatchConfig,
    W = 0,
    P = null,
    X = null,
    Y = 0,
    cj = 0,
    mj = Tf(0),
    R = 0,
    nk = null,
    Fg = 0,
    ok = 0,
    pk = 0,
    qk = null,
    rk = null,
    dk = 0,
    aj = Infinity,
    sk = null,
    Li = !1,
    Mi = null,
    Oi = null,
    tk = !1,
    uk = null,
    vk = 0,
    wk = 0,
    xk = null,
    yk = -1,
    zk = 0;

function Jg() {
  return 0 !== (W & 6) ? B() : -1 !== yk ? yk : yk = B();
}

function Kg(a) {
  if (0 === (a.mode & 1)) return 1;
  if (0 !== (W & 2) && 0 !== Y) return Y & -Y;
  if (null !== jg.transition) return 0 === zk && (zk = xc()), zk;
  a = C;
  if (0 !== a) return a;
  a = window.event;
  a = void 0 === a ? 16 : id(a.type);
  return a;
}

function Lg(a, b, c) {
  if (50 < wk) throw wk = 0, xk = null, Error(p(185));
  var d = Ak(a, b);
  if (null === d) return null;
  zc(d, b, c);
  if (0 === (W & 2) || d !== P) d === P && (0 === (W & 2) && (ok |= b), 4 === R && Bk(d, Y)), Ck(d, c), 1 === b && 0 === W && 0 === (a.mode & 1) && (aj = B() + 500, eg && ig());
  return d;
}

function Ak(a, b) {
  a.lanes |= b;
  var c = a.alternate;
  null !== c && (c.lanes |= b);
  c = a;

  for (a = a["return"]; null !== a;) {
    a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a["return"];
  }

  return 3 === c.tag ? c.stateNode : null;
}

function Bg(a) {
  return (null !== P || null !== vg) && 0 !== (a.mode & 1) && 0 === (W & 2);
}

function Ck(a, b) {
  var c = a.callbackNode;
  vc(a, b);
  var d = tc(a, a === P ? Y : 0);
  if (0 === d) null !== c && ac(c), a.callbackNode = null, a.callbackPriority = 0;else if (b = d & -d, a.callbackPriority !== b) {
    null != c && ac(c);
    if (1 === b) 0 === a.tag ? hg(Dk.bind(null, a)) : gg(Dk.bind(null, a)), If(function () {
      0 === W && ig();
    }), c = null;else {
      switch (Cc(d)) {
        case 1:
          c = ec;
          break;

        case 4:
          c = fc;
          break;

        case 16:
          c = gc;
          break;

        case 536870912:
          c = ic;
          break;

        default:
          c = gc;
      }

      c = Ek(c, Fk.bind(null, a));
    }
    a.callbackPriority = b;
    a.callbackNode = c;
  }
}

function Fk(a, b) {
  yk = -1;
  zk = 0;
  if (0 !== (W & 6)) throw Error(p(327));
  var c = a.callbackNode;
  if (Gk() && a.callbackNode !== c) return null;
  var d = tc(a, a === P ? Y : 0);
  if (0 === d) return null;
  if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Hk(a, d);else {
    b = d;
    var e = W;
    W |= 2;
    var f = Ik();
    if (P !== a || Y !== b) sk = null, aj = B() + 500, Jk(a, b);

    do {
      try {
        Kk();
        break;
      } catch (h) {
        Lk(a, h);
      }
    } while (1);

    pg();
    kk.current = f;
    W = e;
    null !== X ? b = 0 : (P = null, Y = 0, b = R);
  }

  if (0 !== b) {
    2 === b && (e = wc(a), 0 !== e && (d = e, b = Mk(a, e)));
    if (1 === b) throw c = nk, Jk(a, 0), Bk(a, d), Ck(a, B()), c;
    if (6 === b) Bk(a, d);else {
      e = a.current.alternate;
      if (0 === (d & 30) && !Nk(e) && (b = Hk(a, d), 2 === b && (f = wc(a), 0 !== f && (d = f, b = Mk(a, f))), 1 === b)) throw c = nk, Jk(a, 0), Bk(a, d), Ck(a, B()), c;
      a.finishedWork = e;
      a.finishedLanes = d;

      switch (b) {
        case 0:
        case 1:
          throw Error(p(345));

        case 2:
          Ok(a, rk, sk);
          break;

        case 3:
          Bk(a, d);

          if ((d & 130023424) === d && (b = dk + 500 - B(), 10 < b)) {
            if (0 !== tc(a, 0)) break;
            e = a.suspendedLanes;

            if ((e & d) !== d) {
              Jg();
              a.pingedLanes |= a.suspendedLanes & e;
              break;
            }

            a.timeoutHandle = Ef(Ok.bind(null, a, rk, sk), b);
            break;
          }

          Ok(a, rk, sk);
          break;

        case 4:
          Bk(a, d);
          if ((d & 4194240) === d) break;
          b = a.eventTimes;

          for (e = -1; 0 < d;) {
            var g = 31 - nc(d);
            f = 1 << g;
            g = b[g];
            g > e && (e = g);
            d &= ~f;
          }

          d = e;
          d = B() - d;
          d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * jk(d / 1960)) - d;

          if (10 < d) {
            a.timeoutHandle = Ef(Ok.bind(null, a, rk, sk), d);
            break;
          }

          Ok(a, rk, sk);
          break;

        case 5:
          Ok(a, rk, sk);
          break;

        default:
          throw Error(p(329));
      }
    }
  }

  Ck(a, B());
  return a.callbackNode === c ? Fk.bind(null, a) : null;
}

function Mk(a, b) {
  var c = qk;
  a.current.memoizedState.isDehydrated && (Jk(a, b).flags |= 256);
  a = Hk(a, b);
  2 !== a && (b = rk, rk = c, null !== b && Zi(b));
  return a;
}

function Zi(a) {
  null === rk ? rk = a : rk.push.apply(rk, a);
}

function Nk(a) {
  for (var b = a;;) {
    if (b.flags & 16384) {
      var c = b.updateQueue;
      if (null !== c && (c = c.stores, null !== c)) for (var d = 0; d < c.length; d++) {
        var e = c[d],
            f = e.getSnapshot;
        e = e.value;

        try {
          if (!Ge(f(), e)) return !1;
        } catch (g) {
          return !1;
        }
      }
    }

    c = b.child;
    if (b.subtreeFlags & 16384 && null !== c) c["return"] = b, b = c;else {
      if (b === a) break;

      for (; null === b.sibling;) {
        if (null === b["return"] || b["return"] === a) return !0;
        b = b["return"];
      }

      b.sibling["return"] = b["return"];
      b = b.sibling;
    }
  }

  return !0;
}

function Bk(a, b) {
  b &= ~pk;
  b &= ~ok;
  a.suspendedLanes |= b;
  a.pingedLanes &= ~b;

  for (a = a.expirationTimes; 0 < b;) {
    var c = 31 - nc(b),
        d = 1 << c;
    a[c] = -1;
    b &= ~d;
  }
}

function Dk(a) {
  if (0 !== (W & 6)) throw Error(p(327));
  Gk();
  var b = tc(a, 0);
  if (0 === (b & 1)) return Ck(a, B()), null;
  var c = Hk(a, b);

  if (0 !== a.tag && 2 === c) {
    var d = wc(a);
    0 !== d && (b = d, c = Mk(a, d));
  }

  if (1 === c) throw c = nk, Jk(a, 0), Bk(a, b), Ck(a, B()), c;
  if (6 === c) throw Error(p(345));
  a.finishedWork = a.current.alternate;
  a.finishedLanes = b;
  Ok(a, rk, sk);
  Ck(a, B());
  return null;
}

function Pk(a, b) {
  var c = W;
  W |= 1;

  try {
    return a(b);
  } finally {
    W = c, 0 === W && (aj = B() + 500, eg && ig());
  }
}

function Qk(a) {
  null !== uk && 0 === uk.tag && 0 === (W & 6) && Gk();
  var b = W;
  W |= 1;
  var c = mk.transition,
      d = C;

  try {
    if (mk.transition = null, C = 1, a) return a();
  } finally {
    C = d, mk.transition = c, W = b, 0 === (W & 6) && ig();
  }
}

function bj() {
  cj = mj.current;
  E(mj);
}

function Jk(a, b) {
  a.finishedWork = null;
  a.finishedLanes = 0;
  var c = a.timeoutHandle;
  -1 !== c && (a.timeoutHandle = -1, Ff(c));
  if (null !== X) for (c = X["return"]; null !== c;) {
    var d = c;
    ch(d);

    switch (d.tag) {
      case 1:
        d = d.type.childContextTypes;
        null !== d && void 0 !== d && Zf();
        break;

      case 3:
        Gh();
        E(Vf);
        E(H);
        Lh();
        break;

      case 5:
        Ih(d);
        break;

      case 4:
        Gh();
        break;

      case 13:
        E(K);
        break;

      case 19:
        E(K);
        break;

      case 10:
        qg(d.type._context);
        break;

      case 22:
      case 23:
        bj();
    }

    c = c["return"];
  }
  P = a;
  X = a = th(a.current, null);
  Y = cj = b;
  R = 0;
  nk = null;
  pk = ok = Fg = 0;
  rk = qk = null;

  if (null !== vg) {
    for (b = 0; b < vg.length; b++) {
      if (c = vg[b], d = c.interleaved, null !== d) {
        c.interleaved = null;
        var e = d.next,
            f = c.pending;

        if (null !== f) {
          var g = f.next;
          f.next = e;
          d.next = g;
        }

        c.pending = d;
      }
    }

    vg = null;
  }

  return a;
}

function Lk(a, b) {
  do {
    var c = X;

    try {
      pg();
      Mh.current = Yh;

      if (Ph) {
        for (var d = L.memoizedState; null !== d;) {
          var e = d.queue;
          null !== e && (e.pending = null);
          d = d.next;
        }

        Ph = !1;
      }

      Oh = 0;
      N = M = L = null;
      Qh = !1;
      Rh = 0;
      lk.current = null;

      if (null === c || null === c["return"]) {
        R = 1;
        nk = b;
        X = null;
        break;
      }

      a: {
        var f = a,
            g = c["return"],
            h = c,
            k = b;
        b = Y;
        h.flags |= 32768;

        if (null !== k && "object" === typeof k && "function" === typeof k.then) {
          var l = k,
              n = h,
              u = n.tag;

          if (0 === (n.mode & 1) && (0 === u || 11 === u || 15 === u)) {
            var q = n.alternate;
            q ? (n.updateQueue = q.updateQueue, n.memoizedState = q.memoizedState, n.lanes = q.lanes) : (n.updateQueue = null, n.memoizedState = null);
          }

          var y = Ri(g);

          if (null !== y) {
            y.flags &= -257;
            Si(y, g, h, f, b);
            y.mode & 1 && Pi(f, l, b);
            b = y;
            k = l;
            var m = b.updateQueue;

            if (null === m) {
              var w = new Set();
              w.add(k);
              b.updateQueue = w;
            } else m.add(k);

            break a;
          } else {
            if (0 === (b & 1)) {
              Pi(f, l, b);
              $i();
              break a;
            }

            k = Error(p(426));
          }
        } else if (I && h.mode & 1) {
          var J = Ri(g);

          if (null !== J) {
            0 === (J.flags & 65536) && (J.flags |= 256);
            Si(J, g, h, f, b);
            oh(k);
            break a;
          }
        }

        f = k;
        4 !== R && (R = 2);
        null === qk ? qk = [f] : qk.push(f);
        k = Hi(k, h);
        h = g;

        do {
          switch (h.tag) {
            case 3:
              h.flags |= 65536;
              b &= -b;
              h.lanes |= b;
              var v = Ki(h, k, b);
              Dg(h, v);
              break a;

            case 1:
              f = k;
              var x = h.type,
                  r = h.stateNode;

              if (0 === (h.flags & 128) && ("function" === typeof x.getDerivedStateFromError || null !== r && "function" === typeof r.componentDidCatch && (null === Oi || !Oi.has(r)))) {
                h.flags |= 65536;
                b &= -b;
                h.lanes |= b;
                var F = Ni(h, f, b);
                Dg(h, F);
                break a;
              }

          }

          h = h["return"];
        } while (null !== h);
      }

      Rk(c);
    } catch (Z) {
      b = Z;
      X === c && null !== c && (X = c = c["return"]);
      continue;
    }

    break;
  } while (1);
}

function Ik() {
  var a = kk.current;
  kk.current = Yh;
  return null === a ? Yh : a;
}

function $i() {
  if (0 === R || 3 === R || 2 === R) R = 4;
  null === P || 0 === (Fg & 268435455) && 0 === (ok & 268435455) || Bk(P, Y);
}

function Hk(a, b) {
  var c = W;
  W |= 2;
  var d = Ik();
  if (P !== a || Y !== b) sk = null, Jk(a, b);

  do {
    try {
      Sk();
      break;
    } catch (e) {
      Lk(a, e);
    }
  } while (1);

  pg();
  W = c;
  kk.current = d;
  if (null !== X) throw Error(p(261));
  P = null;
  Y = 0;
  return R;
}

function Sk() {
  for (; null !== X;) {
    Tk(X);
  }
}

function Kk() {
  for (; null !== X && !bc();) {
    Tk(X);
  }
}

function Tk(a) {
  var b = Uk(a.alternate, a, cj);
  a.memoizedProps = a.pendingProps;
  null === b ? Rk(a) : X = b;
  lk.current = null;
}

function Rk(a) {
  var b = a;

  do {
    var c = b.alternate;
    a = b["return"];

    if (0 === (b.flags & 32768)) {
      if (c = Yi(c, b, cj), null !== c) {
        X = c;
        return;
      }
    } else {
      c = Gj(c, b);

      if (null !== c) {
        c.flags &= 32767;
        X = c;
        return;
      }

      if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;else {
        R = 6;
        X = null;
        return;
      }
    }

    b = b.sibling;

    if (null !== b) {
      X = b;
      return;
    }

    X = b = a;
  } while (null !== b);

  0 === R && (R = 5);
}

function Ok(a, b, c) {
  var d = C,
      e = mk.transition;

  try {
    mk.transition = null, C = 1, Vk(a, b, c, d);
  } finally {
    mk.transition = e, C = d;
  }

  return null;
}

function Vk(a, b, c, d) {
  do {
    Gk();
  } while (null !== uk);

  if (0 !== (W & 6)) throw Error(p(327));
  c = a.finishedWork;
  var e = a.finishedLanes;
  if (null === c) return null;
  a.finishedWork = null;
  a.finishedLanes = 0;
  if (c === a.current) throw Error(p(177));
  a.callbackNode = null;
  a.callbackPriority = 0;
  var f = c.lanes | c.childLanes;
  Ac(a, f);
  a === P && (X = P = null, Y = 0);
  0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || tk || (tk = !0, Ek(gc, function () {
    Gk();
    return null;
  }));
  f = 0 !== (c.flags & 15990);

  if (0 !== (c.subtreeFlags & 15990) || f) {
    f = mk.transition;
    mk.transition = null;
    var g = C;
    C = 1;
    var h = W;
    W |= 4;
    lk.current = null;
    Mj(a, c);
    bk(c, a);
    Ne(Cf);
    cd = !!Bf;
    Cf = Bf = null;
    a.current = c;
    fk(c);
    cc();
    W = h;
    C = g;
    mk.transition = f;
  } else a.current = c;

  tk && (tk = !1, uk = a, vk = e);
  f = a.pendingLanes;
  0 === f && (Oi = null);
  lc(c.stateNode);
  Ck(a, B());
  if (null !== b) for (d = a.onRecoverableError, c = 0; c < b.length; c++) {
    d(b[c]);
  }
  if (Li) throw Li = !1, a = Mi, Mi = null, a;
  0 !== (vk & 1) && 0 !== a.tag && Gk();
  f = a.pendingLanes;
  0 !== (f & 1) ? a === xk ? wk++ : (wk = 0, xk = a) : wk = 0;
  ig();
  return null;
}

function Gk() {
  if (null !== uk) {
    var a = Cc(vk),
        b = mk.transition,
        c = C;

    try {
      mk.transition = null;
      C = 16 > a ? 16 : a;
      if (null === uk) var d = !1;else {
        a = uk;
        uk = null;
        vk = 0;
        if (0 !== (W & 6)) throw Error(p(331));
        var e = W;
        W |= 4;

        for (T = a.current; null !== T;) {
          var f = T,
              g = f.child;

          if (0 !== (T.flags & 16)) {
            var h = f.deletions;

            if (null !== h) {
              for (var k = 0; k < h.length; k++) {
                var l = h[k];

                for (T = l; null !== T;) {
                  var n = T;

                  switch (n.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Nj(8, n, f);
                  }

                  var u = n.child;
                  if (null !== u) u["return"] = n, T = u;else for (; null !== T;) {
                    n = T;
                    var q = n.sibling,
                        y = n["return"];
                    Qj(n);

                    if (n === l) {
                      T = null;
                      break;
                    }

                    if (null !== q) {
                      q["return"] = y;
                      T = q;
                      break;
                    }

                    T = y;
                  }
                }
              }

              var m = f.alternate;

              if (null !== m) {
                var w = m.child;

                if (null !== w) {
                  m.child = null;

                  do {
                    var J = w.sibling;
                    w.sibling = null;
                    w = J;
                  } while (null !== w);
                }
              }

              T = f;
            }
          }

          if (0 !== (f.subtreeFlags & 2064) && null !== g) g["return"] = f, T = g;else b: for (; null !== T;) {
            f = T;
            if (0 !== (f.flags & 2048)) switch (f.tag) {
              case 0:
              case 11:
              case 15:
                Nj(9, f, f["return"]);
            }
            var v = f.sibling;

            if (null !== v) {
              v["return"] = f["return"];
              T = v;
              break b;
            }

            T = f["return"];
          }
        }

        var x = a.current;

        for (T = x; null !== T;) {
          g = T;
          var r = g.child;
          if (0 !== (g.subtreeFlags & 2064) && null !== r) r["return"] = g, T = r;else b: for (g = x; null !== T;) {
            h = T;
            if (0 !== (h.flags & 2048)) try {
              switch (h.tag) {
                case 0:
                case 11:
                case 15:
                  Oj(9, h);
              }
            } catch (Z) {
              U(h, h["return"], Z);
            }

            if (h === g) {
              T = null;
              break b;
            }

            var F = h.sibling;

            if (null !== F) {
              F["return"] = h["return"];
              T = F;
              break b;
            }

            T = h["return"];
          }
        }

        W = e;
        ig();
        if (kc && "function" === typeof kc.onPostCommitFiberRoot) try {
          kc.onPostCommitFiberRoot(jc, a);
        } catch (Z) {}
        d = !0;
      }
      return d;
    } finally {
      C = c, mk.transition = b;
    }
  }

  return !1;
}

function Wk(a, b, c) {
  b = Hi(c, b);
  b = Ki(a, b, 1);
  Ag(a, b);
  b = Jg();
  a = Ak(a, 1);
  null !== a && (zc(a, 1, b), Ck(a, b));
}

function U(a, b, c) {
  if (3 === a.tag) Wk(a, a, c);else for (; null !== b;) {
    if (3 === b.tag) {
      Wk(b, a, c);
      break;
    } else if (1 === b.tag) {
      var d = b.stateNode;

      if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Oi || !Oi.has(d))) {
        a = Hi(c, a);
        a = Ni(b, a, 1);
        Ag(b, a);
        a = Jg();
        b = Ak(b, 1);
        null !== b && (zc(b, 1, a), Ck(b, a));
        break;
      }
    }

    b = b["return"];
  }
}

function Qi(a, b, c) {
  var d = a.pingCache;
  null !== d && d["delete"](b);
  b = Jg();
  a.pingedLanes |= a.suspendedLanes & c;
  P === a && (Y & c) === c && (4 === R || 3 === R && (Y & 130023424) === Y && 500 > B() - dk ? Jk(a, 0) : pk |= c);
  Ck(a, b);
}

function Xk(a, b) {
  0 === b && (0 === (a.mode & 1) ? b = 1 : (b = rc, rc <<= 1, 0 === (rc & 130023424) && (rc = 4194304)));
  var c = Jg();
  a = Ak(a, b);
  null !== a && (zc(a, b, c), Ck(a, c));
}

function zj(a) {
  var b = a.memoizedState,
      c = 0;
  null !== b && (c = b.retryLane);
  Xk(a, c);
}

function Zj(a, b) {
  var c = 0;

  switch (a.tag) {
    case 13:
      var d = a.stateNode;
      var e = a.memoizedState;
      null !== e && (c = e.retryLane);
      break;

    case 19:
      d = a.stateNode;
      break;

    default:
      throw Error(p(314));
  }

  null !== d && d["delete"](b);
  Xk(a, c);
}

var Uk;

Uk = function Uk(a, b, c) {
  if (null !== a) {
    if (a.memoizedProps !== b.pendingProps || Vf.current) tg = !0;else {
      if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return tg = !1, Fj(a, b, c);
      tg = 0 !== (a.flags & 131072) ? !0 : !1;
    }
  } else tg = !1, I && 0 !== (b.flags & 1048576) && ah(b, Ug, b.index);
  b.lanes = 0;

  switch (b.tag) {
    case 2:
      var d = b.type;
      null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
      a = b.pendingProps;
      var e = Xf(b, H.current);
      sg(b, c);
      e = Uh(null, b, d, a, e, c);
      var f = Zh();
      b.flags |= 1;
      "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Yf(d) ? (f = !0, bg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, xg(b), e.updater = Mg, b.stateNode = e, e._reactInternals = b, Qg(b, d, a, c), b = pj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && bh(b), ej(null, b, e, c), b = b.child);
      return b;

    case 16:
      d = b.elementType;

      a: {
        null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
        a = b.pendingProps;
        e = d._init;
        d = e(d._payload);
        b.type = d;
        e = b.tag = Yk(d);
        a = kg(d, a);

        switch (e) {
          case 0:
            b = kj(null, b, d, a, c);
            break a;

          case 1:
            b = oj(null, b, d, a, c);
            break a;

          case 11:
            b = fj(null, b, d, a, c);
            break a;

          case 14:
            b = hj(null, b, d, kg(d.type, a), c);
            break a;
        }

        throw Error(p(306, d, ""));
      }

      return b;

    case 0:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : kg(d, e), kj(a, b, d, e, c);

    case 1:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : kg(d, e), oj(a, b, d, e, c);

    case 3:
      a: {
        qj(b);
        if (null === a) throw Error(p(387));
        d = b.pendingProps;
        f = b.memoizedState;
        e = f.element;
        yg(a, b);
        Eg(b, d, null, c);
        var g = b.memoizedState;
        d = g.element;
        if (f.isDehydrated) {
          if (f = {
            element: d,
            isDehydrated: !1,
            cache: g.cache,
            pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
            transitions: g.transitions
          }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
            e = Error(p(423));
            b = rj(a, b, d, c, e);
            break a;
          } else if (d !== e) {
            e = Error(p(424));
            b = rj(a, b, d, c, e);
            break a;
          } else for (eh = Kf(b.stateNode.containerInfo.firstChild), dh = b, I = !0, fh = null, c = zh(b, null, d, c), b.child = c; c;) {
            c.flags = c.flags & -3 | 4096, c = c.sibling;
          }
        } else {
          nh();

          if (d === e) {
            b = gj(a, b, c);
            break a;
          }

          ej(a, b, d, c);
        }
        b = b.child;
      }

      return b;

    case 5:
      return Hh(b), null === a && kh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Df(d, e) ? g = null : null !== f && Df(d, f) && (b.flags |= 32), nj(a, b), ej(a, b, g, c), b.child;

    case 6:
      return null === a && kh(b), null;

    case 13:
      return vj(a, b, c);

    case 4:
      return Fh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = yh(b, null, d, c) : ej(a, b, d, c), b.child;

    case 11:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : kg(d, e), fj(a, b, d, e, c);

    case 7:
      return ej(a, b, b.pendingProps, c), b.child;

    case 8:
      return ej(a, b, b.pendingProps.children, c), b.child;

    case 12:
      return ej(a, b, b.pendingProps.children, c), b.child;

    case 10:
      a: {
        d = b.type._context;
        e = b.pendingProps;
        f = b.memoizedProps;
        g = e.value;
        G(lg, d._currentValue);
        d._currentValue = g;
        if (null !== f) if (Ge(f.value, g)) {
          if (f.children === e.children && !Vf.current) {
            b = gj(a, b, c);
            break a;
          }
        } else for (f = b.child, null !== f && (f["return"] = b); null !== f;) {
          var h = f.dependencies;

          if (null !== h) {
            g = f.child;

            for (var k = h.firstContext; null !== k;) {
              if (k.context === d) {
                if (1 === f.tag) {
                  k = zg(-1, c & -c);
                  k.tag = 2;
                  var l = f.updateQueue;

                  if (null !== l) {
                    l = l.shared;
                    var n = l.pending;
                    null === n ? k.next = k : (k.next = n.next, n.next = k);
                    l.pending = k;
                  }
                }

                f.lanes |= c;
                k = f.alternate;
                null !== k && (k.lanes |= c);
                rg(f["return"], c, b);
                h.lanes |= c;
                break;
              }

              k = k.next;
            }
          } else if (10 === f.tag) g = f.type === b.type ? null : f.child;else if (18 === f.tag) {
            g = f["return"];
            if (null === g) throw Error(p(341));
            g.lanes |= c;
            h = g.alternate;
            null !== h && (h.lanes |= c);
            rg(g, c, b);
            g = f.sibling;
          } else g = f.child;

          if (null !== g) g["return"] = f;else for (g = f; null !== g;) {
            if (g === b) {
              g = null;
              break;
            }

            f = g.sibling;

            if (null !== f) {
              f["return"] = g["return"];
              g = f;
              break;
            }

            g = g["return"];
          }
          f = g;
        }
        ej(a, b, e.children, c);
        b = b.child;
      }

      return b;

    case 9:
      return e = b.type, d = b.pendingProps.children, sg(b, c), e = ug(e), d = d(e), b.flags |= 1, ej(a, b, d, c), b.child;

    case 14:
      return d = b.type, e = kg(d, b.pendingProps), e = kg(d.type, e), hj(a, b, d, e, c);

    case 15:
      return jj(a, b, b.type, b.pendingProps, c);

    case 17:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : kg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Yf(d) ? (a = !0, bg(b)) : a = !1, sg(b, c), Og(b, d, e), Qg(b, d, e, c), pj(null, b, d, !0, a, c);

    case 19:
      return Ej(a, b, c);

    case 22:
      return lj(a, b, c);
  }

  throw Error(p(156, b.tag));
};

function Ek(a, b) {
  return $b(a, b);
}

function Zk(a, b, c, d) {
  this.tag = a;
  this.key = c;
  this.sibling = this.child = this["return"] = this.stateNode = this.type = this.elementType = null;
  this.index = 0;
  this.ref = null;
  this.pendingProps = b;
  this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
  this.mode = d;
  this.subtreeFlags = this.flags = 0;
  this.deletions = null;
  this.childLanes = this.lanes = 0;
  this.alternate = null;
}

function hh(a, b, c, d) {
  return new Zk(a, b, c, d);
}

function ij(a) {
  a = a.prototype;
  return !(!a || !a.isReactComponent);
}

function Yk(a) {
  if ("function" === typeof a) return ij(a) ? 1 : 0;

  if (void 0 !== a && null !== a) {
    a = a.$$typeof;
    if (a === Ca) return 11;
    if (a === Fa) return 14;
  }

  return 2;
}

function th(a, b) {
  var c = a.alternate;
  null === c ? (c = hh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
  c.flags = a.flags & 14680064;
  c.childLanes = a.childLanes;
  c.lanes = a.lanes;
  c.child = a.child;
  c.memoizedProps = a.memoizedProps;
  c.memoizedState = a.memoizedState;
  c.updateQueue = a.updateQueue;
  b = a.dependencies;
  c.dependencies = null === b ? null : {
    lanes: b.lanes,
    firstContext: b.firstContext
  };
  c.sibling = a.sibling;
  c.index = a.index;
  c.ref = a.ref;
  return c;
}

function vh(a, b, c, d, e, f) {
  var g = 2;
  d = a;
  if ("function" === typeof a) ij(a) && (g = 1);else if ("string" === typeof a) g = 5;else a: switch (a) {
    case wa:
      return xh(c.children, e, f, b);

    case xa:
      g = 8;
      e |= 8;
      break;

    case za:
      return a = hh(12, c, b, e | 2), a.elementType = za, a.lanes = f, a;

    case Da:
      return a = hh(13, c, b, e), a.elementType = Da, a.lanes = f, a;

    case Ea:
      return a = hh(19, c, b, e), a.elementType = Ea, a.lanes = f, a;

    case Ha:
      return wj(c, e, f, b);

    default:
      if ("object" === typeof a && null !== a) switch (a.$$typeof) {
        case Aa:
          g = 10;
          break a;

        case Ba:
          g = 9;
          break a;

        case Ca:
          g = 11;
          break a;

        case Fa:
          g = 14;
          break a;

        case Ga:
          g = 16;
          d = null;
          break a;
      }
      throw Error(p(130, null == a ? a : typeof a, ""));
  }
  b = hh(g, c, b, e);
  b.elementType = a;
  b.type = d;
  b.lanes = f;
  return b;
}

function xh(a, b, c, d) {
  a = hh(7, a, d, b);
  a.lanes = c;
  return a;
}

function wj(a, b, c, d) {
  a = hh(22, a, d, b);
  a.elementType = Ha;
  a.lanes = c;
  a.stateNode = {};
  return a;
}

function uh(a, b, c) {
  a = hh(6, a, null, b);
  a.lanes = c;
  return a;
}

function wh(a, b, c) {
  b = hh(4, null !== a.children ? a.children : [], a.key, b);
  b.lanes = c;
  b.stateNode = {
    containerInfo: a.containerInfo,
    pendingChildren: null,
    implementation: a.implementation
  };
  return b;
}

function $k(a, b, c, d, e) {
  this.tag = b;
  this.containerInfo = a;
  this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
  this.timeoutHandle = -1;
  this.callbackNode = this.pendingContext = this.context = null;
  this.callbackPriority = 0;
  this.eventTimes = yc(0);
  this.expirationTimes = yc(-1);
  this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
  this.entanglements = yc(0);
  this.identifierPrefix = d;
  this.onRecoverableError = e;
  this.mutableSourceEagerHydrationData = null;
}

function al(a, b, c, d, e, f, g, h, k) {
  a = new $k(a, b, c, h, k);
  1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
  f = hh(3, null, null, b);
  a.current = f;
  f.stateNode = a;
  f.memoizedState = {
    element: d,
    isDehydrated: c,
    cache: null,
    transitions: null,
    pendingSuspenseBoundaries: null
  };
  xg(f);
  return a;
}

function bl(a, b, c) {
  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
  return {
    $$typeof: va,
    key: null == d ? null : "" + d,
    children: a,
    containerInfo: b,
    implementation: c
  };
}

function cl(a) {
  if (!a) return Uf;
  a = a._reactInternals;

  a: {
    if (Ub(a) !== a || 1 !== a.tag) throw Error(p(170));
    var b = a;

    do {
      switch (b.tag) {
        case 3:
          b = b.stateNode.context;
          break a;

        case 1:
          if (Yf(b.type)) {
            b = b.stateNode.__reactInternalMemoizedMergedChildContext;
            break a;
          }

      }

      b = b["return"];
    } while (null !== b);

    throw Error(p(171));
  }

  if (1 === a.tag) {
    var c = a.type;
    if (Yf(c)) return ag(a, c, b);
  }

  return b;
}

function dl(a, b, c, d, e, f, g, h, k) {
  a = al(c, d, !0, a, e, f, g, h, k);
  a.context = cl(null);
  c = a.current;
  d = Jg();
  e = Kg(c);
  f = zg(d, e);
  f.callback = void 0 !== b && null !== b ? b : null;
  Ag(c, f);
  a.current.lanes = e;
  zc(a, e, d);
  Ck(a, d);
  return a;
}

function el(a, b, c, d) {
  var e = b.current,
      f = Jg(),
      g = Kg(e);
  c = cl(c);
  null === b.context ? b.context = c : b.pendingContext = c;
  b = zg(f, g);
  b.payload = {
    element: a
  };
  d = void 0 === d ? null : d;
  null !== d && (b.callback = d);
  Ag(e, b);
  a = Lg(e, g, f);
  null !== a && Cg(a, e, g);
  return g;
}

function fl(a) {
  a = a.current;
  if (!a.child) return null;

  switch (a.child.tag) {
    case 5:
      return a.child.stateNode;

    default:
      return a.child.stateNode;
  }
}

function gl(a, b) {
  a = a.memoizedState;

  if (null !== a && null !== a.dehydrated) {
    var c = a.retryLane;
    a.retryLane = 0 !== c && c < b ? c : b;
  }
}

function hl(a, b) {
  gl(a, b);
  (a = a.alternate) && gl(a, b);
}

function il() {
  return null;
}

var jl = "function" === typeof reportError ? reportError : function (a) {
  console.error(a);
};

function kl(a) {
  this._internalRoot = a;
}

ll.prototype.render = kl.prototype.render = function (a) {
  var b = this._internalRoot;
  if (null === b) throw Error(p(409));
  el(a, b, null, null);
};

ll.prototype.unmount = kl.prototype.unmount = function () {
  var a = this._internalRoot;

  if (null !== a) {
    this._internalRoot = null;
    var b = a.containerInfo;
    Qk(function () {
      el(null, a, null, null);
    });
    b[tf] = null;
  }
};

function ll(a) {
  this._internalRoot = a;
}

ll.prototype.unstable_scheduleHydration = function (a) {
  if (a) {
    var b = Gc();
    a = {
      blockedOn: null,
      target: a,
      priority: b
    };

    for (var c = 0; c < Pc.length && 0 !== b && b < Pc[c].priority; c++) {
    }

    Pc.splice(c, 0, a);
    0 === c && Uc(a);
  }
};

function ml(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}

function nl(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}

function ol() {}

function pl(a, b, c, d, e) {
  if (e) {
    if ("function" === typeof d) {
      var f = d;

      d = function d() {
        var a = fl(g);
        f.call(a);
      };
    }

    var g = dl(b, d, a, 0, null, !1, !1, "", ol);
    a._reactRootContainer = g;
    a[tf] = g.current;
    rf(8 === a.nodeType ? a.parentNode : a);
    Qk();
    return g;
  }

  for (; e = a.lastChild;) {
    a.removeChild(e);
  }

  if ("function" === typeof d) {
    var h = d;

    d = function d() {
      var a = fl(k);
      h.call(a);
    };
  }

  var k = al(a, 0, !1, null, null, !1, !1, "", ol);
  a._reactRootContainer = k;
  a[tf] = k.current;
  rf(8 === a.nodeType ? a.parentNode : a);
  Qk(function () {
    el(b, k, c, d);
  });
  return k;
}

function ql(a, b, c, d, e) {
  var f = c._reactRootContainer;

  if (f) {
    var g = f;

    if ("function" === typeof e) {
      var h = e;

      e = function e() {
        var a = fl(g);
        h.call(a);
      };
    }

    el(b, g, a, e);
  } else g = pl(c, b, a, e, d);

  return fl(g);
}

Dc = function Dc(a) {
  switch (a.tag) {
    case 3:
      var b = a.stateNode;

      if (b.current.memoizedState.isDehydrated) {
        var c = sc(b.pendingLanes);
        0 !== c && (Bc(b, c | 1), Ck(b, B()), 0 === (W & 6) && (aj = B() + 500, ig()));
      }

      break;

    case 13:
      var d = Jg();
      Qk(function () {
        return Lg(a, 1, d);
      });
      hl(a, 1);
  }
};

Ec = function Ec(a) {
  if (13 === a.tag) {
    var b = Jg();
    Lg(a, 134217728, b);
    hl(a, 134217728);
  }
};

Fc = function Fc(a) {
  if (13 === a.tag) {
    var b = Jg(),
        c = Kg(a);
    Lg(a, c, b);
    hl(a, c);
  }
};

Gc = function Gc() {
  return C;
};

Hc = function Hc(a, b) {
  var c = C;

  try {
    return C = a, b();
  } finally {
    C = c;
  }
};

xb = function xb(a, b, c) {
  switch (b) {
    case "input":
      $a(a, c);
      b = c.name;

      if ("radio" === c.type && null != b) {
        for (c = a; c.parentNode;) {
          c = c.parentNode;
        }

        c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');

        for (b = 0; b < c.length; b++) {
          var d = c[b];

          if (d !== a && d.form === a.form) {
            var e = Cb(d);
            if (!e) throw Error(p(90));
            Va(d);
            $a(d, e);
          }
        }
      }

      break;

    case "textarea":
      hb(a, c);
      break;

    case "select":
      b = c.value, null != b && eb(a, !!c.multiple, b, !1);
  }
};

Fb = Pk;
Gb = Qk;
var rl = {
  usingClientEntryPoint: !1,
  Events: [Bb, te, Cb, Db, Eb, Pk]
},
    sl = {
  findFiberByHostInstance: Vc,
  bundleType: 0,
  version: "18.1.0",
  rendererPackageName: "react-dom"
};
var tl = {
  bundleType: sl.bundleType,
  version: sl.version,
  rendererPackageName: sl.rendererPackageName,
  rendererConfig: sl.rendererConfig,
  overrideHookState: null,
  overrideHookStateDeletePath: null,
  overrideHookStateRenamePath: null,
  overrideProps: null,
  overridePropsDeletePath: null,
  overridePropsRenamePath: null,
  setErrorHandler: null,
  setSuspenseHandler: null,
  scheduleUpdate: null,
  currentDispatcherRef: ta.ReactCurrentDispatcher,
  findHostInstanceByFiber: function findHostInstanceByFiber(a) {
    a = Yb(a);
    return null === a ? null : a.stateNode;
  },
  findFiberByHostInstance: sl.findFiberByHostInstance || il,
  findHostInstancesForRefresh: null,
  scheduleRefresh: null,
  scheduleRoot: null,
  setRefreshHandler: null,
  getCurrentFiber: null,
  reconcilerVersion: "18.1.0-next-22edb9f77-20220426"
};

if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
  var ul = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!ul.isDisabled && ul.supportsFiber) try {
    jc = ul.inject(tl), kc = ul;
  } catch (a) {}
}

var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = rl;

var createPortal = function createPortal(a, b) {
  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
  if (!ml(b)) throw Error(p(200));
  return bl(a, b, null, c);
};

var createRoot = function createRoot(a, b) {
  if (!ml(a)) throw Error(p(299));
  var c = !1,
      d = "",
      e = jl;
  null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
  b = al(a, 1, !1, null, null, c, !1, d, e);
  a[tf] = b.current;
  rf(8 === a.nodeType ? a.parentNode : a);
  return new kl(b);
};

var findDOMNode = function findDOMNode(a) {
  if (null == a) return null;
  if (1 === a.nodeType) return a;
  var b = a._reactInternals;

  if (void 0 === b) {
    if ("function" === typeof a.render) throw Error(p(188));
    a = Object.keys(a).join(",");
    throw Error(p(268, a));
  }

  a = Yb(b);
  a = null === a ? null : a.stateNode;
  return a;
};

var flushSync = function flushSync(a) {
  return Qk(a);
};

var hydrate = function hydrate(a, b, c) {
  if (!nl(b)) throw Error(p(200));
  return ql(null, a, b, !0, c);
};

var hydrateRoot = function hydrateRoot(a, b, c) {
  if (!ml(a)) throw Error(p(405));
  var d = null != c && c.hydratedSources || null,
      e = !1,
      f = "",
      g = jl;
  null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
  b = dl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
  a[tf] = b.current;
  rf(a);
  if (d) for (a = 0; a < d.length; a++) {
    c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [c, e] : b.mutableSourceEagerHydrationData.push(c, e);
  }
  return new ll(b);
};

var render = function render(a, b, c) {
  if (!nl(b)) throw Error(p(200));
  return ql(null, a, b, !1, c);
};

var unmountComponentAtNode = function unmountComponentAtNode(a) {
  if (!nl(a)) throw Error(p(40));
  return a._reactRootContainer ? (Qk(function () {
    ql(null, null, a, !1, function () {
      a._reactRootContainer = null;
      a[tf] = null;
    });
  }), !0) : !1;
};

var unstable_batchedUpdates = Pk;

var unstable_renderSubtreeIntoContainer = function unstable_renderSubtreeIntoContainer(a, b, c, d) {
  if (!nl(c)) throw Error(p(200));
  if (null == a || void 0 === a._reactInternals) throw Error(p(38));
  return ql(a, b, c, !1, d);
};

var version = "18.1.0-next-22edb9f77-20220426";
var reactDom_production_min = {
  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  createPortal: createPortal,
  createRoot: createRoot,
  findDOMNode: findDOMNode,
  flushSync: flushSync,
  hydrate: hydrate,
  hydrateRoot: hydrateRoot,
  render: render,
  unmountComponentAtNode: unmountComponentAtNode,
  unstable_batchedUpdates: unstable_batchedUpdates,
  unstable_renderSubtreeIntoContainer: unstable_renderSubtreeIntoContainer,
  version: version
};

var reactDom_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {

      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }

      var React = React__default;
      var Scheduler = scheduler;
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      var suppressWarning = false;

      function setSuppressWarning(newSuppressWarning) {
        {
          suppressWarning = newSuppressWarning;
        }
      }

      function warn(format) {
        {
          if (!suppressWarning) {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            printWarning('warn', format, args);
          }
        }
      }

      function error(format) {
        {
          if (!suppressWarning) {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            printWarning('error', format, args);
          }
        }
      }

      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();

          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          }

          var argsWithFormat = args.map(function (item) {
            return String(item);
          });
          argsWithFormat.unshift('Warning: ' + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }

      var FunctionComponent = 0;
      var ClassComponent = 1;
      var IndeterminateComponent = 2;
      var HostRoot = 3;
      var HostPortal = 4;
      var HostComponent = 5;
      var HostText = 6;
      var Fragment = 7;
      var Mode = 8;
      var ContextConsumer = 9;
      var ContextProvider = 10;
      var ForwardRef = 11;
      var Profiler = 12;
      var SuspenseComponent = 13;
      var MemoComponent = 14;
      var SimpleMemoComponent = 15;
      var LazyComponent = 16;
      var IncompleteClassComponent = 17;
      var DehydratedFragment = 18;
      var SuspenseListComponent = 19;
      var ScopeComponent = 21;
      var OffscreenComponent = 22;
      var LegacyHiddenComponent = 23;
      var CacheComponent = 24;
      var TracingMarkerComponent = 25;
      var enableClientRenderFallbackOnTextMismatch = true;
      var enableNewReconciler = false;
      var enableLazyContextPropagation = false;
      var enableLegacyHidden = false;
      var enableSuspenseAvoidThisFallback = false;
      var disableCommentsAsDOMContainers = true;
      var enableCustomElementPropertySupport = false;
      var warnAboutStringRefs = false;
      var enableSchedulingProfiler = true;
      var enableProfilerTimer = true;
      var enableProfilerCommitHooks = true;
      var allNativeEvents = new Set();
      var registrationNameDependencies = {};
      var possibleRegistrationNames = {};

      function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + 'Capture', dependencies);
      }

      function registerDirectEvent(registrationName, dependencies) {
        {
          if (registrationNameDependencies[registrationName]) {
            error('EventRegistry: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName);
          }
        }
        registrationNameDependencies[registrationName] = dependencies;
        {
          var lowerCasedName = registrationName.toLowerCase();
          possibleRegistrationNames[lowerCasedName] = registrationName;

          if (registrationName === 'onDoubleClick') {
            possibleRegistrationNames.ondblclick = registrationName;
          }
        }

        for (var i = 0; i < dependencies.length; i++) {
          allNativeEvents.add(dependencies[i]);
        }
      }

      var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
      var hasOwnProperty = Object.prototype.hasOwnProperty;

      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
          return type;
        }
      }

      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }

      function testStringCoercion(value) {
        return '' + value;
      }

      function checkAttributeStringCoercion(value, attributeName) {
        {
          if (willCoercionThrow(value)) {
            error('The provided `%s` attribute is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', attributeName, typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkPropStringCoercion(value, propName) {
        {
          if (willCoercionThrow(value)) {
            error('The provided `%s` prop is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', propName, typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkCSSPropertyStringCoercion(value, propName) {
        {
          if (willCoercionThrow(value)) {
            error('The provided `%s` CSS property is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', propName, typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkHtmlStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error('The provided HTML markup uses a value of unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      function checkFormFieldValueStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error('Form field values (value, checked, defaultValue, or defaultChecked props)' + ' must be strings, not %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
            return testStringCoercion(value);
          }
        }
      }

      var RESERVED = 0;
      var STRING = 1;
      var BOOLEANISH_STRING = 2;
      var BOOLEAN = 3;
      var OVERLOADED_BOOLEAN = 4;
      var NUMERIC = 5;
      var POSITIVE_NUMERIC = 6;
      var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
      var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
      var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
      var illegalAttributeNameCache = {};
      var validatedAttributeNameCache = {};

      function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
          return true;
        }

        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
          return false;
        }

        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
          validatedAttributeNameCache[attributeName] = true;
          return true;
        }

        illegalAttributeNameCache[attributeName] = true;
        {
          error('Invalid attribute name: `%s`', attributeName);
        }
        return false;
      }

      function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) {
          return propertyInfo.type === RESERVED;
        }

        if (isCustomComponentTag) {
          return false;
        }

        if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
          return true;
        }

        return false;
      }

      function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) {
          return false;
        }

        switch (typeof value) {
          case 'function':
          case 'symbol':
            return true;

          case 'boolean':
            {
              if (isCustomComponentTag) {
                return false;
              }

              if (propertyInfo !== null) {
                return !propertyInfo.acceptsBooleans;
              } else {
                var prefix = name.toLowerCase().slice(0, 5);
                return prefix !== 'data-' && prefix !== 'aria-';
              }
            }

          default:
            return false;
        }
      }

      function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === 'undefined') {
          return true;
        }

        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
          return true;
        }

        if (isCustomComponentTag) {
          return false;
        }

        if (propertyInfo !== null) {
          switch (propertyInfo.type) {
            case BOOLEAN:
              return !value;

            case OVERLOADED_BOOLEAN:
              return value === false;

            case NUMERIC:
              return isNaN(value);

            case POSITIVE_NUMERIC:
              return isNaN(value) || value < 1;
          }
        }

        return false;
      }

      function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
      }

      function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
      }

      var properties = {};
      var reservedProps = ['children', 'dangerouslySetInnerHTML', 'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
      reservedProps.forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
      });
      [['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
        var name = _ref[0],
            attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
      });
      ['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
      });
      ['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
      });
      ['allowFullScreen', 'async', 'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', 'itemScope'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
      });
      ['checked', 'multiple', 'muted', 'selected'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
      });
      ['capture', 'download'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
      });
      ['cols', 'rows', 'size', 'span'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
      });
      ['rowSpan', 'start'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
      });
      var CAMELIZE = /[\-\:]([a-z])/g;

      var capitalize = function capitalize(token) {
        return token[1].toUpperCase();
      };

      ['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height'].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
      });
      ['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type'].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/1999/xlink', false, false);
      });
      ['xml:base', 'xml:lang', 'xml:space'].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/XML/1998/namespace', false, false);
      });
      ['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
      });
      var xlinkHref = 'xlinkHref';
      properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, 'xlink:href', 'http://www.w3.org/1999/xlink', true, false);
      ['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
      });
      var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
      var didWarn = false;

      function sanitizeURL(url) {
        {
          if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error('A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
          }
        }
      }

      function getValueForProperty(node, name, expected, propertyInfo) {
        {
          if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
          } else {
            {
              checkAttributeStringCoercion(expected, name);
            }

            if (propertyInfo.sanitizeURL) {
              sanitizeURL('' + expected);
            }

            var attributeName = propertyInfo.attributeName;
            var stringValue = null;

            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
              if (node.hasAttribute(attributeName)) {
                var value = node.getAttribute(attributeName);

                if (value === '') {
                  return true;
                }

                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                  return value;
                }

                if (value === '' + expected) {
                  return expected;
                }

                return value;
              }
            } else if (node.hasAttribute(attributeName)) {
              if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                return node.getAttribute(attributeName);
              }

              if (propertyInfo.type === BOOLEAN) {
                return expected;
              }

              stringValue = node.getAttribute(attributeName);
            }

            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
              return stringValue === null ? expected : stringValue;
            } else if (stringValue === '' + expected) {
              return expected;
            } else {
              return stringValue;
            }
          }
        }
      }

      function getValueForAttribute(node, name, expected) {
        {
          if (!isAttributeNameSafe(name)) {
            return;
          }

          if (!node.hasAttribute(name)) {
            return expected === undefined ? undefined : null;
          }

          var value = node.getAttribute(name);
          {
            checkAttributeStringCoercion(expected, name);
          }

          if (value === '' + expected) {
            return expected;
          }

          return value;
        }
      }

      function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);

        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) {
          return;
        }

        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) {
          value = null;
        }

        if (isCustomComponentTag || propertyInfo === null) {
          if (isAttributeNameSafe(name)) {
            var _attributeName = name;

            if (value === null) {
              node.removeAttribute(_attributeName);
            } else {
              {
                checkAttributeStringCoercion(value, name);
              }
              node.setAttribute(_attributeName, '' + value);
            }
          }

          return;
        }

        var mustUseProperty = propertyInfo.mustUseProperty;

        if (mustUseProperty) {
          var propertyName = propertyInfo.propertyName;

          if (value === null) {
            var type = propertyInfo.type;
            node[propertyName] = type === BOOLEAN ? false : '';
          } else {
            node[propertyName] = value;
          }

          return;
        }

        var attributeName = propertyInfo.attributeName,
            attributeNamespace = propertyInfo.attributeNamespace;

        if (value === null) {
          node.removeAttribute(attributeName);
        } else {
          var _type = propertyInfo.type;
          var attributeValue;

          if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) {
            attributeValue = '';
          } else {
            {
              {
                checkAttributeStringCoercion(value, attributeName);
              }
              attributeValue = '' + value;
            }

            if (propertyInfo.sanitizeURL) {
              sanitizeURL(attributeValue.toString());
            }
          }

          if (attributeNamespace) {
            node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
          } else {
            node.setAttribute(attributeName, attributeValue);
          }
        }
      }

      var REACT_ELEMENT_TYPE = Symbol["for"]('react.element');
      var REACT_PORTAL_TYPE = Symbol["for"]('react.portal');
      var REACT_FRAGMENT_TYPE = Symbol["for"]('react.fragment');
      var REACT_STRICT_MODE_TYPE = Symbol["for"]('react.strict_mode');
      var REACT_PROFILER_TYPE = Symbol["for"]('react.profiler');
      var REACT_PROVIDER_TYPE = Symbol["for"]('react.provider');
      var REACT_CONTEXT_TYPE = Symbol["for"]('react.context');
      var REACT_FORWARD_REF_TYPE = Symbol["for"]('react.forward_ref');
      var REACT_SUSPENSE_TYPE = Symbol["for"]('react.suspense');
      var REACT_SUSPENSE_LIST_TYPE = Symbol["for"]('react.suspense_list');
      var REACT_MEMO_TYPE = Symbol["for"]('react.memo');
      var REACT_LAZY_TYPE = Symbol["for"]('react.lazy');
      var REACT_SCOPE_TYPE = Symbol["for"]('react.scope');
      var REACT_DEBUG_TRACING_MODE_TYPE = Symbol["for"]('react.debug_trace_mode');
      var REACT_OFFSCREEN_TYPE = Symbol["for"]('react.offscreen');
      var REACT_LEGACY_HIDDEN_TYPE = Symbol["for"]('react.legacy_hidden');
      var REACT_CACHE_TYPE = Symbol["for"]('react.cache');
      var REACT_TRACING_MARKER_TYPE = Symbol["for"]('react.tracing_marker');
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';

      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }

        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }

        return null;
      }

      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;

      function disabledLog() {}

      disabledLog.__reactDisabledLog = true;

      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }

          disabledDepth++;
        }
      }

      function reenableLogs() {
        {
          disabledDepth--;

          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }

          if (disabledDepth < 0) {
            error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
          }
        }
      }

      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;

      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === undefined) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || '';
            }
          }

          return '\n' + prefix + name;
        }
      }

      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }

      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return '';
        }

        {
          var frame = componentFrameCache.get(fn);

          if (frame !== undefined) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }

        try {
          if (construct) {
            var Fake = function Fake() {
              throw Error();
            };

            Object.defineProperty(Fake.prototype, 'props', {
              set: function set() {
                throw Error();
              }
            });

            if (typeof Reflect === 'object' && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }

              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }

              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }

            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === 'string') {
            var sampleLines = sample.stack.split('\n');
            var controlLines = control.stack.split('\n');
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;

            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }

            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;

                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                      if (fn.displayName && _frame.includes('<anonymous>')) {
                        _frame = _frame.replace('<anonymous>', fn.displayName);
                      }

                      {
                        if (typeof fn === 'function') {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }

                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }

        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        {
          if (typeof fn === 'function') {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }

      function describeClassComponentFrame(ctor, source, ownerFn) {
        {
          return describeNativeComponentFrame(ctor, true);
        }
      }

      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }

      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return '';
        }

        if (typeof type === 'function') {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }

        if (typeof type === 'string') {
          return describeBuiltInComponentFrame(type);
        }

        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame('Suspense');

          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame('SuspenseList');
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);

            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
              }
          }
        }

        return '';
      }

      function describeFiber(fiber) {

        switch (fiber.tag) {
          case HostComponent:
            return describeBuiltInComponentFrame(fiber.type);

          case LazyComponent:
            return describeBuiltInComponentFrame('Lazy');

          case SuspenseComponent:
            return describeBuiltInComponentFrame('Suspense');

          case SuspenseListComponent:
            return describeBuiltInComponentFrame('SuspenseList');

          case FunctionComponent:
          case IndeterminateComponent:
          case SimpleMemoComponent:
            return describeFunctionComponentFrame(fiber.type);

          case ForwardRef:
            return describeFunctionComponentFrame(fiber.type.render);

          case ClassComponent:
            return describeClassComponentFrame(fiber.type);

          default:
            return '';
        }
      }

      function getStackByFiberInDevAndProd(workInProgress) {
        try {
          var info = '';
          var node = workInProgress;

          do {
            info += describeFiber(node);
            node = node["return"];
          } while (node);

          return info;
        } catch (x) {
          return '\nError generating stack: ' + x.message + '\n' + x.stack;
        }
      }

      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;

        if (displayName) {
          return displayName;
        }

        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
      }

      function getContextName(type) {
        return type.displayName || 'Context';
      }

      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }

        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }

        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }

        if (typeof type === 'string') {
          return type;
        }

        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return 'Fragment';

          case REACT_PORTAL_TYPE:
            return 'Portal';

          case REACT_PROFILER_TYPE:
            return 'Profiler';

          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';

          case REACT_SUSPENSE_TYPE:
            return 'Suspense';

          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + '.Consumer';

            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + '.Provider';

            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');

            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;

              if (outerName !== null) {
                return outerName;
              }

              return getComponentNameFromType(type.type) || 'Memo';

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return getComponentNameFromType(init(payload));
                } catch (x) {
                  return null;
                }
              }
          }
        }

        return null;
      }

      function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
      }

      function getContextName$1(type) {
        return type.displayName || 'Context';
      }

      function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag,
            type = fiber.type;

        switch (tag) {
          case CacheComponent:
            return 'Cache';

          case ContextConsumer:
            var context = type;
            return getContextName$1(context) + '.Consumer';

          case ContextProvider:
            var provider = type;
            return getContextName$1(provider._context) + '.Provider';

          case DehydratedFragment:
            return 'DehydratedFragment';

          case ForwardRef:
            return getWrappedName$1(type, type.render, 'ForwardRef');

          case Fragment:
            return 'Fragment';

          case HostComponent:
            return type;

          case HostPortal:
            return 'Portal';

          case HostRoot:
            return 'Root';

          case HostText:
            return 'Text';

          case LazyComponent:
            return getComponentNameFromType(type);

          case Mode:
            if (type === REACT_STRICT_MODE_TYPE) {
              return 'StrictMode';
            }

            return 'Mode';

          case OffscreenComponent:
            return 'Offscreen';

          case Profiler:
            return 'Profiler';

          case ScopeComponent:
            return 'Scope';

          case SuspenseComponent:
            return 'Suspense';

          case SuspenseListComponent:
            return 'SuspenseList';

          case TracingMarkerComponent:
            return 'TracingMarker';

          case ClassComponent:
          case FunctionComponent:
          case IncompleteClassComponent:
          case IndeterminateComponent:
          case MemoComponent:
          case SimpleMemoComponent:
            if (typeof type === 'function') {
              return type.displayName || type.name || null;
            }

            if (typeof type === 'string') {
              return type;
            }

            break;
        }

        return null;
      }

      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      var current = null;
      var isRendering = false;

      function getCurrentFiberOwnerNameInDevOrNull() {
        {
          if (current === null) {
            return null;
          }

          var owner = current._debugOwner;

          if (owner !== null && typeof owner !== 'undefined') {
            return getComponentNameFromFiber(owner);
          }
        }
        return null;
      }

      function getCurrentFiberStackInDev() {
        {
          if (current === null) {
            return '';
          }

          return getStackByFiberInDevAndProd(current);
        }
      }

      function resetCurrentFiber() {
        {
          ReactDebugCurrentFrame.getCurrentStack = null;
          current = null;
          isRendering = false;
        }
      }

      function setCurrentFiber(fiber) {
        {
          ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
          current = fiber;
          isRendering = false;
        }
      }

      function getCurrentFiber() {
        {
          return current;
        }
      }

      function setIsRendering(rendering) {
        {
          isRendering = rendering;
        }
      }

      function toString(value) {
        return '' + value;
      }

      function getToStringValue(value) {
        switch (typeof value) {
          case 'boolean':
          case 'number':
          case 'string':
          case 'undefined':
            return value;

          case 'object':
            {
              checkFormFieldValueStringCoercion(value);
            }
            return value;

          default:
            return '';
        }
      }

      var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
      };

      function checkControlledValueProps(tagName, props) {
        {
          if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
            error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
          }

          if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
            error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
          }
        }
      }

      function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
      }

      function getTracker(node) {
        return node._valueTracker;
      }

      function detachTracker(node) {
        node._valueTracker = null;
      }

      function getValueFromNode(node) {
        var value = '';

        if (!node) {
          return value;
        }

        if (isCheckable(node)) {
          value = node.checked ? 'true' : 'false';
        } else {
          value = node.value;
        }

        return value;
      }

      function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? 'checked' : 'value';
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        {
          checkFormFieldValueStringCoercion(node[valueField]);
        }
        var currentValue = '' + node[valueField];

        if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
          return;
        }

        var _get = descriptor.get,
            _set = descriptor.set;
        Object.defineProperty(node, valueField, {
          configurable: true,
          get: function get() {
            return _get.call(this);
          },
          set: function set(value) {
            {
              checkFormFieldValueStringCoercion(value);
            }
            currentValue = '' + value;

            _set.call(this, value);
          }
        });
        Object.defineProperty(node, valueField, {
          enumerable: descriptor.enumerable
        });
        var tracker = {
          getValue: function getValue() {
            return currentValue;
          },
          setValue: function setValue(value) {
            {
              checkFormFieldValueStringCoercion(value);
            }
            currentValue = '' + value;
          },
          stopTracking: function stopTracking() {
            detachTracker(node);
            delete node[valueField];
          }
        };
        return tracker;
      }

      function track(node) {
        if (getTracker(node)) {
          return;
        }

        node._valueTracker = trackValueOnNode(node);
      }

      function updateValueIfChanged(node) {
        if (!node) {
          return false;
        }

        var tracker = getTracker(node);

        if (!tracker) {
          return true;
        }

        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);

        if (nextValue !== lastValue) {
          tracker.setValue(nextValue);
          return true;
        }

        return false;
      }

      function getActiveElement(doc) {
        doc = doc || (typeof document !== 'undefined' ? document : undefined);

        if (typeof doc === 'undefined') {
          return null;
        }

        try {
          return doc.activeElement || doc.body;
        } catch (e) {
          return doc.body;
        }
      }

      var didWarnValueDefaultValue = false;
      var didWarnCheckedDefaultChecked = false;
      var didWarnControlledToUncontrolled = false;
      var didWarnUncontrolledToControlled = false;

      function isControlled(props) {
        var usesChecked = props.type === 'checkbox' || props.type === 'radio';
        return usesChecked ? props.checked != null : props.value != null;
      }

      function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
          defaultChecked: undefined,
          defaultValue: undefined,
          value: undefined,
          checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
      }

      function initWrapperState(element, props) {
        {
          checkControlledValueProps('input', props);

          if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error('%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnCheckedDefaultChecked = true;
          }

          if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error('%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnValueDefaultValue = true;
          }
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
        node._wrapperState = {
          initialChecked: props.checked != null ? props.checked : props.defaultChecked,
          initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
          controlled: isControlled(props)
        };
      }

      function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;

        if (checked != null) {
          setValueForProperty(node, 'checked', checked, false);
        }
      }

      function updateWrapper(element, props) {
        var node = element;
        {
          var controlled = isControlled(props);

          if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error('A component is changing an uncontrolled input to be controlled. ' + 'This is likely caused by the value changing from undefined to ' + 'a defined value, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');
            didWarnUncontrolledToControlled = true;
          }

          if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error('A component is changing a controlled input to be uncontrolled. ' + 'This is likely caused by the value changing from a defined to ' + 'undefined, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');
            didWarnControlledToUncontrolled = true;
          }
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;

        if (value != null) {
          if (type === 'number') {
            if (value === 0 && node.value === '' || node.value != value) {
              node.value = toString(value);
            }
          } else if (node.value !== toString(value)) {
            node.value = toString(value);
          }
        } else if (type === 'submit' || type === 'reset') {
          node.removeAttribute('value');
          return;
        }

        {
          if (props.hasOwnProperty('value')) {
            setDefaultValue(node, props.type, value);
          } else if (props.hasOwnProperty('defaultValue')) {
            setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
          }
        }
        {
          if (props.checked == null && props.defaultChecked != null) {
            node.defaultChecked = !!props.defaultChecked;
          }
        }
      }

      function postMountWrapper(element, props, isHydrating) {
        var node = element;

        if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
          var type = props.type;
          var isButton = type === 'submit' || type === 'reset';

          if (isButton && (props.value === undefined || props.value === null)) {
            return;
          }

          var initialValue = toString(node._wrapperState.initialValue);

          if (!isHydrating) {
            {
              if (initialValue !== node.value) {
                node.value = initialValue;
              }
            }
          }

          {
            node.defaultValue = initialValue;
          }
        }

        var name = node.name;

        if (name !== '') {
          node.name = '';
        }

        {
          node.defaultChecked = !node.defaultChecked;
          node.defaultChecked = !!node._wrapperState.initialChecked;
        }

        if (name !== '') {
          node.name = name;
        }
      }

      function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
      }

      function updateNamedCousins(rootNode, props) {
        var name = props.name;

        if (props.type === 'radio' && name != null) {
          var queryRoot = rootNode;

          while (queryRoot.parentNode) {
            queryRoot = queryRoot.parentNode;
          }

          {
            checkAttributeStringCoercion(name, 'name');
          }
          var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

          for (var i = 0; i < group.length; i++) {
            var otherNode = group[i];

            if (otherNode === rootNode || otherNode.form !== rootNode.form) {
              continue;
            }

            var otherProps = getFiberCurrentPropsFromNode(otherNode);

            if (!otherProps) {
              throw new Error('ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.');
            }

            updateValueIfChanged(otherNode);
            updateWrapper(otherNode, otherProps);
          }
        }
      }

      function setDefaultValue(node, type, value) {
        if (type !== 'number' || getActiveElement(node.ownerDocument) !== node) {
          if (value == null) {
            node.defaultValue = toString(node._wrapperState.initialValue);
          } else if (node.defaultValue !== toString(value)) {
            node.defaultValue = toString(value);
          }
        }
      }

      var didWarnSelectedSetOnOption = false;
      var didWarnInvalidChild = false;
      var didWarnInvalidInnerHTML = false;

      function validateProps(element, props) {
        {
          if (props.value == null) {
            if (typeof props.children === 'object' && props.children !== null) {
              React.Children.forEach(props.children, function (child) {
                if (child == null) {
                  return;
                }

                if (typeof child === 'string' || typeof child === 'number') {
                  return;
                }

                if (!didWarnInvalidChild) {
                  didWarnInvalidChild = true;
                  error('Cannot infer the option value of complex children. ' + 'Pass a `value` prop or use a plain string as children to <option>.');
                }
              });
            } else if (props.dangerouslySetInnerHTML != null) {
              if (!didWarnInvalidInnerHTML) {
                didWarnInvalidInnerHTML = true;
                error('Pass a `value` prop if you set dangerouslyInnerHTML so React knows ' + 'which value should be selected.');
              }
            }
          }

          if (props.selected != null && !didWarnSelectedSetOnOption) {
            error('Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.');
            didWarnSelectedSetOnOption = true;
          }
        }
      }

      function postMountWrapper$1(element, props) {
        if (props.value != null) {
          element.setAttribute('value', toString(getToStringValue(props.value)));
        }
      }

      var isArrayImpl = Array.isArray;

      function isArray(a) {
        return isArrayImpl(a);
      }

      var didWarnValueDefaultValue$1;
      {
        didWarnValueDefaultValue$1 = false;
      }

      function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();

        if (ownerName) {
          return '\n\nCheck the render method of `' + ownerName + '`.';
        }

        return '';
      }

      var valuePropNames = ['value', 'defaultValue'];

      function checkSelectPropTypes(props) {
        {
          checkControlledValueProps('select', props);

          for (var i = 0; i < valuePropNames.length; i++) {
            var propName = valuePropNames[i];

            if (props[propName] == null) {
              continue;
            }

            var propNameIsArray = isArray(props[propName]);

            if (props.multiple && !propNameIsArray) {
              error('The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum());
            } else if (!props.multiple && propNameIsArray) {
              error('The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum());
            }
          }
        }
      }

      function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;

        if (multiple) {
          var selectedValues = propValue;
          var selectedValue = {};

          for (var i = 0; i < selectedValues.length; i++) {
            selectedValue['$' + selectedValues[i]] = true;
          }

          for (var _i = 0; _i < options.length; _i++) {
            var selected = selectedValue.hasOwnProperty('$' + options[_i].value);

            if (options[_i].selected !== selected) {
              options[_i].selected = selected;
            }

            if (selected && setDefaultSelected) {
              options[_i].defaultSelected = true;
            }
          }
        } else {
          var _selectedValue = toString(getToStringValue(propValue));

          var defaultSelected = null;

          for (var _i2 = 0; _i2 < options.length; _i2++) {
            if (options[_i2].value === _selectedValue) {
              options[_i2].selected = true;

              if (setDefaultSelected) {
                options[_i2].defaultSelected = true;
              }

              return;
            }

            if (defaultSelected === null && !options[_i2].disabled) {
              defaultSelected = options[_i2];
            }
          }

          if (defaultSelected !== null) {
            defaultSelected.selected = true;
          }
        }
      }

      function getHostProps$1(element, props) {
        return assign({}, props, {
          value: undefined
        });
      }

      function initWrapperState$1(element, props) {
        var node = element;
        {
          checkSelectPropTypes(props);
        }
        node._wrapperState = {
          wasMultiple: !!props.multiple
        };
        {
          if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error('Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components');
            didWarnValueDefaultValue$1 = true;
          }
        }
      }

      function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;

        if (value != null) {
          updateOptions(node, !!props.multiple, value, false);
        } else if (props.defaultValue != null) {
          updateOptions(node, !!props.multiple, props.defaultValue, true);
        }
      }

      function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;

        if (value != null) {
          updateOptions(node, !!props.multiple, value, false);
        } else if (wasMultiple !== !!props.multiple) {
          if (props.defaultValue != null) {
            updateOptions(node, !!props.multiple, props.defaultValue, true);
          } else {
            updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
          }
        }
      }

      function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;

        if (value != null) {
          updateOptions(node, !!props.multiple, value, false);
        }
      }

      var didWarnValDefaultVal = false;

      function getHostProps$2(element, props) {
        var node = element;

        if (props.dangerouslySetInnerHTML != null) {
          throw new Error('`dangerouslySetInnerHTML` does not make sense on <textarea>.');
        }

        var hostProps = assign({}, props, {
          value: undefined,
          defaultValue: undefined,
          children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
      }

      function initWrapperState$2(element, props) {
        var node = element;
        {
          checkControlledValueProps('textarea', props);

          if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error('%s contains a textarea with both value and defaultValue props. ' + 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component');
            didWarnValDefaultVal = true;
          }
        }
        var initialValue = props.value;

        if (initialValue == null) {
          var children = props.children,
              defaultValue = props.defaultValue;

          if (children != null) {
            {
              error('Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
            }
            {
              if (defaultValue != null) {
                throw new Error('If you supply `defaultValue` on a <textarea>, do not pass children.');
              }

              if (isArray(children)) {
                if (children.length > 1) {
                  throw new Error('<textarea> can only have at most one child.');
                }

                children = children[0];
              }

              defaultValue = children;
            }
          }

          if (defaultValue == null) {
            defaultValue = '';
          }

          initialValue = defaultValue;
        }

        node._wrapperState = {
          initialValue: getToStringValue(initialValue)
        };
      }

      function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);

        if (value != null) {
          var newValue = toString(value);

          if (newValue !== node.value) {
            node.value = newValue;
          }

          if (props.defaultValue == null && node.defaultValue !== newValue) {
            node.defaultValue = newValue;
          }
        }

        if (defaultValue != null) {
          node.defaultValue = toString(defaultValue);
        }
      }

      function postMountWrapper$3(element, props) {
        var node = element;
        var textContent = node.textContent;

        if (textContent === node._wrapperState.initialValue) {
          if (textContent !== '' && textContent !== null) {
            node.value = textContent;
          }
        }
      }

      function restoreControlledState$2(element, props) {
        updateWrapper$1(element, props);
      }

      var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
      var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
      var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';

      function getIntrinsicNamespace(type) {
        switch (type) {
          case 'svg':
            return SVG_NAMESPACE;

          case 'math':
            return MATH_NAMESPACE;

          default:
            return HTML_NAMESPACE;
        }
      }

      function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
          return getIntrinsicNamespace(type);
        }

        if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
          return HTML_NAMESPACE;
        }

        return parentNamespace;
      }

      var createMicrosoftUnsafeLocalFunction = function createMicrosoftUnsafeLocalFunction(func) {
        if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
          return function (arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function () {
              return func(arg0, arg1, arg2, arg3);
            });
          };
        } else {
          return func;
        }
      };

      var reusableSVGContainer;
      var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
          if (!('innerHTML' in node)) {
            reusableSVGContainer = reusableSVGContainer || document.createElement('div');
            reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
            var svgNode = reusableSVGContainer.firstChild;

            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }

            while (svgNode.firstChild) {
              node.appendChild(svgNode.firstChild);
            }

            return;
          }
        }

        node.innerHTML = html;
      });
      var ELEMENT_NODE = 1;
      var TEXT_NODE = 3;
      var COMMENT_NODE = 8;
      var DOCUMENT_NODE = 9;
      var DOCUMENT_FRAGMENT_NODE = 11;

      var setTextContent = function setTextContent(node, text) {
        if (text) {
          var firstChild = node.firstChild;

          if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
            firstChild.nodeValue = text;
            return;
          }
        }

        node.textContent = text;
      };

      var shorthandToLonghand = {
        animation: ['animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction'],
        background: ['backgroundAttachment', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundSize'],
        backgroundPosition: ['backgroundPositionX', 'backgroundPositionY'],
        border: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderTopColor', 'borderTopStyle', 'borderTopWidth'],
        borderBlockEnd: ['borderBlockEndColor', 'borderBlockEndStyle', 'borderBlockEndWidth'],
        borderBlockStart: ['borderBlockStartColor', 'borderBlockStartStyle', 'borderBlockStartWidth'],
        borderBottom: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth'],
        borderColor: ['borderBottomColor', 'borderLeftColor', 'borderRightColor', 'borderTopColor'],
        borderImage: ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
        borderInlineEnd: ['borderInlineEndColor', 'borderInlineEndStyle', 'borderInlineEndWidth'],
        borderInlineStart: ['borderInlineStartColor', 'borderInlineStartStyle', 'borderInlineStartWidth'],
        borderLeft: ['borderLeftColor', 'borderLeftStyle', 'borderLeftWidth'],
        borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
        borderRight: ['borderRightColor', 'borderRightStyle', 'borderRightWidth'],
        borderStyle: ['borderBottomStyle', 'borderLeftStyle', 'borderRightStyle', 'borderTopStyle'],
        borderTop: ['borderTopColor', 'borderTopStyle', 'borderTopWidth'],
        borderWidth: ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth'],
        columnRule: ['columnRuleColor', 'columnRuleStyle', 'columnRuleWidth'],
        columns: ['columnCount', 'columnWidth'],
        flex: ['flexBasis', 'flexGrow', 'flexShrink'],
        flexFlow: ['flexDirection', 'flexWrap'],
        font: ['fontFamily', 'fontFeatureSettings', 'fontKerning', 'fontLanguageOverride', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition', 'fontWeight', 'lineHeight'],
        fontVariant: ['fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition'],
        gap: ['columnGap', 'rowGap'],
        grid: ['gridAutoColumns', 'gridAutoFlow', 'gridAutoRows', 'gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
        gridArea: ['gridColumnEnd', 'gridColumnStart', 'gridRowEnd', 'gridRowStart'],
        gridColumn: ['gridColumnEnd', 'gridColumnStart'],
        gridColumnGap: ['columnGap'],
        gridGap: ['columnGap', 'rowGap'],
        gridRow: ['gridRowEnd', 'gridRowStart'],
        gridRowGap: ['rowGap'],
        gridTemplate: ['gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
        listStyle: ['listStyleImage', 'listStylePosition', 'listStyleType'],
        margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
        marker: ['markerEnd', 'markerMid', 'markerStart'],
        mask: ['maskClip', 'maskComposite', 'maskImage', 'maskMode', 'maskOrigin', 'maskPositionX', 'maskPositionY', 'maskRepeat', 'maskSize'],
        maskPosition: ['maskPositionX', 'maskPositionY'],
        outline: ['outlineColor', 'outlineStyle', 'outlineWidth'],
        overflow: ['overflowX', 'overflowY'],
        padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
        placeContent: ['alignContent', 'justifyContent'],
        placeItems: ['alignItems', 'justifyItems'],
        placeSelf: ['alignSelf', 'justifySelf'],
        textDecoration: ['textDecorationColor', 'textDecorationLine', 'textDecorationStyle'],
        textEmphasis: ['textEmphasisColor', 'textEmphasisStyle'],
        transition: ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction'],
        wordWrap: ['overflowWrap']
      };
      var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
      };

      function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
      }

      var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
      Object.keys(isUnitlessNumber).forEach(function (prop) {
        prefixes.forEach(function (prefix) {
          isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
      });

      function dangerousStyleValue(name, value, isCustomProperty) {
        var isEmpty = value == null || typeof value === 'boolean' || value === '';

        if (isEmpty) {
          return '';
        }

        if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
          return value + 'px';
        }

        {
          checkCSSPropertyStringCoercion(value, name);
        }
        return ('' + value).trim();
      }

      var uppercasePattern = /([A-Z])/g;
      var msPattern = /^ms-/;

      function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
      }

      var warnValidStyle = function warnValidStyle() {};

      {
        var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
        var msPattern$1 = /^-ms-/;
        var hyphenPattern = /-(.)/g;
        var badStyleValueWithSemicolonPattern = /;\s*$/;
        var warnedStyleNames = {};
        var warnedStyleValues = {};
        var warnedForNaNValue = false;
        var warnedForInfinityValue = false;

        var camelize = function camelize(string) {
          return string.replace(hyphenPattern, function (_, character) {
            return character.toUpperCase();
          });
        };

        var warnHyphenatedStyleName = function warnHyphenatedStyleName(name) {
          if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
            return;
          }

          warnedStyleNames[name] = true;
          error('Unsupported style property %s. Did you mean %s?', name, camelize(name.replace(msPattern$1, 'ms-')));
        };

        var warnBadVendoredStyleName = function warnBadVendoredStyleName(name) {
          if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
            return;
          }

          warnedStyleNames[name] = true;
          error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
        };

        var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value) {
          if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
            return;
          }

          warnedStyleValues[value] = true;
          error("Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
        };

        var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value) {
          if (warnedForNaNValue) {
            return;
          }

          warnedForNaNValue = true;
          error('`NaN` is an invalid value for the `%s` css style property.', name);
        };

        var warnStyleValueIsInfinity = function warnStyleValueIsInfinity(name, value) {
          if (warnedForInfinityValue) {
            return;
          }

          warnedForInfinityValue = true;
          error('`Infinity` is an invalid value for the `%s` css style property.', name);
        };

        warnValidStyle = function warnValidStyle(name, value) {
          if (name.indexOf('-') > -1) {
            warnHyphenatedStyleName(name);
          } else if (badVendoredStyleNamePattern.test(name)) {
            warnBadVendoredStyleName(name);
          } else if (badStyleValueWithSemicolonPattern.test(value)) {
            warnStyleValueWithSemicolon(name, value);
          }

          if (typeof value === 'number') {
            if (isNaN(value)) {
              warnStyleValueIsNaN(name, value);
            } else if (!isFinite(value)) {
              warnStyleValueIsInfinity(name, value);
            }
          }
        };
      }
      var warnValidStyle$1 = warnValidStyle;

      function createDangerousStringForStyles(styles) {
        {
          var serialized = '';
          var delimiter = '';

          for (var styleName in styles) {
            if (!styles.hasOwnProperty(styleName)) {
              continue;
            }

            var styleValue = styles[styleName];

            if (styleValue != null) {
              var isCustomProperty = styleName.indexOf('--') === 0;
              serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
              serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
              delimiter = ';';
            }
          }

          return serialized || null;
        }
      }

      function setValueForStyles(node, styles) {
        var style = node.style;

        for (var styleName in styles) {
          if (!styles.hasOwnProperty(styleName)) {
            continue;
          }

          var isCustomProperty = styleName.indexOf('--') === 0;
          {
            if (!isCustomProperty) {
              warnValidStyle$1(styleName, styles[styleName]);
            }
          }
          var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);

          if (styleName === 'float') {
            styleName = 'cssFloat';
          }

          if (isCustomProperty) {
            style.setProperty(styleName, styleValue);
          } else {
            style[styleName] = styleValue;
          }
        }
      }

      function isValueEmpty(value) {
        return value == null || typeof value === 'boolean' || value === '';
      }

      function expandShorthandMap(styles) {
        var expanded = {};

        for (var key in styles) {
          var longhands = shorthandToLonghand[key] || [key];

          for (var i = 0; i < longhands.length; i++) {
            expanded[longhands[i]] = key;
          }
        }

        return expanded;
      }

      function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        {
          if (!nextStyles) {
            return;
          }

          var expandedUpdates = expandShorthandMap(styleUpdates);
          var expandedStyles = expandShorthandMap(nextStyles);
          var warnedAbout = {};

          for (var key in expandedUpdates) {
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];

            if (correctOriginalKey && originalKey !== correctOriginalKey) {
              var warningKey = originalKey + ',' + correctOriginalKey;

              if (warnedAbout[warningKey]) {
                continue;
              }

              warnedAbout[warningKey] = true;
              error('%s a style property during rerender (%s) when a ' + 'conflicting property is set (%s) can lead to styling bugs. To ' + "avoid this, don't mix shorthand and non-shorthand properties " + 'for the same value; instead, replace the shorthand with ' + 'separate values.', isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
            }
          }
        }
      }

      var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true
      };
      var voidElementTags = assign({
        menuitem: true
      }, omittedCloseTags);
      var HTML = '__html';

      function assertValidProps(tag, props) {
        if (!props) {
          return;
        }

        if (voidElementTags[tag]) {
          if (props.children != null || props.dangerouslySetInnerHTML != null) {
            throw new Error(tag + " is a void element tag and must neither have `children` nor " + 'use `dangerouslySetInnerHTML`.');
          }
        }

        if (props.dangerouslySetInnerHTML != null) {
          if (props.children != null) {
            throw new Error('Can only set one of `children` or `props.dangerouslySetInnerHTML`.');
          }

          if (typeof props.dangerouslySetInnerHTML !== 'object' || !(HTML in props.dangerouslySetInnerHTML)) {
            throw new Error('`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://reactjs.org/link/dangerously-set-inner-html ' + 'for more information.');
          }
        }

        {
          if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
            error('A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.');
          }
        }

        if (props.style != null && typeof props.style !== 'object') {
          throw new Error('The `style` prop expects a mapping from style properties to values, ' + "not a string. For example, style={{marginRight: spacing + 'em'}} when " + 'using JSX.');
        }
      }

      function isCustomComponent(tagName, props) {
        if (tagName.indexOf('-') === -1) {
          return typeof props.is === 'string';
        }

        switch (tagName) {
          case 'annotation-xml':
          case 'color-profile':
          case 'font-face':
          case 'font-face-src':
          case 'font-face-uri':
          case 'font-face-format':
          case 'font-face-name':
          case 'missing-glyph':
            return false;

          default:
            return true;
        }
      }

      var possibleStandardNames = {
        accept: 'accept',
        acceptcharset: 'acceptCharset',
        'accept-charset': 'acceptCharset',
        accesskey: 'accessKey',
        action: 'action',
        allowfullscreen: 'allowFullScreen',
        alt: 'alt',
        as: 'as',
        async: 'async',
        autocapitalize: 'autoCapitalize',
        autocomplete: 'autoComplete',
        autocorrect: 'autoCorrect',
        autofocus: 'autoFocus',
        autoplay: 'autoPlay',
        autosave: 'autoSave',
        capture: 'capture',
        cellpadding: 'cellPadding',
        cellspacing: 'cellSpacing',
        challenge: 'challenge',
        charset: 'charSet',
        checked: 'checked',
        children: 'children',
        cite: 'cite',
        "class": 'className',
        classid: 'classID',
        classname: 'className',
        cols: 'cols',
        colspan: 'colSpan',
        content: 'content',
        contenteditable: 'contentEditable',
        contextmenu: 'contextMenu',
        controls: 'controls',
        controlslist: 'controlsList',
        coords: 'coords',
        crossorigin: 'crossOrigin',
        dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
        data: 'data',
        datetime: 'dateTime',
        "default": 'default',
        defaultchecked: 'defaultChecked',
        defaultvalue: 'defaultValue',
        defer: 'defer',
        dir: 'dir',
        disabled: 'disabled',
        disablepictureinpicture: 'disablePictureInPicture',
        disableremoteplayback: 'disableRemotePlayback',
        download: 'download',
        draggable: 'draggable',
        enctype: 'encType',
        enterkeyhint: 'enterKeyHint',
        "for": 'htmlFor',
        form: 'form',
        formmethod: 'formMethod',
        formaction: 'formAction',
        formenctype: 'formEncType',
        formnovalidate: 'formNoValidate',
        formtarget: 'formTarget',
        frameborder: 'frameBorder',
        headers: 'headers',
        height: 'height',
        hidden: 'hidden',
        high: 'high',
        href: 'href',
        hreflang: 'hrefLang',
        htmlfor: 'htmlFor',
        httpequiv: 'httpEquiv',
        'http-equiv': 'httpEquiv',
        icon: 'icon',
        id: 'id',
        imagesizes: 'imageSizes',
        imagesrcset: 'imageSrcSet',
        innerhtml: 'innerHTML',
        inputmode: 'inputMode',
        integrity: 'integrity',
        is: 'is',
        itemid: 'itemID',
        itemprop: 'itemProp',
        itemref: 'itemRef',
        itemscope: 'itemScope',
        itemtype: 'itemType',
        keyparams: 'keyParams',
        keytype: 'keyType',
        kind: 'kind',
        label: 'label',
        lang: 'lang',
        list: 'list',
        loop: 'loop',
        low: 'low',
        manifest: 'manifest',
        marginwidth: 'marginWidth',
        marginheight: 'marginHeight',
        max: 'max',
        maxlength: 'maxLength',
        media: 'media',
        mediagroup: 'mediaGroup',
        method: 'method',
        min: 'min',
        minlength: 'minLength',
        multiple: 'multiple',
        muted: 'muted',
        name: 'name',
        nomodule: 'noModule',
        nonce: 'nonce',
        novalidate: 'noValidate',
        open: 'open',
        optimum: 'optimum',
        pattern: 'pattern',
        placeholder: 'placeholder',
        playsinline: 'playsInline',
        poster: 'poster',
        preload: 'preload',
        profile: 'profile',
        radiogroup: 'radioGroup',
        readonly: 'readOnly',
        referrerpolicy: 'referrerPolicy',
        rel: 'rel',
        required: 'required',
        reversed: 'reversed',
        role: 'role',
        rows: 'rows',
        rowspan: 'rowSpan',
        sandbox: 'sandbox',
        scope: 'scope',
        scoped: 'scoped',
        scrolling: 'scrolling',
        seamless: 'seamless',
        selected: 'selected',
        shape: 'shape',
        size: 'size',
        sizes: 'sizes',
        span: 'span',
        spellcheck: 'spellCheck',
        src: 'src',
        srcdoc: 'srcDoc',
        srclang: 'srcLang',
        srcset: 'srcSet',
        start: 'start',
        step: 'step',
        style: 'style',
        summary: 'summary',
        tabindex: 'tabIndex',
        target: 'target',
        title: 'title',
        type: 'type',
        usemap: 'useMap',
        value: 'value',
        width: 'width',
        wmode: 'wmode',
        wrap: 'wrap',
        about: 'about',
        accentheight: 'accentHeight',
        'accent-height': 'accentHeight',
        accumulate: 'accumulate',
        additive: 'additive',
        alignmentbaseline: 'alignmentBaseline',
        'alignment-baseline': 'alignmentBaseline',
        allowreorder: 'allowReorder',
        alphabetic: 'alphabetic',
        amplitude: 'amplitude',
        arabicform: 'arabicForm',
        'arabic-form': 'arabicForm',
        ascent: 'ascent',
        attributename: 'attributeName',
        attributetype: 'attributeType',
        autoreverse: 'autoReverse',
        azimuth: 'azimuth',
        basefrequency: 'baseFrequency',
        baselineshift: 'baselineShift',
        'baseline-shift': 'baselineShift',
        baseprofile: 'baseProfile',
        bbox: 'bbox',
        begin: 'begin',
        bias: 'bias',
        by: 'by',
        calcmode: 'calcMode',
        capheight: 'capHeight',
        'cap-height': 'capHeight',
        clip: 'clip',
        clippath: 'clipPath',
        'clip-path': 'clipPath',
        clippathunits: 'clipPathUnits',
        cliprule: 'clipRule',
        'clip-rule': 'clipRule',
        color: 'color',
        colorinterpolation: 'colorInterpolation',
        'color-interpolation': 'colorInterpolation',
        colorinterpolationfilters: 'colorInterpolationFilters',
        'color-interpolation-filters': 'colorInterpolationFilters',
        colorprofile: 'colorProfile',
        'color-profile': 'colorProfile',
        colorrendering: 'colorRendering',
        'color-rendering': 'colorRendering',
        contentscripttype: 'contentScriptType',
        contentstyletype: 'contentStyleType',
        cursor: 'cursor',
        cx: 'cx',
        cy: 'cy',
        d: 'd',
        datatype: 'datatype',
        decelerate: 'decelerate',
        descent: 'descent',
        diffuseconstant: 'diffuseConstant',
        direction: 'direction',
        display: 'display',
        divisor: 'divisor',
        dominantbaseline: 'dominantBaseline',
        'dominant-baseline': 'dominantBaseline',
        dur: 'dur',
        dx: 'dx',
        dy: 'dy',
        edgemode: 'edgeMode',
        elevation: 'elevation',
        enablebackground: 'enableBackground',
        'enable-background': 'enableBackground',
        end: 'end',
        exponent: 'exponent',
        externalresourcesrequired: 'externalResourcesRequired',
        fill: 'fill',
        fillopacity: 'fillOpacity',
        'fill-opacity': 'fillOpacity',
        fillrule: 'fillRule',
        'fill-rule': 'fillRule',
        filter: 'filter',
        filterres: 'filterRes',
        filterunits: 'filterUnits',
        floodopacity: 'floodOpacity',
        'flood-opacity': 'floodOpacity',
        floodcolor: 'floodColor',
        'flood-color': 'floodColor',
        focusable: 'focusable',
        fontfamily: 'fontFamily',
        'font-family': 'fontFamily',
        fontsize: 'fontSize',
        'font-size': 'fontSize',
        fontsizeadjust: 'fontSizeAdjust',
        'font-size-adjust': 'fontSizeAdjust',
        fontstretch: 'fontStretch',
        'font-stretch': 'fontStretch',
        fontstyle: 'fontStyle',
        'font-style': 'fontStyle',
        fontvariant: 'fontVariant',
        'font-variant': 'fontVariant',
        fontweight: 'fontWeight',
        'font-weight': 'fontWeight',
        format: 'format',
        from: 'from',
        fx: 'fx',
        fy: 'fy',
        g1: 'g1',
        g2: 'g2',
        glyphname: 'glyphName',
        'glyph-name': 'glyphName',
        glyphorientationhorizontal: 'glyphOrientationHorizontal',
        'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
        glyphorientationvertical: 'glyphOrientationVertical',
        'glyph-orientation-vertical': 'glyphOrientationVertical',
        glyphref: 'glyphRef',
        gradienttransform: 'gradientTransform',
        gradientunits: 'gradientUnits',
        hanging: 'hanging',
        horizadvx: 'horizAdvX',
        'horiz-adv-x': 'horizAdvX',
        horizoriginx: 'horizOriginX',
        'horiz-origin-x': 'horizOriginX',
        ideographic: 'ideographic',
        imagerendering: 'imageRendering',
        'image-rendering': 'imageRendering',
        in2: 'in2',
        "in": 'in',
        inlist: 'inlist',
        intercept: 'intercept',
        k1: 'k1',
        k2: 'k2',
        k3: 'k3',
        k4: 'k4',
        k: 'k',
        kernelmatrix: 'kernelMatrix',
        kernelunitlength: 'kernelUnitLength',
        kerning: 'kerning',
        keypoints: 'keyPoints',
        keysplines: 'keySplines',
        keytimes: 'keyTimes',
        lengthadjust: 'lengthAdjust',
        letterspacing: 'letterSpacing',
        'letter-spacing': 'letterSpacing',
        lightingcolor: 'lightingColor',
        'lighting-color': 'lightingColor',
        limitingconeangle: 'limitingConeAngle',
        local: 'local',
        markerend: 'markerEnd',
        'marker-end': 'markerEnd',
        markerheight: 'markerHeight',
        markermid: 'markerMid',
        'marker-mid': 'markerMid',
        markerstart: 'markerStart',
        'marker-start': 'markerStart',
        markerunits: 'markerUnits',
        markerwidth: 'markerWidth',
        mask: 'mask',
        maskcontentunits: 'maskContentUnits',
        maskunits: 'maskUnits',
        mathematical: 'mathematical',
        mode: 'mode',
        numoctaves: 'numOctaves',
        offset: 'offset',
        opacity: 'opacity',
        operator: 'operator',
        order: 'order',
        orient: 'orient',
        orientation: 'orientation',
        origin: 'origin',
        overflow: 'overflow',
        overlineposition: 'overlinePosition',
        'overline-position': 'overlinePosition',
        overlinethickness: 'overlineThickness',
        'overline-thickness': 'overlineThickness',
        paintorder: 'paintOrder',
        'paint-order': 'paintOrder',
        panose1: 'panose1',
        'panose-1': 'panose1',
        pathlength: 'pathLength',
        patterncontentunits: 'patternContentUnits',
        patterntransform: 'patternTransform',
        patternunits: 'patternUnits',
        pointerevents: 'pointerEvents',
        'pointer-events': 'pointerEvents',
        points: 'points',
        pointsatx: 'pointsAtX',
        pointsaty: 'pointsAtY',
        pointsatz: 'pointsAtZ',
        prefix: 'prefix',
        preservealpha: 'preserveAlpha',
        preserveaspectratio: 'preserveAspectRatio',
        primitiveunits: 'primitiveUnits',
        property: 'property',
        r: 'r',
        radius: 'radius',
        refx: 'refX',
        refy: 'refY',
        renderingintent: 'renderingIntent',
        'rendering-intent': 'renderingIntent',
        repeatcount: 'repeatCount',
        repeatdur: 'repeatDur',
        requiredextensions: 'requiredExtensions',
        requiredfeatures: 'requiredFeatures',
        resource: 'resource',
        restart: 'restart',
        result: 'result',
        results: 'results',
        rotate: 'rotate',
        rx: 'rx',
        ry: 'ry',
        scale: 'scale',
        security: 'security',
        seed: 'seed',
        shaperendering: 'shapeRendering',
        'shape-rendering': 'shapeRendering',
        slope: 'slope',
        spacing: 'spacing',
        specularconstant: 'specularConstant',
        specularexponent: 'specularExponent',
        speed: 'speed',
        spreadmethod: 'spreadMethod',
        startoffset: 'startOffset',
        stddeviation: 'stdDeviation',
        stemh: 'stemh',
        stemv: 'stemv',
        stitchtiles: 'stitchTiles',
        stopcolor: 'stopColor',
        'stop-color': 'stopColor',
        stopopacity: 'stopOpacity',
        'stop-opacity': 'stopOpacity',
        strikethroughposition: 'strikethroughPosition',
        'strikethrough-position': 'strikethroughPosition',
        strikethroughthickness: 'strikethroughThickness',
        'strikethrough-thickness': 'strikethroughThickness',
        string: 'string',
        stroke: 'stroke',
        strokedasharray: 'strokeDasharray',
        'stroke-dasharray': 'strokeDasharray',
        strokedashoffset: 'strokeDashoffset',
        'stroke-dashoffset': 'strokeDashoffset',
        strokelinecap: 'strokeLinecap',
        'stroke-linecap': 'strokeLinecap',
        strokelinejoin: 'strokeLinejoin',
        'stroke-linejoin': 'strokeLinejoin',
        strokemiterlimit: 'strokeMiterlimit',
        'stroke-miterlimit': 'strokeMiterlimit',
        strokewidth: 'strokeWidth',
        'stroke-width': 'strokeWidth',
        strokeopacity: 'strokeOpacity',
        'stroke-opacity': 'strokeOpacity',
        suppresscontenteditablewarning: 'suppressContentEditableWarning',
        suppresshydrationwarning: 'suppressHydrationWarning',
        surfacescale: 'surfaceScale',
        systemlanguage: 'systemLanguage',
        tablevalues: 'tableValues',
        targetx: 'targetX',
        targety: 'targetY',
        textanchor: 'textAnchor',
        'text-anchor': 'textAnchor',
        textdecoration: 'textDecoration',
        'text-decoration': 'textDecoration',
        textlength: 'textLength',
        textrendering: 'textRendering',
        'text-rendering': 'textRendering',
        to: 'to',
        transform: 'transform',
        "typeof": 'typeof',
        u1: 'u1',
        u2: 'u2',
        underlineposition: 'underlinePosition',
        'underline-position': 'underlinePosition',
        underlinethickness: 'underlineThickness',
        'underline-thickness': 'underlineThickness',
        unicode: 'unicode',
        unicodebidi: 'unicodeBidi',
        'unicode-bidi': 'unicodeBidi',
        unicoderange: 'unicodeRange',
        'unicode-range': 'unicodeRange',
        unitsperem: 'unitsPerEm',
        'units-per-em': 'unitsPerEm',
        unselectable: 'unselectable',
        valphabetic: 'vAlphabetic',
        'v-alphabetic': 'vAlphabetic',
        values: 'values',
        vectoreffect: 'vectorEffect',
        'vector-effect': 'vectorEffect',
        version: 'version',
        vertadvy: 'vertAdvY',
        'vert-adv-y': 'vertAdvY',
        vertoriginx: 'vertOriginX',
        'vert-origin-x': 'vertOriginX',
        vertoriginy: 'vertOriginY',
        'vert-origin-y': 'vertOriginY',
        vhanging: 'vHanging',
        'v-hanging': 'vHanging',
        videographic: 'vIdeographic',
        'v-ideographic': 'vIdeographic',
        viewbox: 'viewBox',
        viewtarget: 'viewTarget',
        visibility: 'visibility',
        vmathematical: 'vMathematical',
        'v-mathematical': 'vMathematical',
        vocab: 'vocab',
        widths: 'widths',
        wordspacing: 'wordSpacing',
        'word-spacing': 'wordSpacing',
        writingmode: 'writingMode',
        'writing-mode': 'writingMode',
        x1: 'x1',
        x2: 'x2',
        x: 'x',
        xchannelselector: 'xChannelSelector',
        xheight: 'xHeight',
        'x-height': 'xHeight',
        xlinkactuate: 'xlinkActuate',
        'xlink:actuate': 'xlinkActuate',
        xlinkarcrole: 'xlinkArcrole',
        'xlink:arcrole': 'xlinkArcrole',
        xlinkhref: 'xlinkHref',
        'xlink:href': 'xlinkHref',
        xlinkrole: 'xlinkRole',
        'xlink:role': 'xlinkRole',
        xlinkshow: 'xlinkShow',
        'xlink:show': 'xlinkShow',
        xlinktitle: 'xlinkTitle',
        'xlink:title': 'xlinkTitle',
        xlinktype: 'xlinkType',
        'xlink:type': 'xlinkType',
        xmlbase: 'xmlBase',
        'xml:base': 'xmlBase',
        xmllang: 'xmlLang',
        'xml:lang': 'xmlLang',
        xmlns: 'xmlns',
        'xml:space': 'xmlSpace',
        xmlnsxlink: 'xmlnsXlink',
        'xmlns:xlink': 'xmlnsXlink',
        xmlspace: 'xmlSpace',
        y1: 'y1',
        y2: 'y2',
        y: 'y',
        ychannelselector: 'yChannelSelector',
        z: 'z',
        zoomandpan: 'zoomAndPan'
      };
      var ariaProperties = {
        'aria-current': 0,
        'aria-description': 0,
        'aria-details': 0,
        'aria-disabled': 0,
        'aria-hidden': 0,
        'aria-invalid': 0,
        'aria-keyshortcuts': 0,
        'aria-label': 0,
        'aria-roledescription': 0,
        'aria-autocomplete': 0,
        'aria-checked': 0,
        'aria-expanded': 0,
        'aria-haspopup': 0,
        'aria-level': 0,
        'aria-modal': 0,
        'aria-multiline': 0,
        'aria-multiselectable': 0,
        'aria-orientation': 0,
        'aria-placeholder': 0,
        'aria-pressed': 0,
        'aria-readonly': 0,
        'aria-required': 0,
        'aria-selected': 0,
        'aria-sort': 0,
        'aria-valuemax': 0,
        'aria-valuemin': 0,
        'aria-valuenow': 0,
        'aria-valuetext': 0,
        'aria-atomic': 0,
        'aria-busy': 0,
        'aria-live': 0,
        'aria-relevant': 0,
        'aria-dropeffect': 0,
        'aria-grabbed': 0,
        'aria-activedescendant': 0,
        'aria-colcount': 0,
        'aria-colindex': 0,
        'aria-colspan': 0,
        'aria-controls': 0,
        'aria-describedby': 0,
        'aria-errormessage': 0,
        'aria-flowto': 0,
        'aria-labelledby': 0,
        'aria-owns': 0,
        'aria-posinset': 0,
        'aria-rowcount': 0,
        'aria-rowindex': 0,
        'aria-rowspan': 0,
        'aria-setsize': 0
      };
      var warnedProperties = {};
      var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
      var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');

      function validateProperty(tagName, name) {
        {
          if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) {
            return true;
          }

          if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null;

            if (correctName == null) {
              error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
              warnedProperties[name] = true;
              return true;
            }

            if (name !== correctName) {
              error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
              warnedProperties[name] = true;
              return true;
            }
          }

          if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null;

            if (standardName == null) {
              warnedProperties[name] = true;
              return false;
            }

            if (name !== standardName) {
              error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
              warnedProperties[name] = true;
              return true;
            }
          }
        }
        return true;
      }

      function warnInvalidARIAProps(type, props) {
        {
          var invalidProps = [];

          for (var key in props) {
            var isValid = validateProperty(type, key);

            if (!isValid) {
              invalidProps.push(key);
            }
          }

          var unknownPropString = invalidProps.map(function (prop) {
            return '`' + prop + '`';
          }).join(', ');

          if (invalidProps.length === 1) {
            error('Invalid aria prop %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
          } else if (invalidProps.length > 1) {
            error('Invalid aria props %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
          }
        }
      }

      function validateProperties(type, props) {
        if (isCustomComponent(type, props)) {
          return;
        }

        warnInvalidARIAProps(type, props);
      }

      var didWarnValueNull = false;

      function validateProperties$1(type, props) {
        {
          if (type !== 'input' && type !== 'textarea' && type !== 'select') {
            return;
          }

          if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;

            if (type === 'select' && props.multiple) {
              error('`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
            } else {
              error('`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
            }
          }
        }
      }

      var validateProperty$1 = function validateProperty$1() {};

      {
        var warnedProperties$1 = {};
        var EVENT_NAME_REGEX = /^on./;
        var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
        var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
        var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');

        validateProperty$1 = function validateProperty$1(tagName, name, value, eventRegistry) {
          if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
            return true;
          }

          var lowerCasedName = name.toLowerCase();

          if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
            error('React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');
            warnedProperties$1[name] = true;
            return true;
          }

          if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies,
                possibleRegistrationNames = eventRegistry.possibleRegistrationNames;

            if (registrationNameDependencies.hasOwnProperty(name)) {
              return true;
            }

            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;

            if (registrationName != null) {
              error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
              warnedProperties$1[name] = true;
              return true;
            }

            if (EVENT_NAME_REGEX.test(name)) {
              error('Unknown event handler property `%s`. It will be ignored.', name);
              warnedProperties$1[name] = true;
              return true;
            }
          } else if (EVENT_NAME_REGEX.test(name)) {
            if (INVALID_EVENT_NAME_REGEX.test(name)) {
              error('Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
            }

            warnedProperties$1[name] = true;
            return true;
          }

          if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
            return true;
          }

          if (lowerCasedName === 'innerhtml') {
            error('Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');
            warnedProperties$1[name] = true;
            return true;
          }

          if (lowerCasedName === 'aria') {
            error('The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');
            warnedProperties$1[name] = true;
            return true;
          }

          if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
            error('Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);
            warnedProperties$1[name] = true;
            return true;
          }

          if (typeof value === 'number' && isNaN(value)) {
            error('Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);
            warnedProperties$1[name] = true;
            return true;
          }

          var propertyInfo = getPropertyInfo(name);
          var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED;

          if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];

            if (standardName !== name) {
              error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
              warnedProperties$1[name] = true;
              return true;
            }
          } else if (!isReserved && name !== lowerCasedName) {
            error('React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
          }

          if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) {
              error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
            } else {
              error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            }

            warnedProperties$1[name] = true;
            return true;
          }

          if (isReserved) {
            return true;
          }

          if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
          }

          if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error('Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
          }

          return true;
        };
      }

      var warnUnknownProperties = function warnUnknownProperties(type, props, eventRegistry) {
        {
          var unknownProps = [];

          for (var key in props) {
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);

            if (!isValid) {
              unknownProps.push(key);
            }
          }

          var unknownPropString = unknownProps.map(function (prop) {
            return '`' + prop + '`';
          }).join(', ');

          if (unknownProps.length === 1) {
            error('Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
          } else if (unknownProps.length > 1) {
            error('Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
          }
        }
      };

      function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) {
          return;
        }

        warnUnknownProperties(type, props, eventRegistry);
      }

      var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
      var IS_NON_DELEGATED = 1 << 1;
      var IS_CAPTURE_PHASE = 1 << 2;
      var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
      var currentReplayingEvent = null;

      function setReplayingEvent(event) {
        {
          if (currentReplayingEvent !== null) {
            error('Expected currently replaying event to be null. This error ' + 'is likely caused by a bug in React. Please file an issue.');
          }
        }
        currentReplayingEvent = event;
      }

      function resetReplayingEvent() {
        {
          if (currentReplayingEvent === null) {
            error('Expected currently replaying event to not be null. This error ' + 'is likely caused by a bug in React. Please file an issue.');
          }
        }
        currentReplayingEvent = null;
      }

      function isReplayingEvent(event) {
        return event === currentReplayingEvent;
      }

      function getEventTarget(nativeEvent) {
        var target = nativeEvent.target || nativeEvent.srcElement || window;

        if (target.correspondingUseElement) {
          target = target.correspondingUseElement;
        }

        return target.nodeType === TEXT_NODE ? target.parentNode : target;
      }

      var restoreImpl = null;
      var restoreTarget = null;
      var restoreQueue = null;

      function restoreStateOfTarget(target) {
        var internalInstance = getInstanceFromNode(target);

        if (!internalInstance) {
          return;
        }

        if (typeof restoreImpl !== 'function') {
          throw new Error('setRestoreImplementation() needs to be called to handle a target for controlled ' + 'events. This error is likely caused by a bug in React. Please file an issue.');
        }

        var stateNode = internalInstance.stateNode;

        if (stateNode) {
          var _props = getFiberCurrentPropsFromNode(stateNode);

          restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
      }

      function setRestoreImplementation(impl) {
        restoreImpl = impl;
      }

      function enqueueStateRestore(target) {
        if (restoreTarget) {
          if (restoreQueue) {
            restoreQueue.push(target);
          } else {
            restoreQueue = [target];
          }
        } else {
          restoreTarget = target;
        }
      }

      function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
      }

      function restoreStateIfNeeded() {
        if (!restoreTarget) {
          return;
        }

        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);

        if (queuedTargets) {
          for (var i = 0; i < queuedTargets.length; i++) {
            restoreStateOfTarget(queuedTargets[i]);
          }
        }
      }

      var batchedUpdatesImpl = function batchedUpdatesImpl(fn, bookkeeping) {
        return fn(bookkeeping);
      };

      var flushSyncImpl = function flushSyncImpl() {};

      var isInsideEventHandler = false;

      function finishEventHandler() {
        var controlledComponentsHavePendingUpdates = needsStateRestore();

        if (controlledComponentsHavePendingUpdates) {
          flushSyncImpl();
          restoreStateIfNeeded();
        }
      }

      function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) {
          return fn(a, b);
        }

        isInsideEventHandler = true;

        try {
          return batchedUpdatesImpl(fn, a, b);
        } finally {
          isInsideEventHandler = false;
          finishEventHandler();
        }
      }

      function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
      }

      function isInteractive(tag) {
        return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
      }

      function shouldPreventMouseEvent(name, type, props) {
        switch (name) {
          case 'onClick':
          case 'onClickCapture':
          case 'onDoubleClick':
          case 'onDoubleClickCapture':
          case 'onMouseDown':
          case 'onMouseDownCapture':
          case 'onMouseMove':
          case 'onMouseMoveCapture':
          case 'onMouseUp':
          case 'onMouseUpCapture':
          case 'onMouseEnter':
            return !!(props.disabled && isInteractive(type));

          default:
            return false;
        }
      }

      function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;

        if (stateNode === null) {
          return null;
        }

        var props = getFiberCurrentPropsFromNode(stateNode);

        if (props === null) {
          return null;
        }

        var listener = props[registrationName];

        if (shouldPreventMouseEvent(registrationName, inst.type, props)) {
          return null;
        }

        if (listener && typeof listener !== 'function') {
          throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        }

        return listener;
      }

      var passiveBrowserEventsSupported = false;

      if (canUseDOM) {
        try {
          var options = {};
          Object.defineProperty(options, 'passive', {
            get: function get() {
              passiveBrowserEventsSupported = true;
            }
          });
          window.addEventListener('test', options, options);
          window.removeEventListener('test', options, options);
        } catch (e) {
          passiveBrowserEventsSupported = false;
        }
      }

      function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);

        try {
          func.apply(context, funcArgs);
        } catch (error) {
          this.onError(error);
        }
      }

      var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
      {
        if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
          var fakeNode = document.createElement('react');

          invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            if (typeof document === 'undefined' || document === null) {
              throw new Error('The `document` global was defined when React was initialized, but is not ' + 'defined anymore. This can happen in a test environment if a component ' + 'schedules an update from an asynchronous callback, but the test has already ' + 'finished running. To solve this, you can either unmount the component at ' + 'the end of your test (and ensure that any asynchronous operations get ' + 'canceled in `componentWillUnmount`), or you can change the test itself ' + 'to be asynchronous.');
            }

            var evt = document.createEvent('Event');
            var didCall = false;
            var didError = true;
            var windowEvent = window.event;
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');

            function restoreAfterDispatch() {
              fakeNode.removeEventListener(evtType, callCallback, false);

              if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) {
                window.event = windowEvent;
              }
            }

            var funcArgs = Array.prototype.slice.call(arguments, 3);

            function callCallback() {
              didCall = true;
              restoreAfterDispatch();
              func.apply(context, funcArgs);
              didError = false;
            }

            var error;
            var didSetError = false;
            var isCrossOriginError = false;

            function handleWindowError(event) {
              error = event.error;
              didSetError = true;

              if (error === null && event.colno === 0 && event.lineno === 0) {
                isCrossOriginError = true;
              }

              if (event.defaultPrevented) {
                if (error != null && typeof error === 'object') {
                  try {
                    error._suppressLogging = true;
                  } catch (inner) {}
                }
              }
            }

            var evtType = "react-" + (name ? name : 'invokeguardedcallback');
            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false);
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);

            if (windowEventDescriptor) {
              Object.defineProperty(window, 'event', windowEventDescriptor);
            }

            if (didCall && didError) {
              if (!didSetError) {
                error = new Error('An error was thrown inside one of your components, but React ' + "doesn't know what it was. This is likely due to browser " + 'flakiness. React does its best to preserve the "Pause on ' + 'exceptions" behavior of the DevTools, which requires some ' + "DEV-mode only tricks. It's possible that these don't work in " + 'your browser. Try triggering the error in production mode, ' + 'or switching to a modern browser. If you suspect that this is ' + 'actually an issue with React, please file an issue.');
              } else if (isCrossOriginError) {
                error = new Error("A cross-origin error was thrown. React doesn't have access to " + 'the actual error object in development. ' + 'See https://reactjs.org/link/crossorigin-error for more information.');
              }

              this.onError(error);
            }

            window.removeEventListener('error', handleWindowError);

            if (!didCall) {
              restoreAfterDispatch();
              return invokeGuardedCallbackProd.apply(this, arguments);
            }
          };
        }
      }
      var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
      var hasError = false;
      var caughtError = null;
      var hasRethrowError = false;
      var rethrowError = null;
      var reporter = {
        onError: function onError(error) {
          hasError = true;
          caughtError = error;
        }
      };

      function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
      }

      function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);

        if (hasError) {
          var error = clearCaughtError();

          if (!hasRethrowError) {
            hasRethrowError = true;
            rethrowError = error;
          }
        }
      }

      function rethrowCaughtError() {
        if (hasRethrowError) {
          var error = rethrowError;
          hasRethrowError = false;
          rethrowError = null;
          throw error;
        }
      }

      function hasCaughtError() {
        return hasError;
      }

      function clearCaughtError() {
        if (hasError) {
          var error = caughtError;
          hasError = false;
          caughtError = null;
          return error;
        } else {
          throw new Error('clearCaughtError was called but no error was captured. This error ' + 'is likely caused by a bug in React. Please file an issue.');
        }
      }

      function get(key) {
        return key._reactInternals;
      }

      function has(key) {
        return key._reactInternals !== undefined;
      }

      function set(key, value) {
        key._reactInternals = value;
      }

      var NoFlags = 0;
      var PerformedWork = 1;
      var Placement = 2;
      var Update = 4;
      var ChildDeletion = 16;
      var ContentReset = 32;
      var Callback = 64;
      var DidCapture = 128;
      var ForceClientRender = 256;
      var Ref = 512;
      var Snapshot = 1024;
      var Passive = 2048;
      var Hydrating = 4096;
      var Visibility = 8192;
      var StoreConsistency = 16384;
      var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency;
      var HostEffectMask = 32767;
      var Incomplete = 32768;
      var ShouldCapture = 65536;
      var ForceUpdateForLegacySuspense = 131072;
      var Forked = 1048576;
      var RefStatic = 2097152;
      var LayoutStatic = 4194304;
      var PassiveStatic = 8388608;
      var MountLayoutDev = 16777216;
      var MountPassiveDev = 33554432;
      var BeforeMutationMask = Update | Snapshot | 0;
      var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
      var LayoutMask = Update | Callback | Ref | Visibility;
      var PassiveMask = Passive | ChildDeletion;
      var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;

      function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;

        if (!fiber.alternate) {
          var nextNode = node;

          do {
            node = nextNode;

            if ((node.flags & (Placement | Hydrating)) !== NoFlags) {
              nearestMounted = node["return"];
            }

            nextNode = node["return"];
          } while (nextNode);
        } else {
          while (node["return"]) {
            node = node["return"];
          }
        }

        if (node.tag === HostRoot) {
          return nearestMounted;
        }

        return null;
      }

      function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
          var suspenseState = fiber.memoizedState;

          if (suspenseState === null) {
            var current = fiber.alternate;

            if (current !== null) {
              suspenseState = current.memoizedState;
            }
          }

          if (suspenseState !== null) {
            return suspenseState.dehydrated;
          }
        }

        return null;
      }

      function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
      }

      function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
      }

      function isMounted(component) {
        {
          var owner = ReactCurrentOwner.current;

          if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;

            if (!instance._warnedAboutRefsInRender) {
              error('%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentNameFromFiber(ownerFiber) || 'A component');
            }

            instance._warnedAboutRefsInRender = true;
          }
        }
        var fiber = get(component);

        if (!fiber) {
          return false;
        }

        return getNearestMountedFiber(fiber) === fiber;
      }

      function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) {
          throw new Error('Unable to find node on an unmounted component.');
        }
      }

      function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;

        if (!alternate) {
          var nearestMounted = getNearestMountedFiber(fiber);

          if (nearestMounted === null) {
            throw new Error('Unable to find node on an unmounted component.');
          }

          if (nearestMounted !== fiber) {
            return null;
          }

          return fiber;
        }

        var a = fiber;
        var b = alternate;

        while (true) {
          var parentA = a["return"];

          if (parentA === null) {
            break;
          }

          var parentB = parentA.alternate;

          if (parentB === null) {
            var nextParent = parentA["return"];

            if (nextParent !== null) {
              a = b = nextParent;
              continue;
            }

            break;
          }

          if (parentA.child === parentB.child) {
            var child = parentA.child;

            while (child) {
              if (child === a) {
                assertIsMounted(parentA);
                return fiber;
              }

              if (child === b) {
                assertIsMounted(parentA);
                return alternate;
              }

              child = child.sibling;
            }

            throw new Error('Unable to find node on an unmounted component.');
          }

          if (a["return"] !== b["return"]) {
            a = parentA;
            b = parentB;
          } else {
            var didFindChild = false;
            var _child = parentA.child;

            while (_child) {
              if (_child === a) {
                didFindChild = true;
                a = parentA;
                b = parentB;
                break;
              }

              if (_child === b) {
                didFindChild = true;
                b = parentA;
                a = parentB;
                break;
              }

              _child = _child.sibling;
            }

            if (!didFindChild) {
              _child = parentB.child;

              while (_child) {
                if (_child === a) {
                  didFindChild = true;
                  a = parentB;
                  b = parentA;
                  break;
                }

                if (_child === b) {
                  didFindChild = true;
                  b = parentB;
                  a = parentA;
                  break;
                }

                _child = _child.sibling;
              }

              if (!didFindChild) {
                throw new Error('Child was not found in either parent set. This indicates a bug ' + 'in React related to the return pointer. Please file an issue.');
              }
            }
          }

          if (a.alternate !== b) {
            throw new Error("Return fibers should always be each others' alternates. " + 'This error is likely caused by a bug in React. Please file an issue.');
          }
        }

        if (a.tag !== HostRoot) {
          throw new Error('Unable to find node on an unmounted component.');
        }

        if (a.stateNode.current === a) {
          return fiber;
        }

        return alternate;
      }

      function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
      }

      function findCurrentHostFiberImpl(node) {
        if (node.tag === HostComponent || node.tag === HostText) {
          return node;
        }

        var child = node.child;

        while (child !== null) {
          var match = findCurrentHostFiberImpl(child);

          if (match !== null) {
            return match;
          }

          child = child.sibling;
        }

        return null;
      }

      function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
      }

      function findCurrentHostFiberWithNoPortalsImpl(node) {
        if (node.tag === HostComponent || node.tag === HostText) {
          return node;
        }

        var child = node.child;

        while (child !== null) {
          if (child.tag !== HostPortal) {
            var match = findCurrentHostFiberWithNoPortalsImpl(child);

            if (match !== null) {
              return match;
            }
          }

          child = child.sibling;
        }

        return null;
      }

      var scheduleCallback = Scheduler.unstable_scheduleCallback;
      var cancelCallback = Scheduler.unstable_cancelCallback;
      var shouldYield = Scheduler.unstable_shouldYield;
      var requestPaint = Scheduler.unstable_requestPaint;
      var now = Scheduler.unstable_now;
      var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
      var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
      var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
      var NormalPriority = Scheduler.unstable_NormalPriority;
      var LowPriority = Scheduler.unstable_LowPriority;
      var IdlePriority = Scheduler.unstable_IdlePriority;
      var unstable_yieldValue = Scheduler.unstable_yieldValue;
      var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
      var rendererID = null;
      var injectedHook = null;
      var injectedProfilingHooks = null;
      var hasLoggedError = false;
      var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';

      function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
          return false;
        }

        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;

        if (hook.isDisabled) {
          return true;
        }

        if (!hook.supportsFiber) {
          {
            error('The installed version of React DevTools is too old and will not work ' + 'with the current version of React. Please update React DevTools. ' + 'https://reactjs.org/link/react-devtools');
          }
          return true;
        }

        try {
          if (enableSchedulingProfiler) {
            internals = assign({}, internals, {
              getLaneLabelMap: getLaneLabelMap,
              injectProfilingHooks: injectProfilingHooks
            });
          }

          rendererID = hook.inject(internals);
          injectedHook = hook;
        } catch (err) {
          {
            error('React instrumentation encountered an error: %s.', err);
          }
        }

        if (hook.checkDCE) {
          return true;
        } else {
          return false;
        }
      }

      function onScheduleRoot(root, children) {
        {
          if (injectedHook && typeof injectedHook.onScheduleFiberRoot === 'function') {
            try {
              injectedHook.onScheduleFiberRoot(rendererID, root, children);
            } catch (err) {
              if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
              }
            }
          }
        }
      }

      function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === 'function') {
          try {
            var didError = (root.current.flags & DidCapture) === DidCapture;

            if (enableProfilerTimer) {
              var schedulerPriority;

              switch (eventPriority) {
                case DiscreteEventPriority:
                  schedulerPriority = ImmediatePriority;
                  break;

                case ContinuousEventPriority:
                  schedulerPriority = UserBlockingPriority;
                  break;

                case DefaultEventPriority:
                  schedulerPriority = NormalPriority;
                  break;

                case IdleEventPriority:
                  schedulerPriority = IdlePriority;
                  break;

                default:
                  schedulerPriority = NormalPriority;
                  break;
              }

              injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else {
              injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
            }
          } catch (err) {
            {
              if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
              }
            }
          }
        }
      }

      function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === 'function') {
          try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
          } catch (err) {
            {
              if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
              }
            }
          }
        }
      }

      function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === 'function') {
          try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
          } catch (err) {
            {
              if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
              }
            }
          }
        }
      }

      function setIsStrictModeForDevtools(newIsStrictMode) {
        {
          if (typeof unstable_yieldValue === 'function') {
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
          }

          if (injectedHook && typeof injectedHook.setStrictMode === 'function') {
            try {
              injectedHook.setStrictMode(rendererID, newIsStrictMode);
            } catch (err) {
              {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error('React instrumentation encountered an error: %s', err);
                }
              }
            }
          }
        }
      }

      function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
      }

      function getLaneLabelMap() {
        {
          var map = new Map();
          var lane = 1;

          for (var index = 0; index < TotalLanes; index++) {
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
          }

          return map;
        }
      }

      function markCommitStarted(lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === 'function') {
            injectedProfilingHooks.markCommitStarted(lanes);
          }
        }
      }

      function markCommitStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === 'function') {
            injectedProfilingHooks.markCommitStopped();
          }
        }
      }

      function markComponentRenderStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === 'function') {
            injectedProfilingHooks.markComponentRenderStarted(fiber);
          }
        }
      }

      function markComponentRenderStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === 'function') {
            injectedProfilingHooks.markComponentRenderStopped();
          }
        }
      }

      function markComponentPassiveEffectMountStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === 'function') {
            injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
          }
        }
      }

      function markComponentPassiveEffectMountStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === 'function') {
            injectedProfilingHooks.markComponentPassiveEffectMountStopped();
          }
        }
      }

      function markComponentPassiveEffectUnmountStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === 'function') {
            injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
          }
        }
      }

      function markComponentPassiveEffectUnmountStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === 'function') {
            injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
          }
        }
      }

      function markComponentLayoutEffectMountStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === 'function') {
            injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
          }
        }
      }

      function markComponentLayoutEffectMountStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === 'function') {
            injectedProfilingHooks.markComponentLayoutEffectMountStopped();
          }
        }
      }

      function markComponentLayoutEffectUnmountStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === 'function') {
            injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
          }
        }
      }

      function markComponentLayoutEffectUnmountStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === 'function') {
            injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
          }
        }
      }

      function markComponentErrored(fiber, thrownValue, lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === 'function') {
            injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
          }
        }
      }

      function markComponentSuspended(fiber, wakeable, lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === 'function') {
            injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
          }
        }
      }

      function markLayoutEffectsStarted(lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === 'function') {
            injectedProfilingHooks.markLayoutEffectsStarted(lanes);
          }
        }
      }

      function markLayoutEffectsStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === 'function') {
            injectedProfilingHooks.markLayoutEffectsStopped();
          }
        }
      }

      function markPassiveEffectsStarted(lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === 'function') {
            injectedProfilingHooks.markPassiveEffectsStarted(lanes);
          }
        }
      }

      function markPassiveEffectsStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === 'function') {
            injectedProfilingHooks.markPassiveEffectsStopped();
          }
        }
      }

      function markRenderStarted(lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === 'function') {
            injectedProfilingHooks.markRenderStarted(lanes);
          }
        }
      }

      function markRenderYielded() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === 'function') {
            injectedProfilingHooks.markRenderYielded();
          }
        }
      }

      function markRenderStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === 'function') {
            injectedProfilingHooks.markRenderStopped();
          }
        }
      }

      function markRenderScheduled(lane) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === 'function') {
            injectedProfilingHooks.markRenderScheduled(lane);
          }
        }
      }

      function markForceUpdateScheduled(fiber, lane) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === 'function') {
            injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
          }
        }
      }

      function markStateUpdateScheduled(fiber, lane) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === 'function') {
            injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
          }
        }
      }

      var NoMode = 0;
      var ConcurrentMode = 1;
      var ProfileMode = 2;
      var StrictLegacyMode = 8;
      var StrictEffectsMode = 16;
      var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback;
      var log = Math.log;
      var LN2 = Math.LN2;

      function clz32Fallback(x) {
        var asUint = x >>> 0;

        if (asUint === 0) {
          return 32;
        }

        return 31 - (log(asUint) / LN2 | 0) | 0;
      }

      var TotalLanes = 31;
      var NoLanes = 0;
      var NoLane = 0;
      var SyncLane = 1;
      var InputContinuousHydrationLane = 2;
      var InputContinuousLane = 4;
      var DefaultHydrationLane = 8;
      var DefaultLane = 16;
      var TransitionHydrationLane = 32;
      var TransitionLanes = 4194240;
      var TransitionLane1 = 64;
      var TransitionLane2 = 128;
      var TransitionLane3 = 256;
      var TransitionLane4 = 512;
      var TransitionLane5 = 1024;
      var TransitionLane6 = 2048;
      var TransitionLane7 = 4096;
      var TransitionLane8 = 8192;
      var TransitionLane9 = 16384;
      var TransitionLane10 = 32768;
      var TransitionLane11 = 65536;
      var TransitionLane12 = 131072;
      var TransitionLane13 = 262144;
      var TransitionLane14 = 524288;
      var TransitionLane15 = 1048576;
      var TransitionLane16 = 2097152;
      var RetryLanes = 130023424;
      var RetryLane1 = 4194304;
      var RetryLane2 = 8388608;
      var RetryLane3 = 16777216;
      var RetryLane4 = 33554432;
      var RetryLane5 = 67108864;
      var SomeRetryLane = RetryLane1;
      var SelectiveHydrationLane = 134217728;
      var NonIdleLanes = 268435455;
      var IdleHydrationLane = 268435456;
      var IdleLane = 536870912;
      var OffscreenLane = 1073741824;

      function getLabelForLane(lane) {
        {
          if (lane & SyncLane) {
            return 'Sync';
          }

          if (lane & InputContinuousHydrationLane) {
            return 'InputContinuousHydration';
          }

          if (lane & InputContinuousLane) {
            return 'InputContinuous';
          }

          if (lane & DefaultHydrationLane) {
            return 'DefaultHydration';
          }

          if (lane & DefaultLane) {
            return 'Default';
          }

          if (lane & TransitionHydrationLane) {
            return 'TransitionHydration';
          }

          if (lane & TransitionLanes) {
            return 'Transition';
          }

          if (lane & RetryLanes) {
            return 'Retry';
          }

          if (lane & SelectiveHydrationLane) {
            return 'SelectiveHydration';
          }

          if (lane & IdleHydrationLane) {
            return 'IdleHydration';
          }

          if (lane & IdleLane) {
            return 'Idle';
          }

          if (lane & OffscreenLane) {
            return 'Offscreen';
          }
        }
      }

      var NoTimestamp = -1;
      var nextTransitionLane = TransitionLane1;
      var nextRetryLane = RetryLane1;

      function getHighestPriorityLanes(lanes) {
        switch (getHighestPriorityLane(lanes)) {
          case SyncLane:
            return SyncLane;

          case InputContinuousHydrationLane:
            return InputContinuousHydrationLane;

          case InputContinuousLane:
            return InputContinuousLane;

          case DefaultHydrationLane:
            return DefaultHydrationLane;

          case DefaultLane:
            return DefaultLane;

          case TransitionHydrationLane:
            return TransitionHydrationLane;

          case TransitionLane1:
          case TransitionLane2:
          case TransitionLane3:
          case TransitionLane4:
          case TransitionLane5:
          case TransitionLane6:
          case TransitionLane7:
          case TransitionLane8:
          case TransitionLane9:
          case TransitionLane10:
          case TransitionLane11:
          case TransitionLane12:
          case TransitionLane13:
          case TransitionLane14:
          case TransitionLane15:
          case TransitionLane16:
            return lanes & TransitionLanes;

          case RetryLane1:
          case RetryLane2:
          case RetryLane3:
          case RetryLane4:
          case RetryLane5:
            return lanes & RetryLanes;

          case SelectiveHydrationLane:
            return SelectiveHydrationLane;

          case IdleHydrationLane:
            return IdleHydrationLane;

          case IdleLane:
            return IdleLane;

          case OffscreenLane:
            return OffscreenLane;

          default:
            {
              error('Should have found matching lanes. This is a bug in React.');
            }
            return lanes;
        }
      }

      function getNextLanes(root, wipLanes) {
        var pendingLanes = root.pendingLanes;

        if (pendingLanes === NoLanes) {
          return NoLanes;
        }

        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;

        if (nonIdlePendingLanes !== NoLanes) {
          var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;

          if (nonIdleUnblockedLanes !== NoLanes) {
            nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
          } else {
            var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;

            if (nonIdlePingedLanes !== NoLanes) {
              nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
          }
        } else {
          var unblockedLanes = pendingLanes & ~suspendedLanes;

          if (unblockedLanes !== NoLanes) {
            nextLanes = getHighestPriorityLanes(unblockedLanes);
          } else {
            if (pingedLanes !== NoLanes) {
              nextLanes = getHighestPriorityLanes(pingedLanes);
            }
          }
        }

        if (nextLanes === NoLanes) {
          return NoLanes;
        }

        if (wipLanes !== NoLanes && wipLanes !== nextLanes && (wipLanes & suspendedLanes) === NoLanes) {
          var nextLane = getHighestPriorityLane(nextLanes);
          var wipLane = getHighestPriorityLane(wipLanes);

          if (nextLane >= wipLane || nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) {
            return wipLanes;
          }
        }

        if ((nextLanes & InputContinuousLane) !== NoLanes) {
          nextLanes |= pendingLanes & DefaultLane;
        }

        var entangledLanes = root.entangledLanes;

        if (entangledLanes !== NoLanes) {
          var entanglements = root.entanglements;
          var lanes = nextLanes & entangledLanes;

          while (lanes > 0) {
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            nextLanes |= entanglements[index];
            lanes &= ~lane;
          }
        }

        return nextLanes;
      }

      function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;

        while (lanes > 0) {
          var index = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index;
          var eventTime = eventTimes[index];

          if (eventTime > mostRecentEventTime) {
            mostRecentEventTime = eventTime;
          }

          lanes &= ~lane;
        }

        return mostRecentEventTime;
      }

      function computeExpirationTime(lane, currentTime) {
        switch (lane) {
          case SyncLane:
          case InputContinuousHydrationLane:
          case InputContinuousLane:
            return currentTime + 250;

          case DefaultHydrationLane:
          case DefaultLane:
          case TransitionHydrationLane:
          case TransitionLane1:
          case TransitionLane2:
          case TransitionLane3:
          case TransitionLane4:
          case TransitionLane5:
          case TransitionLane6:
          case TransitionLane7:
          case TransitionLane8:
          case TransitionLane9:
          case TransitionLane10:
          case TransitionLane11:
          case TransitionLane12:
          case TransitionLane13:
          case TransitionLane14:
          case TransitionLane15:
          case TransitionLane16:
            return currentTime + 5000;

          case RetryLane1:
          case RetryLane2:
          case RetryLane3:
          case RetryLane4:
          case RetryLane5:
            return NoTimestamp;

          case SelectiveHydrationLane:
          case IdleHydrationLane:
          case IdleLane:
          case OffscreenLane:
            return NoTimestamp;

          default:
            {
              error('Should have found matching lanes. This is a bug in React.');
            }
            return NoTimestamp;
        }
      }

      function markStarvedLanesAsExpired(root, currentTime) {
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes;
        var lanes = pendingLanes;

        while (lanes > 0) {
          var index = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index;
          var expirationTime = expirationTimes[index];

          if (expirationTime === NoTimestamp) {
            if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) {
              expirationTimes[index] = computeExpirationTime(lane, currentTime);
            }
          } else if (expirationTime <= currentTime) {
            root.expiredLanes |= lane;
          }

          lanes &= ~lane;
        }
      }

      function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
      }

      function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;

        if (everythingButOffscreen !== NoLanes) {
          return everythingButOffscreen;
        }

        if (everythingButOffscreen & OffscreenLane) {
          return OffscreenLane;
        }

        return NoLanes;
      }

      function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
      }

      function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
      }

      function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
      }

      function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
      }

      function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
      }

      function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
      }

      function includesExpiredLane(root, lanes) {
        return (lanes & root.expiredLanes) !== NoLanes;
      }

      function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
      }

      function claimNextTransitionLane() {
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;

        if ((nextTransitionLane & TransitionLanes) === NoLanes) {
          nextTransitionLane = TransitionLane1;
        }

        return lane;
      }

      function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;

        if ((nextRetryLane & RetryLanes) === NoLanes) {
          nextRetryLane = RetryLane1;
        }

        return lane;
      }

      function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
      }

      function pickArbitraryLane(lanes) {
        return getHighestPriorityLane(lanes);
      }

      function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
      }

      function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
      }

      function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
      }

      function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
      }

      function mergeLanes(a, b) {
        return a | b;
      }

      function removeLanes(set, subset) {
        return set & ~subset;
      }

      function intersectLanes(a, b) {
        return a & b;
      }

      function laneToLanes(lane) {
        return lane;
      }

      function higherPriorityLane(a, b) {
        return a !== NoLane && a < b ? a : b;
      }

      function createLaneMap(initial) {
        var laneMap = [];

        for (var i = 0; i < TotalLanes; i++) {
          laneMap.push(initial);
        }

        return laneMap;
      }

      function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane;

        if (updateLane !== IdleLane) {
          root.suspendedLanes = NoLanes;
          root.pingedLanes = NoLanes;
        }

        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane);
        eventTimes[index] = eventTime;
      }

      function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes;
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;

        while (lanes > 0) {
          var index = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index;
          expirationTimes[index] = NoTimestamp;
          lanes &= ~lane;
        }
      }

      function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
      }

      function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes;
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes;
        var lanes = noLongerPendingLanes;

        while (lanes > 0) {
          var index = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index;
          entanglements[index] = NoLanes;
          eventTimes[index] = NoTimestamp;
          expirationTimes[index] = NoTimestamp;
          lanes &= ~lane;
        }
      }

      function markRootEntangled(root, entangledLanes) {
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;

        while (lanes) {
          var index = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index;

          if (lane & entangledLanes | entanglements[index] & entangledLanes) {
            entanglements[index] |= entangledLanes;
          }

          lanes &= ~lane;
        }
      }

      function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;

        switch (renderLane) {
          case InputContinuousLane:
            lane = InputContinuousHydrationLane;
            break;

          case DefaultLane:
            lane = DefaultHydrationLane;
            break;

          case TransitionLane1:
          case TransitionLane2:
          case TransitionLane3:
          case TransitionLane4:
          case TransitionLane5:
          case TransitionLane6:
          case TransitionLane7:
          case TransitionLane8:
          case TransitionLane9:
          case TransitionLane10:
          case TransitionLane11:
          case TransitionLane12:
          case TransitionLane13:
          case TransitionLane14:
          case TransitionLane15:
          case TransitionLane16:
          case RetryLane1:
          case RetryLane2:
          case RetryLane3:
          case RetryLane4:
          case RetryLane5:
            lane = TransitionHydrationLane;
            break;

          case IdleLane:
            lane = IdleHydrationLane;
            break;

          default:
            lane = NoLane;
            break;
        }

        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) {
          return NoLane;
        }

        return lane;
      }

      function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) {
          return;
        }

        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;

        while (lanes > 0) {
          var index = laneToIndex(lanes);
          var lane = 1 << index;
          var updaters = pendingUpdatersLaneMap[index];
          updaters.add(fiber);
          lanes &= ~lane;
        }
      }

      function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) {
          return;
        }

        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;

        while (lanes > 0) {
          var index = laneToIndex(lanes);
          var lane = 1 << index;
          var updaters = pendingUpdatersLaneMap[index];

          if (updaters.size > 0) {
            updaters.forEach(function (fiber) {
              var alternate = fiber.alternate;

              if (alternate === null || !memoizedUpdaters.has(alternate)) {
                memoizedUpdaters.add(fiber);
              }
            });
            updaters.clear();
          }

          lanes &= ~lane;
        }
      }

      function getTransitionsForLanes(root, lanes) {
        {
          return null;
        }
      }

      var DiscreteEventPriority = SyncLane;
      var ContinuousEventPriority = InputContinuousLane;
      var DefaultEventPriority = DefaultLane;
      var IdleEventPriority = IdleLane;
      var currentUpdatePriority = NoLane;

      function getCurrentUpdatePriority() {
        return currentUpdatePriority;
      }

      function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
      }

      function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;

        try {
          currentUpdatePriority = priority;
          return fn();
        } finally {
          currentUpdatePriority = previousPriority;
        }
      }

      function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
      }

      function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
      }

      function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
      }

      function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);

        if (!isHigherEventPriority(DiscreteEventPriority, lane)) {
          return DiscreteEventPriority;
        }

        if (!isHigherEventPriority(ContinuousEventPriority, lane)) {
          return ContinuousEventPriority;
        }

        if (includesNonIdleWork(lane)) {
          return DefaultEventPriority;
        }

        return IdleEventPriority;
      }

      function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
      }

      var _attemptSynchronousHydration;

      function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
      }

      function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
      }

      var attemptContinuousHydration;

      function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
      }

      var attemptHydrationAtCurrentPriority;

      function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
      }

      var getCurrentUpdatePriority$1;

      function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
      }

      var attemptHydrationAtPriority;

      function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
      }

      var hasScheduledReplayAttempt = false;
      var queuedDiscreteEvents = [];
      var queuedFocus = null;
      var queuedDrag = null;
      var queuedMouse = null;
      var queuedPointers = new Map();
      var queuedPointerCaptures = new Map();
      var queuedExplicitHydrationTargets = [];
      var discreteReplayableEvents = ['mousedown', 'mouseup', 'touchcancel', 'touchend', 'touchstart', 'auxclick', 'dblclick', 'pointercancel', 'pointerdown', 'pointerup', 'dragend', 'dragstart', 'drop', 'compositionend', 'compositionstart', 'keydown', 'keypress', 'keyup', 'input', 'textInput', 'copy', 'cut', 'paste', 'click', 'change', 'contextmenu', 'reset', 'submit'];

      function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
      }

      function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
          blockedOn: blockedOn,
          domEventName: domEventName,
          eventSystemFlags: eventSystemFlags,
          nativeEvent: nativeEvent,
          targetContainers: [targetContainer]
        };
      }

      function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch (domEventName) {
          case 'focusin':
          case 'focusout':
            queuedFocus = null;
            break;

          case 'dragenter':
          case 'dragleave':
            queuedDrag = null;
            break;

          case 'mouseover':
          case 'mouseout':
            queuedMouse = null;
            break;

          case 'pointerover':
          case 'pointerout':
            {
              var pointerId = nativeEvent.pointerId;
              queuedPointers["delete"](pointerId);
              break;
            }

          case 'gotpointercapture':
          case 'lostpointercapture':
            {
              var _pointerId = nativeEvent.pointerId;
              queuedPointerCaptures["delete"](_pointerId);
              break;
            }
        }
      }

      function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
          var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);

          if (blockedOn !== null) {
            var _fiber2 = getInstanceFromNode(blockedOn);

            if (_fiber2 !== null) {
              attemptContinuousHydration(_fiber2);
            }
          }

          return queuedEvent;
        }

        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;

        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) {
          targetContainers.push(targetContainer);
        }

        return existingQueuedEvent;
      }

      function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        switch (domEventName) {
          case 'focusin':
            {
              var focusEvent = nativeEvent;
              queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
              return true;
            }

          case 'dragenter':
            {
              var dragEvent = nativeEvent;
              queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
              return true;
            }

          case 'mouseover':
            {
              var mouseEvent = nativeEvent;
              queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
              return true;
            }

          case 'pointerover':
            {
              var pointerEvent = nativeEvent;
              var pointerId = pointerEvent.pointerId;
              queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
              return true;
            }

          case 'gotpointercapture':
            {
              var _pointerEvent = nativeEvent;
              var _pointerId2 = _pointerEvent.pointerId;
              queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
              return true;
            }
        }

        return false;
      }

      function attemptExplicitHydrationTarget(queuedTarget) {
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);

        if (targetInst !== null) {
          var nearestMounted = getNearestMountedFiber(targetInst);

          if (nearestMounted !== null) {
            var tag = nearestMounted.tag;

            if (tag === SuspenseComponent) {
              var instance = getSuspenseInstanceFromFiber(nearestMounted);

              if (instance !== null) {
                queuedTarget.blockedOn = instance;
                attemptHydrationAtPriority(queuedTarget.priority, function () {
                  attemptHydrationAtCurrentPriority(nearestMounted);
                });
                return;
              }
            } else if (tag === HostRoot) {
              var root = nearestMounted.stateNode;

              if (isRootDehydrated(root)) {
                queuedTarget.blockedOn = getContainerFromFiber(nearestMounted);
                return;
              }
            }
          }
        }

        queuedTarget.blockedOn = null;
      }

      function queueExplicitHydrationTarget(target) {
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
          blockedOn: null,
          target: target,
          priority: updatePriority
        };
        var i = 0;

        for (; i < queuedExplicitHydrationTargets.length; i++) {
          if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) {
            break;
          }
        }

        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);

        if (i === 0) {
          attemptExplicitHydrationTarget(queuedTarget);
        }
      }

      function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) {
          return false;
        }

        var targetContainers = queuedEvent.targetContainers;

        while (targetContainers.length > 0) {
          var targetContainer = targetContainers[0];
          var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);

          if (nextBlockedOn === null) {
            {
              var nativeEvent = queuedEvent.nativeEvent;
              var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
              setReplayingEvent(nativeEventClone);
              nativeEvent.target.dispatchEvent(nativeEventClone);
              resetReplayingEvent();
            }
          } else {
            var _fiber3 = getInstanceFromNode(nextBlockedOn);

            if (_fiber3 !== null) {
              attemptContinuousHydration(_fiber3);
            }

            queuedEvent.blockedOn = nextBlockedOn;
            return false;
          }

          targetContainers.shift();
        }

        return true;
      }

      function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) {
          map["delete"](key);
        }
      }

      function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;

        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) {
          queuedFocus = null;
        }

        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) {
          queuedDrag = null;
        }

        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) {
          queuedMouse = null;
        }

        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
      }

      function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
          queuedEvent.blockedOn = null;

          if (!hasScheduledReplayAttempt) {
            hasScheduledReplayAttempt = true;
            Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
          }
        }
      }

      function retryIfBlockedOn(unblocked) {
        if (queuedDiscreteEvents.length > 0) {
          scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked);

          for (var i = 1; i < queuedDiscreteEvents.length; i++) {
            var queuedEvent = queuedDiscreteEvents[i];

            if (queuedEvent.blockedOn === unblocked) {
              queuedEvent.blockedOn = null;
            }
          }
        }

        if (queuedFocus !== null) {
          scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        }

        if (queuedDrag !== null) {
          scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        }

        if (queuedMouse !== null) {
          scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        }

        var unblock = function unblock(queuedEvent) {
          return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };

        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);

        for (var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++) {
          var queuedTarget = queuedExplicitHydrationTargets[_i];

          if (queuedTarget.blockedOn === unblocked) {
            queuedTarget.blockedOn = null;
          }
        }

        while (queuedExplicitHydrationTargets.length > 0) {
          var nextExplicitTarget = queuedExplicitHydrationTargets[0];

          if (nextExplicitTarget.blockedOn !== null) {
            break;
          } else {
            attemptExplicitHydrationTarget(nextExplicitTarget);

            if (nextExplicitTarget.blockedOn === null) {
              queuedExplicitHydrationTargets.shift();
            }
          }
        }
      }

      var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
      var _enabled = true;

      function setEnabled(enabled) {
        _enabled = !!enabled;
      }

      function isEnabled() {
        return _enabled;
      }

      function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;

        switch (eventPriority) {
          case DiscreteEventPriority:
            listenerWrapper = dispatchDiscreteEvent;
            break;

          case ContinuousEventPriority:
            listenerWrapper = dispatchContinuousEvent;
            break;

          case DefaultEventPriority:
          default:
            listenerWrapper = dispatchEvent;
            break;
        }

        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
      }

      function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;

        try {
          setCurrentUpdatePriority(DiscreteEventPriority);
          dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig.transition = prevTransition;
        }
      }

      function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;

        try {
          setCurrentUpdatePriority(ContinuousEventPriority);
          dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig.transition = prevTransition;
        }
      }

      function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) {
          return;
        }

        {
          dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        }
      }

      function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);

        if (blockedOn === null) {
          dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
          clearIfContinuousEvent(domEventName, nativeEvent);
          return;
        }

        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
          nativeEvent.stopPropagation();
          return;
        }

        clearIfContinuousEvent(domEventName, nativeEvent);

        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
          while (blockedOn !== null) {
            var fiber = getInstanceFromNode(blockedOn);

            if (fiber !== null) {
              attemptSynchronousHydration(fiber);
            }

            var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);

            if (nextBlockedOn === null) {
              dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            }

            if (nextBlockedOn === blockedOn) {
              break;
            }

            blockedOn = nextBlockedOn;
          }

          if (blockedOn !== null) {
            nativeEvent.stopPropagation();
          }

          return;
        }

        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
      }

      var return_targetInst = null;

      function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);

        if (targetInst !== null) {
          var nearestMounted = getNearestMountedFiber(targetInst);

          if (nearestMounted === null) {
            targetInst = null;
          } else {
            var tag = nearestMounted.tag;

            if (tag === SuspenseComponent) {
              var instance = getSuspenseInstanceFromFiber(nearestMounted);

              if (instance !== null) {
                return instance;
              }

              targetInst = null;
            } else if (tag === HostRoot) {
              var root = nearestMounted.stateNode;

              if (isRootDehydrated(root)) {
                return getContainerFromFiber(nearestMounted);
              }

              targetInst = null;
            } else if (nearestMounted !== targetInst) {
              targetInst = null;
            }
          }
        }

        return_targetInst = targetInst;
        return null;
      }

      function getEventPriority(domEventName) {
        switch (domEventName) {
          case 'cancel':
          case 'click':
          case 'close':
          case 'contextmenu':
          case 'copy':
          case 'cut':
          case 'auxclick':
          case 'dblclick':
          case 'dragend':
          case 'dragstart':
          case 'drop':
          case 'focusin':
          case 'focusout':
          case 'input':
          case 'invalid':
          case 'keydown':
          case 'keypress':
          case 'keyup':
          case 'mousedown':
          case 'mouseup':
          case 'paste':
          case 'pause':
          case 'play':
          case 'pointercancel':
          case 'pointerdown':
          case 'pointerup':
          case 'ratechange':
          case 'reset':
          case 'resize':
          case 'seeked':
          case 'submit':
          case 'touchcancel':
          case 'touchend':
          case 'touchstart':
          case 'volumechange':
          case 'change':
          case 'selectionchange':
          case 'textInput':
          case 'compositionstart':
          case 'compositionend':
          case 'compositionupdate':
          case 'beforeblur':
          case 'afterblur':
          case 'beforeinput':
          case 'blur':
          case 'fullscreenchange':
          case 'focus':
          case 'hashchange':
          case 'popstate':
          case 'select':
          case 'selectstart':
            return DiscreteEventPriority;

          case 'drag':
          case 'dragenter':
          case 'dragexit':
          case 'dragleave':
          case 'dragover':
          case 'mousemove':
          case 'mouseout':
          case 'mouseover':
          case 'pointermove':
          case 'pointerout':
          case 'pointerover':
          case 'scroll':
          case 'toggle':
          case 'touchmove':
          case 'wheel':
          case 'mouseenter':
          case 'mouseleave':
          case 'pointerenter':
          case 'pointerleave':
            return ContinuousEventPriority;

          case 'message':
            {
              var schedulerPriority = getCurrentPriorityLevel();

              switch (schedulerPriority) {
                case ImmediatePriority:
                  return DiscreteEventPriority;

                case UserBlockingPriority:
                  return ContinuousEventPriority;

                case NormalPriority:
                case LowPriority:
                  return DefaultEventPriority;

                case IdlePriority:
                  return IdleEventPriority;

                default:
                  return DefaultEventPriority;
              }
            }

          default:
            return DefaultEventPriority;
        }
      }

      function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
      }

      function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
      }

      function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
          capture: true,
          passive: passive
        });
        return listener;
      }

      function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
          passive: passive
        });
        return listener;
      }

      var root = null;
      var startText = null;
      var fallbackText = null;

      function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
      }

      function reset() {
        root = null;
        startText = null;
        fallbackText = null;
      }

      function getData() {
        if (fallbackText) {
          return fallbackText;
        }

        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;

        for (start = 0; start < startLength; start++) {
          if (startValue[start] !== endValue[start]) {
            break;
          }
        }

        var minEnd = startLength - start;

        for (end = 1; end <= minEnd; end++) {
          if (startValue[startLength - end] !== endValue[endLength - end]) {
            break;
          }
        }

        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
      }

      function getText() {
        if ('value' in root) {
          return root.value;
        }

        return root.textContent;
      }

      function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;

        if ('charCode' in nativeEvent) {
          charCode = nativeEvent.charCode;

          if (charCode === 0 && keyCode === 13) {
            charCode = 13;
          }
        } else {
          charCode = keyCode;
        }

        if (charCode === 10) {
          charCode = 13;
        }

        if (charCode >= 32 || charCode === 13) {
          return charCode;
        }

        return 0;
      }

      function functionThatReturnsTrue() {
        return true;
      }

      function functionThatReturnsFalse() {
        return false;
      }

      function createSyntheticEvent(Interface) {
        function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
          this._reactName = reactName;
          this._targetInst = targetInst;
          this.type = reactEventType;
          this.nativeEvent = nativeEvent;
          this.target = nativeEventTarget;
          this.currentTarget = null;

          for (var _propName in Interface) {
            if (!Interface.hasOwnProperty(_propName)) {
              continue;
            }

            var normalize = Interface[_propName];

            if (normalize) {
              this[_propName] = normalize(nativeEvent);
            } else {
              this[_propName] = nativeEvent[_propName];
            }
          }

          var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;

          if (defaultPrevented) {
            this.isDefaultPrevented = functionThatReturnsTrue;
          } else {
            this.isDefaultPrevented = functionThatReturnsFalse;
          }

          this.isPropagationStopped = functionThatReturnsFalse;
          return this;
        }

        assign(SyntheticBaseEvent.prototype, {
          preventDefault: function preventDefault() {
            this.defaultPrevented = true;
            var event = this.nativeEvent;

            if (!event) {
              return;
            }

            if (event.preventDefault) {
              event.preventDefault();
            } else if (typeof event.returnValue !== 'unknown') {
              event.returnValue = false;
            }

            this.isDefaultPrevented = functionThatReturnsTrue;
          },
          stopPropagation: function stopPropagation() {
            var event = this.nativeEvent;

            if (!event) {
              return;
            }

            if (event.stopPropagation) {
              event.stopPropagation();
            } else if (typeof event.cancelBubble !== 'unknown') {
              event.cancelBubble = true;
            }

            this.isPropagationStopped = functionThatReturnsTrue;
          },
          persist: function persist() {},
          isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
      }

      var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function timeStamp(event) {
          return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
      };
      var SyntheticEvent = createSyntheticEvent(EventInterface);
      var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
      });
      var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
      var lastMovementX;
      var lastMovementY;
      var lastMouseEvent;

      function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
          if (lastMouseEvent && event.type === 'mousemove') {
            lastMovementX = event.screenX - lastMouseEvent.screenX;
            lastMovementY = event.screenY - lastMouseEvent.screenY;
          } else {
            lastMovementX = 0;
            lastMovementY = 0;
          }

          lastMouseEvent = event;
        }
      }

      var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function relatedTarget(event) {
          if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
          return event.relatedTarget;
        },
        movementX: function movementX(event) {
          if ('movementX' in event) {
            return event.movementX;
          }

          updateMouseMovementPolyfillState(event);
          return lastMovementX;
        },
        movementY: function movementY(event) {
          if ('movementY' in event) {
            return event.movementY;
          }

          return lastMovementY;
        }
      });
      var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
      var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
      });
      var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
      var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
      });
      var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
      var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      });
      var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
      var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function clipboardData(event) {
          return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
        }
      });
      var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
      var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
      });
      var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
      var SyntheticInputEvent = SyntheticCompositionEvent;
      var normalizeKey = {
        Esc: 'Escape',
        Spacebar: ' ',
        Left: 'ArrowLeft',
        Up: 'ArrowUp',
        Right: 'ArrowRight',
        Down: 'ArrowDown',
        Del: 'Delete',
        Win: 'OS',
        Menu: 'ContextMenu',
        Apps: 'ContextMenu',
        Scroll: 'ScrollLock',
        MozPrintableKey: 'Unidentified'
      };
      var translateToKey = {
        '8': 'Backspace',
        '9': 'Tab',
        '12': 'Clear',
        '13': 'Enter',
        '16': 'Shift',
        '17': 'Control',
        '18': 'Alt',
        '19': 'Pause',
        '20': 'CapsLock',
        '27': 'Escape',
        '32': ' ',
        '33': 'PageUp',
        '34': 'PageDown',
        '35': 'End',
        '36': 'Home',
        '37': 'ArrowLeft',
        '38': 'ArrowUp',
        '39': 'ArrowRight',
        '40': 'ArrowDown',
        '45': 'Insert',
        '46': 'Delete',
        '112': 'F1',
        '113': 'F2',
        '114': 'F3',
        '115': 'F4',
        '116': 'F5',
        '117': 'F6',
        '118': 'F7',
        '119': 'F8',
        '120': 'F9',
        '121': 'F10',
        '122': 'F11',
        '123': 'F12',
        '144': 'NumLock',
        '145': 'ScrollLock',
        '224': 'Meta'
      };

      function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
          var key = normalizeKey[nativeEvent.key] || nativeEvent.key;

          if (key !== 'Unidentified') {
            return key;
          }
        }

        if (nativeEvent.type === 'keypress') {
          var charCode = getEventCharCode(nativeEvent);
          return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
        }

        if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
          return translateToKey[nativeEvent.keyCode] || 'Unidentified';
        }

        return '';
      }

      var modifierKeyToProp = {
        Alt: 'altKey',
        Control: 'ctrlKey',
        Meta: 'metaKey',
        Shift: 'shiftKey'
      };

      function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;

        if (nativeEvent.getModifierState) {
          return nativeEvent.getModifierState(keyArg);
        }

        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
      }

      function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
      }

      var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        charCode: function charCode(event) {
          if (event.type === 'keypress') {
            return getEventCharCode(event);
          }

          return 0;
        },
        keyCode: function keyCode(event) {
          if (event.type === 'keydown' || event.type === 'keyup') {
            return event.keyCode;
          }

          return 0;
        },
        which: function which(event) {
          if (event.type === 'keypress') {
            return getEventCharCode(event);
          }

          if (event.type === 'keydown' || event.type === 'keyup') {
            return event.keyCode;
          }

          return 0;
        }
      });
      var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
      var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
      });
      var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
      var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
      });
      var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
      var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      });
      var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
      var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function deltaX(event) {
          return 'deltaX' in event ? event.deltaX : 'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function deltaY(event) {
          return 'deltaY' in event ? event.deltaY : 'wheelDeltaY' in event ? -event.wheelDeltaY : 'wheelDelta' in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        deltaMode: 0
      });
      var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
      var END_KEYCODES = [9, 13, 27, 32];
      var START_KEYCODE = 229;
      var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
      var documentMode = null;

      if (canUseDOM && 'documentMode' in document) {
        documentMode = document.documentMode;
      }

      var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode;
      var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
      var SPACEBAR_CODE = 32;
      var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

      function registerEvents() {
        registerTwoPhaseEvent('onBeforeInput', ['compositionend', 'keypress', 'textInput', 'paste']);
        registerTwoPhaseEvent('onCompositionEnd', ['compositionend', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
        registerTwoPhaseEvent('onCompositionStart', ['compositionstart', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
        registerTwoPhaseEvent('onCompositionUpdate', ['compositionupdate', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
      }

      var hasSpaceKeypress = false;

      function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && !(nativeEvent.ctrlKey && nativeEvent.altKey);
      }

      function getCompositionEventType(domEventName) {
        switch (domEventName) {
          case 'compositionstart':
            return 'onCompositionStart';

          case 'compositionend':
            return 'onCompositionEnd';

          case 'compositionupdate':
            return 'onCompositionUpdate';
        }
      }

      function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === 'keydown' && nativeEvent.keyCode === START_KEYCODE;
      }

      function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch (domEventName) {
          case 'keyup':
            return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;

          case 'keydown':
            return nativeEvent.keyCode !== START_KEYCODE;

          case 'keypress':
          case 'mousedown':
          case 'focusout':
            return true;

          default:
            return false;
        }
      }

      function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;

        if (typeof detail === 'object' && 'data' in detail) {
          return detail.data;
        }

        return null;
      }

      function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === 'ko';
      }

      var isComposing = false;

      function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;

        if (canUseCompositionEvent) {
          eventType = getCompositionEventType(domEventName);
        } else if (!isComposing) {
          if (isFallbackCompositionStart(domEventName, nativeEvent)) {
            eventType = 'onCompositionStart';
          }
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) {
          eventType = 'onCompositionEnd';
        }

        if (!eventType) {
          return null;
        }

        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
          if (!isComposing && eventType === 'onCompositionStart') {
            isComposing = initialize(nativeEventTarget);
          } else if (eventType === 'onCompositionEnd') {
            if (isComposing) {
              fallbackData = getData();
            }
          }
        }

        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);

        if (listeners.length > 0) {
          var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
          dispatchQueue.push({
            event: event,
            listeners: listeners
          });

          if (fallbackData) {
            event.data = fallbackData;
          } else {
            var customData = getDataFromCustomEvent(nativeEvent);

            if (customData !== null) {
              event.data = customData;
            }
          }
        }
      }

      function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch (domEventName) {
          case 'compositionend':
            return getDataFromCustomEvent(nativeEvent);

          case 'keypress':
            var which = nativeEvent.which;

            if (which !== SPACEBAR_CODE) {
              return null;
            }

            hasSpaceKeypress = true;
            return SPACEBAR_CHAR;

          case 'textInput':
            var chars = nativeEvent.data;

            if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
              return null;
            }

            return chars;

          default:
            return null;
        }
      }

      function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        if (isComposing) {
          if (domEventName === 'compositionend' || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
            var chars = getData();
            reset();
            isComposing = false;
            return chars;
          }

          return null;
        }

        switch (domEventName) {
          case 'paste':
            return null;

          case 'keypress':
            if (!isKeypressCommand(nativeEvent)) {
              if (nativeEvent["char"] && nativeEvent["char"].length > 1) {
                return nativeEvent["char"];
              } else if (nativeEvent.which) {
                return String.fromCharCode(nativeEvent.which);
              }
            }

            return null;

          case 'compositionend':
            return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;

          default:
            return null;
        }
      }

      function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;

        if (canUseTextInputEvent) {
          chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        } else {
          chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
        }

        if (!chars) {
          return null;
        }

        var listeners = accumulateTwoPhaseListeners(targetInst, 'onBeforeInput');

        if (listeners.length > 0) {
          var event = new SyntheticInputEvent('onBeforeInput', 'beforeinput', null, nativeEvent, nativeEventTarget);
          dispatchQueue.push({
            event: event,
            listeners: listeners
          });
          event.data = chars;
        }
      }

      function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
      }

      var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
      };

      function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

        if (nodeName === 'input') {
          return !!supportedInputTypes[elem.type];
        }

        if (nodeName === 'textarea') {
          return true;
        }

        return false;
      }

      function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) {
          return false;
        }

        var eventName = 'on' + eventNameSuffix;
        var isSupported = (eventName in document);

        if (!isSupported) {
          var element = document.createElement('div');
          element.setAttribute(eventName, 'return;');
          isSupported = typeof element[eventName] === 'function';
        }

        return isSupported;
      }

      function registerEvents$1() {
        registerTwoPhaseEvent('onChange', ['change', 'click', 'focusin', 'focusout', 'input', 'keydown', 'keyup', 'selectionchange']);
      }

      function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, 'onChange');

        if (listeners.length > 0) {
          var event = new SyntheticEvent('onChange', 'change', null, nativeEvent, target);
          dispatchQueue.push({
            event: event,
            listeners: listeners
          });
        }
      }

      var activeElement = null;
      var activeElementInst = null;

      function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
      }

      function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
        batchedUpdates(runEventInBatch, dispatchQueue);
      }

      function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
      }

      function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);

        if (updateValueIfChanged(targetNode)) {
          return targetInst;
        }
      }

      function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === 'change') {
          return targetInst;
        }
      }

      var isInputEventSupported = false;

      if (canUseDOM) {
        isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
      }

      function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent('onpropertychange', handlePropertyChange);
      }

      function stopWatchingForValueChange() {
        if (!activeElement) {
          return;
        }

        activeElement.detachEvent('onpropertychange', handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
      }

      function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== 'value') {
          return;
        }

        if (getInstIfValueChanged(activeElementInst)) {
          manualDispatchChangeEvent(nativeEvent);
        }
      }

      function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === 'focusin') {
          stopWatchingForValueChange();
          startWatchingForValueChange(target, targetInst);
        } else if (domEventName === 'focusout') {
          stopWatchingForValueChange();
        }
      }

      function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === 'selectionchange' || domEventName === 'keyup' || domEventName === 'keydown') {
          return getInstIfValueChanged(activeElementInst);
        }
      }

      function shouldUseClickEvent(elem) {
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
      }

      function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === 'click') {
          return getInstIfValueChanged(targetInst);
        }
      }

      function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === 'input' || domEventName === 'change') {
          return getInstIfValueChanged(targetInst);
        }
      }

      function handleControlledInputBlur(node) {
        var state = node._wrapperState;

        if (!state || !state.controlled || node.type !== 'number') {
          return;
        }

        {
          setDefaultValue(node, 'number', node.value);
        }
      }

      function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;

        if (shouldUseChangeEvent(targetNode)) {
          getTargetInstFunc = getTargetInstForChangeEvent;
        } else if (isTextInputElement(targetNode)) {
          if (isInputEventSupported) {
            getTargetInstFunc = getTargetInstForInputOrChangeEvent;
          } else {
            getTargetInstFunc = getTargetInstForInputEventPolyfill;
            handleEventFunc = handleEventsForInputEventPolyfill;
          }
        } else if (shouldUseClickEvent(targetNode)) {
          getTargetInstFunc = getTargetInstForClickEvent;
        }

        if (getTargetInstFunc) {
          var inst = getTargetInstFunc(domEventName, targetInst);

          if (inst) {
            createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
            return;
          }
        }

        if (handleEventFunc) {
          handleEventFunc(domEventName, targetNode, targetInst);
        }

        if (domEventName === 'focusout') {
          handleControlledInputBlur(targetNode);
        }
      }

      function registerEvents$2() {
        registerDirectEvent('onMouseEnter', ['mouseout', 'mouseover']);
        registerDirectEvent('onMouseLeave', ['mouseout', 'mouseover']);
        registerDirectEvent('onPointerEnter', ['pointerout', 'pointerover']);
        registerDirectEvent('onPointerLeave', ['pointerout', 'pointerover']);
      }

      function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === 'mouseover' || domEventName === 'pointerover';
        var isOutEvent = domEventName === 'mouseout' || domEventName === 'pointerout';

        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
          var related = nativeEvent.relatedTarget || nativeEvent.fromElement;

          if (related) {
            if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) {
              return;
            }
          }
        }

        if (!isOutEvent && !isOverEvent) {
          return;
        }

        var win;

        if (nativeEventTarget.window === nativeEventTarget) {
          win = nativeEventTarget;
        } else {
          var doc = nativeEventTarget.ownerDocument;

          if (doc) {
            win = doc.defaultView || doc.parentWindow;
          } else {
            win = window;
          }
        }

        var from;
        var to;

        if (isOutEvent) {
          var _related = nativeEvent.relatedTarget || nativeEvent.toElement;

          from = targetInst;
          to = _related ? getClosestInstanceFromNode(_related) : null;

          if (to !== null) {
            var nearestMounted = getNearestMountedFiber(to);

            if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) {
              to = null;
            }
          }
        } else {
          from = null;
          to = targetInst;
        }

        if (from === to) {
          return;
        }

        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = 'onMouseLeave';
        var enterEventType = 'onMouseEnter';
        var eventTypePrefix = 'mouse';

        if (domEventName === 'pointerout' || domEventName === 'pointerover') {
          SyntheticEventCtor = SyntheticPointerEvent;
          leaveEventType = 'onPointerLeave';
          enterEventType = 'onPointerEnter';
          eventTypePrefix = 'pointer';
        }

        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + 'leave', from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null;
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);

        if (nativeTargetInst === targetInst) {
          var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + 'enter', to, nativeEvent, nativeEventTarget);
          enterEvent.target = toNode;
          enterEvent.relatedTarget = fromNode;
          enter = enterEvent;
        }

        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
      }

      function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
      }

      var objectIs = typeof Object.is === 'function' ? Object.is : is;

      function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) {
          return true;
        }

        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
          return false;
        }

        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);

        if (keysA.length !== keysB.length) {
          return false;
        }

        for (var i = 0; i < keysA.length; i++) {
          var currentKey = keysA[i];

          if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) {
            return false;
          }
        }

        return true;
      }

      function getLeafNode(node) {
        while (node && node.firstChild) {
          node = node.firstChild;
        }

        return node;
      }

      function getSiblingNode(node) {
        while (node) {
          if (node.nextSibling) {
            return node.nextSibling;
          }

          node = node.parentNode;
        }
      }

      function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;

        while (node) {
          if (node.nodeType === TEXT_NODE) {
            nodeEnd = nodeStart + node.textContent.length;

            if (nodeStart <= offset && nodeEnd >= offset) {
              return {
                node: node,
                offset: offset - nodeStart
              };
            }

            nodeStart = nodeEnd;
          }

          node = getLeafNode(getSiblingNode(node));
        }
      }

      function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();

        if (!selection || selection.rangeCount === 0) {
          return null;
        }

        var anchorNode = selection.anchorNode,
            anchorOffset = selection.anchorOffset,
            focusNode = selection.focusNode,
            focusOffset = selection.focusOffset;

        try {
          anchorNode.nodeType;
          focusNode.nodeType;
        } catch (e) {
          return null;
        }

        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
      }

      function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;

        outer: while (true) {
          var next = null;

          while (true) {
            if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) {
              start = length + anchorOffset;
            }

            if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) {
              end = length + focusOffset;
            }

            if (node.nodeType === TEXT_NODE) {
              length += node.nodeValue.length;
            }

            if ((next = node.firstChild) === null) {
              break;
            }

            parentNode = node;
            node = next;
          }

          while (true) {
            if (node === outerNode) {
              break outer;
            }

            if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) {
              start = length;
            }

            if (parentNode === focusNode && ++indexWithinFocus === focusOffset) {
              end = length;
            }

            if ((next = node.nextSibling) !== null) {
              break;
            }

            node = parentNode;
            parentNode = node.parentNode;
          }

          node = next;
        }

        if (start === -1 || end === -1) {
          return null;
        }

        return {
          start: start,
          end: end
        };
      }

      function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window;

        if (!win.getSelection) {
          return;
        }

        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

        if (!selection.extend && start > end) {
          var temp = end;
          end = start;
          start = temp;
        }

        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);

        if (startMarker && endMarker) {
          if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) {
            return;
          }

          var range = doc.createRange();
          range.setStart(startMarker.node, startMarker.offset);
          selection.removeAllRanges();

          if (start > end) {
            selection.addRange(range);
            selection.extend(endMarker.node, endMarker.offset);
          } else {
            range.setEnd(endMarker.node, endMarker.offset);
            selection.addRange(range);
          }
        }
      }

      function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
      }

      function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) {
          return false;
        } else if (outerNode === innerNode) {
          return true;
        } else if (isTextNode(outerNode)) {
          return false;
        } else if (isTextNode(innerNode)) {
          return containsNode(outerNode, innerNode.parentNode);
        } else if ('contains' in outerNode) {
          return outerNode.contains(innerNode);
        } else if (outerNode.compareDocumentPosition) {
          return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        } else {
          return false;
        }
      }

      function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
      }

      function isSameOriginFrame(iframe) {
        try {
          return typeof iframe.contentWindow.location.href === 'string';
        } catch (err) {
          return false;
        }
      }

      function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();

        while (element instanceof win.HTMLIFrameElement) {
          if (isSameOriginFrame(element)) {
            win = element.contentWindow;
          } else {
            return element;
          }

          element = getActiveElement(win.document);
        }

        return element;
      }

      function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
      }

      function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
          focusedElem: focusedElem,
          selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
      }

      function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;

        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
          if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) {
            setSelection(priorFocusedElem, priorSelectionRange);
          }

          var ancestors = [];
          var ancestor = priorFocusedElem;

          while (ancestor = ancestor.parentNode) {
            if (ancestor.nodeType === ELEMENT_NODE) {
              ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
              });
            }
          }

          if (typeof priorFocusedElem.focus === 'function') {
            priorFocusedElem.focus();
          }

          for (var i = 0; i < ancestors.length; i++) {
            var info = ancestors[i];
            info.element.scrollLeft = info.left;
            info.element.scrollTop = info.top;
          }
        }
      }

      function getSelection(input) {
        var selection;

        if ('selectionStart' in input) {
          selection = {
            start: input.selectionStart,
            end: input.selectionEnd
          };
        } else {
          selection = getOffsets(input);
        }

        return selection || {
          start: 0,
          end: 0
        };
      }

      function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;

        if (end === undefined) {
          end = start;
        }

        if ('selectionStart' in input) {
          input.selectionStart = start;
          input.selectionEnd = Math.min(end, input.value.length);
        } else {
          setOffsets(input, offsets);
        }
      }

      var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;

      function registerEvents$3() {
        registerTwoPhaseEvent('onSelect', ['focusout', 'contextmenu', 'dragend', 'focusin', 'keydown', 'keyup', 'mousedown', 'mouseup', 'selectionchange']);
      }

      var activeElement$1 = null;
      var activeElementInst$1 = null;
      var lastSelection = null;
      var mouseDown = false;

      function getSelection$1(node) {
        if ('selectionStart' in node && hasSelectionCapabilities(node)) {
          return {
            start: node.selectionStart,
            end: node.selectionEnd
          };
        } else {
          var win = node.ownerDocument && node.ownerDocument.defaultView || window;
          var selection = win.getSelection();
          return {
            anchorNode: selection.anchorNode,
            anchorOffset: selection.anchorOffset,
            focusNode: selection.focusNode,
            focusOffset: selection.focusOffset
          };
        }
      }

      function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
      }

      function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        var doc = getEventTargetDocument(nativeEventTarget);

        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) {
          return;
        }

        var currentSelection = getSelection$1(activeElement$1);

        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
          lastSelection = currentSelection;
          var listeners = accumulateTwoPhaseListeners(activeElementInst$1, 'onSelect');

          if (listeners.length > 0) {
            var event = new SyntheticEvent('onSelect', 'select', null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
              event: event,
              listeners: listeners
            });
            event.target = activeElement$1;
          }
        }
      }

      function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;

        switch (domEventName) {
          case 'focusin':
            if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
              activeElement$1 = targetNode;
              activeElementInst$1 = targetInst;
              lastSelection = null;
            }

            break;

          case 'focusout':
            activeElement$1 = null;
            activeElementInst$1 = null;
            lastSelection = null;
            break;

          case 'mousedown':
            mouseDown = true;
            break;

          case 'contextmenu':
          case 'mouseup':
          case 'dragend':
            mouseDown = false;
            constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            break;

          case 'selectionchange':
            if (skipSelectionChangeEvent) {
              break;
            }

          case 'keydown':
          case 'keyup':
            constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
      }

      function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes['Webkit' + styleProp] = 'webkit' + eventName;
        prefixes['Moz' + styleProp] = 'moz' + eventName;
        return prefixes;
      }

      var vendorPrefixes = {
        animationend: makePrefixMap('Animation', 'AnimationEnd'),
        animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
        animationstart: makePrefixMap('Animation', 'AnimationStart'),
        transitionend: makePrefixMap('Transition', 'TransitionEnd')
      };
      var prefixedEventNames = {};
      var style = {};

      if (canUseDOM) {
        style = document.createElement('div').style;

        if (!('AnimationEvent' in window)) {
          delete vendorPrefixes.animationend.animation;
          delete vendorPrefixes.animationiteration.animation;
          delete vendorPrefixes.animationstart.animation;
        }

        if (!('TransitionEvent' in window)) {
          delete vendorPrefixes.transitionend.transition;
        }
      }

      function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) {
          return prefixedEventNames[eventName];
        } else if (!vendorPrefixes[eventName]) {
          return eventName;
        }

        var prefixMap = vendorPrefixes[eventName];

        for (var styleProp in prefixMap) {
          if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
            return prefixedEventNames[eventName] = prefixMap[styleProp];
          }
        }

        return eventName;
      }

      var ANIMATION_END = getVendorPrefixedEventName('animationend');
      var ANIMATION_ITERATION = getVendorPrefixedEventName('animationiteration');
      var ANIMATION_START = getVendorPrefixedEventName('animationstart');
      var TRANSITION_END = getVendorPrefixedEventName('transitionend');
      var topLevelEventsToReactNames = new Map();
      var simpleEventPluginEvents = ['abort', 'auxClick', 'cancel', 'canPlay', 'canPlayThrough', 'click', 'close', 'contextMenu', 'copy', 'cut', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'gotPointerCapture', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'lostPointerCapture', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'pointerCancel', 'pointerDown', 'pointerMove', 'pointerOut', 'pointerOver', 'pointerUp', 'progress', 'rateChange', 'reset', 'resize', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchStart', 'volumeChange', 'scroll', 'toggle', 'touchMove', 'waiting', 'wheel'];

      function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [domEventName]);
      }

      function registerSimpleEvents() {
        for (var i = 0; i < simpleEventPluginEvents.length; i++) {
          var eventName = simpleEventPluginEvents[i];
          var domEventName = eventName.toLowerCase();
          var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
          registerSimpleEvent(domEventName, 'on' + capitalizedEvent);
        }

        registerSimpleEvent(ANIMATION_END, 'onAnimationEnd');
        registerSimpleEvent(ANIMATION_ITERATION, 'onAnimationIteration');
        registerSimpleEvent(ANIMATION_START, 'onAnimationStart');
        registerSimpleEvent('dblclick', 'onDoubleClick');
        registerSimpleEvent('focusin', 'onFocus');
        registerSimpleEvent('focusout', 'onBlur');
        registerSimpleEvent(TRANSITION_END, 'onTransitionEnd');
      }

      function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);

        if (reactName === undefined) {
          return;
        }

        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;

        switch (domEventName) {
          case 'keypress':
            if (getEventCharCode(nativeEvent) === 0) {
              return;
            }

          case 'keydown':
          case 'keyup':
            SyntheticEventCtor = SyntheticKeyboardEvent;
            break;

          case 'focusin':
            reactEventType = 'focus';
            SyntheticEventCtor = SyntheticFocusEvent;
            break;

          case 'focusout':
            reactEventType = 'blur';
            SyntheticEventCtor = SyntheticFocusEvent;
            break;

          case 'beforeblur':
          case 'afterblur':
            SyntheticEventCtor = SyntheticFocusEvent;
            break;

          case 'click':
            if (nativeEvent.button === 2) {
              return;
            }

          case 'auxclick':
          case 'dblclick':
          case 'mousedown':
          case 'mousemove':
          case 'mouseup':
          case 'mouseout':
          case 'mouseover':
          case 'contextmenu':
            SyntheticEventCtor = SyntheticMouseEvent;
            break;

          case 'drag':
          case 'dragend':
          case 'dragenter':
          case 'dragexit':
          case 'dragleave':
          case 'dragover':
          case 'dragstart':
          case 'drop':
            SyntheticEventCtor = SyntheticDragEvent;
            break;

          case 'touchcancel':
          case 'touchend':
          case 'touchmove':
          case 'touchstart':
            SyntheticEventCtor = SyntheticTouchEvent;
            break;

          case ANIMATION_END:
          case ANIMATION_ITERATION:
          case ANIMATION_START:
            SyntheticEventCtor = SyntheticAnimationEvent;
            break;

          case TRANSITION_END:
            SyntheticEventCtor = SyntheticTransitionEvent;
            break;

          case 'scroll':
            SyntheticEventCtor = SyntheticUIEvent;
            break;

          case 'wheel':
            SyntheticEventCtor = SyntheticWheelEvent;
            break;

          case 'copy':
          case 'cut':
          case 'paste':
            SyntheticEventCtor = SyntheticClipboardEvent;
            break;

          case 'gotpointercapture':
          case 'lostpointercapture':
          case 'pointercancel':
          case 'pointerdown':
          case 'pointermove':
          case 'pointerout':
          case 'pointerover':
          case 'pointerup':
            SyntheticEventCtor = SyntheticPointerEvent;
            break;
        }

        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        {
          var accumulateTargetOnly = !inCapturePhase && domEventName === 'scroll';

          var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);

          if (_listeners.length > 0) {
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);

            dispatchQueue.push({
              event: _event,
              listeners: _listeners
            });
          }
        }
      }

      registerSimpleEvents();
      registerEvents$2();
      registerEvents$1();
      registerEvents$3();
      registerEvents();

      function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0;

        if (shouldProcessPolyfillPlugins) {
          extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
          extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
          extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
          extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
      }

      var mediaEventTypes = ['abort', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'encrypted', 'ended', 'error', 'loadeddata', 'loadedmetadata', 'loadstart', 'pause', 'play', 'playing', 'progress', 'ratechange', 'resize', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting'];
      var nonDelegatedEvents = new Set(['cancel', 'close', 'invalid', 'load', 'scroll', 'toggle'].concat(mediaEventTypes));

      function executeDispatch(event, listener, currentTarget) {
        var type = event.type || 'unknown-event';
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
      }

      function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;

        if (inCapturePhase) {
          for (var i = dispatchListeners.length - 1; i >= 0; i--) {
            var _dispatchListeners$i = dispatchListeners[i],
                instance = _dispatchListeners$i.instance,
                currentTarget = _dispatchListeners$i.currentTarget,
                listener = _dispatchListeners$i.listener;

            if (instance !== previousInstance && event.isPropagationStopped()) {
              return;
            }

            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
          }
        } else {
          for (var _i = 0; _i < dispatchListeners.length; _i++) {
            var _dispatchListeners$_i = dispatchListeners[_i],
                _instance = _dispatchListeners$_i.instance,
                _currentTarget = _dispatchListeners$_i.currentTarget,
                _listener = _dispatchListeners$_i.listener;

            if (_instance !== previousInstance && event.isPropagationStopped()) {
              return;
            }

            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
          }
        }
      }

      function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;

        for (var i = 0; i < dispatchQueue.length; i++) {
          var _dispatchQueue$i = dispatchQueue[i],
              event = _dispatchQueue$i.event,
              listeners = _dispatchQueue$i.listeners;
          processDispatchQueueItemsInOrder(event, listeners, inCapturePhase);
        }

        rethrowCaughtError();
      }

      function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
      }

      function listenToNonDelegatedEvent(domEventName, targetElement) {
        {
          if (!nonDelegatedEvents.has(domEventName)) {
            error('Did not expect a listenToNonDelegatedEvent() call for "%s". ' + 'This is a bug in React. Please file an issue.', domEventName);
          }
        }
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);

        if (!listenerSet.has(listenerSetKey)) {
          addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
          listenerSet.add(listenerSetKey);
        }
      }

      function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        {
          if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) {
            error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. ' + 'This is a bug in React. Please file an issue.', domEventName);
          }
        }
        var eventSystemFlags = 0;

        if (isCapturePhaseListener) {
          eventSystemFlags |= IS_CAPTURE_PHASE;
        }

        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
      }

      var listeningMarker = '_reactListening' + Math.random().toString(36).slice(2);

      function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
          rootContainerElement[listeningMarker] = true;
          allNativeEvents.forEach(function (domEventName) {
            if (domEventName !== 'selectionchange') {
              if (!nonDelegatedEvents.has(domEventName)) {
                listenToNativeEvent(domEventName, false, rootContainerElement);
              }

              listenToNativeEvent(domEventName, true, rootContainerElement);
            }
          });
          var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;

          if (ownerDocument !== null) {
            if (!ownerDocument[listeningMarker]) {
              ownerDocument[listeningMarker] = true;
              listenToNativeEvent('selectionchange', false, ownerDocument);
            }
          }
        }
      }

      function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags);
        var isPassiveListener = undefined;

        if (passiveBrowserEventsSupported) {
          if (domEventName === 'touchstart' || domEventName === 'touchmove' || domEventName === 'wheel') {
            isPassiveListener = true;
          }
        }

        targetContainer = targetContainer;
        var unsubscribeListener;

        if (isCapturePhaseListener) {
          if (isPassiveListener !== undefined) {
            unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
          } else {
            unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
          }
        } else {
          if (isPassiveListener !== undefined) {
            unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
          } else {
            unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
          }
        }
      }

      function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
      }

      function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;

        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
          var targetContainerNode = targetContainer;

          if (targetInst !== null) {
            var node = targetInst;

            mainLoop: while (true) {
              if (node === null) {
                return;
              }

              var nodeTag = node.tag;

              if (nodeTag === HostRoot || nodeTag === HostPortal) {
                var container = node.stateNode.containerInfo;

                if (isMatchingRootContainer(container, targetContainerNode)) {
                  break;
                }

                if (nodeTag === HostPortal) {
                  var grandNode = node["return"];

                  while (grandNode !== null) {
                    var grandTag = grandNode.tag;

                    if (grandTag === HostRoot || grandTag === HostPortal) {
                      var grandContainer = grandNode.stateNode.containerInfo;

                      if (isMatchingRootContainer(grandContainer, targetContainerNode)) {
                        return;
                      }
                    }

                    grandNode = grandNode["return"];
                  }
                }

                while (container !== null) {
                  var parentNode = getClosestInstanceFromNode(container);

                  if (parentNode === null) {
                    return;
                  }

                  var parentTag = parentNode.tag;

                  if (parentTag === HostComponent || parentTag === HostText) {
                    node = ancestorInst = parentNode;
                    continue mainLoop;
                  }

                  container = container.parentNode;
                }
              }

              node = node["return"];
            }
          }
        }

        batchedUpdates(function () {
          return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
      }

      function createDispatchListener(instance, listener, currentTarget) {
        return {
          instance: instance,
          listener: listener,
          currentTarget: currentTarget
        };
      }

      function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + 'Capture' : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null;

        while (instance !== null) {
          var _instance2 = instance,
              stateNode = _instance2.stateNode,
              tag = _instance2.tag;

          if (tag === HostComponent && stateNode !== null) {
            lastHostComponent = stateNode;

            if (reactEventName !== null) {
              var listener = getListener(instance, reactEventName);

              if (listener != null) {
                listeners.push(createDispatchListener(instance, listener, lastHostComponent));
              }
            }
          }

          if (accumulateTargetOnly) {
            break;
          }

          instance = instance["return"];
        }

        return listeners;
      }

      function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + 'Capture';
        var listeners = [];
        var instance = targetFiber;

        while (instance !== null) {
          var _instance3 = instance,
              stateNode = _instance3.stateNode,
              tag = _instance3.tag;

          if (tag === HostComponent && stateNode !== null) {
            var currentTarget = stateNode;
            var captureListener = getListener(instance, captureName);

            if (captureListener != null) {
              listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
            }

            var bubbleListener = getListener(instance, reactName);

            if (bubbleListener != null) {
              listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
          }

          instance = instance["return"];
        }

        return listeners;
      }

      function getParent(inst) {
        if (inst === null) {
          return null;
        }

        do {
          inst = inst["return"];
        } while (inst && inst.tag !== HostComponent);

        if (inst) {
          return inst;
        }

        return null;
      }

      function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;

        for (var tempA = nodeA; tempA; tempA = getParent(tempA)) {
          depthA++;
        }

        var depthB = 0;

        for (var tempB = nodeB; tempB; tempB = getParent(tempB)) {
          depthB++;
        }

        while (depthA - depthB > 0) {
          nodeA = getParent(nodeA);
          depthA--;
        }

        while (depthB - depthA > 0) {
          nodeB = getParent(nodeB);
          depthB--;
        }

        var depth = depthA;

        while (depth--) {
          if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) {
            return nodeA;
          }

          nodeA = getParent(nodeA);
          nodeB = getParent(nodeB);
        }

        return null;
      }

      function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;

        while (instance !== null) {
          if (instance === common) {
            break;
          }

          var _instance4 = instance,
              alternate = _instance4.alternate,
              stateNode = _instance4.stateNode,
              tag = _instance4.tag;

          if (alternate !== null && alternate === common) {
            break;
          }

          if (tag === HostComponent && stateNode !== null) {
            var currentTarget = stateNode;

            if (inCapturePhase) {
              var captureListener = getListener(instance, registrationName);

              if (captureListener != null) {
                listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
              }
            } else if (!inCapturePhase) {
              var bubbleListener = getListener(instance, registrationName);

              if (bubbleListener != null) {
                listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
              }
            }
          }

          instance = instance["return"];
        }

        if (listeners.length !== 0) {
          dispatchQueue.push({
            event: event,
            listeners: listeners
          });
        }
      }

      function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;

        if (from !== null) {
          accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        }

        if (to !== null && enterEvent !== null) {
          accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
        }
      }

      function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? 'capture' : 'bubble');
      }

      var didWarnInvalidHydration = false;
      var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
      var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
      var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
      var AUTOFOCUS = 'autoFocus';
      var CHILDREN = 'children';
      var STYLE = 'style';
      var HTML$1 = '__html';
      var warnedUnknownTags;
      var validatePropertiesInDevelopment;
      var warnForPropDifference;
      var warnForExtraAttributes;
      var warnForInvalidEventListener;
      var canDiffStyleForHydrationWarning;
      var normalizeHTML;
      {
        warnedUnknownTags = {
          dialog: true,
          webview: true
        };

        validatePropertiesInDevelopment = function validatePropertiesInDevelopment(type, props) {
          validateProperties(type, props);
          validateProperties$1(type, props);
          validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
          });
        };

        canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;

        warnForPropDifference = function warnForPropDifference(propName, serverValue, clientValue) {
          if (didWarnInvalidHydration) {
            return;
          }

          var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
          var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);

          if (normalizedServerValue === normalizedClientValue) {
            return;
          }

          didWarnInvalidHydration = true;
          error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
        };

        warnForExtraAttributes = function warnForExtraAttributes(attributeNames) {
          if (didWarnInvalidHydration) {
            return;
          }

          didWarnInvalidHydration = true;
          var names = [];
          attributeNames.forEach(function (name) {
            names.push(name);
          });
          error('Extra attributes from the server: %s', names);
        };

        warnForInvalidEventListener = function warnForInvalidEventListener(registrationName, listener) {
          if (listener === false) {
            error('Expected `%s` listener to be a function, instead got `false`.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', registrationName, registrationName, registrationName);
          } else {
            error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
          }
        };

        normalizeHTML = function normalizeHTML(parent, html) {
          var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
          testElement.innerHTML = html;
          return testElement.innerHTML;
        };
      }
      var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
      var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;

      function normalizeMarkupForTextOrAttribute(markup) {
        {
          checkHtmlStringCoercion(markup);
        }
        var markupString = typeof markup === 'string' ? markup : '' + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
      }

      function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);

        if (normalizedServerText === normalizedClientText) {
          return;
        }

        if (shouldWarnDev) {
          {
            if (!didWarnInvalidHydration) {
              didWarnInvalidHydration = true;
              error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
          }
        }

        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) {
          throw new Error('Text content does not match server-rendered HTML.');
        }
      }

      function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
      }

      function noop() {}

      function trapClickOnNonInteractiveElement(node) {
        node.onclick = noop;
      }

      function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for (var propKey in nextProps) {
          if (!nextProps.hasOwnProperty(propKey)) {
            continue;
          }

          var nextProp = nextProps[propKey];

          if (propKey === STYLE) {
            {
              if (nextProp) {
                Object.freeze(nextProp);
              }
            }
            setValueForStyles(domElement, nextProp);
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
            var nextHtml = nextProp ? nextProp[HTML$1] : undefined;

            if (nextHtml != null) {
              setInnerHTML(domElement, nextHtml);
            }
          } else if (propKey === CHILDREN) {
            if (typeof nextProp === 'string') {
              var canSetTextContent = tag !== 'textarea' || nextProp !== '';

              if (canSetTextContent) {
                setTextContent(domElement, nextProp);
              }
            } else if (typeof nextProp === 'number') {
              setTextContent(domElement, '' + nextProp);
            }
          } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (propKey === AUTOFOCUS) ;else if (registrationNameDependencies.hasOwnProperty(propKey)) {
            if (nextProp != null) {
              if (typeof nextProp !== 'function') {
                warnForInvalidEventListener(propKey, nextProp);
              }

              if (propKey === 'onScroll') {
                listenToNonDelegatedEvent('scroll', domElement);
              }
            }
          } else if (nextProp != null) {
            setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
          }
        }
      }

      function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        for (var i = 0; i < updatePayload.length; i += 2) {
          var propKey = updatePayload[i];
          var propValue = updatePayload[i + 1];

          if (propKey === STYLE) {
            setValueForStyles(domElement, propValue);
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
            setInnerHTML(domElement, propValue);
          } else if (propKey === CHILDREN) {
            setTextContent(domElement, propValue);
          } else {
            setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
          }
        }
      }

      function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag;
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;

        if (namespaceURI === HTML_NAMESPACE) {
          namespaceURI = getIntrinsicNamespace(type);
        }

        if (namespaceURI === HTML_NAMESPACE) {
          {
            isCustomComponentTag = isCustomComponent(type, props);

            if (!isCustomComponentTag && type !== type.toLowerCase()) {
              error('<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', type);
            }
          }

          if (type === 'script') {
            var div = ownerDocument.createElement('div');
            div.innerHTML = '<script><' + '/script>';
            var firstChild = div.firstChild;
            domElement = div.removeChild(firstChild);
          } else if (typeof props.is === 'string') {
            domElement = ownerDocument.createElement(type, {
              is: props.is
            });
          } else {
            domElement = ownerDocument.createElement(type);

            if (type === 'select') {
              var node = domElement;

              if (props.multiple) {
                node.multiple = true;
              } else if (props.size) {
                node.size = props.size;
              }
            }
          }
        } else {
          domElement = ownerDocument.createElementNS(namespaceURI, type);
        }

        {
          if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !hasOwnProperty.call(warnedUnknownTags, type)) {
              warnedUnknownTags[type] = true;
              error('The tag <%s> is unrecognized in this browser. ' + 'If you meant to render a React component, start its name with ' + 'an uppercase letter.', type);
            }
          }
        }
        return domElement;
      }

      function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
      }

      function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        {
          validatePropertiesInDevelopment(tag, rawProps);
        }
        var props;

        switch (tag) {
          case 'dialog':
            listenToNonDelegatedEvent('cancel', domElement);
            listenToNonDelegatedEvent('close', domElement);
            props = rawProps;
            break;

          case 'iframe':
          case 'object':
          case 'embed':
            listenToNonDelegatedEvent('load', domElement);
            props = rawProps;
            break;

          case 'video':
          case 'audio':
            for (var i = 0; i < mediaEventTypes.length; i++) {
              listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
            }

            props = rawProps;
            break;

          case 'source':
            listenToNonDelegatedEvent('error', domElement);
            props = rawProps;
            break;

          case 'img':
          case 'image':
          case 'link':
            listenToNonDelegatedEvent('error', domElement);
            listenToNonDelegatedEvent('load', domElement);
            props = rawProps;
            break;

          case 'details':
            listenToNonDelegatedEvent('toggle', domElement);
            props = rawProps;
            break;

          case 'input':
            initWrapperState(domElement, rawProps);
            props = getHostProps(domElement, rawProps);
            listenToNonDelegatedEvent('invalid', domElement);
            break;

          case 'option':
            validateProps(domElement, rawProps);
            props = rawProps;
            break;

          case 'select':
            initWrapperState$1(domElement, rawProps);
            props = getHostProps$1(domElement, rawProps);
            listenToNonDelegatedEvent('invalid', domElement);
            break;

          case 'textarea':
            initWrapperState$2(domElement, rawProps);
            props = getHostProps$2(domElement, rawProps);
            listenToNonDelegatedEvent('invalid', domElement);
            break;

          default:
            props = rawProps;
        }

        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);

        switch (tag) {
          case 'input':
            track(domElement);
            postMountWrapper(domElement, rawProps, false);
            break;

          case 'textarea':
            track(domElement);
            postMountWrapper$3(domElement);
            break;

          case 'option':
            postMountWrapper$1(domElement, rawProps);
            break;

          case 'select':
            postMountWrapper$2(domElement, rawProps);
            break;

          default:
            if (typeof props.onClick === 'function') {
              trapClickOnNonInteractiveElement(domElement);
            }

            break;
        }
      }

      function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        {
          validatePropertiesInDevelopment(tag, nextRawProps);
        }
        var updatePayload = null;
        var lastProps;
        var nextProps;

        switch (tag) {
          case 'input':
            lastProps = getHostProps(domElement, lastRawProps);
            nextProps = getHostProps(domElement, nextRawProps);
            updatePayload = [];
            break;

          case 'select':
            lastProps = getHostProps$1(domElement, lastRawProps);
            nextProps = getHostProps$1(domElement, nextRawProps);
            updatePayload = [];
            break;

          case 'textarea':
            lastProps = getHostProps$2(domElement, lastRawProps);
            nextProps = getHostProps$2(domElement, nextRawProps);
            updatePayload = [];
            break;

          default:
            lastProps = lastRawProps;
            nextProps = nextRawProps;

            if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') {
              trapClickOnNonInteractiveElement(domElement);
            }

            break;
        }

        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;

        for (propKey in lastProps) {
          if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
            continue;
          }

          if (propKey === STYLE) {
            var lastStyle = lastProps[propKey];

            for (styleName in lastStyle) {
              if (lastStyle.hasOwnProperty(styleName)) {
                if (!styleUpdates) {
                  styleUpdates = {};
                }

                styleUpdates[styleName] = '';
              }
            }
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (propKey === AUTOFOCUS) ;else if (registrationNameDependencies.hasOwnProperty(propKey)) {
            if (!updatePayload) {
              updatePayload = [];
            }
          } else {
            (updatePayload = updatePayload || []).push(propKey, null);
          }
        }

        for (propKey in nextProps) {
          var nextProp = nextProps[propKey];
          var lastProp = lastProps != null ? lastProps[propKey] : undefined;

          if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
            continue;
          }

          if (propKey === STYLE) {
            {
              if (nextProp) {
                Object.freeze(nextProp);
              }
            }

            if (lastProp) {
              for (styleName in lastProp) {
                if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                  if (!styleUpdates) {
                    styleUpdates = {};
                  }

                  styleUpdates[styleName] = '';
                }
              }

              for (styleName in nextProp) {
                if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                  if (!styleUpdates) {
                    styleUpdates = {};
                  }

                  styleUpdates[styleName] = nextProp[styleName];
                }
              }
            } else {
              if (!styleUpdates) {
                if (!updatePayload) {
                  updatePayload = [];
                }

                updatePayload.push(propKey, styleUpdates);
              }

              styleUpdates = nextProp;
            }
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
            var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
            var lastHtml = lastProp ? lastProp[HTML$1] : undefined;

            if (nextHtml != null) {
              if (lastHtml !== nextHtml) {
                (updatePayload = updatePayload || []).push(propKey, nextHtml);
              }
            }
          } else if (propKey === CHILDREN) {
            if (typeof nextProp === 'string' || typeof nextProp === 'number') {
              (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
            }
          } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (registrationNameDependencies.hasOwnProperty(propKey)) {
            if (nextProp != null) {
              if (typeof nextProp !== 'function') {
                warnForInvalidEventListener(propKey, nextProp);
              }

              if (propKey === 'onScroll') {
                listenToNonDelegatedEvent('scroll', domElement);
              }
            }

            if (!updatePayload && lastProp !== nextProp) {
              updatePayload = [];
            }
          } else {
            (updatePayload = updatePayload || []).push(propKey, nextProp);
          }
        }

        if (styleUpdates) {
          {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
          }
          (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }

        return updatePayload;
      }

      function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) {
          updateChecked(domElement, nextRawProps);
        }

        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps);
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag);

        switch (tag) {
          case 'input':
            updateWrapper(domElement, nextRawProps);
            break;

          case 'textarea':
            updateWrapper$1(domElement, nextRawProps);
            break;

          case 'select':
            postUpdateWrapper(domElement, nextRawProps);
            break;
        }
      }

      function getPossibleStandardName(propName) {
        {
          var lowerCasedName = propName.toLowerCase();

          if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            return null;
          }

          return possibleStandardNames[lowerCasedName] || null;
        }
      }

      function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        {
          isCustomComponentTag = isCustomComponent(tag, rawProps);
          validatePropertiesInDevelopment(tag, rawProps);
        }

        switch (tag) {
          case 'dialog':
            listenToNonDelegatedEvent('cancel', domElement);
            listenToNonDelegatedEvent('close', domElement);
            break;

          case 'iframe':
          case 'object':
          case 'embed':
            listenToNonDelegatedEvent('load', domElement);
            break;

          case 'video':
          case 'audio':
            for (var i = 0; i < mediaEventTypes.length; i++) {
              listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
            }

            break;

          case 'source':
            listenToNonDelegatedEvent('error', domElement);
            break;

          case 'img':
          case 'image':
          case 'link':
            listenToNonDelegatedEvent('error', domElement);
            listenToNonDelegatedEvent('load', domElement);
            break;

          case 'details':
            listenToNonDelegatedEvent('toggle', domElement);
            break;

          case 'input':
            initWrapperState(domElement, rawProps);
            listenToNonDelegatedEvent('invalid', domElement);
            break;

          case 'option':
            validateProps(domElement, rawProps);
            break;

          case 'select':
            initWrapperState$1(domElement, rawProps);
            listenToNonDelegatedEvent('invalid', domElement);
            break;

          case 'textarea':
            initWrapperState$2(domElement, rawProps);
            listenToNonDelegatedEvent('invalid', domElement);
            break;
        }

        assertValidProps(tag, rawProps);
        {
          extraAttributeNames = new Set();
          var attributes = domElement.attributes;

          for (var _i = 0; _i < attributes.length; _i++) {
            var name = attributes[_i].name.toLowerCase();

            switch (name) {
              case 'value':
                break;

              case 'checked':
                break;

              case 'selected':
                break;

              default:
                extraAttributeNames.add(attributes[_i].name);
            }
          }
        }
        var updatePayload = null;

        for (var propKey in rawProps) {
          if (!rawProps.hasOwnProperty(propKey)) {
            continue;
          }

          var nextProp = rawProps[propKey];

          if (propKey === CHILDREN) {
            if (typeof nextProp === 'string') {
              if (domElement.textContent !== nextProp) {
                if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) {
                  checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                }

                updatePayload = [CHILDREN, nextProp];
              }
            } else if (typeof nextProp === 'number') {
              if (domElement.textContent !== '' + nextProp) {
                if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) {
                  checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                }

                updatePayload = [CHILDREN, '' + nextProp];
              }
            }
          } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
            if (nextProp != null) {
              if (typeof nextProp !== 'function') {
                warnForInvalidEventListener(propKey, nextProp);
              }

              if (propKey === 'onScroll') {
                listenToNonDelegatedEvent('scroll', domElement);
              }
            }
          } else if (shouldWarnDev && true && typeof isCustomComponentTag === 'boolean') {
            var serverValue = void 0;
            var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
            if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || propKey === 'value' || propKey === 'checked' || propKey === 'selected') ;else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              var serverHTML = domElement.innerHTML;
              var nextHtml = nextProp ? nextProp[HTML$1] : undefined;

              if (nextHtml != null) {
                var expectedHTML = normalizeHTML(domElement, nextHtml);

                if (expectedHTML !== serverHTML) {
                  warnForPropDifference(propKey, serverHTML, expectedHTML);
                }
              }
            } else if (propKey === STYLE) {
              extraAttributeNames["delete"](propKey);

              if (canDiffStyleForHydrationWarning) {
                var expectedStyle = createDangerousStringForStyles(nextProp);
                serverValue = domElement.getAttribute('style');

                if (expectedStyle !== serverValue) {
                  warnForPropDifference(propKey, serverValue, expectedStyle);
                }
              }
            } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
              extraAttributeNames["delete"](propKey.toLowerCase());
              serverValue = getValueForAttribute(domElement, propKey, nextProp);

              if (nextProp !== serverValue) {
                warnForPropDifference(propKey, serverValue, nextProp);
              }
            } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
              var isMismatchDueToBadCasing = false;

              if (propertyInfo !== null) {
                extraAttributeNames["delete"](propertyInfo.attributeName);
                serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
              } else {
                var ownNamespace = parentNamespace;

                if (ownNamespace === HTML_NAMESPACE) {
                  ownNamespace = getIntrinsicNamespace(tag);
                }

                if (ownNamespace === HTML_NAMESPACE) {
                  extraAttributeNames["delete"](propKey.toLowerCase());
                } else {
                  var standardName = getPossibleStandardName(propKey);

                  if (standardName !== null && standardName !== propKey) {
                    isMismatchDueToBadCasing = true;
                    extraAttributeNames["delete"](standardName);
                  }

                  extraAttributeNames["delete"](propKey);
                }

                serverValue = getValueForAttribute(domElement, propKey, nextProp);
              }

              var dontWarnCustomElement = enableCustomElementPropertySupport;

              if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) {
                warnForPropDifference(propKey, serverValue, nextProp);
              }
            }
          }
        }

        {
          if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) {
              warnForExtraAttributes(extraAttributeNames);
            }
          }
        }

        switch (tag) {
          case 'input':
            track(domElement);
            postMountWrapper(domElement, rawProps, true);
            break;

          case 'textarea':
            track(domElement);
            postMountWrapper$3(domElement);
            break;

          case 'select':
          case 'option':
            break;

          default:
            if (typeof rawProps.onClick === 'function') {
              trapClickOnNonInteractiveElement(domElement);
            }

            break;
        }

        return updatePayload;
      }

      function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
      }

      function warnForDeletedHydratableElement(parentNode, child) {
        {
          if (didWarnInvalidHydration) {
            return;
          }

          didWarnInvalidHydration = true;
          error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
        }
      }

      function warnForDeletedHydratableText(parentNode, child) {
        {
          if (didWarnInvalidHydration) {
            return;
          }

          didWarnInvalidHydration = true;
          error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
        }
      }

      function warnForInsertedHydratedElement(parentNode, tag, props) {
        {
          if (didWarnInvalidHydration) {
            return;
          }

          didWarnInvalidHydration = true;
          error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
        }
      }

      function warnForInsertedHydratedText(parentNode, text) {
        {
          if (text === '') {
            return;
          }

          if (didWarnInvalidHydration) {
            return;
          }

          didWarnInvalidHydration = true;
          error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
        }
      }

      function restoreControlledState$3(domElement, tag, props) {
        switch (tag) {
          case 'input':
            restoreControlledState(domElement, props);
            return;

          case 'textarea':
            restoreControlledState$2(domElement, props);
            return;

          case 'select':
            restoreControlledState$1(domElement, props);
            return;
        }
      }

      var validateDOMNesting = function validateDOMNesting() {};

      var updatedAncestorInfo = function updatedAncestorInfo() {};

      {
        var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
        var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template', 'foreignObject', 'desc', 'title'];
        var buttonScopeTags = inScopeTags.concat(['button']);
        var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
        var emptyAncestorInfo = {
          current: null,
          formTag: null,
          aTagInScope: null,
          buttonTagInScope: null,
          nobrTagInScope: null,
          pTagInButtonScope: null,
          listItemTagAutoclosing: null,
          dlItemTagAutoclosing: null
        };

        updatedAncestorInfo = function updatedAncestorInfo(oldInfo, tag) {
          var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
          var info = {
            tag: tag
          };

          if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
          }

          if (buttonScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.pTagInButtonScope = null;
          }

          if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
          }

          ancestorInfo.current = info;

          if (tag === 'form') {
            ancestorInfo.formTag = info;
          }

          if (tag === 'a') {
            ancestorInfo.aTagInScope = info;
          }

          if (tag === 'button') {
            ancestorInfo.buttonTagInScope = info;
          }

          if (tag === 'nobr') {
            ancestorInfo.nobrTagInScope = info;
          }

          if (tag === 'p') {
            ancestorInfo.pTagInButtonScope = info;
          }

          if (tag === 'li') {
            ancestorInfo.listItemTagAutoclosing = info;
          }

          if (tag === 'dd' || tag === 'dt') {
            ancestorInfo.dlItemTagAutoclosing = info;
          }

          return ancestorInfo;
        };

        var isTagValidWithParent = function isTagValidWithParent(tag, parentTag) {
          switch (parentTag) {
            case 'select':
              return tag === 'option' || tag === 'optgroup' || tag === '#text';

            case 'optgroup':
              return tag === 'option' || tag === '#text';

            case 'option':
              return tag === '#text';

            case 'tr':
              return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';

            case 'tbody':
            case 'thead':
            case 'tfoot':
              return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';

            case 'colgroup':
              return tag === 'col' || tag === 'template';

            case 'table':
              return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';

            case 'head':
              return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';

            case 'html':
              return tag === 'head' || tag === 'body' || tag === 'frameset';

            case 'frameset':
              return tag === 'frame';

            case '#document':
              return tag === 'html';
          }

          switch (tag) {
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
              return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

            case 'rp':
            case 'rt':
              return impliedEndTags.indexOf(parentTag) === -1;

            case 'body':
            case 'caption':
            case 'col':
            case 'colgroup':
            case 'frameset':
            case 'frame':
            case 'head':
            case 'html':
            case 'tbody':
            case 'td':
            case 'tfoot':
            case 'th':
            case 'thead':
            case 'tr':
              return parentTag == null;
          }

          return true;
        };

        var findInvalidAncestorForTag = function findInvalidAncestorForTag(tag, ancestorInfo) {
          switch (tag) {
            case 'address':
            case 'article':
            case 'aside':
            case 'blockquote':
            case 'center':
            case 'details':
            case 'dialog':
            case 'dir':
            case 'div':
            case 'dl':
            case 'fieldset':
            case 'figcaption':
            case 'figure':
            case 'footer':
            case 'header':
            case 'hgroup':
            case 'main':
            case 'menu':
            case 'nav':
            case 'ol':
            case 'p':
            case 'section':
            case 'summary':
            case 'ul':
            case 'pre':
            case 'listing':
            case 'table':
            case 'hr':
            case 'xmp':
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
              return ancestorInfo.pTagInButtonScope;

            case 'form':
              return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

            case 'li':
              return ancestorInfo.listItemTagAutoclosing;

            case 'dd':
            case 'dt':
              return ancestorInfo.dlItemTagAutoclosing;

            case 'button':
              return ancestorInfo.buttonTagInScope;

            case 'a':
              return ancestorInfo.aTagInScope;

            case 'nobr':
              return ancestorInfo.nobrTagInScope;
          }

          return null;
        };

        var didWarn$1 = {};

        validateDOMNesting = function validateDOMNesting(childTag, childText, ancestorInfo) {
          ancestorInfo = ancestorInfo || emptyAncestorInfo;
          var parentInfo = ancestorInfo.current;
          var parentTag = parentInfo && parentInfo.tag;

          if (childText != null) {
            if (childTag != null) {
              error('validateDOMNesting: when childText is passed, childTag should be null');
            }

            childTag = '#text';
          }

          var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
          var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
          var invalidParentOrAncestor = invalidParent || invalidAncestor;

          if (!invalidParentOrAncestor) {
            return;
          }

          var ancestorTag = invalidParentOrAncestor.tag;
          var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag;

          if (didWarn$1[warnKey]) {
            return;
          }

          didWarn$1[warnKey] = true;
          var tagDisplayName = childTag;
          var whitespaceInfo = '';

          if (childTag === '#text') {
            if (/\S/.test(childText)) {
              tagDisplayName = 'Text nodes';
            } else {
              tagDisplayName = 'Whitespace text nodes';
              whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
            }
          } else {
            tagDisplayName = '<' + childTag + '>';
          }

          if (invalidParent) {
            var info = '';

            if (ancestorTag === 'table' && childTag === 'tr') {
              info += ' Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by ' + 'the browser.';
            }

            error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
          } else {
            error('validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>.', tagDisplayName, ancestorTag);
          }
        };
      }
      var SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
      var SUSPENSE_START_DATA = '$';
      var SUSPENSE_END_DATA = '/$';
      var SUSPENSE_PENDING_START_DATA = '$?';
      var SUSPENSE_FALLBACK_START_DATA = '$!';
      var STYLE$1 = 'style';
      var eventsEnabled = null;
      var selectionInformation = null;

      function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;

        switch (nodeType) {
          case DOCUMENT_NODE:
          case DOCUMENT_FRAGMENT_NODE:
            {
              type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
              var root = rootContainerInstance.documentElement;
              namespace = root ? root.namespaceURI : getChildNamespace(null, '');
              break;
            }

          default:
            {
              var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
              var ownNamespace = container.namespaceURI || null;
              type = container.tagName;
              namespace = getChildNamespace(ownNamespace, type);
              break;
            }
        }

        {
          var validatedTag = type.toLowerCase();
          var ancestorInfo = updatedAncestorInfo(null, validatedTag);
          return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
          };
        }
      }

      function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        {
          var parentHostContextDev = parentHostContext;
          var namespace = getChildNamespace(parentHostContextDev.namespace, type);
          var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
          return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
          };
        }
      }

      function getPublicInstance(instance) {
        return instance;
      }

      function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
      }

      function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
      }

      function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        {
          var hostContextDev = hostContext;
          validateDOMNesting(type, null, hostContextDev.ancestorInfo);

          if (typeof props.children === 'string' || typeof props.children === 'number') {
            var string = '' + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
          }

          parentNamespace = hostContextDev.namespace;
        }
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
      }

      function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
      }

      function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);

        switch (type) {
          case 'button':
          case 'input':
          case 'select':
          case 'textarea':
            return !!props.autoFocus;

          case 'img':
            return true;

          default:
            return false;
        }
      }

      function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        {
          var hostContextDev = hostContext;

          if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
            var string = '' + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
          }
        }
        return diffProperties(domElement, type, oldProps, newProps);
      }

      function shouldSetTextContent(type, props) {
        return type === 'textarea' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
      }

      function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        {
          var hostContextDev = hostContext;
          validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        }
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
      }

      function getCurrentEventPriority() {
        var currentEvent = window.event;

        if (currentEvent === undefined) {
          return DefaultEventPriority;
        }

        return getEventPriority(currentEvent.type);
      }

      var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
      var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
      var noTimeout = -1;
      var localPromise = typeof Promise === 'function' ? Promise : undefined;
      var scheduleMicrotask = typeof queueMicrotask === 'function' ? queueMicrotask : typeof localPromise !== 'undefined' ? function (callback) {
        return localPromise.resolve(null).then(callback)["catch"](handleErrorInNextTick);
      } : scheduleTimeout;

      function handleErrorInNextTick(error) {
        setTimeout(function () {
          throw error;
        });
      }

      function commitMount(domElement, type, newProps, internalInstanceHandle) {
        switch (type) {
          case 'button':
          case 'input':
          case 'select':
          case 'textarea':
            if (newProps.autoFocus) {
              domElement.focus();
            }

            return;

          case 'img':
            {
              if (newProps.src) {
                domElement.src = newProps.src;
              }

              return;
            }
        }
      }

      function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        updateProperties(domElement, updatePayload, type, oldProps, newProps);
        updateFiberProps(domElement, newProps);
      }

      function resetTextContent(domElement) {
        setTextContent(domElement, '');
      }

      function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
      }

      function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
      }

      function appendChildToContainer(container, child) {
        var parentNode;

        if (container.nodeType === COMMENT_NODE) {
          parentNode = container.parentNode;
          parentNode.insertBefore(child, container);
        } else {
          parentNode = container;
          parentNode.appendChild(child);
        }

        var reactRootContainer = container._reactRootContainer;

        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) {
          trapClickOnNonInteractiveElement(parentNode);
        }
      }

      function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
      }

      function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) {
          container.parentNode.insertBefore(child, beforeChild);
        } else {
          container.insertBefore(child, beforeChild);
        }
      }

      function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
      }

      function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) {
          container.parentNode.removeChild(child);
        } else {
          container.removeChild(child);
        }
      }

      function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance;
        var depth = 0;

        do {
          var nextNode = node.nextSibling;
          parentInstance.removeChild(node);

          if (nextNode && nextNode.nodeType === COMMENT_NODE) {
            var data = nextNode.data;

            if (data === SUSPENSE_END_DATA) {
              if (depth === 0) {
                parentInstance.removeChild(nextNode);
                retryIfBlockedOn(suspenseInstance);
                return;
              } else {
                depth--;
              }
            } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) {
              depth++;
            }
          }

          node = nextNode;
        } while (node);

        retryIfBlockedOn(suspenseInstance);
      }

      function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) {
          clearSuspenseBoundary(container.parentNode, suspenseInstance);
        } else if (container.nodeType === ELEMENT_NODE) {
          clearSuspenseBoundary(container, suspenseInstance);
        }

        retryIfBlockedOn(container);
      }

      function hideInstance(instance) {
        instance = instance;
        var style = instance.style;

        if (typeof style.setProperty === 'function') {
          style.setProperty('display', 'none', 'important');
        } else {
          style.display = 'none';
        }
      }

      function hideTextInstance(textInstance) {
        textInstance.nodeValue = '';
      }

      function unhideInstance(instance, props) {
        instance = instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
        instance.style.display = dangerousStyleValue('display', display);
      }

      function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
      }

      function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) {
          container.textContent = '';
        } else if (container.nodeType === DOCUMENT_NODE) {
          var body = container.body;

          if (body != null) {
            body.textContent = '';
          }
        }
      }

      function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) {
          return null;
        }

        return instance;
      }

      function canHydrateTextInstance(instance, text) {
        if (text === '' || instance.nodeType !== TEXT_NODE) {
          return null;
        }

        return instance;
      }

      function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) {
          return null;
        }

        return instance;
      }

      function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
      }

      function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
      }

      function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
      }

      function getNextHydratable(node) {
        for (; node != null; node = node.nextSibling) {
          var nodeType = node.nodeType;

          if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) {
            break;
          }

          if (nodeType === COMMENT_NODE) {
            var nodeData = node.data;

            if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) {
              break;
            }

            if (nodeData === SUSPENSE_END_DATA) {
              return null;
            }
          }
        }

        return node;
      }

      function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
      }

      function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
      }

      function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
      }

      function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
      }

      function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance);
        updateFiberProps(instance, props);
        var parentNamespace;
        {
          var hostContextDev = hostContext;
          parentNamespace = hostContextDev.namespace;
        }
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
      }

      function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance);
        return diffHydratedText(textInstance, text);
      }

      function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
      }

      function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling;
        var depth = 0;

        while (node) {
          if (node.nodeType === COMMENT_NODE) {
            var data = node.data;

            if (data === SUSPENSE_END_DATA) {
              if (depth === 0) {
                return getNextHydratableSibling(node);
              } else {
                depth--;
              }
            } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
              depth++;
            }
          }

          node = node.nextSibling;
        }

        return null;
      }

      function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling;
        var depth = 0;

        while (node) {
          if (node.nodeType === COMMENT_NODE) {
            var data = node.data;

            if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
              if (depth === 0) {
                return node;
              } else {
                depth--;
              }
            } else if (data === SUSPENSE_END_DATA) {
              depth++;
            }
          }

          node = node.previousSibling;
        }

        return null;
      }

      function commitHydratedContainer(container) {
        retryIfBlockedOn(container);
      }

      function commitHydratedSuspenseInstance(suspenseInstance) {
        retryIfBlockedOn(suspenseInstance);
      }

      function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== 'head' && parentType !== 'body';
      }

      function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
      }

      function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
          var shouldWarnDev = true;
          checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
      }

      function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        {
          if (instance.nodeType === ELEMENT_NODE) {
            warnForDeletedHydratableElement(parentContainer, instance);
          } else if (instance.nodeType === COMMENT_NODE) ;else {
            warnForDeletedHydratableText(parentContainer, instance);
          }
        }
      }

      function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        {
          var parentNode = parentInstance.parentNode;

          if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) {
              warnForDeletedHydratableElement(parentNode, instance);
            } else if (instance.nodeType === COMMENT_NODE) ;else {
              warnForDeletedHydratableText(parentNode, instance);
            }
          }
        }
      }

      function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        {
          if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) {
              warnForDeletedHydratableElement(parentInstance, instance);
            } else if (instance.nodeType === COMMENT_NODE) ;else {
              warnForDeletedHydratableText(parentInstance, instance);
            }
          }
        }
      }

      function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        {
          warnForInsertedHydratedElement(parentContainer, type);
        }
      }

      function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        {
          warnForInsertedHydratedText(parentContainer, text);
        }
      }

      function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        {
          var parentNode = parentInstance.parentNode;
          if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
        }
      }

      function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        {
          var parentNode = parentInstance.parentNode;
          if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
        }
      }

      function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        {
          if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            warnForInsertedHydratedElement(parentInstance, type);
          }
        }
      }

      function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        {
          if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            warnForInsertedHydratedText(parentInstance, text);
          }
        }
      }

      function errorHydratingContainer(parentContainer) {
        {
          error('An error occurred during hydration. The server HTML was replaced with client content in <%s>.', parentContainer.nodeName.toLowerCase());
        }
      }

      function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
      }

      var randomKey = Math.random().toString(36).slice(2);
      var internalInstanceKey = '__reactFiber$' + randomKey;
      var internalPropsKey = '__reactProps$' + randomKey;
      var internalContainerInstanceKey = '__reactContainer$' + randomKey;
      var internalEventHandlersKey = '__reactEvents$' + randomKey;
      var internalEventHandlerListenersKey = '__reactListeners$' + randomKey;
      var internalEventHandlesSetKey = '__reactHandles$' + randomKey;

      function detachDeletedInstance(node) {
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
      }

      function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
      }

      function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
      }

      function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
      }

      function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
      }

      function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];

        if (targetInst) {
          return targetInst;
        }

        var parentNode = targetNode.parentNode;

        while (parentNode) {
          targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];

          if (targetInst) {
            var alternate = targetInst.alternate;

            if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
              var suspenseInstance = getParentSuspenseInstance(targetNode);

              while (suspenseInstance !== null) {
                var targetSuspenseInst = suspenseInstance[internalInstanceKey];

                if (targetSuspenseInst) {
                  return targetSuspenseInst;
                }

                suspenseInstance = getParentSuspenseInstance(suspenseInstance);
              }
            }

            return targetInst;
          }

          targetNode = parentNode;
          parentNode = targetNode.parentNode;
        }

        return null;
      }

      function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];

        if (inst) {
          if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) {
            return inst;
          } else {
            return null;
          }
        }

        return null;
      }

      function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) {
          return inst.stateNode;
        }

        throw new Error('getNodeFromInstance: Invalid argument.');
      }

      function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
      }

      function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
      }

      function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];

        if (elementListenerSet === undefined) {
          elementListenerSet = node[internalEventHandlersKey] = new Set();
        }

        return elementListenerSet;
      }

      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }

      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has = Function.call.bind(hasOwnProperty);

          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0;

              try {
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                  var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                  err.name = 'Invariant Violation';
                  throw err;
                }

                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
              } catch (ex) {
                error$1 = ex;
              }

              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }

              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }

      var valueStack = [];
      var fiberStack;
      {
        fiberStack = [];
      }
      var index = -1;

      function createCursor(defaultValue) {
        return {
          current: defaultValue
        };
      }

      function pop(cursor, fiber) {
        if (index < 0) {
          {
            error('Unexpected pop.');
          }
          return;
        }

        {
          if (fiber !== fiberStack[index]) {
            error('Unexpected Fiber popped.');
          }
        }
        cursor.current = valueStack[index];
        valueStack[index] = null;
        {
          fiberStack[index] = null;
        }
        index--;
      }

      function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        {
          fiberStack[index] = fiber;
        }
        cursor.current = value;
      }

      var warnedAboutMissingGetChildContext;
      {
        warnedAboutMissingGetChildContext = {};
      }
      var emptyContextObject = {};
      {
        Object.freeze(emptyContextObject);
      }
      var contextStackCursor = createCursor(emptyContextObject);
      var didPerformWorkStackCursor = createCursor(false);
      var previousContext = emptyContextObject;

      function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        {
          if (didPushOwnContextIfProvider && isContextProvider(Component)) {
            return previousContext;
          }

          return contextStackCursor.current;
        }
      }

      function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        {
          var instance = workInProgress.stateNode;
          instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
          instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
        }
      }

      function getMaskedContext(workInProgress, unmaskedContext) {
        {
          var type = workInProgress.type;
          var contextTypes = type.contextTypes;

          if (!contextTypes) {
            return emptyContextObject;
          }

          var instance = workInProgress.stateNode;

          if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
            return instance.__reactInternalMemoizedMaskedChildContext;
          }

          var context = {};

          for (var key in contextTypes) {
            context[key] = unmaskedContext[key];
          }

          {
            var name = getComponentNameFromFiber(workInProgress) || 'Unknown';
            checkPropTypes(contextTypes, context, 'context', name);
          }

          if (instance) {
            cacheContext(workInProgress, unmaskedContext, context);
          }

          return context;
        }
      }

      function hasContextChanged() {
        {
          return didPerformWorkStackCursor.current;
        }
      }

      function isContextProvider(type) {
        {
          var childContextTypes = type.childContextTypes;
          return childContextTypes !== null && childContextTypes !== undefined;
        }
      }

      function popContext(fiber) {
        {
          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }
      }

      function popTopLevelContextObject(fiber) {
        {
          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }
      }

      function pushTopLevelContextObject(fiber, context, didChange) {
        {
          if (contextStackCursor.current !== emptyContextObject) {
            throw new Error('Unexpected context found on stack. ' + 'This error is likely caused by a bug in React. Please file an issue.');
          }

          push(contextStackCursor, context, fiber);
          push(didPerformWorkStackCursor, didChange, fiber);
        }
      }

      function processChildContext(fiber, type, parentContext) {
        {
          var instance = fiber.stateNode;
          var childContextTypes = type.childContextTypes;

          if (typeof instance.getChildContext !== 'function') {
            {
              var componentName = getComponentNameFromFiber(fiber) || 'Unknown';

              if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error('%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
              }
            }
            return parentContext;
          }

          var childContext = instance.getChildContext();

          for (var contextKey in childContext) {
            if (!(contextKey in childContextTypes)) {
              throw new Error((getComponentNameFromFiber(fiber) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
            }
          }

          {
            var name = getComponentNameFromFiber(fiber) || 'Unknown';
            checkPropTypes(childContextTypes, childContext, 'child context', name);
          }
          return assign({}, parentContext, childContext);
        }
      }

      function pushContextProvider(workInProgress) {
        {
          var instance = workInProgress.stateNode;
          var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject;
          previousContext = contextStackCursor.current;
          push(contextStackCursor, memoizedMergedChildContext, workInProgress);
          push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
          return true;
        }
      }

      function invalidateContextProvider(workInProgress, type, didChange) {
        {
          var instance = workInProgress.stateNode;

          if (!instance) {
            throw new Error('Expected to have an instance by this point. ' + 'This error is likely caused by a bug in React. Please file an issue.');
          }

          if (didChange) {
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext;
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress);
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
          } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
          }
        }
      }

      function findCurrentUnmaskedContext(fiber) {
        {
          if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) {
            throw new Error('Expected subtree parent to be a mounted class component. ' + 'This error is likely caused by a bug in React. Please file an issue.');
          }

          var node = fiber;

          do {
            switch (node.tag) {
              case HostRoot:
                return node.stateNode.context;

              case ClassComponent:
                {
                  var Component = node.type;

                  if (isContextProvider(Component)) {
                    return node.stateNode.__reactInternalMemoizedMergedChildContext;
                  }

                  break;
                }
            }

            node = node["return"];
          } while (node !== null);

          throw new Error('Found unexpected detached subtree parent. ' + 'This error is likely caused by a bug in React. Please file an issue.');
        }
      }

      var LegacyRoot = 0;
      var ConcurrentRoot = 1;
      var syncQueue = null;
      var includesLegacySyncCallbacks = false;
      var isFlushingSyncQueue = false;

      function scheduleSyncCallback(callback) {
        if (syncQueue === null) {
          syncQueue = [callback];
        } else {
          syncQueue.push(callback);
        }
      }

      function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
      }

      function flushSyncCallbacksOnlyInLegacyMode() {
        if (includesLegacySyncCallbacks) {
          flushSyncCallbacks();
        }
      }

      function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
          isFlushingSyncQueue = true;
          var i = 0;
          var previousUpdatePriority = getCurrentUpdatePriority();

          try {
            var isSync = true;
            var queue = syncQueue;
            setCurrentUpdatePriority(DiscreteEventPriority);

            for (; i < queue.length; i++) {
              var callback = queue[i];

              do {
                callback = callback(isSync);
              } while (callback !== null);
            }

            syncQueue = null;
            includesLegacySyncCallbacks = false;
          } catch (error) {
            if (syncQueue !== null) {
              syncQueue = syncQueue.slice(i + 1);
            }

            scheduleCallback(ImmediatePriority, flushSyncCallbacks);
            throw error;
          } finally {
            setCurrentUpdatePriority(previousUpdatePriority);
            isFlushingSyncQueue = false;
          }
        }

        return null;
      }

      var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
      var NoTransition = null;

      function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
      }

      var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function recordUnsafeLifecycleWarnings(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function flushPendingUnsafeLifecycleWarnings() {},
        recordLegacyContextWarning: function recordLegacyContextWarning(fiber, instance) {},
        flushLegacyContextWarning: function flushLegacyContextWarning() {},
        discardPendingWarnings: function discardPendingWarnings() {}
      };
      {
        var findStrictRoot = function findStrictRoot(fiber) {
          var maybeStrictRoot = null;
          var node = fiber;

          while (node !== null) {
            if (node.mode & StrictLegacyMode) {
              maybeStrictRoot = node;
            }

            node = node["return"];
          }

          return maybeStrictRoot;
        };

        var setToSortedString = function setToSortedString(set) {
          var array = [];
          set.forEach(function (value) {
            array.push(value);
          });
          return array.sort().join(', ');
        };

        var pendingComponentWillMountWarnings = [];
        var pendingUNSAFE_ComponentWillMountWarnings = [];
        var pendingComponentWillReceivePropsWarnings = [];
        var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        var pendingComponentWillUpdateWarnings = [];
        var pendingUNSAFE_ComponentWillUpdateWarnings = [];
        var didWarnAboutUnsafeLifecycles = new Set();

        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function (fiber, instance) {
          if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
            return;
          }

          if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
            pendingComponentWillMountWarnings.push(fiber);
          }

          if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === 'function') {
            pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
          }

          if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
            pendingComponentWillReceivePropsWarnings.push(fiber);
          }

          if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
          }

          if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
            pendingComponentWillUpdateWarnings.push(fiber);
          }

          if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === 'function') {
            pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
          }
        };

        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function () {
          var componentWillMountUniqueNames = new Set();

          if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function (fiber) {
              componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
          }

          var UNSAFE_componentWillMountUniqueNames = new Set();

          if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function (fiber) {
              UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
          }

          var componentWillReceivePropsUniqueNames = new Set();

          if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function (fiber) {
              componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
          }

          var UNSAFE_componentWillReceivePropsUniqueNames = new Set();

          if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function (fiber) {
              UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          }

          var componentWillUpdateUniqueNames = new Set();

          if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function (fiber) {
              componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
          }

          var UNSAFE_componentWillUpdateUniqueNames = new Set();

          if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function (fiber) {
              UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
          }

          if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error('Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '\nPlease update the following components: %s', sortedNames);
          }

          if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);

            error('Using UNSAFE_componentWillReceiveProps in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, " + 'refactor your code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '\nPlease update the following components: %s', _sortedNames);
          }

          if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);

            error('Using UNSAFE_componentWillUpdate in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '\nPlease update the following components: %s', _sortedNames2);
          }

          if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);

            warn('componentWillMount has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '* Rename componentWillMount to UNSAFE_componentWillMount to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames3);
          }

          if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);

            warn('componentWillReceiveProps has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, refactor your " + 'code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames4);
          }

          if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);

            warn('componentWillUpdate has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames5);
          }
        };

        var pendingLegacyContextWarning = new Map();
        var didWarnAboutLegacyContext = new Set();

        ReactStrictModeWarnings.recordLegacyContextWarning = function (fiber, instance) {
          var strictRoot = findStrictRoot(fiber);

          if (strictRoot === null) {
            error('Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');
            return;
          }

          if (didWarnAboutLegacyContext.has(fiber.type)) {
            return;
          }

          var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);

          if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
              warningsForRoot = [];
              pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }

            warningsForRoot.push(fiber);
          }
        };

        ReactStrictModeWarnings.flushLegacyContextWarning = function () {
          pendingLegacyContextWarning.forEach(function (fiberArray, strictRoot) {
            if (fiberArray.length === 0) {
              return;
            }

            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function (fiber) {
              uniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
              didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);

            try {
              setCurrentFiber(firstFiber);
              error('Legacy context API has been detected within a strict-mode tree.' + '\n\nThe old API will be supported in all 16.x releases, but applications ' + 'using it should migrate to the new version.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context', sortedNames);
            } finally {
              resetCurrentFiber();
            }
          });
        };

        ReactStrictModeWarnings.discardPendingWarnings = function () {
          pendingComponentWillMountWarnings = [];
          pendingUNSAFE_ComponentWillMountWarnings = [];
          pendingComponentWillReceivePropsWarnings = [];
          pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          pendingComponentWillUpdateWarnings = [];
          pendingUNSAFE_ComponentWillUpdateWarnings = [];
          pendingLegacyContextWarning = new Map();
        };
      }

      function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
          var props = assign({}, baseProps);
          var defaultProps = Component.defaultProps;

          for (var propName in defaultProps) {
            if (props[propName] === undefined) {
              props[propName] = defaultProps[propName];
            }
          }

          return props;
        }

        return baseProps;
      }

      var valueCursor = createCursor(null);
      var rendererSigil;
      {
        rendererSigil = {};
      }
      var currentlyRenderingFiber = null;
      var lastContextDependency = null;
      var lastFullyObservedContext = null;
      var isDisallowedContextReadInDEV = false;

      function resetContextDependencies() {
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        {
          isDisallowedContextReadInDEV = false;
        }
      }

      function enterDisallowedContextReadInDEV() {
        {
          isDisallowedContextReadInDEV = true;
        }
      }

      function exitDisallowedContextReadInDEV() {
        {
          isDisallowedContextReadInDEV = false;
        }
      }

      function pushProvider(providerFiber, context, nextValue) {
        {
          push(valueCursor, context._currentValue, providerFiber);
          context._currentValue = nextValue;
          {
            if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
              error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
            }

            context._currentRenderer = rendererSigil;
          }
        }
      }

      function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        {
          {
            context._currentValue = currentValue;
          }
        }
      }

      function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        var node = parent;

        while (node !== null) {
          var alternate = node.alternate;

          if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
            node.childLanes = mergeLanes(node.childLanes, renderLanes);

            if (alternate !== null) {
              alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            }
          } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) {
            alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
          }

          if (node === propagationRoot) {
            break;
          }

          node = node["return"];
        }

        {
          if (node !== propagationRoot) {
            error('Expected to find the propagation root when scheduling context work. ' + 'This error is likely caused by a bug in React. Please file an issue.');
          }
        }
      }

      function propagateContextChange(workInProgress, context, renderLanes) {
        {
          propagateContextChange_eager(workInProgress, context, renderLanes);
        }
      }

      function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;

        if (fiber !== null) {
          fiber["return"] = workInProgress;
        }

        while (fiber !== null) {
          var nextFiber = void 0;
          var list = fiber.dependencies;

          if (list !== null) {
            nextFiber = fiber.child;
            var dependency = list.firstContext;

            while (dependency !== null) {
              if (dependency.context === context) {
                if (fiber.tag === ClassComponent) {
                  var lane = pickArbitraryLane(renderLanes);
                  var update = createUpdate(NoTimestamp, lane);
                  update.tag = ForceUpdate;
                  var updateQueue = fiber.updateQueue;
                  if (updateQueue === null) ;else {
                    var sharedQueue = updateQueue.shared;
                    var pending = sharedQueue.pending;

                    if (pending === null) {
                      update.next = update;
                    } else {
                      update.next = pending.next;
                      pending.next = update;
                    }

                    sharedQueue.pending = update;
                  }
                }

                fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                var alternate = fiber.alternate;

                if (alternate !== null) {
                  alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                }

                scheduleContextWorkOnParentPath(fiber["return"], renderLanes, workInProgress);
                list.lanes = mergeLanes(list.lanes, renderLanes);
                break;
              }

              dependency = dependency.next;
            }
          } else if (fiber.tag === ContextProvider) {
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
          } else if (fiber.tag === DehydratedFragment) {
            var parentSuspense = fiber["return"];

            if (parentSuspense === null) {
              throw new Error('We just came from a parent so we must have had a parent. This is a bug in React.');
            }

            parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
            var _alternate = parentSuspense.alternate;

            if (_alternate !== null) {
              _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
            }

            scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
            nextFiber = fiber.sibling;
          } else {
            nextFiber = fiber.child;
          }

          if (nextFiber !== null) {
            nextFiber["return"] = fiber;
          } else {
            nextFiber = fiber;

            while (nextFiber !== null) {
              if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
              }

              var sibling = nextFiber.sibling;

              if (sibling !== null) {
                sibling["return"] = nextFiber["return"];
                nextFiber = sibling;
                break;
              }

              nextFiber = nextFiber["return"];
            }
          }

          fiber = nextFiber;
        }
      }

      function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;

        if (dependencies !== null) {
          {
            var firstContext = dependencies.firstContext;

            if (firstContext !== null) {
              if (includesSomeLane(dependencies.lanes, renderLanes)) {
                markWorkInProgressReceivedUpdate();
              }

              dependencies.firstContext = null;
            }
          }
        }
      }

      function _readContext(context) {
        {
          if (isDisallowedContextReadInDEV) {
            error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
          }
        }
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;else {
          var contextItem = {
            context: context,
            memoizedValue: value,
            next: null
          };

          if (lastContextDependency === null) {
            if (currentlyRenderingFiber === null) {
              throw new Error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
            }

            lastContextDependency = contextItem;
            currentlyRenderingFiber.dependencies = {
              lanes: NoLanes,
              firstContext: contextItem
            };
          } else {
            lastContextDependency = lastContextDependency.next = contextItem;
          }
        }
        return value;
      }

      var interleavedQueues = null;

      function pushInterleavedQueue(queue) {
        if (interleavedQueues === null) {
          interleavedQueues = [queue];
        } else {
          interleavedQueues.push(queue);
        }
      }

      function hasInterleavedUpdates() {
        return interleavedQueues !== null;
      }

      function enqueueInterleavedUpdates() {
        if (interleavedQueues !== null) {
          for (var i = 0; i < interleavedQueues.length; i++) {
            var queue = interleavedQueues[i];
            var lastInterleavedUpdate = queue.interleaved;

            if (lastInterleavedUpdate !== null) {
              queue.interleaved = null;
              var firstInterleavedUpdate = lastInterleavedUpdate.next;
              var lastPendingUpdate = queue.pending;

              if (lastPendingUpdate !== null) {
                var firstPendingUpdate = lastPendingUpdate.next;
                lastPendingUpdate.next = firstInterleavedUpdate;
                lastInterleavedUpdate.next = firstPendingUpdate;
              }

              queue.pending = lastInterleavedUpdate;
            }
          }

          interleavedQueues = null;
        }
      }

      var UpdateState = 0;
      var ReplaceState = 1;
      var ForceUpdate = 2;
      var CaptureUpdate = 3;
      var hasForceUpdate = false;
      var didWarnUpdateInsideUpdate;
      var currentlyProcessingQueue;
      {
        didWarnUpdateInsideUpdate = false;
        currentlyProcessingQueue = null;
      }

      function initializeUpdateQueue(fiber) {
        var queue = {
          baseState: fiber.memoizedState,
          firstBaseUpdate: null,
          lastBaseUpdate: null,
          shared: {
            pending: null,
            interleaved: null,
            lanes: NoLanes
          },
          effects: null
        };
        fiber.updateQueue = queue;
      }

      function cloneUpdateQueue(current, workInProgress) {
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;

        if (queue === currentQueue) {
          var clone = {
            baseState: currentQueue.baseState,
            firstBaseUpdate: currentQueue.firstBaseUpdate,
            lastBaseUpdate: currentQueue.lastBaseUpdate,
            shared: currentQueue.shared,
            effects: currentQueue.effects
          };
          workInProgress.updateQueue = clone;
        }
      }

      function createUpdate(eventTime, lane) {
        var update = {
          eventTime: eventTime,
          lane: lane,
          tag: UpdateState,
          payload: null,
          callback: null,
          next: null
        };
        return update;
      }

      function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;

        if (updateQueue === null) {
          return;
        }

        var sharedQueue = updateQueue.shared;

        if (isInterleavedUpdate(fiber)) {
          var interleaved = sharedQueue.interleaved;

          if (interleaved === null) {
            update.next = update;
            pushInterleavedQueue(sharedQueue);
          } else {
            update.next = interleaved.next;
            interleaved.next = update;
          }

          sharedQueue.interleaved = update;
        } else {
          var pending = sharedQueue.pending;

          if (pending === null) {
            update.next = update;
          } else {
            update.next = pending.next;
            pending.next = update;
          }

          sharedQueue.pending = update;
        }

        {
          if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error('An update (setState, replaceState, or forceUpdate) was scheduled ' + 'from inside an update function. Update functions should be pure, ' + 'with zero side-effects. Consider using componentDidUpdate or a ' + 'callback.');
            didWarnUpdateInsideUpdate = true;
          }
        }
      }

      function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;

        if (updateQueue === null) {
          return;
        }

        var sharedQueue = updateQueue.shared;

        if (isTransitionLane(lane)) {
          var queueLanes = sharedQueue.lanes;
          queueLanes = intersectLanes(queueLanes, root.pendingLanes);
          var newQueueLanes = mergeLanes(queueLanes, lane);
          sharedQueue.lanes = newQueueLanes;
          markRootEntangled(root, newQueueLanes);
        }
      }

      function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        var queue = workInProgress.updateQueue;
        var current = workInProgress.alternate;

        if (current !== null) {
          var currentQueue = current.updateQueue;

          if (queue === currentQueue) {
            var newFirst = null;
            var newLast = null;
            var firstBaseUpdate = queue.firstBaseUpdate;

            if (firstBaseUpdate !== null) {
              var update = firstBaseUpdate;

              do {
                var clone = {
                  eventTime: update.eventTime,
                  lane: update.lane,
                  tag: update.tag,
                  payload: update.payload,
                  callback: update.callback,
                  next: null
                };

                if (newLast === null) {
                  newFirst = newLast = clone;
                } else {
                  newLast.next = clone;
                  newLast = clone;
                }

                update = update.next;
              } while (update !== null);

              if (newLast === null) {
                newFirst = newLast = capturedUpdate;
              } else {
                newLast.next = capturedUpdate;
                newLast = capturedUpdate;
              }
            } else {
              newFirst = newLast = capturedUpdate;
            }

            queue = {
              baseState: currentQueue.baseState,
              firstBaseUpdate: newFirst,
              lastBaseUpdate: newLast,
              shared: currentQueue.shared,
              effects: currentQueue.effects
            };
            workInProgress.updateQueue = queue;
            return;
          }
        }

        var lastBaseUpdate = queue.lastBaseUpdate;

        if (lastBaseUpdate === null) {
          queue.firstBaseUpdate = capturedUpdate;
        } else {
          lastBaseUpdate.next = capturedUpdate;
        }

        queue.lastBaseUpdate = capturedUpdate;
      }

      function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch (update.tag) {
          case ReplaceState:
            {
              var payload = update.payload;

              if (typeof payload === 'function') {
                {
                  enterDisallowedContextReadInDEV();
                }
                var nextState = payload.call(instance, prevState, nextProps);
                {
                  if (workInProgress.mode & StrictLegacyMode) {
                    setIsStrictModeForDevtools(true);

                    try {
                      payload.call(instance, prevState, nextProps);
                    } finally {
                      setIsStrictModeForDevtools(false);
                    }
                  }

                  exitDisallowedContextReadInDEV();
                }
                return nextState;
              }

              return payload;
            }

          case CaptureUpdate:
            {
              workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            }

          case UpdateState:
            {
              var _payload = update.payload;
              var partialState;

              if (typeof _payload === 'function') {
                {
                  enterDisallowedContextReadInDEV();
                }
                partialState = _payload.call(instance, prevState, nextProps);
                {
                  if (workInProgress.mode & StrictLegacyMode) {
                    setIsStrictModeForDevtools(true);

                    try {
                      _payload.call(instance, prevState, nextProps);
                    } finally {
                      setIsStrictModeForDevtools(false);
                    }
                  }

                  exitDisallowedContextReadInDEV();
                }
              } else {
                partialState = _payload;
              }

              if (partialState === null || partialState === undefined) {
                return prevState;
              }

              return assign({}, prevState, partialState);
            }

          case ForceUpdate:
            {
              hasForceUpdate = true;
              return prevState;
            }
        }

        return prevState;
      }

      function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        {
          currentlyProcessingQueue = queue.shared;
        }
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate;
        var pendingQueue = queue.shared.pending;

        if (pendingQueue !== null) {
          queue.shared.pending = null;
          var lastPendingUpdate = pendingQueue;
          var firstPendingUpdate = lastPendingUpdate.next;
          lastPendingUpdate.next = null;

          if (lastBaseUpdate === null) {
            firstBaseUpdate = firstPendingUpdate;
          } else {
            lastBaseUpdate.next = firstPendingUpdate;
          }

          lastBaseUpdate = lastPendingUpdate;
          var current = workInProgress.alternate;

          if (current !== null) {
            var currentQueue = current.updateQueue;
            var currentLastBaseUpdate = currentQueue.lastBaseUpdate;

            if (currentLastBaseUpdate !== lastBaseUpdate) {
              if (currentLastBaseUpdate === null) {
                currentQueue.firstBaseUpdate = firstPendingUpdate;
              } else {
                currentLastBaseUpdate.next = firstPendingUpdate;
              }

              currentQueue.lastBaseUpdate = lastPendingUpdate;
            }
          }
        }

        if (firstBaseUpdate !== null) {
          var newState = queue.baseState;
          var newLanes = NoLanes;
          var newBaseState = null;
          var newFirstBaseUpdate = null;
          var newLastBaseUpdate = null;
          var update = firstBaseUpdate;

          do {
            var updateLane = update.lane;
            var updateEventTime = update.eventTime;

            if (!isSubsetOfLanes(renderLanes, updateLane)) {
              var clone = {
                eventTime: updateEventTime,
                lane: updateLane,
                tag: update.tag,
                payload: update.payload,
                callback: update.callback,
                next: null
              };

              if (newLastBaseUpdate === null) {
                newFirstBaseUpdate = newLastBaseUpdate = clone;
                newBaseState = newState;
              } else {
                newLastBaseUpdate = newLastBaseUpdate.next = clone;
              }

              newLanes = mergeLanes(newLanes, updateLane);
            } else {
              if (newLastBaseUpdate !== null) {
                var _clone = {
                  eventTime: updateEventTime,
                  lane: NoLane,
                  tag: update.tag,
                  payload: update.payload,
                  callback: update.callback,
                  next: null
                };
                newLastBaseUpdate = newLastBaseUpdate.next = _clone;
              }

              newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
              var callback = update.callback;

              if (callback !== null && update.lane !== NoLane) {
                workInProgress.flags |= Callback;
                var effects = queue.effects;

                if (effects === null) {
                  queue.effects = [update];
                } else {
                  effects.push(update);
                }
              }
            }

            update = update.next;

            if (update === null) {
              pendingQueue = queue.shared.pending;

              if (pendingQueue === null) {
                break;
              } else {
                var _lastPendingUpdate = pendingQueue;
                var _firstPendingUpdate = _lastPendingUpdate.next;
                _lastPendingUpdate.next = null;
                update = _firstPendingUpdate;
                queue.lastBaseUpdate = _lastPendingUpdate;
                queue.shared.pending = null;
              }
            }
          } while (true);

          if (newLastBaseUpdate === null) {
            newBaseState = newState;
          }

          queue.baseState = newBaseState;
          queue.firstBaseUpdate = newFirstBaseUpdate;
          queue.lastBaseUpdate = newLastBaseUpdate;
          var lastInterleaved = queue.shared.interleaved;

          if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;

            do {
              newLanes = mergeLanes(newLanes, interleaved.lane);
              interleaved = interleaved.next;
            } while (interleaved !== lastInterleaved);
          } else if (firstBaseUpdate === null) {
            queue.shared.lanes = NoLanes;
          }

          markSkippedUpdateLanes(newLanes);
          workInProgress.lanes = newLanes;
          workInProgress.memoizedState = newState;
        }

        {
          currentlyProcessingQueue = null;
        }
      }

      function callCallback(callback, context) {
        if (typeof callback !== 'function') {
          throw new Error('Invalid argument passed as callback. Expected a function. Instead ' + ("received: " + callback));
        }

        callback.call(context);
      }

      function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
      }

      function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
      }

      function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;

        if (effects !== null) {
          for (var i = 0; i < effects.length; i++) {
            var effect = effects[i];
            var callback = effect.callback;

            if (callback !== null) {
              effect.callback = null;
              callCallback(callback, instance);
            }
          }
        }
      }

      var fakeInternalInstance = {};
      var emptyRefsObject = new React.Component().refs;
      var didWarnAboutStateAssignmentForComponent;
      var didWarnAboutUninitializedState;
      var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
      var didWarnAboutLegacyLifecyclesAndDerivedState;
      var didWarnAboutUndefinedDerivedState;
      var warnOnUndefinedDerivedState;
      var warnOnInvalidCallback;
      var didWarnAboutDirectlyAssigningPropsToState;
      var didWarnAboutContextTypeAndContextTypes;
      var didWarnAboutInvalidateContextType;
      {
        didWarnAboutStateAssignmentForComponent = new Set();
        didWarnAboutUninitializedState = new Set();
        didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
        didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
        didWarnAboutDirectlyAssigningPropsToState = new Set();
        didWarnAboutUndefinedDerivedState = new Set();
        didWarnAboutContextTypeAndContextTypes = new Set();
        didWarnAboutInvalidateContextType = new Set();
        var didWarnOnInvalidCallback = new Set();

        warnOnInvalidCallback = function warnOnInvalidCallback(callback, callerName) {
          if (callback === null || typeof callback === 'function') {
            return;
          }

          var key = callerName + '_' + callback;

          if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
          }
        };

        warnOnUndefinedDerivedState = function warnOnUndefinedDerivedState(type, partialState) {
          if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || 'Component';

            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
              didWarnAboutUndefinedDerivedState.add(componentName);
              error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
            }
          }
        };

        Object.defineProperty(fakeInternalInstance, '_processChildContext', {
          enumerable: false,
          value: function value() {
            throw new Error('_processChildContext is not available in React 16+. This likely ' + 'means you have multiple copies of React and are attempting to nest ' + 'a React 15 tree inside a React 16 tree using ' + "unstable_renderSubtreeIntoContainer, which isn't supported. Try " + 'to make sure you have only one copy of React (and ideally, switch ' + 'to ReactDOM.createPortal).');
          }
        });
        Object.freeze(fakeInternalInstance);
      }

      function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        {
          if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);

            try {
              partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally {
              setIsStrictModeForDevtools(false);
            }
          }

          warnOnUndefinedDerivedState(ctor, partialState);
        }
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState;

        if (workInProgress.lanes === NoLanes) {
          var updateQueue = workInProgress.updateQueue;
          updateQueue.baseState = memoizedState;
        }
      }

      var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function enqueueSetState(inst, payload, callback) {
          var fiber = get(inst);
          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          var update = createUpdate(eventTime, lane);
          update.payload = payload;

          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'setState');
            }
            update.callback = callback;
          }

          enqueueUpdate(fiber, update);
          var root = scheduleUpdateOnFiber(fiber, lane, eventTime);

          if (root !== null) {
            entangleTransitions(root, fiber, lane);
          }

          {
            markStateUpdateScheduled(fiber, lane);
          }
        },
        enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
          var fiber = get(inst);
          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          var update = createUpdate(eventTime, lane);
          update.tag = ReplaceState;
          update.payload = payload;

          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'replaceState');
            }
            update.callback = callback;
          }

          enqueueUpdate(fiber, update);
          var root = scheduleUpdateOnFiber(fiber, lane, eventTime);

          if (root !== null) {
            entangleTransitions(root, fiber, lane);
          }

          {
            markStateUpdateScheduled(fiber, lane);
          }
        },
        enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
          var fiber = get(inst);
          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          var update = createUpdate(eventTime, lane);
          update.tag = ForceUpdate;

          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'forceUpdate');
            }
            update.callback = callback;
          }

          enqueueUpdate(fiber, update);
          var root = scheduleUpdateOnFiber(fiber, lane, eventTime);

          if (root !== null) {
            entangleTransitions(root, fiber, lane);
          }

          {
            markForceUpdateScheduled(fiber, lane);
          }
        }
      };

      function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;

        if (typeof instance.shouldComponentUpdate === 'function') {
          var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
          {
            if (workInProgress.mode & StrictLegacyMode) {
              setIsStrictModeForDevtools(true);

              try {
                shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
              } finally {
                setIsStrictModeForDevtools(false);
              }
            }

            if (shouldUpdate === undefined) {
              error('%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', getComponentNameFromType(ctor) || 'Component');
            }
          }
          return shouldUpdate;
        }

        if (ctor.prototype && ctor.prototype.isPureReactComponent) {
          return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        }

        return true;
      }

      function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        {
          var name = getComponentNameFromType(ctor) || 'Component';
          var renderPresent = instance.render;

          if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') {
              error('%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
            } else {
              error('%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
            }
          }

          if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
            error('getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name);
          }

          if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name);
          }

          if (instance.propTypes) {
            error('propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name);
          }

          if (instance.contextType) {
            error('contextType was defined as an instance property on %s. Use a static ' + 'property to define contextType instead.', name);
          }

          {
            if (instance.contextTypes) {
              error('contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name);
            }

            if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
              didWarnAboutContextTypeAndContextTypes.add(ctor);
              error('%s declares both contextTypes and contextType static properties. ' + 'The legacy contextTypes property will be ignored.', name);
            }
          }

          if (typeof instance.componentShouldUpdate === 'function') {
            error('%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name);
          }

          if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
            error('%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentNameFromType(ctor) || 'A pure component');
          }

          if (typeof instance.componentDidUnmount === 'function') {
            error('%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name);
          }

          if (typeof instance.componentDidReceiveProps === 'function') {
            error('%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name);
          }

          if (typeof instance.componentWillRecieveProps === 'function') {
            error('%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name);
          }

          if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') {
            error('%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name);
          }

          var hasMutatedProps = instance.props !== newProps;

          if (instance.props !== undefined && hasMutatedProps) {
            error('%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", name, name);
          }

          if (instance.defaultProps) {
            error('Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name);
          }

          if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error('%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentNameFromType(ctor));
          }

          if (typeof instance.getDerivedStateFromProps === 'function') {
            error('%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
          }

          if (typeof instance.getDerivedStateFromError === 'function') {
            error('%s: getDerivedStateFromError() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
          }

          if (typeof ctor.getSnapshotBeforeUpdate === 'function') {
            error('%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name);
          }

          var _state = instance.state;

          if (_state && (typeof _state !== 'object' || isArray(_state))) {
            error('%s.state: must be set to an object or null', name);
          }

          if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') {
            error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name);
          }
        }
      }

      function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance;
        set(instance, workInProgress);
        {
          instance._reactInternalInstance = fakeInternalInstance;
        }
      }

      function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        {
          if ('contextType' in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined;

            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
              didWarnAboutInvalidateContextType.add(ctor);
              var addendum = '';

              if (contextType === undefined) {
                addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
              } else if (typeof contextType !== 'object') {
                addendum = ' However, it is set to a ' + typeof contextType + '.';
              } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
                addendum = ' Did you accidentally pass the Context.Provider instead?';
              } else if (contextType._context !== undefined) {
                addendum = ' Did you accidentally pass the Context.Consumer instead?';
              } else {
                addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
              }

              error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentNameFromType(ctor) || 'Component', addendum);
            }
          }
        }

        if (typeof contextType === 'object' && contextType !== null) {
          context = _readContext(contextType);
        } else {
          unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          var contextTypes = ctor.contextTypes;
          isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
          context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }

        var instance = new ctor(props, context);
        {
          if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);

            try {
              instance = new ctor(props, context);
            } finally {
              setIsStrictModeForDevtools(false);
            }
          }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        {
          if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentNameFromType(ctor) || 'Component';

            if (!didWarnAboutUninitializedState.has(componentName)) {
              didWarnAboutUninitializedState.add(componentName);
              error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
          }

          if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;

            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
              foundWillMountName = 'componentWillMount';
            } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
              foundWillMountName = 'UNSAFE_componentWillMount';
            }

            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              foundWillReceivePropsName = 'componentWillReceiveProps';
            } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
              foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            }

            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
              foundWillUpdateName = 'componentWillUpdate';
            } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
              foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            }

            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
              var _componentName = getComponentNameFromType(ctor) || 'Component';

              var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';

              if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://reactjs.org/link/unsafe-component-lifecycles', _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
              }
            }
          }
        }

        if (isLegacyContextConsumer) {
          cacheContext(workInProgress, unmaskedContext, context);
        }

        return instance;
      }

      function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;

        if (typeof instance.componentWillMount === 'function') {
          instance.componentWillMount();
        }

        if (typeof instance.UNSAFE_componentWillMount === 'function') {
          instance.UNSAFE_componentWillMount();
        }

        if (oldState !== instance.state) {
          {
            error('%s.componentWillMount(): Assigning directly to this.state is ' + "deprecated (except inside a component's " + 'constructor). Use setState instead.', getComponentNameFromFiber(workInProgress) || 'Component');
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      }

      function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;

        if (typeof instance.componentWillReceiveProps === 'function') {
          instance.componentWillReceiveProps(newProps, nextContext);
        }

        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
          instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        }

        if (instance.state !== oldState) {
          {
            var componentName = getComponentNameFromFiber(workInProgress) || 'Component';

            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
              didWarnAboutStateAssignmentForComponent.add(componentName);
              error('%s.componentWillReceiveProps(): Assigning directly to ' + "this.state is deprecated (except inside a component's " + 'constructor). Use setState instead.', componentName);
            }
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      }

      function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        {
          checkClassInstance(workInProgress, ctor, newProps);
        }
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;

        if (typeof contextType === 'object' && contextType !== null) {
          instance.context = _readContext(contextType);
        } else {
          var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }

        {
          if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || 'Component';

            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
              didWarnAboutDirectlyAssigningPropsToState.add(componentName);
              error('%s: It is not recommended to assign props directly to state ' + "because updates to props won't be reflected in state. " + 'In most cases, it is better to use props directly.', componentName);
            }
          }

          if (workInProgress.mode & StrictLegacyMode) {
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
          }

          {
            ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
          }
        }
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;

        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          instance.state = workInProgress.memoizedState;
        }

        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
          callComponentWillMount(workInProgress, instance);
          processUpdateQueue(workInProgress, newProps, instance, renderLanes);
          instance.state = workInProgress.memoizedState;
        }

        if (typeof instance.componentDidMount === 'function') {
          var fiberFlags = Update;
          {
            fiberFlags |= LayoutStatic;
          }

          if ((workInProgress.mode & StrictEffectsMode) !== NoMode) {
            fiberFlags |= MountLayoutDev;
          }

          workInProgress.flags |= fiberFlags;
        }
      }

      function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;

        if (typeof contextType === 'object' && contextType !== null) {
          nextContext = _readContext(contextType);
        } else {
          var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }

        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function';

        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
          if (oldProps !== newProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
          }
        }

        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;

        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
          if (typeof instance.componentDidMount === 'function') {
            var fiberFlags = Update;
            {
              fiberFlags |= LayoutStatic;
            }

            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) {
              fiberFlags |= MountLayoutDev;
            }

            workInProgress.flags |= fiberFlags;
          }

          return false;
        }

        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress.memoizedState;
        }

        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);

        if (shouldUpdate) {
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            if (typeof instance.componentWillMount === 'function') {
              instance.componentWillMount();
            }

            if (typeof instance.UNSAFE_componentWillMount === 'function') {
              instance.UNSAFE_componentWillMount();
            }
          }

          if (typeof instance.componentDidMount === 'function') {
            var _fiberFlags = Update;
            {
              _fiberFlags |= LayoutStatic;
            }

            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) {
              _fiberFlags |= MountLayoutDev;
            }

            workInProgress.flags |= _fiberFlags;
          }
        } else {
          if (typeof instance.componentDidMount === 'function') {
            var _fiberFlags2 = Update;
            {
              _fiberFlags2 |= LayoutStatic;
            }

            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) {
              _fiberFlags2 |= MountLayoutDev;
            }

            workInProgress.flags |= _fiberFlags2;
          }

          workInProgress.memoizedProps = newProps;
          workInProgress.memoizedState = newState;
        }

        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
      }

      function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;

        if (typeof contextType === 'object' && contextType !== null) {
          nextContext = _readContext(contextType);
        } else {
          var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }

        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function';

        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
          if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
          }
        }

        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;

        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
          if (typeof instance.componentDidUpdate === 'function') {
            if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.flags |= Update;
            }
          }

          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.flags |= Snapshot;
            }
          }

          return false;
        }

        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress.memoizedState;
        }

        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || enableLazyContextPropagation;

        if (shouldUpdate) {
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
            if (typeof instance.componentWillUpdate === 'function') {
              instance.componentWillUpdate(newProps, newState, nextContext);
            }

            if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
              instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
          }

          if (typeof instance.componentDidUpdate === 'function') {
            workInProgress.flags |= Update;
          }

          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            workInProgress.flags |= Snapshot;
          }
        } else {
          if (typeof instance.componentDidUpdate === 'function') {
            if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.flags |= Update;
            }
          }

          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.flags |= Snapshot;
            }
          }

          workInProgress.memoizedProps = newProps;
          workInProgress.memoizedState = newState;
        }

        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
      }

      var forkStack = [];
      var forkStackIndex = 0;
      var treeForkProvider = null;
      var treeForkCount = 0;
      var idStack = [];
      var idStackIndex = 0;
      var treeContextProvider = null;
      var treeContextId = 1;
      var treeContextOverflow = '';

      function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
      }

      function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
      }

      function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
      }

      function pushTreeFork(workInProgress, totalChildren) {
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
      }

      function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow;
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength;

        if (length > 30) {
          var numberOfOverflowBits = baseLength - baseLength % 5;
          var newOverflowBits = (1 << numberOfOverflowBits) - 1;
          var newOverflow = (baseId & newOverflowBits).toString(32);
          var restOfBaseId = baseId >> numberOfOverflowBits;
          var restOfBaseLength = baseLength - numberOfOverflowBits;
          var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
          var restOfNewBits = slot << restOfBaseLength;
          var id = restOfNewBits | restOfBaseId;
          var overflow = newOverflow + baseOverflow;
          treeContextId = 1 << restOfLength | id;
          treeContextOverflow = overflow;
        } else {
          var newBits = slot << baseLength;

          var _id = newBits | baseId;

          var _overflow = baseOverflow;
          treeContextId = 1 << length | _id;
          treeContextOverflow = _overflow;
        }
      }

      function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating();
        var returnFiber = workInProgress["return"];

        if (returnFiber !== null) {
          var numberOfForks = 1;
          var slotIndex = 0;
          pushTreeFork(workInProgress, numberOfForks);
          pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
      }

      function getBitLength(number) {
        return 32 - clz32(number);
      }

      function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
      }

      function popTreeContext(workInProgress) {
        while (workInProgress === treeForkProvider) {
          treeForkProvider = forkStack[--forkStackIndex];
          forkStack[forkStackIndex] = null;
          treeForkCount = forkStack[--forkStackIndex];
          forkStack[forkStackIndex] = null;
        }

        while (workInProgress === treeContextProvider) {
          treeContextProvider = idStack[--idStackIndex];
          idStack[idStackIndex] = null;
          treeContextOverflow = idStack[--idStackIndex];
          idStack[idStackIndex] = null;
          treeContextId = idStack[--idStackIndex];
          idStack[idStackIndex] = null;
        }
      }

      function getSuspendedTreeContext() {
        warnIfNotHydrating();

        if (treeContextProvider !== null) {
          return {
            id: treeContextId,
            overflow: treeContextOverflow
          };
        } else {
          return null;
        }
      }

      function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
      }

      function warnIfNotHydrating() {
        {
          if (!getIsHydrating()) {
            error('Expected to be hydrating. This is a bug in React. Please file ' + 'an issue.');
          }
        }
      }

      var hydrationParentFiber = null;
      var nextHydratableInstance = null;
      var isHydrating = false;
      var didSuspendOrErrorDEV = false;
      var hydrationErrors = null;

      function warnIfHydrating() {
        {
          if (isHydrating) {
            error('We should not be hydrating here. This is a bug in React. Please file a bug.');
          }
        }
      }

      function markDidThrowWhileHydratingDEV() {
        {
          didSuspendOrErrorDEV = true;
        }
      }

      function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
      }

      function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;

        if (treeContext !== null) {
          restoreSuspendedTreeContext(fiber, treeContext);
        }

        return true;
      }

      function warnUnhydratedInstance(returnFiber, instance) {
        {
          switch (returnFiber.tag) {
            case HostRoot:
              {
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
              }

            case HostComponent:
              {
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
              }

            case SuspenseComponent:
              {
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
              }
          }
        }
      }

      function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete["return"] = returnFiber;
        var deletions = returnFiber.deletions;

        if (deletions === null) {
          returnFiber.deletions = [childToDelete];
          returnFiber.flags |= ChildDeletion;
        } else {
          deletions.push(childToDelete);
        }
      }

      function warnNonhydratedInstance(returnFiber, fiber) {
        {
          if (didSuspendOrErrorDEV) {
            return;
          }

          switch (returnFiber.tag) {
            case HostRoot:
              {
                var parentContainer = returnFiber.stateNode.containerInfo;

                switch (fiber.tag) {
                  case HostComponent:
                    var type = fiber.type;
                    didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                    break;

                  case HostText:
                    var text = fiber.pendingProps;
                    didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                    break;
                }

                break;
              }

            case HostComponent:
              {
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;

                switch (fiber.tag) {
                  case HostComponent:
                    {
                      var _type = fiber.type;
                      var _props = fiber.pendingProps;
                      var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                      didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                      break;
                    }

                  case HostText:
                    {
                      var _text = fiber.pendingProps;

                      var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;

                      didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                      break;
                    }
                }

                break;
              }

            case SuspenseComponent:
              {
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch (fiber.tag) {
                  case HostComponent:
                    var _type2 = fiber.type;
                    didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                    break;

                  case HostText:
                    var _text2 = fiber.pendingProps;
                    didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                    break;
                }
                break;
              }

            default:
              return;
          }
        }
      }

      function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
      }

      function tryHydrate(fiber, nextInstance) {
        switch (fiber.tag) {
          case HostComponent:
            {
              var type = fiber.type;
              var instance = canHydrateInstance(nextInstance, type);

              if (instance !== null) {
                fiber.stateNode = instance;
                hydrationParentFiber = fiber;
                nextHydratableInstance = getFirstHydratableChild(instance);
                return true;
              }

              return false;
            }

          case HostText:
            {
              var text = fiber.pendingProps;
              var textInstance = canHydrateTextInstance(nextInstance, text);

              if (textInstance !== null) {
                fiber.stateNode = textInstance;
                hydrationParentFiber = fiber;
                nextHydratableInstance = null;
                return true;
              }

              return false;
            }

          case SuspenseComponent:
            {
              var suspenseInstance = canHydrateSuspenseInstance(nextInstance);

              if (suspenseInstance !== null) {
                var suspenseState = {
                  dehydrated: suspenseInstance,
                  treeContext: getSuspendedTreeContext(),
                  retryLane: OffscreenLane
                };
                fiber.memoizedState = suspenseState;
                var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                dehydratedFragment["return"] = fiber;
                fiber.child = dehydratedFragment;
                hydrationParentFiber = fiber;
                nextHydratableInstance = null;
                return true;
              }

              return false;
            }

          default:
            return false;
        }
      }

      function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
      }

      function throwOnHydrationMismatch(fiber) {
        throw new Error('Hydration failed because the initial UI does not match what was ' + 'rendered on the server.');
      }

      function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) {
          return;
        }

        var nextInstance = nextHydratableInstance;

        if (!nextInstance) {
          if (shouldClientRenderOnMismatch(fiber)) {
            warnNonhydratedInstance(hydrationParentFiber, fiber);
            throwOnHydrationMismatch();
          }

          insertNonHydratedInstance(hydrationParentFiber, fiber);
          isHydrating = false;
          hydrationParentFiber = fiber;
          return;
        }

        var firstAttemptedInstance = nextInstance;

        if (!tryHydrate(fiber, nextInstance)) {
          if (shouldClientRenderOnMismatch(fiber)) {
            warnNonhydratedInstance(hydrationParentFiber, fiber);
            throwOnHydrationMismatch();
          }

          nextInstance = getNextHydratableSibling(firstAttemptedInstance);
          var prevHydrationParentFiber = hydrationParentFiber;

          if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
          }

          deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
      }

      function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev);
        fiber.updateQueue = updatePayload;

        if (updatePayload !== null) {
          return true;
        }

        return false;
      }

      function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);

        if (shouldUpdate) {
          var returnFiber = hydrationParentFiber;

          if (returnFiber !== null) {
            switch (returnFiber.tag) {
              case HostRoot:
                {
                  var parentContainer = returnFiber.stateNode.containerInfo;
                  var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                  didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                  break;
                }

              case HostComponent:
                {
                  var parentType = returnFiber.type;
                  var parentProps = returnFiber.memoizedProps;
                  var parentInstance = returnFiber.stateNode;

                  var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;

                  didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                  break;
                }
            }
          }
        }

        return shouldUpdate;
      }

      function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;

        if (!suspenseInstance) {
          throw new Error('Expected to have a hydrated suspense instance. ' + 'This error is likely caused by a bug in React. Please file an issue.');
        }

        hydrateSuspenseInstance(suspenseInstance, fiber);
      }

      function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;

        if (!suspenseInstance) {
          throw new Error('Expected to have a hydrated suspense instance. ' + 'This error is likely caused by a bug in React. Please file an issue.');
        }

        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
      }

      function popToNextHostParent(fiber) {
        var parent = fiber["return"];

        while (parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent) {
          parent = parent["return"];
        }

        hydrationParentFiber = parent;
      }

      function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) {
          return false;
        }

        if (!isHydrating) {
          popToNextHostParent(fiber);
          isHydrating = true;
          return false;
        }

        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
          var nextInstance = nextHydratableInstance;

          if (nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
              warnIfUnhydratedTailNodes(fiber);
              throwOnHydrationMismatch();
            } else {
              while (nextInstance) {
                deleteHydratableInstance(fiber, nextInstance);
                nextInstance = getNextHydratableSibling(nextInstance);
              }
            }
          }
        }

        popToNextHostParent(fiber);

        if (fiber.tag === SuspenseComponent) {
          nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        } else {
          nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        }

        return true;
      }

      function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
      }

      function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;

        while (nextInstance) {
          warnUnhydratedInstance(fiber, nextInstance);
          nextInstance = getNextHydratableSibling(nextInstance);
        }
      }

      function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
      }

      function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
          queueRecoverableErrors(hydrationErrors);
          hydrationErrors = null;
        }
      }

      function getIsHydrating() {
        return isHydrating;
      }

      function queueHydrationError(error) {
        if (hydrationErrors === null) {
          hydrationErrors = [error];
        } else {
          hydrationErrors.push(error);
        }
      }

      var didWarnAboutMaps;
      var didWarnAboutGenerators;
      var didWarnAboutStringRefs;
      var ownerHasKeyUseWarning;
      var ownerHasFunctionTypeWarning;

      var warnForMissingKey = function warnForMissingKey(child, returnFiber) {};

      {
        didWarnAboutMaps = false;
        didWarnAboutGenerators = false;
        didWarnAboutStringRefs = {};
        ownerHasKeyUseWarning = {};
        ownerHasFunctionTypeWarning = {};

        warnForMissingKey = function warnForMissingKey(child, returnFiber) {
          if (child === null || typeof child !== 'object') {
            return;
          }

          if (!child._store || child._store.validated || child.key != null) {
            return;
          }

          if (typeof child._store !== 'object') {
            throw new Error('React Component in warnForMissingKey should have a _store. ' + 'This error is likely caused by a bug in React. Please file an issue.');
          }

          child._store.validated = true;
          var componentName = getComponentNameFromFiber(returnFiber) || 'Component';

          if (ownerHasKeyUseWarning[componentName]) {
            return;
          }

          ownerHasKeyUseWarning[componentName] = true;
          error('Each child in a list should have a unique ' + '"key" prop. See https://reactjs.org/link/warning-keys for ' + 'more information.');
        };
      }

      function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;

        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
          {
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && !(element._owner && element._self && element._owner.stateNode !== element._self)) {
              var componentName = getComponentNameFromFiber(returnFiber) || 'Component';

              if (!didWarnAboutStringRefs[componentName]) {
                {
                  error('A string ref, "%s", has been found within a strict mode tree. ' + 'String refs are a source of potential bugs and should be avoided. ' + 'We recommend using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                }
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }

          if (element._owner) {
            var owner = element._owner;
            var inst;

            if (owner) {
              var ownerFiber = owner;

              if (ownerFiber.tag !== ClassComponent) {
                throw new Error('Function components cannot have string refs. ' + 'We recommend using useRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref');
              }

              inst = ownerFiber.stateNode;
            }

            if (!inst) {
              throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + 'bug in React. Please file an issue.');
            }

            var resolvedInst = inst;
            {
              checkPropStringCoercion(mixedRef, 'ref');
            }
            var stringRef = '' + mixedRef;

            if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) {
              return current.ref;
            }

            var ref = function ref(value) {
              var refs = resolvedInst.refs;

              if (refs === emptyRefsObject) {
                refs = resolvedInst.refs = {};
              }

              if (value === null) {
                delete refs[stringRef];
              } else {
                refs[stringRef] = value;
              }
            };

            ref._stringRef = stringRef;
            return ref;
          } else {
            if (typeof mixedRef !== 'string') {
              throw new Error('Expected ref to be a function, a string, an object returned by React.createRef(), or null.');
            }

            if (!element._owner) {
              throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + ' the following reasons:\n' + '1. You may be adding a ref to a function component\n' + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + '3. You have multiple copies of React loaded\n' + 'See https://reactjs.org/link/refs-must-have-owner for more information.');
            }
          }
        }

        return mixedRef;
      }

      function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : childString) + "). " + 'If you meant to render a collection of children, use an array ' + 'instead.');
      }

      function warnOnFunctionType(returnFiber) {
        {
          var componentName = getComponentNameFromFiber(returnFiber) || 'Component';

          if (ownerHasFunctionTypeWarning[componentName]) {
            return;
          }

          ownerHasFunctionTypeWarning[componentName] = true;
          error('Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.');
        }
      }

      function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
      }

      function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
          if (!shouldTrackSideEffects) {
            return;
          }

          var deletions = returnFiber.deletions;

          if (deletions === null) {
            returnFiber.deletions = [childToDelete];
            returnFiber.flags |= ChildDeletion;
          } else {
            deletions.push(childToDelete);
          }
        }

        function deleteRemainingChildren(returnFiber, currentFirstChild) {
          if (!shouldTrackSideEffects) {
            return null;
          }

          var childToDelete = currentFirstChild;

          while (childToDelete !== null) {
            deleteChild(returnFiber, childToDelete);
            childToDelete = childToDelete.sibling;
          }

          return null;
        }

        function mapRemainingChildren(returnFiber, currentFirstChild) {
          var existingChildren = new Map();
          var existingChild = currentFirstChild;

          while (existingChild !== null) {
            if (existingChild.key !== null) {
              existingChildren.set(existingChild.key, existingChild);
            } else {
              existingChildren.set(existingChild.index, existingChild);
            }

            existingChild = existingChild.sibling;
          }

          return existingChildren;
        }

        function useFiber(fiber, pendingProps) {
          var clone = createWorkInProgress(fiber, pendingProps);
          clone.index = 0;
          clone.sibling = null;
          return clone;
        }

        function placeChild(newFiber, lastPlacedIndex, newIndex) {
          newFiber.index = newIndex;

          if (!shouldTrackSideEffects) {
            newFiber.flags |= Forked;
            return lastPlacedIndex;
          }

          var current = newFiber.alternate;

          if (current !== null) {
            var oldIndex = current.index;

            if (oldIndex < lastPlacedIndex) {
              newFiber.flags |= Placement;
              return lastPlacedIndex;
            } else {
              return oldIndex;
            }
          } else {
            newFiber.flags |= Placement;
            return lastPlacedIndex;
          }
        }

        function placeSingleChild(newFiber) {
          if (shouldTrackSideEffects && newFiber.alternate === null) {
            newFiber.flags |= Placement;
          }

          return newFiber;
        }

        function updateTextNode(returnFiber, current, textContent, lanes) {
          if (current === null || current.tag !== HostText) {
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created["return"] = returnFiber;
            return created;
          } else {
            var existing = useFiber(current, textContent);
            existing["return"] = returnFiber;
            return existing;
          }
        }

        function updateElement(returnFiber, current, element, lanes) {
          var elementType = element.type;

          if (elementType === REACT_FRAGMENT_TYPE) {
            return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
          }

          if (current !== null) {
            if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || typeof elementType === 'object' && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
              var existing = useFiber(current, element.props);
              existing.ref = coerceRef(returnFiber, current, element);
              existing["return"] = returnFiber;
              {
                existing._debugSource = element._source;
                existing._debugOwner = element._owner;
              }
              return existing;
            }
          }

          var created = createFiberFromElement(element, returnFiber.mode, lanes);
          created.ref = coerceRef(returnFiber, current, element);
          created["return"] = returnFiber;
          return created;
        }

        function updatePortal(returnFiber, current, portal, lanes) {
          if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created["return"] = returnFiber;
            return created;
          } else {
            var existing = useFiber(current, portal.children || []);
            existing["return"] = returnFiber;
            return existing;
          }
        }

        function updateFragment(returnFiber, current, fragment, lanes, key) {
          if (current === null || current.tag !== Fragment) {
            var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
            created["return"] = returnFiber;
            return created;
          } else {
            var existing = useFiber(current, fragment);
            existing["return"] = returnFiber;
            return existing;
          }
        }

        function createChild(returnFiber, newChild, lanes) {
          if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
            var created = createFiberFromText('' + newChild, returnFiber.mode, lanes);
            created["return"] = returnFiber;
            return created;
          }

          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);

                  _created.ref = coerceRef(returnFiber, null, newChild);
                  _created["return"] = returnFiber;
                  return _created;
                }

              case REACT_PORTAL_TYPE:
                {
                  var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);

                  _created2["return"] = returnFiber;
                  return _created2;
                }

              case REACT_LAZY_TYPE:
                {
                  var payload = newChild._payload;
                  var init = newChild._init;
                  return createChild(returnFiber, init(payload), lanes);
                }
            }

            if (isArray(newChild) || getIteratorFn(newChild)) {
              var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);

              _created3["return"] = returnFiber;
              return _created3;
            }

            throwOnInvalidObjectType(returnFiber, newChild);
          }

          {
            if (typeof newChild === 'function') {
              warnOnFunctionType(returnFiber);
            }
          }
          return null;
        }

        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
          var key = oldFiber !== null ? oldFiber.key : null;

          if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
            if (key !== null) {
              return null;
            }

            return updateTextNode(returnFiber, oldFiber, '' + newChild, lanes);
          }

          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  if (newChild.key === key) {
                    return updateElement(returnFiber, oldFiber, newChild, lanes);
                  } else {
                    return null;
                  }
                }

              case REACT_PORTAL_TYPE:
                {
                  if (newChild.key === key) {
                    return updatePortal(returnFiber, oldFiber, newChild, lanes);
                  } else {
                    return null;
                  }
                }

              case REACT_LAZY_TYPE:
                {
                  var payload = newChild._payload;
                  var init = newChild._init;
                  return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
            }

            if (isArray(newChild) || getIteratorFn(newChild)) {
              if (key !== null) {
                return null;
              }

              return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            }

            throwOnInvalidObjectType(returnFiber, newChild);
          }

          {
            if (typeof newChild === 'function') {
              warnOnFunctionType(returnFiber);
            }
          }
          return null;
        }

        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
          if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
            var matchedFiber = existingChildren.get(newIdx) || null;
            return updateTextNode(returnFiber, matchedFiber, '' + newChild, lanes);
          }

          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

                  return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                }

              case REACT_PORTAL_TYPE:
                {
                  var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

                  return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                }

              case REACT_LAZY_TYPE:
                var payload = newChild._payload;
                var init = newChild._init;
                return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
            }

            if (isArray(newChild) || getIteratorFn(newChild)) {
              var _matchedFiber3 = existingChildren.get(newIdx) || null;

              return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
            }

            throwOnInvalidObjectType(returnFiber, newChild);
          }

          {
            if (typeof newChild === 'function') {
              warnOnFunctionType(returnFiber);
            }
          }
          return null;
        }

        function warnOnInvalidKey(child, knownKeys, returnFiber) {
          {
            if (typeof child !== 'object' || child === null) {
              return knownKeys;
            }

            switch (child.$$typeof) {
              case REACT_ELEMENT_TYPE:
              case REACT_PORTAL_TYPE:
                warnForMissingKey(child, returnFiber);
                var key = child.key;

                if (typeof key !== 'string') {
                  break;
                }

                if (knownKeys === null) {
                  knownKeys = new Set();
                  knownKeys.add(key);
                  break;
                }

                if (!knownKeys.has(key)) {
                  knownKeys.add(key);
                  break;
                }

                error('Encountered two children with the same key, `%s`. ' + 'Keys should be unique so that components maintain their identity ' + 'across updates. Non-unique keys may cause children to be ' + 'duplicated and/or omitted — the behavior is unsupported and ' + 'could change in a future version.', key);
                break;

              case REACT_LAZY_TYPE:
                var payload = child._payload;
                var init = child._init;
                warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                break;
            }
          }
          return knownKeys;
        }

        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
          {
            var knownKeys = null;

            for (var i = 0; i < newChildren.length; i++) {
              var child = newChildren[i];
              knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
          }
          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;

          for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }

            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);

            if (newFiber === null) {
              if (oldFiber === null) {
                oldFiber = nextOldFiber;
              }

              break;
            }

            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                deleteChild(returnFiber, oldFiber);
              }
            }

            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

            if (previousNewFiber === null) {
              resultingFirstChild = newFiber;
            } else {
              previousNewFiber.sibling = newFiber;
            }

            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }

          if (newIdx === newChildren.length) {
            deleteRemainingChildren(returnFiber, oldFiber);

            if (getIsHydrating()) {
              var numberOfForks = newIdx;
              pushTreeFork(returnFiber, numberOfForks);
            }

            return resultingFirstChild;
          }

          if (oldFiber === null) {
            for (; newIdx < newChildren.length; newIdx++) {
              var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);

              if (_newFiber === null) {
                continue;
              }

              lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber;
              } else {
                previousNewFiber.sibling = _newFiber;
              }

              previousNewFiber = _newFiber;
            }

            if (getIsHydrating()) {
              var _numberOfForks = newIdx;
              pushTreeFork(returnFiber, _numberOfForks);
            }

            return resultingFirstChild;
          }

          var existingChildren = mapRemainingChildren(returnFiber, oldFiber);

          for (; newIdx < newChildren.length; newIdx++) {
            var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);

            if (_newFiber2 !== null) {
              if (shouldTrackSideEffects) {
                if (_newFiber2.alternate !== null) {
                  existingChildren["delete"](_newFiber2.key === null ? newIdx : _newFiber2.key);
                }
              }

              lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber2;
              } else {
                previousNewFiber.sibling = _newFiber2;
              }

              previousNewFiber = _newFiber2;
            }
          }

          if (shouldTrackSideEffects) {
            existingChildren.forEach(function (child) {
              return deleteChild(returnFiber, child);
            });
          }

          if (getIsHydrating()) {
            var _numberOfForks2 = newIdx;
            pushTreeFork(returnFiber, _numberOfForks2);
          }

          return resultingFirstChild;
        }

        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
          var iteratorFn = getIteratorFn(newChildrenIterable);

          if (typeof iteratorFn !== 'function') {
            throw new Error('An object is not an iterable. This error is likely caused by a bug in ' + 'React. Please file an issue.');
          }

          {
            if (typeof Symbol === 'function' && newChildrenIterable[Symbol.toStringTag] === 'Generator') {
              if (!didWarnAboutGenerators) {
                error('Using Generators as children is unsupported and will likely yield ' + 'unexpected results because enumerating a generator mutates it. ' + 'You may convert it to an array with `Array.from()` or the ' + '`[...spread]` operator before rendering. Keep in mind ' + 'you might need to polyfill these features for older browsers.');
              }

              didWarnAboutGenerators = true;
            }

            if (newChildrenIterable.entries === iteratorFn) {
              if (!didWarnAboutMaps) {
                error('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
              }

              didWarnAboutMaps = true;
            }

            var _newChildren = iteratorFn.call(newChildrenIterable);

            if (_newChildren) {
              var knownKeys = null;

              var _step = _newChildren.next();

              for (; !_step.done; _step = _newChildren.next()) {
                var child = _step.value;
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
              }
            }
          }
          var newChildren = iteratorFn.call(newChildrenIterable);

          if (newChildren == null) {
            throw new Error('An iterable object provided no iterator.');
          }

          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;
          var step = newChildren.next();

          for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }

            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);

            if (newFiber === null) {
              if (oldFiber === null) {
                oldFiber = nextOldFiber;
              }

              break;
            }

            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                deleteChild(returnFiber, oldFiber);
              }
            }

            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

            if (previousNewFiber === null) {
              resultingFirstChild = newFiber;
            } else {
              previousNewFiber.sibling = newFiber;
            }

            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }

          if (step.done) {
            deleteRemainingChildren(returnFiber, oldFiber);

            if (getIsHydrating()) {
              var numberOfForks = newIdx;
              pushTreeFork(returnFiber, numberOfForks);
            }

            return resultingFirstChild;
          }

          if (oldFiber === null) {
            for (; !step.done; newIdx++, step = newChildren.next()) {
              var _newFiber3 = createChild(returnFiber, step.value, lanes);

              if (_newFiber3 === null) {
                continue;
              }

              lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber3;
              } else {
                previousNewFiber.sibling = _newFiber3;
              }

              previousNewFiber = _newFiber3;
            }

            if (getIsHydrating()) {
              var _numberOfForks3 = newIdx;
              pushTreeFork(returnFiber, _numberOfForks3);
            }

            return resultingFirstChild;
          }

          var existingChildren = mapRemainingChildren(returnFiber, oldFiber);

          for (; !step.done; newIdx++, step = newChildren.next()) {
            var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);

            if (_newFiber4 !== null) {
              if (shouldTrackSideEffects) {
                if (_newFiber4.alternate !== null) {
                  existingChildren["delete"](_newFiber4.key === null ? newIdx : _newFiber4.key);
                }
              }

              lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber4;
              } else {
                previousNewFiber.sibling = _newFiber4;
              }

              previousNewFiber = _newFiber4;
            }
          }

          if (shouldTrackSideEffects) {
            existingChildren.forEach(function (child) {
              return deleteChild(returnFiber, child);
            });
          }

          if (getIsHydrating()) {
            var _numberOfForks4 = newIdx;
            pushTreeFork(returnFiber, _numberOfForks4);
          }

          return resultingFirstChild;
        }

        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
          if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
            var existing = useFiber(currentFirstChild, textContent);
            existing["return"] = returnFiber;
            return existing;
          }

          deleteRemainingChildren(returnFiber, currentFirstChild);
          var created = createFiberFromText(textContent, returnFiber.mode, lanes);
          created["return"] = returnFiber;
          return created;
        }

        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
          var key = element.key;
          var child = currentFirstChild;

          while (child !== null) {
            if (child.key === key) {
              var elementType = element.type;

              if (elementType === REACT_FRAGMENT_TYPE) {
                if (child.tag === Fragment) {
                  deleteRemainingChildren(returnFiber, child.sibling);
                  var existing = useFiber(child, element.props.children);
                  existing["return"] = returnFiber;
                  {
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                  }
                  return existing;
                }
              } else {
                if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || typeof elementType === 'object' && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                  deleteRemainingChildren(returnFiber, child.sibling);

                  var _existing = useFiber(child, element.props);

                  _existing.ref = coerceRef(returnFiber, child, element);
                  _existing["return"] = returnFiber;
                  {
                    _existing._debugSource = element._source;
                    _existing._debugOwner = element._owner;
                  }
                  return _existing;
                }
              }

              deleteRemainingChildren(returnFiber, child);
              break;
            } else {
              deleteChild(returnFiber, child);
            }

            child = child.sibling;
          }

          if (element.type === REACT_FRAGMENT_TYPE) {
            var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
            created["return"] = returnFiber;
            return created;
          } else {
            var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);

            _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
            _created4["return"] = returnFiber;
            return _created4;
          }
        }

        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
          var key = portal.key;
          var child = currentFirstChild;

          while (child !== null) {
            if (child.key === key) {
              if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                deleteRemainingChildren(returnFiber, child.sibling);
                var existing = useFiber(child, portal.children || []);
                existing["return"] = returnFiber;
                return existing;
              } else {
                deleteRemainingChildren(returnFiber, child);
                break;
              }
            } else {
              deleteChild(returnFiber, child);
            }

            child = child.sibling;
          }

          var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
          created["return"] = returnFiber;
          return created;
        }

        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
          var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;

          if (isUnkeyedTopLevelFragment) {
            newChild = newChild.props.children;
          }

          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));

              case REACT_PORTAL_TYPE:
                return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));

              case REACT_LAZY_TYPE:
                var payload = newChild._payload;
                var init = newChild._init;
                return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
            }

            if (isArray(newChild)) {
              return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            }

            if (getIteratorFn(newChild)) {
              return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }

            throwOnInvalidObjectType(returnFiber, newChild);
          }

          if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
            return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, lanes));
          }

          {
            if (typeof newChild === 'function') {
              warnOnFunctionType(returnFiber);
            }
          }
          return deleteRemainingChildren(returnFiber, currentFirstChild);
        }

        return reconcileChildFibers;
      }

      var reconcileChildFibers = ChildReconciler(true);
      var mountChildFibers = ChildReconciler(false);

      function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) {
          throw new Error('Resuming work not yet implemented.');
        }

        if (workInProgress.child === null) {
          return;
        }

        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild["return"] = workInProgress;

        while (currentChild.sibling !== null) {
          currentChild = currentChild.sibling;
          newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
          newChild["return"] = workInProgress;
        }

        newChild.sibling = null;
      }

      function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;

        while (child !== null) {
          resetWorkInProgress(child, lanes);
          child = child.sibling;
        }
      }

      var NO_CONTEXT = {};
      var contextStackCursor$1 = createCursor(NO_CONTEXT);
      var contextFiberStackCursor = createCursor(NO_CONTEXT);
      var rootInstanceStackCursor = createCursor(NO_CONTEXT);

      function requiredContext(c) {
        if (c === NO_CONTEXT) {
          throw new Error('Expected host context to exist. This error is likely caused by a bug ' + 'in React. Please file an issue.');
        }

        return c;
      }

      function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
      }

      function pushHostContainer(fiber, nextRootInstance) {
        push(rootInstanceStackCursor, nextRootInstance, fiber);
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance);
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
      }

      function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
      }

      function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
      }

      function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type);

        if (context === nextContext) {
          return;
        }

        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
      }

      function popHostContext(fiber) {
        if (contextFiberStackCursor.current !== fiber) {
          return;
        }

        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
      }

      var DefaultSuspenseContext = 0;
      var SubtreeSuspenseContextMask = 1;
      var InvisibleParentSuspenseContext = 1;
      var ForceSuspenseFallback = 2;
      var suspenseStackCursor = createCursor(DefaultSuspenseContext);

      function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
      }

      function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
      }

      function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
      }

      function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
      }

      function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
      }

      function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
      }

      function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        var nextState = workInProgress.memoizedState;

        if (nextState !== null) {
          if (nextState.dehydrated !== null) {
            return true;
          }

          return false;
        }
        {
          return true;
        }
      }

      function findFirstSuspended(row) {
        var node = row;

        while (node !== null) {
          if (node.tag === SuspenseComponent) {
            var state = node.memoizedState;

            if (state !== null) {
              var dehydrated = state.dehydrated;

              if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) {
                return node;
              }
            }
          } else if (node.tag === SuspenseListComponent && node.memoizedProps.revealOrder !== undefined) {
            var didSuspend = (node.flags & DidCapture) !== NoFlags;

            if (didSuspend) {
              return node;
            }
          } else if (node.child !== null) {
            node.child["return"] = node;
            node = node.child;
            continue;
          }

          if (node === row) {
            return null;
          }

          while (node.sibling === null) {
            if (node["return"] === null || node["return"] === row) {
              return null;
            }

            node = node["return"];
          }

          node.sibling["return"] = node["return"];
          node = node.sibling;
        }

        return null;
      }

      var NoFlags$1 = 0;
      var HasEffect = 1;
      var Insertion = 2;
      var Layout = 4;
      var Passive$1 = 8;
      var workInProgressSources = [];

      function resetWorkInProgressVersions() {
        for (var i = 0; i < workInProgressSources.length; i++) {
          var mutableSource = workInProgressSources[i];
          {
            mutableSource._workInProgressVersionPrimary = null;
          }
        }

        workInProgressSources.length = 0;
      }

      function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source);

        if (root.mutableSourceEagerHydrationData == null) {
          root.mutableSourceEagerHydrationData = [mutableSource, version];
        } else {
          root.mutableSourceEagerHydrationData.push(mutableSource, version);
        }
      }

      var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher,
          ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
      var didWarnAboutMismatchedHooksForComponent;
      var didWarnUncachedGetSnapshot;
      {
        didWarnAboutMismatchedHooksForComponent = new Set();
      }
      var renderLanes = NoLanes;
      var currentlyRenderingFiber$1 = null;
      var currentHook = null;
      var workInProgressHook = null;
      var didScheduleRenderPhaseUpdate = false;
      var didScheduleRenderPhaseUpdateDuringThisPass = false;
      var localIdCounter = 0;
      var globalClientIdCounter = 0;
      var RE_RENDER_LIMIT = 25;
      var currentHookNameInDev = null;
      var hookTypesDev = null;
      var hookTypesUpdateIndexDev = -1;
      var ignorePreviousDependencies = false;

      function mountHookTypesDev() {
        {
          var hookName = currentHookNameInDev;

          if (hookTypesDev === null) {
            hookTypesDev = [hookName];
          } else {
            hookTypesDev.push(hookName);
          }
        }
      }

      function updateHookTypesDev() {
        {
          var hookName = currentHookNameInDev;

          if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;

            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
              warnOnHookMismatchInDev(hookName);
            }
          }
        }
      }

      function checkDepsAreArrayDev(deps) {
        {
          if (deps !== undefined && deps !== null && !isArray(deps)) {
            error('%s received a final argument that is not an array (instead, received `%s`). When ' + 'specified, the final argument must be an array.', currentHookNameInDev, typeof deps);
          }
        }
      }

      function warnOnHookMismatchInDev(currentHookName) {
        {
          var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);

          if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);

            if (hookTypesDev !== null) {
              var table = '';
              var secondColumnStart = 30;

              for (var i = 0; i <= hookTypesUpdateIndexDev; i++) {
                var oldHookName = hookTypesDev[i];
                var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                var row = i + 1 + ". " + oldHookName;

                while (row.length < secondColumnStart) {
                  row += ' ';
                }

                row += newHookName + '\n';
                table += row;
              }

              error('React has detected a change in the order of Hooks called by %s. ' + 'This will lead to bugs and errors if not fixed. ' + 'For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n' + '   Previous render            Next render\n' + '   ------------------------------------------------------\n' + '%s' + '   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n', componentName, table);
            }
          }
        }
      }

      function throwInvalidHookError() {
        throw new Error('Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for' + ' one of the following reasons:\n' + '1. You might have mismatching versions of React and the renderer (such as React DOM)\n' + '2. You might be breaking the Rules of Hooks\n' + '3. You might have more than one copy of React in the same app\n' + 'See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.');
      }

      function areHookInputsEqual(nextDeps, prevDeps) {
        {
          if (ignorePreviousDependencies) {
            return false;
          }
        }

        if (prevDeps === null) {
          {
            error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
          }
          return false;
        }

        {
          if (nextDeps.length !== prevDeps.length) {
            error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
          }
        }

        for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
          if (objectIs(nextDeps[i], prevDeps[i])) {
            continue;
          }

          return false;
        }

        return true;
      }

      function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        {
          hookTypesDev = current !== null ? current._debugHookTypes : null;
          hookTypesUpdateIndexDev = -1;
          ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        }
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes;
        {
          if (current !== null && current.memoizedState !== null) {
            ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
          } else if (hookTypesDev !== null) {
            ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
          } else {
            ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
          }
        }
        var children = Component(props, secondArg);

        if (didScheduleRenderPhaseUpdateDuringThisPass) {
          var numberOfReRenders = 0;

          do {
            didScheduleRenderPhaseUpdateDuringThisPass = false;
            localIdCounter = 0;

            if (numberOfReRenders >= RE_RENDER_LIMIT) {
              throw new Error('Too many re-renders. React limits the number of renders to prevent ' + 'an infinite loop.');
            }

            numberOfReRenders += 1;
            {
              ignorePreviousDependencies = false;
            }
            currentHook = null;
            workInProgressHook = null;
            workInProgress.updateQueue = null;
            {
              hookTypesUpdateIndexDev = -1;
            }
            ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
            children = Component(props, secondArg);
          } while (didScheduleRenderPhaseUpdateDuringThisPass);
        }

        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        {
          workInProgress._debugHookTypes = hookTypesDev;
        }
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        {
          currentHookNameInDev = null;
          hookTypesDev = null;
          hookTypesUpdateIndexDev = -1;

          if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && (current.mode & ConcurrentMode) !== NoMode) {
            error('Internal React error: Expected static flag was missing. Please ' + 'notify the React team.');
          }
        }
        didScheduleRenderPhaseUpdate = false;

        if (didRenderTooFewHooks) {
          throw new Error('Rendered fewer hooks than expected. This may be caused by an accidental ' + 'early return statement.');
        }

        return children;
      }

      function checkDidRenderIdHook() {
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
      }

      function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue;

        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) {
          workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        } else {
          workInProgress.flags &= ~(Passive | Update);
        }

        current.lanes = removeLanes(current.lanes, lanes);
      }

      function resetHooksAfterThrow() {
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;

        if (didScheduleRenderPhaseUpdate) {
          var hook = currentlyRenderingFiber$1.memoizedState;

          while (hook !== null) {
            var queue = hook.queue;

            if (queue !== null) {
              queue.pending = null;
            }

            hook = hook.next;
          }

          didScheduleRenderPhaseUpdate = false;
        }

        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        {
          hookTypesDev = null;
          hookTypesUpdateIndexDev = -1;
          currentHookNameInDev = null;
          isUpdatingOpaqueValueInRenderPhase = false;
        }
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
      }

      function mountWorkInProgressHook() {
        var hook = {
          memoizedState: null,
          baseState: null,
          baseQueue: null,
          queue: null,
          next: null
        };

        if (workInProgressHook === null) {
          currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        } else {
          workInProgressHook = workInProgressHook.next = hook;
        }

        return workInProgressHook;
      }

      function updateWorkInProgressHook() {
        var nextCurrentHook;

        if (currentHook === null) {
          var current = currentlyRenderingFiber$1.alternate;

          if (current !== null) {
            nextCurrentHook = current.memoizedState;
          } else {
            nextCurrentHook = null;
          }
        } else {
          nextCurrentHook = currentHook.next;
        }

        var nextWorkInProgressHook;

        if (workInProgressHook === null) {
          nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        } else {
          nextWorkInProgressHook = workInProgressHook.next;
        }

        if (nextWorkInProgressHook !== null) {
          workInProgressHook = nextWorkInProgressHook;
          nextWorkInProgressHook = workInProgressHook.next;
          currentHook = nextCurrentHook;
        } else {
          if (nextCurrentHook === null) {
            throw new Error('Rendered more hooks than during the previous render.');
          }

          currentHook = nextCurrentHook;
          var newHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
          };

          if (workInProgressHook === null) {
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
          } else {
            workInProgressHook = workInProgressHook.next = newHook;
          }
        }

        return workInProgressHook;
      }

      function createFunctionComponentUpdateQueue() {
        return {
          lastEffect: null,
          stores: null
        };
      }

      function basicStateReducer(state, action) {
        return typeof action === 'function' ? action(state) : action;
      }

      function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;

        if (init !== undefined) {
          initialState = init(initialArg);
        } else {
          initialState = initialArg;
        }

        hook.memoizedState = hook.baseState = initialState;
        var queue = {
          pending: null,
          interleaved: null,
          lanes: NoLanes,
          dispatch: null,
          lastRenderedReducer: reducer,
          lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [hook.memoizedState, dispatch];
      }

      function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;

        if (queue === null) {
          throw new Error('Should have a queue. This is likely a bug in React. Please file an issue.');
        }

        queue.lastRenderedReducer = reducer;
        var current = currentHook;
        var baseQueue = current.baseQueue;
        var pendingQueue = queue.pending;

        if (pendingQueue !== null) {
          if (baseQueue !== null) {
            var baseFirst = baseQueue.next;
            var pendingFirst = pendingQueue.next;
            baseQueue.next = pendingFirst;
            pendingQueue.next = baseFirst;
          }

          {
            if (current.baseQueue !== baseQueue) {
              error('Internal error: Expected work-in-progress queue to be a clone. ' + 'This is a bug in React.');
            }
          }
          current.baseQueue = baseQueue = pendingQueue;
          queue.pending = null;
        }

        if (baseQueue !== null) {
          var first = baseQueue.next;
          var newState = current.baseState;
          var newBaseState = null;
          var newBaseQueueFirst = null;
          var newBaseQueueLast = null;
          var update = first;

          do {
            var updateLane = update.lane;

            if (!isSubsetOfLanes(renderLanes, updateLane)) {
              var clone = {
                lane: updateLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
              };

              if (newBaseQueueLast === null) {
                newBaseQueueFirst = newBaseQueueLast = clone;
                newBaseState = newState;
              } else {
                newBaseQueueLast = newBaseQueueLast.next = clone;
              }

              currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
              markSkippedUpdateLanes(updateLane);
            } else {
              if (newBaseQueueLast !== null) {
                var _clone = {
                  lane: NoLane,
                  action: update.action,
                  hasEagerState: update.hasEagerState,
                  eagerState: update.eagerState,
                  next: null
                };
                newBaseQueueLast = newBaseQueueLast.next = _clone;
              }

              if (update.hasEagerState) {
                newState = update.eagerState;
              } else {
                var action = update.action;
                newState = reducer(newState, action);
              }
            }

            update = update.next;
          } while (update !== null && update !== first);

          if (newBaseQueueLast === null) {
            newBaseState = newState;
          } else {
            newBaseQueueLast.next = newBaseQueueFirst;
          }

          if (!objectIs(newState, hook.memoizedState)) {
            markWorkInProgressReceivedUpdate();
          }

          hook.memoizedState = newState;
          hook.baseState = newBaseState;
          hook.baseQueue = newBaseQueueLast;
          queue.lastRenderedState = newState;
        }

        var lastInterleaved = queue.interleaved;

        if (lastInterleaved !== null) {
          var interleaved = lastInterleaved;

          do {
            var interleavedLane = interleaved.lane;
            currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
            markSkippedUpdateLanes(interleavedLane);
            interleaved = interleaved.next;
          } while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) {
          queue.lanes = NoLanes;
        }

        var dispatch = queue.dispatch;
        return [hook.memoizedState, dispatch];
      }

      function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;

        if (queue === null) {
          throw new Error('Should have a queue. This is likely a bug in React. Please file an issue.');
        }

        queue.lastRenderedReducer = reducer;
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;

        if (lastRenderPhaseUpdate !== null) {
          queue.pending = null;
          var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
          var update = firstRenderPhaseUpdate;

          do {
            var action = update.action;
            newState = reducer(newState, action);
            update = update.next;
          } while (update !== firstRenderPhaseUpdate);

          if (!objectIs(newState, hook.memoizedState)) {
            markWorkInProgressReceivedUpdate();
          }

          hook.memoizedState = newState;

          if (hook.baseQueue === null) {
            hook.baseState = newState;
          }

          queue.lastRenderedState = newState;
        }

        return [newState, dispatch];
      }

      function mountMutableSource(source, getSnapshot, subscribe) {
        {
          return undefined;
        }
      }

      function updateMutableSource(source, getSnapshot, subscribe) {
        {
          return undefined;
        }
      }

      function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();

        if (isHydrating) {
          if (getServerSnapshot === undefined) {
            throw new Error('Missing getServerSnapshot, which is required for ' + 'server-rendered content. Will revert to client rendering.');
          }

          nextSnapshot = getServerSnapshot();
          {
            if (!didWarnUncachedGetSnapshot) {
              if (nextSnapshot !== getServerSnapshot()) {
                error('The result of getServerSnapshot should be cached to avoid an infinite loop');
                didWarnUncachedGetSnapshot = true;
              }
            }
          }
        } else {
          nextSnapshot = getSnapshot();
          {
            if (!didWarnUncachedGetSnapshot) {
              var cachedSnapshot = getSnapshot();

              if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error('The result of getSnapshot should be cached to avoid an infinite loop');
                didWarnUncachedGetSnapshot = true;
              }
            }
          }
          var root = getWorkInProgressRoot();

          if (root === null) {
            throw new Error('Expected a work-in-progress root. This is a bug in React. Please file an issue.');
          }

          if (!includesBlockingLane(root, renderLanes)) {
            pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
          }
        }

        hook.memoizedState = nextSnapshot;
        var inst = {
          value: nextSnapshot,
          getSnapshot: getSnapshot
        };
        hook.queue = inst;
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [subscribe]);
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
      }

      function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook();
        var nextSnapshot = getSnapshot();
        {
          if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();

            if (!objectIs(nextSnapshot, cachedSnapshot)) {
              error('The result of getSnapshot should be cached to avoid an infinite loop');
              didWarnUncachedGetSnapshot = true;
            }
          }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);

        if (snapshotChanged) {
          hook.memoizedState = nextSnapshot;
          markWorkInProgressReceivedUpdate();
        }

        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [subscribe]);

        if (inst.getSnapshot !== getSnapshot || snapshotChanged || workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
          fiber.flags |= Passive;
          pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
          var root = getWorkInProgressRoot();

          if (root === null) {
            throw new Error('Expected a work-in-progress root. This is a bug in React. Please file an issue.');
          }

          if (!includesBlockingLane(root, renderLanes)) {
            pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
          }
        }

        return nextSnapshot;
      }

      function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
          getSnapshot: getSnapshot,
          value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;

        if (componentUpdateQueue === null) {
          componentUpdateQueue = createFunctionComponentUpdateQueue();
          currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
          componentUpdateQueue.stores = [check];
        } else {
          var stores = componentUpdateQueue.stores;

          if (stores === null) {
            componentUpdateQueue.stores = [check];
          } else {
            stores.push(check);
          }
        }
      }

      function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot;

        if (checkIfSnapshotChanged(inst)) {
          forceStoreRerender(fiber);
        }
      }

      function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function handleStoreChange() {
          if (checkIfSnapshotChanged(inst)) {
            forceStoreRerender(fiber);
          }
        };

        return subscribe(handleStoreChange);
      }

      function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;

        try {
          var nextValue = latestGetSnapshot();
          return !objectIs(prevValue, nextValue);
        } catch (error) {
          return true;
        }
      }

      function forceStoreRerender(fiber) {
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
      }

      function mountState(initialState) {
        var hook = mountWorkInProgressHook();

        if (typeof initialState === 'function') {
          initialState = initialState();
        }

        hook.memoizedState = hook.baseState = initialState;
        var queue = {
          pending: null,
          interleaved: null,
          lanes: NoLanes,
          dispatch: null,
          lastRenderedReducer: basicStateReducer,
          lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [hook.memoizedState, dispatch];
      }

      function updateState(initialState) {
        return updateReducer(basicStateReducer);
      }

      function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
      }

      function pushEffect(tag, create, destroy, deps) {
        var effect = {
          tag: tag,
          create: create,
          destroy: destroy,
          deps: deps,
          next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;

        if (componentUpdateQueue === null) {
          componentUpdateQueue = createFunctionComponentUpdateQueue();
          currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
          componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
          var lastEffect = componentUpdateQueue.lastEffect;

          if (lastEffect === null) {
            componentUpdateQueue.lastEffect = effect.next = effect;
          } else {
            var firstEffect = lastEffect.next;
            lastEffect.next = effect;
            effect.next = firstEffect;
            componentUpdateQueue.lastEffect = effect;
          }
        }

        return effect;
      }

      function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        {
          var _ref2 = {
            current: initialValue
          };
          hook.memoizedState = _ref2;
          return _ref2;
        }
      }

      function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
      }

      function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
      }

      function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;

        if (currentHook !== null) {
          var prevEffect = currentHook.memoizedState;
          destroy = prevEffect.destroy;

          if (nextDeps !== null) {
            var prevDeps = prevEffect.deps;

            if (areHookInputsEqual(nextDeps, prevDeps)) {
              hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
              return;
            }
          }
        }

        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
      }

      function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) {
          return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        } else {
          return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
        }
      }

      function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
      }

      function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
      }

      function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
      }

      function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        {
          fiberFlags |= LayoutStatic;
        }

        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) {
          fiberFlags |= MountLayoutDev;
        }

        return mountEffectImpl(fiberFlags, Layout, create, deps);
      }

      function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
      }

      function imperativeHandleEffect(create, ref) {
        if (typeof ref === 'function') {
          var refCallback = ref;

          var _inst = create();

          refCallback(_inst);
          return function () {
            refCallback(null);
          };
        } else if (ref !== null && ref !== undefined) {
          var refObject = ref;
          {
            if (!refObject.hasOwnProperty('current')) {
              error('Expected useImperativeHandle() first argument to either be a ' + 'ref callback or React.createRef() object. Instead received: %s.', 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
            }
          }

          var _inst2 = create();

          refObject.current = _inst2;
          return function () {
            refObject.current = null;
          };
        }
      }

      function mountImperativeHandle(ref, create, deps) {
        {
          if (typeof create !== 'function') {
            error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
          }
        }
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
        var fiberFlags = Update;
        {
          fiberFlags |= LayoutStatic;
        }

        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) {
          fiberFlags |= MountLayoutDev;
        }

        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
      }

      function updateImperativeHandle(ref, create, deps) {
        {
          if (typeof create !== 'function') {
            error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
          }
        }
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
      }

      function mountDebugValue(value, formatterFn) {}

      var updateDebugValue = mountDebugValue;

      function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [callback, nextDeps];
        return callback;
      }

      function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;

        if (prevState !== null) {
          if (nextDeps !== null) {
            var prevDeps = prevState[1];

            if (areHookInputsEqual(nextDeps, prevDeps)) {
              return prevState[0];
            }
          }
        }

        hook.memoizedState = [callback, nextDeps];
        return callback;
      }

      function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }

      function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;

        if (prevState !== null) {
          if (nextDeps !== null) {
            var prevDeps = prevState[1];

            if (areHookInputsEqual(nextDeps, prevDeps)) {
              return prevState[0];
            }
          }
        }

        var nextValue = nextCreate();
        hook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }

      function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
      }

      function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
      }

      function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();

        if (currentHook === null) {
          hook.memoizedState = value;
          return value;
        } else {
          var prevValue = currentHook.memoizedState;
          return updateDeferredValueImpl(hook, prevValue, value);
        }
      }

      function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);

        if (shouldDeferValue) {
          if (!objectIs(value, prevValue)) {
            var deferredLane = claimNextTransitionLane();
            currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
            markSkippedUpdateLanes(deferredLane);
            hook.baseState = true;
          }

          return prevValue;
        } else {
          if (hook.baseState) {
            hook.baseState = false;
            markWorkInProgressReceivedUpdate();
          }

          hook.memoizedState = value;
          return value;
        }
      }

      function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        {
          ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        }

        try {
          setPending(false);
          callback();
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$2.transition = prevTransition;
          {
            if (prevTransition === null && currentTransition._updatedFibers) {
              var updatedFibersCount = currentTransition._updatedFibers.size;

              if (updatedFibersCount > 10) {
                warn('Detected a large number of updates inside startTransition. ' + 'If this is due to a subscription please re-write it to use React provided hooks. ' + 'Otherwise concurrent mode guarantees are off the table.');
              }

              currentTransition._updatedFibers.clear();
            }
          }
        }
      }

      function mountTransition() {
        var _mountState = mountState(false),
            isPending = _mountState[0],
            setPending = _mountState[1];

        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [isPending, start];
      }

      function updateTransition() {
        var _updateState = updateState(),
            isPending = _updateState[0];

        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [isPending, start];
      }

      function rerenderTransition() {
        var _rerenderState = rerenderState(),
            isPending = _rerenderState[0];

        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [isPending, start];
      }

      var isUpdatingOpaqueValueInRenderPhase = false;

      function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        {
          return isUpdatingOpaqueValueInRenderPhase;
        }
      }

      function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot();
        var identifierPrefix = root.identifierPrefix;
        var id;

        if (getIsHydrating()) {
          var treeId = getTreeId();
          id = ':' + identifierPrefix + 'R' + treeId;
          var localId = localIdCounter++;

          if (localId > 0) {
            id += 'H' + localId.toString(32);
          }

          id += ':';
        } else {
          var globalClientId = globalClientIdCounter++;
          id = ':' + identifierPrefix + 'r' + globalClientId.toString(32) + ':';
        }

        hook.memoizedState = id;
        return id;
      }

      function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
      }

      function dispatchReducerAction(fiber, queue, action) {
        {
          if (typeof arguments[3] === 'function') {
            error("State updates from the useState() and useReducer() Hooks don't support the " + 'second callback argument. To execute a side effect after ' + 'rendering, declare it in the component body with useEffect().');
          }
        }
        var lane = requestUpdateLane(fiber);
        var update = {
          lane: lane,
          action: action,
          hasEagerState: false,
          eagerState: null,
          next: null
        };

        if (isRenderPhaseUpdate(fiber)) {
          enqueueRenderPhaseUpdate(queue, update);
        } else {
          enqueueUpdate$1(fiber, queue, update);
          var eventTime = requestEventTime();
          var root = scheduleUpdateOnFiber(fiber, lane, eventTime);

          if (root !== null) {
            entangleTransitionUpdate(root, queue, lane);
          }
        }

        markUpdateInDevTools(fiber, lane);
      }

      function dispatchSetState(fiber, queue, action) {
        {
          if (typeof arguments[3] === 'function') {
            error("State updates from the useState() and useReducer() Hooks don't support the " + 'second callback argument. To execute a side effect after ' + 'rendering, declare it in the component body with useEffect().');
          }
        }
        var lane = requestUpdateLane(fiber);
        var update = {
          lane: lane,
          action: action,
          hasEagerState: false,
          eagerState: null,
          next: null
        };

        if (isRenderPhaseUpdate(fiber)) {
          enqueueRenderPhaseUpdate(queue, update);
        } else {
          enqueueUpdate$1(fiber, queue, update);
          var alternate = fiber.alternate;

          if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
            var lastRenderedReducer = queue.lastRenderedReducer;

            if (lastRenderedReducer !== null) {
              var prevDispatcher;
              {
                prevDispatcher = ReactCurrentDispatcher$1.current;
                ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              }

              try {
                var currentState = queue.lastRenderedState;
                var eagerState = lastRenderedReducer(currentState, action);
                update.hasEagerState = true;
                update.eagerState = eagerState;

                if (objectIs(eagerState, currentState)) {
                  return;
                }
              } catch (error) {} finally {
                {
                  ReactCurrentDispatcher$1.current = prevDispatcher;
                }
              }
            }
          }

          var eventTime = requestEventTime();
          var root = scheduleUpdateOnFiber(fiber, lane, eventTime);

          if (root !== null) {
            entangleTransitionUpdate(root, queue, lane);
          }
        }

        markUpdateInDevTools(fiber, lane);
      }

      function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
      }

      function enqueueRenderPhaseUpdate(queue, update) {
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;

        if (pending === null) {
          update.next = update;
        } else {
          update.next = pending.next;
          pending.next = update;
        }

        queue.pending = update;
      }

      function enqueueUpdate$1(fiber, queue, update, lane) {
        if (isInterleavedUpdate(fiber)) {
          var interleaved = queue.interleaved;

          if (interleaved === null) {
            update.next = update;
            pushInterleavedQueue(queue);
          } else {
            update.next = interleaved.next;
            interleaved.next = update;
          }

          queue.interleaved = update;
        } else {
          var pending = queue.pending;

          if (pending === null) {
            update.next = update;
          } else {
            update.next = pending.next;
            pending.next = update;
          }

          queue.pending = update;
        }
      }

      function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
          var queueLanes = queue.lanes;
          queueLanes = intersectLanes(queueLanes, root.pendingLanes);
          var newQueueLanes = mergeLanes(queueLanes, lane);
          queue.lanes = newQueueLanes;
          markRootEntangled(root, newQueueLanes);
        }
      }

      function markUpdateInDevTools(fiber, lane, action) {
        {
          markStateUpdateScheduled(fiber, lane);
        }
      }

      var ContextOnlyDispatcher = {
        readContext: _readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
      };
      var HooksDispatcherOnMountInDEV = null;
      var HooksDispatcherOnMountWithHookTypesInDEV = null;
      var HooksDispatcherOnUpdateInDEV = null;
      var HooksDispatcherOnRerenderInDEV = null;
      var InvalidNestedHooksDispatcherOnMountInDEV = null;
      var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
      var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
      {
        var warnInvalidContextAccess = function warnInvalidContextAccess() {
          error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
        };

        var warnInvalidHookAccess = function warnInvalidHookAccess() {
          error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://reactjs.org/link/rules-of-hooks');
        };

        HooksDispatcherOnMountInDEV = {
          readContext: function readContext(context) {
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            mountHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            mountHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            mountHookTypesDev();
            return mountDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            mountHookTypesDev();
            return mountDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            mountHookTypesDev();
            return mountTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            mountHookTypesDev();
            return mountMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            mountHookTypesDev();
            return mountId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        HooksDispatcherOnMountWithHookTypesInDEV = {
          readContext: function readContext(context) {
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return mountDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return mountDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return mountTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return mountMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return mountId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        HooksDispatcherOnUpdateInDEV = {
          readContext: function readContext(context) {
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return updateDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return updateTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return updateId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        HooksDispatcherOnRerenderInDEV = {
          readContext: function readContext(context) {
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

            try {
              return rerenderReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

            try {
              return rerenderState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return rerenderDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return rerenderTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return updateId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        InvalidNestedHooksDispatcherOnMountInDEV = {
          readContext: function readContext(context) {
            warnInvalidContextAccess();
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        InvalidNestedHooksDispatcherOnUpdateInDEV = {
          readContext: function readContext(context) {
            warnInvalidContextAccess();
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        InvalidNestedHooksDispatcherOnRerenderInDEV = {
          readContext: function readContext(context) {
            warnInvalidContextAccess();
            return _readContext(context);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return _readContext(context);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return rerenderReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

            try {
              return rerenderState(initialState);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
          },
          useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
          },
          useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
          },
          useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
          },
          useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
          },
          useId: function useId() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
      }
      var now$1 = Scheduler.unstable_now;
      var commitTime = 0;
      var layoutEffectStartTime = -1;
      var profilerStartTime = -1;
      var passiveEffectStartTime = -1;
      var currentUpdateIsNested = false;
      var nestedUpdateScheduled = false;

      function isCurrentUpdateNested() {
        return currentUpdateIsNested;
      }

      function markNestedUpdateScheduled() {
        {
          nestedUpdateScheduled = true;
        }
      }

      function resetNestedUpdateFlag() {
        {
          currentUpdateIsNested = false;
          nestedUpdateScheduled = false;
        }
      }

      function syncNestedUpdateFlag() {
        {
          currentUpdateIsNested = nestedUpdateScheduled;
          nestedUpdateScheduled = false;
        }
      }

      function getCommitTime() {
        return commitTime;
      }

      function recordCommitTime() {
        commitTime = now$1();
      }

      function startProfilerTimer(fiber) {
        profilerStartTime = now$1();

        if (fiber.actualStartTime < 0) {
          fiber.actualStartTime = now$1();
        }
      }

      function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
      }

      function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
          var elapsedTime = now$1() - profilerStartTime;
          fiber.actualDuration += elapsedTime;

          if (overrideBaseTime) {
            fiber.selfBaseDuration = elapsedTime;
          }

          profilerStartTime = -1;
        }
      }

      function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
          var elapsedTime = now$1() - layoutEffectStartTime;
          layoutEffectStartTime = -1;
          var parentFiber = fiber["return"];

          while (parentFiber !== null) {
            switch (parentFiber.tag) {
              case HostRoot:
                var root = parentFiber.stateNode;
                root.effectDuration += elapsedTime;
                return;

              case Profiler:
                var parentStateNode = parentFiber.stateNode;
                parentStateNode.effectDuration += elapsedTime;
                return;
            }

            parentFiber = parentFiber["return"];
          }
        }
      }

      function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
          var elapsedTime = now$1() - passiveEffectStartTime;
          passiveEffectStartTime = -1;
          var parentFiber = fiber["return"];

          while (parentFiber !== null) {
            switch (parentFiber.tag) {
              case HostRoot:
                var root = parentFiber.stateNode;

                if (root !== null) {
                  root.passiveEffectDuration += elapsedTime;
                }

                return;

              case Profiler:
                var parentStateNode = parentFiber.stateNode;

                if (parentStateNode !== null) {
                  parentStateNode.passiveEffectDuration += elapsedTime;
                }

                return;
            }

            parentFiber = parentFiber["return"];
          }
        }
      }

      function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
      }

      function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
      }

      function transferActualDuration(fiber) {
        var child = fiber.child;

        while (child) {
          fiber.actualDuration += child.actualDuration;
          child = child.sibling;
        }
      }

      function createCapturedValue(value, source) {
        return {
          value: value,
          source: source,
          stack: getStackByFiberInDevAndProd(source)
        };
      }

      function showErrorDialog(boundary, errorInfo) {
        return true;
      }

      function logCapturedError(boundary, errorInfo) {
        try {
          var logError = showErrorDialog(boundary, errorInfo);

          if (logError === false) {
            return;
          }

          var error = errorInfo.value;

          if (true) {
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : '';

            if (error != null && error._suppressLogging) {
              if (boundary.tag === ClassComponent) {
                return;
              }

              console['error'](error);
            }

            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
            var errorBoundaryMessage;

            if (boundary.tag === HostRoot) {
              errorBoundaryMessage = 'Consider adding an error boundary to your tree to customize error handling behavior.\n' + 'Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.';
            } else {
              var errorBoundaryName = getComponentNameFromFiber(boundary) || 'Anonymous';
              errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }

            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage);
            console['error'](combinedMessage);
          } else {
            console['error'](error);
          }
        } catch (e) {
          setTimeout(function () {
            throw e;
          });
        }
      }

      var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;

      function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        update.payload = {
          element: null
        };
        var error = errorInfo.value;

        update.callback = function () {
          onUncaughtError(error);
          logCapturedError(fiber, errorInfo);
        };

        return update;
      }

      function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;

        if (typeof getDerivedStateFromError === 'function') {
          var error$1 = errorInfo.value;

          update.payload = function () {
            return getDerivedStateFromError(error$1);
          };

          update.callback = function () {
            {
              markFailedErrorBoundaryForHotReloading(fiber);
            }
            logCapturedError(fiber, errorInfo);
          };
        }

        var inst = fiber.stateNode;

        if (inst !== null && typeof inst.componentDidCatch === 'function') {
          update.callback = function callback() {
            {
              markFailedErrorBoundaryForHotReloading(fiber);
            }
            logCapturedError(fiber, errorInfo);

            if (typeof getDerivedStateFromError !== 'function') {
              markLegacyErrorBoundaryAsFailed(this);
            }

            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
              componentStack: stack !== null ? stack : ''
            });
            {
              if (typeof getDerivedStateFromError !== 'function') {
                if (!includesSomeLane(fiber.lanes, SyncLane)) {
                  error('%s: Error boundaries should implement getDerivedStateFromError(). ' + 'In that method, return a state update to display an error message or fallback UI.', getComponentNameFromFiber(fiber) || 'Unknown');
                }
              }
            }
          };
        }

        return update;
      }

      function attachPingListener(root, wakeable, lanes) {
        var pingCache = root.pingCache;
        var threadIDs;

        if (pingCache === null) {
          pingCache = root.pingCache = new PossiblyWeakMap$1();
          threadIDs = new Set();
          pingCache.set(wakeable, threadIDs);
        } else {
          threadIDs = pingCache.get(wakeable);

          if (threadIDs === undefined) {
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
          }
        }

        if (!threadIDs.has(lanes)) {
          threadIDs.add(lanes);
          var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
          {
            if (isDevToolsPresent) {
              restorePendingUpdaters(root, lanes);
            }
          }
          wakeable.then(ping, ping);
        }
      }

      function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        var wakeables = suspenseBoundary.updateQueue;

        if (wakeables === null) {
          var updateQueue = new Set();
          updateQueue.add(wakeable);
          suspenseBoundary.updateQueue = updateQueue;
        } else {
          wakeables.add(wakeable);
        }
      }

      function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        var tag = sourceFiber.tag;

        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
          var currentSource = sourceFiber.alternate;

          if (currentSource) {
            sourceFiber.updateQueue = currentSource.updateQueue;
            sourceFiber.memoizedState = currentSource.memoizedState;
            sourceFiber.lanes = currentSource.lanes;
          } else {
            sourceFiber.updateQueue = null;
            sourceFiber.memoizedState = null;
          }
        }
      }

      function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;

        do {
          if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) {
            return node;
          }

          node = node["return"];
        } while (node !== null);

        return null;
      }

      function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
          if (suspenseBoundary === returnFiber) {
            suspenseBoundary.flags |= ShouldCapture;
          } else {
            suspenseBoundary.flags |= DidCapture;
            sourceFiber.flags |= ForceUpdateForLegacySuspense;
            sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);

            if (sourceFiber.tag === ClassComponent) {
              var currentSourceFiber = sourceFiber.alternate;

              if (currentSourceFiber === null) {
                sourceFiber.tag = IncompleteClassComponent;
              } else {
                var update = createUpdate(NoTimestamp, SyncLane);
                update.tag = ForceUpdate;
                enqueueUpdate(sourceFiber, update);
              }
            }

            sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
          }

          return suspenseBoundary;
        }

        suspenseBoundary.flags |= ShouldCapture;
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
      }

      function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        sourceFiber.flags |= Incomplete;
        {
          if (isDevToolsPresent) {
            restorePendingUpdaters(root, rootRenderLanes);
          }
        }

        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
          var wakeable = value;
          resetSuspendedComponent(sourceFiber);
          {
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
              markDidThrowWhileHydratingDEV();
            }
          }
          var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);

          if (suspenseBoundary !== null) {
            suspenseBoundary.flags &= ~ForceClientRender;
            markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes);

            if (suspenseBoundary.mode & ConcurrentMode) {
              attachPingListener(root, wakeable, rootRenderLanes);
            }

            attachRetryListener(suspenseBoundary, root, wakeable);
            return;
          } else {
            if (!includesSyncLane(rootRenderLanes)) {
              attachPingListener(root, wakeable, rootRenderLanes);
              renderDidSuspendDelayIfPossible();
              return;
            }

            var uncaughtSuspenseError = new Error('A component suspended while responding to synchronous input. This ' + 'will cause the UI to be replaced with a loading indicator. To ' + 'fix, updates that suspend should be wrapped ' + 'with startTransition.');
            value = uncaughtSuspenseError;
          }
        } else {
          if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();

            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);

            if (_suspenseBoundary !== null) {
              if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) {
                _suspenseBoundary.flags |= ForceClientRender;
              }

              markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes);
              queueHydrationError(value);
              return;
            }
          }
        }

        renderDidError(value);
        value = createCapturedValue(value, sourceFiber);
        var workInProgress = returnFiber;

        do {
          switch (workInProgress.tag) {
            case HostRoot:
              {
                var _errorInfo = value;
                workInProgress.flags |= ShouldCapture;
                var lane = pickArbitraryLane(rootRenderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                enqueueCapturedUpdate(workInProgress, update);
                return;
              }

            case ClassComponent:
              var errorInfo = value;
              var ctor = workInProgress.type;
              var instance = workInProgress.stateNode;

              if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                workInProgress.flags |= ShouldCapture;

                var _lane = pickArbitraryLane(rootRenderLanes);

                workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane);

                var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);

                enqueueCapturedUpdate(workInProgress, _update);
                return;
              }

              break;
          }

          workInProgress = workInProgress["return"];
        } while (workInProgress !== null);
      }

      function getSuspendedCache() {
        {
          return null;
        }
      }

      function markUpdate(workInProgress) {
        workInProgress.flags |= Update;
      }

      function markRef(workInProgress) {
        workInProgress.flags |= Ref;
        {
          workInProgress.flags |= RefStatic;
        }
      }

      var appendAllChildren;
      var updateHostContainer;
      var updateHostComponent;
      var updateHostText;
      {
        appendAllChildren = function appendAllChildren(parent, workInProgress, needsVisibilityToggle, isHidden) {
          var node = workInProgress.child;

          while (node !== null) {
            if (node.tag === HostComponent || node.tag === HostText) {
              appendInitialChild(parent, node.stateNode);
            } else if (node.tag === HostPortal) ;else if (node.child !== null) {
              node.child["return"] = node;
              node = node.child;
              continue;
            }

            if (node === workInProgress) {
              return;
            }

            while (node.sibling === null) {
              if (node["return"] === null || node["return"] === workInProgress) {
                return;
              }

              node = node["return"];
            }

            node.sibling["return"] = node["return"];
            node = node.sibling;
          }
        };

        updateHostContainer = function updateHostContainer(current, workInProgress) {};

        updateHostComponent = function updateHostComponent(current, workInProgress, type, newProps, rootContainerInstance) {
          var oldProps = current.memoizedProps;

          if (oldProps === newProps) {
            return;
          }

          var instance = workInProgress.stateNode;
          var currentHostContext = getHostContext();
          var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext);
          workInProgress.updateQueue = updatePayload;

          if (updatePayload) {
            markUpdate(workInProgress);
          }
        };

        updateHostText = function updateHostText(current, workInProgress, oldText, newText) {
          if (oldText !== newText) {
            markUpdate(workInProgress);
          }
        };
      }

      function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) {
          return;
        }

        switch (renderState.tailMode) {
          case 'hidden':
            {
              var tailNode = renderState.tail;
              var lastTailNode = null;

              while (tailNode !== null) {
                if (tailNode.alternate !== null) {
                  lastTailNode = tailNode;
                }

                tailNode = tailNode.sibling;
              }

              if (lastTailNode === null) {
                renderState.tail = null;
              } else {
                lastTailNode.sibling = null;
              }

              break;
            }

          case 'collapsed':
            {
              var _tailNode = renderState.tail;
              var _lastTailNode = null;

              while (_tailNode !== null) {
                if (_tailNode.alternate !== null) {
                  _lastTailNode = _tailNode;
                }

                _tailNode = _tailNode.sibling;
              }

              if (_lastTailNode === null) {
                if (!hasRenderedATailFallback && renderState.tail !== null) {
                  renderState.tail.sibling = null;
                } else {
                  renderState.tail = null;
                }
              } else {
                _lastTailNode.sibling = null;
              }

              break;
            }
        }
      }

      function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;

        if (!didBailout) {
          if ((completedWork.mode & ProfileMode) !== NoMode) {
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration;
            var child = completedWork.child;

            while (child !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
              subtreeFlags |= child.subtreeFlags;
              subtreeFlags |= child.flags;
              actualDuration += child.actualDuration;
              treeBaseDuration += child.treeBaseDuration;
              child = child.sibling;
            }

            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
          } else {
            var _child = completedWork.child;

            while (_child !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
              subtreeFlags |= _child.subtreeFlags;
              subtreeFlags |= _child.flags;
              _child["return"] = completedWork;
              _child = _child.sibling;
            }
          }

          completedWork.subtreeFlags |= subtreeFlags;
        } else {
          if ((completedWork.mode & ProfileMode) !== NoMode) {
            var _treeBaseDuration = completedWork.selfBaseDuration;
            var _child2 = completedWork.child;

            while (_child2 !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes));
              subtreeFlags |= _child2.subtreeFlags & StaticMask;
              subtreeFlags |= _child2.flags & StaticMask;
              _treeBaseDuration += _child2.treeBaseDuration;
              _child2 = _child2.sibling;
            }

            completedWork.treeBaseDuration = _treeBaseDuration;
          } else {
            var _child3 = completedWork.child;

            while (_child3 !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes));
              subtreeFlags |= _child3.subtreeFlags & StaticMask;
              subtreeFlags |= _child3.flags & StaticMask;
              _child3["return"] = completedWork;
              _child3 = _child3.sibling;
            }
          }

          completedWork.subtreeFlags |= subtreeFlags;
        }

        completedWork.childLanes = newChildLanes;
        return didBailout;
      }

      function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps;
        popTreeContext(workInProgress);

        switch (workInProgress.tag) {
          case IndeterminateComponent:
          case LazyComponent:
          case SimpleMemoComponent:
          case FunctionComponent:
          case ForwardRef:
          case Fragment:
          case Mode:
          case Profiler:
          case ContextConsumer:
          case MemoComponent:
            bubbleProperties(workInProgress);
            return null;

          case ClassComponent:
            {
              var Component = workInProgress.type;

              if (isContextProvider(Component)) {
                popContext(workInProgress);
              }

              bubbleProperties(workInProgress);
              return null;
            }

          case HostRoot:
            {
              var fiberRoot = workInProgress.stateNode;
              popHostContainer(workInProgress);
              popTopLevelContextObject(workInProgress);
              resetWorkInProgressVersions();

              if (fiberRoot.pendingContext) {
                fiberRoot.context = fiberRoot.pendingContext;
                fiberRoot.pendingContext = null;
              }

              if (current === null || current.child === null) {
                var wasHydrated = popHydrationState(workInProgress);

                if (wasHydrated) {
                  markUpdate(workInProgress);
                } else {
                  if (current !== null) {
                    var prevState = current.memoizedState;

                    if (!prevState.isDehydrated || (workInProgress.flags & ForceClientRender) !== NoFlags) {
                      workInProgress.flags |= Snapshot;
                      upgradeHydrationErrorsToRecoverable();
                    }
                  }
                }
              }

              updateHostContainer(current, workInProgress);
              bubbleProperties(workInProgress);
              return null;
            }

          case HostComponent:
            {
              popHostContext(workInProgress);
              var rootContainerInstance = getRootHostContainer();
              var type = workInProgress.type;

              if (current !== null && workInProgress.stateNode != null) {
                updateHostComponent(current, workInProgress, type, newProps, rootContainerInstance);

                if (current.ref !== workInProgress.ref) {
                  markRef(workInProgress);
                }
              } else {
                if (!newProps) {
                  if (workInProgress.stateNode === null) {
                    throw new Error('We must have new props for new mounts. This error is likely ' + 'caused by a bug in React. Please file an issue.');
                  }

                  bubbleProperties(workInProgress);
                  return null;
                }

                var currentHostContext = getHostContext();

                var _wasHydrated = popHydrationState(workInProgress);

                if (_wasHydrated) {
                  if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) {
                    markUpdate(workInProgress);
                  }
                } else {
                  var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                  appendAllChildren(instance, workInProgress, false, false);
                  workInProgress.stateNode = instance;

                  if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) {
                    markUpdate(workInProgress);
                  }
                }

                if (workInProgress.ref !== null) {
                  markRef(workInProgress);
                }
              }

              bubbleProperties(workInProgress);
              return null;
            }

          case HostText:
            {
              var newText = newProps;

              if (current && workInProgress.stateNode != null) {
                var oldText = current.memoizedProps;
                updateHostText(current, workInProgress, oldText, newText);
              } else {
                if (typeof newText !== 'string') {
                  if (workInProgress.stateNode === null) {
                    throw new Error('We must have new props for new mounts. This error is likely ' + 'caused by a bug in React. Please file an issue.');
                  }
                }

                var _rootContainerInstance = getRootHostContainer();

                var _currentHostContext = getHostContext();

                var _wasHydrated2 = popHydrationState(workInProgress);

                if (_wasHydrated2) {
                  if (prepareToHydrateHostTextInstance(workInProgress)) {
                    markUpdate(workInProgress);
                  }
                } else {
                  workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
              }

              bubbleProperties(workInProgress);
              return null;
            }

          case SuspenseComponent:
            {
              popSuspenseContext(workInProgress);
              var nextState = workInProgress.memoizedState;

              if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
                warnIfUnhydratedTailNodes(workInProgress);
                resetHydrationState();
                workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
                return workInProgress;
              }

              if (nextState !== null && nextState.dehydrated !== null) {
                var _wasHydrated3 = popHydrationState(workInProgress);

                if (current === null) {
                  if (!_wasHydrated3) {
                    throw new Error('A dehydrated suspense component was completed without a hydrated node. ' + 'This is probably a bug in React.');
                  }

                  prepareToHydrateHostSuspenseInstance(workInProgress);
                  bubbleProperties(workInProgress);
                  {
                    if ((workInProgress.mode & ProfileMode) !== NoMode) {
                      var isTimedOutSuspense = nextState !== null;

                      if (isTimedOutSuspense) {
                        var primaryChildFragment = workInProgress.child;

                        if (primaryChildFragment !== null) {
                          workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                        }
                      }
                    }
                  }
                  return null;
                } else {
                  resetHydrationState();

                  if ((workInProgress.flags & DidCapture) === NoFlags) {
                    workInProgress.memoizedState = null;
                  }

                  workInProgress.flags |= Update;
                  bubbleProperties(workInProgress);
                  {
                    if ((workInProgress.mode & ProfileMode) !== NoMode) {
                      var _isTimedOutSuspense = nextState !== null;

                      if (_isTimedOutSuspense) {
                        var _primaryChildFragment = workInProgress.child;

                        if (_primaryChildFragment !== null) {
                          workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                        }
                      }
                    }
                  }
                  return null;
                }
              }

              upgradeHydrationErrorsToRecoverable();

              if ((workInProgress.flags & DidCapture) !== NoFlags) {
                workInProgress.lanes = renderLanes;

                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                  transferActualDuration(workInProgress);
                }

                return workInProgress;
              }

              var nextDidTimeout = nextState !== null;
              var prevDidTimeout = false;

              if (current === null) {
                popHydrationState(workInProgress);
              } else {
                var _prevState = current.memoizedState;
                prevDidTimeout = _prevState !== null;
              }

              if (nextDidTimeout !== prevDidTimeout) {
                if (nextDidTimeout) {
                  var _offscreenFiber2 = workInProgress.child;
                  _offscreenFiber2.flags |= Visibility;

                  if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                    var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);

                    if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
                      renderDidSuspend();
                    } else {
                      renderDidSuspendDelayIfPossible();
                    }
                  }
                }
              }

              var wakeables = workInProgress.updateQueue;

              if (wakeables !== null) {
                workInProgress.flags |= Update;
              }

              bubbleProperties(workInProgress);
              {
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                  if (nextDidTimeout) {
                    var _primaryChildFragment2 = workInProgress.child;

                    if (_primaryChildFragment2 !== null) {
                      workInProgress.treeBaseDuration -= _primaryChildFragment2.treeBaseDuration;
                    }
                  }
                }
              }
              return null;
            }

          case HostPortal:
            popHostContainer(workInProgress);
            updateHostContainer(current, workInProgress);

            if (current === null) {
              preparePortalMount(workInProgress.stateNode.containerInfo);
            }

            bubbleProperties(workInProgress);
            return null;

          case ContextProvider:
            var context = workInProgress.type._context;
            popProvider(context, workInProgress);
            bubbleProperties(workInProgress);
            return null;

          case IncompleteClassComponent:
            {
              var _Component = workInProgress.type;

              if (isContextProvider(_Component)) {
                popContext(workInProgress);
              }

              bubbleProperties(workInProgress);
              return null;
            }

          case SuspenseListComponent:
            {
              popSuspenseContext(workInProgress);
              var renderState = workInProgress.memoizedState;

              if (renderState === null) {
                bubbleProperties(workInProgress);
                return null;
              }

              var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
              var renderedTail = renderState.rendering;

              if (renderedTail === null) {
                if (!didSuspendAlready) {
                  var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);

                  if (!cannotBeSuspended) {
                    var row = workInProgress.child;

                    while (row !== null) {
                      var suspended = findFirstSuspended(row);

                      if (suspended !== null) {
                        didSuspendAlready = true;
                        workInProgress.flags |= DidCapture;
                        cutOffTailIfNeeded(renderState, false);
                        var newThenables = suspended.updateQueue;

                        if (newThenables !== null) {
                          workInProgress.updateQueue = newThenables;
                          workInProgress.flags |= Update;
                        }

                        workInProgress.subtreeFlags = NoFlags;
                        resetChildFibers(workInProgress, renderLanes);
                        pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                        return workInProgress.child;
                      }

                      row = row.sibling;
                    }
                  }

                  if (renderState.tail !== null && now() > getRenderTargetTime()) {
                    workInProgress.flags |= DidCapture;
                    didSuspendAlready = true;
                    cutOffTailIfNeeded(renderState, false);
                    workInProgress.lanes = SomeRetryLane;
                  }
                } else {
                  cutOffTailIfNeeded(renderState, false);
                }
              } else {
                if (!didSuspendAlready) {
                  var _suspended = findFirstSuspended(renderedTail);

                  if (_suspended !== null) {
                    workInProgress.flags |= DidCapture;
                    didSuspendAlready = true;
                    var _newThenables = _suspended.updateQueue;

                    if (_newThenables !== null) {
                      workInProgress.updateQueue = _newThenables;
                      workInProgress.flags |= Update;
                    }

                    cutOffTailIfNeeded(renderState, true);

                    if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate && !getIsHydrating()) {
                      bubbleProperties(workInProgress);
                      return null;
                    }
                  } else if (now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                    workInProgress.flags |= DidCapture;
                    didSuspendAlready = true;
                    cutOffTailIfNeeded(renderState, false);
                    workInProgress.lanes = SomeRetryLane;
                  }
                }

                if (renderState.isBackwards) {
                  renderedTail.sibling = workInProgress.child;
                  workInProgress.child = renderedTail;
                } else {
                  var previousSibling = renderState.last;

                  if (previousSibling !== null) {
                    previousSibling.sibling = renderedTail;
                  } else {
                    workInProgress.child = renderedTail;
                  }

                  renderState.last = renderedTail;
                }
              }

              if (renderState.tail !== null) {
                var next = renderState.tail;
                renderState.rendering = next;
                renderState.tail = next.sibling;
                renderState.renderingStartTime = now();
                next.sibling = null;
                var suspenseContext = suspenseStackCursor.current;

                if (didSuspendAlready) {
                  suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                } else {
                  suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                }

                pushSuspenseContext(workInProgress, suspenseContext);
                return next;
              }

              bubbleProperties(workInProgress);
              return null;
            }

          case ScopeComponent:
            {
              break;
            }

          case OffscreenComponent:
          case LegacyHiddenComponent:
            {
              popRenderLanes(workInProgress);
              var _nextState = workInProgress.memoizedState;
              var nextIsHidden = _nextState !== null;

              if (current !== null) {
                var _prevState2 = current.memoizedState;
                var prevIsHidden = _prevState2 !== null;

                if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) {
                  workInProgress.flags |= Visibility;
                }
              }

              if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) {
                bubbleProperties(workInProgress);
              } else {
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                  bubbleProperties(workInProgress);
                  {
                    if (workInProgress.subtreeFlags & (Placement | Update)) {
                      workInProgress.flags |= Visibility;
                    }
                  }
                }
              }

              return null;
            }

          case CacheComponent:
            {
              return null;
            }

          case TracingMarkerComponent:
            {
              return null;
            }
        }

        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + 'React. Please file an issue.');
      }

      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var didReceiveUpdate = false;
      var didWarnAboutBadClass;
      var didWarnAboutModulePatternComponent;
      var didWarnAboutContextTypeOnFunctionComponent;
      var didWarnAboutGetDerivedStateOnFunctionComponent;
      var didWarnAboutFunctionRefs;
      var didWarnAboutReassigningProps;
      var didWarnAboutRevealOrder;
      var didWarnAboutTailOptions;
      {
        didWarnAboutBadClass = {};
        didWarnAboutModulePatternComponent = {};
        didWarnAboutContextTypeOnFunctionComponent = {};
        didWarnAboutGetDerivedStateOnFunctionComponent = {};
        didWarnAboutFunctionRefs = {};
        didWarnAboutReassigningProps = false;
        didWarnAboutRevealOrder = {};
        didWarnAboutTailOptions = {};
      }

      function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) {
          workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        } else {
          workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
        }
      }

      function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
      }

      function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            var innerPropTypes = Component.propTypes;

            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
            }
          }
        }
        var render = Component.render;
        var ref = workInProgress.ref;
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        {
          markComponentRenderStarted(workInProgress);
        }
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
          hasId = checkDidRenderIdHook();

          if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);

            try {
              nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
              hasId = checkDidRenderIdHook();
            } finally {
              setIsStrictModeForDevtools(false);
            }
          }

          setIsRendering(false);
        }
        {
          markComponentRenderStopped();
        }

        if (current !== null && !didReceiveUpdate) {
          bailoutHooks(current, workInProgress, renderLanes);
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }

        if (getIsHydrating() && hasId) {
          pushMaterializedTreeId(workInProgress);
        }

        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
          var type = Component.type;

          if (isSimpleFunctionComponent(type) && Component.compare === null && Component.defaultProps === undefined) {
            var resolvedType = type;
            {
              resolvedType = resolveFunctionForHotReloading(type);
            }
            workInProgress.tag = SimpleMemoComponent;
            workInProgress.type = resolvedType;
            {
              validateFunctionComponentInDev(workInProgress, type);
            }
            return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
          }

          {
            var innerPropTypes = type.propTypes;

            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(type));
            }
          }
          var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
          child.ref = workInProgress.ref;
          child["return"] = workInProgress;
          workInProgress.child = child;
          return child;
        }

        {
          var _type = Component.type;
          var _innerPropTypes = _type.propTypes;

          if (_innerPropTypes) {
            checkPropTypes(_innerPropTypes, nextProps, 'prop', getComponentNameFromType(_type));
          }
        }
        var currentChild = current.child;
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);

        if (!hasScheduledUpdateOrContext) {
          var prevProps = currentChild.memoizedProps;
          var compare = Component.compare;
          compare = compare !== null ? compare : shallowEqual;

          if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) {
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
          }
        }

        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild["return"] = workInProgress;
        workInProgress.child = newChild;
        return newChild;
      }

      function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            var outerMemoType = workInProgress.elementType;

            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
              var lazyComponent = outerMemoType;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;

              try {
                outerMemoType = init(payload);
              } catch (x) {
                outerMemoType = null;
              }

              var outerPropTypes = outerMemoType && outerMemoType.propTypes;

              if (outerPropTypes) {
                checkPropTypes(outerPropTypes, nextProps, 'prop', getComponentNameFromType(outerMemoType));
              }
            }
          }
        }

        if (current !== null) {
          var prevProps = current.memoizedProps;

          if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
            didReceiveUpdate = false;
            workInProgress.pendingProps = nextProps = prevProps;

            if (!checkScheduledUpdateOrContext(current, renderLanes)) {
              workInProgress.lanes = current.lanes;
              return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
              didReceiveUpdate = true;
            }
          }
        }

        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
      }

      function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;

        if (nextProps.mode === 'hidden' || enableLegacyHidden) {
          if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            var nextState = {
              baseLanes: NoLanes,
              cachePool: null,
              transitions: null
            };
            workInProgress.memoizedState = nextState;
            pushRenderLanes(workInProgress, renderLanes);
          } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
            var spawnedCachePool = null;
            var nextBaseLanes;

            if (prevState !== null) {
              var prevBaseLanes = prevState.baseLanes;
              nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
            } else {
              nextBaseLanes = renderLanes;
            }

            workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
            var _nextState = {
              baseLanes: nextBaseLanes,
              cachePool: spawnedCachePool,
              transitions: null
            };
            workInProgress.memoizedState = _nextState;
            workInProgress.updateQueue = null;
            pushRenderLanes(workInProgress, nextBaseLanes);
            return null;
          } else {
            var _nextState2 = {
              baseLanes: NoLanes,
              cachePool: null,
              transitions: null
            };
            workInProgress.memoizedState = _nextState2;
            var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
            pushRenderLanes(workInProgress, subtreeRenderLanes);
          }
        } else {
          var _subtreeRenderLanes;

          if (prevState !== null) {
            _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
            workInProgress.memoizedState = null;
          } else {
            _subtreeRenderLanes = renderLanes;
          }

          pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }

        {
          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
          return workInProgress.child;
        }
      }

      function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function updateProfiler(current, workInProgress, renderLanes) {
        {
          workInProgress.flags |= Update;
          {
            var stateNode = workInProgress.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
          }
        }
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function markRef$1(current, workInProgress) {
        var ref = workInProgress.ref;

        if (current === null && ref !== null || current !== null && current.ref !== ref) {
          workInProgress.flags |= Ref;
          {
            workInProgress.flags |= RefStatic;
          }
        }
      }

      function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            var innerPropTypes = Component.propTypes;

            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
            }
          }
        }
        var context;
        {
          var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
          context = getMaskedContext(workInProgress, unmaskedContext);
        }
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        {
          markComponentRenderStarted(workInProgress);
        }
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
          hasId = checkDidRenderIdHook();

          if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);

            try {
              nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
              hasId = checkDidRenderIdHook();
            } finally {
              setIsStrictModeForDevtools(false);
            }
          }

          setIsRendering(false);
        }
        {
          markComponentRenderStopped();
        }

        if (current !== null && !didReceiveUpdate) {
          bailoutHooks(current, workInProgress, renderLanes);
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }

        if (getIsHydrating() && hasId) {
          pushMaterializedTreeId(workInProgress);
        }

        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        {
          switch (shouldError(workInProgress)) {
            case false:
              {
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type;
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;

                _instance.updater.enqueueSetState(_instance, state, null);

                break;
              }

            case true:
              {
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture;
                var error$1 = new Error('Simulated error coming from DevTools');
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                var update = createClassErrorUpdate(workInProgress, createCapturedValue(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
              }
          }

          if (workInProgress.type !== workInProgress.elementType) {
            var innerPropTypes = Component.propTypes;

            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
            }
          }
        }
        var hasContext;

        if (isContextProvider(Component)) {
          hasContext = true;
          pushContextProvider(workInProgress);
        } else {
          hasContext = false;
        }

        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;

        if (instance === null) {
          if (current !== null) {
            current.alternate = null;
            workInProgress.alternate = null;
            workInProgress.flags |= Placement;
          }

          constructClassInstance(workInProgress, Component, nextProps);
          mountClassInstance(workInProgress, Component, nextProps, renderLanes);
          shouldUpdate = true;
        } else if (current === null) {
          shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        } else {
          shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        }

        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        {
          var inst = workInProgress.stateNode;

          if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) {
              error('It looks like %s is reassigning its own `this.props` while rendering. ' + 'This is not supported and can lead to confusing bugs.', getComponentNameFromFiber(workInProgress) || 'a component');
            }

            didWarnAboutReassigningProps = true;
          }
        }
        return nextUnitOfWork;
      }

      function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        markRef$1(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;

        if (!shouldUpdate && !didCaptureError) {
          if (hasContext) {
            invalidateContextProvider(workInProgress, Component, false);
          }

          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }

        var instance = workInProgress.stateNode;
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;

        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
          nextChildren = null;
          {
            stopProfilerTimerIfRunning();
          }
        } else {
          {
            markComponentRenderStarted(workInProgress);
          }
          {
            setIsRendering(true);
            nextChildren = instance.render();

            if (workInProgress.mode & StrictLegacyMode) {
              setIsStrictModeForDevtools(true);

              try {
                instance.render();
              } finally {
                setIsStrictModeForDevtools(false);
              }
            }

            setIsRendering(false);
          }
          {
            markComponentRenderStopped();
          }
        }

        workInProgress.flags |= PerformedWork;

        if (current !== null && didCaptureError) {
          forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        } else {
          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }

        workInProgress.memoizedState = instance.state;

        if (hasContext) {
          invalidateContextProvider(workInProgress, Component, true);
        }

        return workInProgress.child;
      }

      function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;

        if (root.pendingContext) {
          pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        } else if (root.context) {
          pushTopLevelContextObject(workInProgress, root.context, false);
        }

        pushHostContainer(workInProgress, root.containerInfo);
      }

      function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);

        if (current === null) {
          throw new Error('Should have a current fiber. This is a bug in React.');
        }

        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var nextChildren = nextState.element;

        if (prevState.isDehydrated) {
          var overrideState = {
            element: nextChildren,
            isDehydrated: false,
            cache: nextState.cache,
            pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
            transitions: nextState.transitions
          };
          var updateQueue = workInProgress.updateQueue;
          updateQueue.baseState = overrideState;
          workInProgress.memoizedState = overrideState;

          if (workInProgress.flags & ForceClientRender) {
            var recoverableError = new Error('There was an error while hydrating. Because the error happened outside ' + 'of a Suspense boundary, the entire root will switch to ' + 'client rendering.');
            return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
          } else if (nextChildren !== prevChildren) {
            var _recoverableError = new Error('This root received an early update, before anything was able ' + 'hydrate. Switched the entire root to client rendering.');

            return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
          } else {
            enterHydrationState(workInProgress);
            var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
            workInProgress.child = child;
            var node = child;

            while (node) {
              node.flags = node.flags & ~Placement | Hydrating;
              node = node.sibling;
            }
          }
        } else {
          resetHydrationState();

          if (nextChildren === prevChildren) {
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
          }

          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }

        return workInProgress.child;
      }

      function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function updateHostComponent$1(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);

        if (current === null) {
          tryToClaimNextHydratableInstance(workInProgress);
        }

        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);

        if (isDirectTextChild) {
          nextChildren = null;
        } else if (prevProps !== null && shouldSetTextContent(type, prevProps)) {
          workInProgress.flags |= ContentReset;
        }

        markRef$1(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
      }

      function updateHostText$1(current, workInProgress) {
        if (current === null) {
          tryToClaimNextHydratableInstance(workInProgress);
        }

        return null;
      }

      function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        if (_current !== null) {
          _current.alternate = null;
          workInProgress.alternate = null;
          workInProgress.flags |= Placement;
        }

        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload);
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;

        switch (resolvedTag) {
          case FunctionComponent:
            {
              {
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
              }
              child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
              return child;
            }

          case ClassComponent:
            {
              {
                workInProgress.type = Component = resolveClassForHotReloading(Component);
              }
              child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
              return child;
            }

          case ForwardRef:
            {
              {
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
              }
              child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
              return child;
            }

          case MemoComponent:
            {
              {
                if (workInProgress.type !== workInProgress.elementType) {
                  var outerPropTypes = Component.propTypes;

                  if (outerPropTypes) {
                    checkPropTypes(outerPropTypes, resolvedProps, 'prop', getComponentNameFromType(Component));
                  }
                }
              }
              child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
              return child;
            }
        }

        var hint = '';
        {
          if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) {
            hint = ' Did you wrap a component in React.lazy() more than once?';
          }
        }
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
      }

      function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        if (_current !== null) {
          _current.alternate = null;
          workInProgress.alternate = null;
          workInProgress.flags |= Placement;
        }

        workInProgress.tag = ClassComponent;
        var hasContext;

        if (isContextProvider(Component)) {
          hasContext = true;
          pushContextProvider(workInProgress);
        } else {
          hasContext = false;
        }

        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
      }

      function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        if (_current !== null) {
          _current.alternate = null;
          workInProgress.alternate = null;
          workInProgress.flags |= Placement;
        }

        var props = workInProgress.pendingProps;
        var context;
        {
          var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
          context = getMaskedContext(workInProgress, unmaskedContext);
        }
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        {
          markComponentRenderStarted(workInProgress);
        }
        {
          if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentNameFromType(Component) || 'Unknown';

            if (!didWarnAboutBadClass[componentName]) {
              error("The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);
              didWarnAboutBadClass[componentName] = true;
            }
          }

          if (workInProgress.mode & StrictLegacyMode) {
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
          }

          setIsRendering(true);
          ReactCurrentOwner$1.current = workInProgress;
          value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
          hasId = checkDidRenderIdHook();
          setIsRendering(false);
        }
        {
          markComponentRenderStopped();
        }
        workInProgress.flags |= PerformedWork;
        {
          if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || 'Unknown';

            if (!didWarnAboutModulePatternComponent[_componentName]) {
              error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName, _componentName, _componentName);
              didWarnAboutModulePatternComponent[_componentName] = true;
            }
          }
        }

        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
          {
            var _componentName2 = getComponentNameFromType(Component) || 'Unknown';

            if (!didWarnAboutModulePatternComponent[_componentName2]) {
              error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName2, _componentName2, _componentName2);
              didWarnAboutModulePatternComponent[_componentName2] = true;
            }
          }
          workInProgress.tag = ClassComponent;
          workInProgress.memoizedState = null;
          workInProgress.updateQueue = null;
          var hasContext = false;

          if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
          } else {
            hasContext = false;
          }

          workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
          initializeUpdateQueue(workInProgress);
          adoptClassInstance(workInProgress, value);
          mountClassInstance(workInProgress, Component, props, renderLanes);
          return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
          workInProgress.tag = FunctionComponent;
          {
            if (workInProgress.mode & StrictLegacyMode) {
              setIsStrictModeForDevtools(true);

              try {
                value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                hasId = checkDidRenderIdHook();
              } finally {
                setIsStrictModeForDevtools(false);
              }
            }
          }

          if (getIsHydrating() && hasId) {
            pushMaterializedTreeId(workInProgress);
          }

          reconcileChildren(null, workInProgress, value, renderLanes);
          {
            validateFunctionComponentInDev(workInProgress, Component);
          }
          return workInProgress.child;
        }
      }

      function validateFunctionComponentInDev(workInProgress, Component) {
        {
          if (Component) {
            if (Component.childContextTypes) {
              error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
            }
          }

          if (workInProgress.ref !== null) {
            var info = '';
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();

            if (ownerName) {
              info += '\n\nCheck the render method of `' + ownerName + '`.';
            }

            var warningKey = ownerName || '';
            var debugSource = workInProgress._debugSource;

            if (debugSource) {
              warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
            }

            if (!didWarnAboutFunctionRefs[warningKey]) {
              didWarnAboutFunctionRefs[warningKey] = true;
              error('Function components cannot be given refs. ' + 'Attempts to access this ref will fail. ' + 'Did you mean to use React.forwardRef()?%s', info);
            }
          }

          if (typeof Component.getDerivedStateFromProps === 'function') {
            var _componentName3 = getComponentNameFromType(Component) || 'Unknown';

            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
              error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);
              didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
          }

          if (typeof Component.contextType === 'object' && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || 'Unknown';

            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
              error('%s: Function components do not support contextType.', _componentName4);
              didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
          }
        }
      }

      var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
      };

      function mountSuspenseOffscreenState(renderLanes) {
        return {
          baseLanes: renderLanes,
          cachePool: getSuspendedCache(),
          transitions: null
        };
      }

      function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
          baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
          cachePool: cachePool,
          transitions: prevOffscreenState.transitions
        };
      }

      function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        if (current !== null) {
          var suspenseState = current.memoizedState;

          if (suspenseState === null) {
            return false;
          }
        }

        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
      }

      function getRemainingWorkInPrimaryTree(current, renderLanes) {
        return removeLanes(current.childLanes, renderLanes);
      }

      function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        {
          if (shouldSuspend(workInProgress)) {
            workInProgress.flags |= DidCapture;
          }
        }
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;

        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
          showFallback = true;
          workInProgress.flags &= ~DidCapture;
        } else {
          if (current === null || current.memoizedState !== null) {
            {
              suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
            }
          }
        }

        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext);

        if (current === null) {
          tryToClaimNextHydratableInstance(workInProgress);
          var suspenseState = workInProgress.memoizedState;

          if (suspenseState !== null) {
            var dehydrated = suspenseState.dehydrated;

            if (dehydrated !== null) {
              return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
          }

          var nextPrimaryChildren = nextProps.children;
          var nextFallbackChildren = nextProps.fallback;

          if (showFallback) {
            var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
            var primaryChildFragment = workInProgress.child;
            primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
            workInProgress.memoizedState = SUSPENDED_MARKER;
            return fallbackFragment;
          } else {
            return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
          }
        } else {
          var prevState = current.memoizedState;

          if (prevState !== null) {
            var _dehydrated = prevState.dehydrated;

            if (_dehydrated !== null) {
              if (!didSuspend) {
                return updateDehydratedSuspenseComponent(current, workInProgress, _dehydrated, prevState, renderLanes);
              } else if (workInProgress.flags & ForceClientRender) {
                workInProgress.flags &= ~ForceClientRender;
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, new Error('There was an error while hydrating this Suspense boundary. ' + 'Switched to client rendering.'));
              } else if (workInProgress.memoizedState !== null) {
                workInProgress.child = current.child;
                workInProgress.flags |= DidCapture;
                return null;
              } else {
                var _nextPrimaryChildren = nextProps.children;
                var _nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                _primaryChildFragment2.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
              }
            }

            if (showFallback) {
              var _nextFallbackChildren2 = nextProps.fallback;
              var _nextPrimaryChildren2 = nextProps.children;

              var _fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes);

              var _primaryChildFragment3 = workInProgress.child;
              var prevOffscreenState = current.child.memoizedState;
              _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
              _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
              workInProgress.memoizedState = SUSPENDED_MARKER;
              return _fallbackChildFragment;
            } else {
              var _nextPrimaryChildren3 = nextProps.children;

              var _primaryChildFragment4 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren3, renderLanes);

              workInProgress.memoizedState = null;
              return _primaryChildFragment4;
            }
          } else {
            if (showFallback) {
              var _nextFallbackChildren3 = nextProps.fallback;
              var _nextPrimaryChildren4 = nextProps.children;

              var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes);

              var _primaryChildFragment5 = workInProgress.child;
              var _prevOffscreenState = current.child.memoizedState;
              _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes);
              _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
              workInProgress.memoizedState = SUSPENDED_MARKER;
              return _fallbackChildFragment2;
            } else {
              var _nextPrimaryChildren5 = nextProps.children;

              var _primaryChildFragment6 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren5, renderLanes);

              workInProgress.memoizedState = null;
              return _primaryChildFragment6;
            }
          }
        }
      }

      function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
          mode: 'visible',
          children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment["return"] = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
      }

      function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
          mode: 'hidden',
          children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;

        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
          primaryChildFragment = progressedPrimaryFragment;
          primaryChildFragment.childLanes = NoLanes;
          primaryChildFragment.pendingProps = primaryChildProps;

          if (workInProgress.mode & ProfileMode) {
            primaryChildFragment.actualDuration = 0;
            primaryChildFragment.actualStartTime = -1;
            primaryChildFragment.selfBaseDuration = 0;
            primaryChildFragment.treeBaseDuration = 0;
          }

          fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
          primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
          fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }

        primaryChildFragment["return"] = workInProgress;
        fallbackChildFragment["return"] = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
      }

      function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
      }

      function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        return createWorkInProgress(current, offscreenProps);
      }

      function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
          mode: 'visible',
          children: primaryChildren
        });

        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
          primaryChildFragment.lanes = renderLanes;
        }

        primaryChildFragment["return"] = workInProgress;
        primaryChildFragment.sibling = null;

        if (currentFallbackChildFragment !== null) {
          var deletions = workInProgress.deletions;

          if (deletions === null) {
            workInProgress.deletions = [currentFallbackChildFragment];
            workInProgress.flags |= ChildDeletion;
          } else {
            deletions.push(currentFallbackChildFragment);
          }
        }

        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
      }

      function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
          mode: 'hidden',
          children: primaryChildren
        };
        var primaryChildFragment;

        if ((mode & ConcurrentMode) === NoMode && workInProgress.child !== currentPrimaryChildFragment) {
          var progressedPrimaryFragment = workInProgress.child;
          primaryChildFragment = progressedPrimaryFragment;
          primaryChildFragment.childLanes = NoLanes;
          primaryChildFragment.pendingProps = primaryChildProps;

          if (workInProgress.mode & ProfileMode) {
            primaryChildFragment.actualDuration = 0;
            primaryChildFragment.actualStartTime = -1;
            primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
            primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
          }

          workInProgress.deletions = null;
        } else {
          primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
          primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }

        var fallbackChildFragment;

        if (currentFallbackChildFragment !== null) {
          fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        } else {
          fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
          fallbackChildFragment.flags |= Placement;
        }

        fallbackChildFragment["return"] = workInProgress;
        primaryChildFragment["return"] = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
      }

      function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        if (recoverableError !== null) {
          queueHydrationError(recoverableError);
        }

        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren);
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
      }

      function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
          mode: 'visible',
          children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null);
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment["return"] = workInProgress;
        fallbackChildFragment["return"] = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;

        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
          reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        }

        return fallbackChildFragment;
      }

      function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
          {
            error('Cannot hydrate Suspense in legacy mode. Switch from ' + 'ReactDOM.hydrate(element, container) to ' + 'ReactDOMClient.hydrateRoot(container, <App />)' + '.render(element) or remove the Suspense components from ' + 'the server rendered components.');
          }
          workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) {
          workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        } else {
          workInProgress.lanes = laneToLanes(OffscreenLane);
        }

        return null;
      }

      function updateDehydratedSuspenseComponent(current, workInProgress, suspenseInstance, suspenseState, renderLanes) {
        warnIfHydrating();

        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
          return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, null);
        }

        if (isSuspenseInstanceFallback(suspenseInstance)) {
          return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, new Error('The server could not finish this Suspense boundary, likely ' + 'due to an error during server rendering. Switched to ' + 'client rendering.'));
        }

        var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);

        if (didReceiveUpdate || hasContextChanged) {
          var root = getWorkInProgressRoot();

          if (root !== null) {
            var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);

            if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
              suspenseState.retryLane = attemptHydrationAtLane;
              var eventTime = NoTimestamp;
              scheduleUpdateOnFiber(current, attemptHydrationAtLane, eventTime);
            }
          }

          renderDidSuspendDelayIfPossible();
          return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, new Error('This Suspense boundary received an update before it finished ' + 'hydrating. This caused the boundary to switch to client rendering. ' + 'The usual way to fix this is to wrap the original update ' + 'in startTransition.'));
        } else if (isSuspenseInstancePending(suspenseInstance)) {
          workInProgress.flags |= DidCapture;
          workInProgress.child = current.child;
          var retry = retryDehydratedSuspenseBoundary.bind(null, current);
          registerSuspenseInstanceRetry(suspenseInstance, retry);
          return null;
        } else {
          reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
          var nextProps = workInProgress.pendingProps;
          var primaryChildren = nextProps.children;
          var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren);
          primaryChildFragment.flags |= Hydrating;
          return primaryChildFragment;
        }
      }

      function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;

        if (alternate !== null) {
          alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        }

        scheduleContextWorkOnParentPath(fiber["return"], renderLanes, propagationRoot);
      }

      function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        var node = firstChild;

        while (node !== null) {
          if (node.tag === SuspenseComponent) {
            var state = node.memoizedState;

            if (state !== null) {
              scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            }
          } else if (node.tag === SuspenseListComponent) {
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
          } else if (node.child !== null) {
            node.child["return"] = node;
            node = node.child;
            continue;
          }

          if (node === workInProgress) {
            return;
          }

          while (node.sibling === null) {
            if (node["return"] === null || node["return"] === workInProgress) {
              return;
            }

            node = node["return"];
          }

          node.sibling["return"] = node["return"];
          node = node.sibling;
        }
      }

      function findLastContentRow(firstChild) {
        var row = firstChild;
        var lastContentRow = null;

        while (row !== null) {
          var currentRow = row.alternate;

          if (currentRow !== null && findFirstSuspended(currentRow) === null) {
            lastContentRow = row;
          }

          row = row.sibling;
        }

        return lastContentRow;
      }

      function validateRevealOrder(revealOrder) {
        {
          if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;

            if (typeof revealOrder === 'string') {
              switch (revealOrder.toLowerCase()) {
                case 'together':
                case 'forwards':
                case 'backwards':
                  {
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }

                case 'forward':
                case 'backward':
                  {
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }

                default:
                  error('"%s" is not a supported revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
                  break;
              }
            } else {
              error('%s is not a supported value for revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
            }
          }
        }
      }

      function validateTailOptions(tailMode, revealOrder) {
        {
          if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
              didWarnAboutTailOptions[tailMode] = true;
              error('"%s" is not a supported value for tail on <SuspenseList />. ' + 'Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
              didWarnAboutTailOptions[tailMode] = true;
              error('<SuspenseList tail="%s" /> is only valid if revealOrder is ' + '"forwards" or "backwards". ' + 'Did you mean to specify revealOrder="forwards"?', tailMode);
            }
          }
        }
      }

      function validateSuspenseListNestedChild(childSlot, index) {
        {
          var isAnArray = isArray(childSlot);
          var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === 'function';

          if (isAnArray || isIterable) {
            var type = isAnArray ? 'array' : 'iterable';
            error('A nested %s was passed to row #%s in <SuspenseList />. Wrap it in ' + 'an additional SuspenseList to configure its revealOrder: ' + '<SuspenseList revealOrder=...> ... ' + '<SuspenseList revealOrder=...>{%s}</SuspenseList> ... ' + '</SuspenseList>', type, index, type);
            return false;
          }
        }
        return true;
      }

      function validateSuspenseListChildren(children, revealOrder) {
        {
          if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) {
              for (var i = 0; i < children.length; i++) {
                if (!validateSuspenseListNestedChild(children[i], i)) {
                  return;
                }
              }
            } else {
              var iteratorFn = getIteratorFn(children);

              if (typeof iteratorFn === 'function') {
                var childrenIterator = iteratorFn.call(children);

                if (childrenIterator) {
                  var step = childrenIterator.next();
                  var _i = 0;

                  for (; !step.done; step = childrenIterator.next()) {
                    if (!validateSuspenseListNestedChild(step.value, _i)) {
                      return;
                    }

                    _i++;
                  }
                }
              } else {
                error('A single row was passed to a <SuspenseList revealOrder="%s" />. ' + 'This is not useful since it needs multiple rows. ' + 'Did you mean to pass multiple children or an array?', revealOrder);
              }
            }
          }
        }
      }

      function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;

        if (renderState === null) {
          workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
          };
        } else {
          renderState.isBackwards = isBackwards;
          renderState.rendering = null;
          renderState.renderingStartTime = 0;
          renderState.last = lastContentRow;
          renderState.tail = tail;
          renderState.tailMode = tailMode;
        }
      }

      function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);

        if (shouldForceFallback) {
          suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
          workInProgress.flags |= DidCapture;
        } else {
          var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;

          if (didSuspendBefore) {
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
          }

          suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }

        pushSuspenseContext(workInProgress, suspenseContext);

        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
          workInProgress.memoizedState = null;
        } else {
          switch (revealOrder) {
            case 'forwards':
              {
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;

                if (lastContentRow === null) {
                  tail = workInProgress.child;
                  workInProgress.child = null;
                } else {
                  tail = lastContentRow.sibling;
                  lastContentRow.sibling = null;
                }

                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
              }

            case 'backwards':
              {
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;

                while (row !== null) {
                  var currentRow = row.alternate;

                  if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                    workInProgress.child = row;
                    break;
                  }

                  var nextRow = row.sibling;
                  row.sibling = _tail;
                  _tail = row;
                  row = nextRow;
                }

                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
              }

            case 'together':
              {
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
              }

            default:
              {
                workInProgress.memoizedState = null;
              }
          }
        }

        return workInProgress.child;
      }

      function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;

        if (current === null) {
          workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        } else {
          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }

        return workInProgress.child;
      }

      var hasWarnedAboutUsingNoValuePropOnContextProvider = false;

      function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        {
          if (!('value' in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
              hasWarnedAboutUsingNoValuePropOnContextProvider = true;
              error('The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?');
            }
          }

          var providerPropTypes = workInProgress.type.propTypes;

          if (providerPropTypes) {
            checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider');
          }
        }
        pushProvider(workInProgress, context, newValue);
        {
          if (oldProps !== null) {
            var oldValue = oldProps.value;

            if (objectIs(oldValue, newValue)) {
              if (oldProps.children === newProps.children && !hasContextChanged()) {
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
              }
            } else {
              propagateContextChange(workInProgress, context, renderLanes);
            }
          }
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
      }

      var hasWarnedAboutUsingContextAsConsumer = false;

      function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type;
        {
          if (context._context === undefined) {
            if (context !== context.Consumer) {
              if (!hasWarnedAboutUsingContextAsConsumer) {
                hasWarnedAboutUsingContextAsConsumer = true;
                error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
              }
            }
          } else {
            context = context._context;
          }
        }
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        {
          if (typeof render !== 'function') {
            error('A context consumer was rendered with multiple children, or a child ' + "that isn't a function. A context consumer expects a single child " + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.');
          }
        }
        prepareToReadContext(workInProgress, renderLanes);

        var newValue = _readContext(context);

        {
          markComponentRenderStarted(workInProgress);
        }
        var newChildren;
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          newChildren = render(newValue);
          setIsRendering(false);
        }
        {
          markComponentRenderStopped();
        }
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
      }

      function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
      }

      function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) {
          workInProgress.dependencies = current.dependencies;
        }

        {
          stopProfilerTimerIfRunning();
        }
        markSkippedUpdateLanes(workInProgress.lanes);

        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) {
          {
            return null;
          }
        }

        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
      }

      function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        {
          var returnFiber = oldWorkInProgress["return"];

          if (returnFiber === null) {
            throw new Error('Cannot swap the root fiber.');
          }

          current.alternate = null;
          oldWorkInProgress.alternate = null;
          newWorkInProgress.index = oldWorkInProgress.index;
          newWorkInProgress.sibling = oldWorkInProgress.sibling;
          newWorkInProgress["return"] = oldWorkInProgress["return"];
          newWorkInProgress.ref = oldWorkInProgress.ref;

          if (oldWorkInProgress === returnFiber.child) {
            returnFiber.child = newWorkInProgress;
          } else {
            var prevSibling = returnFiber.child;

            if (prevSibling === null) {
              throw new Error('Expected parent to have a child.');
            }

            while (prevSibling.sibling !== oldWorkInProgress) {
              prevSibling = prevSibling.sibling;

              if (prevSibling === null) {
                throw new Error('Expected to find the previous sibling.');
              }
            }

            prevSibling.sibling = newWorkInProgress;
          }

          var deletions = returnFiber.deletions;

          if (deletions === null) {
            returnFiber.deletions = [current];
            returnFiber.flags |= ChildDeletion;
          } else {
            deletions.push(current);
          }

          newWorkInProgress.flags |= Placement;
          return newWorkInProgress;
        }
      }

      function checkScheduledUpdateOrContext(current, renderLanes) {
        var updateLanes = current.lanes;

        if (includesSomeLane(updateLanes, renderLanes)) {
          return true;
        }

        return false;
      }

      function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        switch (workInProgress.tag) {
          case HostRoot:
            pushHostRootContext(workInProgress);
            resetHydrationState();
            break;

          case HostComponent:
            pushHostContext(workInProgress);
            break;

          case ClassComponent:
            {
              var Component = workInProgress.type;

              if (isContextProvider(Component)) {
                pushContextProvider(workInProgress);
              }

              break;
            }

          case HostPortal:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;

          case ContextProvider:
            {
              var newValue = workInProgress.memoizedProps.value;
              var context = workInProgress.type._context;
              pushProvider(workInProgress, context, newValue);
              break;
            }

          case Profiler:
            {
              var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);

              if (hasChildWork) {
                workInProgress.flags |= Update;
              }

              {
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
              }
            }
            break;

          case SuspenseComponent:
            {
              var state = workInProgress.memoizedState;

              if (state !== null) {
                if (state.dehydrated !== null) {
                  pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                  workInProgress.flags |= DidCapture;
                  return null;
                }

                var primaryChildFragment = workInProgress.child;
                var primaryChildLanes = primaryChildFragment.childLanes;

                if (includesSomeLane(renderLanes, primaryChildLanes)) {
                  return updateSuspenseComponent(current, workInProgress, renderLanes);
                } else {
                  pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                  var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);

                  if (child !== null) {
                    return child.sibling;
                  } else {
                    return null;
                  }
                }
              } else {
                pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
              }

              break;
            }

          case SuspenseListComponent:
            {
              var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;

              var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);

              if (didSuspendBefore) {
                if (_hasChildWork) {
                  return updateSuspenseListComponent(current, workInProgress, renderLanes);
                }

                workInProgress.flags |= DidCapture;
              }

              var renderState = workInProgress.memoizedState;

              if (renderState !== null) {
                renderState.rendering = null;
                renderState.tail = null;
                renderState.lastEffect = null;
              }

              pushSuspenseContext(workInProgress, suspenseStackCursor.current);

              if (_hasChildWork) {
                break;
              } else {
                return null;
              }
            }

          case OffscreenComponent:
          case LegacyHiddenComponent:
            {
              workInProgress.lanes = NoLanes;
              return updateOffscreenComponent(current, workInProgress, renderLanes);
            }
        }

        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
      }

      function beginWork(current, workInProgress, renderLanes) {
        {
          if (workInProgress._debugNeedsRemount && current !== null) {
            return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
          }
        }

        if (current !== null) {
          var oldProps = current.memoizedProps;
          var newProps = workInProgress.pendingProps;

          if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) {
            didReceiveUpdate = true;
          } else {
            var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);

            if (!hasScheduledUpdateOrContext && (workInProgress.flags & DidCapture) === NoFlags) {
              didReceiveUpdate = false;
              return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            }

            if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
              didReceiveUpdate = true;
            } else {
              didReceiveUpdate = false;
            }
          }
        } else {
          didReceiveUpdate = false;

          if (getIsHydrating() && isForkedChild(workInProgress)) {
            var slotIndex = workInProgress.index;
            var numberOfForks = getForksAtLevel();
            pushTreeId(workInProgress, numberOfForks, slotIndex);
          }
        }

        workInProgress.lanes = NoLanes;

        switch (workInProgress.tag) {
          case IndeterminateComponent:
            {
              return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            }

          case LazyComponent:
            {
              var elementType = workInProgress.elementType;
              return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            }

          case FunctionComponent:
            {
              var Component = workInProgress.type;
              var unresolvedProps = workInProgress.pendingProps;
              var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
              return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            }

          case ClassComponent:
            {
              var _Component = workInProgress.type;
              var _unresolvedProps = workInProgress.pendingProps;

              var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);

              return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            }

          case HostRoot:
            return updateHostRoot(current, workInProgress, renderLanes);

          case HostComponent:
            return updateHostComponent$1(current, workInProgress, renderLanes);

          case HostText:
            return updateHostText$1(current, workInProgress);

          case SuspenseComponent:
            return updateSuspenseComponent(current, workInProgress, renderLanes);

          case HostPortal:
            return updatePortalComponent(current, workInProgress, renderLanes);

          case ForwardRef:
            {
              var type = workInProgress.type;
              var _unresolvedProps2 = workInProgress.pendingProps;

              var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);

              return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            }

          case Fragment:
            return updateFragment(current, workInProgress, renderLanes);

          case Mode:
            return updateMode(current, workInProgress, renderLanes);

          case Profiler:
            return updateProfiler(current, workInProgress, renderLanes);

          case ContextProvider:
            return updateContextProvider(current, workInProgress, renderLanes);

          case ContextConsumer:
            return updateContextConsumer(current, workInProgress, renderLanes);

          case MemoComponent:
            {
              var _type2 = workInProgress.type;
              var _unresolvedProps3 = workInProgress.pendingProps;

              var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);

              {
                if (workInProgress.type !== workInProgress.elementType) {
                  var outerPropTypes = _type2.propTypes;

                  if (outerPropTypes) {
                    checkPropTypes(outerPropTypes, _resolvedProps3, 'prop', getComponentNameFromType(_type2));
                  }
                }
              }
              _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
              return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            }

          case SimpleMemoComponent:
            {
              return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            }

          case IncompleteClassComponent:
            {
              var _Component2 = workInProgress.type;
              var _unresolvedProps4 = workInProgress.pendingProps;

              var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);

              return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            }

          case SuspenseListComponent:
            {
              return updateSuspenseListComponent(current, workInProgress, renderLanes);
            }

          case ScopeComponent:
            {
              break;
            }

          case OffscreenComponent:
            {
              return updateOffscreenComponent(current, workInProgress, renderLanes);
            }
        }

        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + 'React. Please file an issue.');
      }

      function unwindWork(current, workInProgress, renderLanes) {
        popTreeContext(workInProgress);

        switch (workInProgress.tag) {
          case ClassComponent:
            {
              var Component = workInProgress.type;

              if (isContextProvider(Component)) {
                popContext(workInProgress);
              }

              var flags = workInProgress.flags;

              if (flags & ShouldCapture) {
                workInProgress.flags = flags & ~ShouldCapture | DidCapture;

                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                  transferActualDuration(workInProgress);
                }

                return workInProgress;
              }

              return null;
            }

          case HostRoot:
            {
              popHostContainer(workInProgress);
              popTopLevelContextObject(workInProgress);
              resetWorkInProgressVersions();
              var _flags = workInProgress.flags;

              if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                return workInProgress;
              }

              return null;
            }

          case HostComponent:
            {
              popHostContext(workInProgress);
              return null;
            }

          case SuspenseComponent:
            {
              popSuspenseContext(workInProgress);
              var suspenseState = workInProgress.memoizedState;

              if (suspenseState !== null && suspenseState.dehydrated !== null) {
                if (workInProgress.alternate === null) {
                  throw new Error('Threw in newly mounted dehydrated component. This is likely a bug in ' + 'React. Please file an issue.');
                }

                resetHydrationState();
              }

              var _flags2 = workInProgress.flags;

              if (_flags2 & ShouldCapture) {
                workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture;

                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                  transferActualDuration(workInProgress);
                }

                return workInProgress;
              }

              return null;
            }

          case SuspenseListComponent:
            {
              popSuspenseContext(workInProgress);
              return null;
            }

          case HostPortal:
            popHostContainer(workInProgress);
            return null;

          case ContextProvider:
            var context = workInProgress.type._context;
            popProvider(context, workInProgress);
            return null;

          case OffscreenComponent:
          case LegacyHiddenComponent:
            popRenderLanes(workInProgress);
            return null;

          case CacheComponent:
            return null;

          default:
            return null;
        }
      }

      function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        popTreeContext(interruptedWork);

        switch (interruptedWork.tag) {
          case ClassComponent:
            {
              var childContextTypes = interruptedWork.type.childContextTypes;

              if (childContextTypes !== null && childContextTypes !== undefined) {
                popContext(interruptedWork);
              }

              break;
            }

          case HostRoot:
            {
              popHostContainer(interruptedWork);
              popTopLevelContextObject(interruptedWork);
              resetWorkInProgressVersions();
              break;
            }

          case HostComponent:
            {
              popHostContext(interruptedWork);
              break;
            }

          case HostPortal:
            popHostContainer(interruptedWork);
            break;

          case SuspenseComponent:
            popSuspenseContext(interruptedWork);
            break;

          case SuspenseListComponent:
            popSuspenseContext(interruptedWork);
            break;

          case ContextProvider:
            var context = interruptedWork.type._context;
            popProvider(context, interruptedWork);
            break;

          case OffscreenComponent:
          case LegacyHiddenComponent:
            popRenderLanes(interruptedWork);
            break;
        }
      }

      var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
      {
        didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
      }
      var offscreenSubtreeIsHidden = false;
      var offscreenSubtreeWasHidden = false;
      var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
      var nextEffect = null;
      var inProgressLanes = null;
      var inProgressRoot = null;

      function reportUncaughtErrorInDEV(error) {
        {
          invokeGuardedCallback(null, function () {
            throw error;
          });
          clearCaughtError();
        }
      }

      var callComponentWillUnmountWithTimer = function callComponentWillUnmountWithTimer(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;

        if (current.mode & ProfileMode) {
          try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
          } finally {
            recordLayoutEffectDuration(current);
          }
        } else {
          instance.componentWillUnmount();
        }
      };

      function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
          commitHookEffectListMount(Layout, current);
        } catch (error) {
          captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
      }

      function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
          callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
          captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
      }

      function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
          instance.componentDidMount();
        } catch (error) {
          captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
      }

      function safelyAttachRef(current, nearestMountedAncestor) {
        try {
          commitAttachRef(current);
        } catch (error) {
          captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
      }

      function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;

        if (ref !== null) {
          if (typeof ref === 'function') {
            var retVal;

            try {
              if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) {
                try {
                  startLayoutEffectTimer();
                  retVal = ref(null);
                } finally {
                  recordLayoutEffectDuration(current);
                }
              } else {
                retVal = ref(null);
              }
            } catch (error) {
              captureCommitPhaseError(current, nearestMountedAncestor, error);
            }

            {
              if (typeof retVal === 'function') {
                error('Unexpected return value from a callback ref in %s. ' + 'A callback ref should not return a function.', getComponentNameFromFiber(current));
              }
            }
          } else {
            ref.current = null;
          }
        }
      }

      function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
          destroy();
        } catch (error) {
          captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
      }

      var focusedInstanceHandle = null;
      var shouldFireAfterActiveInstanceBlur = false;

      function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit();
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin();
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
      }

      function commitBeforeMutationEffects_begin() {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var child = fiber.child;

          if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
            child["return"] = fiber;
            nextEffect = child;
          } else {
            commitBeforeMutationEffects_complete();
          }
        }
      }

      function commitBeforeMutationEffects_complete() {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          setCurrentFiber(fiber);

          try {
            commitBeforeMutationEffectsOnFiber(fiber);
          } catch (error) {
            captureCommitPhaseError(fiber, fiber["return"], error);
          }

          resetCurrentFiber();
          var sibling = fiber.sibling;

          if (sibling !== null) {
            sibling["return"] = fiber["return"];
            nextEffect = sibling;
            return;
          }

          nextEffect = fiber["return"];
        }
      }

      function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;

        if ((flags & Snapshot) !== NoFlags) {
          setCurrentFiber(finishedWork);

          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
              {
                break;
              }

            case ClassComponent:
              {
                if (current !== null) {
                  var prevProps = current.memoizedProps;
                  var prevState = current.memoizedState;
                  var instance = finishedWork.stateNode;
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                      }

                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                      }
                    }
                  }
                  var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                  {
                    var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;

                    if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                      didWarnSet.add(finishedWork.type);
                      error('%s.getSnapshotBeforeUpdate(): A snapshot value (or null) ' + 'must be returned. You have returned undefined.', getComponentNameFromFiber(finishedWork));
                    }
                  }
                  instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                }

                break;
              }

            case HostRoot:
              {
                {
                  var root = finishedWork.stateNode;
                  clearContainer(root.containerInfo);
                }
                break;
              }

            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
              break;

            default:
              {
                throw new Error('This unit of work tag should not have side-effects. This error is ' + 'likely caused by a bug in React. Please file an issue.');
              }
          }

          resetCurrentFiber();
        }
      }

      function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

        if (lastEffect !== null) {
          var firstEffect = lastEffect.next;
          var effect = firstEffect;

          do {
            if ((effect.tag & flags) === flags) {
              var destroy = effect.destroy;
              effect.destroy = undefined;

              if (destroy !== undefined) {
                {
                  if ((flags & Passive$1) !== NoFlags$1) {
                    markComponentPassiveEffectUnmountStarted(finishedWork);
                  } else if ((flags & Layout) !== NoFlags$1) {
                    markComponentLayoutEffectUnmountStarted(finishedWork);
                  }
                }
                {
                  if ((flags & Insertion) !== NoFlags$1) {
                    setIsRunningInsertionEffect(true);
                  }
                }
                safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                {
                  if ((flags & Insertion) !== NoFlags$1) {
                    setIsRunningInsertionEffect(false);
                  }
                }
                {
                  if ((flags & Passive$1) !== NoFlags$1) {
                    markComponentPassiveEffectUnmountStopped();
                  } else if ((flags & Layout) !== NoFlags$1) {
                    markComponentLayoutEffectUnmountStopped();
                  }
                }
              }
            }

            effect = effect.next;
          } while (effect !== firstEffect);
        }
      }

      function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

        if (lastEffect !== null) {
          var firstEffect = lastEffect.next;
          var effect = firstEffect;

          do {
            if ((effect.tag & flags) === flags) {
              {
                if ((flags & Passive$1) !== NoFlags$1) {
                  markComponentPassiveEffectMountStarted(finishedWork);
                } else if ((flags & Layout) !== NoFlags$1) {
                  markComponentLayoutEffectMountStarted(finishedWork);
                }
              }
              var create = effect.create;
              {
                if ((flags & Insertion) !== NoFlags$1) {
                  setIsRunningInsertionEffect(true);
                }
              }
              effect.destroy = create();
              {
                if ((flags & Insertion) !== NoFlags$1) {
                  setIsRunningInsertionEffect(false);
                }
              }
              {
                if ((flags & Passive$1) !== NoFlags$1) {
                  markComponentPassiveEffectMountStopped();
                } else if ((flags & Layout) !== NoFlags$1) {
                  markComponentLayoutEffectMountStopped();
                }
              }
              {
                var destroy = effect.destroy;

                if (destroy !== undefined && typeof destroy !== 'function') {
                  var hookName = void 0;

                  if ((effect.tag & Layout) !== NoFlags) {
                    hookName = 'useLayoutEffect';
                  } else if ((effect.tag & Insertion) !== NoFlags) {
                    hookName = 'useInsertionEffect';
                  } else {
                    hookName = 'useEffect';
                  }

                  var addendum = void 0;

                  if (destroy === null) {
                    addendum = ' You returned null. If your effect does not require clean ' + 'up, return undefined (or nothing).';
                  } else if (typeof destroy.then === 'function') {
                    addendum = '\n\nIt looks like you wrote ' + hookName + '(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + hookName + '(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + 'Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching';
                  } else {
                    addendum = ' You returned: ' + destroy;
                  }

                  error('%s must not return anything besides a function, ' + 'which is used for clean-up.%s', hookName, addendum);
                }
              }
            }

            effect = effect.next;
          } while (effect !== firstEffect);
        }
      }

      function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        {
          if ((finishedWork.flags & Update) !== NoFlags) {
            switch (finishedWork.tag) {
              case Profiler:
                {
                  var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                  var _finishedWork$memoize = finishedWork.memoizedProps,
                      id = _finishedWork$memoize.id,
                      onPostCommit = _finishedWork$memoize.onPostCommit;
                  var commitTime = getCommitTime();
                  var phase = finishedWork.alternate === null ? 'mount' : 'update';
                  {
                    if (isCurrentUpdateNested()) {
                      phase = 'nested-update';
                    }
                  }

                  if (typeof onPostCommit === 'function') {
                    onPostCommit(id, phase, passiveEffectDuration, commitTime);
                  }

                  var parentFiber = finishedWork["return"];

                  outer: while (parentFiber !== null) {
                    switch (parentFiber.tag) {
                      case HostRoot:
                        var root = parentFiber.stateNode;
                        root.passiveEffectDuration += passiveEffectDuration;
                        break outer;

                      case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.passiveEffectDuration += passiveEffectDuration;
                        break outer;
                    }

                    parentFiber = parentFiber["return"];
                  }

                  break;
                }
            }
          }
        }
      }

      function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
              {
                if (!offscreenSubtreeWasHidden) {
                  if (finishedWork.mode & ProfileMode) {
                    try {
                      startLayoutEffectTimer();
                      commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally {
                      recordLayoutEffectDuration(finishedWork);
                    }
                  } else {
                    commitHookEffectListMount(Layout | HasEffect, finishedWork);
                  }
                }

                break;
              }

            case ClassComponent:
              {
                var instance = finishedWork.stateNode;

                if (finishedWork.flags & Update) {
                  if (!offscreenSubtreeWasHidden) {
                    if (current === null) {
                      {
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                          if (instance.props !== finishedWork.memoizedProps) {
                            error('Expected %s props to match memoized props before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                          }

                          if (instance.state !== finishedWork.memoizedState) {
                            error('Expected %s state to match memoized state before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                          }
                        }
                      }

                      if (finishedWork.mode & ProfileMode) {
                        try {
                          startLayoutEffectTimer();
                          instance.componentDidMount();
                        } finally {
                          recordLayoutEffectDuration(finishedWork);
                        }
                      } else {
                        instance.componentDidMount();
                      }
                    } else {
                      var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                      var prevState = current.memoizedState;
                      {
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                          if (instance.props !== finishedWork.memoizedProps) {
                            error('Expected %s props to match memoized props before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                          }

                          if (instance.state !== finishedWork.memoizedState) {
                            error('Expected %s state to match memoized state before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                          }
                        }
                      }

                      if (finishedWork.mode & ProfileMode) {
                        try {
                          startLayoutEffectTimer();
                          instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        } finally {
                          recordLayoutEffectDuration(finishedWork);
                        }
                      } else {
                        instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                      }
                    }
                  }
                }

                var updateQueue = finishedWork.updateQueue;

                if (updateQueue !== null) {
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                      }

                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentNameFromFiber(finishedWork) || 'instance');
                      }
                    }
                  }
                  commitUpdateQueue(finishedWork, updateQueue, instance);
                }

                break;
              }

            case HostRoot:
              {
                var _updateQueue = finishedWork.updateQueue;

                if (_updateQueue !== null) {
                  var _instance = null;

                  if (finishedWork.child !== null) {
                    switch (finishedWork.child.tag) {
                      case HostComponent:
                        _instance = getPublicInstance(finishedWork.child.stateNode);
                        break;

                      case ClassComponent:
                        _instance = finishedWork.child.stateNode;
                        break;
                    }
                  }

                  commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }

                break;
              }

            case HostComponent:
              {
                var _instance2 = finishedWork.stateNode;

                if (current === null && finishedWork.flags & Update) {
                  var type = finishedWork.type;
                  var props = finishedWork.memoizedProps;
                  commitMount(_instance2, type, props);
                }

                break;
              }

            case HostText:
              {
                break;
              }

            case HostPortal:
              {
                break;
              }

            case Profiler:
              {
                {
                  var _finishedWork$memoize2 = finishedWork.memoizedProps,
                      onCommit = _finishedWork$memoize2.onCommit,
                      onRender = _finishedWork$memoize2.onRender;
                  var effectDuration = finishedWork.stateNode.effectDuration;
                  var commitTime = getCommitTime();
                  var phase = current === null ? 'mount' : 'update';
                  {
                    if (isCurrentUpdateNested()) {
                      phase = 'nested-update';
                    }
                  }

                  if (typeof onRender === 'function') {
                    onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                  }

                  {
                    if (typeof onCommit === 'function') {
                      onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                    }

                    enqueuePendingPassiveProfilerEffect(finishedWork);
                    var parentFiber = finishedWork["return"];

                    outer: while (parentFiber !== null) {
                      switch (parentFiber.tag) {
                        case HostRoot:
                          var root = parentFiber.stateNode;
                          root.effectDuration += effectDuration;
                          break outer;

                        case Profiler:
                          var parentStateNode = parentFiber.stateNode;
                          parentStateNode.effectDuration += effectDuration;
                          break outer;
                      }

                      parentFiber = parentFiber["return"];
                    }
                  }
                }
                break;
              }

            case SuspenseComponent:
              {
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
              }

            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
              {
                break;
              }

            default:
              throw new Error('This unit of work tag should not have side-effects. This error is ' + 'likely caused by a bug in React. Please file an issue.');
          }
        }

        if (!offscreenSubtreeWasHidden) {
          {
            if (finishedWork.flags & Ref) {
              commitAttachRef(finishedWork);
            }
          }
        }
      }

      function reappearLayoutEffectsOnFiber(node) {
        switch (node.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
            {
              if (node.mode & ProfileMode) {
                try {
                  startLayoutEffectTimer();
                  safelyCallCommitHookLayoutEffectListMount(node, node["return"]);
                } finally {
                  recordLayoutEffectDuration(node);
                }
              } else {
                safelyCallCommitHookLayoutEffectListMount(node, node["return"]);
              }

              break;
            }

          case ClassComponent:
            {
              var instance = node.stateNode;

              if (typeof instance.componentDidMount === 'function') {
                safelyCallComponentDidMount(node, node["return"], instance);
              }

              safelyAttachRef(node, node["return"]);
              break;
            }

          case HostComponent:
            {
              safelyAttachRef(node, node["return"]);
              break;
            }
        }
      }

      function hideOrUnhideAllChildren(finishedWork, isHidden) {
        var hostSubtreeRoot = null;
        {
          var node = finishedWork;

          while (true) {
            if (node.tag === HostComponent) {
              if (hostSubtreeRoot === null) {
                hostSubtreeRoot = node;

                try {
                  var instance = node.stateNode;

                  if (isHidden) {
                    hideInstance(instance);
                  } else {
                    unhideInstance(node.stateNode, node.memoizedProps);
                  }
                } catch (error) {
                  captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                }
              }
            } else if (node.tag === HostText) {
              if (hostSubtreeRoot === null) {
                try {
                  var _instance3 = node.stateNode;

                  if (isHidden) {
                    hideTextInstance(_instance3);
                  } else {
                    unhideTextInstance(_instance3, node.memoizedProps);
                  }
                } catch (error) {
                  captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                }
              }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;else if (node.child !== null) {
              node.child["return"] = node;
              node = node.child;
              continue;
            }

            if (node === finishedWork) {
              return;
            }

            while (node.sibling === null) {
              if (node["return"] === null || node["return"] === finishedWork) {
                return;
              }

              if (hostSubtreeRoot === node) {
                hostSubtreeRoot = null;
              }

              node = node["return"];
            }

            if (hostSubtreeRoot === node) {
              hostSubtreeRoot = null;
            }

            node.sibling["return"] = node["return"];
            node = node.sibling;
          }
        }
      }

      function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;

        if (ref !== null) {
          var instance = finishedWork.stateNode;
          var instanceToUse;

          switch (finishedWork.tag) {
            case HostComponent:
              instanceToUse = getPublicInstance(instance);
              break;

            default:
              instanceToUse = instance;
          }

          if (typeof ref === 'function') {
            var retVal;

            if (finishedWork.mode & ProfileMode) {
              try {
                startLayoutEffectTimer();
                retVal = ref(instanceToUse);
              } finally {
                recordLayoutEffectDuration(finishedWork);
              }
            } else {
              retVal = ref(instanceToUse);
            }

            {
              if (typeof retVal === 'function') {
                error('Unexpected return value from a callback ref in %s. ' + 'A callback ref should not return a function.', getComponentNameFromFiber(finishedWork));
              }
            }
          } else {
            {
              if (!ref.hasOwnProperty('current')) {
                error('Unexpected ref object provided for %s. ' + 'Use either a ref-setter function or React.createRef().', getComponentNameFromFiber(finishedWork));
              }
            }
            ref.current = instanceToUse;
          }
        }
      }

      function detachFiberMutation(fiber) {
        var alternate = fiber.alternate;

        if (alternate !== null) {
          alternate["return"] = null;
        }

        fiber["return"] = null;
      }

      function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;

        if (alternate !== null) {
          fiber.alternate = null;
          detachFiberAfterEffects(alternate);
        }

        {
          fiber.child = null;
          fiber.deletions = null;
          fiber.sibling = null;

          if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;

            if (hostInstance !== null) {
              detachDeletedInstance(hostInstance);
            }
          }

          fiber.stateNode = null;
          {
            fiber._debugOwner = null;
          }
          {
            fiber["return"] = null;
            fiber.dependencies = null;
            fiber.memoizedProps = null;
            fiber.memoizedState = null;
            fiber.pendingProps = null;
            fiber.stateNode = null;
            fiber.updateQueue = null;
          }
        }
      }

      function getHostParentFiber(fiber) {
        var parent = fiber["return"];

        while (parent !== null) {
          if (isHostParent(parent)) {
            return parent;
          }

          parent = parent["return"];
        }

        throw new Error('Expected to find a host parent. This error is likely caused by a bug ' + 'in React. Please file an issue.');
      }

      function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
      }

      function getHostSibling(fiber) {
        var node = fiber;

        siblings: while (true) {
          while (node.sibling === null) {
            if (node["return"] === null || isHostParent(node["return"])) {
              return null;
            }

            node = node["return"];
          }

          node.sibling["return"] = node["return"];
          node = node.sibling;

          while (node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment) {
            if (node.flags & Placement) {
              continue siblings;
            }

            if (node.child === null || node.tag === HostPortal) {
              continue siblings;
            } else {
              node.child["return"] = node;
              node = node.child;
            }
          }

          if (!(node.flags & Placement)) {
            return node.stateNode;
          }
        }
      }

      function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork);

        switch (parentFiber.tag) {
          case HostComponent:
            {
              var parent = parentFiber.stateNode;

              if (parentFiber.flags & ContentReset) {
                resetTextContent(parent);
                parentFiber.flags &= ~ContentReset;
              }

              var before = getHostSibling(finishedWork);
              insertOrAppendPlacementNode(finishedWork, before, parent);
              break;
            }

          case HostRoot:
          case HostPortal:
            {
              var _parent = parentFiber.stateNode.containerInfo;

              var _before = getHostSibling(finishedWork);

              insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
              break;
            }

          default:
            throw new Error('Invalid host parent fiber. This error is likely caused by a bug ' + 'in React. Please file an issue.');
        }
      }

      function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;

        if (isHost) {
          var stateNode = node.stateNode;

          if (before) {
            insertInContainerBefore(parent, stateNode, before);
          } else {
            appendChildToContainer(parent, stateNode);
          }
        } else if (tag === HostPortal) ;else {
          var child = node.child;

          if (child !== null) {
            insertOrAppendPlacementNodeIntoContainer(child, before, parent);
            var sibling = child.sibling;

            while (sibling !== null) {
              insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
              sibling = sibling.sibling;
            }
          }
        }
      }

      function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;

        if (isHost) {
          var stateNode = node.stateNode;

          if (before) {
            insertBefore(parent, stateNode, before);
          } else {
            appendChild(parent, stateNode);
          }
        } else if (tag === HostPortal) ;else {
          var child = node.child;

          if (child !== null) {
            insertOrAppendPlacementNode(child, before, parent);
            var sibling = child.sibling;

            while (sibling !== null) {
              insertOrAppendPlacementNode(sibling, before, parent);
              sibling = sibling.sibling;
            }
          }
        }
      }

      var hostParent = null;
      var hostParentIsContainer = false;

      function commitDeletionEffects(root, returnFiber, deletedFiber) {
        {
          var parent = returnFiber;

          findParent: while (parent !== null) {
            switch (parent.tag) {
              case HostComponent:
                {
                  hostParent = parent.stateNode;
                  hostParentIsContainer = false;
                  break findParent;
                }

              case HostRoot:
                {
                  hostParent = parent.stateNode.containerInfo;
                  hostParentIsContainer = true;
                  break findParent;
                }

              case HostPortal:
                {
                  hostParent = parent.stateNode.containerInfo;
                  hostParentIsContainer = true;
                  break findParent;
                }
            }

            parent = parent["return"];
          }

          if (hostParent === null) {
            throw new Error('Expected to find a host parent. This error is likely caused by ' + 'a bug in React. Please file an issue.');
          }

          commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
          hostParent = null;
          hostParentIsContainer = false;
        }
        detachFiberMutation(deletedFiber);
      }

      function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        var child = parent.child;

        while (child !== null) {
          commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
          child = child.sibling;
        }
      }

      function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber);

        switch (deletedFiber.tag) {
          case HostComponent:
            {
              if (!offscreenSubtreeWasHidden) {
                safelyDetachRef(deletedFiber, nearestMountedAncestor);
              }
            }

          case HostText:
            {
              {
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;

                if (hostParent !== null) {
                  if (hostParentIsContainer) {
                    removeChildFromContainer(hostParent, deletedFiber.stateNode);
                  } else {
                    removeChild(hostParent, deletedFiber.stateNode);
                  }
                }
              }
              return;
            }

          case DehydratedFragment:
            {
              {
                if (hostParent !== null) {
                  if (hostParentIsContainer) {
                    clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                  } else {
                    clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                  }
                }
              }
              return;
            }

          case HostPortal:
            {
              {
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
              }
              return;
            }

          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent:
            {
              if (!offscreenSubtreeWasHidden) {
                var updateQueue = deletedFiber.updateQueue;

                if (updateQueue !== null) {
                  var lastEffect = updateQueue.lastEffect;

                  if (lastEffect !== null) {
                    var firstEffect = lastEffect.next;
                    var effect = firstEffect;

                    do {
                      var _effect = effect,
                          destroy = _effect.destroy,
                          tag = _effect.tag;

                      if (destroy !== undefined) {
                        if ((tag & Insertion) !== NoFlags$1) {
                          safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                        } else if ((tag & Layout) !== NoFlags$1) {
                          {
                            markComponentLayoutEffectUnmountStarted(deletedFiber);
                          }

                          if (deletedFiber.mode & ProfileMode) {
                            startLayoutEffectTimer();
                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                            recordLayoutEffectDuration(deletedFiber);
                          } else {
                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                          }

                          {
                            markComponentLayoutEffectUnmountStopped();
                          }
                        }
                      }

                      effect = effect.next;
                    } while (effect !== firstEffect);
                  }
                }
              }

              recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
              return;
            }

          case ClassComponent:
            {
              if (!offscreenSubtreeWasHidden) {
                safelyDetachRef(deletedFiber, nearestMountedAncestor);
                var instance = deletedFiber.stateNode;

                if (typeof instance.componentWillUnmount === 'function') {
                  safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
              }

              recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
              return;
            }

          case ScopeComponent:
            {
              recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
              return;
            }

          case OffscreenComponent:
            {
              if (deletedFiber.mode & ConcurrentMode) {
                var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
              } else {
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
              }

              break;
            }

          default:
            {
              recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
              return;
            }
        }
      }

      function commitSuspenseCallback(finishedWork) {
      }

      function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;

        if (newState === null) {
          var current = finishedWork.alternate;

          if (current !== null) {
            var prevState = current.memoizedState;

            if (prevState !== null) {
              var suspenseInstance = prevState.dehydrated;

              if (suspenseInstance !== null) {
                commitHydratedSuspenseInstance(suspenseInstance);
              }
            }
          }
        }
      }

      function attachSuspenseRetryListeners(finishedWork) {
        var wakeables = finishedWork.updateQueue;

        if (wakeables !== null) {
          finishedWork.updateQueue = null;
          var retryCache = finishedWork.stateNode;

          if (retryCache === null) {
            retryCache = finishedWork.stateNode = new PossiblyWeakSet();
          }

          wakeables.forEach(function (wakeable) {
            var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);

            if (!retryCache.has(wakeable)) {
              retryCache.add(wakeable);
              {
                if (isDevToolsPresent) {
                  if (inProgressLanes !== null && inProgressRoot !== null) {
                    restorePendingUpdaters(inProgressRoot, inProgressLanes);
                  } else {
                    throw Error('Expected finished root and lanes to be set. This is a bug in React.');
                  }
                }
              }
              wakeable.then(retry, retry);
            }
          });
        }
      }

      function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
      }

      function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        var deletions = parentFiber.deletions;

        if (deletions !== null) {
          for (var i = 0; i < deletions.length; i++) {
            var childToDelete = deletions[i];

            try {
              commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
              captureCommitPhaseError(childToDelete, parentFiber, error);
            }
          }
        }

        var prevDebugFiber = getCurrentFiber();

        if (parentFiber.subtreeFlags & MutationMask) {
          var child = parentFiber.child;

          while (child !== null) {
            setCurrentFiber(child);
            commitMutationEffectsOnFiber(child, root);
            child = child.sibling;
          }
        }

        setCurrentFiber(prevDebugFiber);
      }

      function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;

        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);

              if (flags & Update) {
                try {
                  commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork["return"]);
                  commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                } catch (error) {
                  captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                }

                if (finishedWork.mode & ProfileMode) {
                  try {
                    startLayoutEffectTimer();
                    commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork["return"]);
                  } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                  }

                  recordLayoutEffectDuration(finishedWork);
                } else {
                  try {
                    commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork["return"]);
                  } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                  }
                }
              }

              return;
            }

          case ClassComponent:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);

              if (flags & Ref) {
                if (current !== null) {
                  safelyDetachRef(current, current["return"]);
                }
              }

              return;
            }

          case HostComponent:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);

              if (flags & Ref) {
                if (current !== null) {
                  safelyDetachRef(current, current["return"]);
                }
              }

              {
                if (finishedWork.flags & ContentReset) {
                  var instance = finishedWork.stateNode;

                  try {
                    resetTextContent(instance);
                  } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                  }
                }

                if (flags & Update) {
                  var _instance4 = finishedWork.stateNode;

                  if (_instance4 != null) {
                    var newProps = finishedWork.memoizedProps;
                    var oldProps = current !== null ? current.memoizedProps : newProps;
                    var type = finishedWork.type;
                    var updatePayload = finishedWork.updateQueue;
                    finishedWork.updateQueue = null;

                    if (updatePayload !== null) {
                      try {
                        commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                      } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                      }
                    }
                  }
                }
              }
              return;
            }

          case HostText:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);

              if (flags & Update) {
                {
                  if (finishedWork.stateNode === null) {
                    throw new Error('This should have a text node initialized. This error is likely ' + 'caused by a bug in React. Please file an issue.');
                  }

                  var textInstance = finishedWork.stateNode;
                  var newText = finishedWork.memoizedProps;
                  var oldText = current !== null ? current.memoizedProps : newText;

                  try {
                    commitTextUpdate(textInstance, oldText, newText);
                  } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                  }
                }
              }

              return;
            }

          case HostRoot:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);

              if (flags & Update) {
                {
                  if (current !== null) {
                    var prevRootState = current.memoizedState;

                    if (prevRootState.isDehydrated) {
                      try {
                        commitHydratedContainer(root.containerInfo);
                      } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                      }
                    }
                  }
                }
              }

              return;
            }

          case HostPortal:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);
              return;
            }

          case SuspenseComponent:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);
              var offscreenFiber = finishedWork.child;

              if (offscreenFiber.flags & Visibility) {
                var newState = offscreenFiber.memoizedState;
                var isHidden = newState !== null;

                if (isHidden) {
                  var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;

                  if (!wasHidden) {
                    markCommitTimeOfFallback();
                  }
                }
              }

              if (flags & Update) {
                try {
                  commitSuspenseCallback(finishedWork);
                } catch (error) {
                  captureCommitPhaseError(finishedWork, finishedWork["return"], error);
                }

                attachSuspenseRetryListeners(finishedWork);
              }

              return;
            }

          case OffscreenComponent:
            {
              var _wasHidden = current !== null && current.memoizedState !== null;

              if (finishedWork.mode & ConcurrentMode) {
                var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                recursivelyTraverseMutationEffects(root, finishedWork);
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
              } else {
                recursivelyTraverseMutationEffects(root, finishedWork);
              }

              commitReconciliationEffects(finishedWork);

              if (flags & Visibility) {
                var _newState = finishedWork.memoizedState;

                var _isHidden = _newState !== null;

                var offscreenBoundary = finishedWork;
                {
                  hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                {
                  if (_isHidden) {
                    if (!_wasHidden) {
                      if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                        nextEffect = offscreenBoundary;
                        var offscreenChild = offscreenBoundary.child;

                        while (offscreenChild !== null) {
                          nextEffect = offscreenChild;
                          disappearLayoutEffects_begin(offscreenChild);
                          offscreenChild = offscreenChild.sibling;
                        }
                      }
                    }
                  }
                }
              }

              return;
            }

          case SuspenseListComponent:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);

              if (flags & Update) {
                attachSuspenseRetryListeners(finishedWork);
              }

              return;
            }

          case ScopeComponent:
            {
              return;
            }

          default:
            {
              recursivelyTraverseMutationEffects(root, finishedWork);
              commitReconciliationEffects(finishedWork);
              return;
            }
        }
      }

      function commitReconciliationEffects(finishedWork) {
        var flags = finishedWork.flags;

        if (flags & Placement) {
          try {
            commitPlacement(finishedWork);
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork["return"], error);
          }

          finishedWork.flags &= ~Placement;
        }

        if (flags & Hydrating) {
          finishedWork.flags &= ~Hydrating;
        }
      }

      function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
      }

      function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;

        while (nextEffect !== null) {
          var fiber = nextEffect;
          var firstChild = fiber.child;

          if (fiber.tag === OffscreenComponent && isModernRoot) {
            var isHidden = fiber.memoizedState !== null;
            var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;

            if (newOffscreenSubtreeIsHidden) {
              commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
              continue;
            } else {
              var current = fiber.alternate;
              var wasHidden = current !== null && current.memoizedState !== null;
              var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
              var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
              var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
              offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
              offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;

              if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                nextEffect = fiber;
                reappearLayoutEffects_begin(fiber);
              }

              var child = firstChild;

              while (child !== null) {
                nextEffect = child;
                commitLayoutEffects_begin(child, root, committedLanes);
                child = child.sibling;
              }

              nextEffect = fiber;
              offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
              offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
              commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
              continue;
            }
          }

          if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
            firstChild["return"] = fiber;
            nextEffect = firstChild;
          } else {
            commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
          }
        }
      }

      function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while (nextEffect !== null) {
          var fiber = nextEffect;

          if ((fiber.flags & LayoutMask) !== NoFlags) {
            var current = fiber.alternate;
            setCurrentFiber(fiber);

            try {
              commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
            } catch (error) {
              captureCommitPhaseError(fiber, fiber["return"], error);
            }

            resetCurrentFiber();
          }

          if (fiber === subtreeRoot) {
            nextEffect = null;
            return;
          }

          var sibling = fiber.sibling;

          if (sibling !== null) {
            sibling["return"] = fiber["return"];
            nextEffect = sibling;
            return;
          }

          nextEffect = fiber["return"];
        }
      }

      function disappearLayoutEffects_begin(subtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var firstChild = fiber.child;

          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
              {
                if (fiber.mode & ProfileMode) {
                  try {
                    startLayoutEffectTimer();
                    commitHookEffectListUnmount(Layout, fiber, fiber["return"]);
                  } finally {
                    recordLayoutEffectDuration(fiber);
                  }
                } else {
                  commitHookEffectListUnmount(Layout, fiber, fiber["return"]);
                }

                break;
              }

            case ClassComponent:
              {
                safelyDetachRef(fiber, fiber["return"]);
                var instance = fiber.stateNode;

                if (typeof instance.componentWillUnmount === 'function') {
                  safelyCallComponentWillUnmount(fiber, fiber["return"], instance);
                }

                break;
              }

            case HostComponent:
              {
                safelyDetachRef(fiber, fiber["return"]);
                break;
              }

            case OffscreenComponent:
              {
                var isHidden = fiber.memoizedState !== null;

                if (isHidden) {
                  disappearLayoutEffects_complete(subtreeRoot);
                  continue;
                }

                break;
              }
          }

          if (firstChild !== null) {
            firstChild["return"] = fiber;
            nextEffect = firstChild;
          } else {
            disappearLayoutEffects_complete(subtreeRoot);
          }
        }
      }

      function disappearLayoutEffects_complete(subtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;

          if (fiber === subtreeRoot) {
            nextEffect = null;
            return;
          }

          var sibling = fiber.sibling;

          if (sibling !== null) {
            sibling["return"] = fiber["return"];
            nextEffect = sibling;
            return;
          }

          nextEffect = fiber["return"];
        }
      }

      function reappearLayoutEffects_begin(subtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var firstChild = fiber.child;

          if (fiber.tag === OffscreenComponent) {
            var isHidden = fiber.memoizedState !== null;

            if (isHidden) {
              reappearLayoutEffects_complete(subtreeRoot);
              continue;
            }
          }

          if (firstChild !== null) {
            firstChild["return"] = fiber;
            nextEffect = firstChild;
          } else {
            reappearLayoutEffects_complete(subtreeRoot);
          }
        }
      }

      function reappearLayoutEffects_complete(subtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          setCurrentFiber(fiber);

          try {
            reappearLayoutEffectsOnFiber(fiber);
          } catch (error) {
            captureCommitPhaseError(fiber, fiber["return"], error);
          }

          resetCurrentFiber();

          if (fiber === subtreeRoot) {
            nextEffect = null;
            return;
          }

          var sibling = fiber.sibling;

          if (sibling !== null) {
            sibling["return"] = fiber["return"];
            nextEffect = sibling;
            return;
          }

          nextEffect = fiber["return"];
        }
      }

      function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
      }

      function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var firstChild = fiber.child;

          if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
            firstChild["return"] = fiber;
            nextEffect = firstChild;
          } else {
            commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
          }
        }
      }

      function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while (nextEffect !== null) {
          var fiber = nextEffect;

          if ((fiber.flags & Passive) !== NoFlags) {
            setCurrentFiber(fiber);

            try {
              commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
            } catch (error) {
              captureCommitPhaseError(fiber, fiber["return"], error);
            }

            resetCurrentFiber();
          }

          if (fiber === subtreeRoot) {
            nextEffect = null;
            return;
          }

          var sibling = fiber.sibling;

          if (sibling !== null) {
            sibling["return"] = fiber["return"];
            nextEffect = sibling;
            return;
          }

          nextEffect = fiber["return"];
        }
      }

      function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
            {
              if (finishedWork.mode & ProfileMode) {
                startPassiveEffectTimer();

                try {
                  commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                } finally {
                  recordPassiveEffectDuration(finishedWork);
                }
              } else {
                commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
              }

              break;
            }
        }
      }

      function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
      }

      function commitPassiveUnmountEffects_begin() {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var child = fiber.child;

          if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
            var deletions = fiber.deletions;

            if (deletions !== null) {
              for (var i = 0; i < deletions.length; i++) {
                var fiberToDelete = deletions[i];
                nextEffect = fiberToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
              }

              {
                var previousFiber = fiber.alternate;

                if (previousFiber !== null) {
                  var detachedChild = previousFiber.child;

                  if (detachedChild !== null) {
                    previousFiber.child = null;

                    do {
                      var detachedSibling = detachedChild.sibling;
                      detachedChild.sibling = null;
                      detachedChild = detachedSibling;
                    } while (detachedChild !== null);
                  }
                }
              }
              nextEffect = fiber;
            }
          }

          if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
            child["return"] = fiber;
            nextEffect = child;
          } else {
            commitPassiveUnmountEffects_complete();
          }
        }
      }

      function commitPassiveUnmountEffects_complete() {
        while (nextEffect !== null) {
          var fiber = nextEffect;

          if ((fiber.flags & Passive) !== NoFlags) {
            setCurrentFiber(fiber);
            commitPassiveUnmountOnFiber(fiber);
            resetCurrentFiber();
          }

          var sibling = fiber.sibling;

          if (sibling !== null) {
            sibling["return"] = fiber["return"];
            nextEffect = sibling;
            return;
          }

          nextEffect = fiber["return"];
        }
      }

      function commitPassiveUnmountOnFiber(finishedWork) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
            {
              if (finishedWork.mode & ProfileMode) {
                startPassiveEffectTimer();
                commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork["return"]);
                recordPassiveEffectDuration(finishedWork);
              } else {
                commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork["return"]);
              }

              break;
            }
        }
      }

      function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          setCurrentFiber(fiber);
          commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
          resetCurrentFiber();
          var child = fiber.child;

          if (child !== null) {
            child["return"] = fiber;
            nextEffect = child;
          } else {
            commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
          }
        }
      }

      function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var sibling = fiber.sibling;
          var returnFiber = fiber["return"];
          {
            detachFiberAfterEffects(fiber);

            if (fiber === deletedSubtreeRoot) {
              nextEffect = null;
              return;
            }
          }

          if (sibling !== null) {
            sibling["return"] = returnFiber;
            nextEffect = sibling;
            return;
          }

          nextEffect = returnFiber;
        }
      }

      function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch (current.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
            {
              if (current.mode & ProfileMode) {
                startPassiveEffectTimer();
                commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                recordPassiveEffectDuration(current);
              } else {
                commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
              }

              break;
            }
        }
      }

      function invokeLayoutEffectMountInDEV(fiber) {
        {
          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
              {
                try {
                  commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                  captureCommitPhaseError(fiber, fiber["return"], error);
                }

                break;
              }

            case ClassComponent:
              {
                var instance = fiber.stateNode;

                try {
                  instance.componentDidMount();
                } catch (error) {
                  captureCommitPhaseError(fiber, fiber["return"], error);
                }

                break;
              }
          }
        }
      }

      function invokePassiveEffectMountInDEV(fiber) {
        {
          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
              {
                try {
                  commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                  captureCommitPhaseError(fiber, fiber["return"], error);
                }

                break;
              }
          }
        }
      }

      function invokeLayoutEffectUnmountInDEV(fiber) {
        {
          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
              {
                try {
                  commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber["return"]);
                } catch (error) {
                  captureCommitPhaseError(fiber, fiber["return"], error);
                }

                break;
              }

            case ClassComponent:
              {
                var instance = fiber.stateNode;

                if (typeof instance.componentWillUnmount === 'function') {
                  safelyCallComponentWillUnmount(fiber, fiber["return"], instance);
                }

                break;
              }
          }
        }
      }

      function invokePassiveEffectUnmountInDEV(fiber) {
        {
          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
              {
                try {
                  commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber["return"]);
                } catch (error) {
                  captureCommitPhaseError(fiber, fiber["return"], error);
                }
              }
          }
        }
      }

      var COMPONENT_TYPE = 0;
      var HAS_PSEUDO_CLASS_TYPE = 1;
      var ROLE_TYPE = 2;
      var TEST_NAME_TYPE = 3;
      var TEXT_TYPE = 4;

      if (typeof Symbol === 'function' && Symbol["for"]) {
        var symbolFor = Symbol["for"];
        COMPONENT_TYPE = symbolFor('selector.component');
        HAS_PSEUDO_CLASS_TYPE = symbolFor('selector.has_pseudo_class');
        ROLE_TYPE = symbolFor('selector.role');
        TEST_NAME_TYPE = symbolFor('selector.test_id');
        TEXT_TYPE = symbolFor('selector.text');
      }

      var commitHooks = [];

      function onCommitRoot$1() {
        {
          commitHooks.forEach(function (commitHook) {
            return commitHook();
          });
        }
      }

      var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;

      function isLegacyActEnvironment(fiber) {
        {
          var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined' ? IS_REACT_ACT_ENVIRONMENT : undefined;
          var jestIsDefined = typeof jest !== 'undefined';
          return jestIsDefined && isReactActEnvironmentGlobal !== false;
        }
      }

      function isConcurrentActEnvironment() {
        {
          var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined' ? IS_REACT_ACT_ENVIRONMENT : undefined;

          if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) {
            error('The current testing environment is not configured to support ' + 'act(...)');
          }

          return isReactActEnvironmentGlobal;
        }
      }

      var ceil = Math.ceil;
      var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher,
          ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner,
          ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig,
          ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
      var NoContext = 0;
      var BatchedContext = 1;
      var RenderContext = 2;
      var CommitContext = 4;
      var RootInProgress = 0;
      var RootFatalErrored = 1;
      var RootErrored = 2;
      var RootSuspended = 3;
      var RootSuspendedWithDelay = 4;
      var RootCompleted = 5;
      var RootDidNotComplete = 6;
      var executionContext = NoContext;
      var workInProgressRoot = null;
      var workInProgress = null;
      var workInProgressRootRenderLanes = NoLanes;
      var subtreeRenderLanes = NoLanes;
      var subtreeRenderLanesCursor = createCursor(NoLanes);
      var workInProgressRootExitStatus = RootInProgress;
      var workInProgressRootFatalError = null;
      var workInProgressRootIncludedLanes = NoLanes;
      var workInProgressRootSkippedLanes = NoLanes;
      var workInProgressRootInterleavedUpdatedLanes = NoLanes;
      var workInProgressRootPingedLanes = NoLanes;
      var workInProgressRootConcurrentErrors = null;
      var workInProgressRootRecoverableErrors = null;
      var globalMostRecentFallbackTime = 0;
      var FALLBACK_THROTTLE_MS = 500;
      var workInProgressRootRenderTargetTime = Infinity;
      var RENDER_TIMEOUT_MS = 500;
      var workInProgressTransitions = null;

      function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
      }

      function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
      }

      var hasUncaughtError = false;
      var firstUncaughtError = null;
      var legacyErrorBoundariesThatAlreadyFailed = null;
      var rootDoesHavePassiveEffects = false;
      var rootWithPendingPassiveEffects = null;
      var pendingPassiveEffectsLanes = NoLanes;
      var pendingPassiveProfilerEffects = [];
      var pendingPassiveTransitions = null;
      var NESTED_UPDATE_LIMIT = 50;
      var nestedUpdateCount = 0;
      var rootWithNestedUpdates = null;
      var isFlushingPassiveEffects = false;
      var didScheduleUpdateDuringPassiveEffects = false;
      var NESTED_PASSIVE_UPDATE_LIMIT = 50;
      var nestedPassiveUpdateCount = 0;
      var rootWithPassiveNestedUpdates = null;
      var currentEventTime = NoTimestamp;
      var currentEventTransitionLane = NoLanes;
      var isRunningInsertionEffect = false;

      function getWorkInProgressRoot() {
        return workInProgressRoot;
      }

      function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          return now();
        }

        if (currentEventTime !== NoTimestamp) {
          return currentEventTime;
        }

        currentEventTime = now();
        return currentEventTime;
      }

      function requestUpdateLane(fiber) {
        var mode = fiber.mode;

        if ((mode & ConcurrentMode) === NoMode) {
          return SyncLane;
        } else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) {
          return pickArbitraryLane(workInProgressRootRenderLanes);
        }

        var isTransition = requestCurrentTransition() !== NoTransition;

        if (isTransition) {
          if (ReactCurrentBatchConfig$3.transition !== null) {
            var transition = ReactCurrentBatchConfig$3.transition;

            if (!transition._updatedFibers) {
              transition._updatedFibers = new Set();
            }

            transition._updatedFibers.add(fiber);
          }

          if (currentEventTransitionLane === NoLane) {
            currentEventTransitionLane = claimNextTransitionLane();
          }

          return currentEventTransitionLane;
        }

        var updateLane = getCurrentUpdatePriority();

        if (updateLane !== NoLane) {
          return updateLane;
        }

        var eventLane = getCurrentEventPriority();
        return eventLane;
      }

      function requestRetryLane(fiber) {
        var mode = fiber.mode;

        if ((mode & ConcurrentMode) === NoMode) {
          return SyncLane;
        }

        return claimNextRetryLane();
      }

      function scheduleUpdateOnFiber(fiber, lane, eventTime) {
        checkForNestedUpdates();
        {
          if (isRunningInsertionEffect) {
            error('useInsertionEffect must not schedule updates.');
          }
        }
        var root = markUpdateLaneFromFiberToRoot(fiber, lane);

        if (root === null) {
          return null;
        }

        {
          if (isFlushingPassiveEffects) {
            didScheduleUpdateDuringPassiveEffects = true;
          }
        }
        markRootUpdated(root, lane, eventTime);

        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) {
          warnAboutRenderPhaseUpdatesInDEV(fiber);
        } else {
          {
            if (isDevToolsPresent) {
              addFiberToLanesMap(root, fiber, lane);
            }
          }
          warnIfUpdatesNotWrappedWithActDEV(fiber);

          if (root === workInProgressRoot) {
            if ((executionContext & RenderContext) === NoContext) {
              workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
            }

            if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
              markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
          }

          ensureRootIsScheduled(root, eventTime);

          if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && !ReactCurrentActQueue$1.isBatchingLegacy) {
            resetRenderTimer();
            flushSyncCallbacksOnlyInLegacyMode();
          }
        }

        return root;
      }

      function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
      }

      function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;

        if (alternate !== null) {
          alternate.lanes = mergeLanes(alternate.lanes, lane);
        }

        {
          if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) {
            warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
          }
        }
        var node = sourceFiber;
        var parent = sourceFiber["return"];

        while (parent !== null) {
          parent.childLanes = mergeLanes(parent.childLanes, lane);
          alternate = parent.alternate;

          if (alternate !== null) {
            alternate.childLanes = mergeLanes(alternate.childLanes, lane);
          } else {
            {
              if ((parent.flags & (Placement | Hydrating)) !== NoFlags) {
                warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
              }
            }
          }

          node = parent;
          parent = parent["return"];
        }

        if (node.tag === HostRoot) {
          var root = node.stateNode;
          return root;
        } else {
          return null;
        }
      }

      function isInterleavedUpdate(fiber, lane) {
        return (workInProgressRoot !== null || hasInterleavedUpdates()) && (fiber.mode & ConcurrentMode) !== NoMode && (executionContext & RenderContext) === NoContext;
      }

      function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode;
        markStarvedLanesAsExpired(root, currentTime);
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);

        if (nextLanes === NoLanes) {
          if (existingCallbackNode !== null) {
            cancelCallback$1(existingCallbackNode);
          }

          root.callbackNode = null;
          root.callbackPriority = NoLane;
          return;
        }

        var newCallbackPriority = getHighestPriorityLane(nextLanes);
        var existingCallbackPriority = root.callbackPriority;

        if (existingCallbackPriority === newCallbackPriority && !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
          {
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) {
              error('Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.');
            }
          }
          return;
        }

        if (existingCallbackNode != null) {
          cancelCallback$1(existingCallbackNode);
        }

        var newCallbackNode;

        if (newCallbackPriority === SyncLane) {
          if (root.tag === LegacyRoot) {
            if (ReactCurrentActQueue$1.isBatchingLegacy !== null) {
              ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
            }

            scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
          } else {
            scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
          }

          {
            if (ReactCurrentActQueue$1.current !== null) {
              ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            } else {
              scheduleMicrotask(function () {
                if (executionContext === NoContext) {
                  flushSyncCallbacks();
                }
              });
            }
          }
          newCallbackNode = null;
        } else {
          var schedulerPriorityLevel;

          switch (lanesToEventPriority(nextLanes)) {
            case DiscreteEventPriority:
              schedulerPriorityLevel = ImmediatePriority;
              break;

            case ContinuousEventPriority:
              schedulerPriorityLevel = UserBlockingPriority;
              break;

            case DefaultEventPriority:
              schedulerPriorityLevel = NormalPriority;
              break;

            case IdleEventPriority:
              schedulerPriorityLevel = IdlePriority;
              break;

            default:
              schedulerPriorityLevel = NormalPriority;
              break;
          }

          newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }

        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
      }

      function performConcurrentWorkOnRoot(root, didTimeout) {
        {
          resetNestedUpdateFlag();
        }
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;

        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          throw new Error('Should not already be working.');
        }

        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();

        if (didFlushPassiveEffects) {
          if (root.callbackNode !== originalCallbackNode) {
            return null;
          }
        }

        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);

        if (lanes === NoLanes) {
          return null;
        }

        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);

        if (exitStatus !== RootInProgress) {
          if (exitStatus === RootErrored) {
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);

            if (errorRetryLanes !== NoLanes) {
              lanes = errorRetryLanes;
              exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
          }

          if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
          }

          if (exitStatus === RootDidNotComplete) {
            markRootSuspended$1(root, lanes);
          } else {
            var renderWasConcurrent = !includesBlockingLane(root, lanes);
            var finishedWork = root.current.alternate;

            if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
              exitStatus = renderRootSync(root, lanes);

              if (exitStatus === RootErrored) {
                var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);

                if (_errorRetryLanes !== NoLanes) {
                  lanes = _errorRetryLanes;
                  exitStatus = recoverFromConcurrentError(root, _errorRetryLanes);
                }
              }

              if (exitStatus === RootFatalErrored) {
                var _fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw _fatalError;
              }
            }

            root.finishedWork = finishedWork;
            root.finishedLanes = lanes;
            finishConcurrentRender(root, exitStatus, lanes);
          }
        }

        ensureRootIsScheduled(root, now());

        if (root.callbackNode === originalCallbackNode) {
          return performConcurrentWorkOnRoot.bind(null, root);
        }

        return null;
      }

      function recoverFromConcurrentError(root, errorRetryLanes) {
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;

        if (isRootDehydrated(root)) {
          var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
          rootWorkInProgress.flags |= ForceClientRender;
          {
            errorHydratingContainer(root.containerInfo);
          }
        }

        var exitStatus = renderRootSync(root, errorRetryLanes);

        if (exitStatus !== RootErrored) {
          var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
          workInProgressRootRecoverableErrors = errorsFromFirstAttempt;

          if (errorsFromSecondAttempt !== null) {
            queueRecoverableErrors(errorsFromSecondAttempt);
          }
        }

        return exitStatus;
      }

      function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) {
          workInProgressRootRecoverableErrors = errors;
        } else {
          workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
        }
      }

      function finishConcurrentRender(root, exitStatus, lanes) {
        switch (exitStatus) {
          case RootInProgress:
          case RootFatalErrored:
            {
              throw new Error('Root did not complete. This is a bug in React.');
            }

          case RootErrored:
            {
              commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
              break;
            }

          case RootSuspended:
            {
              markRootSuspended$1(root, lanes);

              if (includesOnlyRetries(lanes) && !shouldForceFlushFallbacksInDEV()) {
                var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now();

                if (msUntilTimeout > 10) {
                  var nextLanes = getNextLanes(root, NoLanes);

                  if (nextLanes !== NoLanes) {
                    break;
                  }

                  var suspendedLanes = root.suspendedLanes;

                  if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                    var eventTime = requestEventTime();
                    markRootPinged(root, suspendedLanes);
                    break;
                  }

                  root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                  break;
                }
              }

              commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
              break;
            }

          case RootSuspendedWithDelay:
            {
              markRootSuspended$1(root, lanes);

              if (includesOnlyTransitions(lanes)) {
                break;
              }

              if (!shouldForceFlushFallbacksInDEV()) {
                var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                var eventTimeMs = mostRecentEventTime;
                var timeElapsedMs = now() - eventTimeMs;

                var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs;

                if (_msUntilTimeout > 10) {
                  root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                  break;
                }
              }

              commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
              break;
            }

          case RootCompleted:
            {
              commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
              break;
            }

          default:
            {
              throw new Error('Unknown root exit status.');
            }
        }
      }

      function isRenderConsistentWithExternalStores(finishedWork) {
        var node = finishedWork;

        while (true) {
          if (node.flags & StoreConsistency) {
            var updateQueue = node.updateQueue;

            if (updateQueue !== null) {
              var checks = updateQueue.stores;

              if (checks !== null) {
                for (var i = 0; i < checks.length; i++) {
                  var check = checks[i];
                  var getSnapshot = check.getSnapshot;
                  var renderedValue = check.value;

                  try {
                    if (!objectIs(getSnapshot(), renderedValue)) {
                      return false;
                    }
                  } catch (error) {
                    return false;
                  }
                }
              }
            }
          }

          var child = node.child;

          if (node.subtreeFlags & StoreConsistency && child !== null) {
            child["return"] = node;
            node = child;
            continue;
          }

          if (node === finishedWork) {
            return true;
          }

          while (node.sibling === null) {
            if (node["return"] === null || node["return"] === finishedWork) {
              return true;
            }

            node = node["return"];
          }

          node.sibling["return"] = node["return"];
          node = node.sibling;
        }

        return true;
      }

      function markRootSuspended$1(root, suspendedLanes) {
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
      }

      function performSyncWorkOnRoot(root) {
        {
          syncNestedUpdateFlag();
        }

        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          throw new Error('Should not already be working.');
        }

        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);

        if (!includesSomeLane(lanes, SyncLane)) {
          ensureRootIsScheduled(root, now());
          return null;
        }

        var exitStatus = renderRootSync(root, lanes);

        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
          var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);

          if (errorRetryLanes !== NoLanes) {
            lanes = errorRetryLanes;
            exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
          }
        }

        if (exitStatus === RootFatalErrored) {
          var fatalError = workInProgressRootFatalError;
          prepareFreshStack(root, NoLanes);
          markRootSuspended$1(root, lanes);
          ensureRootIsScheduled(root, now());
          throw fatalError;
        }

        if (exitStatus === RootDidNotComplete) {
          throw new Error('Root did not complete. This is a bug in React.');
        }

        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
        ensureRootIsScheduled(root, now());
        return null;
      }

      function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
          markRootEntangled(root, mergeLanes(lanes, SyncLane));
          ensureRootIsScheduled(root, now());

          if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
            resetRenderTimer();
            flushSyncCallbacks();
          }
        }
      }

      function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;

        try {
          return fn(a);
        } finally {
          executionContext = prevExecutionContext;

          if (executionContext === NoContext && !ReactCurrentActQueue$1.isBatchingLegacy) {
            resetRenderTimer();
            flushSyncCallbacksOnlyInLegacyMode();
          }
        }
      }

      function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;

        try {
          ReactCurrentBatchConfig$3.transition = null;
          setCurrentUpdatePriority(DiscreteEventPriority);
          return fn(a, b, c, d);
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$3.transition = prevTransition;

          if (executionContext === NoContext) {
            resetRenderTimer();
          }
        }
      }

      function flushSync(fn) {
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) {
          flushPassiveEffects();
        }

        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();

        try {
          ReactCurrentBatchConfig$3.transition = null;
          setCurrentUpdatePriority(DiscreteEventPriority);

          if (fn) {
            return fn();
          } else {
            return undefined;
          }
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$3.transition = prevTransition;
          executionContext = prevExecutionContext;

          if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
            flushSyncCallbacks();
          }
        }
      }

      function isAlreadyRendering() {
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
      }

      function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
      }

      function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
      }

      function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;

        if (timeoutHandle !== noTimeout) {
          root.timeoutHandle = noTimeout;
          cancelTimeout(timeoutHandle);
        }

        if (workInProgress !== null) {
          var interruptedWork = workInProgress["return"];

          while (interruptedWork !== null) {
            var current = interruptedWork.alternate;
            unwindInterruptedWork(current, interruptedWork);
            interruptedWork = interruptedWork["return"];
          }
        }

        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        enqueueInterleavedUpdates();
        {
          ReactStrictModeWarnings.discardPendingWarnings();
        }
        return rootWorkInProgress;
      }

      function handleError(root, thrownValue) {
        do {
          var erroredWork = workInProgress;

          try {
            resetContextDependencies();
            resetHooksAfterThrow();
            resetCurrentFiber();
            ReactCurrentOwner$2.current = null;

            if (erroredWork === null || erroredWork["return"] === null) {
              workInProgressRootExitStatus = RootFatalErrored;
              workInProgressRootFatalError = thrownValue;
              workInProgress = null;
              return;
            }

            if (enableProfilerTimer && erroredWork.mode & ProfileMode) {
              stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
            }

            if (enableSchedulingProfiler) {
              markComponentRenderStopped();

              if (thrownValue !== null && typeof thrownValue === 'object' && typeof thrownValue.then === 'function') {
                var wakeable = thrownValue;
                markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
              } else {
                markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
              }
            }

            throwException(root, erroredWork["return"], erroredWork, thrownValue, workInProgressRootRenderLanes);
            completeUnitOfWork(erroredWork);
          } catch (yetAnotherThrownValue) {
            thrownValue = yetAnotherThrownValue;

            if (workInProgress === erroredWork && erroredWork !== null) {
              erroredWork = erroredWork["return"];
              workInProgress = erroredWork;
            } else {
              erroredWork = workInProgress;
            }

            continue;
          }

          return;
        } while (true);
      }

      function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;

        if (prevDispatcher === null) {
          return ContextOnlyDispatcher;
        } else {
          return prevDispatcher;
        }
      }

      function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
      }

      function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
      }

      function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
      }

      function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) {
          workInProgressRootExitStatus = RootSuspended;
        }
      }

      function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) {
          workInProgressRootExitStatus = RootSuspendedWithDelay;
        }

        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) {
          markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
        }
      }

      function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) {
          workInProgressRootExitStatus = RootErrored;
        }

        if (workInProgressRootConcurrentErrors === null) {
          workInProgressRootConcurrentErrors = [error];
        } else {
          workInProgressRootConcurrentErrors.push(error);
        }
      }

      function renderHasNotSuspendedYet() {
        return workInProgressRootExitStatus === RootInProgress;
      }

      function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher();

        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
          {
            if (isDevToolsPresent) {
              var memoizedUpdaters = root.memoizedUpdaters;

              if (memoizedUpdaters.size > 0) {
                restorePendingUpdaters(root, workInProgressRootRenderLanes);
                memoizedUpdaters.clear();
              }

              movePendingFibersToMemoized(root, lanes);
            }
          }
          workInProgressTransitions = getTransitionsForLanes();
          prepareFreshStack(root, lanes);
        }

        {
          markRenderStarted(lanes);
        }

        do {
          try {
            workLoopSync();
            break;
          } catch (thrownValue) {
            handleError(root, thrownValue);
          }
        } while (true);

        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);

        if (workInProgress !== null) {
          throw new Error('Cannot commit an incomplete root. This error is likely caused by a ' + 'bug in React. Please file an issue.');
        }

        {
          markRenderStopped();
        }
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
      }

      function workLoopSync() {
        while (workInProgress !== null) {
          performUnitOfWork(workInProgress);
        }
      }

      function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher();

        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
          {
            if (isDevToolsPresent) {
              var memoizedUpdaters = root.memoizedUpdaters;

              if (memoizedUpdaters.size > 0) {
                restorePendingUpdaters(root, workInProgressRootRenderLanes);
                memoizedUpdaters.clear();
              }

              movePendingFibersToMemoized(root, lanes);
            }
          }
          workInProgressTransitions = getTransitionsForLanes();
          resetRenderTimer();
          prepareFreshStack(root, lanes);
        }

        {
          markRenderStarted(lanes);
        }

        do {
          try {
            workLoopConcurrent();
            break;
          } catch (thrownValue) {
            handleError(root, thrownValue);
          }
        } while (true);

        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;

        if (workInProgress !== null) {
          {
            markRenderYielded();
          }
          return RootInProgress;
        } else {
          {
            markRenderStopped();
          }
          workInProgressRoot = null;
          workInProgressRootRenderLanes = NoLanes;
          return workInProgressRootExitStatus;
        }
      }

      function workLoopConcurrent() {
        while (workInProgress !== null && !shouldYield()) {
          performUnitOfWork(workInProgress);
        }
      }

      function performUnitOfWork(unitOfWork) {
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;

        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
          startProfilerTimer(unitOfWork);
          next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
          stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else {
          next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        }

        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;

        if (next === null) {
          completeUnitOfWork(unitOfWork);
        } else {
          workInProgress = next;
        }

        ReactCurrentOwner$2.current = null;
      }

      function completeUnitOfWork(unitOfWork) {
        var completedWork = unitOfWork;

        do {
          var current = completedWork.alternate;
          var returnFiber = completedWork["return"];

          if ((completedWork.flags & Incomplete) === NoFlags) {
            setCurrentFiber(completedWork);
            var next = void 0;

            if ((completedWork.mode & ProfileMode) === NoMode) {
              next = completeWork(current, completedWork, subtreeRenderLanes);
            } else {
              startProfilerTimer(completedWork);
              next = completeWork(current, completedWork, subtreeRenderLanes);
              stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
            }

            resetCurrentFiber();

            if (next !== null) {
              workInProgress = next;
              return;
            }
          } else {
            var _next = unwindWork(current, completedWork);

            if (_next !== null) {
              _next.flags &= HostEffectMask;
              workInProgress = _next;
              return;
            }

            if ((completedWork.mode & ProfileMode) !== NoMode) {
              stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
              var actualDuration = completedWork.actualDuration;
              var child = completedWork.child;

              while (child !== null) {
                actualDuration += child.actualDuration;
                child = child.sibling;
              }

              completedWork.actualDuration = actualDuration;
            }

            if (returnFiber !== null) {
              returnFiber.flags |= Incomplete;
              returnFiber.subtreeFlags = NoFlags;
              returnFiber.deletions = null;
            } else {
              workInProgressRootExitStatus = RootDidNotComplete;
              workInProgress = null;
              return;
            }
          }

          var siblingFiber = completedWork.sibling;

          if (siblingFiber !== null) {
            workInProgress = siblingFiber;
            return;
          }

          completedWork = returnFiber;
          workInProgress = completedWork;
        } while (completedWork !== null);

        if (workInProgressRootExitStatus === RootInProgress) {
          workInProgressRootExitStatus = RootCompleted;
        }
      }

      function commitRoot(root, recoverableErrors, transitions) {
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;

        try {
          ReactCurrentBatchConfig$3.transition = null;
          setCurrentUpdatePriority(DiscreteEventPriority);
          commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally {
          ReactCurrentBatchConfig$3.transition = prevTransition;
          setCurrentUpdatePriority(previousUpdateLanePriority);
        }

        return null;
      }

      function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do {
          flushPassiveEffects();
        } while (rootWithPendingPassiveEffects !== null);

        flushRenderPhaseStrictModeWarningsInDEV();

        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          throw new Error('Should not already be working.');
        }

        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        {
          markCommitStarted(lanes);
        }

        if (finishedWork === null) {
          {
            markCommitStopped();
          }
          return null;
        } else {
          {
            if (lanes === NoLanes) {
              error('root.finishedLanes should not be empty during a commit. This is a ' + 'bug in React.');
            }
          }
        }

        root.finishedWork = null;
        root.finishedLanes = NoLanes;

        if (finishedWork === root.current) {
          throw new Error('Cannot commit the same tree as before. This error is likely caused by ' + 'a bug in React. Please file an issue.');
        }

        root.callbackNode = null;
        root.callbackPriority = NoLane;
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);

        if (root === workInProgressRoot) {
          workInProgressRoot = null;
          workInProgress = null;
          workInProgressRootRenderLanes = NoLanes;
        }

        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
          if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            pendingPassiveTransitions = transitions;
            scheduleCallback$1(NormalPriority, function () {
              flushPassiveEffects();
              return null;
            });
          }
        }

        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;

        if (subtreeHasEffects || rootHasEffect) {
          var prevTransition = ReactCurrentBatchConfig$3.transition;
          ReactCurrentBatchConfig$3.transition = null;
          var previousPriority = getCurrentUpdatePriority();
          setCurrentUpdatePriority(DiscreteEventPriority);
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          ReactCurrentOwner$2.current = null;
          var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
          {
            recordCommitTime();
          }
          commitMutationEffects(root, finishedWork, lanes);
          resetAfterCommit();
          root.current = finishedWork;
          {
            markLayoutEffectsStarted(lanes);
          }
          commitLayoutEffects(finishedWork, root, lanes);
          {
            markLayoutEffectsStopped();
          }
          requestPaint();
          executionContext = prevExecutionContext;
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
          root.current = finishedWork;
          {
            recordCommitTime();
          }
        }

        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;

        if (rootDoesHavePassiveEffects) {
          rootDoesHavePassiveEffects = false;
          rootWithPendingPassiveEffects = root;
          pendingPassiveEffectsLanes = lanes;
        } else {
          {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
          }
        }

        remainingLanes = root.pendingLanes;

        if (remainingLanes === NoLanes) {
          legacyErrorBoundariesThatAlreadyFailed = null;
        }

        {
          if (!rootDidHavePassiveEffects) {
            commitDoubleInvokeEffectsInDEV(root.current, false);
          }
        }
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        {
          if (isDevToolsPresent) {
            root.memoizedUpdaters.clear();
          }
        }
        {
          onCommitRoot$1();
        }
        ensureRootIsScheduled(root, now());

        if (recoverableErrors !== null) {
          var onRecoverableError = root.onRecoverableError;

          for (var i = 0; i < recoverableErrors.length; i++) {
            var recoverableError = recoverableErrors[i];
            onRecoverableError(recoverableError);
          }
        }

        if (hasUncaughtError) {
          hasUncaughtError = false;
          var error$1 = firstUncaughtError;
          firstUncaughtError = null;
          throw error$1;
        }

        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) {
          flushPassiveEffects();
        }

        remainingLanes = root.pendingLanes;

        if (includesSomeLane(remainingLanes, SyncLane)) {
          {
            markNestedUpdateScheduled();
          }

          if (root === rootWithNestedUpdates) {
            nestedUpdateCount++;
          } else {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = root;
          }
        } else {
          nestedUpdateCount = 0;
        }

        flushSyncCallbacks();
        {
          markCommitStopped();
        }
        return null;
      }

      function flushPassiveEffects() {
        if (rootWithPendingPassiveEffects !== null) {
          var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
          var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
          var prevTransition = ReactCurrentBatchConfig$3.transition;
          var previousPriority = getCurrentUpdatePriority();

          try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(priority);
            return flushPassiveEffectsImpl();
          } finally {
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
          }
        }

        return false;
      }

      function enqueuePendingPassiveProfilerEffect(fiber) {
        {
          pendingPassiveProfilerEffects.push(fiber);

          if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function () {
              flushPassiveEffects();
              return null;
            });
          }
        }
      }

      function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) {
          return false;
        }

        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null;
        pendingPassiveEffectsLanes = NoLanes;

        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          throw new Error('Cannot flush passive effects while already rendering.');
        }

        {
          isFlushingPassiveEffects = true;
          didScheduleUpdateDuringPassiveEffects = false;
        }
        {
          markPassiveEffectsStarted(lanes);
        }
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions);
        {
          var profilerEffects = pendingPassiveProfilerEffects;
          pendingPassiveProfilerEffects = [];

          for (var i = 0; i < profilerEffects.length; i++) {
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
          }
        }
        {
          markPassiveEffectsStopped();
        }
        {
          commitDoubleInvokeEffectsInDEV(root.current, true);
        }
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        {
          if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) {
              nestedPassiveUpdateCount++;
            } else {
              nestedPassiveUpdateCount = 0;
              rootWithPassiveNestedUpdates = root;
            }
          } else {
            nestedPassiveUpdateCount = 0;
          }

          isFlushingPassiveEffects = false;
          didScheduleUpdateDuringPassiveEffects = false;
        }
        onPostCommitRoot(root);
        {
          var stateNode = root.current.stateNode;
          stateNode.effectDuration = 0;
          stateNode.passiveEffectDuration = 0;
        }
        return true;
      }

      function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
      }

      function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) {
          legacyErrorBoundariesThatAlreadyFailed = new Set([instance]);
        } else {
          legacyErrorBoundariesThatAlreadyFailed.add(instance);
        }
      }

      function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
          hasUncaughtError = true;
          firstUncaughtError = error;
        }
      }

      var onUncaughtError = prepareToThrowUncaughtError;

      function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        enqueueUpdate(rootFiber, update);
        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);

        if (root !== null) {
          markRootUpdated(root, SyncLane, eventTime);
          ensureRootIsScheduled(root, eventTime);
        }
      }

      function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        {
          reportUncaughtErrorInDEV(error$1);
          setIsRunningInsertionEffect(false);
        }

        if (sourceFiber.tag === HostRoot) {
          captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
          return;
        }

        var fiber = null;
        {
          fiber = nearestMountedAncestor;
        }

        while (fiber !== null) {
          if (fiber.tag === HostRoot) {
            captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
            return;
          } else if (fiber.tag === ClassComponent) {
            var ctor = fiber.type;
            var instance = fiber.stateNode;

            if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
              var errorInfo = createCapturedValue(error$1, sourceFiber);
              var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
              enqueueUpdate(fiber, update);
              var eventTime = requestEventTime();
              var root = markUpdateLaneFromFiberToRoot(fiber, SyncLane);

              if (root !== null) {
                markRootUpdated(root, SyncLane, eventTime);
                ensureRootIsScheduled(root, eventTime);
              }

              return;
            }
          }

          fiber = fiber["return"];
        }

        {
          error('Internal React error: Attempted to capture a commit phase error ' + 'inside a detached tree. This indicates a bug in React. Likely ' + 'causes include deleting the same fiber more than once, committing an ' + 'already-finished tree, or an inconsistent return pointer.\n\n' + 'Error message:\n\n%s', error$1);
        }
      }

      function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;

        if (pingCache !== null) {
          pingCache["delete"](wakeable);
        }

        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);

        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
          if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
            prepareFreshStack(root, NoLanes);
          } else {
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
          }
        }

        ensureRootIsScheduled(root, eventTime);
      }

      function retryTimedOutBoundary(boundaryFiber, retryLane) {
        if (retryLane === NoLane) {
          retryLane = requestRetryLane(boundaryFiber);
        }

        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);

        if (root !== null) {
          markRootUpdated(root, retryLane, eventTime);
          ensureRootIsScheduled(root, eventTime);
        }
      }

      function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;

        if (suspenseState !== null) {
          retryLane = suspenseState.retryLane;
        }

        retryTimedOutBoundary(boundaryFiber, retryLane);
      }

      function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane;
        var retryCache;

        switch (boundaryFiber.tag) {
          case SuspenseComponent:
            retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;

            if (suspenseState !== null) {
              retryLane = suspenseState.retryLane;
            }

            break;

          case SuspenseListComponent:
            retryCache = boundaryFiber.stateNode;
            break;

          default:
            throw new Error('Pinged unknown suspense boundary type. ' + 'This is probably a bug in React.');
        }

        if (retryCache !== null) {
          retryCache["delete"](wakeable);
        }

        retryTimedOutBoundary(boundaryFiber, retryLane);
      }

      function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
      }

      function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
          nestedUpdateCount = 0;
          rootWithNestedUpdates = null;
          throw new Error('Maximum update depth exceeded. This can happen when a component ' + 'repeatedly calls setState inside componentWillUpdate or ' + 'componentDidUpdate. React limits the number of nested updates to ' + 'prevent infinite loops.');
        }

        {
          if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error('Maximum update depth exceeded. This can happen when a component ' + "calls setState inside useEffect, but useEffect either doesn't " + 'have a dependency array, or one of the dependencies changes on ' + 'every render.');
          }
        }
      }

      function flushRenderPhaseStrictModeWarningsInDEV() {
        {
          ReactStrictModeWarnings.flushLegacyContextWarning();
          {
            ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
          }
        }
      }

      function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        {
          setCurrentFiber(fiber);
          invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);

          if (hasPassiveEffects) {
            invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
          }

          invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);

          if (hasPassiveEffects) {
            invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
          }

          resetCurrentFiber();
        }
      }

      function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        {
          var current = firstChild;
          var subtreeRoot = null;

          while (current !== null) {
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;

            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) {
              current = current.child;
            } else {
              if ((current.flags & fiberFlags) !== NoFlags) {
                invokeEffectFn(current);
              }

              if (current.sibling !== null) {
                current = current.sibling;
              } else {
                current = subtreeRoot = current["return"];
              }
            }
          }
        }
      }

      var didWarnStateUpdateForNotYetMountedComponent = null;

      function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        {
          if ((executionContext & RenderContext) !== NoContext) {
            return;
          }

          if (!(fiber.mode & ConcurrentMode)) {
            return;
          }

          var tag = fiber.tag;

          if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) {
            return;
          }

          var componentName = getComponentNameFromFiber(fiber) || 'ReactComponent';

          if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) {
              return;
            }

            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
          } else {
            didWarnStateUpdateForNotYetMountedComponent = new Set([componentName]);
          }

          var previousFiber = current;

          try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. " + 'This indicates that you have a side-effect in your render function that ' + 'asynchronously later calls tries to update the component. Move this work to ' + 'useEffect instead.');
          } finally {
            if (previousFiber) {
              setCurrentFiber(fiber);
            } else {
              resetCurrentFiber();
            }
          }
        }
      }

      var beginWork$1;
      {
        var dummyFiber = null;

        beginWork$1 = function beginWork$1(current, unitOfWork, lanes) {
          var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);

          try {
            return beginWork(current, unitOfWork, lanes);
          } catch (originalError) {
            if (originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') {
              throw originalError;
            }

            resetContextDependencies();
            resetHooksAfterThrow();
            unwindInterruptedWork(current, unitOfWork);
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);

            if (unitOfWork.mode & ProfileMode) {
              startProfilerTimer(unitOfWork);
            }

            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);

            if (hasCaughtError()) {
              var replayError = clearCaughtError();

              if (typeof replayError === 'object' && replayError !== null && replayError._suppressLogging && typeof originalError === 'object' && originalError !== null && !originalError._suppressLogging) {
                originalError._suppressLogging = true;
              }
            }

            throw originalError;
          }
        };
      }
      var didWarnAboutUpdateInRender = false;
      var didWarnAboutUpdateInRenderForAnotherComponent;
      {
        didWarnAboutUpdateInRenderForAnotherComponent = new Set();
      }

      function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        {
          if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) {
            switch (fiber.tag) {
              case FunctionComponent:
              case ForwardRef:
              case SimpleMemoComponent:
                {
                  var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || 'Unknown';
                  var dedupeKey = renderingComponentName;

                  if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || 'Unknown';
                    error('Cannot update a component (`%s`) while rendering a ' + 'different component (`%s`). To locate the bad setState() call inside `%s`, ' + 'follow the stack trace as described in https://reactjs.org/link/setstate-in-render', setStateComponentName, renderingComponentName, renderingComponentName);
                  }

                  break;
                }

              case ClassComponent:
                {
                  if (!didWarnAboutUpdateInRender) {
                    error('Cannot update during an existing state transition (such as ' + 'within `render`). Render methods should be a pure ' + 'function of props and state.');
                    didWarnAboutUpdateInRender = true;
                  }

                  break;
                }
            }
          }
        }
      }

      function restorePendingUpdaters(root, lanes) {
        {
          if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function (schedulingFiber) {
              addFiberToLanesMap(root, schedulingFiber, lanes);
            });
          }
        }
      }

      var fakeActCallbackNode = {};

      function scheduleCallback$1(priorityLevel, callback) {
        {
          var actQueue = ReactCurrentActQueue$1.current;

          if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
          } else {
            return scheduleCallback(priorityLevel, callback);
          }
        }
      }

      function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) {
          return;
        }

        return cancelCallback(callbackNode);
      }

      function shouldForceFlushFallbacksInDEV() {
        return ReactCurrentActQueue$1.current !== null;
      }

      function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        {
          if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) {
              return;
            }
          } else {
            if (!isLegacyActEnvironment()) {
              return;
            }

            if (executionContext !== NoContext) {
              return;
            }

            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) {
              return;
            }
          }

          if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;

            try {
              setCurrentFiber(fiber);
              error('An update to %s inside a test was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act', getComponentNameFromFiber(fiber));
            } finally {
              if (previousFiber) {
                setCurrentFiber(fiber);
              } else {
                resetCurrentFiber();
              }
            }
          }
        }
      }

      function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        {
          if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) {
            error('A suspended resource finished loading inside a test, but the event ' + 'was not wrapped in act(...).\n\n' + 'When testing, code that resolves suspended data should be wrapped ' + 'into act(...):\n\n' + 'act(() => {\n' + '  /* finish loading suspended data */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act');
          }
        }
      }

      function setIsRunningInsertionEffect(isRunning) {
        {
          isRunningInsertionEffect = isRunning;
        }
      }

      var resolveFamily = null;
      var failedBoundaries = null;

      var setRefreshHandler = function setRefreshHandler(handler) {
        {
          resolveFamily = handler;
        }
      };

      function resolveFunctionForHotReloading(type) {
        {
          if (resolveFamily === null) {
            return type;
          }

          var family = resolveFamily(type);

          if (family === undefined) {
            return type;
          }

          return family.current;
        }
      }

      function resolveClassForHotReloading(type) {
        return resolveFunctionForHotReloading(type);
      }

      function resolveForwardRefForHotReloading(type) {
        {
          if (resolveFamily === null) {
            return type;
          }

          var family = resolveFamily(type);

          if (family === undefined) {
            if (type !== null && type !== undefined && typeof type.render === 'function') {
              var currentRender = resolveFunctionForHotReloading(type.render);

              if (type.render !== currentRender) {
                var syntheticType = {
                  $$typeof: REACT_FORWARD_REF_TYPE,
                  render: currentRender
                };

                if (type.displayName !== undefined) {
                  syntheticType.displayName = type.displayName;
                }

                return syntheticType;
              }
            }

            return type;
          }

          return family.current;
        }
      }

      function isCompatibleFamilyForHotReloading(fiber, element) {
        {
          if (resolveFamily === null) {
            return false;
          }

          var prevType = fiber.elementType;
          var nextType = element.type;
          var needsCompareFamilies = false;
          var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;

          switch (fiber.tag) {
            case ClassComponent:
              {
                if (typeof nextType === 'function') {
                  needsCompareFamilies = true;
                }

                break;
              }

            case FunctionComponent:
              {
                if (typeof nextType === 'function') {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }

                break;
              }

            case ForwardRef:
              {
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }

                break;
              }

            case MemoComponent:
            case SimpleMemoComponent:
              {
                if ($$typeofNextType === REACT_MEMO_TYPE) {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }

                break;
              }

            default:
              return false;
          }

          if (needsCompareFamilies) {
            var prevFamily = resolveFamily(prevType);

            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) {
              return true;
            }
          }

          return false;
        }
      }

      function markFailedErrorBoundaryForHotReloading(fiber) {
        {
          if (resolveFamily === null) {
            return;
          }

          if (typeof WeakSet !== 'function') {
            return;
          }

          if (failedBoundaries === null) {
            failedBoundaries = new WeakSet();
          }

          failedBoundaries.add(fiber);
        }
      }

      var scheduleRefresh = function scheduleRefresh(root, update) {
        {
          if (resolveFamily === null) {
            return;
          }

          var staleFamilies = update.staleFamilies,
              updatedFamilies = update.updatedFamilies;
          flushPassiveEffects();
          flushSync(function () {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
          });
        }
      };

      var scheduleRoot = function scheduleRoot(root, element) {
        {
          if (root.context !== emptyContextObject) {
            return;
          }

          flushPassiveEffects();
          flushSync(function () {
            updateContainer(element, root, null, null);
          });
        }
      };

      function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        {
          var alternate = fiber.alternate,
              child = fiber.child,
              sibling = fiber.sibling,
              tag = fiber.tag,
              type = fiber.type;
          var candidateType = null;

          switch (tag) {
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
              candidateType = type;
              break;

            case ForwardRef:
              candidateType = type.render;
              break;
          }

          if (resolveFamily === null) {
            throw new Error('Expected resolveFamily to be set during hot reload.');
          }

          var needsRender = false;
          var needsRemount = false;

          if (candidateType !== null) {
            var family = resolveFamily(candidateType);

            if (family !== undefined) {
              if (staleFamilies.has(family)) {
                needsRemount = true;
              } else if (updatedFamilies.has(family)) {
                if (tag === ClassComponent) {
                  needsRemount = true;
                } else {
                  needsRender = true;
                }
              }
            }
          }

          if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
              needsRemount = true;
            }
          }

          if (needsRemount) {
            fiber._debugNeedsRemount = true;
          }

          if (needsRemount || needsRender) {
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          }

          if (child !== null && !needsRemount) {
            scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
          }

          if (sibling !== null) {
            scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
          }
        }
      }

      var findHostInstancesForRefresh = function findHostInstancesForRefresh(root, families) {
        {
          var hostInstances = new Set();
          var types = new Set(families.map(function (family) {
            return family.current;
          }));
          findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
          return hostInstances;
        }
      };

      function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        {
          var child = fiber.child,
              sibling = fiber.sibling,
              tag = fiber.tag,
              type = fiber.type;
          var candidateType = null;

          switch (tag) {
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
              candidateType = type;
              break;

            case ForwardRef:
              candidateType = type.render;
              break;
          }

          var didMatch = false;

          if (candidateType !== null) {
            if (types.has(candidateType)) {
              didMatch = true;
            }
          }

          if (didMatch) {
            findHostInstancesForFiberShallowly(fiber, hostInstances);
          } else {
            if (child !== null) {
              findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
            }
          }

          if (sibling !== null) {
            findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
          }
        }
      }

      function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        {
          var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);

          if (foundHostInstances) {
            return;
          }

          var node = fiber;

          while (true) {
            switch (node.tag) {
              case HostComponent:
                hostInstances.add(node.stateNode);
                return;

              case HostPortal:
                hostInstances.add(node.stateNode.containerInfo);
                return;

              case HostRoot:
                hostInstances.add(node.stateNode.containerInfo);
                return;
            }

            if (node["return"] === null) {
              throw new Error('Expected to reach root first.');
            }

            node = node["return"];
          }
        }
      }

      function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        {
          var node = fiber;
          var foundHostInstances = false;

          while (true) {
            if (node.tag === HostComponent) {
              foundHostInstances = true;
              hostInstances.add(node.stateNode);
            } else if (node.child !== null) {
              node.child["return"] = node;
              node = node.child;
              continue;
            }

            if (node === fiber) {
              return foundHostInstances;
            }

            while (node.sibling === null) {
              if (node["return"] === null || node["return"] === fiber) {
                return foundHostInstances;
              }

              node = node["return"];
            }

            node.sibling["return"] = node["return"];
            node = node.sibling;
          }
        }
        return false;
      }

      var hasBadMapPolyfill;
      {
        hasBadMapPolyfill = false;

        try {
          var nonExtensibleObject = Object.preventExtensions({});
          new Map([[nonExtensibleObject, null]]);
          new Set([nonExtensibleObject]);
        } catch (e) {
          hasBadMapPolyfill = true;
        }
      }

      function FiberNode(tag, pendingProps, key, mode) {
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null;
        this["return"] = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode;
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        {
          this.actualDuration = Number.NaN;
          this.actualStartTime = Number.NaN;
          this.selfBaseDuration = Number.NaN;
          this.treeBaseDuration = Number.NaN;
          this.actualDuration = 0;
          this.actualStartTime = -1;
          this.selfBaseDuration = 0;
          this.treeBaseDuration = 0;
        }
        {
          this._debugSource = null;
          this._debugOwner = null;
          this._debugNeedsRemount = false;
          this._debugHookTypes = null;

          if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') {
            Object.preventExtensions(this);
          }
        }
      }

      var createFiber = function createFiber(tag, pendingProps, key, mode) {
        return new FiberNode(tag, pendingProps, key, mode);
      };

      function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct$1(type) && type.defaultProps === undefined;
      }

      function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') {
          return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        } else if (Component !== undefined && Component !== null) {
          var $$typeof = Component.$$typeof;

          if ($$typeof === REACT_FORWARD_REF_TYPE) {
            return ForwardRef;
          }

          if ($$typeof === REACT_MEMO_TYPE) {
            return MemoComponent;
          }
        }

        return IndeterminateComponent;
      }

      function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;

        if (workInProgress === null) {
          workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
          workInProgress.elementType = current.elementType;
          workInProgress.type = current.type;
          workInProgress.stateNode = current.stateNode;
          {
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
          }
          workInProgress.alternate = current;
          current.alternate = workInProgress;
        } else {
          workInProgress.pendingProps = pendingProps;
          workInProgress.type = current.type;
          workInProgress.flags = NoFlags;
          workInProgress.subtreeFlags = NoFlags;
          workInProgress.deletions = null;
          {
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
          }
        }

        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue;
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
          lanes: currentDependencies.lanes,
          firstContext: currentDependencies.firstContext
        };
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        {
          workInProgress.selfBaseDuration = current.selfBaseDuration;
          workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        {
          workInProgress._debugNeedsRemount = current._debugNeedsRemount;

          switch (workInProgress.tag) {
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
              workInProgress.type = resolveFunctionForHotReloading(current.type);
              break;

            case ClassComponent:
              workInProgress.type = resolveClassForHotReloading(current.type);
              break;

            case ForwardRef:
              workInProgress.type = resolveForwardRefForHotReloading(current.type);
              break;
          }
        }
        return workInProgress;
      }

      function resetWorkInProgress(workInProgress, renderLanes) {
        workInProgress.flags &= StaticMask | Placement;
        var current = workInProgress.alternate;

        if (current === null) {
          workInProgress.childLanes = NoLanes;
          workInProgress.lanes = renderLanes;
          workInProgress.child = null;
          workInProgress.subtreeFlags = NoFlags;
          workInProgress.memoizedProps = null;
          workInProgress.memoizedState = null;
          workInProgress.updateQueue = null;
          workInProgress.dependencies = null;
          workInProgress.stateNode = null;
          {
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
          }
        } else {
          workInProgress.childLanes = current.childLanes;
          workInProgress.lanes = current.lanes;
          workInProgress.child = current.child;
          workInProgress.subtreeFlags = NoFlags;
          workInProgress.deletions = null;
          workInProgress.memoizedProps = current.memoizedProps;
          workInProgress.memoizedState = current.memoizedState;
          workInProgress.updateQueue = current.updateQueue;
          workInProgress.type = current.type;
          var currentDependencies = current.dependencies;
          workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
          };
          {
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
          }
        }

        return workInProgress;
      }

      function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;

        if (tag === ConcurrentRoot) {
          mode = ConcurrentMode;

          if (isStrictMode === true) {
            mode |= StrictLegacyMode;
            {
              mode |= StrictEffectsMode;
            }
          }
        } else {
          mode = NoMode;
        }

        if (isDevToolsPresent) {
          mode |= ProfileMode;
        }

        return createFiber(HostRoot, null, null, mode);
      }

      function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent;
        var resolvedType = type;

        if (typeof type === 'function') {
          if (shouldConstruct$1(type)) {
            fiberTag = ClassComponent;
            {
              resolvedType = resolveClassForHotReloading(resolvedType);
            }
          } else {
            {
              resolvedType = resolveFunctionForHotReloading(resolvedType);
            }
          }
        } else if (typeof type === 'string') {
          fiberTag = HostComponent;
        } else {
          getTag: switch (type) {
            case REACT_FRAGMENT_TYPE:
              return createFiberFromFragment(pendingProps.children, mode, lanes, key);

            case REACT_STRICT_MODE_TYPE:
              fiberTag = Mode;
              mode |= StrictLegacyMode;

              if ((mode & ConcurrentMode) !== NoMode) {
                mode |= StrictEffectsMode;
              }

              break;

            case REACT_PROFILER_TYPE:
              return createFiberFromProfiler(pendingProps, mode, lanes, key);

            case REACT_SUSPENSE_TYPE:
              return createFiberFromSuspense(pendingProps, mode, lanes, key);

            case REACT_SUSPENSE_LIST_TYPE:
              return createFiberFromSuspenseList(pendingProps, mode, lanes, key);

            case REACT_OFFSCREEN_TYPE:
              return createFiberFromOffscreen(pendingProps, mode, lanes, key);

            case REACT_LEGACY_HIDDEN_TYPE:
            case REACT_SCOPE_TYPE:
            case REACT_CACHE_TYPE:
            case REACT_TRACING_MARKER_TYPE:
            case REACT_DEBUG_TRACING_MODE_TYPE:
            default:
              {
                if (typeof type === 'object' && type !== null) {
                  switch (type.$$typeof) {
                    case REACT_PROVIDER_TYPE:
                      fiberTag = ContextProvider;
                      break getTag;

                    case REACT_CONTEXT_TYPE:
                      fiberTag = ContextConsumer;
                      break getTag;

                    case REACT_FORWARD_REF_TYPE:
                      fiberTag = ForwardRef;
                      {
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                      }
                      break getTag;

                    case REACT_MEMO_TYPE:
                      fiberTag = MemoComponent;
                      break getTag;

                    case REACT_LAZY_TYPE:
                      fiberTag = LazyComponent;
                      resolvedType = null;
                      break getTag;
                  }
                }

                var info = '';
                {
                  if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
                    info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
                  }

                  var ownerName = owner ? getComponentNameFromFiber(owner) : null;

                  if (ownerName) {
                    info += '\n\nCheck the render method of `' + ownerName + '`.';
                  }
                }
                throw new Error('Element type is invalid: expected a string (for built-in ' + 'components) or a class/function (for composite components) ' + ("but got: " + (type == null ? type : typeof type) + "." + info));
              }
          }
        }

        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        {
          fiber._debugOwner = owner;
        }
        return fiber;
      }

      function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        {
          owner = element._owner;
        }
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        {
          fiber._debugSource = element._source;
          fiber._debugOwner = element._owner;
        }
        return fiber;
      }

      function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
      }

      function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        {
          if (typeof pendingProps.id !== 'string') {
            error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
          }
        }
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        {
          fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
          };
        }
        return fiber;
      }

      function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
      }

      function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
      }

      function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {};
        fiber.stateNode = primaryChildInstance;
        return fiber;
      }

      function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
      }

      function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = 'DELETED';
        return fiber;
      }

      function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
      }

      function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
          containerInfo: portal.containerInfo,
          pendingChildren: null,
          implementation: portal.implementation
        };
        return fiber;
      }

      function assignFiberPropertiesInDEV(target, source) {
        if (target === null) {
          target = createFiber(IndeterminateComponent, null, null, NoMode);
        }

        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target["return"] = source["return"];
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        {
          target.actualDuration = source.actualDuration;
          target.actualStartTime = source.actualStartTime;
          target.selfBaseDuration = source.selfBaseDuration;
          target.treeBaseDuration = source.treeBaseDuration;
        }
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
      }

      function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        {
          this.mutableSourceEagerHydrationData = null;
        }
        {
          this.effectDuration = 0;
          this.passiveEffectDuration = 0;
        }
        {
          this.memoizedUpdaters = new Set();
          var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];

          for (var _i = 0; _i < TotalLanes; _i++) {
            pendingUpdatersLaneMap.push(new Set());
          }
        }
        {
          switch (tag) {
            case ConcurrentRoot:
              this._debugRootType = hydrate ? 'hydrateRoot()' : 'createRoot()';
              break;

            case LegacyRoot:
              this._debugRootType = hydrate ? 'hydrate()' : 'render()';
              break;
          }
        }
      }

      function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        {
          var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            transitions: null,
            pendingSuspenseBoundaries: null
          };
          uninitializedFiber.memoizedState = _initialState;
        }
        initializeUpdateQueue(uninitializedFiber);
        return root;
      }

      var ReactVersion = '18.1.0';

      function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        {
          checkKeyStringCoercion(key);
        }
        return {
          $$typeof: REACT_PORTAL_TYPE,
          key: key == null ? null : '' + key,
          children: children,
          containerInfo: containerInfo,
          implementation: implementation
        };
      }

      var didWarnAboutNestedUpdates;
      var didWarnAboutFindNodeInStrictMode;
      {
        didWarnAboutNestedUpdates = false;
        didWarnAboutFindNodeInStrictMode = {};
      }

      function getContextForSubtree(parentComponent) {
        if (!parentComponent) {
          return emptyContextObject;
        }

        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);

        if (fiber.tag === ClassComponent) {
          var Component = fiber.type;

          if (isContextProvider(Component)) {
            return processChildContext(fiber, Component, parentContext);
          }
        }

        return parentContext;
      }

      function findHostInstanceWithWarning(component, methodName) {
        {
          var fiber = get(component);

          if (fiber === undefined) {
            if (typeof component.render === 'function') {
              throw new Error('Unable to find node on an unmounted component.');
            } else {
              var keys = Object.keys(component).join(',');
              throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
          }

          var hostFiber = findCurrentHostFiber(fiber);

          if (hostFiber === null) {
            return null;
          }

          if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || 'Component';

            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
              didWarnAboutFindNodeInStrictMode[componentName] = true;
              var previousFiber = current;

              try {
                setCurrentFiber(hostFiber);

                if (fiber.mode & StrictLegacyMode) {
                  error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which is inside StrictMode. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
                } else {
                  error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which renders StrictMode children. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
                }
              } finally {
                if (previousFiber) {
                  setCurrentFiber(previousFiber);
                } else {
                  resetCurrentFiber();
                }
              }
            }
          }

          return hostFiber.stateNode;
        }
      }

      function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
      }

      function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        root.context = getContextForSubtree(null);
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
      }

      function updateContainer(element, container, parentComponent, callback) {
        {
          onScheduleRoot(container, element);
        }
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        {
          markRenderScheduled(lane);
        }
        var context = getContextForSubtree(parentComponent);

        if (container.context === null) {
          container.context = context;
        } else {
          container.pendingContext = context;
        }

        {
          if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error('Render methods should be a pure function of props and state; ' + 'triggering nested component updates from render is not allowed. ' + 'If necessary, trigger nested updates in componentDidUpdate.\n\n' + 'Check the render method of %s.', getComponentNameFromFiber(current) || 'Unknown');
          }
        }
        var update = createUpdate(eventTime, lane);
        update.payload = {
          element: element
        };
        callback = callback === undefined ? null : callback;

        if (callback !== null) {
          {
            if (typeof callback !== 'function') {
              error('render(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callback);
            }
          }
          update.callback = callback;
        }

        enqueueUpdate(current$1, update);
        var root = scheduleUpdateOnFiber(current$1, lane, eventTime);

        if (root !== null) {
          entangleTransitions(root, current$1, lane);
        }

        return lane;
      }

      function getPublicRootInstance(container) {
        var containerFiber = container.current;

        if (!containerFiber.child) {
          return null;
        }

        switch (containerFiber.child.tag) {
          case HostComponent:
            return getPublicInstance(containerFiber.child.stateNode);

          default:
            return containerFiber.child.stateNode;
        }
      }

      function attemptSynchronousHydration$1(fiber) {
        switch (fiber.tag) {
          case HostRoot:
            var root = fiber.stateNode;

            if (isRootDehydrated(root)) {
              var lanes = getHighestPriorityPendingLanes(root);
              flushRoot(root, lanes);
            }

            break;

          case SuspenseComponent:
            var eventTime = requestEventTime();
            flushSync(function () {
              return scheduleUpdateOnFiber(fiber, SyncLane, eventTime);
            });
            var retryLane = SyncLane;
            markRetryLaneIfNotHydrated(fiber, retryLane);
            break;
        }
      }

      function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;

        if (suspenseState !== null && suspenseState.dehydrated !== null) {
          suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
        }
      }

      function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;

        if (alternate) {
          markRetryLaneImpl(alternate, retryLane);
        }
      }

      function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) {
          return;
        }

        var eventTime = requestEventTime();
        var lane = SelectiveHydrationLane;
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
      }

      function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) {
          return;
        }

        var eventTime = requestEventTime();
        var lane = requestUpdateLane(fiber);
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
      }

      function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);

        if (hostFiber === null) {
          return null;
        }

        return hostFiber.stateNode;
      }

      var shouldErrorImpl = function shouldErrorImpl(fiber) {
        return null;
      };

      function shouldError(fiber) {
        return shouldErrorImpl(fiber);
      }

      var shouldSuspendImpl = function shouldSuspendImpl(fiber) {
        return false;
      };

      function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
      }

      var overrideHookState = null;
      var overrideHookStateDeletePath = null;
      var overrideHookStateRenamePath = null;
      var overrideProps = null;
      var overridePropsDeletePath = null;
      var overridePropsRenamePath = null;
      var scheduleUpdate = null;
      var setErrorHandler = null;
      var setSuspenseHandler = null;
      {
        var copyWithDeleteImpl = function copyWithDeleteImpl(obj, path, index) {
          var key = path[index];
          var updated = isArray(obj) ? obj.slice() : assign({}, obj);

          if (index + 1 === path.length) {
            if (isArray(updated)) {
              updated.splice(key, 1);
            } else {
              delete updated[key];
            }

            return updated;
          }

          updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
          return updated;
        };

        var copyWithDelete = function copyWithDelete(obj, path) {
          return copyWithDeleteImpl(obj, path, 0);
        };

        var copyWithRenameImpl = function copyWithRenameImpl(obj, oldPath, newPath, index) {
          var oldKey = oldPath[index];
          var updated = isArray(obj) ? obj.slice() : assign({}, obj);

          if (index + 1 === oldPath.length) {
            var newKey = newPath[index];
            updated[newKey] = updated[oldKey];

            if (isArray(updated)) {
              updated.splice(oldKey, 1);
            } else {
              delete updated[oldKey];
            }
          } else {
            updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
          }

          return updated;
        };

        var copyWithRename = function copyWithRename(obj, oldPath, newPath) {
          if (oldPath.length !== newPath.length) {
            warn('copyWithRename() expects paths of the same length');
            return;
          } else {
            for (var i = 0; i < newPath.length - 1; i++) {
              if (oldPath[i] !== newPath[i]) {
                warn('copyWithRename() expects paths to be the same except for the deepest key');
                return;
              }
            }
          }

          return copyWithRenameImpl(obj, oldPath, newPath, 0);
        };

        var copyWithSetImpl = function copyWithSetImpl(obj, path, index, value) {
          if (index >= path.length) {
            return value;
          }

          var key = path[index];
          var updated = isArray(obj) ? obj.slice() : assign({}, obj);
          updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
          return updated;
        };

        var copyWithSet = function copyWithSet(obj, path, value) {
          return copyWithSetImpl(obj, path, 0, value);
        };

        var findHook = function findHook(fiber, id) {
          var currentHook = fiber.memoizedState;

          while (currentHook !== null && id > 0) {
            currentHook = currentHook.next;
            id--;
          }

          return currentHook;
        };

        overrideHookState = function overrideHookState(fiber, id, path, value) {
          var hook = findHook(fiber, id);

          if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState;
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          }
        };

        overrideHookStateDeletePath = function overrideHookStateDeletePath(fiber, id, path) {
          var hook = findHook(fiber, id);

          if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState;
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          }
        };

        overrideHookStateRenamePath = function overrideHookStateRenamePath(fiber, id, oldPath, newPath) {
          var hook = findHook(fiber, id);

          if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState;
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          }
        };

        overrideProps = function overrideProps(fiber, path, value) {
          fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);

          if (fiber.alternate) {
            fiber.alternate.pendingProps = fiber.pendingProps;
          }

          scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        };

        overridePropsDeletePath = function overridePropsDeletePath(fiber, path) {
          fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);

          if (fiber.alternate) {
            fiber.alternate.pendingProps = fiber.pendingProps;
          }

          scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        };

        overridePropsRenamePath = function overridePropsRenamePath(fiber, oldPath, newPath) {
          fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);

          if (fiber.alternate) {
            fiber.alternate.pendingProps = fiber.pendingProps;
          }

          scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        };

        scheduleUpdate = function scheduleUpdate(fiber) {
          scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        };

        setErrorHandler = function setErrorHandler(newShouldErrorImpl) {
          shouldErrorImpl = newShouldErrorImpl;
        };

        setSuspenseHandler = function setSuspenseHandler(newShouldSuspendImpl) {
          shouldSuspendImpl = newShouldSuspendImpl;
        };
      }

      function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);

        if (hostFiber === null) {
          return null;
        }

        return hostFiber.stateNode;
      }

      function emptyFindFiberByHostInstance(instance) {
        return null;
      }

      function getCurrentFiberForDevTools() {
        return current;
      }

      function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
          bundleType: devToolsConfig.bundleType,
          version: devToolsConfig.version,
          rendererPackageName: devToolsConfig.rendererPackageName,
          rendererConfig: devToolsConfig.rendererConfig,
          overrideHookState: overrideHookState,
          overrideHookStateDeletePath: overrideHookStateDeletePath,
          overrideHookStateRenamePath: overrideHookStateRenamePath,
          overrideProps: overrideProps,
          overridePropsDeletePath: overridePropsDeletePath,
          overridePropsRenamePath: overridePropsRenamePath,
          setErrorHandler: setErrorHandler,
          setSuspenseHandler: setSuspenseHandler,
          scheduleUpdate: scheduleUpdate,
          currentDispatcherRef: ReactCurrentDispatcher,
          findHostInstanceByFiber: findHostInstanceByFiber,
          findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
          findHostInstancesForRefresh: findHostInstancesForRefresh,
          scheduleRefresh: scheduleRefresh,
          scheduleRoot: scheduleRoot,
          setRefreshHandler: setRefreshHandler,
          getCurrentFiber: getCurrentFiberForDevTools,
          reconcilerVersion: ReactVersion
        });
      }

      var defaultOnRecoverableError = typeof reportError === 'function' ? reportError : function (error) {
        console['error'](error);
      };

      function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
      }

      ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function (children) {
        var root = this._internalRoot;

        if (root === null) {
          throw new Error('Cannot update an unmounted root.');
        }

        {
          if (typeof arguments[1] === 'function') {
            error('render(...): does not support the second callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
          } else if (isValidContainer(arguments[1])) {
            error('You passed a container to the second argument of root.render(...). ' + "You don't need to pass it again since you already passed it to create the root.");
          } else if (typeof arguments[1] !== 'undefined') {
            error('You passed a second argument to root.render(...) but it only accepts ' + 'one argument.');
          }

          var container = root.containerInfo;

          if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);

            if (hostInstance) {
              if (hostInstance.parentNode !== container) {
                error('render(...): It looks like the React-rendered content of the ' + 'root container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + "root.unmount() to empty a root's container.");
              }
            }
          }
        }
        updateContainer(children, root, null, null);
      };

      ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function () {
        {
          if (typeof arguments[0] === 'function') {
            error('unmount(...): does not support a callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
          }
        }
        var root = this._internalRoot;

        if (root !== null) {
          this._internalRoot = null;
          var container = root.containerInfo;
          {
            if (isAlreadyRendering()) {
              error('Attempted to synchronously unmount a root while React was already ' + 'rendering. React cannot finish unmounting the root until the ' + 'current render has completed, which may lead to a race condition.');
            }
          }
          flushSync(function () {
            updateContainer(null, root, null, null);
          });
          unmarkContainerAsRoot(container);
        }
      };

      function createRoot(container, options) {
        if (!isValidContainer(container)) {
          throw new Error('createRoot(...): Target container is not a DOM element.');
        }

        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = '';
        var onRecoverableError = defaultOnRecoverableError;

        if (options !== null && options !== undefined) {
          {
            if (options.hydrate) {
              warn('hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.');
            } else {
              if (typeof options === 'object' && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) {
                error('You passed a JSX element to createRoot. You probably meant to ' + 'call root.render instead. ' + 'Example usage:\n\n' + '  let root = createRoot(domContainer);\n' + '  root.render(<App />);');
              }
            }
          }

          if (options.unstable_strictMode === true) {
            isStrictMode = true;
          }

          if (options.identifierPrefix !== undefined) {
            identifierPrefix = options.identifierPrefix;
          }

          if (options.onRecoverableError !== undefined) {
            onRecoverableError = options.onRecoverableError;
          }
        }

        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
      }

      function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
      }

      function scheduleHydration(target) {
        if (target) {
          queueExplicitHydrationTarget(target);
        }
      }

      ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;

      function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) {
          throw new Error('hydrateRoot(...): Target container is not a DOM element.');
        }

        warnIfReactDOMContainerInDEV(container);
        {
          if (initialChildren === undefined) {
            error('Must provide initial children as second argument to hydrateRoot. ' + 'Example usage: hydrateRoot(domContainer, <App />)');
          }
        }
        var hydrationCallbacks = options != null ? options : null;
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = '';
        var onRecoverableError = defaultOnRecoverableError;

        if (options !== null && options !== undefined) {
          if (options.unstable_strictMode === true) {
            isStrictMode = true;
          }

          if (options.identifierPrefix !== undefined) {
            identifierPrefix = options.identifierPrefix;
          }

          if (options.onRecoverableError !== undefined) {
            onRecoverableError = options.onRecoverableError;
          }
        }

        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        listenToAllSupportedEvents(container);

        if (mutableSources) {
          for (var i = 0; i < mutableSources.length; i++) {
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
          }
        }

        return new ReactDOMHydrationRoot(root);
      }

      function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
      }

      function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
      }

      function warnIfReactDOMContainerInDEV(container) {
        {
          if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') {
            error('createRoot(): Creating roots directly with document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try using a container element created ' + 'for your app.');
          }

          if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) {
              error('You are calling ReactDOMClient.createRoot() on a container that was previously ' + 'passed to ReactDOM.render(). This is not supported.');
            } else {
              error('You are calling ReactDOMClient.createRoot() on a container that ' + 'has already been passed to createRoot() before. Instead, call ' + 'root.render() on the existing root instead if you want to update it.');
            }
          }
        }
      }

      var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
      var topLevelUpdateWarnings;
      {
        topLevelUpdateWarnings = function topLevelUpdateWarnings(container) {
          if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);

            if (hostInstance) {
              if (hostInstance.parentNode !== container) {
                error('render(...): It looks like the React-rendered content of this ' + 'container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + 'ReactDOM.unmountComponentAtNode to empty a container.');
              }
            }
          }

          var isRootRenderedBySomeReact = !!container._reactRootContainer;
          var rootEl = getReactRootElementInContainer(container);
          var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));

          if (hasNonRootReactChild && !isRootRenderedBySomeReact) {
            error('render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.');
          }

          if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') {
            error('render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.');
          }
        };
      }

      function getReactRootElementInContainer(container) {
        if (!container) {
          return null;
        }

        if (container.nodeType === DOCUMENT_NODE) {
          return container.documentElement;
        } else {
          return container.firstChild;
        }
      }

      function noopOnRecoverableError() {}

      function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
          if (typeof callback === 'function') {
            var originalCallback = callback;

            callback = function callback() {
              var instance = getPublicRootInstance(root);
              originalCallback.call(instance);
            };
          }

          var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, '', noopOnRecoverableError);
          container._reactRootContainer = root;
          markContainerAsRoot(root.current, container);
          var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
          listenToAllSupportedEvents(rootContainerElement);
          flushSync();
          return root;
        } else {
          var rootSibling;

          while (rootSibling = container.lastChild) {
            container.removeChild(rootSibling);
          }

          if (typeof callback === 'function') {
            var _originalCallback = callback;

            callback = function callback() {
              var instance = getPublicRootInstance(_root);

              _originalCallback.call(instance);
            };
          }

          var _root = createContainer(container, LegacyRoot, null, false, false, '', noopOnRecoverableError);

          container._reactRootContainer = _root;
          markContainerAsRoot(_root.current, container);

          var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;

          listenToAllSupportedEvents(_rootContainerElement);
          flushSync(function () {
            updateContainer(initialChildren, _root, parentComponent, callback);
          });
          return _root;
        }
      }

      function warnOnInvalidCallback$1(callback, callerName) {
        {
          if (callback !== null && typeof callback !== 'function') {
            error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
          }
        }
      }

      function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        {
          topLevelUpdateWarnings(container);
          warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
        }
        var maybeRoot = container._reactRootContainer;
        var root;

        if (!maybeRoot) {
          root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        } else {
          root = maybeRoot;

          if (typeof callback === 'function') {
            var originalCallback = callback;

            callback = function callback() {
              var instance = getPublicRootInstance(root);
              originalCallback.call(instance);
            };
          }

          updateContainer(children, root, parentComponent, callback);
        }

        return getPublicRootInstance(root);
      }

      function findDOMNode(componentOrElement) {
        {
          var owner = ReactCurrentOwner$3.current;

          if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;

            if (!warnedAboutRefsInRender) {
              error('%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentNameFromType(owner.type) || 'A component');
            }

            owner.stateNode._warnedAboutRefsInRender = true;
          }
        }

        if (componentOrElement == null) {
          return null;
        }

        if (componentOrElement.nodeType === ELEMENT_NODE) {
          return componentOrElement;
        }

        {
          return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
        }
      }

      function hydrate(element, container, callback) {
        {
          error('ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot ' + 'instead. Until you switch to the new API, your app will behave as ' + "if it's running React 17. Learn " + 'more: https://reactjs.org/link/switch-to-createroot');
        }

        if (!isValidContainerLegacy(container)) {
          throw new Error('Target container is not a DOM element.');
        }

        {
          var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

          if (isModernRoot) {
            error('You are calling ReactDOM.hydrate() on a container that was previously ' + 'passed to ReactDOMClient.createRoot(). This is not supported. ' + 'Did you mean to call hydrateRoot(container, element)?');
          }
        }
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
      }

      function render(element, container, callback) {
        {
          error('ReactDOM.render is no longer supported in React 18. Use createRoot ' + 'instead. Until you switch to the new API, your app will behave as ' + "if it's running React 17. Learn " + 'more: https://reactjs.org/link/switch-to-createroot');
        }

        if (!isValidContainerLegacy(container)) {
          throw new Error('Target container is not a DOM element.');
        }

        {
          var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

          if (isModernRoot) {
            error('You are calling ReactDOM.render() on a container that was previously ' + 'passed to ReactDOMClient.createRoot(). This is not supported. ' + 'Did you mean to call root.render(element)?');
          }
        }
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
      }

      function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        {
          error('ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported ' + 'in React 18. Consider using a portal instead. Until you switch to ' + "the createRoot API, your app will behave as if it's running React " + '17. Learn more: https://reactjs.org/link/switch-to-createroot');
        }

        if (!isValidContainerLegacy(containerNode)) {
          throw new Error('Target container is not a DOM element.');
        }

        if (parentComponent == null || !has(parentComponent)) {
          throw new Error('parentComponent must be a valid React Component');
        }

        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
      }

      function unmountComponentAtNode(container) {
        if (!isValidContainerLegacy(container)) {
          throw new Error('unmountComponentAtNode(...): Target container is not a DOM element.');
        }

        {
          var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

          if (isModernRoot) {
            error('You are calling ReactDOM.unmountComponentAtNode() on a container that was previously ' + 'passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?');
          }
        }

        if (container._reactRootContainer) {
          {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);

            if (renderedByDifferentReact) {
              error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.');
            }
          }
          flushSync(function () {
            legacyRenderSubtreeIntoContainer(null, null, container, false, function () {
              container._reactRootContainer = null;
              unmarkContainerAsRoot(container);
            });
          });
          return true;
        } else {
          {
            var _rootEl = getReactRootElementInContainer(container);

            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl));
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;

            if (hasNonRootReactChild) {
              error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.');
            }
          }
          return false;
        }
      }

      setAttemptSynchronousHydration(attemptSynchronousHydration$1);
      setAttemptContinuousHydration(attemptContinuousHydration$1);
      setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
      setGetCurrentUpdatePriority(getCurrentUpdatePriority);
      setAttemptHydrationAtPriority(runWithPriority);
      {
        if (typeof Map !== 'function' || Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') {
          error('React depends on Map and Set built-in types. Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
        }
      }
      setRestoreImplementation(restoreControlledState$3);
      setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);

      function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        if (!isValidContainer(container)) {
          throw new Error('Target container is not a DOM element.');
        }

        return createPortal(children, container, null, key);
      }

      function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
      }

      var Internals = {
        usingClientEntryPoint: false,
        Events: [getInstanceFromNode, getNodeFromInstance, getFiberCurrentPropsFromNode, enqueueStateRestore, restoreStateIfNeeded, batchedUpdates$1]
      };

      function createRoot$1(container, options) {
        {
          if (!Internals.usingClientEntryPoint && !false) {
            error('You are importing createRoot from "react-dom" which is not supported. ' + 'You should instead import it from "react-dom/client".');
          }
        }
        return createRoot(container, options);
      }

      function hydrateRoot$1(container, initialChildren, options) {
        {
          if (!Internals.usingClientEntryPoint && !false) {
            error('You are importing hydrateRoot from "react-dom" which is not supported. ' + 'You should instead import it from "react-dom/client".');
          }
        }
        return hydrateRoot(container, initialChildren, options);
      }

      function flushSync$1(fn) {
        {
          if (isAlreadyRendering()) {
            error('flushSync was called from inside a lifecycle method. React cannot ' + 'flush when React is already rendering. Consider moving this call to ' + 'a scheduler task or micro task.');
          }
        }
        return flushSync(fn);
      }

      var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: 'react-dom'
      });
      {
        if (!foundDevTools && canUseDOM && window.top === window.self) {
          if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
            var protocol = window.location.protocol;

            if (/^(https?|file):$/.test(protocol)) {
              console.info('%cDownload the React DevTools ' + 'for a better development experience: ' + 'https://reactjs.org/link/react-devtools' + (protocol === 'file:' ? '\nYou might need to use a local HTTP server (instead of file://): ' + 'https://reactjs.org/link/react-devtools-faq' : ''), 'font-weight:bold');
            }
          }
        }
      }
      exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
      exports.createPortal = createPortal$1;
      exports.createRoot = createRoot$1;
      exports.findDOMNode = findDOMNode;
      exports.flushSync = flushSync$1;
      exports.hydrate = hydrate;
      exports.hydrateRoot = hydrateRoot$1;
      exports.render = render;
      exports.unmountComponentAtNode = unmountComponentAtNode;
      exports.unstable_batchedUpdates = batchedUpdates$1;
      exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
      exports.version = ReactVersion;

      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
});

var reactDom = createCommonjsModule(function (module) {

  function checkDCE() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      throw new Error('^_^');
    }

    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      console.error(err);
    }
  }

  if (process.env.NODE_ENV === 'production') {
    checkDCE();
    module.exports = reactDom_production_min;
  } else {
    module.exports = reactDom_development;
  }
});

var Portal = function Portal(props) {
  var mount = document.getElementById("portal_root");

  if (props.target) {
    mount = document.getElementById(props.target);
  }

  return reactDom.createPortal(props.children, mount);
};

var base_cls = " py-2 px-2 rounded font-medium text-sm outline-none ";
var colors = {
  'primary': ' bg-primary text-white hover:bg-primary-lighten',
  'secondary': ' bg-secondary text-white',
  'transparent': 'bg-transparent text-primary hover:bg-light-selected rounded-full',
  'disabled': ' bg-disabled text-gray-500',
  'warning': ' bg-transparent text-gray-500 hover:text-red-600 rounded-full'
};

function IconButton(props) {
  var cls = function cls() {
    var base = props.className ? props.className.concat(base_cls) : base_cls;
    return base.concat(colors[props.color]);
  };

  return /*#__PURE__*/React__default.createElement("button", {
    type: props.type || 'button',
    className: cls(),
    style: props.style,
    onClick: props.onClick
  }, props.children);
}

var _path;

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$1.apply(this, arguments);
}

function SvgClose(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
  })));
}

var height = 50;
var pos = height + 10;

function SnackBarWeb(props) {
  var snack = props.snack;
  var levels = {
    'sucessfull': " bg-green-200 text-green-800 border-green-400",
    'error': " bg-red-200 text-red-800 border-red-400"
  };
  var style = {
    position: 'fixed',
    zIndex: '9999',
    top: props.position ? Math.max(props.position * pos, pos) : 0,
    right: 'auto',
    bottom: 'auto',
    height: height
  };
  return /*#__PURE__*/React__default.createElement(Portal, {
    target: props.target
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "snackbar-appear text-sm".concat(levels[snack.level]),
    style: style
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "h-full w-full text-justify py-4 px-4 font-medium"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React__default.createElement("span", null, snack.message), /*#__PURE__*/React__default.createElement(IconButton, {
    color: "warning",
    onClick: function onClick() {
      snack.remove();
    },
    style: {
      paddingTop: 0,
      paddingBottom: 0
    }
  }, /*#__PURE__*/React__default.createElement(SvgClose, {
    style: {
      width: '.7em',
      height: '.7em'
    },
    className: "fill-current  text-xl cursor-pointer w-4 h-2"
  }))))));
}

var SnackBar;

if (environment() === 'web') {
  SnackBar = SnackBarWeb;
}

function Paper(props) {
  var classNames = " bg-white shadow-xl ";
  return /*#__PURE__*/React__default.createElement("div", {
    className: props.className ? classNames.concat(props.className) : classNames,
    style: props.style || {}
  }, props.children);
}

function Modal(props) {
  var style = {
    position: 'fixed',
    top: props.top ? props.top : '50%',
    left: props.left ? props.left : '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translateX(-50%) translateY(calc(-50% - .5px))',
    zIndex: '9999',
    fontSmoothing: 'subpixel-antialiased'
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.open && /*#__PURE__*/React__default.createElement(Portal, {
    target: props.target
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "absolute bg-modal-background inset-0 z-40"
  }, props.paper ? /*#__PURE__*/React__default.createElement(Paper, {
    className: props.className,
    style: props.style ? _extends({}, style, props.style) : style
  }, props.children) : /*#__PURE__*/React__default.createElement("div", {
    className: props.className,
    style: props.style ? _extends({}, style, props.style) : style
  }, props.children))));
}

var base_cls$1 = " py-2 px-2 rounded w-full font-medium text-sm outline-none";
var list_cls = " font-bold py-1 px-1 rounded-full outline-none";
var colors$1 = {
  'primary': ' bg-primary text-white hover:bg-primary-lighten',
  'secondary': ' bg-secondary text-white',
  'disabled': ' bg-disabled text-grey-500'
};

function FormButton(props) {
  var state_attrs = props.state_attrs;

  var cls = function cls() {
    var base = props.variant === "list" ? list_cls : base_cls$1;
    base = props.className ? base.concat(props.className) : base;
    var color = props.readonly ? 'disabled' : props.color;
    return base.concat(colors$1[color]);
  };

  return /*#__PURE__*/React__default.createElement("button", {
    type: props.type || 'button',
    className: cls(),
    style: _extends({
      display: state_attrs.invisible ? 'none' : ''
    }, props.style),
    disabled: state_attrs.readonly,
    variant: props.variant,
    onClick: props.onClick
  }, props.children);
}

function DefaultBody(props) {
  var dialog = props.dialog;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col flex-grow px-2 py-2",
    style: {
      justifyContent: 'space-around'
    }
  }, dialog.html ? /*#__PURE__*/React__default.createElement("div", {
    className: "py-8 px-2",
    dangerouslySetInnerHTML: {
      __html: dialog.message
    }
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: "py-8 px-2"
  }, dialog.message), /*#__PURE__*/React__default.createElement("div", {
    className: "flex"
  }, dialog.actions.map(function (a, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: a.name,
      className: "flex-grow px-2"
    }, /*#__PURE__*/React__default.createElement(FormButton, {
      onClick: function onClick() {
        return dialog.callbackWrapper(a.callback);
      },
      state_attrs: {},
      color: a.color
    }, a.name));
  })));
}

var ConfirmationDialog = observer(function ConfirmationDialog(props) {
  var dialog = props.dialog;
  return /*#__PURE__*/React__default.createElement(Modal, {
    open: true,
    paper: true,
    target: props.target,
    style: {
      minWidth: '40%',
      minHeight: '15%',
      marginTop: props.position * 40
    },
    top: "25%",
    className: "flex w-2/5"
  }, dialog.body_component ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, dialog.component({
    dialog: dialog
  })) : /*#__PURE__*/React__default.createElement(DefaultBody, {
    dialog: dialog
  }));
});

var NotificationArea = observer(function NotificationArea(props) {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SnackList, null), /*#__PURE__*/React__default.createElement(DialogList, null));
});
var SnackList = observer(function SnackList(props) {
  var nc = useContext(NotificationContext);
  var snack_queue = nc.snack_queue;
  var SnackComponent = nc.snack_component ? nc.snack_component : SnackBar;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, snack_queue.map(function (n, index) {
    return /*#__PURE__*/React__default.createElement(SnackComponent, {
      key: n.id,
      position: index,
      snack: n,
      target: "notifications"
    });
  }));
});
var DialogList = observer(function DialogList(props) {
  var nc = useContext(NotificationContext);
  var dialog_queue = nc.dialog_queue;
  var DialogComponent = nc.dialog_component ? nc.dialog_component.component : ConfirmationDialog;
  var extra_props = nc.dialog_component && nc.dialog_component.extra_props ? nc.dialog_component.extra_props : {};
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, dialog_queue.map(function (n, index) {
    return /*#__PURE__*/React__default.createElement(DialogComponent, _extends({
      key: n.id,
      position: index,
      dialog: n,
      target: "notifications"
    }, extra_props));
  }));
});

function NotificationProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(NotificationContext.Provider, {
    value: new NotificationManager()
  }, /*#__PURE__*/React__default.createElement(NotificationArea, null), children);
}

var AppRoot = function AppRoot(_ref) {
  var children = _ref.children,
      use_default_theme = _ref.use_default_theme,
      connection_info = _ref.connection_info,
      load_db_adapter = _ref.load_db_adapter;
  return /*#__PURE__*/React__default.createElement(NotificationProvider, null, /*#__PURE__*/React__default.createElement(ConnectionProvider, {
    connection_info: connection_info,
    load_db_adapter: load_db_adapter
  }, /*#__PURE__*/React__default.createElement(AppContextProvider, null, /*#__PURE__*/React__default.createElement(ThemeContextProvider, {
    use_default_theme: use_default_theme
  }, children))));
};

var InjectContext = observer(function InjectContext(props) {
  console.log("PROPS ON INJECT CONTEXT");
  console.log(props);
  window.portal_bridge = {};
  window.portal_bridge.connection = useContext(SessionContext);
  window.portal_bridge.app = useContext(AppContext);

  if (props.token) {
    window.portal_bridge.connection.setSession(props).then(function (ses) {
      console.log("I HAVE THE SESSION");
      console.log("setting router");
      window.portal_bridge.connection.setRouter({
        'routes': window.portal_bridge.connection.routes
      });
    });
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
});

var Login = /*#__PURE__*/function () {
  function Login(connection) {
    this.screen = "";
    this.connection = "";
    makeObservable(this, {
      setScreen: action,
      screen: observable
    });
    this.connection = connection;
    this.getLoginView();
  }

  var _proto = Login.prototype;

  _proto.createScreen = function createScreen(definition) {
    var group = new ScreenGroup(this.connection, true);
    var screen = group.addScreen(definition.view, false, [], {}, true, false, false, false, false);
    screen.createFields(definition.fields);
    screen.createActions(definition.actions);
    screen.loadingFields = false;
    return screen;
  };

  _proto.setScreen = function setScreen(definition, login_info) {
    var _this = this;

    var screen = this.createScreen(definition);
    var values = login_info ? login_info : {
      'id': -1
    };
    var record = screen.data.addRecord({
      values: values
    });
    screen.set_active_record(record);
    screen.data.loadingInitialData = false;
    screen.data.loading = false;
    screen.set_actions_map({
      'login': function login(records) {
        _this.getToken(records);
      }
    });
    this.screen = screen;
  };

  _proto.getLoginView = function getLoginView() {
    try {
      var _this3 = this;

      var abortController = new AbortController();
      var login_info = false;
      return Promise.resolve(_this3.connection.dispatch('GET', '/auth/login_view', {}, false, true, false, abortController)).then(function (view_definition) {
        if (!view_definition) {
          return;
        }

        return Promise.resolve(_this3.connection.storage.getItem('kalenis_login_info')).then(function (stored_data) {
          if (stored_data) {
            login_info = JSON.parse(stored_data);
          }

          if (view_definition) {
            _this3.setScreen(view_definition, login_info);
          }
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getToken = function getToken(records) {
    try {
      var _this5 = this;

      return Promise.resolve(_this5.connection.login(records[0]._values)).then(function (session) {
        if (!session) {
          _this5.connection.notifications.addSnack({
            message: "Usuario y/o contraseña incorrecto",
            level: "error"
          });

          return false;
        }

        return Promise.resolve(_this5.connection.storage.setItem('kalenis_login_info', JSON.stringify(records[0]._values))).then(function () {
          return true;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getSignupView = function getSignupView() {
    try {
      var _this7 = this;

      var abortController = new AbortController();
      return Promise.resolve(_this7.connection.dispatch('GET', '/auth/signup_request_view', {}, false, true, false, abortController));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.requestSignup = function requestSignup() {
    try {
      var _this9 = this;

      var style = {
        'modal': {
          height: 'calc(70% - 100px)',
          backgroundColor: 'transparent',
          boxShadow: 'none'
        }
      };
      var cls = {
        'modal': 'w-full sm:w-2/4 lg:w-2/4 h-full'
      };
      return Promise.resolve(_this9.getSignupView()).then(function (definition) {
        var screen = false;

        if (!definition) {
          return false;
        }

        screen = _this9.screen.modal_childs.addScreen(definition.view, _this9.connection, false, [], {}, false, false, false, false);
        screen.createFields(definition.fields);
        screen.createActions(definition.actions);
        var record = screen.data.addRecord({
          values: {
            'id': -1
          }
        });
        screen.set_active_record(record);
        screen.loadingFields = false;
        screen.data.loadingInitialData = false;
        screen.data.loading = false;
        screen.set_actions_map({
          'request_signup': function request_signup(records) {
            _this9.submitRequestSignup(records);
          }
        });
        screen.add_style(style);
        screen.add_classname(cls);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.submitRequestSignup = function submitRequestSignup(records) {
    try {
      var _this11 = this;

      var abortController = new AbortController();
      return Promise.resolve(_this11.screen.connection.dispatch('POST', '/auth/new_signup_request', records[0]._values, false, false, false, abortController)).then(function (res) {
        if (res) {
          _this11.screen.modal_childs.clear();

          _this11.connection.notifications.addSnack({
            message: "Muchas gracias. Su solicitud será revisada.",
            level: "sucessfull"
          });
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getForgoPasswordView = function getForgoPasswordView() {
    try {
      var _this13 = this;

      var abortController = new AbortController();
      return Promise.resolve(_this13.connection.dispatch('GET', '/auth/reset_password_request_view', {}, false, true, false, abortController));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.forgotPassword = function forgotPassword() {
    try {
      var _this15 = this;

      var style = {
        'modal': {
          height: 'calc(70% - 100px)',
          backgroundColor: 'transparent',
          boxShadow: 'none'
        }
      };
      var cls = {
        'modal': 'w-full sm:w-2/4 lg:w-2/4 h-full'
      };
      return Promise.resolve(_this15.getForgoPasswordView()).then(function (definition) {
        var screen = false;

        if (!definition) {
          return false;
        }

        screen = _this15.screen.modal_childs.addScreen(definition.view, _this15.connection, false, [], {}, false, false, false, false);
        screen.createFields(definition.fields);
        screen.createActions(definition.actions);
        var record = screen.data.addRecord({
          values: {
            'id': -1
          }
        });
        screen.set_active_record(record);
        screen.loadingFields = false;
        screen.data.loadingInitialData = false;
        screen.data.loading = false;
        screen.set_actions_map({
          'request_password_reset': function request_password_reset(records) {
            _this15.submitPasswordResetRequest(records);
          }
        });
        screen.add_style(style);
        screen.add_classname(cls);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.submitPasswordResetRequest = function submitPasswordResetRequest(records) {
    try {
      var _this17 = this;

      var abortController = new AbortController();
      return Promise.resolve(_this17.screen.connection.dispatch('POST', '/auth/reset_password', records[0]._values, false, false, false, abortController)).then(function (res) {
        if (res) {
          _this17.screen.modal_childs.clear();

          _this17.connection.notifications.addSnack({
            message: "Muchas gracias, las instrucciones serán enviadas por E-mail",
            level: "sucessfull"
          });
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return Login;
}();

var PreLogin = /*#__PURE__*/function () {
  function PreLogin(connection) {
    this.email = "";
    this.connection = "";
    this.hosts = [];
    this.select_host = false;
    this.active_host = false;
    makeObservable(this, {
      email: observable,
      setEmail: action,
      hosts: observable,
      active_host: observable,
      setActiveHost: action,
      select_host: observable,
      setHosts: action,
      setSelectHost: action
    });
    this.email = "";
    this.connection = connection;
    this.hosts = [];
    this.active_host = false;
    this.select_host = false;
    this.setEmailFromStorage();
  }

  var _proto = PreLogin.prototype;

  _proto.getEmailFromStorage = function getEmailFromStorage() {
    try {
      var _this2 = this;

      var email = "";
      return Promise.resolve(_this2.connection.storage.getItem('kalenis_login_info')).then(function (session_info) {
        if (session_info) {
          session_info = JSON.parse(session_info);

          if (session_info['email']) {
            email = session_info['email'];
          }
        }

        return email;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setEmailFromStorage = function setEmailFromStorage() {
    try {
      var _this4 = this;

      return Promise.resolve(_this4.getEmailFromStorage()).then(function (email) {
        if (email) {
          _this4.setEmail(email);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setEmailToStorage = function setEmailToStorage() {
    try {
      var _this6 = this;

      return Promise.resolve(_this6.connection.storage.setItem('kalenis_login_info', JSON.stringify({
        'email': _this6.email
      }))).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setEmail = function setEmail(value) {
    this.email = value;
  };

  _proto.setHosts = function setHosts(value) {
    this.hosts = value;
  };

  _proto.setSelectHost = function setSelectHost(value) {
    this.select_host = value;
  };

  _proto.submit = function submit() {
    try {
      var _this8 = this;

      if (!_this8.email) {
        _this8.connection.notifications.addSnack({
          message: "Debe ingresar un correo electrónico",
          level: "error"
        });

        return Promise.resolve();
      }

      return Promise.resolve(_this8.getAvailableHosts()).then(function (hosts) {
        if (!hosts) {
          return false;
        } else {
          return Promise.resolve(_this8.setEmailToStorage()).then(function () {
            if (hosts.length > 1) {
              _this8.setHosts(hosts);

              _this8.setSelectHost(true);

              return false;
            } else {
              return _this8.setActiveHost(hosts[0]);
            }
          });
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setActiveHost = function setActiveHost(host) {
    this.active_host = host;
    this.connection.setApiPath(host.address);
    return this.active_host;
  };

  _proto.getAvailableHosts = function getAvailableHosts() {
    try {
      var _this10 = this;

      var values = {
        'email': _this10.email
      };
      return Promise.resolve(_this10.connection.getAvailableHosts(values)).then(function (hosts) {
        if (!hosts.length) {
          _this10.connection.notifications.addSnack({
            message: "Usuario no registrado",
            level: "error"
          });

          return false;
        }

        return hosts;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return PreLogin;
}();

var ResetPassword = /*#__PURE__*/function () {
  function ResetPassword(connection, navigate) {
    this.screen = "";
    this.connection = "";
    this.url = "";

    this.navigate = function () {};

    makeObservable(this, {
      setScreen: action,
      screen: observable,
      setUrl: action
    });
    this.connection = connection;
    this.navigate = navigate;
    this.getView();
  }

  var _proto = ResetPassword.prototype;

  _proto.createScreen = function createScreen(definition) {
    var screen = new Screen({}, definition.view, this.connection, false, [], {}, false, false, false, false);
    screen.createFields(definition.fields);
    screen.createActions(definition.actions);
    screen.loadingFields = false;
    return screen;
  };

  _proto.setUrl = function setUrl(url) {
    this.url = url;
  };

  _proto.setScreen = function setScreen(definition) {
    var _this = this;

    var screen = this.createScreen(definition);
    var record = screen.data.addRecord({
      values: {
        'id': -1
      }
    });
    screen.set_active_record(record);
    screen.data.loadingInitialData = false;
    screen.data.loading = false;
    screen.set_actions_map({
      'reset_password': function reset_password(records) {
        _this.setPassword(records);
      }
    });
    this.screen = screen;
  };

  _proto.getView = function getView() {
    try {
      var _this3 = this;

      var abortController = new AbortController();
      return Promise.resolve(_this3.connection.dispatch('GET', '/auth/reset_password_view', {}, false, true, false, abortController)).then(function (view_definition) {
        if (view_definition) {
          _this3.setScreen(view_definition);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.validatePassword = function validatePassword(record) {
    var valid = true;
    var password = record._values['new_password'];
    var confirm = record._values['repeat_password'];

    if (!password || !confirm) {
      return false;
    } else if (password !== confirm) {
      valid = false;
    }

    return valid;
  };

  _proto.setPassword = function setPassword(records) {
    try {
      var _this5 = this;

      if (!records[0]) {
        return Promise.resolve();
      }

      var record = records[0];

      if (!_this5.validatePassword(record)) {
        alert("Las contraseñas no coinciden");
        return Promise.resolve();
      }

      var args = {};
      args['url'] = _this5.url;
      args['password'] = record._values['new_password'];
      var abortController = new AbortController();

      var goToLogin = function goToLogin() {
        _this5.navigate('/login');

        return true;
      };

      return Promise.resolve(_this5.screen.connection.dispatch('POST', '/auth/set_password_url', args, false, false, false, abortController)).then(function (res) {
        if (res['status']) {
          _this5.screen.notifications.addDialog({
            'message': "Contraseña Recuperada con éxito.",
            'actions': [{
              'name': 'OK',
              'color': 'primary',
              'callback': goToLogin
            }]
          });
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return ResetPassword;
}();

var SyncStatus = /*#__PURE__*/function () {
  function SyncStatus(connection) {
    this.initialized = false;
    this.connection_status = undefined;
    this.last_sync = "";
    this.pending_transactions = 0;
    this.connection = connection;
    makeObservable(this, {
      connection_status: observable,
      initialized: observable,
      last_sync: observable,
      setLastSync: action,
      setInitialized: action,
      setConnectionStatus: action,
      pending_transactions: observable,
      setPendingTransactions: action
    });
  }

  var _proto = SyncStatus.prototype;

  _proto.initialize = function initialize() {
    try {
      var _this2 = this;

      return Promise.resolve(_this2.get_connection_status()).then(function () {
        return Promise.resolve(_this2.get_sync_log()).then(function () {
          _this2.setInitialized(true);

          _this2.getPendingTransactions();
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setInitialized = function setInitialized(status) {
    this.initialized = status;
  };

  _proto.setConnectionStatus = function setConnectionStatus(status) {
    this.connection_status = status;
  };

  _proto.setLastSync = function setLastSync(last_sync) {
    this.last_sync = last_sync;
  };

  _proto.setPendingTransactions = function setPendingTransactions(transactions_qty) {
    this.pending_transactions = transactions_qty;
  };

  _proto.get_connection_status = function get_connection_status(status) {
    if (status === void 0) {
      status = false;
    }

    try {
      var _temp3 = function _temp3() {
        _this4.setConnectionStatus(status);

        return status;
      };

      var _this4 = this;

      var _temp4 = function () {
        if (!status) {
          return Promise.resolve(_this4.connection.checkConnection()).then(function (_this3$connection$che) {
            status = _this3$connection$che;
          });
        }
      }();

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.get_sync_log = function get_sync_log() {
    try {
      var _this6 = this;

      return Promise.resolve(_this6.connection.db_handler.getLastSync()).then(function (log) {
        _this6.setLastSync(log);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.resync = function resync() {
    try {
      var _this8 = this;

      _this8.setInitialized(false);

      return Promise.resolve(_this8.connection.db_handler.resync()).then(function (last_synced) {
        _this8.setInitialized(true);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getPendingTransactions = function getPendingTransactions() {
    try {
      var _this10 = this;

      return Promise.resolve(_this10.connection.db_handler.countNewTransactions()).then(function (pending_transactions_qty) {
        _this10.setPendingTransactions(pending_transactions_qty);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return SyncStatus;
}();

export { Action, AppContext, AppContextProvider, AppRoot, Connection, ConnectionProvider, IconButton, InjectContext, Login, Modal, NotificationContext, PreLogin, ResetPassword, Screen, ScreenGroup, SessionContext, SyncStatus, ThemeContext, common, createField };
//# sourceMappingURL=index.modern.js.map
